
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec080"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec080"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2J5hC", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $jdtFf = parcelRequire("jdtFf");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $jdtFf.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $jdtFf.default)(Rgb, rgb, (0, $jdtFf.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $jdtFf.default)(Hsl, hsl, (0, $jdtFf.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("jdtFf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfd63df02087f6a9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $dfd63df02087f6a9$export$8b58be045bf06082; });
function $dfd63df02087f6a9$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $dfd63df02087f6a9$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("bjwWZ", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("jwWxh", function(module, exports) {

$parcel$export(module.exports, "animator", function () { return $e37e697455933e61$export$a424a0aa8f687495; });
$parcel$export(module.exports, "Animation", function () { return $e37e697455933e61$export$c35d437ae5945fcd; });
$parcel$export(module.exports, "Animations", function () { return $e37e697455933e61$export$8ab227dac26677d; });
$parcel$export(module.exports, "DatasetController", function () { return $e37e697455933e61$export$75572ec5c55b4048; });
$parcel$export(module.exports, "BarController", function () { return $e37e697455933e61$export$e97d5dc64e999004; });
$parcel$export(module.exports, "BubbleController", function () { return $e37e697455933e61$export$19b5c4773f17abe; });
$parcel$export(module.exports, "DoughnutController", function () { return $e37e697455933e61$export$e04603e7d8b77172; });
$parcel$export(module.exports, "LineController", function () { return $e37e697455933e61$export$3c9b5d28c11cbfd0; });
$parcel$export(module.exports, "PolarAreaController", function () { return $e37e697455933e61$export$2a270b3a0d973c85; });
$parcel$export(module.exports, "PieController", function () { return $e37e697455933e61$export$b21a3f1286706191; });
$parcel$export(module.exports, "RadarController", function () { return $e37e697455933e61$export$48dbc6ac651bf8be; });
$parcel$export(module.exports, "ScatterController", function () { return $e37e697455933e61$export$b2f2bae6713db87; });
$parcel$export(module.exports, "controllers", function () { return $e37e697455933e61$export$a6506504f799c5d5; });
$parcel$export(module.exports, "_adapters", function () { return $e37e697455933e61$export$f32766ea09ec8bc4; });
$parcel$export(module.exports, "Interaction", function () { return $e37e697455933e61$export$a13296960cae0384; });
$parcel$export(module.exports, "layouts", function () { return $e37e697455933e61$export$1ecca0613f5e56d2; });
$parcel$export(module.exports, "BasePlatform", function () { return $e37e697455933e61$export$7b1aeb87f31f7da8; });
$parcel$export(module.exports, "BasicPlatform", function () { return $e37e697455933e61$export$a40a96b24b46cf35; });
$parcel$export(module.exports, "DomPlatform", function () { return $e37e697455933e61$export$f02da7f882cf6b2e; });
$parcel$export(module.exports, "Element", function () { return $e37e697455933e61$export$db77ccec0bb4ccac; });
$parcel$export(module.exports, "Ticks", function () { return $e37e697455933e61$export$27c7467594ef87bd; });
$parcel$export(module.exports, "Scale", function () { return $e37e697455933e61$export$d60cfc58d3c358b6; });
$parcel$export(module.exports, "registry", function () { return $e37e697455933e61$export$4bb7493d241fd8a5; });
$parcel$export(module.exports, "Chart", function () { return $e37e697455933e61$export$acaa6426d77a227e; });
$parcel$export(module.exports, "ArcElement", function () { return $e37e697455933e61$export$d48203c759d6a1fc; });
$parcel$export(module.exports, "LineElement", function () { return $e37e697455933e61$export$55e463fa7bcd3469; });
$parcel$export(module.exports, "PointElement", function () { return $e37e697455933e61$export$bd159b522b230b7a; });
$parcel$export(module.exports, "BarElement", function () { return $e37e697455933e61$export$a16ed71bf4b07672; });
$parcel$export(module.exports, "elements", function () { return $e37e697455933e61$export$7a5d735b2ab6389d; });
$parcel$export(module.exports, "Decimation", function () { return $e37e697455933e61$export$be17f937e9aa7533; });
$parcel$export(module.exports, "Filler", function () { return $e37e697455933e61$export$d19ba4d812bed757; });
$parcel$export(module.exports, "Legend", function () { return $e37e697455933e61$export$ed247974535929c7; });
$parcel$export(module.exports, "Title", function () { return $e37e697455933e61$export$f99233281efd08a0; });
$parcel$export(module.exports, "SubTitle", function () { return $e37e697455933e61$export$d5c56664638992a4; });
$parcel$export(module.exports, "Tooltip", function () { return $e37e697455933e61$export$28c660c63b792dea; });
$parcel$export(module.exports, "plugins", function () { return $e37e697455933e61$export$8b3ca321c77fdea6; });
$parcel$export(module.exports, "CategoryScale", function () { return $e37e697455933e61$export$29e663ba4d09fe7; });
$parcel$export(module.exports, "LinearScale", function () { return $e37e697455933e61$export$e7f4e5e8656f0b93; });
$parcel$export(module.exports, "LogarithmicScale", function () { return $e37e697455933e61$export$85295eaf7cb3ac3e; });
$parcel$export(module.exports, "RadialLinearScale", function () { return $e37e697455933e61$export$cfafc36d95386d38; });
$parcel$export(module.exports, "TimeScale", function () { return $e37e697455933e61$export$a894c72689ff3ec; });
$parcel$export(module.exports, "TimeSeriesScale", function () { return $e37e697455933e61$export$85df64a8eb6dc986; });
$parcel$export(module.exports, "scales", function () { return $e37e697455933e61$export$bcac1c16f1530ec2; });
$parcel$export(module.exports, "registerables", function () { return $e37e697455933e61$export$e8959e79e3af550f; });
$parcel$export(module.exports, "defaults", function () { return (parcelRequire("kW5V1")).d; });
/*!
 * Chart.js v3.4.1
 * https://www.chartjs.org
 * (c) 2021 Chart.js Contributors
 * Released under the MIT License
 */ 
var $kW5V1 = parcelRequire("kW5V1");
class $e37e697455933e61$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        const me = this;
        if (me._request) return;
        me._running = true;
        me._request = (0, $kW5V1.r).call(window, ()=>{
            me._update();
            me._request = null;
            if (me._running) me._refresh();
        });
    }
    _update(date = Date.now()) {
        const me = this;
        let remaining = 0;
        me._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                me._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                me._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        me._lastDate = date;
        if (remaining === 0) me._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $e37e697455933e61$export$a424a0aa8f687495 = new $e37e697455933e61$var$Animator();
const $e37e697455933e61$var$transparent = "transparent";
const $e37e697455933e61$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $kW5V1.c)(from || $e37e697455933e61$var$transparent);
        const c1 = c0.valid && (0, $kW5V1.c)(to || $e37e697455933e61$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $e37e697455933e61$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $kW5V1.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $kW5V1.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $e37e697455933e61$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $kW5V1.e)[cfg.easing] || (0, $kW5V1.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        const me = this;
        if (me._active) {
            me._notify(false);
            const currentValue = me._target[me._prop];
            const elapsed = date - me._start;
            const remain = me._duration - elapsed;
            me._start = date;
            me._duration = Math.floor(Math.max(remain, cfg.duration));
            me._total += elapsed;
            me._loop = !!cfg.loop;
            me._to = (0, $kW5V1.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            me._from = (0, $kW5V1.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        const me = this;
        if (me._active) {
            me.tick(Date.now());
            me._active = false;
            me._notify(false);
        }
    }
    tick(date) {
        const me = this;
        const elapsed = date - me._start;
        const duration = me._duration;
        const prop = me._prop;
        const from = me._from;
        const loop = me._loop;
        const to = me._to;
        let factor;
        me._active = from !== to && (loop || elapsed < duration);
        if (!me._active) {
            me._target[prop] = to;
            me._notify(true);
            return;
        }
        if (elapsed < 0) {
            me._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = me._easing(Math.min(1, Math.max(0, factor)));
        me._target[prop] = me._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
const $e37e697455933e61$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $e37e697455933e61$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
(0, $kW5V1.d).set("animation", {
    delay: undefined,
    duration: 1000,
    easing: "easeOutQuart",
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
});
const $e37e697455933e61$var$animationOptions = Object.keys((0, $kW5V1.d).animation);
(0, $kW5V1.d).describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
});
(0, $kW5V1.d).set("animations", {
    colors: {
        type: "color",
        properties: $e37e697455933e61$var$colors
    },
    numbers: {
        type: "number",
        properties: $e37e697455933e61$var$numbers
    }
});
(0, $kW5V1.d).describe("animations", {
    _fallback: "animation"
});
(0, $kW5V1.d).set("transitions", {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: "transparent"
            },
            visible: {
                type: "boolean",
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: "transparent"
            },
            visible: {
                type: "boolean",
                easing: "linear",
                fn: (v)=>v | 0
            }
        }
    }
});
class $e37e697455933e61$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $kW5V1.i)(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $kW5V1.i)(cfg)) return;
            const resolved = {};
            for (const option of $e37e697455933e61$var$animationOptions)resolved[option] = cfg[option];
            ((0, $kW5V1.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $e37e697455933e61$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $e37e697455933e61$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $e37e697455933e61$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $e37e697455933e61$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $e37e697455933e61$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $e37e697455933e61$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $e37e697455933e61$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $e37e697455933e61$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $e37e697455933e61$var$scaleClip(xScale, allowedOverflow);
    const y = $e37e697455933e61$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $e37e697455933e61$var$toClip(value) {
    let t, r, b, l;
    if ((0, $kW5V1.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $e37e697455933e61$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $e37e697455933e61$var$applyStack(stack, value, dsIndex, options) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $kW5V1.g)(otherValue) && (singleMode || value === 0 || (0, $kW5V1.s)(value) === (0, $kW5V1.s)(otherValue))) value += otherValue;
    }
    return value;
}
function $e37e697455933e61$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $e37e697455933e61$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $e37e697455933e61$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $e37e697455933e61$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $e37e697455933e61$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $e37e697455933e61$var$getLastIndexInStack(stack, vScale, positive) {
    for (const meta of vScale.getMatchingVisibleMetas("bar").reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $e37e697455933e61$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $e37e697455933e61$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $e37e697455933e61$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $e37e697455933e61$var$getLastIndexInStack(stack, vScale, true);
        stack._bottom = $e37e697455933e61$var$getLastIndexInStack(stack, vScale, false);
    }
}
function $e37e697455933e61$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $e37e697455933e61$var$createDatasetContext(parent, index) {
    return Object.assign(Object.create(parent), {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $e37e697455933e61$var$createDataContext(parent, index, element) {
    return Object.assign(Object.create(parent), {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $e37e697455933e61$var$clearStacks(meta, items) {
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][meta.index] === undefined) return;
        delete stacks[axis][meta.index];
    }
}
const $e37e697455933e61$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $e37e697455933e61$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
class $e37e697455933e61$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.$context = undefined;
        this._syncList = [];
        this.initialize();
    }
    initialize() {
        const me = this;
        const meta = me._cachedMeta;
        me.configure();
        me.linkScales();
        meta._stacked = $e37e697455933e61$var$isStacked(meta.vScale, meta);
        me.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $e37e697455933e61$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const me = this;
        const chart = me.chart;
        const meta = me._cachedMeta;
        const dataset = me.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $kW5V1.v)(dataset.xAxisID, $e37e697455933e61$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $kW5V1.v)(dataset.yAxisID, $e37e697455933e61$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $kW5V1.v)(dataset.rAxisID, $e37e697455933e61$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = me.getScaleForId(xid);
        meta.yScale = me.getScaleForId(yid);
        meta.rScale = me.getScaleForId(rid);
        meta.iScale = me.getScaleForId(iid);
        meta.vScale = me.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $kW5V1.u)(this._data, this);
        if (meta._stacked) $e37e697455933e61$var$clearStacks(meta);
    }
    _dataCheck() {
        const me = this;
        const dataset = me.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = me._data;
        if ((0, $kW5V1.i)(data)) me._data = $e37e697455933e61$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $kW5V1.u)(_data, me);
                const meta = me._cachedMeta;
                $e37e697455933e61$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $kW5V1.l)(data, me);
            me._syncList = [];
            me._data = data;
        }
    }
    addElements() {
        const me = this;
        const meta = me._cachedMeta;
        me._dataCheck();
        if (me.datasetElementType) meta.dataset = new me.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const me = this;
        const meta = me._cachedMeta;
        const dataset = me.getDataset();
        let stackChanged = false;
        me._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $e37e697455933e61$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $e37e697455933e61$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        me._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $e37e697455933e61$var$updateStacks(me, meta._parsed);
    }
    configure() {
        const me = this;
        const config = me.chart.config;
        const scopeKeys = config.datasetScopeKeys(me._type);
        const scopes = config.getOptionScopes(me.getDataset(), scopeKeys, true);
        me.options = config.createResolver(scopes, me.getContext());
        me._parsing = me.options.parsing;
    }
    parse(start, count) {
        const me = this;
        const { _cachedMeta: meta, _data: data } = me;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (me._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $kW5V1.b)(data[start])) parsed = me.parseArrayData(meta, data, start, count);
            else if ((0, $kW5V1.i)(data[start])) parsed = me.parseObjectData(meta, data, start, count);
            else parsed = me.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $e37e697455933e61$var$updateStacks(me, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $kW5V1.f)(item, xAxisKey), index),
                y: yScale.parse((0, $kW5V1.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $e37e697455933e61$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $e37e697455933e61$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            range.min = Math.min(range.min, value);
            range.max = Math.max(range.max, value);
            value = $e37e697455933e61$var$applyStack(stack, parsedValue, this._cachedMeta.index, {
                all: true
            });
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const me = this;
        const meta = me._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = me._getOtherScale(scale);
        const stack = canStack && meta._stacked && {
            keys: $e37e697455933e61$var$getSortedDatasetIndices(me.chart, true),
            values: null
        };
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $e37e697455933e61$var$getUserBounds(otherScale);
        let i, value, parsed, otherValue;
        function _skip() {
            parsed = _parsed[i];
            value = parsed[scale.axis];
            otherValue = parsed[otherScale.axis];
            return !(0, $kW5V1.g)(value) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            me.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            me.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $kW5V1.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = me.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const me = this;
        const meta = me._cachedMeta;
        me.configure();
        me._cachedDataOpts = {};
        me.update(mode || "default");
        meta._clip = $e37e697455933e61$var$toClip((0, $kW5V1.v)(me.options.clip, $e37e697455933e61$var$defaultClip(meta.xScale, meta.yScale, me.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const me = this;
        const ctx = me._ctx;
        const chart = me.chart;
        const meta = me._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = me._drawStart || 0;
        const count = me._drawCount || elements.length - start;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.active) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const me = this;
        const dataset = me.getDataset();
        let context;
        if (index >= 0 && index < me._cachedMeta.data.length) {
            const element = me._cachedMeta.data[index];
            context = element.$context || (element.$context = $e37e697455933e61$var$createDataContext(me.getContext(), index, element));
            context.parsed = me.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = me.$context || (me.$context = $e37e697455933e61$var$createDatasetContext(me.chart.getContext(), me.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = me.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const me = this;
        const active = mode === "active";
        const cache = me._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = me.enableOptionSharing && (0, $kW5V1.h)(index);
        if (cached) return $e37e697455933e61$var$cloneIfNotShared(cached, sharing);
        const config = me.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(me._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(me.getDataset(), scopeKeys);
        const names = Object.keys((0, $kW5V1.d).elements[elementType]);
        const context = ()=>me.getContext(index, active);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($e37e697455933e61$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const me = this;
        const chart = me.chart;
        const cache = me._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = me.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(me._type, transition);
            const scopes = config.getOptionScopes(me.getDataset(), scopeKeys);
            options = config.createResolver(scopes, me.getContext(index, active, transition));
        }
        const animations = new $e37e697455933e61$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $e37e697455933e61$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    updateElement(element, index, properties, mode) {
        if ($e37e697455933e61$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$e37e697455933e61$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const me = this;
        const data = me._data;
        const elements = me._cachedMeta.data;
        for (const [method, arg1, arg2] of me._syncList)me[method](arg1, arg2);
        me._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) me.parse(0, count);
        if (numData > numMeta) me._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) me._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const me = this;
        const meta = me._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new me.dataElementType();
        if (me._parsing) move(meta._parsed);
        me.parse(start, count);
        if (resetNewElements) me.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const me = this;
        const meta = me._cachedMeta;
        if (me._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $e37e697455933e61$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _onDataPush() {
        const count = arguments.length;
        this._syncList.push([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._syncList.push([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._syncList.push([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        this._syncList.push([
            "_removeElements",
            start,
            count
        ]);
        this._syncList.push([
            "_insertElements",
            start,
            arguments.length - 2
        ]);
    }
    _onDataUnshift() {
        this._syncList.push([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
$e37e697455933e61$export$75572ec5c55b4048.defaults = {};
$e37e697455933e61$export$75572ec5c55b4048.prototype.datasetElementType = null;
$e37e697455933e61$export$75572ec5c55b4048.prototype.dataElementType = null;
function $e37e697455933e61$var$getAllScaleValues(scale) {
    if (!scale._cache.$bar) {
        const metas = scale.getMatchingVisibleMetas("bar");
        let values = [];
        for(let i = 0, ilen = metas.length; i < ilen; i++)values = values.concat(metas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $kW5V1._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $e37e697455933e61$var$computeMinSampleSize(scale) {
    const values = $e37e697455933e61$var$getAllScaleValues(scale);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $kW5V1.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $e37e697455933e61$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $kW5V1.j)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $e37e697455933e61$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $e37e697455933e61$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $e37e697455933e61$var$parseValue(entry, item, vScale, i) {
    if ((0, $kW5V1.b)(entry)) $e37e697455933e61$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $e37e697455933e61$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($e37e697455933e61$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $e37e697455933e61$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
class $e37e697455933e61$export$e97d5dc64e999004 extends $e37e697455933e61$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $e37e697455933e61$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $e37e697455933e61$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $kW5V1.f)(obj, iAxisKey), i);
            parsed.push($e37e697455933e61$var$parseValue((0, $kW5V1.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = me.getParsed(index);
        const custom = parsed._custom;
        const value = $e37e697455933e61$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        const me = this;
        me.enableOptionSharing = true;
        super.initialize();
        const meta = me._cachedMeta;
        meta.stack = me.getDataset().stack;
    }
    update(mode) {
        const me = this;
        const meta = me._cachedMeta;
        me.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const vScale = me._cachedMeta.vScale;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = me._getRuler();
        const firstOpts = me.resolveDataElementOptions(start, mode);
        const sharedOptions = me.getSharedOptions(firstOpts);
        const includeOptions = me.includeOptions(mode, sharedOptions);
        me.updateSharedOptions(sharedOptions, mode, firstOpts);
        for(let i = start; i < start + count; i++){
            const parsed = me.getParsed(i);
            const vpixels = reset || (0, $kW5V1.j)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : me._calculateBarValuePixels(i);
            const ipixels = me._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $e37e697455933e61$var$isFloatBar(parsed._custom) || me.index === stack._top || me.index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || me.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            me.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const me = this;
        const meta = me._cachedMeta;
        const iScale = meta.iScale;
        const metasets = iScale.getMatchingVisibleMetas(me._type);
        const stacked = iScale.options.stacked;
        const ilen = metasets.length;
        const stacks = [];
        let i, item;
        for(i = 0; i < ilen; ++i){
            item = metasets[i];
            if (!item.controller.options.grouped) continue;
            if (typeof dataIndex !== "undefined") {
                const val = item.controller.getParsed(dataIndex)[item.controller._cachedMeta.vScale.axis];
                if ((0, $kW5V1.j)(val) || isNaN(val)) continue;
            }
            if (stacked === false || stacks.indexOf(item.stack) === -1 || stacked === undefined && item.stack === undefined) stacks.push(item.stack);
            if (item.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const me = this;
        const opts = me.options;
        const meta = me._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(me.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $e37e697455933e61$var$computeMinSampleSize(iScale);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: me._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const me = this;
        const { vScale: vScale, _stacked: _stacked } = me._cachedMeta;
        const { base: baseValue, minBarLength: minBarLength } = me.options;
        const parsed = me.getParsed(index);
        const custom = parsed._custom;
        const floating = $e37e697455933e61$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? me.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $kW5V1.s)(value) !== (0, $kW5V1.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $kW5V1.j)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
            size = size < 0 ? -minBarLength : minBarLength;
            if (value === 0) base -= size / 2;
            head = base + size;
        }
        const actualBase = baseValue || 0;
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = vScale.getLineWidthForValue(actualBase) / 2;
            if (size > 0) {
                base += halfGrid;
                size -= halfGrid;
            } else if (size < 0) {
                base -= halfGrid;
                size += halfGrid;
            }
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const me = this;
        const scale = ruler.scale;
        const options = me.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $kW5V1.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? me._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $e37e697455933e61$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $e37e697455933e61$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = me._getStackIndex(me.index, me._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(me.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const me = this;
        const meta = me._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (me.getParsed(i)[vScale.axis] !== null) rects[i].draw(me._ctx);
    }
}
$e37e697455933e61$export$e97d5dc64e999004.id = "bar";
$e37e697455933e61$export$e97d5dc64e999004.defaults = {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
};
$e37e697455933e61$export$e97d5dc64e999004.overrides = {
    interaction: {
        mode: "index"
    },
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
};
class $e37e697455933e61$export$19b5c4773f17abe extends $e37e697455933e61$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = [];
        let i, ilen, item;
        for(i = start, ilen = start + count; i < ilen; ++i){
            item = data[i];
            parsed.push({
                x: xScale.parse((0, $kW5V1.f)(item, xAxisKey), i),
                y: yScale.parse((0, $kW5V1.f)(item, yAxisKey), i),
                _custom: item && item.r && +item.r
            });
        }
        return parsed;
    }
    getMaxOverflow() {
        const { data: data, _parsed: _parsed } = this._cachedMeta;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size() / 2, _parsed[i]._custom);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = me.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const me = this;
        const points = me._cachedMeta.data;
        me.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = me._cachedMeta;
        const firstOpts = me.resolveDataElementOptions(start, mode);
        const sharedOptions = me.getSharedOptions(firstOpts);
        const includeOptions = me.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && me.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = me.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            me.updateElement(point, i, properties, mode);
        }
        me.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $kW5V1.v)(parsed && parsed._custom, radius);
        return values;
    }
}
$e37e697455933e61$export$19b5c4773f17abe.id = "bubble";
$e37e697455933e61$export$19b5c4773f17abe.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
};
$e37e697455933e61$export$19b5c4773f17abe.overrides = {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                }
            }
        }
    }
};
function $e37e697455933e61$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $kW5V1.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $kW5V1.o)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $kW5V1.o)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $kW5V1.H), startY, endY);
        const minX = calcMin((0, $kW5V1.P), startX, endX);
        const minY = calcMin((0, $kW5V1.P) + (0, $kW5V1.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $e37e697455933e61$export$e04603e7d8b77172 extends $e37e697455933e61$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        let i, ilen;
        for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = +data[i];
    }
    _getRotation() {
        return (0, $kW5V1.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $kW5V1.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $kW5V1.T);
        let max = -(0, $kW5V1.T);
        const me = this;
        for(let i = 0; i < me.chart.data.datasets.length; ++i)if (me.chart.isDatasetVisible(i)) {
            const controller = me.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const me = this;
        const chart = me.chart;
        const { chartArea: chartArea } = chart;
        const meta = me._cachedMeta;
        const arcs = meta.data;
        const spacing = me.getMaxBorderWidth() + me.getMaxOffset(arcs) + me.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $kW5V1.k)(me.options.cutout, maxSize), 1);
        const chartWeight = me._getRingWeight(me.index);
        const { circumference: circumference, rotation: rotation } = me._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $e37e697455933e61$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $kW5V1.m)(me.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / me._getVisibleDatasetWeightTotal();
        me.offsetX = offsetX * outerRadius;
        me.offsetY = offsetY * outerRadius;
        meta.total = me.calculateTotal();
        me.outerRadius = outerRadius - radiusLength * me._getRingWeightOffset(me.index);
        me.innerRadius = Math.max(me.outerRadius - radiusLength * chartWeight, 0);
        me.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const me = this;
        const opts = me.options;
        const meta = me._cachedMeta;
        const circumference = me._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null) return 0;
        return me.calculateCircumference(meta._parsed[i] * circumference / (0, $kW5V1.T));
    }
    updateElements(arcs, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const chart = me.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : me.innerRadius;
        const outerRadius = animateScale ? 0 : me.outerRadius;
        const firstOpts = me.resolveDataElementOptions(start, mode);
        const sharedOptions = me.getSharedOptions(firstOpts);
        const includeOptions = me.includeOptions(mode, sharedOptions);
        let startAngle = me._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += me._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = me._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + me.offsetX,
                y: centerY + me.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || me.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            me.updateElement(arc, i, properties, mode);
        }
        me.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i)) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $kW5V1.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const chart = me.chart;
        const labels = chart.data.labels || [];
        const value = (0, $kW5V1.n)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        const me = this;
        let max = 0;
        const chart = me.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                if (controller !== me) controller.configure();
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $kW5V1.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
$e37e697455933e61$export$e04603e7d8b77172.id = "doughnut";
$e37e697455933e61$export$e04603e7d8b77172.defaults = {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
};
$e37e697455933e61$export$e04603e7d8b77172.descriptors = {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing"
};
$e37e697455933e61$export$e04603e7d8b77172.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ": " + tooltipItem.formattedValue;
                    if ((0, $kW5V1.b)(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $e37e697455933e61$export$3c9b5d28c11cbfd0 extends $e37e697455933e61$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    update(mode) {
        const me = this;
        const meta = me._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = me.chart._animationsDisabled;
        let { start: start, count: count } = $e37e697455933e61$var$getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
        me._drawStart = start;
        me._drawCount = count;
        if ($e37e697455933e61$var$scaleRangesChanged(meta)) {
            start = 0;
            count = points.length;
        }
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = me.resolveDatasetElementOptions(mode);
        if (!me.options.showLine) options.borderWidth = 0;
        options.segment = me.options.segment;
        me.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        me.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked } = me._cachedMeta;
        const firstOpts = me.resolveDataElementOptions(start, mode);
        const sharedOptions = me.getSharedOptions(firstOpts);
        const includeOptions = me.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const spanGaps = me.options.spanGaps;
        const maxGapLength = (0, $kW5V1.p)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = me.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && me.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = me.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $kW5V1.j)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? me.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && parsed[iAxis] - prevParsed[iAxis] > maxGapLength;
            properties.parsed = parsed;
            if (includeOptions) properties.options = sharedOptions || me.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) me.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        me.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const me = this;
        const meta = me._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(me.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(me.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$e37e697455933e61$export$3c9b5d28c11cbfd0.id = "line";
$e37e697455933e61$export$3c9b5d28c11cbfd0.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
};
$e37e697455933e61$export$3c9b5d28c11cbfd0.overrides = {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
};
function $e37e697455933e61$var$getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = (0, $kW5V1.q)(Math.min((0, $kW5V1.w)(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : (0, $kW5V1.w)(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = (0, $kW5V1.q)(Math.max((0, $kW5V1.w)(_parsed, iScale.axis, max).hi + 1, animationsDisabled ? 0 : (0, $kW5V1.w)(points, axis, iScale.getPixelForValue(max)).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $e37e697455933e61$var$scaleRangesChanged(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
class $e37e697455933e61$export$2a270b3a0d973c85 extends $e37e697455933e61$export$75572ec5c55b4048 {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const me = this;
        const meta = me._cachedMeta;
        const chart = me.chart;
        const labels = chart.data.labels || [];
        const value = (0, $kW5V1.n)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _updateRadius() {
        const me = this;
        const chart = me.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        me.outerRadius = outerRadius - radiusLength * me.index;
        me.innerRadius = me.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const me = this;
        const reset = mode === "reset";
        const chart = me.chart;
        const dataset = me.getDataset();
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = me._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $kW5V1.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / me.countVisibleElements();
        for(i = 0; i < start; ++i)angle += me._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + me._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(dataset.data[i]) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: me.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            me.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const dataset = this.getDataset();
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(dataset.data[index]) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $kW5V1.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
$e37e697455933e61$export$2a270b3a0d973c85.id = "polarArea";
$e37e697455933e61$export$2a270b3a0d973c85.defaults = {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
};
$e37e697455933e61$export$2a270b3a0d973c85.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $e37e697455933e61$export$b21a3f1286706191 extends $e37e697455933e61$export$e04603e7d8b77172 {
}
$e37e697455933e61$export$b21a3f1286706191.id = "pie";
$e37e697455933e61$export$b21a3f1286706191.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
};
class $e37e697455933e61$export$48dbc6ac651bf8be extends $e37e697455933e61$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const me = this;
        const vScale = me._cachedMeta.vScale;
        const parsed = me.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    update(mode) {
        const me = this;
        const meta = me._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = me.resolveDatasetElementOptions(mode);
            if (!me.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            me.updateElement(line, undefined, properties, mode);
        }
        me.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const me = this;
        const dataset = me.getDataset();
        const scale = me._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = me.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, dataset.data[i]);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            me.updateElement(point, i, properties, mode);
        }
    }
}
$e37e697455933e61$export$48dbc6ac651bf8be.id = "radar";
$e37e697455933e61$export$48dbc6ac651bf8be.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
};
$e37e697455933e61$export$48dbc6ac651bf8be.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
};
class $e37e697455933e61$export$b2f2bae6713db87 extends $e37e697455933e61$export$3c9b5d28c11cbfd0 {
}
$e37e697455933e61$export$b2f2bae6713db87.id = "scatter";
$e37e697455933e61$export$b2f2bae6713db87.defaults = {
    showLine: false,
    fill: false
};
$e37e697455933e61$export$b2f2bae6713db87.overrides = {
    interaction: {
        mode: "point"
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (item) {
                    return "(" + item.label + ", " + item.formattedValue + ")";
                }
            }
        }
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
};
var $e37e697455933e61$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $e37e697455933e61$export$e97d5dc64e999004,
    BubbleController: $e37e697455933e61$export$19b5c4773f17abe,
    DoughnutController: $e37e697455933e61$export$e04603e7d8b77172,
    LineController: $e37e697455933e61$export$3c9b5d28c11cbfd0,
    PolarAreaController: $e37e697455933e61$export$2a270b3a0d973c85,
    PieController: $e37e697455933e61$export$b21a3f1286706191,
    RadarController: $e37e697455933e61$export$48dbc6ac651bf8be,
    ScatterController: $e37e697455933e61$export$b2f2bae6713db87
});
function $e37e697455933e61$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class $e37e697455933e61$var$DateAdapter {
    constructor(options){
        this.options = options || {};
    }
    formats() {
        return $e37e697455933e61$var$abstract();
    }
    parse(value, format) {
        return $e37e697455933e61$var$abstract();
    }
    format(timestamp, format) {
        return $e37e697455933e61$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $e37e697455933e61$var$abstract();
    }
    diff(a, b, unit) {
        return $e37e697455933e61$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $e37e697455933e61$var$abstract();
    }
    endOf(timestamp, unit) {
        return $e37e697455933e61$var$abstract();
    }
}
$e37e697455933e61$var$DateAdapter.override = function(members) {
    Object.assign($e37e697455933e61$var$DateAdapter.prototype, members);
};
var $e37e697455933e61$export$f32766ea09ec8bc4 = {
    _date: $e37e697455933e61$var$DateAdapter
};
function $e37e697455933e61$var$getRelativePosition(e, chart) {
    if ("native" in e) return {
        x: e.x,
        y: e.y
    };
    return (0, $kW5V1.x)(e, chart);
}
function $e37e697455933e61$var$evaluateAllVisibleItems(chart, handler) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    let index, data, element;
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        ({ index: index, data: data } = metasets[i]);
        for(let j = 0, jlen = data.length; j < jlen; ++j){
            element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $e37e697455933e61$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $kW5V1.z) : (0, $kW5V1.w);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $e37e697455933e61$var$optimizedEvaluateItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $e37e697455933e61$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $e37e697455933e61$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $e37e697455933e61$var$getIntersectItems(chart, position, axis, useFinalPosition) {
    const items = [];
    if (!(0, $kW5V1.y)(position, chart.chartArea, chart._minPadding)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $e37e697455933e61$var$optimizedEvaluateItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $e37e697455933e61$var$getNearestItems(chart, position, axis, intersect, useFinalPosition) {
    const distanceMetric = $e37e697455933e61$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    let items = [];
    if (!(0, $kW5V1.y)(position, chart.chartArea, chart._minPadding)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (intersect && !element.inRange(position.x, position.y, useFinalPosition)) return;
        const center = element.getCenterPoint(useFinalPosition);
        if (!(0, $kW5V1.y)(center, chart.chartArea, chart._minPadding)) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $e37e697455933e61$var$optimizedEvaluateItems(chart, axis, position, evaluationFunc);
    return items;
}
function $e37e697455933e61$var$getAxisItems(chart, e, options, useFinalPosition) {
    const position = $e37e697455933e61$var$getRelativePosition(e, chart);
    const items = [];
    const axis = options.axis;
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $e37e697455933e61$var$evaluateAllVisibleItems(chart, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
        if (element.inRange(position.x, position.y, useFinalPosition)) intersectsItem = true;
    });
    if (options.intersect && !intersectsItem) return [];
    return items;
}
var $e37e697455933e61$export$a13296960cae0384 = {
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = $e37e697455933e61$var$getRelativePosition(e, chart);
            const axis = options.axis || "x";
            const items = options.intersect ? $e37e697455933e61$var$getIntersectItems(chart, position, axis, useFinalPosition) : $e37e697455933e61$var$getNearestItems(chart, position, axis, false, useFinalPosition);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = $e37e697455933e61$var$getRelativePosition(e, chart);
            const axis = options.axis || "xy";
            let items = options.intersect ? $e37e697455933e61$var$getIntersectItems(chart, position, axis, useFinalPosition) : $e37e697455933e61$var$getNearestItems(chart, position, axis, false, useFinalPosition);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = $e37e697455933e61$var$getRelativePosition(e, chart);
            const axis = options.axis || "xy";
            return $e37e697455933e61$var$getIntersectItems(chart, position, axis, useFinalPosition);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = $e37e697455933e61$var$getRelativePosition(e, chart);
            const axis = options.axis || "xy";
            return $e37e697455933e61$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition);
        },
        x (chart, e, options, useFinalPosition) {
            options.axis = "x";
            return $e37e697455933e61$var$getAxisItems(chart, e, options, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            options.axis = "y";
            return $e37e697455933e61$var$getAxisItems(chart, e, options, useFinalPosition);
        }
    }
};
const $e37e697455933e61$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $e37e697455933e61$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $e37e697455933e61$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$e37e697455933e61$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $e37e697455933e61$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $e37e697455933e61$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        layoutBoxes.push({
            index: i,
            box: box,
            pos: box.position,
            horizontal: box.isHorizontal(),
            weight: box.weight
        });
    }
    return layoutBoxes;
}
function $e37e697455933e61$var$setLayoutDims(layouts, params) {
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        if (layout.horizontal) {
            layout.width = layout.box.fullSize && params.availableWidth;
            layout.height = params.hBoxMaxHeight;
        } else {
            layout.width = params.vBoxMaxWidth;
            layout.height = layout.box.fullSize && params.availableHeight;
        }
    }
}
function $e37e697455933e61$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $e37e697455933e61$var$wrapBoxes(boxes);
    const fullSize = $e37e697455933e61$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $e37e697455933e61$var$sortByWeight($e37e697455933e61$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $e37e697455933e61$var$sortByWeight($e37e697455933e61$var$filterByPosition(layoutBoxes, "right"));
    const top = $e37e697455933e61$var$sortByWeight($e37e697455933e61$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $e37e697455933e61$var$sortByWeight($e37e697455933e61$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $e37e697455933e61$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $e37e697455933e61$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $e37e697455933e61$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $e37e697455933e61$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $e37e697455933e61$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $e37e697455933e61$var$updateDims(chartArea, params, layout) {
    const box = layout.box;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $kW5V1.i)(layout.pos)) {
        if (layout.size) chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
    }
    if (box.getPadding) $e37e697455933e61$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $e37e697455933e61$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $e37e697455933e61$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $e37e697455933e61$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $e37e697455933e61$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $e37e697455933e61$var$fitBoxes(boxes, chartArea, params) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $e37e697455933e61$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $e37e697455933e61$var$updateDims(chartArea, params, layout);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $e37e697455933e61$var$fitBoxes(refitBoxes, chartArea, params) || changed;
}
function $e37e697455933e61$var$placeBoxes(boxes, chartArea, params) {
    const userPadding = params.padding;
    let x = chartArea.x;
    let y = chartArea.y;
    let i, ilen, layout, box;
    for(i = 0, ilen = boxes.length; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        if (layout.horizontal) {
            box.left = box.fullSize ? userPadding.left : chartArea.left;
            box.right = box.fullSize ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
            box.top = y;
            box.bottom = y + box.height;
            box.width = box.right - box.left;
            y = box.bottom;
        } else {
            box.left = x;
            box.right = x + box.width;
            box.top = box.fullSize ? userPadding.top : chartArea.top;
            box.bottom = box.fullSize ? params.outerHeight - userPadding.bottom : chartArea.top + chartArea.h;
            box.height = box.bottom - box.top;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
(0, $kW5V1.d).set("layout", {
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $e37e697455933e61$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $kW5V1.A)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $e37e697455933e61$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $kW5V1.B)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $e37e697455933e61$var$updateMaxPadding(maxPadding, (0, $kW5V1.A)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        $e37e697455933e61$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $e37e697455933e61$var$fitBoxes(boxes.fullSize, chartArea, params);
        $e37e697455933e61$var$fitBoxes(verticalBoxes, chartArea, params);
        if ($e37e697455933e61$var$fitBoxes(horizontalBoxes, chartArea, params)) $e37e697455933e61$var$fitBoxes(verticalBoxes, chartArea, params);
        $e37e697455933e61$var$handleMaxPadding(chartArea);
        $e37e697455933e61$var$placeBoxes(boxes.leftAndTop, chartArea, params);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $e37e697455933e61$var$placeBoxes(boxes.rightAndBottom, chartArea, params);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $kW5V1.B)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h);
        });
    }
};
class $e37e697455933e61$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
}
class $e37e697455933e61$export$a40a96b24b46cf35 extends $e37e697455933e61$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
}
const $e37e697455933e61$var$EXPANDO_KEY = "$chartjs";
const $e37e697455933e61$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $e37e697455933e61$var$isNullOrEmpty = (value)=>value === null || value === "";
function $e37e697455933e61$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$e37e697455933e61$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($e37e697455933e61$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $kW5V1.E)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($e37e697455933e61$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $kW5V1.E)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $e37e697455933e61$var$eventListenerOptions = (0, $kW5V1.G) ? {
    passive: true
} : false;
function $e37e697455933e61$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $e37e697455933e61$var$eventListenerOptions);
}
function $e37e697455933e61$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $e37e697455933e61$var$eventListenerOptions);
}
function $e37e697455933e61$var$fromNativeEvent(event, chart) {
    const type = $e37e697455933e61$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $kW5V1.x)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $e37e697455933e61$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $kW5V1.D)(canvas);
    const element = container || canvas;
    const observer = new MutationObserver((entries)=>{
        const parent = (0, $kW5V1.D)(element);
        entries.forEach((entry)=>{
            for(let i = 0; i < entry.addedNodes.length; i++){
                const added = entry.addedNodes[i];
                if (added === element || added === parent) listener(entry.target);
            }
        });
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $e37e697455933e61$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $kW5V1.D)(canvas);
    if (!container) return;
    const observer = new MutationObserver((entries)=>{
        entries.forEach((entry)=>{
            for(let i = 0; i < entry.removedNodes.length; i++)if (entry.removedNodes[i] === canvas) {
                listener();
                break;
            }
        });
    });
    observer.observe(container, {
        childList: true
    });
    return observer;
}
const $e37e697455933e61$var$drpListeningCharts = new Map();
let $e37e697455933e61$var$oldDevicePixelRatio = 0;
function $e37e697455933e61$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $e37e697455933e61$var$oldDevicePixelRatio) return;
    $e37e697455933e61$var$oldDevicePixelRatio = dpr;
    $e37e697455933e61$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $e37e697455933e61$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$e37e697455933e61$var$drpListeningCharts.size) window.addEventListener("resize", $e37e697455933e61$var$onWindowResize);
    $e37e697455933e61$var$drpListeningCharts.set(chart, resize);
}
function $e37e697455933e61$var$unlistenDevicePixelRatioChanges(chart) {
    $e37e697455933e61$var$drpListeningCharts.delete(chart);
    if (!$e37e697455933e61$var$drpListeningCharts.size) window.removeEventListener("resize", $e37e697455933e61$var$onWindowResize);
}
function $e37e697455933e61$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $kW5V1.D)(canvas);
    if (!container) return;
    const resize = (0, $kW5V1.F)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $e37e697455933e61$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $e37e697455933e61$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $e37e697455933e61$var$unlistenDevicePixelRatioChanges(chart);
}
function $e37e697455933e61$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $kW5V1.F)((event)=>{
        if (chart.ctx !== null) listener($e37e697455933e61$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $e37e697455933e61$var$addListener(canvas, type, proxy);
    return proxy;
}
class $e37e697455933e61$export$f02da7f882cf6b2e extends $e37e697455933e61$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $e37e697455933e61$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$e37e697455933e61$var$EXPANDO_KEY]) return false;
        const initial = canvas[$e37e697455933e61$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $kW5V1.j)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$e37e697455933e61$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $e37e697455933e61$var$createAttachObserver,
            detach: $e37e697455933e61$var$createDetachObserver,
            resize: $e37e697455933e61$var$createResizeObserver
        };
        const handler = handlers[type] || $e37e697455933e61$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $e37e697455933e61$var$releaseObserver,
            detach: $e37e697455933e61$var$releaseObserver,
            resize: $e37e697455933e61$var$releaseObserver
        };
        const handler = handlers[type] || $e37e697455933e61$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $kW5V1.C)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $kW5V1.D)(canvas);
        return !!(container && (0, $kW5V1.D)(container));
    }
}
class $e37e697455933e61$export$db77ccec0bb4ccac {
    constructor(){
        this.x = undefined;
        this.y = undefined;
        this.active = false;
        this.options = undefined;
        this.$animations = undefined;
    }
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $kW5V1.p)(this.x) && (0, $kW5V1.p)(this.y);
    }
    getProps(props, final) {
        const me = this;
        const anims = this.$animations;
        if (!final || !anims) return me;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : me[prop];
        });
        return ret;
    }
}
$e37e697455933e61$export$db77ccec0bb4ccac.defaults = {};
$e37e697455933e61$export$db77ccec0bb4ccac.defaultRoutes = undefined;
const $e37e697455933e61$var$formatters = {
    values (value) {
        return (0, $kW5V1.b)(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $e37e697455933e61$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = (0, $kW5V1.I)(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return (0, $kW5V1.n)(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = tickValue / Math.pow(10, Math.floor((0, $kW5V1.I)(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $e37e697455933e61$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $e37e697455933e61$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $e37e697455933e61$export$27c7467594ef87bd = {
    formatters: $e37e697455933e61$var$formatters
};
(0, $kW5V1.d).set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: "",
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: "",
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $e37e697455933e61$export$27c7467594ef87bd.formatters.values,
        minor: {},
        major: {},
        align: "center",
        crossAlign: "near",
        showLabelBackdrop: false,
        backdropColor: "rgba(255, 255, 255, 0.75)",
        backdropPadding: 2
    }
});
(0, $kW5V1.d).route("scale.ticks", "color", "", "color");
(0, $kW5V1.d).route("scale.grid", "color", "", "borderColor");
(0, $kW5V1.d).route("scale.grid", "borderColor", "", "borderColor");
(0, $kW5V1.d).route("scale.title", "color", "", "color");
(0, $kW5V1.d).describe("scale", {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash"
});
(0, $kW5V1.d).describe("scales", {
    _fallback: "scale"
});
(0, $kW5V1.d).describe("scale.ticks", {
    _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
    _indexable: (name)=>name !== "backdropPadding"
});
function $e37e697455933e61$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $e37e697455933e61$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $e37e697455933e61$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $e37e697455933e61$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $e37e697455933e61$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $e37e697455933e61$var$skip(ticks, newTicks, spacing, (0, $kW5V1.j)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$e37e697455933e61$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $e37e697455933e61$var$skip(ticks, newTicks, spacing, last, (0, $kW5V1.j)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $e37e697455933e61$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $e37e697455933e61$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $e37e697455933e61$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $e37e697455933e61$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $kW5V1.J)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $e37e697455933e61$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $e37e697455933e61$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $e37e697455933e61$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $kW5V1.v)(majorStart, 0);
    const end = Math.min((0, $kW5V1.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $e37e697455933e61$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $e37e697455933e61$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $e37e697455933e61$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
function $e37e697455933e61$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $e37e697455933e61$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $e37e697455933e61$var$garbageCollect(caches, length) {
    (0, $kW5V1.B)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $e37e697455933e61$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $e37e697455933e61$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $kW5V1.W)(options.font, fallback);
    const padding = (0, $kW5V1.A)(options.padding);
    const lines = (0, $kW5V1.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $e37e697455933e61$var$createScaleContext(parent, scale) {
    return Object.assign(Object.create(parent), {
        scale: scale,
        type: "scale"
    });
}
function $e37e697455933e61$var$createTickContext(parent, index, tick) {
    return Object.assign(Object.create(parent), {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $e37e697455933e61$var$titleAlign(align, position, reverse) {
    let ret = (0, $kW5V1.X)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $e37e697455933e61$var$reverseAlign(ret);
    return ret;
}
function $e37e697455933e61$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right } = scale;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    if (scale.isHorizontal()) {
        titleX = (0, $kW5V1.Y)(align, left, right);
        titleY = $e37e697455933e61$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        titleX = $e37e697455933e61$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $kW5V1.Y)(align, bottom, top);
        rotation = position === "left" ? -(0, $kW5V1.H) : (0, $kW5V1.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $e37e697455933e61$export$d60cfc58d3c358b6 extends $e37e697455933e61$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        const me = this;
        me.options = options.setContext(me.getContext());
        me.axis = options.axis;
        me._userMin = me.parse(options.min);
        me._userMax = me.parse(options.max);
        me._suggestedMin = me.parse(options.suggestedMin);
        me._suggestedMax = me.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $kW5V1.K)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $kW5V1.K)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $kW5V1.K)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $kW5V1.K)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $kW5V1.K)(_userMin, _suggestedMin),
            max: (0, $kW5V1.K)(_userMax, _suggestedMax),
            minDefined: (0, $kW5V1.g)(_userMin),
            maxDefined: (0, $kW5V1.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        const me = this;
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = me.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(me, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        return {
            min: (0, $kW5V1.K)(min, (0, $kW5V1.K)(max, min)),
            max: (0, $kW5V1.K)(max, (0, $kW5V1.K)(min, max))
        };
    }
    getPadding() {
        const me = this;
        return {
            left: me.paddingLeft || 0,
            top: me.paddingTop || 0,
            right: me.paddingRight || 0,
            bottom: me.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $kW5V1.L)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const me = this;
        const tickOpts = me.options.ticks;
        const sampleSize = tickOpts.sampleSize;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        me.ticks = null;
        me._labelSizes = null;
        me._gridLineItems = null;
        me._labelItems = null;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me._maxLength = me.isHorizontal() ? me.width + margins.left + margins.right : me.height + margins.top + margins.bottom;
        if (!me._dataLimitsCached) {
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            me._range = (0, $kW5V1.M)(me, me.options.grace);
            me._dataLimitsCached = true;
        }
        me.beforeBuildTicks();
        me.ticks = me.buildTicks() || [];
        me.afterBuildTicks();
        const samplingEnabled = sampleSize < me.ticks.length;
        me._convertTicksToLabels(samplingEnabled ? $e37e697455933e61$var$sample(me.ticks, sampleSize) : me.ticks);
        me.configure();
        me.beforeCalculateLabelRotation();
        me.calculateLabelRotation();
        me.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            me.ticks = $e37e697455933e61$var$autoSkip(me, me.ticks);
            me._labelSizes = null;
        }
        if (samplingEnabled) me._convertTicksToLabels(me.ticks);
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
    }
    configure() {
        const me = this;
        let reversePixels = me.options.reverse;
        let startPixel, endPixel;
        if (me.isHorizontal()) {
            startPixel = me.left;
            endPixel = me.right;
        } else {
            startPixel = me.top;
            endPixel = me.bottom;
            reversePixels = !reversePixels;
        }
        me._startPixel = startPixel;
        me._endPixel = endPixel;
        me._reversePixels = reversePixels;
        me._length = endPixel - startPixel;
        me._alignToPixels = me.options.alignToPixels;
    }
    afterUpdate() {
        (0, $kW5V1.L)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $kW5V1.L)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        const me = this;
        if (me.isHorizontal()) {
            me.width = me.maxWidth;
            me.left = 0;
            me.right = me.width;
        } else {
            me.height = me.maxHeight;
            me.top = 0;
            me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $kW5V1.L)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        const me = this;
        me.chart.notifyPlugins(name, me.getContext());
        (0, $kW5V1.L)(me.options[name], [
            me
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $kW5V1.L)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const me = this;
        const tickOpts = me.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $kW5V1.L)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], me);
        }
    }
    afterTickToLabelConversion() {
        (0, $kW5V1.L)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $kW5V1.L)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const me = this;
        const options = me.options;
        const tickOpts = options.ticks;
        const numTicks = me.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
            me.labelRotation = minRotation;
            return;
        }
        const labelSizes = me._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $kW5V1.q)(me.chart.width - maxLabelWidth, 0, me.maxWidth);
        tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = me.maxHeight - $e37e697455933e61$var$getTickMarkLength(options.grid) - tickOpts.padding - $e37e697455933e61$var$getTitleHeight(options.title, me.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $kW5V1.N)(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        me.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $kW5V1.L)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    beforeFit() {
        (0, $kW5V1.L)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const me = this;
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = me;
        const display = me._isVisible();
        const isHorizontal = me.isHorizontal();
        if (display) {
            const titleHeight = $e37e697455933e61$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = me.maxWidth;
                minSize.height = $e37e697455933e61$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = me.maxHeight;
                minSize.width = $e37e697455933e61$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && me.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = me._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $kW5V1.t)(me.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                me._calculatePadding(first, last, sin, cos);
            }
        }
        me._handleMargins();
        if (isHorizontal) {
            me.width = me._length = chart.width - me._margins.left - me._margins.right;
            me.height = minSize.height;
        } else {
            me.width = minSize.width;
            me.height = me._length = chart.height - me._margins.top - me._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const me = this;
        const { ticks: { align: align, padding: padding }, position: position } = me.options;
        const isRotated = me.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && me.axis === "x";
        if (me.isHorizontal()) {
            const offsetLeft = me.getPixelForTick(0) - me.left;
            const offsetRight = me.right - me.getPixelForTick(me.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            me.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * me.width / (me.width - offsetLeft), 0);
            me.paddingRight = Math.max((paddingRight - offsetRight + padding) * me.width / (me.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            me.paddingTop = paddingTop + padding;
            me.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        const me = this;
        if (me._margins) {
            me._margins.left = Math.max(me.paddingLeft, me._margins.left);
            me._margins.top = Math.max(me.paddingTop, me._margins.top);
            me._margins.right = Math.max(me.paddingRight, me._margins.right);
            me._margins.bottom = Math.max(me.paddingBottom, me._margins.bottom);
        }
    }
    afterFit() {
        (0, $kW5V1.L)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        const me = this;
        me.beforeTickToLabelConversion();
        me.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $kW5V1.j)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        me.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        const me = this;
        let labelSizes = me._labelSizes;
        if (!labelSizes) {
            const sampleSize = me.options.ticks.sampleSize;
            let ticks = me.ticks;
            if (sampleSize < ticks.length) ticks = $e37e697455933e61$var$sample(ticks, sampleSize);
            me._labelSizes = labelSizes = me._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $kW5V1.j)(label) && !(0, $kW5V1.b)(label)) {
                width = (0, $kW5V1.O)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $kW5V1.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $kW5V1.j)(nestedLabel) && !(0, $kW5V1.b)(nestedLabel)) {
                    width = (0, $kW5V1.O)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $e37e697455933e61$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        const me = this;
        if (me._reversePixels) decimal = 1 - decimal;
        const pixel = me._startPixel + decimal * me._length;
        return (0, $kW5V1.Q)(me._alignToPixels ? (0, $kW5V1.R)(me.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const me = this;
        const ticks = me.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $e37e697455933e61$var$createTickContext(me.getContext(), index, tick));
        }
        return me.$context || (me.$context = $e37e697455933e61$var$createScaleContext(me.chart.getContext(), me));
    }
    _tickSize() {
        const me = this;
        const optionTicks = me.options.ticks;
        const rot = (0, $kW5V1.t)(me.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = me._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const me = this;
        const axis = me.axis;
        const chart = me.chart;
        const options = me.options;
        const { grid: grid, position: position } = options;
        const offset = grid.offset;
        const isHorizontal = me.isHorizontal();
        const ticks = me.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $e37e697455933e61$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(me.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $kW5V1.R)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(me.bottom);
            ty1 = me.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(me.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = me.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(me.right);
            tx1 = me.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(me.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = me.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $kW5V1.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(me.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $kW5V1.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(me.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $kW5V1.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(me.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = grid.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $e37e697455933e61$var$getPixelForGridLine(me, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $kW5V1.R)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        me._ticksLength = ticksLength;
        me._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const me = this;
        const axis = me.axis;
        const options = me.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = me.isHorizontal();
        const ticks = me.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $e37e697455933e61$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $kW5V1.t)(me.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = me.bottom - hTickAndPadding;
            textAlign = me._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = me.top + hTickAndPadding;
            textAlign = me._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = me._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = me._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $kW5V1.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = me.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = me._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $kW5V1.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = me.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = me._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = me._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(me.getContext(i));
            pixel = me.getPixelForTick(i) + optionTicks.labelOffset;
            font = me._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $kW5V1.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            if (isHorizontal) {
                x = pixel;
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $kW5V1.A)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: textAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const me = this;
        const { position: position, ticks: ticks } = me.options;
        const rotation = -(0, $kW5V1.t)(me.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const me = this;
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = me.options;
        const labelSizes = me._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                textAlign = "left";
                x = me.right + padding;
            } else {
                x = me.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = me.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                textAlign = "right";
                x = me.left + padding;
            } else {
                x = me.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = me.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        const me = this;
        if (me.options.ticks.mirror) return;
        const chart = me.chart;
        const position = me.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: me.left,
            bottom: chart.height,
            right: me.right
        };
        if (position === "top" || position === "bottom") return {
            top: me.top,
            left: 0,
            bottom: me.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const me = this;
        const grid = me.options.grid;
        if (!me._isVisible() || !grid.display) return 0;
        const ticks = me.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(me.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const me = this;
        const grid = me.options.grid;
        const ctx = me.ctx;
        const items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const me = this;
        const { chart: chart, ctx: ctx, options: { grid: grid } } = me;
        const borderOpts = grid.setContext(me.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(me.getContext(0)).lineWidth;
        const borderValue = me._borderValue;
        let x1, x2, y1, y2;
        if (me.isHorizontal()) {
            x1 = (0, $kW5V1.R)(chart, me.left, axisWidth) - axisWidth / 2;
            x2 = (0, $kW5V1.R)(chart, me.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $kW5V1.R)(chart, me.top, axisWidth) - axisWidth / 2;
            y2 = (0, $kW5V1.R)(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const me = this;
        const optionTicks = me.options.ticks;
        if (!optionTicks.display) return;
        const ctx = me.ctx;
        const area = me._computeLabelArea();
        if (area) (0, $kW5V1.S)(ctx, area);
        const items = me._labelItems || (me._labelItems = me._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            (0, $kW5V1.U)(ctx, label, 0, y, tickFont, item);
        }
        if (area) (0, $kW5V1.V)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $kW5V1.W)(title.font);
        const padding = (0, $kW5V1.A)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom") {
            offset += padding.bottom;
            if ((0, $kW5V1.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $e37e697455933e61$var$titleArgs(this, offset, position, align);
        (0, $kW5V1.U)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $e37e697455933e61$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        const me = this;
        if (!me._isVisible()) return;
        me.drawBackground();
        me.drawGrid(chartArea);
        me.drawBorder();
        me.drawTitle();
        me.drawLabels(chartArea);
    }
    _layers() {
        const me = this;
        const opts = me.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = opts.grid && opts.grid.z || 0;
        if (!me._isVisible() || me.draw !== $e37e697455933e61$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw (chartArea) {
                    me.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw (chartArea) {
                    me.drawBackground();
                    me.drawGrid(chartArea);
                    me.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw () {
                    me.drawBorder();
                }
            },
            {
                z: tz,
                draw (chartArea) {
                    me.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const me = this;
        const metas = me.chart.getSortedVisibleDatasetMetas();
        const axisID = me.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === me.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $kW5V1.W)(opts.font);
    }
    _maxDigits() {
        const me = this;
        const fontSize = me._resolveTickFontOptions(0).lineHeight;
        return (me.isHorizontal() ? me.width : me.height) / fontSize;
    }
}
class $e37e697455933e61$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const me = this;
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($e37e697455933e61$var$isIChartComponent(proto)) parentScope = me.register(proto);
        const items = me.items;
        const id = item.id;
        const scope = me.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $e37e697455933e61$var$registerDefaults(item, scope, parentScope);
        if (me.override) (0, $kW5V1.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $kW5V1.d)[scope]) {
            delete (0, $kW5V1.d)[scope][id];
            if (this.override) delete (0, $kW5V1.Z)[id];
        }
    }
}
function $e37e697455933e61$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $kW5V1.$)(Object.create(null), [
        parentScope ? (0, $kW5V1.d).get(parentScope) : {},
        (0, $kW5V1.d).get(scope),
        item.defaults
    ]);
    (0, $kW5V1.d).set(scope, itemDefaults);
    if (item.defaultRoutes) $e37e697455933e61$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $kW5V1.d).describe(scope, item.descriptors);
}
function $e37e697455933e61$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $kW5V1.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $e37e697455933e61$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $e37e697455933e61$var$Registry {
    constructor(){
        this.controllers = new $e37e697455933e61$var$TypedRegistry($e37e697455933e61$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $e37e697455933e61$var$TypedRegistry($e37e697455933e61$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $e37e697455933e61$var$TypedRegistry(Object, "plugins");
        this.scales = new $e37e697455933e61$var$TypedRegistry($e37e697455933e61$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        const me = this;
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || me._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === me.plugins && arg.id) me._exec(method, reg, arg);
            else (0, $kW5V1.B)(arg, (item)=>{
                const itemReg = typedRegistry || me._getRegistryForType(item);
                me._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $kW5V1.a0)(method);
        (0, $kW5V1.L)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $kW5V1.L)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $e37e697455933e61$export$4bb7493d241fd8a5 = new $e37e697455933e61$var$Registry();
class $e37e697455933e61$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        const me = this;
        if (hook === "beforeInit") {
            me._init = me._createDescriptors(chart, true);
            me._notify(me._init, chart, "install");
        }
        const descriptors = filter ? me._descriptors(chart).filter(filter) : me._descriptors(chart);
        const result = me._notify(descriptors, chart, hook, args);
        if (hook === "destroy") {
            me._notify(descriptors, chart, "stop");
            me._notify(me._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $kW5V1.L)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $kW5V1.j)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $kW5V1.v)(config.options && config.options.plugins, {});
        const plugins = $e37e697455933e61$var$allPlugins(config);
        return options === false && !all ? [] : $e37e697455933e61$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $e37e697455933e61$var$allPlugins(config) {
    const plugins = [];
    const keys = Object.keys($e37e697455933e61$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($e37e697455933e61$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) plugins.push(plugin);
    }
    return plugins;
}
function $e37e697455933e61$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $e37e697455933e61$var$createDescriptors(chart, plugins, options, all) {
    const result = [];
    const context = chart.getContext();
    for(let i = 0; i < plugins.length; i++){
        const plugin = plugins[i];
        const id = plugin.id;
        const opts = $e37e697455933e61$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $e37e697455933e61$var$pluginOpts(chart.config, plugin, opts, context)
        });
    }
    return result;
}
function $e37e697455933e61$var$pluginOpts(config, plugin, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $e37e697455933e61$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $kW5V1.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $e37e697455933e61$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $e37e697455933e61$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $e37e697455933e61$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $e37e697455933e61$var$determineAxis(id, scaleOptions) {
    if (id === "x" || id === "y") return id;
    return scaleOptions.axis || $e37e697455933e61$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $e37e697455933e61$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $kW5V1.Z)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $e37e697455933e61$var$getIndexAxis(config.type, options);
    const firstIDs = Object.create(null);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        const axis = $e37e697455933e61$var$determineAxis(id, scaleConf);
        const defaultId = $e37e697455933e61$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales[id] = (0, $kW5V1.a6)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $e37e697455933e61$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $kW5V1.Z)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $e37e697455933e61$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $kW5V1.a6)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $kW5V1.a6)(scale, [
            (0, $kW5V1.d).scales[scale.type],
            (0, $kW5V1.d).scale
        ]);
    });
    return scales;
}
function $e37e697455933e61$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $kW5V1.v)(options.plugins, {});
    options.scales = $e37e697455933e61$var$mergeScaleConfig(config, options);
}
function $e37e697455933e61$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $e37e697455933e61$var$initConfig(config) {
    config = config || {};
    config.data = $e37e697455933e61$var$initData(config.data);
    $e37e697455933e61$var$initOptions(config);
    return config;
}
const $e37e697455933e61$var$keyCache = new Map();
const $e37e697455933e61$var$keysCached = new Set();
function $e37e697455933e61$var$cachedKeys(cacheKey, generate) {
    let keys = $e37e697455933e61$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $e37e697455933e61$var$keyCache.set(cacheKey, keys);
        $e37e697455933e61$var$keysCached.add(keys);
    }
    return keys;
}
const $e37e697455933e61$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $kW5V1.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $e37e697455933e61$var$Config {
    constructor(config){
        this._config = $e37e697455933e61$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $e37e697455933e61$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $e37e697455933e61$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $e37e697455933e61$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $e37e697455933e61$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $e37e697455933e61$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $e37e697455933e61$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$e37e697455933e61$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$e37e697455933e61$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$e37e697455933e61$var$addIfFound(scopes, (0, $kW5V1.Z)[type] || {}, key));
            keys.forEach((key)=>$e37e697455933e61$var$addIfFound(scopes, (0, $kW5V1.d), key));
            keys.forEach((key)=>$e37e697455933e61$var$addIfFound(scopes, (0, $kW5V1.a1), key));
        });
        const array = Array.from(scopes);
        if ($e37e697455933e61$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $kW5V1.Z)[type] || {},
            (0, $kW5V1.d).datasets[type] || {},
            {
                type: type
            },
            (0, $kW5V1.d),
            (0, $kW5V1.a1)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $e37e697455933e61$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($e37e697455933e61$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $kW5V1.a2)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $kW5V1.a3)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $e37e697455933e61$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $kW5V1.i)(context) ? (0, $kW5V1.a3)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $e37e697455933e61$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $kW5V1.a4)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
function $e37e697455933e61$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $kW5V1.a5)(proxy);
    for (const prop of names){
        if (isScriptable(prop) && (0, $kW5V1.a2)(proxy[prop]) || isIndexable(prop) && (0, $kW5V1.b)(proxy[prop])) return true;
    }
    return false;
}
var $e37e697455933e61$var$version = "3.4.1";
const $e37e697455933e61$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $e37e697455933e61$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $e37e697455933e61$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $e37e697455933e61$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $e37e697455933e61$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $kW5V1.L)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $e37e697455933e61$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $kW5V1.L)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $e37e697455933e61$var$isDomSupported() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function $e37e697455933e61$var$getCanvas(item) {
    if ($e37e697455933e61$var$isDomSupported() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $e37e697455933e61$var$instances = {};
const $e37e697455933e61$var$getChart = (key)=>{
    const canvas = $e37e697455933e61$var$getCanvas(key);
    return Object.values($e37e697455933e61$var$instances).filter((c)=>c.canvas === canvas).pop();
};
class $e37e697455933e61$export$acaa6426d77a227e {
    constructor(item, config){
        const me = this;
        this.config = config = new $e37e697455933e61$var$Config(config);
        const initialCanvas = $e37e697455933e61$var$getCanvas(item);
        const existingChart = $e37e697455933e61$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), me.getContext());
        this.platform = me._initializePlatform(initialCanvas, config);
        const context = me.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $kW5V1.a7)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this.scale = undefined;
        this._plugins = new $e37e697455933e61$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $kW5V1.a8)(()=>this.update("resize"), options.resizeDelay || 0);
        $e37e697455933e61$var$instances[me.id] = me;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $e37e697455933e61$export$a424a0aa8f687495.listen(me, "complete", $e37e697455933e61$var$onAnimationsComplete);
        $e37e697455933e61$export$a424a0aa8f687495.listen(me, "progress", $e37e697455933e61$var$onAnimationProgress);
        me._initialize();
        if (me.attached) me.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $kW5V1.j)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        const me = this;
        me.notifyPlugins("beforeInit");
        if (me.options.responsive) me.resize();
        else (0, $kW5V1.a9)(me, me.options.devicePixelRatio);
        me.bindEvents();
        me.notifyPlugins("afterInit");
        return me;
    }
    _initializePlatform(canvas, config) {
        if (config.platform) return new config.platform();
        else if (!$e37e697455933e61$var$isDomSupported() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return new $e37e697455933e61$export$a40a96b24b46cf35();
        return new $e37e697455933e61$export$f02da7f882cf6b2e();
    }
    clear() {
        (0, $kW5V1.aa)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $e37e697455933e61$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$e37e697455933e61$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const me = this;
        const options = me.options;
        const canvas = me.canvas;
        const aspectRatio = options.maintainAspectRatio && me.aspectRatio;
        const newSize = me.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || me.platform.getDevicePixelRatio();
        me.width = newSize.width;
        me.height = newSize.height;
        me._aspectRatio = me.aspectRatio;
        if (!(0, $kW5V1.a9)(me, newRatio, true)) return;
        me.notifyPlugins("resize", {
            size: newSize
        });
        (0, $kW5V1.L)(options.onResize, [
            me,
            newSize
        ], me);
        if (me.attached) {
            if (me._doResize()) me.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $kW5V1.B)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const me = this;
        const options = me.options;
        const scaleOpts = options.scales;
        const scales = me.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $e37e697455933e61$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $kW5V1.B)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $e37e697455933e61$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $kW5V1.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $e37e697455933e61$var$positionIsHorizontal(scaleOptions.position, axis) !== $e37e697455933e61$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $e37e697455933e61$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: me.ctx,
                    chart: me
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $kW5V1.B)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $kW5V1.B)(scales, (scale)=>{
            $e37e697455933e61$export$1ecca0613f5e56d2.configure(me, scale, scale.options);
            $e37e697455933e61$export$1ecca0613f5e56d2.addBox(me, scale);
        });
    }
    _updateMetasets() {
        const me = this;
        const metasets = me._metasets;
        const numData = me.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)me._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        me._sortedMetasets = metasets.slice(0).sort($e37e697455933e61$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const me = this;
        const { _metasets: metasets, data: { datasets: datasets } } = me;
        if (metasets.length > datasets.length) delete me._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) me._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const me = this;
        const newControllers = [];
        const datasets = me.data.datasets;
        let i, ilen;
        me._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = me.getDatasetMeta(i);
            const type = dataset.type || me.config.type;
            if (meta.type && meta.type !== type) {
                me._destroyDatasetMeta(i);
                meta = me.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $e37e697455933e61$var$getIndexAxis(type, me.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = me.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $e37e697455933e61$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $kW5V1.d).datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $e37e697455933e61$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $e37e697455933e61$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(me, i);
                newControllers.push(meta.controller);
            }
        }
        me._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        const me = this;
        (0, $kW5V1.B)(me.data.datasets, (dataset, datasetIndex)=>{
            me.getDatasetMeta(datasetIndex).controller.reset();
        }, me);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const me = this;
        const config = me.config;
        config.update();
        me._options = config.createResolver(config.chartOptionScopes(), me.getContext());
        (0, $kW5V1.B)(me.scales, (scale)=>{
            $e37e697455933e61$export$1ecca0613f5e56d2.removeBox(me, scale);
        });
        const animsDisabled = me._animationsDisabled = !me.options.animation;
        me.ensureScalesHaveIDs();
        me.buildOrUpdateScales();
        const existingEvents = new Set(Object.keys(me._listeners));
        const newEvents = new Set(me.options.events);
        if (!(0, $kW5V1.ab)(existingEvents, newEvents) || !!this._responsiveListeners !== me.options.responsive) {
            me.unbindEvents();
            me.bindEvents();
        }
        me._plugins.invalidate();
        if (me.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = me.buildOrUpdateControllers();
        me.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = me.data.datasets.length; i < ilen; i++){
            const { controller: controller } = me.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        me._minPadding = minPadding;
        me._updateLayout(minPadding);
        if (!animsDisabled) (0, $kW5V1.B)(newControllers, (controller)=>{
            controller.reset();
        });
        me._updateDatasets(mode);
        me.notifyPlugins("afterUpdate", {
            mode: mode
        });
        me._layers.sort($e37e697455933e61$var$compare2Level("z", "_idx"));
        if (me._lastEvent) me._eventHandler(me._lastEvent, true);
        me.render();
    }
    _updateLayout(minPadding) {
        const me = this;
        if (me.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $e37e697455933e61$export$1ecca0613f5e56d2.update(me, me.width, me.height, minPadding);
        const area = me.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        me._layers = [];
        (0, $kW5V1.B)(me.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            me._layers.push(...box._layers());
        }, me);
        me._layers.forEach((item, index)=>{
            item._idx = index;
        });
        me.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        const me = this;
        const isFunction = typeof mode === "function";
        if (me.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me._updateDataset(i, isFunction ? mode({
            datasetIndex: i
        }) : mode);
        me.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const me = this;
        const meta = me.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (me.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        me.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        const me = this;
        if (me.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($e37e697455933e61$export$a424a0aa8f687495.has(me)) {
            if (me.attached && !$e37e697455933e61$export$a424a0aa8f687495.running(me)) $e37e697455933e61$export$a424a0aa8f687495.start(me);
        } else {
            me.draw();
            $e37e697455933e61$var$onAnimationsComplete({
                chart: me
            });
        }
    }
    draw() {
        const me = this;
        let i;
        if (me._resizeBeforeDraw) {
            const { width: width, height: height } = me._resizeBeforeDraw;
            me._resize(width, height);
            me._resizeBeforeDraw = null;
        }
        me.clear();
        if (me.width <= 0 || me.height <= 0) return;
        if (me.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = me._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
        me._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
        me.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const me = this;
        const metasets = me._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        const me = this;
        if (me.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = me.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)me._drawDataset(metasets[i]);
        me.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const me = this;
        const ctx = me.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = me.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (me.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $kW5V1.S)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? me.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? me.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $kW5V1.V)(ctx);
        args.cancelable = false;
        me.notifyPlugins("afterDatasetDraw", args);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $e37e697455933e61$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const me = this;
        const dataset = me.data.datasets[datasetIndex];
        const metasets = me._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = {
            chart: this,
            type: "chart"
        });
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateDatasetVisibility(datasetIndex, visible) {
        const me = this;
        const mode = visible ? "show" : "hide";
        const meta = me.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        me.setDatasetVisibility(datasetIndex, visible);
        anims.update(meta, {
            visible: visible
        });
        me.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
    }
    hide(datasetIndex) {
        this._updateDatasetVisibility(datasetIndex, false);
    }
    show(datasetIndex) {
        this._updateDatasetVisibility(datasetIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const me = this;
        const meta = me._metasets && me._metasets[datasetIndex];
        if (meta && meta.controller) {
            meta.controller._destroy();
            delete me._metasets[datasetIndex];
        }
    }
    destroy() {
        const me = this;
        const { canvas: canvas, ctx: ctx } = me;
        let i, ilen;
        me.stop();
        $e37e697455933e61$export$a424a0aa8f687495.remove(me);
        for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me._destroyDatasetMeta(i);
        me.config.clearCache();
        if (canvas) {
            me.unbindEvents();
            (0, $kW5V1.aa)(canvas, ctx);
            me.platform.releaseContext(ctx);
            me.canvas = null;
            me.ctx = null;
        }
        me.notifyPlugins("destroy");
        delete $e37e697455933e61$var$instances[me.id];
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const me = this;
        const listeners = me._listeners;
        const platform = me.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(me, type, listener);
            listeners[type] = listener;
        };
        const listener = function(e, x, y) {
            e.offsetX = x;
            e.offsetY = y;
            me._eventHandler(e);
        };
        (0, $kW5V1.B)(me.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        const me = this;
        if (!me._responsiveListeners) me._responsiveListeners = {};
        const listeners = me._responsiveListeners;
        const platform = me.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(me, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(me, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (me.canvas) me.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            me.attached = true;
            me.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            me.attached = false;
            _remove("resize", listener);
            _add("attach", attached);
        };
        if (platform.isAttached(me.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        const me = this;
        (0, $kW5V1.B)(me._listeners, (listener, type)=>{
            me.platform.removeEventListener(me, type, listener);
        });
        me._listeners = {};
        (0, $kW5V1.B)(me._responsiveListeners, (listener, type)=>{
            me.platform.removeEventListener(me, type, listener);
        });
        me._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const me = this;
        const lastActive = me._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = me.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $kW5V1.ac)(active, lastActive);
        if (changed) {
            me._active = active;
            me._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const me = this;
        const hoverOptions = me.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) me.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) me.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const me = this;
        const args = {
            event: e,
            replay: replay,
            cancelable: true
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.type);
        if (me.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = me._handleEvent(e, replay);
        args.cancelable = false;
        me.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) me.render();
        return me;
    }
    _handleEvent(e, replay) {
        const me = this;
        const { _active: lastActive = [], options: options } = me;
        const hoverOptions = options.hover;
        const useFinalPosition = replay;
        let active = [];
        let changed = false;
        let lastEvent = null;
        if (e.type !== "mouseout") {
            active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
            lastEvent = e.type === "click" ? me._lastEvent : e;
        }
        me._lastEvent = null;
        if ((0, $kW5V1.y)(e, me.chartArea, me._minPadding)) {
            (0, $kW5V1.L)(options.onHover, [
                e,
                active,
                me
            ], me);
            if (e.type === "mouseup" || e.type === "click" || e.type === "contextmenu") (0, $kW5V1.L)(options.onClick, [
                e,
                active,
                me
            ], me);
        }
        changed = !(0, $kW5V1.ac)(active, lastActive);
        if (changed || replay) {
            me._active = active;
            me._updateHoverStyles(active, lastActive, replay);
        }
        me._lastEvent = lastEvent;
        return changed;
    }
}
const $e37e697455933e61$var$invalidatePlugins = ()=>(0, $kW5V1.B)($e37e697455933e61$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
const $e37e697455933e61$var$enumerable = true;
Object.defineProperties($e37e697455933e61$export$acaa6426d77a227e, {
    defaults: {
        enumerable: $e37e697455933e61$var$enumerable,
        value: (0, $kW5V1.d)
    },
    instances: {
        enumerable: $e37e697455933e61$var$enumerable,
        value: $e37e697455933e61$var$instances
    },
    overrides: {
        enumerable: $e37e697455933e61$var$enumerable,
        value: (0, $kW5V1.Z)
    },
    registry: {
        enumerable: $e37e697455933e61$var$enumerable,
        value: $e37e697455933e61$export$4bb7493d241fd8a5
    },
    version: {
        enumerable: $e37e697455933e61$var$enumerable,
        value: $e37e697455933e61$var$version
    },
    getChart: {
        enumerable: $e37e697455933e61$var$enumerable,
        value: $e37e697455933e61$var$getChart
    },
    register: {
        enumerable: $e37e697455933e61$var$enumerable,
        value: (...items)=>{
            $e37e697455933e61$export$4bb7493d241fd8a5.add(...items);
            $e37e697455933e61$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $e37e697455933e61$var$enumerable,
        value: (...items)=>{
            $e37e697455933e61$export$4bb7493d241fd8a5.remove(...items);
            $e37e697455933e61$var$invalidatePlugins();
        }
    }
});
function $e37e697455933e61$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $kW5V1.H), startAngle - (0, $kW5V1.H));
    ctx.closePath();
    ctx.clip();
}
function $e37e697455933e61$var$toRadiusCorners(value) {
    return (0, $kW5V1.ae)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
function $e37e697455933e61$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $e37e697455933e61$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $kW5V1.q)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $kW5V1.q)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $kW5V1.q)(o.innerEnd, 0, innerLimit)
    };
}
function $e37e697455933e61$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $e37e697455933e61$var$pathArc(ctx, element, offset, spacing, end) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $kW5V1.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $e37e697455933e61$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
    if (outerEnd > 0) {
        const pCenter = $e37e697455933e61$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $kW5V1.H));
    }
    const p4 = $e37e697455933e61$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
    ctx.lineTo(p4.x, p4.y);
    if (innerEnd > 0) {
        const pCenter = $e37e697455933e61$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $kW5V1.H), innerEndAdjustedAngle + Math.PI);
    }
    ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
    if (innerStart > 0) {
        const pCenter = $e37e697455933e61$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $kW5V1.H));
    }
    const p8 = $e37e697455933e61$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
    ctx.lineTo(p8.x, p8.y);
    if (outerStart > 0) {
        const pCenter = $e37e697455933e61$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
        ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $kW5V1.H), outerStartAdjustedAngle);
    }
    ctx.closePath();
}
function $e37e697455933e61$var$drawArc(ctx, element, offset, spacing) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $e37e697455933e61$var$pathArc(ctx, element, offset, spacing, startAngle + (0, $kW5V1.T));
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % (0, $kW5V1.T);
            if (circumference % (0, $kW5V1.T) === 0) endAngle += (0, $kW5V1.T);
        }
    }
    $e37e697455933e61$var$pathArc(ctx, element, offset, spacing, endAngle);
    ctx.fill();
    return endAngle;
}
function $e37e697455933e61$var$drawFullCircleBorders(ctx, element, inner) {
    const { x: x, y: y, startAngle: startAngle, pixelMargin: pixelMargin, fullCircles: fullCircles } = element;
    const outerRadius = Math.max(element.outerRadius - pixelMargin, 0);
    const innerRadius = element.innerRadius + pixelMargin;
    let i;
    if (inner) $e37e697455933e61$var$clipArc(ctx, element, startAngle + (0, $kW5V1.T));
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + (0, $kW5V1.T), startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + (0, $kW5V1.T));
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $e37e697455933e61$var$drawBorder(ctx, element, offset, spacing, endAngle) {
    const { options: options } = element;
    const inner = options.borderAlign === "inner";
    if (!options.borderWidth) return;
    if (inner) {
        ctx.lineWidth = options.borderWidth * 2;
        ctx.lineJoin = "round";
    } else {
        ctx.lineWidth = options.borderWidth;
        ctx.lineJoin = "bevel";
    }
    if (element.fullCircles) $e37e697455933e61$var$drawFullCircleBorders(ctx, element, inner);
    if (inner) $e37e697455933e61$var$clipArc(ctx, element, endAngle);
    $e37e697455933e61$var$pathArc(ctx, element, offset, spacing, endAngle);
    ctx.stroke();
}
class $e37e697455933e61$export$d48203c759d6a1fc extends $e37e697455933e61$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $kW5V1.ad)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const betweenAngles = circumference >= (0, $kW5V1.T) || (0, $kW5V1.o)(angle, startAngle, endAngle);
        const withinRadius = distance >= innerRadius + rAdjust && distance <= outerRadius + rAdjust;
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const me = this;
        const { options: options, circumference: circumference } = me;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        me.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        me.fullCircles = circumference > (0, $kW5V1.T) ? Math.floor(circumference / (0, $kW5V1.T)) : 0;
        if (circumference === 0 || me.innerRadius < 0 || me.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (me.startAngle + me.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (me.circumference >= (0, $kW5V1.P)) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $e37e697455933e61$var$drawArc(ctx, me, radiusOffset, spacing);
        $e37e697455933e61$var$drawBorder(ctx, me, radiusOffset, spacing, endAngle);
        ctx.restore();
    }
}
$e37e697455933e61$export$d48203c759d6a1fc.id = "arc";
$e37e697455933e61$export$d48203c759d6a1fc.defaults = {
    borderAlign: "center",
    borderColor: "#fff",
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined
};
$e37e697455933e61$export$d48203c759d6a1fc.defaultRoutes = {
    backgroundColor: "backgroundColor"
};
function $e37e697455933e61$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $kW5V1.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $kW5V1.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $kW5V1.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $kW5V1.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $kW5V1.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $kW5V1.v)(style.borderColor, options.borderColor);
}
function $e37e697455933e61$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $e37e697455933e61$var$getLineMethod(options) {
    if (options.stepped) return 0, $kW5V1.al;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $kW5V1.am;
    return $e37e697455933e61$var$lineTo;
}
function $e37e697455933e61$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $e37e697455933e61$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $e37e697455933e61$var$pathVars(points, segment, params);
    const lineMethod = $e37e697455933e61$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $e37e697455933e61$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $e37e697455933e61$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $e37e697455933e61$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $e37e697455933e61$var$fastPathSegment : $e37e697455933e61$var$pathSegment;
}
function $e37e697455933e61$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $kW5V1.ai;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $kW5V1.aj;
    return 0, $kW5V1.ak;
}
function $e37e697455933e61$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $e37e697455933e61$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $e37e697455933e61$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $e37e697455933e61$var$_getSegmentMethod(line);
    for (const segment of segments){
        $e37e697455933e61$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $e37e697455933e61$var$usePath2D = typeof Path2D === "function";
function $e37e697455933e61$var$draw(ctx, line, start, count) {
    if ($e37e697455933e61$var$usePath2D && line.segments.length === 1) $e37e697455933e61$var$strokePathWithCache(ctx, line, start, count);
    else $e37e697455933e61$var$strokePathDirect(ctx, line, start, count);
}
class $e37e697455933e61$export$55e463fa7bcd3469 extends $e37e697455933e61$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const me = this;
        const options = me.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !me._pointsUpdated) {
            const loop = options.spanGaps ? me._loop : me._fullLoop;
            (0, $kW5V1.af)(me._points, options, chartArea, loop, indexAxis);
            me._pointsUpdated = true;
        }
    }
    set points(points) {
        const me = this;
        me._points = points;
        delete me._segments;
        delete me._path;
        me._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $kW5V1.ag)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const me = this;
        const options = me.options;
        const value = point[property];
        const points = me.points;
        const segments = (0, $kW5V1.ah)(me, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $e37e697455933e61$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $e37e697455933e61$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const me = this;
        const segments = me.segments;
        const segmentMethod = $e37e697455933e61$var$_getSegmentMethod(me);
        let loop = me._loop;
        start = start || 0;
        count = count || me.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, me, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const me = this;
        const options = me.options || {};
        const points = me.points || [];
        if (!points.length || !options.borderWidth) return;
        ctx.save();
        $e37e697455933e61$var$draw(ctx, me, start, count);
        ctx.restore();
        if (me.animated) {
            me._pointsUpdated = false;
            me._path = undefined;
        }
    }
}
$e37e697455933e61$export$55e463fa7bcd3469.id = "line";
$e37e697455933e61$export$55e463fa7bcd3469.defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$e37e697455933e61$export$55e463fa7bcd3469.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
$e37e697455933e61$export$55e463fa7bcd3469.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
};
function $e37e697455933e61$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $e37e697455933e61$export$bd159b522b230b7a extends $e37e697455933e61$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $e37e697455933e61$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $e37e697455933e61$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx) {
        const me = this;
        const options = me.options;
        if (me.skip || options.radius < 0.1) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $kW5V1.an)(ctx, options, me.x, me.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
}
$e37e697455933e61$export$bd159b522b230b7a.id = "point";
$e37e697455933e61$export$bd159b522b230b7a.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
};
$e37e697455933e61$export$bd159b522b230b7a.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
function $e37e697455933e61$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $e37e697455933e61$var$parseBorderSkipped(bar) {
    let edge = bar.options.borderSkipped;
    const res = {};
    if (!edge) return res;
    edge = bar.horizontal ? $e37e697455933e61$var$parseEdge(edge, "left", "right", bar.base > bar.x) : $e37e697455933e61$var$parseEdge(edge, "bottom", "top", bar.base < bar.y);
    res[edge] = true;
    return res;
}
function $e37e697455933e61$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $e37e697455933e61$var$swap(edge, a, b);
        edge = $e37e697455933e61$var$startEnd(edge, b, a);
    } else edge = $e37e697455933e61$var$startEnd(edge, a, b);
    return edge;
}
function $e37e697455933e61$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $e37e697455933e61$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $e37e697455933e61$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : Math.max(Math.min(value, max), min);
}
function $e37e697455933e61$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = $e37e697455933e61$var$parseBorderSkipped(bar);
    const o = (0, $kW5V1.ap)(value);
    return {
        t: $e37e697455933e61$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $e37e697455933e61$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $e37e697455933e61$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $e37e697455933e61$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $e37e697455933e61$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $kW5V1.aq)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = $e37e697455933e61$var$parseBorderSkipped(bar);
    const enableBorder = enableBorderRadius || (0, $kW5V1.i)(value);
    return {
        topLeft: $e37e697455933e61$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $e37e697455933e61$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $e37e697455933e61$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $e37e697455933e61$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $e37e697455933e61$var$boundingRects(bar) {
    const bounds = $e37e697455933e61$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $e37e697455933e61$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $e37e697455933e61$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $e37e697455933e61$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $e37e697455933e61$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
}
function $e37e697455933e61$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $e37e697455933e61$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
class $e37e697455933e61$export$a16ed71bf4b07672 extends $e37e697455933e61$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const options = this.options;
        const { inner: inner, outer: outer } = $e37e697455933e61$var$boundingRects(this);
        const addRectPath = $e37e697455933e61$var$hasRadius(outer.radius) ? (0, $kW5V1.ao) : $e37e697455933e61$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, outer);
            ctx.clip();
            addRectPath(ctx, inner);
            ctx.fillStyle = options.borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, inner);
        ctx.fillStyle = options.backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $e37e697455933e61$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $e37e697455933e61$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $e37e697455933e61$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
$e37e697455933e61$export$a16ed71bf4b07672.id = "bar";
$e37e697455933e61$export$a16ed71bf4b07672.defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    enableBorderRadius: true,
    pointStyle: undefined
};
$e37e697455933e61$export$a16ed71bf4b07672.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
var $e37e697455933e61$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $e37e697455933e61$export$d48203c759d6a1fc,
    LineElement: $e37e697455933e61$export$55e463fa7bcd3469,
    PointElement: $e37e697455933e61$export$bd159b522b230b7a,
    BarElement: $e37e697455933e61$export$a16ed71bf4b07672
});
function $e37e697455933e61$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $e37e697455933e61$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $kW5V1.j)(minIndex) && !(0, $kW5V1.j)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $e37e697455933e61$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            value: data
        });
    }
}
function $e37e697455933e61$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $e37e697455933e61$var$cleanDecimatedDataset(dataset);
    });
}
function $e37e697455933e61$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $kW5V1.q)((0, $kW5V1.w)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $kW5V1.q)((0, $kW5V1.w)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $e37e697455933e61$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $e37e697455933e61$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $kW5V1.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (meta.type !== "line") return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $e37e697455933e61$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            if (count <= 4 * availableWidth) {
                $e37e697455933e61$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $kW5V1.j)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $e37e697455933e61$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $e37e697455933e61$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $e37e697455933e61$var$cleanDecimatedData(chart);
    }
};
function $e37e697455933e61$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $e37e697455933e61$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $kW5V1.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $e37e697455933e61$var$decodeFill(line, index, count) {
    const fill = $e37e697455933e61$var$parseFillOption(line);
    if ((0, $kW5V1.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $kW5V1.g)(target) && Math.floor(target) === target) {
        if (fill[0] === "-" || fill[0] === "+") target = index + target;
        if (target === index || target < 0 || target >= count) return false;
        return target;
    }
    return [
        "origin",
        "start",
        "end",
        "stack"
    ].indexOf(fill) >= 0 && fill;
}
function $e37e697455933e61$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    let target = null;
    let horizontal;
    if (fill === "start") target = scale.bottom;
    else if (fill === "end") target = scale.top;
    else if ((0, $kW5V1.i)(fill)) target = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) target = scale.getBasePixel();
    if ((0, $kW5V1.g)(target)) {
        horizontal = scale.isHorizontal();
        return {
            x: horizontal ? target : null,
            y: horizontal ? null : target
        };
    }
    return null;
}
class $e37e697455933e61$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $kW5V1.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $e37e697455933e61$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const target = [];
    const start = options.reverse ? scale.max : scale.min;
    const end = options.reverse ? scale.min : scale.max;
    let i, center, value;
    if (fill === "start") value = start;
    else if (fill === "end") value = end;
    else if ((0, $kW5V1.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    if (options.grid.circular) {
        center = scale.getPointPositionForValue(0, start);
        return new $e37e697455933e61$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $e37e697455933e61$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $e37e697455933e61$var$computeCircularBoundary(source);
    return $e37e697455933e61$var$computeLinearBoundary(source);
}
function $e37e697455933e61$var$findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $e37e697455933e61$var$pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $e37e697455933e61$var$findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $e37e697455933e61$var$buildStackLine(source) {
    const { chart: chart, scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $e37e697455933e61$var$getLinesBelow(chart, index);
    linesBelow.push($e37e697455933e61$var$createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$e37e697455933e61$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $e37e697455933e61$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
const $e37e697455933e61$var$isLineAndNotInHideAnimation = (meta)=>meta.type === "line" && !meta.hidden;
function $e37e697455933e61$var$getLinesBelow(chart, index) {
    const below = [];
    const metas = chart.getSortedVisibleDatasetMetas();
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if ($e37e697455933e61$var$isLineAndNotInHideAnimation(meta)) below.unshift(meta.dataset);
    }
    return below;
}
function $e37e697455933e61$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $e37e697455933e61$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $e37e697455933e61$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if (pointValue >= firstValue && pointValue <= lastValue) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
function $e37e697455933e61$var$getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $kW5V1.g)(fill)) return $e37e697455933e61$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $e37e697455933e61$var$buildStackLine(source);
    const boundary = $e37e697455933e61$var$computeBoundary(source);
    if (boundary instanceof $e37e697455933e61$var$simpleArc) return boundary;
    return $e37e697455933e61$var$createBoundaryLine(boundary, line);
}
function $e37e697455933e61$var$createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $kW5V1.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $e37e697455933e61$var$pointsFromSegments(boundary, line);
    return points.length ? new $e37e697455933e61$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $e37e697455933e61$var$resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $kW5V1.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $e37e697455933e61$var$_clip(ctx, target, clipY) {
    ctx.beginPath();
    target.path(ctx);
    ctx.lineTo(target.last().x, clipY);
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $e37e697455933e61$var$getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $kW5V1.as)(start);
        end = (0, $kW5V1.as)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $e37e697455933e61$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $e37e697455933e61$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $e37e697455933e61$var$findSegmentEnd(start, end, points);
        const bounds = $e37e697455933e61$var$getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $kW5V1.ah)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $e37e697455933e61$var$getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $kW5V1.ar)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $e37e697455933e61$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $e37e697455933e61$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $e37e697455933e61$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $e37e697455933e61$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
function $e37e697455933e61$var$_fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $e37e697455933e61$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $e37e697455933e61$var$clipBounds(ctx, scale, $e37e697455933e61$var$getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        if (lineLoop) ctx.closePath();
        else $e37e697455933e61$var$interpolatedLineTo(ctx, target, end, property);
        const targetLoop = !!target.pathSegment(ctx, tgt, {
            move: lineLoop,
            reverse: true
        });
        const loop = lineLoop && targetLoop;
        if (!loop) $e37e697455933e61$var$interpolatedLineTo(ctx, target, start, property);
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $e37e697455933e61$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $e37e697455933e61$var$_clip(ctx, target, area.top);
        $e37e697455933e61$var$_fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $e37e697455933e61$var$_clip(ctx, target, area.bottom);
    }
    $e37e697455933e61$var$_fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $e37e697455933e61$var$drawfill(ctx, source, area) {
    const target = $e37e697455933e61$var$getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $kW5V1.S)(ctx, area);
        $e37e697455933e61$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $kW5V1.V)(ctx);
    }
}
var $e37e697455933e61$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $e37e697455933e61$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $e37e697455933e61$var$decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $e37e697455933e61$var$resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw) $e37e697455933e61$var$drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (source) $e37e697455933e61$var$drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!source || source.fill === false || options.drawTime !== "beforeDatasetDraw") return;
        $e37e697455933e61$var$drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $e37e697455933e61$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $e37e697455933e61$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $e37e697455933e61$var$Legend extends $e37e697455933e61$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        const me = this;
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me._margins = margins;
        me.setDimensions();
        me.buildLabels();
        me.fit();
    }
    setDimensions() {
        const me = this;
        if (me.isHorizontal()) {
            me.width = me.maxWidth;
            me.left = me._margins.left;
            me.right = me.width;
        } else {
            me.height = me.maxHeight;
            me.top = me._margins.top;
            me.bottom = me.height;
        }
    }
    buildLabels() {
        const me = this;
        const labelOpts = me.options.labels || {};
        let legendItems = (0, $kW5V1.L)(labelOpts.generateLabels, [
            me.chart
        ], me) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, me.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, me.chart.data));
        if (me.options.reverse) legendItems.reverse();
        me.legendItems = legendItems;
    }
    fit() {
        const me = this;
        const { options: options, ctx: ctx } = me;
        if (!options.display) {
            me.width = me.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $kW5V1.W)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = me._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $e37e697455933e61$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (me.isHorizontal()) {
            width = me.maxWidth;
            height = me._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = me.maxHeight;
            width = me._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        me.width = Math.min(width, options.maxWidth || me.maxWidth);
        me.height = Math.min(height, options.maxHeight || me.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const me = this;
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = me;
        const hitboxes = me.legendHitBoxes = [];
        const lineWidths = me.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        me.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const me = this;
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = me;
        const hitboxes = me.legendHitBoxes = [];
        const columnSizes = me.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        me.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        const me = this;
        if (!me.options.display) return;
        const titleHeight = me._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = me;
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $kW5V1.Y)(align, me.left + padding, me.right - me.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $kW5V1.Y)(align, me.left + padding, me.right - me.lineWidths[row]);
                }
                hitbox.top += me.top + titleHeight + padding;
                hitbox.left = left;
                left += hitbox.width + padding;
            }
            if (rtl) {
                const boxMap = hitboxes.reduce((map, box)=>{
                    map[box.row] = map[box.row] || [];
                    map[box.row].push(box);
                    return map;
                }, {});
                const newBoxes = [];
                Object.keys(boxMap).forEach((key)=>{
                    boxMap[key].reverse();
                    newBoxes.push(...boxMap[key]);
                });
                me.legendHitBoxes = newBoxes;
            }
        } else {
            let col = 0;
            let top = (0, $kW5V1.Y)(align, me.top + titleHeight + padding, me.bottom - me.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $kW5V1.Y)(align, me.top + titleHeight + padding, me.bottom - me.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += me.left + padding;
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        const me = this;
        if (me.options.display) {
            const ctx = me.ctx;
            (0, $kW5V1.S)(ctx, me);
            me._draw();
            (0, $kW5V1.V)(ctx);
        }
    }
    _draw() {
        const me = this;
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = me;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $kW5V1.d).color;
        const rtlHelper = (0, $kW5V1.at)(opts.rtl, me.left, me.width);
        const labelFont = (0, $kW5V1.W)(labelOpts.font);
        const { color: fontColor, padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        me.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $e37e697455933e61$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $kW5V1.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $kW5V1.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $kW5V1.v)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $kW5V1.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $kW5V1.v)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $kW5V1.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $kW5V1.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxWidth * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $kW5V1.an)(ctx, drawOptions, centerX, centerY);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $kW5V1.aq)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $kW5V1.ao)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $kW5V1.U)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = me.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $kW5V1.Y)(align, me.left + padding, me.right - lineWidths[0]),
            y: me.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: me.left + padding,
            y: (0, $kW5V1.Y)(align, me.top + titleHeight + padding, me.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $kW5V1.au)(me.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        me.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(me.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > me.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $kW5V1.Y)(align, me.left + padding, me.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > me.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $kW5V1.Y)(align, me.top + titleHeight + padding, me.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $kW5V1.av)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : me.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        (0, $kW5V1.aw)(me.ctx, opts.textDirection);
    }
    drawTitle() {
        const me = this;
        const opts = me.options;
        const titleOpts = opts.title;
        const titleFont = (0, $kW5V1.W)(titleOpts.font);
        const titlePadding = (0, $kW5V1.A)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $kW5V1.at)(opts.rtl, me.left, me.width);
        const ctx = me.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = me.left;
        let maxWidth = me.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...me.lineWidths);
            y = me.top + topPaddingPlusHalfFontSize;
            left = (0, $kW5V1.Y)(opts.align, left, me.right - maxWidth);
        } else {
            const maxHeight = me.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $kW5V1.Y)(opts.align, me.top, me.bottom - maxHeight - opts.labels.padding - me._computeTitleHeight());
        }
        const x = (0, $kW5V1.Y)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $kW5V1.X)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $kW5V1.U)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $kW5V1.W)(titleOpts.font);
        const titlePadding = (0, $kW5V1.A)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        const me = this;
        let i, hitBox, lh;
        if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
            lh = me.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) return me.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const me = this;
        const opts = me.options;
        if (!$e37e697455933e61$var$isListened(e.type, opts)) return;
        const hoveredItem = me._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove") {
            const previous = me._hoveredItem;
            const sameItem = $e37e697455933e61$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $kW5V1.L)(opts.onLeave, [
                e,
                previous,
                me
            ], me);
            me._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $kW5V1.L)(opts.onHover, [
                e,
                hoveredItem,
                me
            ], me);
        } else if (hoveredItem) (0, $kW5V1.L)(opts.onClick, [
            e,
            hoveredItem,
            me
        ], me);
    }
}
function $e37e697455933e61$var$isListened(type, opts) {
    if (type === "mousemove" && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $e37e697455933e61$export$ed247974535929c7 = {
    id: "legend",
    _element: $e37e697455933e61$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $e37e697455933e61$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $e37e697455933e61$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $e37e697455933e61$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $e37e697455933e61$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $e37e697455933e61$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $kW5V1.A)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $e37e697455933e61$var$Title extends $e37e697455933e61$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const me = this;
        const opts = me.options;
        me.left = 0;
        me.top = 0;
        if (!opts.display) {
            me.width = me.height = me.right = me.bottom = 0;
            return;
        }
        me.width = me.right = maxWidth;
        me.height = me.bottom = maxHeight;
        const lineCount = (0, $kW5V1.b)(opts.text) ? opts.text.length : 1;
        me._padding = (0, $kW5V1.A)(opts.padding);
        const textSize = lineCount * (0, $kW5V1.W)(opts.font).lineHeight + me._padding.height;
        if (me.isHorizontal()) me.height = textSize;
        else me.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $kW5V1.Y)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $kW5V1.Y)(align, bottom, top);
                rotation = (0, $kW5V1.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $kW5V1.Y)(align, top, bottom);
                rotation = (0, $kW5V1.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const me = this;
        const ctx = me.ctx;
        const opts = me.options;
        if (!opts.display) return;
        const fontOpts = (0, $kW5V1.W)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + me._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = me._drawArgs(offset);
        (0, $kW5V1.U)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $kW5V1.X)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $e37e697455933e61$var$createTitle(chart, titleOpts) {
    const title = new $e37e697455933e61$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $e37e697455933e61$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $e37e697455933e61$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $e37e697455933e61$export$f99233281efd08a0 = {
    id: "title",
    _element: $e37e697455933e61$var$Title,
    start (chart, _args, options) {
        $e37e697455933e61$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $e37e697455933e61$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $e37e697455933e61$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $e37e697455933e61$var$map = new WeakMap();
var $e37e697455933e61$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $e37e697455933e61$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $e37e697455933e61$export$1ecca0613f5e56d2.configure(chart, title, options);
        $e37e697455933e61$export$1ecca0613f5e56d2.addBox(chart, title);
        $e37e697455933e61$var$map.set(chart, title);
    },
    stop (chart) {
        $e37e697455933e61$export$1ecca0613f5e56d2.removeBox(chart, $e37e697455933e61$var$map.get(chart));
        $e37e697455933e61$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $e37e697455933e61$var$map.get(chart);
        $e37e697455933e61$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $e37e697455933e61$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $kW5V1.ay)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $e37e697455933e61$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $kW5V1.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $e37e697455933e61$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $e37e697455933e61$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $e37e697455933e61$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip._chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $kW5V1.W)(options.bodyFont);
    const titleFont = (0, $kW5V1.W)(options.titleFont);
    const footerFont = (0, $kW5V1.W)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $kW5V1.A)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $kW5V1.B)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $kW5V1.B)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 : 0;
    (0, $kW5V1.B)(body, (bodyItem)=>{
        (0, $kW5V1.B)(bodyItem.before, maxLineWidth);
        (0, $kW5V1.B)(bodyItem.lines, maxLineWidth);
        (0, $kW5V1.B)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $kW5V1.B)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $e37e697455933e61$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $e37e697455933e61$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $e37e697455933e61$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($e37e697455933e61$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $e37e697455933e61$var$determineAlignment(chart, options, size) {
    const yAlign = options.yAlign || $e37e697455933e61$var$determineYAlign(chart, size);
    return {
        xAlign: options.xAlign || $e37e697455933e61$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $e37e697455933e61$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $e37e697455933e61$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $e37e697455933e61$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const radiusAndPadding = cornerRadius + caretPadding;
    let x = $e37e697455933e61$var$alignX(size, xAlign);
    const y = $e37e697455933e61$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= radiusAndPadding;
    else if (xAlign === "right") x += radiusAndPadding;
    return {
        x: (0, $kW5V1.q)(x, 0, chart.width - size.width),
        y: (0, $kW5V1.q)(y, 0, chart.height - size.height)
    };
}
function $e37e697455933e61$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $kW5V1.A)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $e37e697455933e61$var$getBeforeAfterBodyLines(callback) {
    return $e37e697455933e61$var$pushOrConcat([], $e37e697455933e61$var$splitNewlines(callback));
}
function $e37e697455933e61$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return Object.assign(Object.create(parent), {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $e37e697455933e61$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $e37e697455933e61$var$Tooltip extends $e37e697455933e61$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._chart = config._chart;
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const me = this;
        const cached = me._cachedAnimations;
        if (cached) return cached;
        const chart = me._chart;
        const options = me.options.setContext(me.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $e37e697455933e61$export$8ab227dac26677d(me._chart, opts);
        if (opts._cacheable) me._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        const me = this;
        return me.$context || (me.$context = $e37e697455933e61$var$createTooltipContext(me._chart.getContext(), me, me._tooltipItems));
    }
    getTitle(context, options) {
        const me = this;
        const { callbacks: callbacks } = options;
        const beforeTitle = callbacks.beforeTitle.apply(me, [
            context
        ]);
        const title = callbacks.title.apply(me, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(me, [
            context
        ]);
        let lines = [];
        lines = $e37e697455933e61$var$pushOrConcat(lines, $e37e697455933e61$var$splitNewlines(beforeTitle));
        lines = $e37e697455933e61$var$pushOrConcat(lines, $e37e697455933e61$var$splitNewlines(title));
        lines = $e37e697455933e61$var$pushOrConcat(lines, $e37e697455933e61$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $e37e697455933e61$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const me = this;
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $kW5V1.B)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $e37e697455933e61$var$overrideCallbacks(callbacks, context);
            $e37e697455933e61$var$pushOrConcat(bodyItem.before, $e37e697455933e61$var$splitNewlines(scoped.beforeLabel.call(me, context)));
            $e37e697455933e61$var$pushOrConcat(bodyItem.lines, scoped.label.call(me, context));
            $e37e697455933e61$var$pushOrConcat(bodyItem.after, $e37e697455933e61$var$splitNewlines(scoped.afterLabel.call(me, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $e37e697455933e61$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const me = this;
        const { callbacks: callbacks } = options;
        const beforeFooter = callbacks.beforeFooter.apply(me, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(me, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(me, [
            tooltipItems
        ]);
        let lines = [];
        lines = $e37e697455933e61$var$pushOrConcat(lines, $e37e697455933e61$var$splitNewlines(beforeFooter));
        lines = $e37e697455933e61$var$pushOrConcat(lines, $e37e697455933e61$var$splitNewlines(footer));
        lines = $e37e697455933e61$var$pushOrConcat(lines, $e37e697455933e61$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const me = this;
        const active = me._active;
        const data = me._chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($e37e697455933e61$var$createTooltipItem(me._chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $kW5V1.B)(tooltipItems, (context)=>{
            const scoped = $e37e697455933e61$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(me, context));
            labelPointStyles.push(scoped.labelPointStyle.call(me, context));
            labelTextColors.push(scoped.labelTextColor.call(me, context));
        });
        me.labelColors = labelColors;
        me.labelPointStyles = labelPointStyles;
        me.labelTextColors = labelTextColors;
        me.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const me = this;
        const options = me.options.setContext(me.getContext());
        const active = me._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (me.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $e37e697455933e61$var$positioners[options.position].call(me, active, me._eventPosition);
            tooltipItems = me._createItems(options);
            me.title = me.getTitle(tooltipItems, options);
            me.beforeBody = me.getBeforeBody(tooltipItems, options);
            me.body = me.getBody(tooltipItems, options);
            me.afterBody = me.getAfterBody(tooltipItems, options);
            me.footer = me.getFooter(tooltipItems, options);
            const size = me._size = $e37e697455933e61$var$getTooltipSize(me, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $e37e697455933e61$var$determineAlignment(me._chart, options, positionAndSize);
            const backgroundPoint = $e37e697455933e61$var$getBackgroundPoint(options, positionAndSize, alignment, me._chart);
            me.xAlign = alignment.xAlign;
            me.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        me._tooltipItems = tooltipItems;
        me.$context = undefined;
        if (properties) me._resolveAnimations().update(me, properties);
        if (changed && options.external) options.external.call(me, {
            chart: me._chart,
            tooltip: me,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { cornerRadius: cornerRadius, caretSize: caretSize } = options;
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + cornerRadius + caretSize;
            else if (xAlign === "right") x2 = ptX + width - cornerRadius - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const me = this;
        const title = me.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $kW5V1.at)(options.rtl, me.x, me.width);
            pt.x = $e37e697455933e61$var$getAlignedX(me, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $kW5V1.W)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const me = this;
        const labelColors = me.labelColors[i];
        const labelPointStyle = me.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $kW5V1.W)(options.bodyFont);
        const colorX = $e37e697455933e61$var$getAlignedX(me, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $kW5V1.an)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            (0, $kW5V1.an)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $kW5V1.aq)(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $kW5V1.ao)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                (0, $kW5V1.ao)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = me.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const me = this;
        const { body: body } = me;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $kW5V1.W)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $kW5V1.at)(options.rtl, me.x, me.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $e37e697455933e61$var$getAlignedX(me, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $kW5V1.B)(me.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + 1 : boxWidth + 2 : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = me.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $kW5V1.B)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                me._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $kW5V1.B)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $kW5V1.B)(me.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const me = this;
        const footer = me.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $kW5V1.at)(options.rtl, me.x, me.width);
            pt.x = $e37e697455933e61$var$getAlignedX(me, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $kW5V1.W)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const radius = options.cornerRadius;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const me = this;
        const chart = me._chart;
        const anims = me.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $e37e697455933e61$var$positioners[options.position].call(me, me._active, me._eventPosition);
            if (!position) return;
            const size = me._size = $e37e697455933e61$var$getTooltipSize(me, options);
            const positionAndSize = Object.assign({}, position, me._size);
            const alignment = $e37e697455933e61$var$determineAlignment(chart, options, positionAndSize);
            const point = $e37e697455933e61$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                me.xAlign = alignment.xAlign;
                me.yAlign = alignment.yAlign;
                me.width = size.width;
                me.height = size.height;
                me.caretX = position.x;
                me.caretY = position.y;
                me._resolveAnimations().update(me, point);
            }
        }
    }
    draw(ctx) {
        const me = this;
        const options = me.options.setContext(me.getContext());
        let opacity = me.opacity;
        if (!opacity) return;
        me._updateAnimationTarget(options);
        const tooltipSize = {
            width: me.width,
            height: me.height
        };
        const pt = {
            x: me.x,
            y: me.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $kW5V1.A)(options.padding);
        const hasTooltipContent = me.title.length || me.beforeBody.length || me.body.length || me.afterBody.length || me.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            me.drawBackground(pt, ctx, tooltipSize, options);
            (0, $kW5V1.au)(ctx, options.textDirection);
            pt.y += padding.top;
            me.drawTitle(pt, ctx, options);
            me.drawBody(pt, ctx, options);
            me.drawFooter(pt, ctx, options);
            (0, $kW5V1.aw)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const me = this;
        const lastActive = me._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = me._chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $kW5V1.ac)(lastActive, active);
        const positionChanged = me._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            me._active = active;
            me._eventPosition = eventPosition;
            me.update(true);
        }
    }
    handleEvent(e, replay) {
        const me = this;
        const options = me.options;
        const lastActive = me._active || [];
        let changed = false;
        let active = [];
        if (e.type !== "mouseout") {
            active = me._chart.getElementsAtEventForMode(e, options.mode, options, replay);
            if (options.reverse) active.reverse();
        }
        const positionChanged = me._positionChanged(active, e);
        changed = replay || !(0, $kW5V1.ac)(active, lastActive) || positionChanged;
        if (changed) {
            me._active = active;
            if (options.enabled || options.external) {
                me._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                me.update(true, replay);
            }
        }
        return changed;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $e37e697455933e61$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
$e37e697455933e61$var$Tooltip.positioners = $e37e697455933e61$var$positioners;
var $e37e697455933e61$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $e37e697455933e61$var$Tooltip,
    positioners: $e37e697455933e61$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $e37e697455933e61$var$Tooltip({
            _chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        const args = {
            tooltip: tooltip
        };
        if (chart.notifyPlugins("beforeTooltipDraw", args) === false) return;
        if (tooltip) tooltip.draw(chart.ctx);
        chart.notifyPlugins("afterTooltipDraw", args);
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: (0, $kW5V1.ax),
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return "";
            },
            afterTitle: (0, $kW5V1.ax),
            beforeBody: (0, $kW5V1.ax),
            beforeLabel: (0, $kW5V1.ax),
            label (tooltipItem) {
                if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || "";
                if (label) label += ": ";
                const value = tooltipItem.formattedValue;
                if (!(0, $kW5V1.j)(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: (0, $kW5V1.ax),
            afterBody: (0, $kW5V1.ax),
            beforeFooter: (0, $kW5V1.ax),
            footer: (0, $kW5V1.ax),
            afterFooter: (0, $kW5V1.ax)
        }
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $e37e697455933e61$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Decimation: $e37e697455933e61$export$be17f937e9aa7533,
    Filler: $e37e697455933e61$export$d19ba4d812bed757,
    Legend: $e37e697455933e61$export$ed247974535929c7,
    SubTitle: $e37e697455933e61$export$d5c56664638992a4,
    Title: $e37e697455933e61$export$f99233281efd08a0,
    Tooltip: $e37e697455933e61$export$28c660c63b792dea
});
const $e37e697455933e61$var$addIfString = (labels, raw, index)=>typeof raw === "string" ? labels.push(raw) - 1 : isNaN(raw) ? null : index;
function $e37e697455933e61$var$findOrAddLabel(labels, raw, index) {
    const first = labels.indexOf(raw);
    if (first === -1) return $e37e697455933e61$var$addIfString(labels, raw, index);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $e37e697455933e61$var$validIndex = (index, max)=>index === null ? null : (0, $kW5V1.q)(Math.round(index), 0, max);
class $e37e697455933e61$export$29e663ba4d09fe7 extends $e37e697455933e61$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $kW5V1.j)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $e37e697455933e61$var$findOrAddLabel(labels, raw, (0, $kW5V1.v)(index, raw));
        return $e37e697455933e61$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const me = this;
        const { minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        let { min: min, max: max } = me.getMinMax(true);
        if (me.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = me.getLabels().length - 1;
        }
        me.min = min;
        me.max = max;
    }
    buildTicks() {
        const me = this;
        const min = me.min;
        const max = me.max;
        const offset = me.options.offset;
        const ticks = [];
        let labels = me.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        me._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        me._startValue = me.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const me = this;
        const labels = me.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        const me = this;
        super.configure();
        if (!me.isHorizontal()) me._reversePixels = !me._reversePixels;
    }
    getPixelForValue(value) {
        const me = this;
        if (typeof value !== "number") value = me.parse(value);
        return value === null ? NaN : me.getPixelForDecimal((value - me._startValue) / me._valueRange);
    }
    getPixelForTick(index) {
        const me = this;
        const ticks = me.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return me.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        const me = this;
        return Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
$e37e697455933e61$export$29e663ba4d09fe7.id = "category";
$e37e697455933e61$export$29e663ba4d09fe7.defaults = {
    ticks: {
        callback: $e37e697455933e61$export$29e663ba4d09fe7.prototype.getLabelForValue
    }
};
function $e37e697455933e61$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $kW5V1.j)(min);
    const maxDefined = !(0, $kW5V1.j)(max);
    const countDefined = !(0, $kW5V1.j)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $kW5V1.aA)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $kW5V1.aA)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $kW5V1.j)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $kW5V1.aB)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $kW5V1.aC)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $kW5V1.aD)(spacing), (0, $kW5V1.aD)(niceMin));
    factor = Math.pow(10, (0, $kW5V1.j)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $kW5V1.aC)(Math.round((niceMin + j * spacing) * factor) / factor, min, $e37e697455933e61$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if ((0, $kW5V1.aC)(ticks[ticks.length - 1].value, max, $e37e697455933e61$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $e37e697455933e61$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $kW5V1.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $e37e697455933e61$var$LinearScaleBase extends $e37e697455933e61$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $kW5V1.j)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const me = this;
        const { beginAtZero: beginAtZero } = me.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        let { min: min, max: max } = me;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $kW5V1.s)(min);
            const maxSign = (0, $kW5V1.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            setMax(max + 1);
            if (!beginAtZero) setMin(min - 1);
        }
        me.min = min;
        me.max = max;
    }
    getTickLimit() {
        const me = this;
        const tickOpts = me.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
        else {
            maxTicks = me.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const me = this;
        const opts = me.options;
        const tickOpts = opts.ticks;
        let maxTicks = me.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: me._maxDigits(),
            horizontal: me.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = me._range || me;
        const ticks = $e37e697455933e61$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $kW5V1.az)(ticks, me, "value");
        if (opts.reverse) {
            ticks.reverse();
            me.start = me.max;
            me.end = me.min;
        } else {
            me.start = me.min;
            me.end = me.max;
        }
        return ticks;
    }
    configure() {
        const me = this;
        const ticks = me.ticks;
        let start = me.min;
        let end = me.max;
        super.configure();
        if (me.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        me._startValue = start;
        me._endValue = end;
        me._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $kW5V1.n)(value, this.chart.options.locale);
    }
}
class $e37e697455933e61$export$e7f4e5e8656f0b93 extends $e37e697455933e61$var$LinearScaleBase {
    determineDataLimits() {
        const me = this;
        const { min: min, max: max } = me.getMinMax(true);
        me.min = (0, $kW5V1.g)(min) ? min : 0;
        me.max = (0, $kW5V1.g)(max) ? max : 1;
        me.handleTickRangeOptions();
    }
    computeTickLimit() {
        const me = this;
        const horizontal = me.isHorizontal();
        const length = horizontal ? me.width : me.height;
        const minRotation = (0, $kW5V1.t)(me.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = me._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$e37e697455933e61$export$e7f4e5e8656f0b93.id = "linear";
$e37e697455933e61$export$e7f4e5e8656f0b93.defaults = {
    ticks: {
        callback: $e37e697455933e61$export$27c7467594ef87bd.formatters.numeric
    }
};
function $e37e697455933e61$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor((0, $kW5V1.I)(tickVal)));
    return remain === 1;
}
function $e37e697455933e61$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor((0, $kW5V1.I)(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = (0, $kW5V1.K)(generationOptions.min, Math.pow(10, Math.floor((0, $kW5V1.I)(dataRange.min))));
    let exp = Math.floor((0, $kW5V1.I)(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $e37e697455933e61$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = (0, $kW5V1.K)(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $e37e697455933e61$var$isMajor(tickVal)
    });
    return ticks;
}
class $e37e697455933e61$export$85295eaf7cb3ac3e extends $e37e697455933e61$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $e37e697455933e61$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $kW5V1.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const me = this;
        const { min: min, max: max } = me.getMinMax(true);
        me.min = (0, $kW5V1.g)(min) ? Math.max(0, min) : null;
        me.max = (0, $kW5V1.g)(max) ? Math.max(0, max) : null;
        if (me.options.beginAtZero) me._zero = true;
        me.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const me = this;
        const { minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        let min = me.min;
        let max = me.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor((0, $kW5V1.I)(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (me._zero && me.min !== me._suggestedMin && min === exp(me.min, 0)) setMin(exp(min, -1));
        me.min = min;
        me.max = max;
    }
    buildTicks() {
        const me = this;
        const opts = me.options;
        const generationOptions = {
            min: me._userMin,
            max: me._userMax
        };
        const ticks = $e37e697455933e61$var$generateTicks(generationOptions, me);
        if (opts.bounds === "ticks") (0, $kW5V1.az)(ticks, me, "value");
        if (opts.reverse) {
            ticks.reverse();
            me.start = me.max;
            me.end = me.min;
        } else {
            me.start = me.min;
            me.end = me.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $kW5V1.n)(value, this.chart.options.locale);
    }
    configure() {
        const me = this;
        const start = me.min;
        super.configure();
        me._startValue = (0, $kW5V1.I)(start);
        me._valueRange = (0, $kW5V1.I)(me.max) - (0, $kW5V1.I)(start);
    }
    getPixelForValue(value) {
        const me = this;
        if (value === undefined || value === 0) value = me.min;
        if (value === null || isNaN(value)) return NaN;
        return me.getPixelForDecimal(value === me.min ? 0 : ((0, $kW5V1.I)(value) - me._startValue) / me._valueRange);
    }
    getValueForPixel(pixel) {
        const me = this;
        const decimal = me.getDecimalForPixel(pixel);
        return Math.pow(10, me._startValue + decimal * me._valueRange);
    }
}
$e37e697455933e61$export$85295eaf7cb3ac3e.id = "logarithmic";
$e37e697455933e61$export$85295eaf7cb3ac3e.defaults = {
    ticks: {
        callback: $e37e697455933e61$export$27c7467594ef87bd.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $e37e697455933e61$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $kW5V1.A)(tickOpts.backdropPadding);
        return (0, $kW5V1.v)(tickOpts.font && tickOpts.font.size, (0, $kW5V1.d).font.size) + padding.height;
    }
    return 0;
}
function $e37e697455933e61$var$measureLabelSize(ctx, font, label) {
    label = (0, $kW5V1.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $kW5V1.aE)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $e37e697455933e61$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $e37e697455933e61$var$fitWithPointLabels(scale) {
    const furthestLimits = {
        l: 0,
        r: scale.width,
        t: 0,
        b: scale.height - scale.paddingTop
    };
    const furthestAngles = {};
    const labelSizes = [];
    const padding = [];
    const valueCount = scale.getLabels().length;
    for(let i = 0; i < valueCount; i++){
        const opts = scale.options.pointLabels.setContext(scale.getContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i]);
        const plFont = (0, $kW5V1.W)(opts.font);
        const textSize = $e37e697455933e61$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = scale.getIndexAngle(i);
        const angle = (0, $kW5V1.N)(angleRadians);
        const hLimits = $e37e697455933e61$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $e37e697455933e61$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        if (hLimits.start < furthestLimits.l) {
            furthestLimits.l = hLimits.start;
            furthestAngles.l = angleRadians;
        }
        if (hLimits.end > furthestLimits.r) {
            furthestLimits.r = hLimits.end;
            furthestAngles.r = angleRadians;
        }
        if (vLimits.start < furthestLimits.t) {
            furthestLimits.t = vLimits.start;
            furthestAngles.t = angleRadians;
        }
        if (vLimits.end > furthestLimits.b) {
            furthestLimits.b = vLimits.end;
            furthestAngles.b = angleRadians;
        }
    }
    scale._setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    scale._pointLabelItems = $e37e697455933e61$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $e37e697455933e61$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale.getLabels().length;
    const opts = scale.options;
    const tickBackdropHeight = $e37e697455933e61$var$getTickBackdropHeight(opts);
    const outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
    for(let i = 0; i < valueCount; i++){
        const extra = i === 0 ? tickBackdropHeight / 2 : 0;
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i]);
        const angle = (0, $kW5V1.N)(scale.getIndexAngle(i));
        const size = labelSizes[i];
        const y = $e37e697455933e61$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $e37e697455933e61$var$getTextAlignForAngle(angle);
        const left = $e37e697455933e61$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $e37e697455933e61$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $e37e697455933e61$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $e37e697455933e61$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $e37e697455933e61$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getContext(i));
        const plFont = (0, $kW5V1.W)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!(0, $kW5V1.j)(backdropColor)) {
            const padding = (0, $kW5V1.A)(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            ctx.fillRect(left - padding.left, top - padding.top, right - left + padding.width, bottom - top + padding.height);
        }
        (0, $kW5V1.U)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $e37e697455933e61$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $kW5V1.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $e37e697455933e61$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $e37e697455933e61$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $e37e697455933e61$var$numberOrZero(param) {
    return (0, $kW5V1.p)(param) ? param : 0;
}
class $e37e697455933e61$export$cfafc36d95386d38 extends $e37e697455933e61$var$LinearScaleBase {
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const me = this;
        me.width = me.maxWidth;
        me.height = me.maxHeight;
        me.paddingTop = $e37e697455933e61$var$getTickBackdropHeight(me.options) / 2;
        me.xCenter = Math.floor(me.width / 2);
        me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
        me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
    }
    determineDataLimits() {
        const me = this;
        const { min: min, max: max } = me.getMinMax(false);
        me.min = (0, $kW5V1.g)(min) && !isNaN(min) ? min : 0;
        me.max = (0, $kW5V1.g)(max) && !isNaN(max) ? max : 0;
        me.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $e37e697455933e61$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        const me = this;
        $e37e697455933e61$var$LinearScaleBase.prototype.generateTickLabels.call(me, ticks);
        me._pointLabels = me.getLabels().map((value, index)=>{
            const label = (0, $kW5V1.L)(me.options.pointLabels.callback, [
                value,
                index
            ], me);
            return label || label === 0 ? label : "";
        });
    }
    fit() {
        const me = this;
        const opts = me.options;
        if (opts.display && opts.pointLabels.display) $e37e697455933e61$var$fitWithPointLabels(me);
        else me.setCenterPoint(0, 0, 0, 0);
    }
    _setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
        const me = this;
        let radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
        let radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
        let radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
        let radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
        radiusReductionLeft = $e37e697455933e61$var$numberOrZero(radiusReductionLeft);
        radiusReductionRight = $e37e697455933e61$var$numberOrZero(radiusReductionRight);
        radiusReductionTop = $e37e697455933e61$var$numberOrZero(radiusReductionTop);
        radiusReductionBottom = $e37e697455933e61$var$numberOrZero(radiusReductionBottom);
        me.drawingArea = Math.max(largestPossibleRadius / 2, Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2)));
        me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        const me = this;
        const maxRight = me.width - rightMovement - me.drawingArea;
        const maxLeft = leftMovement + me.drawingArea;
        const maxTop = topMovement + me.drawingArea;
        const maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
        me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
        me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $kW5V1.T) / this.getLabels().length;
        const startAngle = this.options.startAngle || 0;
        return (0, $kW5V1.as)(index * angleMultiplier + (0, $kW5V1.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        const me = this;
        if ((0, $kW5V1.j)(value)) return NaN;
        const scalingFactor = me.drawingArea / (me.max - me.min);
        if (me.options.reverse) return (me.max - value) * scalingFactor;
        return (value - me.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $kW5V1.j)(distance)) return NaN;
        const me = this;
        const scaledDistance = distance / (me.drawingArea / (me.max - me.min));
        return me.options.reverse ? me.max - scaledDistance : me.min + scaledDistance;
    }
    getPointPosition(index, distanceFromCenter) {
        const me = this;
        const angle = me.getIndexAngle(index) - (0, $kW5V1.H);
        return {
            x: Math.cos(angle) * distanceFromCenter + me.xCenter,
            y: Math.sin(angle) * distanceFromCenter + me.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const me = this;
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = me.options;
        if (backgroundColor) {
            const ctx = me.ctx;
            ctx.save();
            ctx.beginPath();
            $e37e697455933e61$var$pathRadiusLine(me, me.getDistanceFromCenterForValue(me._endValue), circular, me.getLabels().length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const me = this;
        const ctx = me.ctx;
        const opts = me.options;
        const { angleLines: angleLines, grid: grid } = opts;
        const labelCount = me.getLabels().length;
        let i, offset, position;
        if (opts.pointLabels.display) $e37e697455933e61$var$drawPointLabels(me, labelCount);
        if (grid.display) me.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = me.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(me.getContext(index - 1));
                $e37e697455933e61$var$drawRadiusLine(me, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = me.getLabels().length - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(me.getContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                position = me.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(me.xCenter, me.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const me = this;
        const ctx = me.ctx;
        const opts = me.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = me.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(me.xCenter, me.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        me.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(me.getContext(index));
            const tickFont = (0, $kW5V1.W)(optsAtIndex.font);
            offset = me.getDistanceFromCenterForValue(me.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $kW5V1.A)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $kW5V1.U)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
$e37e697455933e61$export$cfafc36d95386d38.id = "radialLinear";
$e37e697455933e61$export$cfafc36d95386d38.defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $e37e697455933e61$export$27c7467594ef87bd.formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5
    }
};
$e37e697455933e61$export$cfafc36d95386d38.defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
};
$e37e697455933e61$export$cfafc36d95386d38.descriptors = {
    angleLines: {
        _fallback: "grid"
    }
};
const $e37e697455933e61$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $e37e697455933e61$var$UNITS = Object.keys($e37e697455933e61$var$INTERVALS);
function $e37e697455933e61$var$sorter(a, b) {
    return a - b;
}
function $e37e697455933e61$var$parse(scale, input) {
    if ((0, $kW5V1.j)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $kW5V1.g)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $kW5V1.p)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $e37e697455933e61$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $e37e697455933e61$var$UNITS.length;
    for(let i = $e37e697455933e61$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $e37e697455933e61$var$INTERVALS[$e37e697455933e61$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $e37e697455933e61$var$UNITS[i];
    }
    return $e37e697455933e61$var$UNITS[ilen - 1];
}
function $e37e697455933e61$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $e37e697455933e61$var$UNITS.length - 1; i >= $e37e697455933e61$var$UNITS.indexOf(minUnit); i--){
        const unit = $e37e697455933e61$var$UNITS[i];
        if ($e37e697455933e61$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $e37e697455933e61$var$UNITS[minUnit ? $e37e697455933e61$var$UNITS.indexOf(minUnit) : 0];
}
function $e37e697455933e61$var$determineMajorUnit(unit) {
    for(let i = $e37e697455933e61$var$UNITS.indexOf(unit) + 1, ilen = $e37e697455933e61$var$UNITS.length; i < ilen; ++i){
        if ($e37e697455933e61$var$INTERVALS[$e37e697455933e61$var$UNITS[i]].common) return $e37e697455933e61$var$UNITS[i];
    }
}
function $e37e697455933e61$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $kW5V1.aG)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $e37e697455933e61$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $e37e697455933e61$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $e37e697455933e61$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $e37e697455933e61$export$a894c72689ff3ec extends $e37e697455933e61$export$d60cfc58d3c358b6 {
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $e37e697455933e61$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        (0, $kW5V1.a6)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $e37e697455933e61$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const me = this;
        const options = me.options;
        const adapter = me._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = me.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(me._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(me.getMinMax(false));
        }
        min = (0, $kW5V1.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $kW5V1.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        me.min = Math.min(min, max - 1);
        me.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const me = this;
        const options = me.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? me.getLabelTimestamps() : me._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            me.min = me._userMin || timestamps[0];
            me.max = me._userMax || timestamps[timestamps.length - 1];
        }
        const min = me.min;
        const max = me.max;
        const ticks = (0, $kW5V1.aF)(timestamps, min, max);
        me._unit = timeOpts.unit || (tickOpts.autoSkip ? $e37e697455933e61$var$determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, me._getLabelCapacity(min)) : $e37e697455933e61$var$determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
        me._majorUnit = !tickOpts.major.enabled || me._unit === "year" ? undefined : $e37e697455933e61$var$determineMajorUnit(me._unit);
        me.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $e37e697455933e61$var$ticksFromTimestamps(me, ticks, me._majorUnit);
    }
    initOffsets(timestamps) {
        const me = this;
        let start = 0;
        let end = 0;
        let first, last;
        if (me.options.offset && timestamps.length) {
            first = me.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (me.getDecimalForValue(timestamps[1]) - first) / 2;
            last = me.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - me.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $kW5V1.q)(start, 0, limit);
        end = (0, $kW5V1.q)(end, 0, limit);
        me._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const me = this;
        const adapter = me._adapter;
        const min = me.min;
        const max = me.max;
        const options = me.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $e37e697455933e61$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, me._getLabelCapacity(min));
        const stepSize = (0, $kW5V1.v)(timeOpts.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $kW5V1.p)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && me.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$e37e697455933e61$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $e37e697455933e61$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const me = this;
        const adapter = me._adapter;
        const timeOpts = me.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const me = this;
        const options = me.options;
        const formats = options.time.displayFormats;
        const unit = me._unit;
        const majorUnit = me._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = me._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? (0, $kW5V1.L)(formatter, [
            label,
            index,
            ticks
        ], me) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        const me = this;
        return value === null ? NaN : (value - me.min) / (me.max - me.min);
    }
    getPixelForValue(value) {
        const me = this;
        const offsets = me._offsets;
        const pos = me.getDecimalForValue(value);
        return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const me = this;
        const offsets = me._offsets;
        const pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return me.min + pos * (me.max - me.min);
    }
    _getLabelSize(label) {
        const me = this;
        const ticksOpts = me.options.ticks;
        const tickLabelWidth = me.ctx.measureText(label).width;
        const angle = (0, $kW5V1.t)(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = me._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const me = this;
        const timeOpts = me.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = me._tickFormatFunction(exampleTime, 0, $e37e697455933e61$var$ticksFromTimestamps(me, [
            exampleTime
        ], me._majorUnit), format);
        const size = me._getLabelSize(exampleLabel);
        const capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        const me = this;
        let timestamps = me._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = me.getMatchingVisibleMetas();
        if (me._normalized && metas.length) return me._cache.data = metas[0].controller.getAllParsedValues(me);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(me));
        return me._cache.data = me.normalize(timestamps);
    }
    getLabelTimestamps() {
        const me = this;
        const timestamps = me._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = me.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($e37e697455933e61$var$parse(me, labels[i]));
        return me._cache.labels = me._normalized ? timestamps : me.normalize(timestamps);
    }
    normalize(values) {
        return (0, $kW5V1._)(values.sort($e37e697455933e61$var$sorter));
    }
}
$e37e697455933e61$export$a894c72689ff3ec.id = "time";
$e37e697455933e61$export$a894c72689ff3ec.defaults = {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        major: {
            enabled: false
        }
    }
};
function $e37e697455933e61$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $kW5V1.w)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $kW5V1.w)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $e37e697455933e61$export$85df64a8eb6dc986 extends $e37e697455933e61$export$a894c72689ff3ec {
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const me = this;
        const timestamps = me._getTimestampsForTable();
        const table = me._table = me.buildLookupTable(timestamps);
        me._minPos = $e37e697455933e61$var$interpolate(table, me.min);
        me._tableRange = $e37e697455933e61$var$interpolate(table, me.max) - me._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        const me = this;
        let timestamps = me._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = me.getDataTimestamps();
        const label = me.getLabelTimestamps();
        if (data.length && label.length) timestamps = me.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = me._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($e37e697455933e61$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const me = this;
        const offsets = me._offsets;
        const decimal = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $e37e697455933e61$var$interpolate(me._table, decimal * me._tableRange + me._minPos, true);
    }
}
$e37e697455933e61$export$85df64a8eb6dc986.id = "timeseries";
$e37e697455933e61$export$85df64a8eb6dc986.defaults = $e37e697455933e61$export$a894c72689ff3ec.defaults;
var $e37e697455933e61$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $e37e697455933e61$export$29e663ba4d09fe7,
    LinearScale: $e37e697455933e61$export$e7f4e5e8656f0b93,
    LogarithmicScale: $e37e697455933e61$export$85295eaf7cb3ac3e,
    RadialLinearScale: $e37e697455933e61$export$cfafc36d95386d38,
    TimeScale: $e37e697455933e61$export$a894c72689ff3ec,
    TimeSeriesScale: $e37e697455933e61$export$85df64a8eb6dc986
});
const $e37e697455933e61$export$e8959e79e3af550f = [
    $e37e697455933e61$export$a6506504f799c5d5,
    $e37e697455933e61$export$7a5d735b2ab6389d,
    $e37e697455933e61$export$8b3ca321c77fdea6,
    $e37e697455933e61$export$bcac1c16f1530ec2
];

});
parcelRegister("kW5V1", function(module, exports) {

$parcel$export(module.exports, "r", function () { return $f3ddd0be20e1c820$export$43caf9889c228507; });
$parcel$export(module.exports, "F", function () { return $f3ddd0be20e1c820$export$d66501df72047452; });
$parcel$export(module.exports, "a8", function () { return $f3ddd0be20e1c820$export$c3950d9923825c02; });
$parcel$export(module.exports, "X", function () { return $f3ddd0be20e1c820$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "Y", function () { return $f3ddd0be20e1c820$export$8743009a87fcb00f; });
$parcel$export(module.exports, "av", function () { return $f3ddd0be20e1c820$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "ax", function () { return $f3ddd0be20e1c820$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "a7", function () { return $f3ddd0be20e1c820$export$a93c5207d687da10; });
$parcel$export(module.exports, "j", function () { return $f3ddd0be20e1c820$export$35e795649ee09318; });
$parcel$export(module.exports, "b", function () { return $f3ddd0be20e1c820$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "i", function () { return $f3ddd0be20e1c820$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "g", function () { return $f3ddd0be20e1c820$export$39b482c5e57630a8; });
$parcel$export(module.exports, "K", function () { return $f3ddd0be20e1c820$export$3466f893ebf79586; });
$parcel$export(module.exports, "v", function () { return $f3ddd0be20e1c820$export$90a7f3efeed30595; });
$parcel$export(module.exports, "k", function () { return $f3ddd0be20e1c820$export$342063e11d6c3cad; });
$parcel$export(module.exports, "m", function () { return $f3ddd0be20e1c820$export$953cecd6e717a553; });
$parcel$export(module.exports, "L", function () { return $f3ddd0be20e1c820$export$61196ced6d74a310; });
$parcel$export(module.exports, "B", function () { return $f3ddd0be20e1c820$export$ef35774e6d314e91; });
$parcel$export(module.exports, "ac", function () { return $f3ddd0be20e1c820$export$2219238a014317b0; });
$parcel$export(module.exports, "$", function () { return $f3ddd0be20e1c820$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "a6", function () { return $f3ddd0be20e1c820$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "f", function () { return $f3ddd0be20e1c820$export$2d1720544b23b823; });
$parcel$export(module.exports, "a0", function () { return $f3ddd0be20e1c820$export$34aec0b863436764; });
$parcel$export(module.exports, "h", function () { return $f3ddd0be20e1c820$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a2", function () { return $f3ddd0be20e1c820$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "ab", function () { return $f3ddd0be20e1c820$export$555508cbc6add439; });
$parcel$export(module.exports, "P", function () { return $f3ddd0be20e1c820$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "T", function () { return $f3ddd0be20e1c820$export$971d5caa766a69d7; });
$parcel$export(module.exports, "H", function () { return $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "I", function () { return $f3ddd0be20e1c820$export$9bb611d729802a56; });
$parcel$export(module.exports, "s", function () { return $f3ddd0be20e1c820$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "aA", function () { return $f3ddd0be20e1c820$export$91c6e00c14e7e6fd; });
$parcel$export(module.exports, "aC", function () { return $f3ddd0be20e1c820$export$890c4ad488842ce7; });
$parcel$export(module.exports, "J", function () { return $f3ddd0be20e1c820$export$b4171a6734a65d42; });
$parcel$export(module.exports, "p", function () { return $f3ddd0be20e1c820$export$ffb5f4729a158638; });
$parcel$export(module.exports, "aB", function () { return $f3ddd0be20e1c820$export$9d398bebfec1c039; });
$parcel$export(module.exports, "az", function () { return $f3ddd0be20e1c820$export$3d12bd131bb975d1; });
$parcel$export(module.exports, "t", function () { return $f3ddd0be20e1c820$export$625550452a3fa3ec; });
$parcel$export(module.exports, "N", function () { return $f3ddd0be20e1c820$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "aD", function () { return $f3ddd0be20e1c820$export$24baa2b76016ce0e; });
$parcel$export(module.exports, "ad", function () { return $f3ddd0be20e1c820$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "ay", function () { return $f3ddd0be20e1c820$export$28f7fcd39efa255; });
$parcel$export(module.exports, "as", function () { return $f3ddd0be20e1c820$export$6554612db691658e; });
$parcel$export(module.exports, "o", function () { return $f3ddd0be20e1c820$export$ae1af26003f05816; });
$parcel$export(module.exports, "q", function () { return $f3ddd0be20e1c820$export$9e5f44173e64f162; });
$parcel$export(module.exports, "Q", function () { return $f3ddd0be20e1c820$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "e", function () { return $f3ddd0be20e1c820$export$f1e1789686576879; });
$parcel$export(module.exports, "c", function () { return $f3ddd0be20e1c820$export$db3b6bfb95261072; });
$parcel$export(module.exports, "Z", function () { return $f3ddd0be20e1c820$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "a1", function () { return $f3ddd0be20e1c820$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "d", function () { return $f3ddd0be20e1c820$export$4368d992c4eafac0; });
$parcel$export(module.exports, "O", function () { return $f3ddd0be20e1c820$export$c4ce752e73470fba; });
$parcel$export(module.exports, "aE", function () { return $f3ddd0be20e1c820$export$158acd800e1ef08b; });
$parcel$export(module.exports, "R", function () { return $f3ddd0be20e1c820$export$db202ddc8be9136; });
$parcel$export(module.exports, "aa", function () { return $f3ddd0be20e1c820$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "an", function () { return $f3ddd0be20e1c820$export$306ddfe3a8403e2; });
$parcel$export(module.exports, "y", function () { return $f3ddd0be20e1c820$export$4a5767248b18ef41; });
$parcel$export(module.exports, "S", function () { return $f3ddd0be20e1c820$export$25ce5a424b770e84; });
$parcel$export(module.exports, "V", function () { return $f3ddd0be20e1c820$export$e7c866399fa523f5; });
$parcel$export(module.exports, "al", function () { return $f3ddd0be20e1c820$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "am", function () { return $f3ddd0be20e1c820$export$1a82df3d29112e01; });
$parcel$export(module.exports, "U", function () { return $f3ddd0be20e1c820$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "ao", function () { return $f3ddd0be20e1c820$export$7a38258bbe170828; });
$parcel$export(module.exports, "ae", function () { return $f3ddd0be20e1c820$export$f787f51d84a910ad; });
$parcel$export(module.exports, "ap", function () { return $f3ddd0be20e1c820$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "aq", function () { return $f3ddd0be20e1c820$export$8a5498727ef6be21; });
$parcel$export(module.exports, "A", function () { return $f3ddd0be20e1c820$export$ebd11618f299a286; });
$parcel$export(module.exports, "W", function () { return $f3ddd0be20e1c820$export$71cec2538cb2c617; });
$parcel$export(module.exports, "a", function () { return $f3ddd0be20e1c820$export$407448d2b89b1813; });
$parcel$export(module.exports, "M", function () { return $f3ddd0be20e1c820$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "aG", function () { return $f3ddd0be20e1c820$export$53a70dd1ebbae346; });
$parcel$export(module.exports, "w", function () { return $f3ddd0be20e1c820$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "z", function () { return $f3ddd0be20e1c820$export$df995fae86a55f06; });
$parcel$export(module.exports, "aF", function () { return $f3ddd0be20e1c820$export$cf2f7c5792f80b46; });
$parcel$export(module.exports, "l", function () { return $f3ddd0be20e1c820$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $f3ddd0be20e1c820$export$3b14a55fb2447963; });
$parcel$export(module.exports, "_", function () { return $f3ddd0be20e1c820$export$71511d61b312f219; });
$parcel$export(module.exports, "a4", function () { return $f3ddd0be20e1c820$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "a3", function () { return $f3ddd0be20e1c820$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "a5", function () { return $f3ddd0be20e1c820$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "af", function () { return $f3ddd0be20e1c820$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "D", function () { return $f3ddd0be20e1c820$export$96f57966bedc81b4; });
$parcel$export(module.exports, "x", function () { return $f3ddd0be20e1c820$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "C", function () { return $f3ddd0be20e1c820$export$e7094788287c5e9b; });
$parcel$export(module.exports, "a9", function () { return $f3ddd0be20e1c820$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "G", function () { return $f3ddd0be20e1c820$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "E", function () { return $f3ddd0be20e1c820$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "ak", function () { return $f3ddd0be20e1c820$export$21579262ef46735b; });
$parcel$export(module.exports, "ai", function () { return $f3ddd0be20e1c820$export$f38c853ae54ed474; });
$parcel$export(module.exports, "aj", function () { return $f3ddd0be20e1c820$export$3b513254972cfc9c; });
$parcel$export(module.exports, "n", function () { return $f3ddd0be20e1c820$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "at", function () { return $f3ddd0be20e1c820$export$493d36ec626b6698; });
$parcel$export(module.exports, "au", function () { return $f3ddd0be20e1c820$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "aw", function () { return $f3ddd0be20e1c820$export$92108d983e8ee699; });
$parcel$export(module.exports, "ar", function () { return $f3ddd0be20e1c820$export$d24c54395ce0c509; });
$parcel$export(module.exports, "ah", function () { return $f3ddd0be20e1c820$export$995eb9fca571757; });
$parcel$export(module.exports, "ag", function () { return $f3ddd0be20e1c820$export$ee7c8ad385a60b7b; });
/*!
 * Chart.js v3.4.1
 * https://www.chartjs.org
 * (c) 2021 Chart.js Contributors
 * Released under the MIT License
 */ function $f3ddd0be20e1c820$export$f96d196f7728bb5(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
const $f3ddd0be20e1c820$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
function $f3ddd0be20e1c820$export$d66501df72047452(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args)=>Array.prototype.slice.call(args));
    let ticking = false;
    let args = [];
    return function(...rest) {
        args = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $f3ddd0be20e1c820$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args);
            });
        }
    };
}
function $f3ddd0be20e1c820$export$c3950d9923825c02(fn, delay) {
    let timeout;
    return function() {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay);
        } else fn();
        return delay;
    };
}
const $f3ddd0be20e1c820$export$78acf4525d8a74c4 = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
const $f3ddd0be20e1c820$export$8743009a87fcb00f = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
const $f3ddd0be20e1c820$export$d66dc83d8cfc8dd = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
function $f3ddd0be20e1c820$export$9fa96a7d116ea3ce() {}
const $f3ddd0be20e1c820$export$a93c5207d687da10 = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $f3ddd0be20e1c820$export$35e795649ee09318(value) {
    return value === null || typeof value === "undefined";
}
function $f3ddd0be20e1c820$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.substr(0, 7) === "[object" && type.substr(-6) === "Array]") return true;
    return false;
}
function $f3ddd0be20e1c820$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
const $f3ddd0be20e1c820$export$39b482c5e57630a8 = (value)=>(typeof value === "number" || value instanceof Number) && isFinite(+value);
function $f3ddd0be20e1c820$export$3466f893ebf79586(value, defaultValue) {
    return $f3ddd0be20e1c820$export$39b482c5e57630a8(value) ? value : defaultValue;
}
function $f3ddd0be20e1c820$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $f3ddd0be20e1c820$export$342063e11d6c3cad = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : value / dimension;
const $f3ddd0be20e1c820$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function $f3ddd0be20e1c820$export$61196ced6d74a310(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $f3ddd0be20e1c820$export$ef35774e6d314e91(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($f3ddd0be20e1c820$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($f3ddd0be20e1c820$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $f3ddd0be20e1c820$export$2219238a014317b0(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $f3ddd0be20e1c820$export$b9a6b53f9be3734(source) {
    if ($f3ddd0be20e1c820$export$8b22cf2602fb60ce(source)) return source.map($f3ddd0be20e1c820$export$b9a6b53f9be3734);
    if ($f3ddd0be20e1c820$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $f3ddd0be20e1c820$export$b9a6b53f9be3734(source[keys[k]]);
        return target;
    }
    return source;
}
function $f3ddd0be20e1c820$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
function $f3ddd0be20e1c820$export$a05254e7c3aeba6e(key, target, source, options) {
    if (!$f3ddd0be20e1c820$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($f3ddd0be20e1c820$export$23f2a1d2818174ef(tval) && $f3ddd0be20e1c820$export$23f2a1d2818174ef(sval)) $f3ddd0be20e1c820$export$3d8c2f653ac9d0b9(tval, sval, options);
    else target[key] = $f3ddd0be20e1c820$export$b9a6b53f9be3734(sval);
}
function $f3ddd0be20e1c820$export$3d8c2f653ac9d0b9(target, source, options) {
    const sources = $f3ddd0be20e1c820$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$f3ddd0be20e1c820$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $f3ddd0be20e1c820$export$a05254e7c3aeba6e;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$f3ddd0be20e1c820$export$23f2a1d2818174ef(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $f3ddd0be20e1c820$export$2e2af4578d910ddf(target, source) {
    return $f3ddd0be20e1c820$export$3d8c2f653ac9d0b9(target, source, {
        merger: $f3ddd0be20e1c820$export$23ebac1979863676
    });
}
function $f3ddd0be20e1c820$export$23ebac1979863676(key, target, source) {
    if (!$f3ddd0be20e1c820$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($f3ddd0be20e1c820$export$23f2a1d2818174ef(tval) && $f3ddd0be20e1c820$export$23f2a1d2818174ef(sval)) $f3ddd0be20e1c820$export$2e2af4578d910ddf(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $f3ddd0be20e1c820$export$b9a6b53f9be3734(sval);
}
function $f3ddd0be20e1c820$export$91477dc880baac21(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
const $f3ddd0be20e1c820$var$emptyString = "";
const $f3ddd0be20e1c820$var$dot = ".";
function $f3ddd0be20e1c820$var$indexOfDotOrLength(key, start) {
    const idx = key.indexOf($f3ddd0be20e1c820$var$dot, start);
    return idx === -1 ? key.length : idx;
}
function $f3ddd0be20e1c820$export$2d1720544b23b823(obj, key) {
    if (key === $f3ddd0be20e1c820$var$emptyString) return obj;
    let pos = 0;
    let idx = $f3ddd0be20e1c820$var$indexOfDotOrLength(key, pos);
    while(obj && idx > pos){
        obj = obj[key.substr(pos, idx - pos)];
        pos = idx + 1;
        idx = $f3ddd0be20e1c820$var$indexOfDotOrLength(key, pos);
    }
    return obj;
}
function $f3ddd0be20e1c820$export$34aec0b863436764(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $f3ddd0be20e1c820$export$dda1d9f60106f0e9 = (value)=>typeof value !== "undefined";
const $f3ddd0be20e1c820$export$ce26c07117d59d6a = (value)=>typeof value === "function";
const $f3ddd0be20e1c820$export$555508cbc6add439 = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
const $f3ddd0be20e1c820$export$56c0d5a1e737357d = Math.PI;
const $f3ddd0be20e1c820$export$971d5caa766a69d7 = 2 * $f3ddd0be20e1c820$export$56c0d5a1e737357d;
const $f3ddd0be20e1c820$export$d377dcb2b61d6c4e = $f3ddd0be20e1c820$export$971d5caa766a69d7 + $f3ddd0be20e1c820$export$56c0d5a1e737357d;
const $f3ddd0be20e1c820$export$667d3bf0c5f83305 = Number.POSITIVE_INFINITY;
const $f3ddd0be20e1c820$export$317a3d46287192d8 = $f3ddd0be20e1c820$export$56c0d5a1e737357d / 180;
const $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd = $f3ddd0be20e1c820$export$56c0d5a1e737357d / 2;
const $f3ddd0be20e1c820$export$1ee57be6f6687d2c = $f3ddd0be20e1c820$export$56c0d5a1e737357d / 4;
const $f3ddd0be20e1c820$export$9d0e2d13d04f7070 = $f3ddd0be20e1c820$export$56c0d5a1e737357d * 2 / 3;
const $f3ddd0be20e1c820$export$9bb611d729802a56 = Math.log10;
const $f3ddd0be20e1c820$export$2408f22a0fab9ae5 = Math.sign;
function $f3ddd0be20e1c820$export$91c6e00c14e7e6fd(range) {
    const roundedRange = Math.round(range);
    range = $f3ddd0be20e1c820$export$890c4ad488842ce7(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($f3ddd0be20e1c820$export$9bb611d729802a56(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $f3ddd0be20e1c820$export$b4171a6734a65d42(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $f3ddd0be20e1c820$export$ffb5f4729a158638(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $f3ddd0be20e1c820$export$890c4ad488842ce7(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $f3ddd0be20e1c820$export$9d398bebfec1c039(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $f3ddd0be20e1c820$export$3d12bd131bb975d1(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $f3ddd0be20e1c820$export$625550452a3fa3ec(degrees) {
    return degrees * ($f3ddd0be20e1c820$export$56c0d5a1e737357d / 180);
}
function $f3ddd0be20e1c820$export$a07804094c3ecf2d(radians) {
    return radians * (180 / $f3ddd0be20e1c820$export$56c0d5a1e737357d);
}
function $f3ddd0be20e1c820$export$24baa2b76016ce0e(x) {
    if (!$f3ddd0be20e1c820$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $f3ddd0be20e1c820$export$4c3d22f3d993c33f(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $f3ddd0be20e1c820$export$56c0d5a1e737357d) angle += $f3ddd0be20e1c820$export$971d5caa766a69d7;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $f3ddd0be20e1c820$export$28f7fcd39efa255(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $f3ddd0be20e1c820$export$1a8f5705751d8277(a, b) {
    return (a - b + $f3ddd0be20e1c820$export$d377dcb2b61d6c4e) % $f3ddd0be20e1c820$export$971d5caa766a69d7 - $f3ddd0be20e1c820$export$56c0d5a1e737357d;
}
function $f3ddd0be20e1c820$export$6554612db691658e(a) {
    return (a % $f3ddd0be20e1c820$export$971d5caa766a69d7 + $f3ddd0be20e1c820$export$971d5caa766a69d7) % $f3ddd0be20e1c820$export$971d5caa766a69d7;
}
function $f3ddd0be20e1c820$export$ae1af26003f05816(angle, start, end, sameAngleIsFullCircle) {
    const a = $f3ddd0be20e1c820$export$6554612db691658e(angle);
    const s = $f3ddd0be20e1c820$export$6554612db691658e(start);
    const e = $f3ddd0be20e1c820$export$6554612db691658e(end);
    const angleToStart = $f3ddd0be20e1c820$export$6554612db691658e(s - a);
    const angleToEnd = $f3ddd0be20e1c820$export$6554612db691658e(e - a);
    const startToAngle = $f3ddd0be20e1c820$export$6554612db691658e(a - s);
    const endToAngle = $f3ddd0be20e1c820$export$6554612db691658e(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $f3ddd0be20e1c820$export$9e5f44173e64f162(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $f3ddd0be20e1c820$export$3722cfe417b6ed86(value) {
    return $f3ddd0be20e1c820$export$9e5f44173e64f162(value, -32768, 32767);
}
const $f3ddd0be20e1c820$var$atEdge = (t)=>t === 0 || t === 1;
const $f3ddd0be20e1c820$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $f3ddd0be20e1c820$export$971d5caa766a69d7 / p));
const $f3ddd0be20e1c820$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $f3ddd0be20e1c820$export$971d5caa766a69d7 / p) + 1;
const $f3ddd0be20e1c820$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($f3ddd0be20e1c820$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$f3ddd0be20e1c820$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$f3ddd0be20e1c820$var$atEdge(t) ? t : $f3ddd0be20e1c820$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$f3ddd0be20e1c820$var$atEdge(t) ? t : $f3ddd0be20e1c820$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $f3ddd0be20e1c820$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $f3ddd0be20e1c820$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $f3ddd0be20e1c820$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $f3ddd0be20e1c820$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $f3ddd0be20e1c820$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $f3ddd0be20e1c820$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.1.9
 * https://github.com/kurkle/color#readme
 * (c) 2020 Jukka Kurkela
 * Released under the MIT License
 */ const $f3ddd0be20e1c820$var$map = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $f3ddd0be20e1c820$var$hex = "0123456789ABCDEF";
const $f3ddd0be20e1c820$var$h1 = (b)=>$f3ddd0be20e1c820$var$hex[b & 0xF];
const $f3ddd0be20e1c820$var$h2 = (b)=>$f3ddd0be20e1c820$var$hex[(b & 0xF0) >> 4] + $f3ddd0be20e1c820$var$hex[b & 0xF];
const $f3ddd0be20e1c820$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
function $f3ddd0be20e1c820$var$isShort(v) {
    return $f3ddd0be20e1c820$var$eq(v.r) && $f3ddd0be20e1c820$var$eq(v.g) && $f3ddd0be20e1c820$var$eq(v.b) && $f3ddd0be20e1c820$var$eq(v.a);
}
function $f3ddd0be20e1c820$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $f3ddd0be20e1c820$var$map[str[1]] * 17,
            g: 255 & $f3ddd0be20e1c820$var$map[str[2]] * 17,
            b: 255 & $f3ddd0be20e1c820$var$map[str[3]] * 17,
            a: len === 5 ? $f3ddd0be20e1c820$var$map[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $f3ddd0be20e1c820$var$map[str[1]] << 4 | $f3ddd0be20e1c820$var$map[str[2]],
            g: $f3ddd0be20e1c820$var$map[str[3]] << 4 | $f3ddd0be20e1c820$var$map[str[4]],
            b: $f3ddd0be20e1c820$var$map[str[5]] << 4 | $f3ddd0be20e1c820$var$map[str[6]],
            a: len === 9 ? $f3ddd0be20e1c820$var$map[str[7]] << 4 | $f3ddd0be20e1c820$var$map[str[8]] : 255
        };
    }
    return ret;
}
function $f3ddd0be20e1c820$var$hexString(v) {
    var f = $f3ddd0be20e1c820$var$isShort(v) ? $f3ddd0be20e1c820$var$h1 : $f3ddd0be20e1c820$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + (v.a < 255 ? f(v.a) : "") : v;
}
function $f3ddd0be20e1c820$var$round(v) {
    return v + 0.5 | 0;
}
const $f3ddd0be20e1c820$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $f3ddd0be20e1c820$var$p2b(v) {
    return $f3ddd0be20e1c820$var$lim($f3ddd0be20e1c820$var$round(v * 2.55), 0, 255);
}
function $f3ddd0be20e1c820$var$n2b(v) {
    return $f3ddd0be20e1c820$var$lim($f3ddd0be20e1c820$var$round(v * 255), 0, 255);
}
function $f3ddd0be20e1c820$var$b2n(v) {
    return $f3ddd0be20e1c820$var$lim($f3ddd0be20e1c820$var$round(v / 2.55) / 100, 0, 1);
}
function $f3ddd0be20e1c820$var$n2p(v) {
    return $f3ddd0be20e1c820$var$lim($f3ddd0be20e1c820$var$round(v * 100), 0, 100);
}
const $f3ddd0be20e1c820$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $f3ddd0be20e1c820$var$rgbParse(str) {
    const m = $f3ddd0be20e1c820$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = 255 & (m[8] ? $f3ddd0be20e1c820$var$p2b(v) : v * 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $f3ddd0be20e1c820$var$p2b(r) : r);
    g = 255 & (m[4] ? $f3ddd0be20e1c820$var$p2b(g) : g);
    b = 255 & (m[6] ? $f3ddd0be20e1c820$var$p2b(b) : b);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $f3ddd0be20e1c820$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$f3ddd0be20e1c820$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $f3ddd0be20e1c820$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $f3ddd0be20e1c820$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $f3ddd0be20e1c820$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $f3ddd0be20e1c820$var$hwb2rgbn(h, w, b) {
    const rgb = $f3ddd0be20e1c820$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $f3ddd0be20e1c820$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $f3ddd0be20e1c820$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($f3ddd0be20e1c820$var$n2b);
}
function $f3ddd0be20e1c820$var$hsl2rgb(h, s, l) {
    return $f3ddd0be20e1c820$var$calln($f3ddd0be20e1c820$var$hsl2rgbn, h, s, l);
}
function $f3ddd0be20e1c820$var$hwb2rgb(h, w, b) {
    return $f3ddd0be20e1c820$var$calln($f3ddd0be20e1c820$var$hwb2rgbn, h, w, b);
}
function $f3ddd0be20e1c820$var$hsv2rgb(h, s, v) {
    return $f3ddd0be20e1c820$var$calln($f3ddd0be20e1c820$var$hsv2rgbn, h, s, v);
}
function $f3ddd0be20e1c820$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $f3ddd0be20e1c820$var$hueParse(str) {
    const m = $f3ddd0be20e1c820$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $f3ddd0be20e1c820$var$p2b(+m[5]) : $f3ddd0be20e1c820$var$n2b(+m[5]);
    const h = $f3ddd0be20e1c820$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $f3ddd0be20e1c820$var$hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = $f3ddd0be20e1c820$var$hsv2rgb(h, p1, p2);
    else v = $f3ddd0be20e1c820$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $f3ddd0be20e1c820$var$rotate(v, deg) {
    var h = $f3ddd0be20e1c820$var$rgb2hsl(v);
    h[0] = $f3ddd0be20e1c820$var$hue(h[0] + deg);
    h = $f3ddd0be20e1c820$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $f3ddd0be20e1c820$var$hslString(v) {
    if (!v) return;
    const a = $f3ddd0be20e1c820$var$rgb2hsl(v);
    const h = a[0];
    const s = $f3ddd0be20e1c820$var$n2p(a[1]);
    const l = $f3ddd0be20e1c820$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$f3ddd0be20e1c820$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $f3ddd0be20e1c820$var$map$1 = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $f3ddd0be20e1c820$var$names = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $f3ddd0be20e1c820$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($f3ddd0be20e1c820$var$names);
    const tkeys = Object.keys($f3ddd0be20e1c820$var$map$1);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $f3ddd0be20e1c820$var$map$1[k]);
        }
        k = parseInt($f3ddd0be20e1c820$var$names[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $f3ddd0be20e1c820$var$names$1;
function $f3ddd0be20e1c820$var$nameParse(str) {
    if (!$f3ddd0be20e1c820$var$names$1) {
        $f3ddd0be20e1c820$var$names$1 = $f3ddd0be20e1c820$var$unpack();
        $f3ddd0be20e1c820$var$names$1.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $f3ddd0be20e1c820$var$names$1[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
function $f3ddd0be20e1c820$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $f3ddd0be20e1c820$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $f3ddd0be20e1c820$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $f3ddd0be20e1c820$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $f3ddd0be20e1c820$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $f3ddd0be20e1c820$var$n2b(input[3]);
        }
    } else {
        v = $f3ddd0be20e1c820$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $f3ddd0be20e1c820$var$n2b(v.a);
    }
    return v;
}
function $f3ddd0be20e1c820$var$functionParse(str) {
    if (str.charAt(0) === "r") return $f3ddd0be20e1c820$var$rgbParse(str);
    return $f3ddd0be20e1c820$var$hueParse(str);
}
class $f3ddd0be20e1c820$var$Color {
    constructor(input){
        if (input instanceof $f3ddd0be20e1c820$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $f3ddd0be20e1c820$var$fromObject(input);
        else if (type === "string") v = $f3ddd0be20e1c820$var$hexParse(input) || $f3ddd0be20e1c820$var$nameParse(input) || $f3ddd0be20e1c820$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $f3ddd0be20e1c820$var$clone(this._rgb);
        if (v) v.a = $f3ddd0be20e1c820$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $f3ddd0be20e1c820$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $f3ddd0be20e1c820$var$rgbString(this._rgb) : this._rgb;
    }
    hexString() {
        return this._valid ? $f3ddd0be20e1c820$var$hexString(this._rgb) : this._rgb;
    }
    hslString() {
        return this._valid ? $f3ddd0be20e1c820$var$hslString(this._rgb) : this._rgb;
    }
    mix(color, weight) {
        const me = this;
        if (color) {
            const c1 = me.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            me.rgb = c1;
        }
        return me;
    }
    clone() {
        return new $f3ddd0be20e1c820$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $f3ddd0be20e1c820$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $f3ddd0be20e1c820$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $f3ddd0be20e1c820$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $f3ddd0be20e1c820$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $f3ddd0be20e1c820$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $f3ddd0be20e1c820$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $f3ddd0be20e1c820$var$rotate(this._rgb, deg);
        return this;
    }
}
function $f3ddd0be20e1c820$var$index_esm(input) {
    return new $f3ddd0be20e1c820$var$Color(input);
}
const $f3ddd0be20e1c820$var$isPatternOrGradient = (value)=>value instanceof CanvasGradient || value instanceof CanvasPattern;
function $f3ddd0be20e1c820$export$db3b6bfb95261072(value) {
    return $f3ddd0be20e1c820$var$isPatternOrGradient(value) ? value : $f3ddd0be20e1c820$var$index_esm(value);
}
function $f3ddd0be20e1c820$export$a33b77bbdbb8366c(value) {
    return $f3ddd0be20e1c820$var$isPatternOrGradient(value) ? value : $f3ddd0be20e1c820$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $f3ddd0be20e1c820$export$dc98b0b04f4c7758 = Object.create(null);
const $f3ddd0be20e1c820$export$3c2fa207a37baaea = Object.create(null);
function $f3ddd0be20e1c820$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $f3ddd0be20e1c820$var$set(root, scope, values) {
    if (typeof scope === "string") return $f3ddd0be20e1c820$export$3d8c2f653ac9d0b9($f3ddd0be20e1c820$var$getScope$1(root, scope), values);
    return $f3ddd0be20e1c820$export$3d8c2f653ac9d0b9($f3ddd0be20e1c820$var$getScope$1(root, ""), scope);
}
class $f3ddd0be20e1c820$var$Defaults {
    constructor(_descriptors){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$f3ddd0be20e1c820$export$a33b77bbdbb8366c(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$f3ddd0be20e1c820$export$a33b77bbdbb8366c(options.borderColor);
        this.hoverColor = (ctx, options)=>$f3ddd0be20e1c820$export$a33b77bbdbb8366c(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.describe(_descriptors);
    }
    set(scope, values) {
        return $f3ddd0be20e1c820$var$set(this, scope, values);
    }
    get(scope) {
        return $f3ddd0be20e1c820$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $f3ddd0be20e1c820$var$set($f3ddd0be20e1c820$export$3c2fa207a37baaea, scope, values);
    }
    override(scope, values) {
        return $f3ddd0be20e1c820$var$set($f3ddd0be20e1c820$export$dc98b0b04f4c7758, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $f3ddd0be20e1c820$var$getScope$1(this, scope);
        const targetScopeObject = $f3ddd0be20e1c820$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($f3ddd0be20e1c820$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $f3ddd0be20e1c820$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
}
var $f3ddd0be20e1c820$export$4368d992c4eafac0 = new $f3ddd0be20e1c820$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $f3ddd0be20e1c820$export$9f4f30ee63539e24(font) {
    if (!font || $f3ddd0be20e1c820$export$35e795649ee09318(font.size) || $f3ddd0be20e1c820$export$35e795649ee09318(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function $f3ddd0be20e1c820$export$c4ce752e73470fba(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $f3ddd0be20e1c820$export$158acd800e1ef08b(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== undefined && thing !== null && $f3ddd0be20e1c820$export$8b22cf2602fb60ce(thing) !== true) longest = $f3ddd0be20e1c820$export$c4ce752e73470fba(ctx, data, gc, longest, thing);
        else if ($f3ddd0be20e1c820$export$8b22cf2602fb60ce(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== undefined && nestedThing !== null && !$f3ddd0be20e1c820$export$8b22cf2602fb60ce(nestedThing)) longest = $f3ddd0be20e1c820$export$c4ce752e73470fba(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $f3ddd0be20e1c820$export$db202ddc8be9136(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $f3ddd0be20e1c820$export$7910e0436ed8d1de(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $f3ddd0be20e1c820$export$306ddfe3a8403e2(ctx, options, x, y) {
    let type, xOffset, yOffset, size, cornerRadius;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $f3ddd0be20e1c820$export$317a3d46287192d8;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            ctx.arc(x, y, radius, 0, $f3ddd0be20e1c820$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $f3ddd0be20e1c820$export$9d0e2d13d04f7070;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $f3ddd0be20e1c820$export$9d0e2d13d04f7070;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $f3ddd0be20e1c820$export$1ee57be6f6687d2c) * size;
            yOffset = Math.sin(rad + $f3ddd0be20e1c820$export$1ee57be6f6687d2c) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $f3ddd0be20e1c820$export$56c0d5a1e737357d, rad - $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd, rad + $f3ddd0be20e1c820$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                ctx.rect(x - size, y - size, 2 * size, 2 * size);
                break;
            }
            rad += $f3ddd0be20e1c820$export$1ee57be6f6687d2c;
        case "rectRot":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $f3ddd0be20e1c820$export$1ee57be6f6687d2c;
        case "cross":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "star":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $f3ddd0be20e1c820$export$1ee57be6f6687d2c;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "line":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $f3ddd0be20e1c820$export$4a5767248b18ef41(point, area, margin) {
    margin = margin || 0.5;
    return point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $f3ddd0be20e1c820$export$25ce5a424b770e84(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $f3ddd0be20e1c820$export$e7c866399fa523f5(ctx) {
    ctx.restore();
}
function $f3ddd0be20e1c820$export$ab83b03e4111b1d0(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $f3ddd0be20e1c820$export$1a82df3d29112e01(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $f3ddd0be20e1c820$export$3a6d5c9ae78a2c08(ctx, text, x, y, font, opts = {}) {
    const lines = $f3ddd0be20e1c820$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $f3ddd0be20e1c820$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$f3ddd0be20e1c820$export$35e795649ee09318(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $f3ddd0be20e1c820$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $f3ddd0be20e1c820$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$f3ddd0be20e1c820$export$35e795649ee09318(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $f3ddd0be20e1c820$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $f3ddd0be20e1c820$export$7a38258bbe170828(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd, $f3ddd0be20e1c820$export$56c0d5a1e737357d, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $f3ddd0be20e1c820$export$56c0d5a1e737357d, $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$f3ddd0be20e1c820$export$7f8ddf7c7c20b3cd, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $f3ddd0be20e1c820$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $f3ddd0be20e1c820$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $f3ddd0be20e1c820$export$738ab4df8bf92ae9(value, size) {
    const matches = ("" + value).match($f3ddd0be20e1c820$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $f3ddd0be20e1c820$var$numberOrZero = (v)=>+v || 0;
function $f3ddd0be20e1c820$export$f787f51d84a910ad(value, props) {
    const ret = {};
    const objProps = $f3ddd0be20e1c820$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $f3ddd0be20e1c820$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$f3ddd0be20e1c820$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $f3ddd0be20e1c820$var$numberOrZero(read(prop));
    return ret;
}
function $f3ddd0be20e1c820$export$2f6ca3d3b1f80bf5(value) {
    return $f3ddd0be20e1c820$export$f787f51d84a910ad(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
function $f3ddd0be20e1c820$export$8a5498727ef6be21(value) {
    return $f3ddd0be20e1c820$export$f787f51d84a910ad(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
function $f3ddd0be20e1c820$export$ebd11618f299a286(value) {
    const obj = $f3ddd0be20e1c820$export$2f6ca3d3b1f80bf5(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $f3ddd0be20e1c820$export$71cec2538cb2c617(options, fallback) {
    options = options || {};
    fallback = fallback || $f3ddd0be20e1c820$export$4368d992c4eafac0.font;
    let size = $f3ddd0be20e1c820$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $f3ddd0be20e1c820$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($f3ddd0be20e1c820$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = "";
    }
    const font = {
        family: $f3ddd0be20e1c820$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $f3ddd0be20e1c820$export$738ab4df8bf92ae9($f3ddd0be20e1c820$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $f3ddd0be20e1c820$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $f3ddd0be20e1c820$export$9f4f30ee63539e24(font);
    return font;
}
function $f3ddd0be20e1c820$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $f3ddd0be20e1c820$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $f3ddd0be20e1c820$export$3a1a48c8f6ef640e(minmax, grace) {
    const { min: min, max: max } = minmax;
    return {
        min: min - Math.abs($f3ddd0be20e1c820$export$953cecd6e717a553(grace, min)),
        max: max + $f3ddd0be20e1c820$export$953cecd6e717a553(grace, max)
    };
}
function $f3ddd0be20e1c820$export$53a70dd1ebbae346(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $f3ddd0be20e1c820$export$efccba1c4a2ef57b = (table, key, value)=>$f3ddd0be20e1c820$export$53a70dd1ebbae346(table, value, (index)=>table[index][key] < value);
const $f3ddd0be20e1c820$export$df995fae86a55f06 = (table, key, value)=>$f3ddd0be20e1c820$export$53a70dd1ebbae346(table, value, (index)=>table[index][key] >= value);
function $f3ddd0be20e1c820$export$cf2f7c5792f80b46(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $f3ddd0be20e1c820$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $f3ddd0be20e1c820$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $f3ddd0be20e1c820$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $f3ddd0be20e1c820$export$34aec0b863436764(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $f3ddd0be20e1c820$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $f3ddd0be20e1c820$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $f3ddd0be20e1c820$export$71511d61b312f219(items) {
    const set = new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set.add(items[i]);
    if (set.size === ilen) return items;
    return Array.from(set);
}
function $f3ddd0be20e1c820$export$efca4cbe5dd06740(scopes, prefixes = [
    ""
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$f3ddd0be20e1c820$export$dda1d9f60106f0e9(fallback)) fallback = $f3ddd0be20e1c820$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$f3ddd0be20e1c820$export$efca4cbe5dd06740([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $f3ddd0be20e1c820$var$_cached(target, prop, ()=>$f3ddd0be20e1c820$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $f3ddd0be20e1c820$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $f3ddd0be20e1c820$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            storage[prop] = value;
            delete target[prop];
            delete target._keys;
            return true;
        }
    });
}
function $f3ddd0be20e1c820$export$6559d589eb85fbb6(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $f3ddd0be20e1c820$export$a8550f7dbe79f93a(proxy, descriptorDefaults),
        setContext: (ctx)=>$f3ddd0be20e1c820$export$6559d589eb85fbb6(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$f3ddd0be20e1c820$export$6559d589eb85fbb6(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $f3ddd0be20e1c820$var$_cached(target, prop, ()=>$f3ddd0be20e1c820$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $f3ddd0be20e1c820$export$a8550f7dbe79f93a(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $f3ddd0be20e1c820$export$ce26c07117d59d6a(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $f3ddd0be20e1c820$export$ce26c07117d59d6a(_indexable) ? _indexable : ()=>_indexable
    };
}
const $f3ddd0be20e1c820$var$readKey = (prefix, name)=>prefix ? prefix + $f3ddd0be20e1c820$export$34aec0b863436764(name) : name;
const $f3ddd0be20e1c820$var$needsSubResolver = (prop, value)=>$f3ddd0be20e1c820$export$23f2a1d2818174ef(value) && prop !== "adapters";
function $f3ddd0be20e1c820$var$_cached(target, prop, resolve) {
    let value = target[prop];
    if ($f3ddd0be20e1c820$export$dda1d9f60106f0e9(value)) return value;
    value = resolve();
    if ($f3ddd0be20e1c820$export$dda1d9f60106f0e9(value)) target[prop] = value;
    return value;
}
function $f3ddd0be20e1c820$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop];
    if ($f3ddd0be20e1c820$export$ce26c07117d59d6a(value) && descriptors.isScriptable(prop)) value = $f3ddd0be20e1c820$var$_resolveScriptable(prop, value, target, receiver);
    if ($f3ddd0be20e1c820$export$8b22cf2602fb60ce(value) && value.length) value = $f3ddd0be20e1c820$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($f3ddd0be20e1c820$var$needsSubResolver(prop, value)) value = $f3ddd0be20e1c820$export$6559d589eb85fbb6(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $f3ddd0be20e1c820$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($f3ddd0be20e1c820$export$23f2a1d2818174ef(value)) value = $f3ddd0be20e1c820$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $f3ddd0be20e1c820$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if ($f3ddd0be20e1c820$export$dda1d9f60106f0e9(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($f3ddd0be20e1c820$export$23f2a1d2818174ef(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $f3ddd0be20e1c820$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($f3ddd0be20e1c820$export$6559d589eb85fbb6(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $f3ddd0be20e1c820$var$resolveFallback(fallback, prop, value) {
    return $f3ddd0be20e1c820$export$ce26c07117d59d6a(fallback) ? fallback(prop, value) : fallback;
}
const $f3ddd0be20e1c820$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $f3ddd0be20e1c820$export$2d1720544b23b823(parent, key) : undefined;
function $f3ddd0be20e1c820$var$addScopes(set, parentScopes, key, parentFallback) {
    for (const parent of parentScopes){
        const scope = $f3ddd0be20e1c820$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $f3ddd0be20e1c820$var$resolveFallback(scope._fallback, key, scope);
            if ($f3ddd0be20e1c820$export$dda1d9f60106f0e9(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $f3ddd0be20e1c820$export$dda1d9f60106f0e9(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $f3ddd0be20e1c820$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $f3ddd0be20e1c820$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $f3ddd0be20e1c820$var$addScopesFromKey(set, allScopes, prop, fallback || prop);
    if (key === null) return false;
    if ($f3ddd0be20e1c820$export$dda1d9f60106f0e9(fallback) && fallback !== prop) {
        key = $f3ddd0be20e1c820$var$addScopesFromKey(set, allScopes, fallback, key);
        if (key === null) return false;
    }
    return $f3ddd0be20e1c820$export$efca4cbe5dd06740(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$f3ddd0be20e1c820$var$subGetTarget(resolver, prop, value));
}
function $f3ddd0be20e1c820$var$addScopesFromKey(set, allScopes, key, fallback) {
    while(key)key = $f3ddd0be20e1c820$var$addScopes(set, allScopes, key, fallback);
    return key;
}
function $f3ddd0be20e1c820$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($f3ddd0be20e1c820$export$8b22cf2602fb60ce(target) && $f3ddd0be20e1c820$export$23f2a1d2818174ef(value)) return value;
    return target;
}
function $f3ddd0be20e1c820$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $f3ddd0be20e1c820$var$_resolve($f3ddd0be20e1c820$var$readKey(prefix, prop), scopes);
        if ($f3ddd0be20e1c820$export$dda1d9f60106f0e9(value)) return $f3ddd0be20e1c820$var$needsSubResolver(prop, value) ? $f3ddd0be20e1c820$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $f3ddd0be20e1c820$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($f3ddd0be20e1c820$export$dda1d9f60106f0e9(value)) return value;
    }
}
function $f3ddd0be20e1c820$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $f3ddd0be20e1c820$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $f3ddd0be20e1c820$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
const $f3ddd0be20e1c820$var$EPSILON = Number.EPSILON || 1e-14;
const $f3ddd0be20e1c820$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $f3ddd0be20e1c820$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $f3ddd0be20e1c820$export$faec65b429be379(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $f3ddd0be20e1c820$export$28f7fcd39efa255(current, previous);
    const d12 = $f3ddd0be20e1c820$export$28f7fcd39efa255(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $f3ddd0be20e1c820$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $f3ddd0be20e1c820$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $f3ddd0be20e1c820$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($f3ddd0be20e1c820$export$890c4ad488842ce7(deltaK[i], 0, $f3ddd0be20e1c820$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $f3ddd0be20e1c820$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $f3ddd0be20e1c820$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $f3ddd0be20e1c820$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $f3ddd0be20e1c820$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $f3ddd0be20e1c820$export$c03999cb2f36933f(points, indexAxis = "x") {
    const valueAxis = $f3ddd0be20e1c820$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $f3ddd0be20e1c820$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $f3ddd0be20e1c820$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $f3ddd0be20e1c820$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $f3ddd0be20e1c820$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $f3ddd0be20e1c820$var$monotoneAdjust(points, deltaK, mK);
    $f3ddd0be20e1c820$var$monotoneCompute(points, mK, indexAxis);
}
function $f3ddd0be20e1c820$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $f3ddd0be20e1c820$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $f3ddd0be20e1c820$export$4a5767248b18ef41(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $f3ddd0be20e1c820$export$4a5767248b18ef41(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $f3ddd0be20e1c820$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $f3ddd0be20e1c820$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $f3ddd0be20e1c820$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $f3ddd0be20e1c820$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $f3ddd0be20e1c820$export$c9170ad7d4cd7e57(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $f3ddd0be20e1c820$export$c03999cb2f36933f(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $f3ddd0be20e1c820$export$faec65b429be379(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $f3ddd0be20e1c820$var$capBezierPoints(points, area);
}
function $f3ddd0be20e1c820$export$96f57966bedc81b4(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
function $f3ddd0be20e1c820$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $f3ddd0be20e1c820$var$getComputedStyle = (element)=>window.getComputedStyle(element, null);
function $f3ddd0be20e1c820$export$2ed0fc6709e59212(el, property) {
    return $f3ddd0be20e1c820$var$getComputedStyle(el).getPropertyValue(property);
}
const $f3ddd0be20e1c820$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $f3ddd0be20e1c820$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $f3ddd0be20e1c820$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $f3ddd0be20e1c820$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $f3ddd0be20e1c820$var$getCanvasPosition(evt, canvas) {
    const e = evt.native || evt;
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($f3ddd0be20e1c820$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $f3ddd0be20e1c820$export$d141bba7fdc215a3(evt, chart) {
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $f3ddd0be20e1c820$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $f3ddd0be20e1c820$var$getPositionedStyle(style, "padding");
    const borders = $f3ddd0be20e1c820$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $f3ddd0be20e1c820$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $f3ddd0be20e1c820$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $f3ddd0be20e1c820$export$96f57966bedc81b4(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $f3ddd0be20e1c820$var$getComputedStyle(container);
            const containerBorder = $f3ddd0be20e1c820$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $f3ddd0be20e1c820$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $f3ddd0be20e1c820$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $f3ddd0be20e1c820$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $f3ddd0be20e1c820$export$667d3bf0c5f83305,
        maxHeight: maxHeight || $f3ddd0be20e1c820$export$667d3bf0c5f83305
    };
}
const $f3ddd0be20e1c820$var$round1 = (v)=>Math.round(v * 10) / 10;
function $f3ddd0be20e1c820$export$e7094788287c5e9b(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $f3ddd0be20e1c820$var$getComputedStyle(canvas);
    const margins = $f3ddd0be20e1c820$var$getPositionedStyle(style, "margin");
    const maxWidth = $f3ddd0be20e1c820$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $f3ddd0be20e1c820$export$667d3bf0c5f83305;
    const maxHeight = $f3ddd0be20e1c820$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $f3ddd0be20e1c820$export$667d3bf0c5f83305;
    const containerSize = $f3ddd0be20e1c820$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $f3ddd0be20e1c820$var$getPositionedStyle(style, "border", "width");
        const paddings = $f3ddd0be20e1c820$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $f3ddd0be20e1c820$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $f3ddd0be20e1c820$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $f3ddd0be20e1c820$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $f3ddd0be20e1c820$export$a9c996f45e5784d0(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $f3ddd0be20e1c820$export$2329c99376c9d0a4 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $f3ddd0be20e1c820$export$a9c23c6ac3fc3eca(element, property) {
    const value = $f3ddd0be20e1c820$export$2ed0fc6709e59212(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
function $f3ddd0be20e1c820$export$21579262ef46735b(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $f3ddd0be20e1c820$export$f38c853ae54ed474(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $f3ddd0be20e1c820$export$3b513254972cfc9c(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $f3ddd0be20e1c820$export$21579262ef46735b(p1, cp1, t);
    const b = $f3ddd0be20e1c820$export$21579262ef46735b(cp1, cp2, t);
    const c = $f3ddd0be20e1c820$export$21579262ef46735b(cp2, p2, t);
    const d = $f3ddd0be20e1c820$export$21579262ef46735b(a, b, t);
    const e = $f3ddd0be20e1c820$export$21579262ef46735b(b, c, t);
    return $f3ddd0be20e1c820$export$21579262ef46735b(d, e, t);
}
const $f3ddd0be20e1c820$var$intlCache = new Map();
function $f3ddd0be20e1c820$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $f3ddd0be20e1c820$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $f3ddd0be20e1c820$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $f3ddd0be20e1c820$export$7ccc53e8f1e7dfc5(num, locale, options) {
    return $f3ddd0be20e1c820$var$getNumberFormat(locale, options).format(num);
}
const $f3ddd0be20e1c820$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $f3ddd0be20e1c820$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $f3ddd0be20e1c820$export$493d36ec626b6698(rtl, rectX, width) {
    return rtl ? $f3ddd0be20e1c820$var$getRightToLeftAdapter(rectX, width) : $f3ddd0be20e1c820$var$getLeftToRightAdapter();
}
function $f3ddd0be20e1c820$export$1fbe638ecf81657e(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $f3ddd0be20e1c820$export$92108d983e8ee699(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $f3ddd0be20e1c820$var$propertyFn(property) {
    if (property === "angle") return {
        between: $f3ddd0be20e1c820$export$ae1af26003f05816,
        compare: $f3ddd0be20e1c820$export$1a8f5705751d8277,
        normalize: $f3ddd0be20e1c820$export$6554612db691658e
    };
    return {
        between: (n, s, e)=>n >= Math.min(s, e) && n <= Math.max(e, s),
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $f3ddd0be20e1c820$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $f3ddd0be20e1c820$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $f3ddd0be20e1c820$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $f3ddd0be20e1c820$export$d24c54395ce0c509(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $f3ddd0be20e1c820$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $f3ddd0be20e1c820$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($f3ddd0be20e1c820$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($f3ddd0be20e1c820$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $f3ddd0be20e1c820$export$995eb9fca571757(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $f3ddd0be20e1c820$export$d24c54395ce0c509(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $f3ddd0be20e1c820$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $f3ddd0be20e1c820$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $f3ddd0be20e1c820$export$ee7c8ad385a60b7b(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $f3ddd0be20e1c820$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $f3ddd0be20e1c820$var$splitByStyles([
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $f3ddd0be20e1c820$var$splitByStyles($f3ddd0be20e1c820$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $f3ddd0be20e1c820$var$splitByStyles(segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $f3ddd0be20e1c820$var$doSplitByStyles(segments, points, segmentOptions);
}
function $f3ddd0be20e1c820$var$doSplitByStyles(segments, points, segmentOptions) {
    const count = points.length;
    const result = [];
    let start = segments[0].start;
    let i = start;
    for (const segment of segments){
        let prevStyle, style;
        let prev = points[start % count];
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $f3ddd0be20e1c820$var$readStyle(segmentOptions.setContext({
                type: "segment",
                p0: prev,
                p1: pt
            }));
            if ($f3ddd0be20e1c820$var$styleChanged(style, prevStyle)) {
                result.push({
                    start: start,
                    end: i - 1,
                    loop: segment.loop,
                    style: prevStyle
                });
                prevStyle = style;
                start = i - 1;
            }
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) {
            result.push({
                start: start,
                end: i - 1,
                loop: segment.loop,
                style: style
            });
            start = i - 1;
        }
    }
    return result;
}
function $f3ddd0be20e1c820$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $f3ddd0be20e1c820$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}

});


parcelRegister("jCgCX", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("5VMx0", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});

parcelRegister("9hx7p", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n = this.utcOffset(), i = this.toDate(), a = i.toLocaleString("en-US", {
                timeZone: t
            }), u = Math.round((i - new Date(a)) / 1e3 / 60), f = o(a, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(i.getTimezoneOffset() / 15) - u, !0);
            if (e) {
                var s = f.utcOffset();
                f = f.add(n - s, "minute");
            }
            return f.$x.$timezone = t, f;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});

});

parcelRegister("favLa", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekday = function(e) {
            var t = this.$locale().weekStart || 0, i = this.$W, n = (i < t ? i + 7 : i) - t;
            return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
        };
    };
});

});

parcelRegister("cKWSB", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});

});

parcelRegister("f8xpu", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});

});

parcelRegister("6s8rf", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});

});

var $0683ab1ee172a3e8$export$8e3ada03ba72bedf = 60;
var $0683ab1ee172a3e8$export$a7c8f89377823cb8 = $0683ab1ee172a3e8$export$8e3ada03ba72bedf * 60;
var $0683ab1ee172a3e8$export$acc6f43ab2895cb5 = $0683ab1ee172a3e8$export$a7c8f89377823cb8 * 24;
var $0683ab1ee172a3e8$export$d99925edf30da4be = $0683ab1ee172a3e8$export$acc6f43ab2895cb5 * 7;
var $0683ab1ee172a3e8$export$c0ed55f5b8675ea3 = 1e3;
var $0683ab1ee172a3e8$export$37971e215480ff4b = $0683ab1ee172a3e8$export$8e3ada03ba72bedf * $0683ab1ee172a3e8$export$c0ed55f5b8675ea3;
var $0683ab1ee172a3e8$export$c42e2f66c1854fa2 = $0683ab1ee172a3e8$export$a7c8f89377823cb8 * $0683ab1ee172a3e8$export$c0ed55f5b8675ea3;
var $0683ab1ee172a3e8$export$a3d0b9741172e0d2 = $0683ab1ee172a3e8$export$acc6f43ab2895cb5 * $0683ab1ee172a3e8$export$c0ed55f5b8675ea3;
var $0683ab1ee172a3e8$export$3dc01d4e106e904c = $0683ab1ee172a3e8$export$d99925edf30da4be * $0683ab1ee172a3e8$export$c0ed55f5b8675ea3; // English locales
var $0683ab1ee172a3e8$export$71ad59f2e432cfe8 = "millisecond";
var $0683ab1ee172a3e8$export$25ce5a424b770e84 = "second";
var $0683ab1ee172a3e8$export$85fbf3b9d951b785 = "minute";
var $0683ab1ee172a3e8$export$7f8ddf7c7c20b3cd = "hour";
var $0683ab1ee172a3e8$export$96f57966bedc81b4 = "day";
var $0683ab1ee172a3e8$export$71cec2538cb2c617 = "week";
var $0683ab1ee172a3e8$export$3a1a48c8f6ef640e = "month";
var $0683ab1ee172a3e8$export$3722cfe417b6ed86 = "quarter";
var $0683ab1ee172a3e8$export$8743009a87fcb00f = "year";
var $0683ab1ee172a3e8$export$501a7fac1df67a49 = "date";
var $0683ab1ee172a3e8$export$43dfb2cd49ed2315 = "YYYY-MM-DDTHH:mm:ssZ";
var $0683ab1ee172a3e8$export$a3f90fd62b441bc0 = "Invalid Date"; // regex
var $0683ab1ee172a3e8$export$5017033e323668ef = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
var $0683ab1ee172a3e8$export$b72c006c7b334a95 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;


// English [en]
// We don't need weekdaysShort, weekdaysMin, monthsShort in en.js locale
var $627fe5bd28c47eeb$export$2e2bcd8739ae039 = {
    name: "en",
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    ordinal: function ordinal(n) {
        var s = [
            "th",
            "st",
            "nd",
            "rd"
        ];
        var v = n % 100;
        return "[" + n + (s[(v - 20) % 10] || s[v] || s[0]) + "]";
    }
};



var $ce1cac635dd2b371$var$padStart = function padStart(string, length, pad) {
    var s = String(string);
    if (!s || s.length >= length) return string;
    return "" + Array(length + 1 - s.length).join(pad) + string;
};
var $ce1cac635dd2b371$var$padZoneStr = function padZoneStr(instance) {
    var negMinutes = -instance.utcOffset();
    var minutes = Math.abs(negMinutes);
    var hourOffset = Math.floor(minutes / 60);
    var minuteOffset = minutes % 60;
    return "" + (negMinutes <= 0 ? "+" : "-") + $ce1cac635dd2b371$var$padStart(hourOffset, 2, "0") + ":" + $ce1cac635dd2b371$var$padStart(minuteOffset, 2, "0");
};
var $ce1cac635dd2b371$var$monthDiff = function monthDiff(a, b) {
    // function from moment.js in order to keep the same result
    if (a.date() < b.date()) return -monthDiff(b, a);
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month());
    var anchor = a.clone().add(wholeMonthDiff, $0683ab1ee172a3e8$export$3a1a48c8f6ef640e);
    var c = b - anchor < 0;
    var anchor2 = a.clone().add(wholeMonthDiff + (c ? -1 : 1), $0683ab1ee172a3e8$export$3a1a48c8f6ef640e);
    return +(-(wholeMonthDiff + (b - anchor) / (c ? anchor - anchor2 : anchor2 - anchor)) || 0);
};
var $ce1cac635dd2b371$var$absFloor = function absFloor(n) {
    return n < 0 ? Math.ceil(n) || 0 : Math.floor(n);
};
var $ce1cac635dd2b371$var$prettyUnit = function prettyUnit(u) {
    var special = {
        M: $0683ab1ee172a3e8$export$3a1a48c8f6ef640e,
        y: $0683ab1ee172a3e8$export$8743009a87fcb00f,
        w: $0683ab1ee172a3e8$export$71cec2538cb2c617,
        d: $0683ab1ee172a3e8$export$96f57966bedc81b4,
        D: $0683ab1ee172a3e8$export$501a7fac1df67a49,
        h: $0683ab1ee172a3e8$export$7f8ddf7c7c20b3cd,
        m: $0683ab1ee172a3e8$export$85fbf3b9d951b785,
        s: $0683ab1ee172a3e8$export$25ce5a424b770e84,
        ms: $0683ab1ee172a3e8$export$71ad59f2e432cfe8,
        Q: $0683ab1ee172a3e8$export$3722cfe417b6ed86
    };
    return special[u] || String(u || "").toLowerCase().replace(/s$/, "");
};
var $ce1cac635dd2b371$var$isUndefined = function isUndefined(s) {
    return s === undefined;
};
var $ce1cac635dd2b371$export$2e2bcd8739ae039 = {
    s: $ce1cac635dd2b371$var$padStart,
    z: $ce1cac635dd2b371$var$padZoneStr,
    m: $ce1cac635dd2b371$var$monthDiff,
    a: $ce1cac635dd2b371$var$absFloor,
    p: $ce1cac635dd2b371$var$prettyUnit,
    u: $ce1cac635dd2b371$var$isUndefined
};


var $0866737b96521d45$var$L = "en"; // global locale
var $0866737b96521d45$var$Ls = {}; // global loaded locale
$0866737b96521d45$var$Ls[$0866737b96521d45$var$L] = (0, $627fe5bd28c47eeb$export$2e2bcd8739ae039);
var $0866737b96521d45$var$IS_DAYJS = "$isDayjsObject"; // eslint-disable-next-line no-use-before-define
var $0866737b96521d45$var$isDayjs = function isDayjs(d) {
    return d instanceof $0866737b96521d45$var$Dayjs || !!(d && d[$0866737b96521d45$var$IS_DAYJS]);
};
var $0866737b96521d45$var$parseLocale = function parseLocale(preset, object, isLocal) {
    var l;
    if (!preset) return $0866737b96521d45$var$L;
    if (typeof preset === "string") {
        var presetLower = preset.toLowerCase();
        if ($0866737b96521d45$var$Ls[presetLower]) l = presetLower;
        if (object) {
            $0866737b96521d45$var$Ls[presetLower] = object;
            l = presetLower;
        }
        var presetSplit = preset.split("-");
        if (!l && presetSplit.length > 1) return parseLocale(presetSplit[0]);
    } else {
        var name = preset.name;
        $0866737b96521d45$var$Ls[name] = preset;
        l = name;
    }
    if (!isLocal && l) $0866737b96521d45$var$L = l;
    return l || !isLocal && $0866737b96521d45$var$L;
};
var $0866737b96521d45$var$dayjs = function dayjs(date, c) {
    if ($0866737b96521d45$var$isDayjs(date)) return date.clone();
     // eslint-disable-next-line no-nested-ternary
    var cfg = typeof c === "object" ? c : {};
    cfg.date = date;
    cfg.args = arguments; // eslint-disable-line prefer-rest-params
    return new $0866737b96521d45$var$Dayjs(cfg); // eslint-disable-line no-use-before-define
};
var $0866737b96521d45$var$wrapper = function wrapper(date, instance) {
    return $0866737b96521d45$var$dayjs(date, {
        locale: instance.$L,
        utc: instance.$u,
        x: instance.$x,
        $offset: instance.$offset // todo: refactor; do not use this.$offset in you code
    });
};
var $0866737b96521d45$var$Utils = (0, $ce1cac635dd2b371$export$2e2bcd8739ae039); // for plugin use
$0866737b96521d45$var$Utils.l = $0866737b96521d45$var$parseLocale;
$0866737b96521d45$var$Utils.i = $0866737b96521d45$var$isDayjs;
$0866737b96521d45$var$Utils.w = $0866737b96521d45$var$wrapper;
var $0866737b96521d45$var$parseDate = function parseDate(cfg) {
    var date = cfg.date, utc = cfg.utc;
    if (date === null) return new Date(NaN); // null is invalid
    if ($0866737b96521d45$var$Utils.u(date)) return new Date(); // today
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        var d = date.match($0683ab1ee172a3e8$export$5017033e323668ef);
        if (d) {
            var m = d[2] - 1 || 0;
            var ms = (d[7] || "0").substring(0, 3);
            if (utc) return new Date(Date.UTC(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms));
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date); // everything else
};
var $0866737b96521d45$var$Dayjs = /*#__PURE__*/ function() {
    function Dayjs(cfg) {
        this.$L = $0866737b96521d45$var$parseLocale(cfg.locale, null, true);
        this.parse(cfg); // for plugin
        this.$x = this.$x || cfg.x || {};
        this[$0866737b96521d45$var$IS_DAYJS] = true;
    }
    var _proto = Dayjs.prototype;
    _proto.parse = function parse(cfg) {
        this.$d = $0866737b96521d45$var$parseDate(cfg);
        this.init();
    };
    _proto.init = function init() {
        var $d = this.$d;
        this.$y = $d.getFullYear();
        this.$M = $d.getMonth();
        this.$D = $d.getDate();
        this.$W = $d.getDay();
        this.$H = $d.getHours();
        this.$m = $d.getMinutes();
        this.$s = $d.getSeconds();
        this.$ms = $d.getMilliseconds();
    } // eslint-disable-next-line class-methods-use-this
    ;
    _proto.$utils = function $utils() {
        return $0866737b96521d45$var$Utils;
    };
    _proto.isValid = function isValid() {
        return !(this.$d.toString() === $0683ab1ee172a3e8$export$a3f90fd62b441bc0);
    };
    _proto.isSame = function isSame(that, units) {
        var other = $0866737b96521d45$var$dayjs(that);
        return this.startOf(units) <= other && other <= this.endOf(units);
    };
    _proto.isAfter = function isAfter(that, units) {
        return $0866737b96521d45$var$dayjs(that) < this.startOf(units);
    };
    _proto.isBefore = function isBefore(that, units) {
        return this.endOf(units) < $0866737b96521d45$var$dayjs(that);
    };
    _proto.$g = function $g(input, get, set) {
        if ($0866737b96521d45$var$Utils.u(input)) return this[get];
        return this.set(set, input);
    };
    _proto.unix = function unix() {
        return Math.floor(this.valueOf() / 1000);
    };
    _proto.valueOf = function valueOf() {
        // timezone(hour) * 60 * 60 * 1000 => ms
        return this.$d.getTime();
    };
    _proto.startOf = function startOf(units, _startOf) {
        var _this = this;
        // startOf -> endOf
        var isStartOf = !$0866737b96521d45$var$Utils.u(_startOf) ? _startOf : true;
        var unit = $0866737b96521d45$var$Utils.p(units);
        var instanceFactory = function instanceFactory(d, m) {
            var ins = $0866737b96521d45$var$Utils.w(_this.$u ? Date.UTC(_this.$y, m, d) : new Date(_this.$y, m, d), _this);
            return isStartOf ? ins : ins.endOf($0683ab1ee172a3e8$export$96f57966bedc81b4);
        };
        var instanceFactorySet = function instanceFactorySet(method, slice) {
            var argumentStart = [
                0,
                0,
                0,
                0
            ];
            var argumentEnd = [
                23,
                59,
                59,
                999
            ];
            return $0866737b96521d45$var$Utils.w(_this.toDate()[method].apply(_this.toDate("s"), (isStartOf ? argumentStart : argumentEnd).slice(slice)), _this);
        };
        var $W = this.$W, $M = this.$M, $D = this.$D;
        var utcPad = "set" + (this.$u ? "UTC" : "");
        switch(unit){
            case $0683ab1ee172a3e8$export$8743009a87fcb00f:
                return isStartOf ? instanceFactory(1, 0) : instanceFactory(31, 11);
            case $0683ab1ee172a3e8$export$3a1a48c8f6ef640e:
                return isStartOf ? instanceFactory(1, $M) : instanceFactory(0, $M + 1);
            case $0683ab1ee172a3e8$export$71cec2538cb2c617:
                var weekStart = this.$locale().weekStart || 0;
                var gap = ($W < weekStart ? $W + 7 : $W) - weekStart;
                return instanceFactory(isStartOf ? $D - gap : $D + (6 - gap), $M);
            case $0683ab1ee172a3e8$export$96f57966bedc81b4:
            case $0683ab1ee172a3e8$export$501a7fac1df67a49:
                return instanceFactorySet(utcPad + "Hours", 0);
            case $0683ab1ee172a3e8$export$7f8ddf7c7c20b3cd:
                return instanceFactorySet(utcPad + "Minutes", 1);
            case $0683ab1ee172a3e8$export$85fbf3b9d951b785:
                return instanceFactorySet(utcPad + "Seconds", 2);
            case $0683ab1ee172a3e8$export$25ce5a424b770e84:
                return instanceFactorySet(utcPad + "Milliseconds", 3);
            default:
                return this.clone();
        }
    };
    _proto.endOf = function endOf(arg) {
        return this.startOf(arg, false);
    };
    _proto.$set = function $set(units, _int) {
        var _C$D$C$DATE$C$M$C$Y$C;
        // private set
        var unit = $0866737b96521d45$var$Utils.p(units);
        var utcPad = "set" + (this.$u ? "UTC" : "");
        var name = (_C$D$C$DATE$C$M$C$Y$C = {}, _C$D$C$DATE$C$M$C$Y$C[$0683ab1ee172a3e8$export$96f57966bedc81b4] = utcPad + "Date", _C$D$C$DATE$C$M$C$Y$C[$0683ab1ee172a3e8$export$501a7fac1df67a49] = utcPad + "Date", _C$D$C$DATE$C$M$C$Y$C[$0683ab1ee172a3e8$export$3a1a48c8f6ef640e] = utcPad + "Month", _C$D$C$DATE$C$M$C$Y$C[$0683ab1ee172a3e8$export$8743009a87fcb00f] = utcPad + "FullYear", _C$D$C$DATE$C$M$C$Y$C[$0683ab1ee172a3e8$export$7f8ddf7c7c20b3cd] = utcPad + "Hours", _C$D$C$DATE$C$M$C$Y$C[$0683ab1ee172a3e8$export$85fbf3b9d951b785] = utcPad + "Minutes", _C$D$C$DATE$C$M$C$Y$C[$0683ab1ee172a3e8$export$25ce5a424b770e84] = utcPad + "Seconds", _C$D$C$DATE$C$M$C$Y$C[$0683ab1ee172a3e8$export$71ad59f2e432cfe8] = utcPad + "Milliseconds", _C$D$C$DATE$C$M$C$Y$C)[unit];
        var arg = unit === $0683ab1ee172a3e8$export$96f57966bedc81b4 ? this.$D + (_int - this.$W) : _int;
        if (unit === $0683ab1ee172a3e8$export$3a1a48c8f6ef640e || unit === $0683ab1ee172a3e8$export$8743009a87fcb00f) {
            // clone is for badMutable plugin
            var date = this.clone().set($0683ab1ee172a3e8$export$501a7fac1df67a49, 1);
            date.$d[name](arg);
            date.init();
            this.$d = date.set($0683ab1ee172a3e8$export$501a7fac1df67a49, Math.min(this.$D, date.daysInMonth())).$d;
        } else if (name) this.$d[name](arg);
        this.init();
        return this;
    };
    _proto.set = function set(string, _int2) {
        return this.clone().$set(string, _int2);
    };
    _proto.get = function get(unit) {
        return this[$0866737b96521d45$var$Utils.p(unit)]();
    };
    _proto.add = function add(number, units) {
        var _this2 = this, _C$MIN$C$H$C$S$unit;
        number = Number(number); // eslint-disable-line no-param-reassign
        var unit = $0866737b96521d45$var$Utils.p(units);
        var instanceFactorySet = function instanceFactorySet(n) {
            var d = $0866737b96521d45$var$dayjs(_this2);
            return $0866737b96521d45$var$Utils.w(d.date(d.date() + Math.round(n * number)), _this2);
        };
        if (unit === $0683ab1ee172a3e8$export$3a1a48c8f6ef640e) return this.set($0683ab1ee172a3e8$export$3a1a48c8f6ef640e, this.$M + number);
        if (unit === $0683ab1ee172a3e8$export$8743009a87fcb00f) return this.set($0683ab1ee172a3e8$export$8743009a87fcb00f, this.$y + number);
        if (unit === $0683ab1ee172a3e8$export$96f57966bedc81b4) return instanceFactorySet(1);
        if (unit === $0683ab1ee172a3e8$export$71cec2538cb2c617) return instanceFactorySet(7);
        var step = (_C$MIN$C$H$C$S$unit = {}, _C$MIN$C$H$C$S$unit[$0683ab1ee172a3e8$export$85fbf3b9d951b785] = $0683ab1ee172a3e8$export$37971e215480ff4b, _C$MIN$C$H$C$S$unit[$0683ab1ee172a3e8$export$7f8ddf7c7c20b3cd] = $0683ab1ee172a3e8$export$c42e2f66c1854fa2, _C$MIN$C$H$C$S$unit[$0683ab1ee172a3e8$export$25ce5a424b770e84] = $0683ab1ee172a3e8$export$c0ed55f5b8675ea3, _C$MIN$C$H$C$S$unit)[unit] || 1; // ms
        var nextTimeStamp = this.$d.getTime() + number * step;
        return $0866737b96521d45$var$Utils.w(nextTimeStamp, this);
    };
    _proto.subtract = function subtract(number, string) {
        return this.add(number * -1, string);
    };
    _proto.format = function format(formatStr) {
        var _this3 = this;
        var locale = this.$locale();
        if (!this.isValid()) return locale.invalidDate || $0683ab1ee172a3e8$export$a3f90fd62b441bc0;
        var str = formatStr || $0683ab1ee172a3e8$export$43dfb2cd49ed2315;
        var zoneStr = $0866737b96521d45$var$Utils.z(this);
        var $H = this.$H, $m = this.$m, $M = this.$M;
        var weekdays = locale.weekdays, months = locale.months, meridiem = locale.meridiem;
        var getShort = function getShort(arr, index, full, length) {
            return arr && (arr[index] || arr(_this3, str)) || full[index].slice(0, length);
        };
        var get$H = function get$H(num) {
            return $0866737b96521d45$var$Utils.s($H % 12 || 12, num, "0");
        };
        var meridiemFunc = meridiem || function(hour, minute, isLowercase) {
            var m = hour < 12 ? "AM" : "PM";
            return isLowercase ? m.toLowerCase() : m;
        };
        var matches = function matches(match) {
            switch(match){
                case "YY":
                    return String(_this3.$y).slice(-2);
                case "YYYY":
                    return $0866737b96521d45$var$Utils.s(_this3.$y, 4, "0");
                case "M":
                    return $M + 1;
                case "MM":
                    return $0866737b96521d45$var$Utils.s($M + 1, 2, "0");
                case "MMM":
                    return getShort(locale.monthsShort, $M, months, 3);
                case "MMMM":
                    return getShort(months, $M);
                case "D":
                    return _this3.$D;
                case "DD":
                    return $0866737b96521d45$var$Utils.s(_this3.$D, 2, "0");
                case "d":
                    return String(_this3.$W);
                case "dd":
                    return getShort(locale.weekdaysMin, _this3.$W, weekdays, 2);
                case "ddd":
                    return getShort(locale.weekdaysShort, _this3.$W, weekdays, 3);
                case "dddd":
                    return weekdays[_this3.$W];
                case "H":
                    return String($H);
                case "HH":
                    return $0866737b96521d45$var$Utils.s($H, 2, "0");
                case "h":
                    return get$H(1);
                case "hh":
                    return get$H(2);
                case "a":
                    return meridiemFunc($H, $m, true);
                case "A":
                    return meridiemFunc($H, $m, false);
                case "m":
                    return String($m);
                case "mm":
                    return $0866737b96521d45$var$Utils.s($m, 2, "0");
                case "s":
                    return String(_this3.$s);
                case "ss":
                    return $0866737b96521d45$var$Utils.s(_this3.$s, 2, "0");
                case "SSS":
                    return $0866737b96521d45$var$Utils.s(_this3.$ms, 3, "0");
                case "Z":
                    return zoneStr;
                // 'ZZ' logic below
                default:
                    break;
            }
            return null;
        };
        return str.replace($0683ab1ee172a3e8$export$b72c006c7b334a95, function(match, $1) {
            return $1 || matches(match) || zoneStr.replace(":", "");
        }); // 'ZZ'
    };
    _proto.utcOffset = function utcOffset() {
        // Because a bug at FF24, we're rounding the timezone offset around 15 minutes
        // https://github.com/moment/moment/pull/1871
        return -Math.round(this.$d.getTimezoneOffset() / 15) * 15;
    };
    _proto.diff = function diff(input, units, _float) {
        var _this4 = this;
        var unit = $0866737b96521d45$var$Utils.p(units);
        var that = $0866737b96521d45$var$dayjs(input);
        var zoneDelta = (that.utcOffset() - this.utcOffset()) * $0683ab1ee172a3e8$export$37971e215480ff4b;
        var diff = this - that;
        var getMonth = function getMonth() {
            return $0866737b96521d45$var$Utils.m(_this4, that);
        };
        var result;
        switch(unit){
            case $0683ab1ee172a3e8$export$8743009a87fcb00f:
                result = getMonth() / 12;
                break;
            case $0683ab1ee172a3e8$export$3a1a48c8f6ef640e:
                result = getMonth();
                break;
            case $0683ab1ee172a3e8$export$3722cfe417b6ed86:
                result = getMonth() / 3;
                break;
            case $0683ab1ee172a3e8$export$71cec2538cb2c617:
                result = (diff - zoneDelta) / $0683ab1ee172a3e8$export$3dc01d4e106e904c;
                break;
            case $0683ab1ee172a3e8$export$96f57966bedc81b4:
                result = (diff - zoneDelta) / $0683ab1ee172a3e8$export$a3d0b9741172e0d2;
                break;
            case $0683ab1ee172a3e8$export$7f8ddf7c7c20b3cd:
                result = diff / $0683ab1ee172a3e8$export$c42e2f66c1854fa2;
                break;
            case $0683ab1ee172a3e8$export$85fbf3b9d951b785:
                result = diff / $0683ab1ee172a3e8$export$37971e215480ff4b;
                break;
            case $0683ab1ee172a3e8$export$25ce5a424b770e84:
                result = diff / $0683ab1ee172a3e8$export$c0ed55f5b8675ea3;
                break;
            default:
                result = diff; // milliseconds
                break;
        }
        return _float ? result : $0866737b96521d45$var$Utils.a(result);
    };
    _proto.daysInMonth = function daysInMonth() {
        return this.endOf($0683ab1ee172a3e8$export$3a1a48c8f6ef640e).$D;
    };
    _proto.$locale = function $locale() {
        // get locale object
        return $0866737b96521d45$var$Ls[this.$L];
    };
    _proto.locale = function locale(preset, object) {
        if (!preset) return this.$L;
        var that = this.clone();
        var nextLocaleName = $0866737b96521d45$var$parseLocale(preset, object, true);
        if (nextLocaleName) that.$L = nextLocaleName;
        return that;
    };
    _proto.clone = function clone() {
        return $0866737b96521d45$var$Utils.w(this.$d, this);
    };
    _proto.toDate = function toDate() {
        return new Date(this.valueOf());
    };
    _proto.toJSON = function toJSON() {
        return this.isValid() ? this.toISOString() : null;
    };
    _proto.toISOString = function toISOString() {
        // ie 8 return
        // new Dayjs(this.valueOf() + this.$d.getTimezoneOffset() * 60000)
        // .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        return this.$d.toISOString();
    };
    _proto.toString = function toString() {
        return this.$d.toUTCString();
    };
    return Dayjs;
}();
var $0866737b96521d45$var$proto = $0866737b96521d45$var$Dayjs.prototype;
$0866737b96521d45$var$dayjs.prototype = $0866737b96521d45$var$proto;
[
    [
        "$ms",
        $0683ab1ee172a3e8$export$71ad59f2e432cfe8
    ],
    [
        "$s",
        $0683ab1ee172a3e8$export$25ce5a424b770e84
    ],
    [
        "$m",
        $0683ab1ee172a3e8$export$85fbf3b9d951b785
    ],
    [
        "$H",
        $0683ab1ee172a3e8$export$7f8ddf7c7c20b3cd
    ],
    [
        "$W",
        $0683ab1ee172a3e8$export$96f57966bedc81b4
    ],
    [
        "$M",
        $0683ab1ee172a3e8$export$3a1a48c8f6ef640e
    ],
    [
        "$y",
        $0683ab1ee172a3e8$export$8743009a87fcb00f
    ],
    [
        "$D",
        $0683ab1ee172a3e8$export$501a7fac1df67a49
    ]
].forEach(function(g) {
    $0866737b96521d45$var$proto[g[1]] = function(input) {
        return this.$g(input, g[0], g[1]);
    };
});
$0866737b96521d45$var$dayjs.extend = function(plugin, option) {
    if (!plugin.$i) {
        // install plugin only once
        plugin(option, $0866737b96521d45$var$Dayjs, $0866737b96521d45$var$dayjs);
        plugin.$i = true;
    }
    return $0866737b96521d45$var$dayjs;
};
$0866737b96521d45$var$dayjs.locale = $0866737b96521d45$var$parseLocale;
$0866737b96521d45$var$dayjs.isDayjs = $0866737b96521d45$var$isDayjs;
$0866737b96521d45$var$dayjs.unix = function(timestamp) {
    return $0866737b96521d45$var$dayjs(timestamp * 1e3);
};
$0866737b96521d45$var$dayjs.en = $0866737b96521d45$var$Ls[$0866737b96521d45$var$L];
$0866737b96521d45$var$dayjs.Ls = $0866737b96521d45$var$Ls;
$0866737b96521d45$var$dayjs.p = {};
var $0866737b96521d45$export$2e2bcd8739ae039 = $0866737b96521d45$var$dayjs;


// French [fr]

var $574728adf27aa276$var$locale = {
    name: "fr",
    weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
    weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
    weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
    months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
    monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
    weekStart: 1,
    yearStart: 4,
    formats: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
    },
    relativeTime: {
        future: "dans %s",
        past: "il y a %s",
        s: "quelques secondes",
        m: "une minute",
        mm: "%d minutes",
        h: "une heure",
        hh: "%d heures",
        d: "un jour",
        dd: "%d jours",
        M: "un mois",
        MM: "%d mois",
        y: "un an",
        yy: "%d ans"
    },
    ordinal: function ordinal(n) {
        var o = n === 1 ? "er" : "";
        return "" + n + o;
    }
};
(0, $0866737b96521d45$export$2e2bcd8739ae039).locale($574728adf27aa276$var$locale, null, true);
var $574728adf27aa276$export$2e2bcd8739ae039 = $574728adf27aa276$var$locale;



var $iRjZV = parcelRequire("iRjZV");

var $iRjZV = parcelRequire("iRjZV");

var $diMLx = parcelRequire("diMLx");

function $608d98f7ec05ac4b$var$none() {}
function $608d98f7ec05ac4b$export$2e2bcd8739ae039(selector) {
    return selector == null ? $608d98f7ec05ac4b$var$none : function() {
        return this.querySelector(selector);
    };
}


function $39b1fd72f1297745$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $608d98f7ec05ac4b$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $3b803b4beec31c0e$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $75e7204d1f1633ea$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $8b1c9c6bf5977103$var$empty() {
    return [];
}
function $8b1c9c6bf5977103$export$2e2bcd8739ae039(selector) {
    return selector == null ? $8b1c9c6bf5977103$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $a6762ec71be79f46$var$arrayAll(select) {
    return function() {
        return (0, $75e7204d1f1633ea$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $a6762ec71be79f46$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $a6762ec71be79f46$var$arrayAll(select);
    else select = (0, $8b1c9c6bf5977103$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $3b803b4beec31c0e$export$52baac22726c72bf)(subgroups, parents);
}


function $d7097d98b333ca38$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $d7097d98b333ca38$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $dfeac64484de6c88$var$find = Array.prototype.find;
function $dfeac64484de6c88$var$childFind(match) {
    return function() {
        return $dfeac64484de6c88$var$find.call(this.children, match);
    };
}
function $dfeac64484de6c88$var$childFirst() {
    return this.firstElementChild;
}
function $dfeac64484de6c88$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $dfeac64484de6c88$var$childFirst : $dfeac64484de6c88$var$childFind(typeof match === "function" ? match : (0, $d7097d98b333ca38$export$90c2759c036528)(match)));
}



var $7652737258550340$var$filter = Array.prototype.filter;
function $7652737258550340$var$children() {
    return Array.from(this.children);
}
function $7652737258550340$var$childrenFilter(match) {
    return function() {
        return $7652737258550340$var$filter.call(this.children, match);
    };
}
function $7652737258550340$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $7652737258550340$var$children : $7652737258550340$var$childrenFilter(typeof match === "function" ? match : (0, $d7097d98b333ca38$export$90c2759c036528)(match)));
}




function $2741bf2f984698dc$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $d7097d98b333ca38$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $3b803b4beec31c0e$export$52baac22726c72bf)(subgroups, this._parents);
}



function $0a8e81465faa18ff$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $d2a0d8ca0539e45b$export$2e2bcd8739ae039() {
    return new (0, $3b803b4beec31c0e$export$52baac22726c72bf)(this._enter || this._groups.map((0, $0a8e81465faa18ff$export$2e2bcd8739ae039)), this._parents);
}
function $d2a0d8ca0539e45b$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$d2a0d8ca0539e45b$export$67b01759a14cf6a4.prototype = {
    constructor: $d2a0d8ca0539e45b$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $bf5bf7a5db5d80cb$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $f0e651f996aa5bb7$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $d2a0d8ca0539e45b$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $f0e651f996aa5bb7$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $d2a0d8ca0539e45b$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $f0e651f996aa5bb7$var$datum(node) {
    return node.__data__;
}
function $f0e651f996aa5bb7$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $f0e651f996aa5bb7$var$datum);
    var bind = key ? $f0e651f996aa5bb7$var$bindKey : $f0e651f996aa5bb7$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $bf5bf7a5db5d80cb$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $f0e651f996aa5bb7$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $3b803b4beec31c0e$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $f0e651f996aa5bb7$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $6e893f4b4c828123$export$2e2bcd8739ae039() {
    return new (0, $3b803b4beec31c0e$export$52baac22726c72bf)(this._exit || this._groups.map((0, $0a8e81465faa18ff$export$2e2bcd8739ae039)), this._parents);
}


function $d3561876e2bc3c09$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $1abbbc90cac02fe8$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $3b803b4beec31c0e$export$52baac22726c72bf)(merges, this._parents);
}


function $6d71f50b3c5796e4$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $a9ed0797e8fafc77$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $a9ed0797e8fafc77$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $3b803b4beec31c0e$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $a9ed0797e8fafc77$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $5ceeade24bb5af79$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $1ce112260c211b70$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $073494835c50b340$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $bb391c2a1b7f16c3$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $ace364bc04fa6866$export$2e2bcd8739ae039() {
    return !this.node();
}


function $136f4572949a0003$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $e2e7d3985d720e66$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $e2e7d3985d720e66$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $e2e7d3985d720e66$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $e0dc001450f7356e$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $e2e7d3985d720e66$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $e2e7d3985d720e66$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $1ea38f551b1f950e$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $1ea38f551b1f950e$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $1ea38f551b1f950e$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $1ea38f551b1f950e$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $1ea38f551b1f950e$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $1ea38f551b1f950e$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $1ea38f551b1f950e$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $e0dc001450f7356e$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $1ea38f551b1f950e$var$attrRemoveNS : $1ea38f551b1f950e$var$attrRemove : typeof value === "function" ? fullname.local ? $1ea38f551b1f950e$var$attrFunctionNS : $1ea38f551b1f950e$var$attrFunction : fullname.local ? $1ea38f551b1f950e$var$attrConstantNS : $1ea38f551b1f950e$var$attrConstant)(fullname, value));
}


function $a13e1254f87d89d4$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $66c1d9161772feec$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $66c1d9161772feec$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $66c1d9161772feec$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $66c1d9161772feec$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $66c1d9161772feec$var$styleRemove : typeof value === "function" ? $66c1d9161772feec$var$styleFunction : $66c1d9161772feec$var$styleConstant)(name, value, priority == null ? "" : priority)) : $66c1d9161772feec$export$5e3cec964f0b5efd(this.node(), name);
}
function $66c1d9161772feec$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $a13e1254f87d89d4$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $577f8a4f5f87ebf2$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $577f8a4f5f87ebf2$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $577f8a4f5f87ebf2$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $577f8a4f5f87ebf2$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $577f8a4f5f87ebf2$var$propertyRemove : typeof value === "function" ? $577f8a4f5f87ebf2$var$propertyFunction : $577f8a4f5f87ebf2$var$propertyConstant)(name, value)) : this.node()[name];
}


function $2e9ec041f89cc9ff$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $2e9ec041f89cc9ff$var$classList(node) {
    return node.classList || new $2e9ec041f89cc9ff$var$ClassList(node);
}
function $2e9ec041f89cc9ff$var$ClassList(node) {
    this._node = node;
    this._names = $2e9ec041f89cc9ff$var$classArray(node.getAttribute("class") || "");
}
$2e9ec041f89cc9ff$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $2e9ec041f89cc9ff$var$classedAdd(node, names) {
    var list = $2e9ec041f89cc9ff$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $2e9ec041f89cc9ff$var$classedRemove(node, names) {
    var list = $2e9ec041f89cc9ff$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $2e9ec041f89cc9ff$var$classedTrue(names) {
    return function() {
        $2e9ec041f89cc9ff$var$classedAdd(this, names);
    };
}
function $2e9ec041f89cc9ff$var$classedFalse(names) {
    return function() {
        $2e9ec041f89cc9ff$var$classedRemove(this, names);
    };
}
function $2e9ec041f89cc9ff$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $2e9ec041f89cc9ff$var$classedAdd : $2e9ec041f89cc9ff$var$classedRemove)(this, names);
    };
}
function $2e9ec041f89cc9ff$export$2e2bcd8739ae039(name, value) {
    var names = $2e9ec041f89cc9ff$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $2e9ec041f89cc9ff$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $2e9ec041f89cc9ff$var$classedFunction : value ? $2e9ec041f89cc9ff$var$classedTrue : $2e9ec041f89cc9ff$var$classedFalse)(names, value));
}


function $43d9854c3e4432ee$var$textRemove() {
    this.textContent = "";
}
function $43d9854c3e4432ee$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $43d9854c3e4432ee$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $43d9854c3e4432ee$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $43d9854c3e4432ee$var$textRemove : (typeof value === "function" ? $43d9854c3e4432ee$var$textFunction : $43d9854c3e4432ee$var$textConstant)(value)) : this.node().textContent;
}


function $610fdfdf9780560a$var$htmlRemove() {
    this.innerHTML = "";
}
function $610fdfdf9780560a$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $610fdfdf9780560a$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $610fdfdf9780560a$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $610fdfdf9780560a$var$htmlRemove : (typeof value === "function" ? $610fdfdf9780560a$var$htmlFunction : $610fdfdf9780560a$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $92bac5210eadd303$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $92bac5210eadd303$export$2e2bcd8739ae039() {
    return this.each($92bac5210eadd303$var$raise);
}


function $57b947748beeb9cb$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $57b947748beeb9cb$export$2e2bcd8739ae039() {
    return this.each($57b947748beeb9cb$var$lower);
}




function $a13a8014ee3ec5c4$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $e2e7d3985d720e66$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $e2e7d3985d720e66$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $a13a8014ee3ec5c4$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $a13a8014ee3ec5c4$export$2e2bcd8739ae039(name) {
    var fullname = (0, $e0dc001450f7356e$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $a13a8014ee3ec5c4$var$creatorFixed : $a13a8014ee3ec5c4$var$creatorInherit)(fullname);
}


function $80c8b4124c4ffbc6$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $a13a8014ee3ec5c4$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $3af7a2f5ea943374$var$constantNull() {
    return null;
}
function $3af7a2f5ea943374$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $a13a8014ee3ec5c4$export$2e2bcd8739ae039)(name), select = before == null ? $3af7a2f5ea943374$var$constantNull : typeof before === "function" ? before : (0, $608d98f7ec05ac4b$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $c854dd7a6c994d70$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $c854dd7a6c994d70$export$2e2bcd8739ae039() {
    return this.each($c854dd7a6c994d70$var$remove);
}


function $91539e66dba7af4f$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $91539e66dba7af4f$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $91539e66dba7af4f$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $91539e66dba7af4f$var$selection_cloneDeep : $91539e66dba7af4f$var$selection_cloneShallow);
}


function $cf53b1f677f9672b$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $65c5776a69c7f720$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $65c5776a69c7f720$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $65c5776a69c7f720$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $65c5776a69c7f720$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $65c5776a69c7f720$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $65c5776a69c7f720$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $65c5776a69c7f720$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $65c5776a69c7f720$var$onAdd : $65c5776a69c7f720$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $919d47aa7ab63882$var$dispatchEvent(node, type, params) {
    var window = (0, $a13e1254f87d89d4$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $919d47aa7ab63882$var$dispatchConstant(type, params) {
    return function() {
        return $919d47aa7ab63882$var$dispatchEvent(this, type, params);
    };
}
function $919d47aa7ab63882$var$dispatchFunction(type, params) {
    return function() {
        return $919d47aa7ab63882$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $919d47aa7ab63882$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $919d47aa7ab63882$var$dispatchFunction : $919d47aa7ab63882$var$dispatchConstant)(type, params));
}


function* $2cdb00f284ed96a2$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $3b803b4beec31c0e$export$e8e78c978b129247 = [
    null
];
function $3b803b4beec31c0e$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $3b803b4beec31c0e$var$selection() {
    return new $3b803b4beec31c0e$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $3b803b4beec31c0e$export$e8e78c978b129247);
}
function $3b803b4beec31c0e$var$selection_selection() {
    return this;
}
$3b803b4beec31c0e$export$52baac22726c72bf.prototype = $3b803b4beec31c0e$var$selection.prototype = {
    constructor: $3b803b4beec31c0e$export$52baac22726c72bf,
    select: (0, $39b1fd72f1297745$export$2e2bcd8739ae039),
    selectAll: (0, $a6762ec71be79f46$export$2e2bcd8739ae039),
    selectChild: (0, $dfeac64484de6c88$export$2e2bcd8739ae039),
    selectChildren: (0, $7652737258550340$export$2e2bcd8739ae039),
    filter: (0, $2741bf2f984698dc$export$2e2bcd8739ae039),
    data: (0, $f0e651f996aa5bb7$export$2e2bcd8739ae039),
    enter: (0, $d2a0d8ca0539e45b$export$2e2bcd8739ae039),
    exit: (0, $6e893f4b4c828123$export$2e2bcd8739ae039),
    join: (0, $d3561876e2bc3c09$export$2e2bcd8739ae039),
    merge: (0, $1abbbc90cac02fe8$export$2e2bcd8739ae039),
    selection: $3b803b4beec31c0e$var$selection_selection,
    order: (0, $6d71f50b3c5796e4$export$2e2bcd8739ae039),
    sort: (0, $a9ed0797e8fafc77$export$2e2bcd8739ae039),
    call: (0, $5ceeade24bb5af79$export$2e2bcd8739ae039),
    nodes: (0, $1ce112260c211b70$export$2e2bcd8739ae039),
    node: (0, $073494835c50b340$export$2e2bcd8739ae039),
    size: (0, $bb391c2a1b7f16c3$export$2e2bcd8739ae039),
    empty: (0, $ace364bc04fa6866$export$2e2bcd8739ae039),
    each: (0, $136f4572949a0003$export$2e2bcd8739ae039),
    attr: (0, $1ea38f551b1f950e$export$2e2bcd8739ae039),
    style: (0, $66c1d9161772feec$export$2e2bcd8739ae039),
    property: (0, $577f8a4f5f87ebf2$export$2e2bcd8739ae039),
    classed: (0, $2e9ec041f89cc9ff$export$2e2bcd8739ae039),
    text: (0, $43d9854c3e4432ee$export$2e2bcd8739ae039),
    html: (0, $610fdfdf9780560a$export$2e2bcd8739ae039),
    raise: (0, $92bac5210eadd303$export$2e2bcd8739ae039),
    lower: (0, $57b947748beeb9cb$export$2e2bcd8739ae039),
    append: (0, $80c8b4124c4ffbc6$export$2e2bcd8739ae039),
    insert: (0, $3af7a2f5ea943374$export$2e2bcd8739ae039),
    remove: (0, $c854dd7a6c994d70$export$2e2bcd8739ae039),
    clone: (0, $91539e66dba7af4f$export$2e2bcd8739ae039),
    datum: (0, $cf53b1f677f9672b$export$2e2bcd8739ae039),
    on: (0, $65c5776a69c7f720$export$2e2bcd8739ae039),
    dispatch: (0, $919d47aa7ab63882$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $2cdb00f284ed96a2$export$2e2bcd8739ae039)
};
var $3b803b4beec31c0e$export$2e2bcd8739ae039 = $3b803b4beec31c0e$var$selection;


function $5ff8fe1f0e47d54c$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3b803b4beec31c0e$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $3b803b4beec31c0e$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $3b803b4beec31c0e$export$e8e78c978b129247));
}



const $a43bc8a9aed084f0$var$getFullWidth = (elem)=>Math.max(elem.offsetWidth, elem.scrollWidth);
const $a43bc8a9aed084f0$var$getFullHeight = (elem)=>Math.max(elem.offsetHeight, elem.scrollHeight);
const $a43bc8a9aed084f0$var$textNodeFromPoint = (element, x, y)=>{
    const nodes = element.childNodes;
    const range = document.createRange();
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (node.nodeType !== 3) continue;
        range.selectNodeContents(node);
        const rect = range.getBoundingClientRect();
        if (x >= rect.left && y >= rect.top && x <= rect.right && y <= rect.bottom) return node;
    }
    return false;
};
const $a43bc8a9aed084f0$var$clearTextSelection = ()=>{
    const selection = window.getSelection ? window.getSelection() : document.selection;
    if (!selection) return;
    if (selection.removeAllRanges) selection.removeAllRanges();
    else if (selection.empty) selection.empty();
};
const $a43bc8a9aed084f0$var$CLICK_EVENT_THRESHOLD_PX = 5;
class $a43bc8a9aed084f0$export$2e2bcd8739ae039 {
    /**
     * Create ScrollBooster instance
     * @param {Object} options - options object
     * @param {Element} options.viewport - container element
     * @param {Element} options.content - scrollable content element
     * @param {String} options.direction - scroll direction
     * @param {String} options.pointerMode - mouse or touch support
     * @param {String} options.scrollMode - predefined scrolling technique
     * @param {Boolean} options.bounce - bounce effect
     * @param {Number} options.bounceForce - bounce effect factor
     * @param {Number} options.friction - scroll friction factor
     * @param {Boolean} options.textSelection - enables text selection
     * @param {Boolean} options.inputsFocus - enables focus on input elements
     * @param {Boolean} options.emulateScroll - enables mousewheel emulation
     * @param {Function} options.onClick - click handler
     * @param {Function} options.onUpdate - state update handler
     * @param {Function} options.onWheel - wheel handler
     * @param {Function} options.shouldScroll - predicate to allow or disable scroll
     */ constructor(options = {}){
        const defaults = {
            content: options.viewport.children[0],
            direction: "all",
            pointerMode: "all",
            scrollMode: undefined,
            bounce: true,
            bounceForce: 0.1,
            friction: 0.05,
            textSelection: false,
            inputsFocus: true,
            emulateScroll: false,
            preventDefaultOnEmulateScroll: false,
            preventPointerMoveDefault: true,
            lockScrollOnDragDirection: false,
            pointerDownPreventDefault: true,
            dragDirectionTolerance: 40,
            onPointerDown () {},
            onPointerUp () {},
            onPointerMove () {},
            onClick () {},
            onUpdate () {},
            onWheel () {},
            shouldScroll () {
                return true;
            }
        };
        this.props = {
            ...defaults,
            ...options
        };
        if (!this.props.viewport || !(this.props.viewport instanceof Element)) {
            console.error(`ScrollBooster init error: "viewport" config property must be present and must be Element`);
            return;
        }
        if (!this.props.content) {
            console.error(`ScrollBooster init error: Viewport does not have any content`);
            return;
        }
        this.isDragging = false;
        this.isTargetScroll = false;
        this.isScrolling = false;
        this.isRunning = false;
        const START_COORDINATES = {
            x: 0,
            y: 0
        };
        this.position = {
            ...START_COORDINATES
        };
        this.velocity = {
            ...START_COORDINATES
        };
        this.dragStartPosition = {
            ...START_COORDINATES
        };
        this.dragOffset = {
            ...START_COORDINATES
        };
        this.clientOffset = {
            ...START_COORDINATES
        };
        this.dragPosition = {
            ...START_COORDINATES
        };
        this.targetPosition = {
            ...START_COORDINATES
        };
        this.scrollOffset = {
            ...START_COORDINATES
        };
        this.rafID = null;
        this.events = {};
        this.updateMetrics();
        this.handleEvents();
    }
    /**
     * Update options object with new given values
     */ updateOptions(options = {}) {
        this.props = {
            ...this.props,
            ...options
        };
        this.props.onUpdate(this.getState());
        this.startAnimationLoop();
    }
    /**
     * Update DOM container elements metrics (width and height)
     */ updateMetrics() {
        this.viewport = {
            width: this.props.viewport.clientWidth,
            height: this.props.viewport.clientHeight
        };
        this.content = {
            width: $a43bc8a9aed084f0$var$getFullWidth(this.props.content),
            height: $a43bc8a9aed084f0$var$getFullHeight(this.props.content)
        };
        this.edgeX = {
            from: Math.min(-this.content.width + this.viewport.width, 0),
            to: 0
        };
        this.edgeY = {
            from: Math.min(-this.content.height + this.viewport.height, 0),
            to: 0
        };
        this.props.onUpdate(this.getState());
        this.startAnimationLoop();
    }
    /**
     * Run animation loop
     */ startAnimationLoop() {
        this.isRunning = true;
        cancelAnimationFrame(this.rafID);
        this.rafID = requestAnimationFrame(()=>this.animate());
    }
    /**
     * Main animation loop
     */ animate() {
        if (!this.isRunning) return;
        this.updateScrollPosition();
        // stop animation loop if nothing moves
        if (!this.isMoving()) {
            this.isRunning = false;
            this.isTargetScroll = false;
        }
        const state = this.getState();
        this.setContentPosition(state);
        this.props.onUpdate(state);
        this.rafID = requestAnimationFrame(()=>this.animate());
    }
    /**
     * Calculate and set new scroll position
     */ updateScrollPosition() {
        this.applyEdgeForce();
        this.applyDragForce();
        this.applyScrollForce();
        this.applyTargetForce();
        const inverseFriction = 1 - this.props.friction;
        this.velocity.x *= inverseFriction;
        this.velocity.y *= inverseFriction;
        if (this.props.direction !== "vertical") this.position.x += this.velocity.x;
        if (this.props.direction !== "horizontal") this.position.y += this.velocity.y;
        // disable bounce effect
        if ((!this.props.bounce || this.isScrolling) && !this.isTargetScroll) {
            this.position.x = Math.max(Math.min(this.position.x, this.edgeX.to), this.edgeX.from);
            this.position.y = Math.max(Math.min(this.position.y, this.edgeY.to), this.edgeY.from);
        }
    }
    /**
     * Increase general scroll velocity by given force amount
     */ applyForce(force) {
        this.velocity.x += force.x;
        this.velocity.y += force.y;
    }
    /**
     * Apply force for bounce effect
     */ applyEdgeForce() {
        if (!this.props.bounce || this.isDragging) return;
        // scrolled past viewport edges
        const beyondXFrom = this.position.x < this.edgeX.from;
        const beyondXTo = this.position.x > this.edgeX.to;
        const beyondYFrom = this.position.y < this.edgeY.from;
        const beyondYTo = this.position.y > this.edgeY.to;
        const beyondX = beyondXFrom || beyondXTo;
        const beyondY = beyondYFrom || beyondYTo;
        if (!beyondX && !beyondY) return;
        const edge = {
            x: beyondXFrom ? this.edgeX.from : this.edgeX.to,
            y: beyondYFrom ? this.edgeY.from : this.edgeY.to
        };
        const distanceToEdge = {
            x: edge.x - this.position.x,
            y: edge.y - this.position.y
        };
        const force = {
            x: distanceToEdge.x * this.props.bounceForce,
            y: distanceToEdge.y * this.props.bounceForce
        };
        const restPosition = {
            x: this.position.x + (this.velocity.x + force.x) / this.props.friction,
            y: this.position.y + (this.velocity.y + force.y) / this.props.friction
        };
        if (beyondXFrom && restPosition.x >= this.edgeX.from || beyondXTo && restPosition.x <= this.edgeX.to) force.x = distanceToEdge.x * this.props.bounceForce - this.velocity.x;
        if (beyondYFrom && restPosition.y >= this.edgeY.from || beyondYTo && restPosition.y <= this.edgeY.to) force.y = distanceToEdge.y * this.props.bounceForce - this.velocity.y;
        this.applyForce({
            x: beyondX ? force.x : 0,
            y: beyondY ? force.y : 0
        });
    }
    /**
     * Apply force to move content while dragging with mouse/touch
     */ applyDragForce() {
        if (!this.isDragging) return;
        const dragVelocity = {
            x: this.dragPosition.x - this.position.x,
            y: this.dragPosition.y - this.position.y
        };
        this.applyForce({
            x: dragVelocity.x - this.velocity.x,
            y: dragVelocity.y - this.velocity.y
        });
    }
    /**
     * Apply force to emulate mouse wheel or trackpad
     */ applyScrollForce() {
        if (!this.isScrolling) return;
        this.applyForce({
            x: this.scrollOffset.x - this.velocity.x,
            y: this.scrollOffset.y - this.velocity.y
        });
        this.scrollOffset.x = 0;
        this.scrollOffset.y = 0;
    }
    /**
     * Apply force to scroll to given target coordinate
     */ applyTargetForce() {
        if (!this.isTargetScroll) return;
        this.applyForce({
            x: (this.targetPosition.x - this.position.x) * 0.08 - this.velocity.x,
            y: (this.targetPosition.y - this.position.y) * 0.08 - this.velocity.y
        });
    }
    /**
     * Check if scrolling happening
     */ isMoving() {
        return this.isDragging || this.isScrolling || Math.abs(this.velocity.x) >= 0.01 || Math.abs(this.velocity.y) >= 0.01;
    }
    /**
     * Set scroll target coordinate for smooth scroll
     */ scrollTo(position = {}) {
        this.isTargetScroll = true;
        this.targetPosition.x = -position.x || 0;
        this.targetPosition.y = -position.y || 0;
        this.startAnimationLoop();
    }
    /**
     * Manual position setting
     */ setPosition(position = {}) {
        this.velocity.x = 0;
        this.velocity.y = 0;
        this.position.x = -position.x || 0;
        this.position.y = -position.y || 0;
        this.startAnimationLoop();
    }
    /**
     * Get latest metrics and coordinates
     */ getState() {
        return {
            isMoving: this.isMoving(),
            isDragging: !!(this.dragOffset.x || this.dragOffset.y),
            position: {
                x: -this.position.x,
                y: -this.position.y
            },
            dragOffset: this.dragOffset,
            dragAngle: this.getDragAngle(this.clientOffset.x, this.clientOffset.y),
            borderCollision: {
                left: this.position.x >= this.edgeX.to,
                right: this.position.x <= this.edgeX.from,
                top: this.position.y >= this.edgeY.to,
                bottom: this.position.y <= this.edgeY.from
            }
        };
    }
    /**
     * Get drag angle (up: 180, left: -90, right: 90, down: 0)
     */ getDragAngle(x, y) {
        return Math.round(Math.atan2(x, y) * (180 / Math.PI));
    }
    /**
     * Get drag direction (horizontal or vertical)
     */ getDragDirection(angle, tolerance) {
        const absAngle = Math.abs(90 - Math.abs(angle));
        if (absAngle <= 90 - tolerance) return "horizontal";
        else return "vertical";
    }
    /**
     * Update DOM container elements metrics (width and height)
     */ setContentPosition(state) {
        if (this.props.scrollMode === "transform") this.props.content.style.transform = `translate(${-state.position.x}px, ${-state.position.y}px)`;
        if (this.props.scrollMode === "native") {
            this.props.viewport.scrollTop = state.position.y;
            this.props.viewport.scrollLeft = state.position.x;
        }
    }
    /**
     * Register all DOM events
     */ handleEvents() {
        const dragOrigin = {
            x: 0,
            y: 0
        };
        const clientOrigin = {
            x: 0,
            y: 0
        };
        let dragDirection = null;
        let wheelTimer = null;
        let isTouch = false;
        const setDragPosition = (event)=>{
            if (!this.isDragging) return;
            const eventData = isTouch ? event.touches[0] : event;
            const { pageX: pageX, pageY: pageY, clientX: clientX, clientY: clientY } = eventData;
            this.dragOffset.x = pageX - dragOrigin.x;
            this.dragOffset.y = pageY - dragOrigin.y;
            this.clientOffset.x = clientX - clientOrigin.x;
            this.clientOffset.y = clientY - clientOrigin.y;
            // get dragDirection if offset threshold is reached
            if (Math.abs(this.clientOffset.x) > 5 && !dragDirection || Math.abs(this.clientOffset.y) > 5 && !dragDirection) dragDirection = this.getDragDirection(this.getDragAngle(this.clientOffset.x, this.clientOffset.y), this.props.dragDirectionTolerance);
            // prevent scroll if not expected scroll direction
            if (this.props.lockScrollOnDragDirection && this.props.lockScrollOnDragDirection !== "all") {
                if (dragDirection === this.props.lockScrollOnDragDirection && isTouch) {
                    this.dragPosition.x = this.dragStartPosition.x + this.dragOffset.x;
                    this.dragPosition.y = this.dragStartPosition.y + this.dragOffset.y;
                } else if (!isTouch) {
                    this.dragPosition.x = this.dragStartPosition.x + this.dragOffset.x;
                    this.dragPosition.y = this.dragStartPosition.y + this.dragOffset.y;
                } else {
                    this.dragPosition.x = this.dragStartPosition.x;
                    this.dragPosition.y = this.dragStartPosition.y;
                }
            } else {
                this.dragPosition.x = this.dragStartPosition.x + this.dragOffset.x;
                this.dragPosition.y = this.dragStartPosition.y + this.dragOffset.y;
            }
        };
        this.events.pointerdown = (event)=>{
            isTouch = !!(event.touches && event.touches[0]);
            this.props.onPointerDown(this.getState(), event, isTouch);
            const eventData = isTouch ? event.touches[0] : event;
            const { pageX: pageX, pageY: pageY, clientX: clientX, clientY: clientY } = eventData;
            const { viewport: viewport } = this.props;
            const rect = viewport.getBoundingClientRect();
            // click on vertical scrollbar
            if (clientX - rect.left >= viewport.clientLeft + viewport.clientWidth) return;
            // click on horizontal scrollbar
            if (clientY - rect.top >= viewport.clientTop + viewport.clientHeight) return;
            // interaction disabled by user
            if (!this.props.shouldScroll(this.getState(), event)) return;
            // disable right mouse button scroll
            if (event.button === 2) return;
            // disable on mobile
            if (this.props.pointerMode === "mouse" && isTouch) return;
            // disable on desktop
            if (this.props.pointerMode === "touch" && !isTouch) return;
            // focus on form input elements
            const formNodes = [
                "input",
                "textarea",
                "button",
                "select",
                "label"
            ];
            if (this.props.inputsFocus && formNodes.indexOf(event.target.nodeName.toLowerCase()) > -1) return;
            // handle text selection
            if (this.props.textSelection) {
                const textNode = $a43bc8a9aed084f0$var$textNodeFromPoint(event.target, clientX, clientY);
                if (textNode) return;
                $a43bc8a9aed084f0$var$clearTextSelection();
            }
            this.isDragging = true;
            dragOrigin.x = pageX;
            dragOrigin.y = pageY;
            clientOrigin.x = clientX;
            clientOrigin.y = clientY;
            this.dragStartPosition.x = this.position.x;
            this.dragStartPosition.y = this.position.y;
            setDragPosition(event);
            this.startAnimationLoop();
            if (!isTouch && this.props.pointerDownPreventDefault) event.preventDefault();
        };
        this.events.pointermove = (event)=>{
            // prevent default scroll if scroll direction is locked
            if (event.cancelable && (this.props.lockScrollOnDragDirection === "all" || this.props.lockScrollOnDragDirection === dragDirection)) event.preventDefault();
            setDragPosition(event);
            this.props.onPointerMove(this.getState(), event, isTouch);
        };
        this.events.pointerup = (event)=>{
            this.isDragging = false;
            dragDirection = null;
            this.props.onPointerUp(this.getState(), event, isTouch);
        };
        this.events.wheel = (event)=>{
            const state = this.getState();
            if (!this.props.emulateScroll) return;
            this.velocity.x = 0;
            this.velocity.y = 0;
            this.isScrolling = true;
            this.scrollOffset.x = -event.deltaX;
            this.scrollOffset.y = -event.deltaY;
            this.props.onWheel(state, event);
            this.startAnimationLoop();
            clearTimeout(wheelTimer);
            wheelTimer = setTimeout(()=>this.isScrolling = false, 80);
            // get (trackpad) scrollDirection and prevent default events
            if (this.props.preventDefaultOnEmulateScroll && this.getDragDirection(this.getDragAngle(-event.deltaX, -event.deltaY), this.props.dragDirectionTolerance) === this.props.preventDefaultOnEmulateScroll) event.preventDefault();
        };
        this.events.scroll = ()=>{
            const { scrollLeft: scrollLeft, scrollTop: scrollTop } = this.props.viewport;
            if (Math.abs(this.position.x + scrollLeft) > 3) {
                this.position.x = -scrollLeft;
                this.velocity.x = 0;
            }
            if (Math.abs(this.position.y + scrollTop) > 3) {
                this.position.y = -scrollTop;
                this.velocity.y = 0;
            }
        };
        this.events.click = (event)=>{
            const state = this.getState();
            const dragOffsetX = this.props.direction !== "vertical" ? state.dragOffset.x : 0;
            const dragOffsetY = this.props.direction !== "horizontal" ? state.dragOffset.y : 0;
            if (Math.max(Math.abs(dragOffsetX), Math.abs(dragOffsetY)) > $a43bc8a9aed084f0$var$CLICK_EVENT_THRESHOLD_PX) {
                event.preventDefault();
                event.stopPropagation();
            }
            this.props.onClick(state, event, isTouch);
        };
        this.events.contentLoad = ()=>this.updateMetrics();
        this.events.resize = ()=>this.updateMetrics();
        this.props.viewport.addEventListener("mousedown", this.events.pointerdown);
        this.props.viewport.addEventListener("touchstart", this.events.pointerdown, {
            passive: false
        });
        this.props.viewport.addEventListener("click", this.events.click);
        this.props.viewport.addEventListener("wheel", this.events.wheel, {
            passive: false
        });
        this.props.viewport.addEventListener("scroll", this.events.scroll);
        this.props.content.addEventListener("load", this.events.contentLoad, true);
        window.addEventListener("mousemove", this.events.pointermove);
        window.addEventListener("touchmove", this.events.pointermove, {
            passive: false
        });
        window.addEventListener("mouseup", this.events.pointerup);
        window.addEventListener("touchend", this.events.pointerup);
        window.addEventListener("resize", this.events.resize);
    }
    /**
     * Unregister all DOM events
     */ destroy() {
        this.props.viewport.removeEventListener("mousedown", this.events.pointerdown);
        this.props.viewport.removeEventListener("touchstart", this.events.pointerdown);
        this.props.viewport.removeEventListener("click", this.events.click);
        this.props.viewport.removeEventListener("wheel", this.events.wheel);
        this.props.viewport.removeEventListener("scroll", this.events.scroll);
        this.props.content.removeEventListener("load", this.events.contentLoad);
        window.removeEventListener("mousemove", this.events.pointermove);
        window.removeEventListener("touchmove", this.events.pointermove);
        window.removeEventListener("mouseup", this.events.pointerup);
        window.removeEventListener("touchend", this.events.pointerup);
        window.removeEventListener("resize", this.events.resize);
    }
}




function $227417086e98b72e$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $3b803b4beec31c0e$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $3b803b4beec31c0e$export$52baac22726c72bf)([
        (0, $75e7204d1f1633ea$export$2e2bcd8739ae039)(selector)
    ], (0, $3b803b4beec31c0e$export$e8e78c978b129247));
}


function $60bb235caa3bb374$var$responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}
function $60bb235caa3bb374$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($60bb235caa3bb374$var$responseJson);
}



var $847860d1f1297bc0$var$noop = {
    value: ()=>{}
};
function $847860d1f1297bc0$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $847860d1f1297bc0$var$Dispatch(_);
}
function $847860d1f1297bc0$var$Dispatch(_) {
    this._ = _;
}
function $847860d1f1297bc0$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$847860d1f1297bc0$var$Dispatch.prototype = $847860d1f1297bc0$var$dispatch.prototype = {
    constructor: $847860d1f1297bc0$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $847860d1f1297bc0$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $847860d1f1297bc0$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $847860d1f1297bc0$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $847860d1f1297bc0$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $847860d1f1297bc0$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $847860d1f1297bc0$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $847860d1f1297bc0$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $847860d1f1297bc0$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $847860d1f1297bc0$export$2e2bcd8739ae039 = $847860d1f1297bc0$var$dispatch;


var $890794dc445c9dfb$var$frame = 0, $890794dc445c9dfb$var$timeout = 0, $890794dc445c9dfb$var$interval = 0, $890794dc445c9dfb$var$pokeDelay = 1000, $890794dc445c9dfb$var$taskHead, $890794dc445c9dfb$var$taskTail, $890794dc445c9dfb$var$clockLast = 0, $890794dc445c9dfb$var$clockNow = 0, $890794dc445c9dfb$var$clockSkew = 0, $890794dc445c9dfb$var$clock = typeof performance === "object" && performance.now ? performance : Date, $890794dc445c9dfb$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $890794dc445c9dfb$export$461939dd4422153() {
    return $890794dc445c9dfb$var$clockNow || ($890794dc445c9dfb$var$setFrame($890794dc445c9dfb$var$clearNow), $890794dc445c9dfb$var$clockNow = $890794dc445c9dfb$var$clock.now() + $890794dc445c9dfb$var$clockSkew);
}
function $890794dc445c9dfb$var$clearNow() {
    $890794dc445c9dfb$var$clockNow = 0;
}
function $890794dc445c9dfb$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$890794dc445c9dfb$export$c57e9b2d8b9e4de.prototype = $890794dc445c9dfb$export$9dc4ecf953986f04.prototype = {
    constructor: $890794dc445c9dfb$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $890794dc445c9dfb$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $890794dc445c9dfb$var$taskTail !== this) {
            if ($890794dc445c9dfb$var$taskTail) $890794dc445c9dfb$var$taskTail._next = this;
            else $890794dc445c9dfb$var$taskHead = this;
            $890794dc445c9dfb$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $890794dc445c9dfb$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $890794dc445c9dfb$var$sleep();
        }
    }
};
function $890794dc445c9dfb$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $890794dc445c9dfb$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $890794dc445c9dfb$export$d60154c1d7f3990e() {
    $890794dc445c9dfb$export$461939dd4422153(); // Get the current time, if not already set.
    ++$890794dc445c9dfb$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $890794dc445c9dfb$var$taskHead, e;
    while(t){
        if ((e = $890794dc445c9dfb$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$890794dc445c9dfb$var$frame;
}
function $890794dc445c9dfb$var$wake() {
    $890794dc445c9dfb$var$clockNow = ($890794dc445c9dfb$var$clockLast = $890794dc445c9dfb$var$clock.now()) + $890794dc445c9dfb$var$clockSkew;
    $890794dc445c9dfb$var$frame = $890794dc445c9dfb$var$timeout = 0;
    try {
        $890794dc445c9dfb$export$d60154c1d7f3990e();
    } finally{
        $890794dc445c9dfb$var$frame = 0;
        $890794dc445c9dfb$var$nap();
        $890794dc445c9dfb$var$clockNow = 0;
    }
}
function $890794dc445c9dfb$var$poke() {
    var now = $890794dc445c9dfb$var$clock.now(), delay = now - $890794dc445c9dfb$var$clockLast;
    if (delay > $890794dc445c9dfb$var$pokeDelay) $890794dc445c9dfb$var$clockSkew -= delay, $890794dc445c9dfb$var$clockLast = now;
}
function $890794dc445c9dfb$var$nap() {
    var t0, t1 = $890794dc445c9dfb$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $890794dc445c9dfb$var$taskHead = t2;
    }
    $890794dc445c9dfb$var$taskTail = t0;
    $890794dc445c9dfb$var$sleep(time);
}
function $890794dc445c9dfb$var$sleep(time) {
    if ($890794dc445c9dfb$var$frame) return; // Soonest alarm already set, or will be.
    if ($890794dc445c9dfb$var$timeout) $890794dc445c9dfb$var$timeout = clearTimeout($890794dc445c9dfb$var$timeout);
    var delay = time - $890794dc445c9dfb$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $890794dc445c9dfb$var$timeout = setTimeout($890794dc445c9dfb$var$wake, time - $890794dc445c9dfb$var$clock.now() - $890794dc445c9dfb$var$clockSkew);
        if ($890794dc445c9dfb$var$interval) $890794dc445c9dfb$var$interval = clearInterval($890794dc445c9dfb$var$interval);
    } else {
        if (!$890794dc445c9dfb$var$interval) $890794dc445c9dfb$var$clockLast = $890794dc445c9dfb$var$clock.now(), $890794dc445c9dfb$var$interval = setInterval($890794dc445c9dfb$var$poke, $890794dc445c9dfb$var$pokeDelay);
        $890794dc445c9dfb$var$frame = 1, $890794dc445c9dfb$var$setFrame($890794dc445c9dfb$var$wake);
    }
}


function $b1b8b0a8b3749385$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $890794dc445c9dfb$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $6198c10bb9a6f211$var$emptyOn = (0, $847860d1f1297bc0$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $6198c10bb9a6f211$var$emptyTween = [];
var $6198c10bb9a6f211$export$ff39ebd4bb12b718 = 0;
var $6198c10bb9a6f211$export$584530fe98d14a84 = 1;
var $6198c10bb9a6f211$export$a5d151aee16efd42 = 2;
var $6198c10bb9a6f211$export$fb935ab5849a0db9 = 3;
var $6198c10bb9a6f211$export$1573e22b087389af = 4;
var $6198c10bb9a6f211$export$a2e792214ded83b2 = 5;
var $6198c10bb9a6f211$export$9d38167254403955 = 6;
function $6198c10bb9a6f211$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $6198c10bb9a6f211$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $6198c10bb9a6f211$var$emptyOn,
        tween: $6198c10bb9a6f211$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $6198c10bb9a6f211$export$ff39ebd4bb12b718
    });
}
function $6198c10bb9a6f211$export$2cd8252107eb640b(node, id) {
    var schedule = $6198c10bb9a6f211$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $6198c10bb9a6f211$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $6198c10bb9a6f211$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $6198c10bb9a6f211$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $6198c10bb9a6f211$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $6198c10bb9a6f211$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $6198c10bb9a6f211$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $890794dc445c9dfb$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $6198c10bb9a6f211$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $6198c10bb9a6f211$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $6198c10bb9a6f211$export$fb935ab5849a0db9) return (0, $b1b8b0a8b3749385$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $6198c10bb9a6f211$export$1573e22b087389af) {
                o.state = $6198c10bb9a6f211$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $6198c10bb9a6f211$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $b1b8b0a8b3749385$export$2e2bcd8739ae039)(function() {
            if (self.state === $6198c10bb9a6f211$export$fb935ab5849a0db9) {
                self.state = $6198c10bb9a6f211$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $6198c10bb9a6f211$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $6198c10bb9a6f211$export$a5d151aee16efd42) return; // interrupted
        self.state = $6198c10bb9a6f211$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $6198c10bb9a6f211$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $6198c10bb9a6f211$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $6198c10bb9a6f211$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $7442394e3305e892$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $6198c10bb9a6f211$export$a5d151aee16efd42) && schedule.state < (0, $6198c10bb9a6f211$export$a2e792214ded83b2);
        schedule.state = (0, $6198c10bb9a6f211$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $578dbb6375703218$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $7442394e3305e892$export$2e2bcd8739ae039)(this, name);
    });
}



function $ac3b0c5e3926ae68$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}


var $75c2d344f650d897$var$degrees = 180 / Math.PI;
var $75c2d344f650d897$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $75c2d344f650d897$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $75c2d344f650d897$var$degrees,
        skewX: Math.atan(skewX) * $75c2d344f650d897$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $6f2180282247c900$var$svgNode;
function $6f2180282247c900$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $75c2d344f650d897$export$f0954fd7d5368655) : (0, $75c2d344f650d897$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $6f2180282247c900$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $75c2d344f650d897$export$f0954fd7d5368655;
    if (!$6f2180282247c900$var$svgNode) $6f2180282247c900$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $6f2180282247c900$var$svgNode.setAttribute("transform", value);
    if (!(value = $6f2180282247c900$var$svgNode.transform.baseVal.consolidate())) return 0, $75c2d344f650d897$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $75c2d344f650d897$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $51d08f871b2ff717$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $ac3b0c5e3926ae68$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $ac3b0c5e3926ae68$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $ac3b0c5e3926ae68$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $ac3b0c5e3926ae68$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $ac3b0c5e3926ae68$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $ac3b0c5e3926ae68$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $51d08f871b2ff717$export$56bec7123bb3589a = $51d08f871b2ff717$var$interpolateTransform((0, $6f2180282247c900$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $51d08f871b2ff717$export$da8cba906d64c082 = $51d08f871b2ff717$var$interpolateTransform((0, $6f2180282247c900$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $ecad09425c4a3980$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $ecad09425c4a3980$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $ecad09425c4a3980$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $6198c10bb9a6f211$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $ecad09425c4a3980$var$tweenRemove : $ecad09425c4a3980$var$tweenFunction)(id, name, value));
}
function $ecad09425c4a3980$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $6198c10bb9a6f211$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $2J5hC = parcelRequire("2J5hC");

var $2J5hC = parcelRequire("2J5hC");
function $b59fecf407bebb69$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $b59fecf407bebb69$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $b59fecf407bebb69$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $39a21e31500a0170$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $b59fecf407bebb69$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $65101188709d0799$export$2e2bcd8739ae039 = (x)=>()=>x;


function $4002af22563096c3$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $4002af22563096c3$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $4002af22563096c3$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $4002af22563096c3$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $65101188709d0799$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $4002af22563096c3$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $4002af22563096c3$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $4002af22563096c3$var$exponential(a, b, y) : (0, $65101188709d0799$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $4002af22563096c3$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $4002af22563096c3$var$linear(a, d) : (0, $65101188709d0799$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $a7ca389ced30e8e1$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $4002af22563096c3$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $2J5hC.rgb)(start)).r, (end = (0, $2J5hC.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $4002af22563096c3$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $a7ca389ced30e8e1$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $2J5hC.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $a7ca389ced30e8e1$export$2c0e28f2e2852d3f = $a7ca389ced30e8e1$var$rgbSpline((0, $b59fecf407bebb69$export$2e2bcd8739ae039));
var $a7ca389ced30e8e1$export$53d5214f625ccd4c = $a7ca389ced30e8e1$var$rgbSpline((0, $39a21e31500a0170$export$2e2bcd8739ae039));


var $b966638859308bfb$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $b966638859308bfb$var$reB = new RegExp($b966638859308bfb$var$reA.source, "g");
function $b966638859308bfb$var$zero(b) {
    return function() {
        return b;
    };
}
function $b966638859308bfb$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $b966638859308bfb$export$2e2bcd8739ae039(a, b) {
    var bi = $b966638859308bfb$var$reA.lastIndex = $b966638859308bfb$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $b966638859308bfb$var$reA.exec(a)) && (bm = $b966638859308bfb$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $ac3b0c5e3926ae68$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $b966638859308bfb$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $b966638859308bfb$var$one(q[0].x) : $b966638859308bfb$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}


function $36c6d5bc72a1e51c$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $ac3b0c5e3926ae68$export$2e2bcd8739ae039) : b instanceof (0, $2J5hC.default) ? (0, $a7ca389ced30e8e1$export$2e2bcd8739ae039) : (c = (0, $2J5hC.default)(b)) ? (b = c, $a7ca389ced30e8e1$export$2e2bcd8739ae039) : (0, $b966638859308bfb$export$2e2bcd8739ae039))(a, b);
}


function $4a7357d1f902810c$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $4a7357d1f902810c$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $4a7357d1f902810c$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $4a7357d1f902810c$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $4a7357d1f902810c$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $4a7357d1f902810c$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $4a7357d1f902810c$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $e0dc001450f7356e$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $51d08f871b2ff717$export$da8cba906d64c082) : (0, $36c6d5bc72a1e51c$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $4a7357d1f902810c$var$attrFunctionNS : $4a7357d1f902810c$var$attrFunction)(fullname, i, (0, $ecad09425c4a3980$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $4a7357d1f902810c$var$attrRemoveNS : $4a7357d1f902810c$var$attrRemove)(fullname) : (fullname.local ? $4a7357d1f902810c$var$attrConstantNS : $4a7357d1f902810c$var$attrConstant)(fullname, i, value));
}



function $0f0c242077ed259a$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $0f0c242077ed259a$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $0f0c242077ed259a$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $0f0c242077ed259a$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $0f0c242077ed259a$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $0f0c242077ed259a$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $0f0c242077ed259a$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $e0dc001450f7356e$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $0f0c242077ed259a$var$attrTweenNS : $0f0c242077ed259a$var$attrTween)(fullname, value));
}



function $66998c7ea8725a4b$var$delayFunction(id, value) {
    return function() {
        (0, $6198c10bb9a6f211$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $66998c7ea8725a4b$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $6198c10bb9a6f211$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $66998c7ea8725a4b$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $66998c7ea8725a4b$var$delayFunction : $66998c7ea8725a4b$var$delayConstant)(id, value)) : (0, $6198c10bb9a6f211$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $97b883cdc3d569f2$var$durationFunction(id, value) {
    return function() {
        (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $97b883cdc3d569f2$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $97b883cdc3d569f2$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $97b883cdc3d569f2$var$durationFunction : $97b883cdc3d569f2$var$durationConstant)(id, value)) : (0, $6198c10bb9a6f211$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $cf071155d082d28d$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $cf071155d082d28d$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($cf071155d082d28d$var$easeConstant(id, value)) : (0, $6198c10bb9a6f211$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $1863095b3ecdd818$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $1863095b3ecdd818$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($1863095b3ecdd818$var$easeVarying(this._id, value));
}




function $d22ff96b05a6651e$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $d7097d98b333ca38$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $9caa4253ba1c6b05$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $4d997dd9bdfef868$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $9caa4253ba1c6b05$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $4ff1f4ba7610fa0c$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $4ff1f4ba7610fa0c$var$onFunction(id, name, listener) {
    var on0, on1, sit = $4ff1f4ba7610fa0c$var$start(name) ? (0, $6198c10bb9a6f211$export$2cd8252107eb640b) : (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $4ff1f4ba7610fa0c$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $6198c10bb9a6f211$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($4ff1f4ba7610fa0c$var$onFunction(id, name, listener));
}


function $55a2540bb56ce7e7$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $55a2540bb56ce7e7$export$2e2bcd8739ae039() {
    return this.on("end.remove", $55a2540bb56ce7e7$var$removeFunction(this._id));
}





function $d2c352e629721fc9$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $608d98f7ec05ac4b$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $6198c10bb9a6f211$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $6198c10bb9a6f211$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $9caa4253ba1c6b05$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $44fb2e5f64a85398$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $8b1c9c6bf5977103$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $6198c10bb9a6f211$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $6198c10bb9a6f211$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $9caa4253ba1c6b05$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $56a24c0cbee33b6b$var$Selection = (0, $3b803b4beec31c0e$export$2e2bcd8739ae039).prototype.constructor;
function $56a24c0cbee33b6b$export$2e2bcd8739ae039() {
    return new $56a24c0cbee33b6b$var$Selection(this._groups, this._parents);
}







function $e01b6fceb677ab9e$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $66c1d9161772feec$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $66c1d9161772feec$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $e01b6fceb677ab9e$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $e01b6fceb677ab9e$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $66c1d9161772feec$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $e01b6fceb677ab9e$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $66c1d9161772feec$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $66c1d9161772feec$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $e01b6fceb677ab9e$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $e01b6fceb677ab9e$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $e01b6fceb677ab9e$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $51d08f871b2ff717$export$56bec7123bb3589a) : (0, $36c6d5bc72a1e51c$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $e01b6fceb677ab9e$var$styleNull(name, i)).on("end.style." + name, $e01b6fceb677ab9e$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $e01b6fceb677ab9e$var$styleFunction(name, i, (0, $ecad09425c4a3980$export$f78ce6ab10405d82)(this, "style." + name, value))).each($e01b6fceb677ab9e$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $e01b6fceb677ab9e$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $f2b6fcb2f56917e9$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $f2b6fcb2f56917e9$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $f2b6fcb2f56917e9$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $f2b6fcb2f56917e9$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $f2b6fcb2f56917e9$var$styleTween(name, value, priority == null ? "" : priority));
}



function $1c3783601ea9d0a4$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $1c3783601ea9d0a4$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $1c3783601ea9d0a4$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $1c3783601ea9d0a4$var$textFunction((0, $ecad09425c4a3980$export$f78ce6ab10405d82)(this, "text", value)) : $1c3783601ea9d0a4$var$textConstant(value == null ? "" : value + ""));
}


function $15488c77ad72cb24$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $15488c77ad72cb24$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $15488c77ad72cb24$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $15488c77ad72cb24$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $15488c77ad72cb24$var$textTween(value));
}




function $5a531772e680179c$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $9caa4253ba1c6b05$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $6198c10bb9a6f211$export$3988ae62b71be9a3)(node, id0);
            (0, $6198c10bb9a6f211$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $9caa4253ba1c6b05$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $9ef3817479de927b$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $6198c10bb9a6f211$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $9caa4253ba1c6b05$var$id = 0;
function $9caa4253ba1c6b05$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $9caa4253ba1c6b05$export$2e2bcd8739ae039(name) {
    return (0, $3b803b4beec31c0e$export$2e2bcd8739ae039)().transition(name);
}
function $9caa4253ba1c6b05$export$9ffd10a3fbdc175b() {
    return ++$9caa4253ba1c6b05$var$id;
}
var $9caa4253ba1c6b05$var$selection_prototype = (0, $3b803b4beec31c0e$export$2e2bcd8739ae039).prototype;
$9caa4253ba1c6b05$export$be58926105124dd4.prototype = $9caa4253ba1c6b05$export$2e2bcd8739ae039.prototype = {
    constructor: $9caa4253ba1c6b05$export$be58926105124dd4,
    select: (0, $d2c352e629721fc9$export$2e2bcd8739ae039),
    selectAll: (0, $44fb2e5f64a85398$export$2e2bcd8739ae039),
    selectChild: $9caa4253ba1c6b05$var$selection_prototype.selectChild,
    selectChildren: $9caa4253ba1c6b05$var$selection_prototype.selectChildren,
    filter: (0, $d22ff96b05a6651e$export$2e2bcd8739ae039),
    merge: (0, $4d997dd9bdfef868$export$2e2bcd8739ae039),
    selection: (0, $56a24c0cbee33b6b$export$2e2bcd8739ae039),
    transition: (0, $5a531772e680179c$export$2e2bcd8739ae039),
    call: $9caa4253ba1c6b05$var$selection_prototype.call,
    nodes: $9caa4253ba1c6b05$var$selection_prototype.nodes,
    node: $9caa4253ba1c6b05$var$selection_prototype.node,
    size: $9caa4253ba1c6b05$var$selection_prototype.size,
    empty: $9caa4253ba1c6b05$var$selection_prototype.empty,
    each: $9caa4253ba1c6b05$var$selection_prototype.each,
    on: (0, $4ff1f4ba7610fa0c$export$2e2bcd8739ae039),
    attr: (0, $4a7357d1f902810c$export$2e2bcd8739ae039),
    attrTween: (0, $0f0c242077ed259a$export$2e2bcd8739ae039),
    style: (0, $e01b6fceb677ab9e$export$2e2bcd8739ae039),
    styleTween: (0, $f2b6fcb2f56917e9$export$2e2bcd8739ae039),
    text: (0, $1c3783601ea9d0a4$export$2e2bcd8739ae039),
    textTween: (0, $15488c77ad72cb24$export$2e2bcd8739ae039),
    remove: (0, $55a2540bb56ce7e7$export$2e2bcd8739ae039),
    tween: (0, $ecad09425c4a3980$export$2e2bcd8739ae039),
    delay: (0, $66998c7ea8725a4b$export$2e2bcd8739ae039),
    duration: (0, $97b883cdc3d569f2$export$2e2bcd8739ae039),
    ease: (0, $cf071155d082d28d$export$2e2bcd8739ae039),
    easeVarying: (0, $1863095b3ecdd818$export$2e2bcd8739ae039),
    end: (0, $9ef3817479de927b$export$2e2bcd8739ae039),
    [Symbol.iterator]: $9caa4253ba1c6b05$var$selection_prototype[Symbol.iterator]
};



function $00daf663a05550a8$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $00daf663a05550a8$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $00daf663a05550a8$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $1508ab7120938eca$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $00daf663a05550a8$export$89238d3bc79d3ada)
};
function $1508ab7120938eca$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $1508ab7120938eca$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $9caa4253ba1c6b05$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $9caa4253ba1c6b05$export$9ffd10a3fbdc175b)(), (timing = $1508ab7120938eca$var$defaultTiming).time = (0, $890794dc445c9dfb$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $6198c10bb9a6f211$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $1508ab7120938eca$var$inherit(node, id));
    }
    return new (0, $9caa4253ba1c6b05$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $3b803b4beec31c0e$export$2e2bcd8739ae039).prototype.interrupt = (0, $578dbb6375703218$export$2e2bcd8739ae039);
(0, $3b803b4beec31c0e$export$2e2bcd8739ae039).prototype.transition = (0, $1508ab7120938eca$export$2e2bcd8739ae039);









var $ca9ad = parcelRequire("ca9ad");

var $iRjZV = parcelRequire("iRjZV");

var $diMLx = parcelRequire("diMLx");

var $am1Dn = parcelRequire("am1Dn");
// import * as d3 from "d3";

var $3f48690703eba119$exports = {};
$3f48690703eba119$exports = JSON.parse('{"name":"leaflet","version":"1.9.4","homepage":"https://leafletjs.com/","description":"JavaScript library for mobile-friendly interactive maps","devDependencies":{"@mapbox/eslint-plugin-script-tags":"^1.0.0","@rollup/plugin-json":"^4.1.0","bundlemon":"^1.4.0","eslint":"^8.23.0","eslint-config-mourner":"^2.0.3","git-rev-sync":"^3.0.2","happen":"~0.3.2","husky":"^8.0.1","karma":"^6.4.0","karma-chrome-launcher":"^3.1.1","karma-edge-launcher":"^0.4.2","karma-expect":"^1.1.3","karma-firefox-launcher":"^2.1.2","karma-ie-launcher":"^1.0.0","karma-mocha":"^2.0.1","karma-rollup-preprocessor":"^7.0.8","karma-safari-launcher":"~1.0.0","karma-sinon":"^1.0.5","leafdoc":"^2.3.0","lint-staged":"^13.0.3","mocha":"^9.2.2","prosthetic-hand":"^1.4.0","rollup":"^2.78.1","rollup-plugin-git-version":"^0.3.1","sinon":"^7.5.0","ssri":"^9.0.1","uglify-js":"^3.17.0"},"main":"dist/leaflet-src.js","style":"dist/leaflet.css","files":["dist","src","!dist/leaflet.zip","!*.leafdoc","CHANGELOG.md"],"scripts":{"docs":"node ./build/docs.js && node ./build/integrity.js","test":"karma start ./spec/karma.conf.js","build":"npm run rollup && npm run uglify","lint":"eslint .","lintfix":"npm run lint -- --fix","rollup":"rollup -c build/rollup-config.js","watch":"rollup -w -c build/rollup-config.js","uglify":"uglifyjs dist/leaflet-src.js -c -m -o dist/leaflet.js --source-map filename=dist/leaflet.js.map --source-map content=dist/leaflet-src.js.map --source-map url=leaflet.js.map --comments","bundlemon":"bundlemon --subProject js --defaultCompression none && bundlemon --subProject js-gzip --defaultCompression gzip","serve":"cd docs && bundle exec jekyll serve","prepare":"husky install"},"eslintConfig":{"ignorePatterns":["dist","debug","docs/docs/highlight","docs/examples/choropleth/us-states.js","docs/examples/geojson/sample-geojson.js","docs/examples/map-panes/eu-countries.js","docs/examples/extending/extending-2-layers.md","docs/_posts/2012*","docs/_site","build/integrity.js"],"root":true,"env":{"commonjs":true,"amd":true,"node":false},"extends":"mourner","plugins":["@mapbox/eslint-plugin-script-tags"],"parserOptions":{"ecmaVersion":6,"sourceType":"module"},"rules":{"linebreak-style":[0,"unix"],"no-mixed-spaces-and-tabs":[2,"smart-tabs"],"indent":[2,"tab",{"VariableDeclarator":0,"flatTernaryExpressions":true}],"curly":2,"spaced-comment":2,"strict":0,"wrap-iife":0,"key-spacing":0,"consistent-return":0,"no-unused-expressions":["error",{"allowShortCircuit":true}]},"overrides":[{"files":["build/**/*"],"env":{"node":true},"rules":{"global-require":0}},{"files":["*.md"],"rules":{"eol-last":0,"no-unused-vars":0}}]},"repository":{"type":"git","url":"git://github.com/Leaflet/Leaflet.git"},"keywords":["gis","map"],"license":"BSD-2-Clause","lint-staged":{"*.(js|md)":"eslint --cache --fix"}}');


/*
 * @namespace Util
 *
 * Various utility functions, used by Leaflet internally.
 */ // @function extend(dest: Object, src?: Object): Object
// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
function $78a895d83da22602$export$8b58be045bf06082(dest) {
    var i, j, len, src;
    for(j = 1, len = arguments.length; j < len; j++){
        src = arguments[j];
        for(i in src)dest[i] = src[i];
    }
    return dest;
}
var $78a895d83da22602$export$185802fd694ee1f5 = Object.create || function() {
    function F() {}
    return function(proto) {
        F.prototype = proto;
        return new F();
    };
}();
function $78a895d83da22602$export$2385a24977818dd0(fn, obj) {
    var slice = Array.prototype.slice;
    if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
    var args = slice.call(arguments, 2);
    return function() {
        return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
    };
}
var $78a895d83da22602$export$be5d847186e3cff2 = 0;
function $78a895d83da22602$export$bd3fba034e28f6b(obj) {
    if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++$78a895d83da22602$export$be5d847186e3cff2;
    return obj._leaflet_id;
}
function $78a895d83da22602$export$de363e709c412c8a(fn, time, context) {
    var lock, args, wrapperFn, later;
    later = function() {
        // reset lock and call if queued
        lock = false;
        if (args) {
            wrapperFn.apply(context, args);
            args = false;
        }
    };
    wrapperFn = function() {
        if (lock) // called too soon, queue to call later
        args = arguments;
        else {
            // call and lock until later
            fn.apply(context, arguments);
            setTimeout(later, time);
            lock = true;
        }
    };
    return wrapperFn;
}
function $78a895d83da22602$export$f6cd9682189b118b(x, range, includeMax) {
    var max = range[1], min = range[0], d = max - min;
    return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
}
function $78a895d83da22602$export$a3891e81a74c5e40() {
    return false;
}
function $78a895d83da22602$export$533e61f4ff7f35ce(num, precision) {
    if (precision === false) return num;
    var pow = Math.pow(10, precision === undefined ? 6 : precision);
    return Math.round(num * pow) / pow;
}
function $78a895d83da22602$export$87c2784dc9fc4ab(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function $78a895d83da22602$export$3ea6d3c1e1f67aaa(str) {
    return $78a895d83da22602$export$87c2784dc9fc4ab(str).split(/\s+/);
}
function $78a895d83da22602$export$add91eafeaeab287(obj, options) {
    if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? $78a895d83da22602$export$185802fd694ee1f5(obj.options) : {};
    for(var i in options)obj.options[i] = options[i];
    return obj.options;
}
function $78a895d83da22602$export$27213b73b2075e98(obj, existingUrl, uppercase) {
    var params = [];
    for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
    return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
}
var $78a895d83da22602$var$templateRe = /\{ *([\w_ -]+) *\}/g;
function $78a895d83da22602$export$ce69bd05624d0c48(str, data) {
    return str.replace($78a895d83da22602$var$templateRe, function(str, key) {
        var value = data[key];
        if (value === undefined) throw new Error("No value provided for variable " + str);
        else if (typeof value === "function") value = value(data);
        return value;
    });
}
var $78a895d83da22602$export$43bee75e5e14138e = Array.isArray || function(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
};
function $78a895d83da22602$export$305f7d4e9d4624f2(array, el) {
    for(var i = 0; i < array.length; i++){
        if (array[i] === el) return i;
    }
    return -1;
}
var $78a895d83da22602$export$993f7e5c731d5268 = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
// inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
function $78a895d83da22602$var$getPrefixed(name) {
    return window["webkit" + name] || window["moz" + name] || window["ms" + name];
}
var $78a895d83da22602$var$lastTime = 0;
// fallback for IE 7-8
function $78a895d83da22602$var$timeoutDefer(fn) {
    var time = +new Date(), timeToCall = Math.max(0, 16 - (time - $78a895d83da22602$var$lastTime));
    $78a895d83da22602$var$lastTime = time + timeToCall;
    return window.setTimeout(fn, timeToCall);
}
var $78a895d83da22602$export$2d6f2967c7dddd06 = window.requestAnimationFrame || $78a895d83da22602$var$getPrefixed("RequestAnimationFrame") || $78a895d83da22602$var$timeoutDefer;
var $78a895d83da22602$export$e76ec94050cfc5fa = window.cancelAnimationFrame || $78a895d83da22602$var$getPrefixed("CancelAnimationFrame") || $78a895d83da22602$var$getPrefixed("CancelRequestAnimationFrame") || function(id) {
    window.clearTimeout(id);
};
function $78a895d83da22602$export$d371ad015c199c06(fn, context, immediate) {
    if (immediate && $78a895d83da22602$export$2d6f2967c7dddd06 === $78a895d83da22602$var$timeoutDefer) fn.call(context);
    else return $78a895d83da22602$export$2d6f2967c7dddd06.call(window, $78a895d83da22602$export$2385a24977818dd0(fn, context));
}
function $78a895d83da22602$export$e1ed83507f55dc9d(id) {
    if (id) $78a895d83da22602$export$e76ec94050cfc5fa.call(window, id);
}


function $a5dc067f35738c55$export$4c85e640eb41c31b() {}
$a5dc067f35738c55$export$4c85e640eb41c31b.extend = function(props) {
    // @function extend(props: Object): Function
    // [Extends the current class](#class-inheritance) given the properties to be included.
    // Returns a Javascript function that is a class constructor (to be called with `new`).
    var NewClass = function() {
        $78a895d83da22602$export$add91eafeaeab287(this);
        // call the constructor
        if (this.initialize) this.initialize.apply(this, arguments);
        // call all constructor hooks
        this.callInitHooks();
    };
    var parentProto = NewClass.__super__ = this.prototype;
    var proto = $78a895d83da22602$export$185802fd694ee1f5(parentProto);
    proto.constructor = NewClass;
    NewClass.prototype = proto;
    // inherit parent's statics
    for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
    // mix static properties into the class
    if (props.statics) $78a895d83da22602$export$8b58be045bf06082(NewClass, props.statics);
    // mix includes into the prototype
    if (props.includes) {
        $a5dc067f35738c55$var$checkDeprecatedMixinEvents(props.includes);
        $78a895d83da22602$export$8b58be045bf06082.apply(null, [
            proto
        ].concat(props.includes));
    }
    // mix given properties into the prototype
    $78a895d83da22602$export$8b58be045bf06082(proto, props);
    delete proto.statics;
    delete proto.includes;
    // merge options
    if (proto.options) {
        proto.options = parentProto.options ? $78a895d83da22602$export$185802fd694ee1f5(parentProto.options) : {};
        $78a895d83da22602$export$8b58be045bf06082(proto.options, props.options);
    }
    proto._initHooks = [];
    // add method for calling all hooks
    proto.callInitHooks = function() {
        if (this._initHooksCalled) return;
        if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
        this._initHooksCalled = true;
        for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
    };
    return NewClass;
};
// @function include(properties: Object): this
// [Includes a mixin](#class-includes) into the current class.
$a5dc067f35738c55$export$4c85e640eb41c31b.include = function(props) {
    var parentOptions = this.prototype.options;
    $78a895d83da22602$export$8b58be045bf06082(this.prototype, props);
    if (props.options) {
        this.prototype.options = parentOptions;
        this.mergeOptions(props.options);
    }
    return this;
};
// @function mergeOptions(options: Object): this
// [Merges `options`](#class-options) into the defaults of the class.
$a5dc067f35738c55$export$4c85e640eb41c31b.mergeOptions = function(options) {
    $78a895d83da22602$export$8b58be045bf06082(this.prototype.options, options);
    return this;
};
// @function addInitHook(fn: Function): this
// Adds a [constructor hook](#class-constructor-hooks) to the class.
$a5dc067f35738c55$export$4c85e640eb41c31b.addInitHook = function(fn) {
    var args = Array.prototype.slice.call(arguments, 1);
    var init = typeof fn === "function" ? fn : function() {
        this[fn].apply(this, args);
    };
    this.prototype._initHooks = this.prototype._initHooks || [];
    this.prototype._initHooks.push(init);
    return this;
};
function $a5dc067f35738c55$var$checkDeprecatedMixinEvents(includes) {
    /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
    includes = $78a895d83da22602$export$43bee75e5e14138e(includes) ? includes : [
        includes
    ];
    for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
}





var $8d0e67ac3b8042d8$export$ada873a34909da65 = {
    /* @method on(type: String, fn: Function, context?: Object): this
	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	 *
	 * @alternative
	 * @method on(eventMap: Object): this
	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	 */ on: function(types, fn, context) {
        // types can be a map of types/handlers
        if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
        // it's a hot path since Layer uses the on(obj) syntax
        this._on(type, types[type], fn);
        else {
            // types can be a string of space-separated words
            types = $78a895d83da22602$export$3ea6d3c1e1f67aaa(types);
            for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
        }
        return this;
    },
    /* @method off(type: String, fn?: Function, context?: Object): this
	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	 *
	 * @alternative
	 * @method off(eventMap: Object): this
	 * Removes a set of type/listener pairs.
	 *
	 * @alternative
	 * @method off: this
	 * Removes all listeners to all events on the object. This includes implicitly attached events.
	 */ off: function(types, fn, context) {
        if (!arguments.length) // clear all listeners if called without arguments
        delete this._events;
        else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
        else {
            types = $78a895d83da22602$export$3ea6d3c1e1f67aaa(types);
            var removeAll = arguments.length === 1;
            for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
            else this._off(types[i], fn, context);
        }
        return this;
    },
    // attach listener (without syntactic sugar now)
    _on: function(type, fn, context, _once) {
        if (typeof fn !== "function") {
            console.warn("wrong listener type: " + typeof fn);
            return;
        }
        // check if fn already there
        if (this._listens(type, fn, context) !== false) return;
        if (context === this) // Less memory footprint.
        context = undefined;
        var newListener = {
            fn: fn,
            ctx: context
        };
        if (_once) newListener.once = true;
        this._events = this._events || {};
        this._events[type] = this._events[type] || [];
        this._events[type].push(newListener);
    },
    _off: function(type, fn, context) {
        var listeners, i, len;
        if (!this._events) return;
        listeners = this._events[type];
        if (!listeners) return;
        if (arguments.length === 1) {
            if (this._firingCount) // Set all removed listeners to noop
            // so they are not called if remove happens in fire
            for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = $78a895d83da22602$export$a3891e81a74c5e40;
            // clear all listeners for a type if function isn't specified
            delete this._events[type];
            return;
        }
        if (typeof fn !== "function") {
            console.warn("wrong listener type: " + typeof fn);
            return;
        }
        // find fn and remove it
        var index = this._listens(type, fn, context);
        if (index !== false) {
            var listener = listeners[index];
            if (this._firingCount) {
                // set the removed listener to noop so that's not called if remove happens in fire
                listener.fn = $78a895d83da22602$export$a3891e81a74c5e40;
                /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
            }
            listeners.splice(index, 1);
        }
    },
    // @method fire(type: String, data?: Object, propagate?: Boolean): this
    // Fires an event of the specified type. You can optionally provide a data
    // object — the first argument of the listener function will contain its
    // properties. The event can optionally be propagated to event parents.
    fire: function(type, data, propagate) {
        if (!this.listens(type, propagate)) return this;
        var event = $78a895d83da22602$export$8b58be045bf06082({}, data, {
            type: type,
            target: this,
            sourceTarget: data && data.sourceTarget || this
        });
        if (this._events) {
            var listeners = this._events[type];
            if (listeners) {
                this._firingCount = this._firingCount + 1 || 1;
                for(var i = 0, len = listeners.length; i < len; i++){
                    var l = listeners[i];
                    // off overwrites l.fn, so we need to copy fn to a var
                    var fn = l.fn;
                    if (l.once) this.off(type, fn, l.ctx);
                    fn.call(l.ctx || this, event);
                }
                this._firingCount--;
            }
        }
        if (propagate) // propagate the event to parents (set with addEventParent)
        this._propagateEvent(event);
        return this;
    },
    // @method listens(type: String, propagate?: Boolean): Boolean
    // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
    // Returns `true` if a particular event type has any listeners attached to it.
    // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
    listens: function(type, fn, context, propagate) {
        if (typeof type !== "string") console.warn('"string" type argument expected');
        // we don't overwrite the input `fn` value, because we need to use it for propagation
        var _fn = fn;
        if (typeof fn !== "function") {
            propagate = !!fn;
            _fn = undefined;
            context = undefined;
        }
        var listeners = this._events && this._events[type];
        if (listeners && listeners.length) {
            if (this._listens(type, _fn, context) !== false) return true;
        }
        if (propagate) // also check parents for listeners if event propagates
        for(var id in this._eventParents){
            if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
        }
        return false;
    },
    // returns the index (number) or false
    _listens: function(type, fn, context) {
        if (!this._events) return false;
        var listeners = this._events[type] || [];
        if (!fn) return !!listeners.length;
        if (context === this) // Less memory footprint.
        context = undefined;
        for(var i = 0, len = listeners.length; i < len; i++){
            if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
        }
        return false;
    },
    // @method once(…): this
    // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
    once: function(types, fn, context) {
        // types can be a map of types/handlers
        if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
        // it's a hot path since Layer uses the on(obj) syntax
        this._on(type, types[type], fn, true);
        else {
            // types can be a string of space-separated words
            types = $78a895d83da22602$export$3ea6d3c1e1f67aaa(types);
            for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
        }
        return this;
    },
    // @method addEventParent(obj: Evented): this
    // Adds an event parent - an `Evented` that will receive propagated events
    addEventParent: function(obj) {
        this._eventParents = this._eventParents || {};
        this._eventParents[$78a895d83da22602$export$bd3fba034e28f6b(obj)] = obj;
        return this;
    },
    // @method removeEventParent(obj: Evented): this
    // Removes an event parent, so it will stop receiving propagated events
    removeEventParent: function(obj) {
        if (this._eventParents) delete this._eventParents[$78a895d83da22602$export$bd3fba034e28f6b(obj)];
        return this;
    },
    _propagateEvent: function(e) {
        for(var id in this._eventParents)this._eventParents[id].fire(e.type, $78a895d83da22602$export$8b58be045bf06082({
            layer: e.target,
            propagatedFrom: e.target
        }, e), true);
    }
};
// aliases; we should ditch those eventually
// @method addEventListener(…): this
// Alias to [`on(…)`](#evented-on)
$8d0e67ac3b8042d8$export$ada873a34909da65.addEventListener = $8d0e67ac3b8042d8$export$ada873a34909da65.on;
// @method removeEventListener(…): this
// Alias to [`off(…)`](#evented-off)
// @method clearAllEventListeners(…): this
// Alias to [`off()`](#evented-off)
$8d0e67ac3b8042d8$export$ada873a34909da65.removeEventListener = $8d0e67ac3b8042d8$export$ada873a34909da65.clearAllEventListeners = $8d0e67ac3b8042d8$export$ada873a34909da65.off;
// @method addOneTimeEventListener(…): this
// Alias to [`once(…)`](#evented-once)
$8d0e67ac3b8042d8$export$ada873a34909da65.addOneTimeEventListener = $8d0e67ac3b8042d8$export$ada873a34909da65.once;
// @method fireEvent(…): this
// Alias to [`fire(…)`](#evented-fire)
$8d0e67ac3b8042d8$export$ada873a34909da65.fireEvent = $8d0e67ac3b8042d8$export$ada873a34909da65.fire;
// @method hasEventListeners(…): Boolean
// Alias to [`listens(…)`](#evented-listens)
$8d0e67ac3b8042d8$export$ada873a34909da65.hasEventListeners = $8d0e67ac3b8042d8$export$ada873a34909da65.listens;
var $8d0e67ac3b8042d8$export$ebcc362d8f4c4311 = (0, $a5dc067f35738c55$export$4c85e640eb41c31b).extend($8d0e67ac3b8042d8$export$ada873a34909da65);



function $0552a615fcf79927$export$baf26146a414f24a(x, y, round) {
    // @property x: Number; The `x` coordinate of the point
    this.x = round ? Math.round(x) : x;
    // @property y: Number; The `y` coordinate of the point
    this.y = round ? Math.round(y) : y;
}
var $0552a615fcf79927$var$trunc = Math.trunc || function(v) {
    return v > 0 ? Math.floor(v) : Math.ceil(v);
};
$0552a615fcf79927$export$baf26146a414f24a.prototype = {
    // @method clone(): Point
    // Returns a copy of the current point.
    clone: function() {
        return new $0552a615fcf79927$export$baf26146a414f24a(this.x, this.y);
    },
    // @method add(otherPoint: Point): Point
    // Returns the result of addition of the current and the given points.
    add: function(point) {
        // non-destructive, returns a new point
        return this.clone()._add($0552a615fcf79927$export$b63cca88ddc558a9(point));
    },
    _add: function(point) {
        // destructive, used directly for performance in situations where it's safe to modify existing point
        this.x += point.x;
        this.y += point.y;
        return this;
    },
    // @method subtract(otherPoint: Point): Point
    // Returns the result of subtraction of the given point from the current.
    subtract: function(point) {
        return this.clone()._subtract($0552a615fcf79927$export$b63cca88ddc558a9(point));
    },
    _subtract: function(point) {
        this.x -= point.x;
        this.y -= point.y;
        return this;
    },
    // @method divideBy(num: Number): Point
    // Returns the result of division of the current point by the given number.
    divideBy: function(num) {
        return this.clone()._divideBy(num);
    },
    _divideBy: function(num) {
        this.x /= num;
        this.y /= num;
        return this;
    },
    // @method multiplyBy(num: Number): Point
    // Returns the result of multiplication of the current point by the given number.
    multiplyBy: function(num) {
        return this.clone()._multiplyBy(num);
    },
    _multiplyBy: function(num) {
        this.x *= num;
        this.y *= num;
        return this;
    },
    // @method scaleBy(scale: Point): Point
    // Multiply each coordinate of the current point by each coordinate of
    // `scale`. In linear algebra terms, multiply the point by the
    // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
    // defined by `scale`.
    scaleBy: function(point) {
        return new $0552a615fcf79927$export$baf26146a414f24a(this.x * point.x, this.y * point.y);
    },
    // @method unscaleBy(scale: Point): Point
    // Inverse of `scaleBy`. Divide each coordinate of the current point by
    // each coordinate of `scale`.
    unscaleBy: function(point) {
        return new $0552a615fcf79927$export$baf26146a414f24a(this.x / point.x, this.y / point.y);
    },
    // @method round(): Point
    // Returns a copy of the current point with rounded coordinates.
    round: function() {
        return this.clone()._round();
    },
    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    },
    // @method floor(): Point
    // Returns a copy of the current point with floored coordinates (rounded down).
    floor: function() {
        return this.clone()._floor();
    },
    _floor: function() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    },
    // @method ceil(): Point
    // Returns a copy of the current point with ceiled coordinates (rounded up).
    ceil: function() {
        return this.clone()._ceil();
    },
    _ceil: function() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    },
    // @method trunc(): Point
    // Returns a copy of the current point with truncated coordinates (rounded towards zero).
    trunc: function() {
        return this.clone()._trunc();
    },
    _trunc: function() {
        this.x = $0552a615fcf79927$var$trunc(this.x);
        this.y = $0552a615fcf79927$var$trunc(this.y);
        return this;
    },
    // @method distanceTo(otherPoint: Point): Number
    // Returns the cartesian distance between the current and the given points.
    distanceTo: function(point) {
        point = $0552a615fcf79927$export$b63cca88ddc558a9(point);
        var x = point.x - this.x, y = point.y - this.y;
        return Math.sqrt(x * x + y * y);
    },
    // @method equals(otherPoint: Point): Boolean
    // Returns `true` if the given point has the same coordinates.
    equals: function(point) {
        point = $0552a615fcf79927$export$b63cca88ddc558a9(point);
        return point.x === this.x && point.y === this.y;
    },
    // @method contains(otherPoint: Point): Boolean
    // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
    contains: function(point) {
        point = $0552a615fcf79927$export$b63cca88ddc558a9(point);
        return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
    },
    // @method toString(): String
    // Returns a string representation of the point for debugging purposes.
    toString: function() {
        return "Point(" + (0, $78a895d83da22602$export$533e61f4ff7f35ce)(this.x) + ", " + (0, $78a895d83da22602$export$533e61f4ff7f35ce)(this.y) + ")";
    }
};
function $0552a615fcf79927$export$b63cca88ddc558a9(x, y, round) {
    if (x instanceof $0552a615fcf79927$export$baf26146a414f24a) return x;
    if ((0, $78a895d83da22602$export$43bee75e5e14138e)(x)) return new $0552a615fcf79927$export$baf26146a414f24a(x[0], x[1]);
    if (x === undefined || x === null) return x;
    if (typeof x === "object" && "x" in x && "y" in x) return new $0552a615fcf79927$export$baf26146a414f24a(x.x, x.y);
    return new $0552a615fcf79927$export$baf26146a414f24a(x, y, round);
}


function $cf9ba342210785ec$export$c4e9d269599ab4b4(a, b) {
    if (!a) return;
    var points = b ? [
        a,
        b
    ] : a;
    for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
}
$cf9ba342210785ec$export$c4e9d269599ab4b4.prototype = {
    // @method extend(point: Point): this
    // Extends the bounds to contain the given point.
    // @alternative
    // @method extend(otherBounds: Bounds): this
    // Extend the bounds to contain the given bounds
    extend: function(obj) {
        var min2, max2;
        if (!obj) return this;
        if (obj instanceof (0, $0552a615fcf79927$export$baf26146a414f24a) || typeof obj[0] === "number" || "x" in obj) min2 = max2 = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(obj);
        else {
            obj = $cf9ba342210785ec$export$c8e2f7c8aba65b28(obj);
            min2 = obj.min;
            max2 = obj.max;
            if (!min2 || !max2) return this;
        }
        // @property min: Point
        // The top left corner of the rectangle.
        // @property max: Point
        // The bottom right corner of the rectangle.
        if (!this.min && !this.max) {
            this.min = min2.clone();
            this.max = max2.clone();
        } else {
            this.min.x = Math.min(min2.x, this.min.x);
            this.max.x = Math.max(max2.x, this.max.x);
            this.min.y = Math.min(min2.y, this.min.y);
            this.max.y = Math.max(max2.y, this.max.y);
        }
        return this;
    },
    // @method getCenter(round?: Boolean): Point
    // Returns the center point of the bounds.
    getCenter: function(round) {
        return (0, $0552a615fcf79927$export$b63cca88ddc558a9)((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
    },
    // @method getBottomLeft(): Point
    // Returns the bottom-left point of the bounds.
    getBottomLeft: function() {
        return (0, $0552a615fcf79927$export$b63cca88ddc558a9)(this.min.x, this.max.y);
    },
    // @method getTopRight(): Point
    // Returns the top-right point of the bounds.
    getTopRight: function() {
        return (0, $0552a615fcf79927$export$b63cca88ddc558a9)(this.max.x, this.min.y);
    },
    // @method getTopLeft(): Point
    // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
    getTopLeft: function() {
        return this.min; // left, top
    },
    // @method getBottomRight(): Point
    // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
    getBottomRight: function() {
        return this.max; // right, bottom
    },
    // @method getSize(): Point
    // Returns the size of the given bounds
    getSize: function() {
        return this.max.subtract(this.min);
    },
    // @method contains(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle contains the given one.
    // @alternative
    // @method contains(point: Point): Boolean
    // Returns `true` if the rectangle contains the given point.
    contains: function(obj) {
        var min, max;
        if (typeof obj[0] === "number" || obj instanceof (0, $0552a615fcf79927$export$baf26146a414f24a)) obj = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(obj);
        else obj = $cf9ba342210785ec$export$c8e2f7c8aba65b28(obj);
        if (obj instanceof $cf9ba342210785ec$export$c4e9d269599ab4b4) {
            min = obj.min;
            max = obj.max;
        } else min = max = obj;
        return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
    },
    // @method intersects(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle intersects the given bounds. Two bounds
    // intersect if they have at least one point in common.
    intersects: function(bounds) {
        bounds = $cf9ba342210785ec$export$c8e2f7c8aba65b28(bounds);
        var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
        return xIntersects && yIntersects;
    },
    // @method overlaps(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle overlaps the given bounds. Two bounds
    // overlap if their intersection is an area.
    overlaps: function(bounds) {
        bounds = $cf9ba342210785ec$export$c8e2f7c8aba65b28(bounds);
        var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
        return xOverlaps && yOverlaps;
    },
    // @method isValid(): Boolean
    // Returns `true` if the bounds are properly initialized.
    isValid: function() {
        return !!(this.min && this.max);
    },
    // @method pad(bufferRatio: Number): Bounds
    // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
    // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
    // Negative values will retract the bounds.
    pad: function(bufferRatio) {
        var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
        return $cf9ba342210785ec$export$c8e2f7c8aba65b28((0, $0552a615fcf79927$export$b63cca88ddc558a9)(min.x - heightBuffer, min.y - widthBuffer), (0, $0552a615fcf79927$export$b63cca88ddc558a9)(max.x + heightBuffer, max.y + widthBuffer));
    },
    // @method equals(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle is equivalent to the given bounds.
    equals: function(bounds) {
        if (!bounds) return false;
        bounds = $cf9ba342210785ec$export$c8e2f7c8aba65b28(bounds);
        return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
    }
};
function $cf9ba342210785ec$export$c8e2f7c8aba65b28(a, b) {
    if (!a || a instanceof $cf9ba342210785ec$export$c4e9d269599ab4b4) return a;
    return new $cf9ba342210785ec$export$c4e9d269599ab4b4(a, b);
}





function $1b787e0b76fef54a$export$fe84d4076a55a8e6(corner1, corner2) {
    if (!corner1) return;
    var latlngs = corner2 ? [
        corner1,
        corner2
    ] : corner1;
    for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
}
$1b787e0b76fef54a$export$fe84d4076a55a8e6.prototype = {
    // @method extend(latlng: LatLng): this
    // Extend the bounds to contain the given point
    // @alternative
    // @method extend(otherBounds: LatLngBounds): this
    // Extend the bounds to contain the given bounds
    extend: function(obj) {
        var sw = this._southWest, ne = this._northEast, sw2, ne2;
        if (obj instanceof (0, $331f1841eb1ed916$export$5fd359ea0b43bded)) {
            sw2 = obj;
            ne2 = obj;
        } else if (obj instanceof $1b787e0b76fef54a$export$fe84d4076a55a8e6) {
            sw2 = obj._southWest;
            ne2 = obj._northEast;
            if (!sw2 || !ne2) return this;
        } else return obj ? this.extend((0, $331f1841eb1ed916$export$a192f247fc7a2057)(obj) || $1b787e0b76fef54a$export$4904432a68b0399(obj)) : this;
        if (!sw && !ne) {
            this._southWest = new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(sw2.lat, sw2.lng);
            this._northEast = new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(ne2.lat, ne2.lng);
        } else {
            sw.lat = Math.min(sw2.lat, sw.lat);
            sw.lng = Math.min(sw2.lng, sw.lng);
            ne.lat = Math.max(ne2.lat, ne.lat);
            ne.lng = Math.max(ne2.lng, ne.lng);
        }
        return this;
    },
    // @method pad(bufferRatio: Number): LatLngBounds
    // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
    // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
    // Negative values will retract the bounds.
    pad: function(bufferRatio) {
        var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
        return new $1b787e0b76fef54a$export$fe84d4076a55a8e6(new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(sw.lat - heightBuffer, sw.lng - widthBuffer), new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(ne.lat + heightBuffer, ne.lng + widthBuffer));
    },
    // @method getCenter(): LatLng
    // Returns the center point of the bounds.
    getCenter: function() {
        return new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
    },
    // @method getSouthWest(): LatLng
    // Returns the south-west point of the bounds.
    getSouthWest: function() {
        return this._southWest;
    },
    // @method getNorthEast(): LatLng
    // Returns the north-east point of the bounds.
    getNorthEast: function() {
        return this._northEast;
    },
    // @method getNorthWest(): LatLng
    // Returns the north-west point of the bounds.
    getNorthWest: function() {
        return new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(this.getNorth(), this.getWest());
    },
    // @method getSouthEast(): LatLng
    // Returns the south-east point of the bounds.
    getSouthEast: function() {
        return new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(this.getSouth(), this.getEast());
    },
    // @method getWest(): Number
    // Returns the west longitude of the bounds
    getWest: function() {
        return this._southWest.lng;
    },
    // @method getSouth(): Number
    // Returns the south latitude of the bounds
    getSouth: function() {
        return this._southWest.lat;
    },
    // @method getEast(): Number
    // Returns the east longitude of the bounds
    getEast: function() {
        return this._northEast.lng;
    },
    // @method getNorth(): Number
    // Returns the north latitude of the bounds
    getNorth: function() {
        return this._northEast.lat;
    },
    // @method contains(otherBounds: LatLngBounds): Boolean
    // Returns `true` if the rectangle contains the given one.
    // @alternative
    // @method contains (latlng: LatLng): Boolean
    // Returns `true` if the rectangle contains the given point.
    contains: function(obj) {
        if (typeof obj[0] === "number" || obj instanceof (0, $331f1841eb1ed916$export$5fd359ea0b43bded) || "lat" in obj) obj = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(obj);
        else obj = $1b787e0b76fef54a$export$4904432a68b0399(obj);
        var sw = this._southWest, ne = this._northEast, sw2, ne2;
        if (obj instanceof $1b787e0b76fef54a$export$fe84d4076a55a8e6) {
            sw2 = obj.getSouthWest();
            ne2 = obj.getNorthEast();
        } else sw2 = ne2 = obj;
        return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
    },
    // @method intersects(otherBounds: LatLngBounds): Boolean
    // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
    intersects: function(bounds) {
        bounds = $1b787e0b76fef54a$export$4904432a68b0399(bounds);
        var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
        return latIntersects && lngIntersects;
    },
    // @method overlaps(otherBounds: LatLngBounds): Boolean
    // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
    overlaps: function(bounds) {
        bounds = $1b787e0b76fef54a$export$4904432a68b0399(bounds);
        var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
        return latOverlaps && lngOverlaps;
    },
    // @method toBBoxString(): String
    // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
    toBBoxString: function() {
        return [
            this.getWest(),
            this.getSouth(),
            this.getEast(),
            this.getNorth()
        ].join(",");
    },
    // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
    // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
    equals: function(bounds, maxMargin) {
        if (!bounds) return false;
        bounds = $1b787e0b76fef54a$export$4904432a68b0399(bounds);
        return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
    },
    // @method isValid(): Boolean
    // Returns `true` if the bounds are properly initialized.
    isValid: function() {
        return !!(this._southWest && this._northEast);
    }
};
function $1b787e0b76fef54a$export$4904432a68b0399(a, b) {
    if (a instanceof $1b787e0b76fef54a$export$fe84d4076a55a8e6) return a;
    return new $1b787e0b76fef54a$export$fe84d4076a55a8e6(a, b);
}


function $331f1841eb1ed916$export$5fd359ea0b43bded(lat, lng, alt) {
    if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
    // @property lat: Number
    // Latitude in degrees
    this.lat = +lat;
    // @property lng: Number
    // Longitude in degrees
    this.lng = +lng;
    // @property alt: Number
    // Altitude in meters (optional)
    if (alt !== undefined) this.alt = +alt;
}
$331f1841eb1ed916$export$5fd359ea0b43bded.prototype = {
    // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
    // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
    equals: function(obj, maxMargin) {
        if (!obj) return false;
        obj = $331f1841eb1ed916$export$a192f247fc7a2057(obj);
        var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
        return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
    },
    // @method toString(): String
    // Returns a string representation of the point (for debugging purposes).
    toString: function(precision) {
        return "LatLng(" + $78a895d83da22602$export$533e61f4ff7f35ce(this.lat, precision) + ", " + $78a895d83da22602$export$533e61f4ff7f35ce(this.lng, precision) + ")";
    },
    // @method distanceTo(otherLatLng: LatLng): Number
    // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
    distanceTo: function(other) {
        return (0, $734dbda617228982$export$a8d7cb18a6ef9581).distance(this, $331f1841eb1ed916$export$a192f247fc7a2057(other));
    },
    // @method wrap(): LatLng
    // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
    wrap: function() {
        return (0, $734dbda617228982$export$a8d7cb18a6ef9581).wrapLatLng(this);
    },
    // @method toBounds(sizeInMeters: Number): LatLngBounds
    // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
    toBounds: function(sizeInMeters) {
        var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
        return (0, $1b787e0b76fef54a$export$4904432a68b0399)([
            this.lat - latAccuracy,
            this.lng - lngAccuracy
        ], [
            this.lat + latAccuracy,
            this.lng + lngAccuracy
        ]);
    },
    clone: function() {
        return new $331f1841eb1ed916$export$5fd359ea0b43bded(this.lat, this.lng, this.alt);
    }
};
function $331f1841eb1ed916$export$a192f247fc7a2057(a, b, c) {
    if (a instanceof $331f1841eb1ed916$export$5fd359ea0b43bded) return a;
    if ($78a895d83da22602$export$43bee75e5e14138e(a) && typeof a[0] !== "object") {
        if (a.length === 3) return new $331f1841eb1ed916$export$5fd359ea0b43bded(a[0], a[1], a[2]);
        if (a.length === 2) return new $331f1841eb1ed916$export$5fd359ea0b43bded(a[0], a[1]);
        return null;
    }
    if (a === undefined || a === null) return a;
    if (typeof a === "object" && "lat" in a) return new $331f1841eb1ed916$export$5fd359ea0b43bded(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
    if (b === undefined) return null;
    return new $331f1841eb1ed916$export$5fd359ea0b43bded(a, b, c);
}




var $4761dfee679e6705$export$bdae29047cba02fc = {
    // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
    // Projects geographical coordinates into pixel coordinates for a given zoom.
    latLngToPoint: function(latlng, zoom) {
        var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
        return this.transformation._transform(projectedPoint, scale);
    },
    // @method pointToLatLng(point: Point, zoom: Number): LatLng
    // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
    // zoom into geographical coordinates.
    pointToLatLng: function(point, zoom) {
        var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
        return this.projection.unproject(untransformedPoint);
    },
    // @method project(latlng: LatLng): Point
    // Projects geographical coordinates into coordinates in units accepted for
    // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
    project: function(latlng) {
        return this.projection.project(latlng);
    },
    // @method unproject(point: Point): LatLng
    // Given a projected coordinate returns the corresponding LatLng.
    // The inverse of `project`.
    unproject: function(point) {
        return this.projection.unproject(point);
    },
    // @method scale(zoom: Number): Number
    // Returns the scale used when transforming projected coordinates into
    // pixel coordinates for a particular zoom. For example, it returns
    // `256 * 2^zoom` for Mercator-based CRS.
    scale: function(zoom) {
        return 256 * Math.pow(2, zoom);
    },
    // @method zoom(scale: Number): Number
    // Inverse of `scale()`, returns the zoom level corresponding to a scale
    // factor of `scale`.
    zoom: function(scale) {
        return Math.log(scale / 256) / Math.LN2;
    },
    // @method getProjectedBounds(zoom: Number): Bounds
    // Returns the projection's bounds scaled and transformed for the provided `zoom`.
    getProjectedBounds: function(zoom) {
        if (this.infinite) return null;
        var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
        return new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(min, max);
    },
    // @method distance(latlng1: LatLng, latlng2: LatLng): Number
    // Returns the distance between two geographical coordinates.
    // @property code: String
    // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
    //
    // @property wrapLng: Number[]
    // An array of two numbers defining whether the longitude (horizontal) coordinate
    // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
    // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
    //
    // @property wrapLat: Number[]
    // Like `wrapLng`, but for the latitude (vertical) axis.
    // wrapLng: [min, max],
    // wrapLat: [min, max],
    // @property infinite: Boolean
    // If true, the coordinate space will be unbounded (infinite in both axes)
    infinite: false,
    // @method wrapLatLng(latlng: LatLng): LatLng
    // Returns a `LatLng` where lat and lng has been wrapped according to the
    // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
    wrapLatLng: function(latlng) {
        var lng = this.wrapLng ? $78a895d83da22602$export$f6cd9682189b118b(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? $78a895d83da22602$export$f6cd9682189b118b(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
        return new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(lat, lng, alt);
    },
    // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
    // Returns a `LatLngBounds` with the same size as the given one, ensuring
    // that its center is within the CRS's bounds.
    // Only accepts actual `L.LatLngBounds` instances, not arrays.
    wrapLatLngBounds: function(bounds) {
        var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
        if (latShift === 0 && lngShift === 0) return bounds;
        var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(sw.lat - latShift, sw.lng - lngShift), newNe = new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(ne.lat - latShift, ne.lng - lngShift);
        return new (0, $1b787e0b76fef54a$export$fe84d4076a55a8e6)(newSw, newNe);
    }
};



var $734dbda617228982$export$a8d7cb18a6ef9581 = $78a895d83da22602$export$8b58be045bf06082({}, (0, $4761dfee679e6705$export$bdae29047cba02fc), {
    wrapLng: [
        -180,
        180
    ],
    // Mean Earth Radius, as recommended for use by
    // the International Union of Geodesy and Geophysics,
    // see https://rosettacode.org/wiki/Haversine_formula
    R: 6371000,
    // distance between two geographical points using spherical law of cosines approximation
    distance: function(latlng1, latlng2) {
        var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return this.R * c;
    }
});





/*
 * @namespace Projection
 * @projection L.Projection.SphericalMercator
 *
 * Spherical Mercator projection — the most common projection for online maps,
 * used by almost all free and commercial tile providers. Assumes that Earth is
 * a sphere. Used by the `EPSG:3857` CRS.
 */ var $70747c5c8d615114$var$earthRadius = 6378137;
var $70747c5c8d615114$export$55a14d9a5359290c = {
    R: $70747c5c8d615114$var$earthRadius,
    MAX_LATITUDE: 85.0511287798,
    project: function(latlng) {
        var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
        return new (0, $0552a615fcf79927$export$baf26146a414f24a)(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
    },
    unproject: function(point) {
        var d = 180 / Math.PI;
        return new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
    },
    bounds: function() {
        var d = $70747c5c8d615114$var$earthRadius * Math.PI;
        return new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)([
            -d,
            -d
        ], [
            d,
            d
        ]);
    }()
};




function $ce389bc6a650be4e$export$a001ee18aa9e474(a, b, c, d) {
    if ($78a895d83da22602$export$43bee75e5e14138e(a)) {
        // use array properties
        this._a = a[0];
        this._b = a[1];
        this._c = a[2];
        this._d = a[3];
        return;
    }
    this._a = a;
    this._b = b;
    this._c = c;
    this._d = d;
}
$ce389bc6a650be4e$export$a001ee18aa9e474.prototype = {
    // @method transform(point: Point, scale?: Number): Point
    // Returns a transformed point, optionally multiplied by the given scale.
    // Only accepts actual `L.Point` instances, not arrays.
    transform: function(point, scale) {
        return this._transform(point.clone(), scale);
    },
    // destructive transform (faster)
    _transform: function(point, scale) {
        scale = scale || 1;
        point.x = scale * (this._a * point.x + this._b);
        point.y = scale * (this._c * point.y + this._d);
        return point;
    },
    // @method untransform(point: Point, scale?: Number): Point
    // Returns the reverse transformation of the given point, optionally divided
    // by the given scale. Only accepts actual `L.Point` instances, not arrays.
    untransform: function(point, scale) {
        scale = scale || 1;
        return new (0, $0552a615fcf79927$export$baf26146a414f24a)((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
    }
};
function $ce389bc6a650be4e$export$9f6f7fcc395e278(a, b, c, d) {
    return new $ce389bc6a650be4e$export$a001ee18aa9e474(a, b, c, d);
}



var $4ab72094fac4360b$export$fa530d80b080b222 = $78a895d83da22602$export$8b58be045bf06082({}, (0, $734dbda617228982$export$a8d7cb18a6ef9581), {
    code: "EPSG:3857",
    projection: (0, $70747c5c8d615114$export$55a14d9a5359290c),
    transformation: function() {
        var scale = 0.5 / (Math.PI * (0, $70747c5c8d615114$export$55a14d9a5359290c).R);
        return (0, $ce389bc6a650be4e$export$9f6f7fcc395e278)(scale, 0.5, -scale, 0.5);
    }()
});
var $4ab72094fac4360b$export$ca3534a3dff3e397 = $78a895d83da22602$export$8b58be045bf06082({}, $4ab72094fac4360b$export$fa530d80b080b222, {
    code: "EPSG:900913"
});








function $67005fefedcce2f7$export$9d9648f1590c5e1(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function $67005fefedcce2f7$export$bc863495a5f10ca1(rings, closed) {
    var str = "", i, j, len, len2, points, p;
    for(i = 0, len = rings.length; i < len; i++){
        points = rings[i];
        for(j = 0, len2 = points.length; j < len2; j++){
            p = points[j];
            str += (j ? "L" : "M") + p.x + " " + p.y;
        }
        // closes the ring for polygons; "x" is VML syntax
        str += closed ? (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).svg ? "z" : "x" : "";
    }
    // SVG complains about empty path strings
    return str || "M0 0";
}


/*
 * @namespace Browser
 * @aka L.Browser
 *
 * A namespace with static properties for browser/feature detection used by Leaflet internally.
 *
 * @example
 *
 * ```js
 * if (L.Browser.ielt9) {
 *   alert('Upgrade your browser, dude!');
 * }
 * ```
 */ var $029e6e3a5e23f5b8$var$style = document.documentElement.style;
// @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
var $029e6e3a5e23f5b8$var$ie = "ActiveXObject" in window;
// @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
var $029e6e3a5e23f5b8$var$ielt9 = $029e6e3a5e23f5b8$var$ie && !document.addEventListener;
// @property edge: Boolean; `true` for the Edge web browser.
var $029e6e3a5e23f5b8$var$edge = "msLaunchUri" in navigator && !("documentMode" in document);
// @property webkit: Boolean;
// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
var $029e6e3a5e23f5b8$var$webkit = $029e6e3a5e23f5b8$var$userAgentContains("webkit");
// @property android: Boolean
// **Deprecated.** `true` for any browser running on an Android platform.
var $029e6e3a5e23f5b8$var$android = $029e6e3a5e23f5b8$var$userAgentContains("android");
// @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
var $029e6e3a5e23f5b8$var$android23 = $029e6e3a5e23f5b8$var$userAgentContains("android 2") || $029e6e3a5e23f5b8$var$userAgentContains("android 3");
/* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var $029e6e3a5e23f5b8$var$webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
// @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
var $029e6e3a5e23f5b8$var$androidStock = $029e6e3a5e23f5b8$var$android && $029e6e3a5e23f5b8$var$userAgentContains("Google") && $029e6e3a5e23f5b8$var$webkitVer < 537 && !("AudioNode" in window);
// @property opera: Boolean; `true` for the Opera browser
var $029e6e3a5e23f5b8$var$opera = !!window.opera;
// @property chrome: Boolean; `true` for the Chrome browser.
var $029e6e3a5e23f5b8$var$chrome = !$029e6e3a5e23f5b8$var$edge && $029e6e3a5e23f5b8$var$userAgentContains("chrome");
// @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
var $029e6e3a5e23f5b8$var$gecko = $029e6e3a5e23f5b8$var$userAgentContains("gecko") && !$029e6e3a5e23f5b8$var$webkit && !$029e6e3a5e23f5b8$var$opera && !$029e6e3a5e23f5b8$var$ie;
// @property safari: Boolean; `true` for the Safari browser.
var $029e6e3a5e23f5b8$var$safari = !$029e6e3a5e23f5b8$var$chrome && $029e6e3a5e23f5b8$var$userAgentContains("safari");
var $029e6e3a5e23f5b8$var$phantom = $029e6e3a5e23f5b8$var$userAgentContains("phantom");
// @property opera12: Boolean
// `true` for the Opera browser supporting CSS transforms (version 12 or later).
var $029e6e3a5e23f5b8$var$opera12 = "OTransition" in $029e6e3a5e23f5b8$var$style;
// @property win: Boolean; `true` when the browser is running in a Windows platform
var $029e6e3a5e23f5b8$var$win = navigator.platform.indexOf("Win") === 0;
// @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
var $029e6e3a5e23f5b8$var$ie3d = $029e6e3a5e23f5b8$var$ie && "transition" in $029e6e3a5e23f5b8$var$style;
// @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
var $029e6e3a5e23f5b8$var$webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !$029e6e3a5e23f5b8$var$android23;
// @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
var $029e6e3a5e23f5b8$var$gecko3d = "MozPerspective" in $029e6e3a5e23f5b8$var$style;
// @property any3d: Boolean
// `true` for all browsers supporting CSS transforms.
var $029e6e3a5e23f5b8$var$any3d = !window.L_DISABLE_3D && ($029e6e3a5e23f5b8$var$ie3d || $029e6e3a5e23f5b8$var$webkit3d || $029e6e3a5e23f5b8$var$gecko3d) && !$029e6e3a5e23f5b8$var$opera12 && !$029e6e3a5e23f5b8$var$phantom;
// @property mobile: Boolean; `true` for all browsers running in a mobile device.
var $029e6e3a5e23f5b8$var$mobile = typeof orientation !== "undefined" || $029e6e3a5e23f5b8$var$userAgentContains("mobile");
// @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
var $029e6e3a5e23f5b8$var$mobileWebkit = $029e6e3a5e23f5b8$var$mobile && $029e6e3a5e23f5b8$var$webkit;
// @property mobileWebkit3d: Boolean
// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
var $029e6e3a5e23f5b8$var$mobileWebkit3d = $029e6e3a5e23f5b8$var$mobile && $029e6e3a5e23f5b8$var$webkit3d;
// @property msPointer: Boolean
// `true` for browsers implementing the Microsoft touch events model (notably IE10).
var $029e6e3a5e23f5b8$var$msPointer = !window.PointerEvent && window.MSPointerEvent;
// @property pointer: Boolean
// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
var $029e6e3a5e23f5b8$var$pointer = !!(window.PointerEvent || $029e6e3a5e23f5b8$var$msPointer);
// @property touchNative: Boolean
// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
// **This does not necessarily mean** that the browser is running in a computer with
// a touchscreen, it only means that the browser is capable of understanding
// touch events.
var $029e6e3a5e23f5b8$var$touchNative = "ontouchstart" in window || !!window.TouchEvent;
// @property touch: Boolean
// `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
// Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
var $029e6e3a5e23f5b8$var$touch = !window.L_NO_TOUCH && ($029e6e3a5e23f5b8$var$touchNative || $029e6e3a5e23f5b8$var$pointer);
// @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
var $029e6e3a5e23f5b8$var$mobileOpera = $029e6e3a5e23f5b8$var$mobile && $029e6e3a5e23f5b8$var$opera;
// @property mobileGecko: Boolean
// `true` for gecko-based browsers running in a mobile device.
var $029e6e3a5e23f5b8$var$mobileGecko = $029e6e3a5e23f5b8$var$mobile && $029e6e3a5e23f5b8$var$gecko;
// @property retina: Boolean
// `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
var $029e6e3a5e23f5b8$var$retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
// @property passiveEvents: Boolean
// `true` for browsers that support passive events.
var $029e6e3a5e23f5b8$var$passiveEvents = function() {
    var supportsPassiveOption = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            get: function() {
                supportsPassiveOption = true;
            }
        });
        window.addEventListener("testPassiveEventSupport", $78a895d83da22602$export$a3891e81a74c5e40, opts);
        window.removeEventListener("testPassiveEventSupport", $78a895d83da22602$export$a3891e81a74c5e40, opts);
    } catch (e) {
    // Errors can safely be ignored since this is only a browser support test.
    }
    return supportsPassiveOption;
}();
// @property canvas: Boolean
// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
var $029e6e3a5e23f5b8$var$canvas = function() {
    return !!document.createElement("canvas").getContext;
}();
// @property svg: Boolean
// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
var $029e6e3a5e23f5b8$var$svg = !!(document.createElementNS && (0, $67005fefedcce2f7$export$9d9648f1590c5e1)("svg").createSVGRect);
var $029e6e3a5e23f5b8$var$inlineSvg = !!$029e6e3a5e23f5b8$var$svg && function() {
    var div = document.createElement("div");
    div.innerHTML = "<svg/>";
    return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
}();
// @property vml: Boolean
// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
var $029e6e3a5e23f5b8$var$vml = !$029e6e3a5e23f5b8$var$svg && function() {
    try {
        var div = document.createElement("div");
        div.innerHTML = '<v:shape adj="1"/>';
        var shape = div.firstChild;
        shape.style.behavior = "url(#default#VML)";
        return shape && typeof shape.adj === "object";
    } catch (e) {
        return false;
    }
}();
// @property mac: Boolean; `true` when the browser is running in a Mac platform
var $029e6e3a5e23f5b8$var$mac = navigator.platform.indexOf("Mac") === 0;
// @property mac: Boolean; `true` when the browser is running in a Linux platform
var $029e6e3a5e23f5b8$var$linux = navigator.platform.indexOf("Linux") === 0;
function $029e6e3a5e23f5b8$var$userAgentContains(str) {
    return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
}
var $029e6e3a5e23f5b8$export$2e2bcd8739ae039 = {
    ie: $029e6e3a5e23f5b8$var$ie,
    ielt9: $029e6e3a5e23f5b8$var$ielt9,
    edge: $029e6e3a5e23f5b8$var$edge,
    webkit: $029e6e3a5e23f5b8$var$webkit,
    android: $029e6e3a5e23f5b8$var$android,
    android23: $029e6e3a5e23f5b8$var$android23,
    androidStock: $029e6e3a5e23f5b8$var$androidStock,
    opera: $029e6e3a5e23f5b8$var$opera,
    chrome: $029e6e3a5e23f5b8$var$chrome,
    gecko: $029e6e3a5e23f5b8$var$gecko,
    safari: $029e6e3a5e23f5b8$var$safari,
    phantom: $029e6e3a5e23f5b8$var$phantom,
    opera12: $029e6e3a5e23f5b8$var$opera12,
    win: $029e6e3a5e23f5b8$var$win,
    ie3d: $029e6e3a5e23f5b8$var$ie3d,
    webkit3d: $029e6e3a5e23f5b8$var$webkit3d,
    gecko3d: $029e6e3a5e23f5b8$var$gecko3d,
    any3d: $029e6e3a5e23f5b8$var$any3d,
    mobile: $029e6e3a5e23f5b8$var$mobile,
    mobileWebkit: $029e6e3a5e23f5b8$var$mobileWebkit,
    mobileWebkit3d: $029e6e3a5e23f5b8$var$mobileWebkit3d,
    msPointer: $029e6e3a5e23f5b8$var$msPointer,
    pointer: $029e6e3a5e23f5b8$var$pointer,
    touch: $029e6e3a5e23f5b8$var$touch,
    touchNative: $029e6e3a5e23f5b8$var$touchNative,
    mobileOpera: $029e6e3a5e23f5b8$var$mobileOpera,
    mobileGecko: $029e6e3a5e23f5b8$var$mobileGecko,
    retina: $029e6e3a5e23f5b8$var$retina,
    passiveEvents: $029e6e3a5e23f5b8$var$passiveEvents,
    canvas: $029e6e3a5e23f5b8$var$canvas,
    svg: $029e6e3a5e23f5b8$var$svg,
    vml: $029e6e3a5e23f5b8$var$vml,
    inlineSvg: $029e6e3a5e23f5b8$var$inlineSvg,
    mac: $029e6e3a5e23f5b8$var$mac,
    linux: $029e6e3a5e23f5b8$var$linux
};








/*
 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
 */ var $7bb321fa9af15676$var$POINTER_DOWN = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).msPointer ? "MSPointerDown" : "pointerdown";
var $7bb321fa9af15676$var$POINTER_MOVE = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).msPointer ? "MSPointerMove" : "pointermove";
var $7bb321fa9af15676$var$POINTER_UP = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).msPointer ? "MSPointerUp" : "pointerup";
var $7bb321fa9af15676$var$POINTER_CANCEL = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).msPointer ? "MSPointerCancel" : "pointercancel";
var $7bb321fa9af15676$var$pEvent = {
    touchstart: $7bb321fa9af15676$var$POINTER_DOWN,
    touchmove: $7bb321fa9af15676$var$POINTER_MOVE,
    touchend: $7bb321fa9af15676$var$POINTER_UP,
    touchcancel: $7bb321fa9af15676$var$POINTER_CANCEL
};
var $7bb321fa9af15676$var$handle = {
    touchstart: $7bb321fa9af15676$var$_onPointerStart,
    touchmove: $7bb321fa9af15676$var$_handlePointer,
    touchend: $7bb321fa9af15676$var$_handlePointer,
    touchcancel: $7bb321fa9af15676$var$_handlePointer
};
var $7bb321fa9af15676$var$_pointers = {};
var $7bb321fa9af15676$var$_pointerDocListener = false;
function $7bb321fa9af15676$export$a6463408b660293c(obj, type, handler) {
    if (type === "touchstart") $7bb321fa9af15676$var$_addPointerDocListener();
    if (!$7bb321fa9af15676$var$handle[type]) {
        console.warn("wrong event specified:", type);
        return 0, $78a895d83da22602$export$a3891e81a74c5e40;
    }
    handler = $7bb321fa9af15676$var$handle[type].bind(this, handler);
    obj.addEventListener($7bb321fa9af15676$var$pEvent[type], handler, false);
    return handler;
}
function $7bb321fa9af15676$export$b9716686da018371(obj, type, handler) {
    if (!$7bb321fa9af15676$var$pEvent[type]) {
        console.warn("wrong event specified:", type);
        return;
    }
    obj.removeEventListener($7bb321fa9af15676$var$pEvent[type], handler, false);
}
function $7bb321fa9af15676$var$_globalPointerDown(e) {
    $7bb321fa9af15676$var$_pointers[e.pointerId] = e;
}
function $7bb321fa9af15676$var$_globalPointerMove(e) {
    if ($7bb321fa9af15676$var$_pointers[e.pointerId]) $7bb321fa9af15676$var$_pointers[e.pointerId] = e;
}
function $7bb321fa9af15676$var$_globalPointerUp(e) {
    delete $7bb321fa9af15676$var$_pointers[e.pointerId];
}
function $7bb321fa9af15676$var$_addPointerDocListener() {
    // need to keep track of what pointers and how many are active to provide e.touches emulation
    if (!$7bb321fa9af15676$var$_pointerDocListener) {
        // we listen document as any drags that end by moving the touch off the screen get fired there
        document.addEventListener($7bb321fa9af15676$var$POINTER_DOWN, $7bb321fa9af15676$var$_globalPointerDown, true);
        document.addEventListener($7bb321fa9af15676$var$POINTER_MOVE, $7bb321fa9af15676$var$_globalPointerMove, true);
        document.addEventListener($7bb321fa9af15676$var$POINTER_UP, $7bb321fa9af15676$var$_globalPointerUp, true);
        document.addEventListener($7bb321fa9af15676$var$POINTER_CANCEL, $7bb321fa9af15676$var$_globalPointerUp, true);
        $7bb321fa9af15676$var$_pointerDocListener = true;
    }
}
function $7bb321fa9af15676$var$_handlePointer(handler, e) {
    if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
    e.touches = [];
    for(var i in $7bb321fa9af15676$var$_pointers)e.touches.push($7bb321fa9af15676$var$_pointers[i]);
    e.changedTouches = [
        e
    ];
    handler(e);
}
function $7bb321fa9af15676$var$_onPointerStart(handler, e) {
    // IE10 specific: MsTouch needs preventDefault. See #2000
    if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) $7c9dd72411ef2269$export$fa3b29edae795ef4(e);
    $7bb321fa9af15676$var$_handlePointer(handler, e);
}



/*
 * Extends the event handling code with double tap support for mobile browsers.
 *
 * Note: currently most browsers fire native dblclick, with only a few exceptions
 * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
 */ function $238135cf8da798e7$var$makeDblclick(event) {
    // in modern browsers `type` cannot be just overridden:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
    var newEvent = {}, prop, i;
    for(i in event){
        prop = event[i];
        newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
    }
    event = newEvent;
    newEvent.type = "dblclick";
    newEvent.detail = 2;
    newEvent.isTrusted = false;
    newEvent._simulated = true; // for debug purposes
    return newEvent;
}
var $238135cf8da798e7$var$delay = 200;
function $238135cf8da798e7$export$21cd263c61b25e59(obj, handler) {
    // Most browsers handle double tap natively
    obj.addEventListener("dblclick", handler);
    // On some platforms the browser doesn't fire native dblclicks for touch events.
    // It seems that in all such cases `detail` property of `click` event is always `1`.
    // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
    var last = 0, detail;
    function simDblclick(e) {
        if (e.detail !== 1) {
            detail = e.detail; // keep in sync to avoid false dblclick in some cases
            return;
        }
        if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
        // When clicking on an <input>, the browser generates a click on its
        // <label> (and vice versa) triggering two clicks in quick succession.
        // This ignores clicks on elements which are a label with a 'for'
        // attribute (or children of such a label), but not children of
        // a <input>.
        var path = $7c9dd72411ef2269$export$3a4b8ff8cd330ea2(e);
        if (path.some(function(el) {
            return el instanceof HTMLLabelElement && el.attributes.for;
        }) && !path.some(function(el) {
            return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
        })) return;
        var now = Date.now();
        if (now - last <= $238135cf8da798e7$var$delay) {
            detail++;
            if (detail === 2) handler($238135cf8da798e7$var$makeDblclick(e));
        } else detail = 1;
        last = now;
    }
    obj.addEventListener("click", simDblclick);
    return {
        dblclick: handler,
        simDblclick: simDblclick
    };
}
function $238135cf8da798e7$export$59697814537dff5(obj, handlers) {
    obj.removeEventListener("dblclick", handlers.dblclick);
    obj.removeEventListener("click", handlers.simDblclick);
}






var $b316889e4737b9d0$export$e3fc61237fe28123 = $b316889e4737b9d0$export$5e36a9b3476148c1([
    "transform",
    "webkitTransform",
    "OTransform",
    "MozTransform",
    "msTransform"
]);
var $b316889e4737b9d0$export$f2127cf693ff3edc = $b316889e4737b9d0$export$5e36a9b3476148c1([
    "webkitTransition",
    "transition",
    "OTransition",
    "MozTransition",
    "msTransition"
]);
var $b316889e4737b9d0$export$2f1790097c50b1a5 = $b316889e4737b9d0$export$f2127cf693ff3edc === "webkitTransition" || $b316889e4737b9d0$export$f2127cf693ff3edc === "OTransition" ? $b316889e4737b9d0$export$f2127cf693ff3edc + "End" : "transitionend";
function $b316889e4737b9d0$export$3988ae62b71be9a3(id) {
    return typeof id === "string" ? document.getElementById(id) : id;
}
function $b316889e4737b9d0$export$3d2f074408bd1b82(el, style) {
    var value = el.style[style] || el.currentStyle && el.currentStyle[style];
    if ((!value || value === "auto") && document.defaultView) {
        var css = document.defaultView.getComputedStyle(el, null);
        value = css ? css[style] : null;
    }
    return value === "auto" ? null : value;
}
function $b316889e4737b9d0$export$185802fd694ee1f5(tagName, className, container) {
    var el = document.createElement(tagName);
    el.className = className || "";
    if (container) container.appendChild(el);
    return el;
}
function $b316889e4737b9d0$export$cd7f480d6b8286c3(el) {
    var parent = el.parentNode;
    if (parent) parent.removeChild(el);
}
function $b316889e4737b9d0$export$6e22c362a0406a2c(el) {
    while(el.firstChild)el.removeChild(el.firstChild);
}
function $b316889e4737b9d0$export$967ea9e64a77dad2(el) {
    var parent = el.parentNode;
    if (parent && parent.lastChild !== el) parent.appendChild(el);
}
function $b316889e4737b9d0$export$4d34781508fd70d9(el) {
    var parent = el.parentNode;
    if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
}
function $b316889e4737b9d0$export$4ea3d958472af68f(el, name) {
    if (el.classList !== undefined) return el.classList.contains(name);
    var className = $b316889e4737b9d0$export$d39d7c22acbe0a14(el);
    return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
}
function $b316889e4737b9d0$export$d2cf6cd1dc7067d3(el, name) {
    if (el.classList !== undefined) {
        var classes = $78a895d83da22602$export$3ea6d3c1e1f67aaa(name);
        for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
    } else if (!$b316889e4737b9d0$export$4ea3d958472af68f(el, name)) {
        var className = $b316889e4737b9d0$export$d39d7c22acbe0a14(el);
        $b316889e4737b9d0$export$2796c4ce44e61efa(el, (className ? className + " " : "") + name);
    }
}
function $b316889e4737b9d0$export$c2255604a80b4506(el, name) {
    if (el.classList !== undefined) el.classList.remove(name);
    else $b316889e4737b9d0$export$2796c4ce44e61efa(el, $78a895d83da22602$export$87c2784dc9fc4ab((" " + $b316889e4737b9d0$export$d39d7c22acbe0a14(el) + " ").replace(" " + name + " ", " ")));
}
function $b316889e4737b9d0$export$2796c4ce44e61efa(el, name) {
    if (el.className.baseVal === undefined) el.className = name;
    else // in case of SVG element
    el.className.baseVal = name;
}
function $b316889e4737b9d0$export$d39d7c22acbe0a14(el) {
    // Check if the element is an SVGElementInstance and use the correspondingElement instead
    // (Required for linked SVG elements in IE11.)
    if (el.correspondingElement) el = el.correspondingElement;
    return el.className.baseVal === undefined ? el.className : el.className.baseVal;
}
function $b316889e4737b9d0$export$2646c6b151d2e8(el, value) {
    if ("opacity" in el.style) el.style.opacity = value;
    else if ("filter" in el.style) $b316889e4737b9d0$var$_setOpacityIE(el, value);
}
function $b316889e4737b9d0$var$_setOpacityIE(el, value) {
    var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
    // filters collection throws an error if we try to retrieve a filter that doesn't exist
    try {
        filter = el.filters.item(filterName);
    } catch (e) {
        // don't set opacity to 1 if we haven't already set an opacity,
        // it isn't needed and breaks transparent pngs.
        if (value === 1) return;
    }
    value = Math.round(value * 100);
    if (filter) {
        filter.Enabled = value !== 100;
        filter.Opacity = value;
    } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
}
function $b316889e4737b9d0$export$5e36a9b3476148c1(props) {
    var style = document.documentElement.style;
    for(var i = 0; i < props.length; i++){
        if (props[i] in style) return props[i];
    }
    return false;
}
function $b316889e4737b9d0$export$ff09356c35bee89b(el, offset, scale) {
    var pos = offset || new (0, $0552a615fcf79927$export$baf26146a414f24a)(0, 0);
    el.style[$b316889e4737b9d0$export$e3fc61237fe28123] = ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
}
function $b316889e4737b9d0$export$f9b088a47202d605(el, point) {
    /*eslint-disable */ el._leaflet_pos = point;
    /* eslint-enable */ if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d) $b316889e4737b9d0$export$ff09356c35bee89b(el, point);
    else {
        el.style.left = point.x + "px";
        el.style.top = point.y + "px";
    }
}
function $b316889e4737b9d0$export$1690e12b840569b9(el) {
    // this method is only used for elements previously positioned using setPosition,
    // so it's safe to cache the position for performance
    return el._leaflet_pos || new (0, $0552a615fcf79927$export$baf26146a414f24a)(0, 0);
}
var $b316889e4737b9d0$export$16a4697467175487;
var $b316889e4737b9d0$export$b1bf1c69425cc693;
var $b316889e4737b9d0$var$_userSelect;
if ("onselectstart" in document) {
    $b316889e4737b9d0$export$16a4697467175487 = function() {
        $7c9dd72411ef2269$export$af631764ddc44097(window, "selectstart", $7c9dd72411ef2269$export$fa3b29edae795ef4);
    };
    $b316889e4737b9d0$export$b1bf1c69425cc693 = function() {
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(window, "selectstart", $7c9dd72411ef2269$export$fa3b29edae795ef4);
    };
} else {
    var $b316889e4737b9d0$var$userSelectProperty = $b316889e4737b9d0$export$5e36a9b3476148c1([
        "userSelect",
        "WebkitUserSelect",
        "OUserSelect",
        "MozUserSelect",
        "msUserSelect"
    ]);
    $b316889e4737b9d0$export$16a4697467175487 = function() {
        if ($b316889e4737b9d0$var$userSelectProperty) {
            var style = document.documentElement.style;
            $b316889e4737b9d0$var$_userSelect = style[$b316889e4737b9d0$var$userSelectProperty];
            style[$b316889e4737b9d0$var$userSelectProperty] = "none";
        }
    };
    $b316889e4737b9d0$export$b1bf1c69425cc693 = function() {
        if ($b316889e4737b9d0$var$userSelectProperty) {
            document.documentElement.style[$b316889e4737b9d0$var$userSelectProperty] = $b316889e4737b9d0$var$_userSelect;
            $b316889e4737b9d0$var$_userSelect = undefined;
        }
    };
}
function $b316889e4737b9d0$export$188eb2a17526281() {
    $7c9dd72411ef2269$export$af631764ddc44097(window, "dragstart", $7c9dd72411ef2269$export$fa3b29edae795ef4);
}
function $b316889e4737b9d0$export$f5ef98e1c9198e63() {
    $7c9dd72411ef2269$export$8c8705df4a2dcec9(window, "dragstart", $7c9dd72411ef2269$export$fa3b29edae795ef4);
}
var $b316889e4737b9d0$var$_outlineElement, $b316889e4737b9d0$var$_outlineStyle;
function $b316889e4737b9d0$export$73d26a0c96b464b6(element) {
    while(element.tabIndex === -1)element = element.parentNode;
    if (!element.style) return;
    $b316889e4737b9d0$export$fa2411f9885e5b98();
    $b316889e4737b9d0$var$_outlineElement = element;
    $b316889e4737b9d0$var$_outlineStyle = element.style.outlineStyle;
    element.style.outlineStyle = "none";
    $7c9dd72411ef2269$export$af631764ddc44097(window, "keydown", $b316889e4737b9d0$export$fa2411f9885e5b98);
}
function $b316889e4737b9d0$export$fa2411f9885e5b98() {
    if (!$b316889e4737b9d0$var$_outlineElement) return;
    $b316889e4737b9d0$var$_outlineElement.style.outlineStyle = $b316889e4737b9d0$var$_outlineStyle;
    $b316889e4737b9d0$var$_outlineElement = undefined;
    $b316889e4737b9d0$var$_outlineStyle = undefined;
    $7c9dd72411ef2269$export$8c8705df4a2dcec9(window, "keydown", $b316889e4737b9d0$export$fa2411f9885e5b98);
}
function $b316889e4737b9d0$export$d444b651082dbd47(element) {
    do element = element.parentNode;
    while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
    return element;
}
function $b316889e4737b9d0$export$5cdac61cf538712e(element) {
    var rect = element.getBoundingClientRect(); // Read-only in old browsers.
    return {
        x: rect.width / element.offsetWidth || 1,
        y: rect.height / element.offsetHeight || 1,
        boundingClientRect: rect
    };
}


function $7c9dd72411ef2269$export$af631764ddc44097(obj, types, fn, context) {
    if (types && typeof types === "object") for(var type in types)$7c9dd72411ef2269$var$addOne(obj, type, types[type], fn);
    else {
        types = $78a895d83da22602$export$3ea6d3c1e1f67aaa(types);
        for(var i = 0, len = types.length; i < len; i++)$7c9dd72411ef2269$var$addOne(obj, types[i], fn, context);
    }
    return this;
}
var $7c9dd72411ef2269$var$eventsKey = "_leaflet_events";
function $7c9dd72411ef2269$export$8c8705df4a2dcec9(obj, types, fn, context) {
    if (arguments.length === 1) {
        $7c9dd72411ef2269$var$batchRemove(obj);
        delete obj[$7c9dd72411ef2269$var$eventsKey];
    } else if (types && typeof types === "object") for(var type in types)$7c9dd72411ef2269$var$removeOne(obj, type, types[type], fn);
    else {
        types = $78a895d83da22602$export$3ea6d3c1e1f67aaa(types);
        if (arguments.length === 2) $7c9dd72411ef2269$var$batchRemove(obj, function(type) {
            return $78a895d83da22602$export$305f7d4e9d4624f2(types, type) !== -1;
        });
        else for(var i = 0, len = types.length; i < len; i++)$7c9dd72411ef2269$var$removeOne(obj, types[i], fn, context);
    }
    return this;
}
function $7c9dd72411ef2269$var$batchRemove(obj, filterFn) {
    for(var id in obj[$7c9dd72411ef2269$var$eventsKey]){
        var type = id.split(/\d/)[0];
        if (!filterFn || filterFn(type)) $7c9dd72411ef2269$var$removeOne(obj, type, null, null, id);
    }
}
var $7c9dd72411ef2269$var$mouseSubst = {
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    wheel: !("onwheel" in window) && "mousewheel"
};
function $7c9dd72411ef2269$var$addOne(obj, type, fn, context) {
    var id = type + $78a895d83da22602$export$bd3fba034e28f6b(fn) + (context ? "_" + $78a895d83da22602$export$bd3fba034e28f6b(context) : "");
    if (obj[$7c9dd72411ef2269$var$eventsKey] && obj[$7c9dd72411ef2269$var$eventsKey][id]) return this;
    var handler = function(e) {
        return fn.call(context || obj, e || window.event);
    };
    var originalHandler = handler;
    if (!(0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).touchNative && (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
    handler = (0, $7bb321fa9af15676$export$a6463408b660293c)(obj, type, handler);
    else if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).touch && type === "dblclick") handler = (0, $238135cf8da798e7$export$21cd263c61b25e59)(obj, handler);
    else if ("addEventListener" in obj) {
        if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener($7c9dd72411ef2269$var$mouseSubst[type] || type, handler, (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).passiveEvents ? {
            passive: false
        } : false);
        else if (type === "mouseenter" || type === "mouseleave") {
            handler = function(e) {
                e = e || window.event;
                if ($7c9dd72411ef2269$export$de90706eda23efa2(obj, e)) originalHandler(e);
            };
            obj.addEventListener($7c9dd72411ef2269$var$mouseSubst[type], handler, false);
        } else obj.addEventListener(type, originalHandler, false);
    } else obj.attachEvent("on" + type, handler);
    obj[$7c9dd72411ef2269$var$eventsKey] = obj[$7c9dd72411ef2269$var$eventsKey] || {};
    obj[$7c9dd72411ef2269$var$eventsKey][id] = handler;
}
function $7c9dd72411ef2269$var$removeOne(obj, type, fn, context, id) {
    id = id || type + $78a895d83da22602$export$bd3fba034e28f6b(fn) + (context ? "_" + $78a895d83da22602$export$bd3fba034e28f6b(context) : "");
    var handler = obj[$7c9dd72411ef2269$var$eventsKey] && obj[$7c9dd72411ef2269$var$eventsKey][id];
    if (!handler) return this;
    if (!(0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).touchNative && (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).pointer && type.indexOf("touch") === 0) (0, $7bb321fa9af15676$export$b9716686da018371)(obj, type, handler);
    else if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).touch && type === "dblclick") (0, $238135cf8da798e7$export$59697814537dff5)(obj, handler);
    else if ("removeEventListener" in obj) obj.removeEventListener($7c9dd72411ef2269$var$mouseSubst[type] || type, handler, false);
    else obj.detachEvent("on" + type, handler);
    obj[$7c9dd72411ef2269$var$eventsKey][id] = null;
}
function $7c9dd72411ef2269$export$51134cce184326b9(e) {
    if (e.stopPropagation) e.stopPropagation();
    else if (e.originalEvent) e.originalEvent._stopped = true;
    else e.cancelBubble = true;
    return this;
}
function $7c9dd72411ef2269$export$383a0f6cce2d3ccb(el) {
    $7c9dd72411ef2269$var$addOne(el, "wheel", $7c9dd72411ef2269$export$51134cce184326b9);
    return this;
}
function $7c9dd72411ef2269$export$a640b530813b3952(el) {
    $7c9dd72411ef2269$export$af631764ddc44097(el, "mousedown touchstart dblclick contextmenu", $7c9dd72411ef2269$export$51134cce184326b9);
    el["_leaflet_disable_click"] = true;
    return this;
}
function $7c9dd72411ef2269$export$fa3b29edae795ef4(e) {
    if (e.preventDefault) e.preventDefault();
    else e.returnValue = false;
    return this;
}
function $7c9dd72411ef2269$export$fa6813432f753b0d(e) {
    $7c9dd72411ef2269$export$fa3b29edae795ef4(e);
    $7c9dd72411ef2269$export$51134cce184326b9(e);
    return this;
}
function $7c9dd72411ef2269$export$3a4b8ff8cd330ea2(ev) {
    if (ev.composedPath) return ev.composedPath();
    var path = [];
    var el = ev.target;
    while(el){
        path.push(el);
        el = el.parentNode;
    }
    return path;
}
function $7c9dd72411ef2269$export$642213d516a9b928(e, container) {
    if (!container) return new (0, $0552a615fcf79927$export$baf26146a414f24a)(e.clientX, e.clientY);
    var scale = (0, $b316889e4737b9d0$export$5cdac61cf538712e)(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
    return new (0, $0552a615fcf79927$export$baf26146a414f24a)(// offset.left/top values are in page scale (like clientX/Y),
    // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
    (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
}
//  except , Safari and
// We need double the scroll pixels (see #7403 and #4538) for all Browsers
// except OSX (Mac) -> 3x, Chrome running on Linux 1x
var $7c9dd72411ef2269$var$wheelPxFactor = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).linux && (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).chrome ? window.devicePixelRatio : (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
function $7c9dd72411ef2269$export$99de932e438a9331(e) {
    return (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / $7c9dd72411ef2269$var$wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
}
function $7c9dd72411ef2269$export$de90706eda23efa2(el, e) {
    var related = e.relatedTarget;
    if (!related) return true;
    try {
        while(related && related !== el)related = related.parentNode;
    } catch (err) {
        return false;
    }
    return related !== el;
}






var $96140b52804261c8$export$51243ffcd383b20 = (0, $8d0e67ac3b8042d8$export$ebcc362d8f4c4311).extend({
    // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
    // Run an animation of a given element to a new position, optionally setting
    // duration in seconds (`0.25` by default) and easing linearity factor (3rd
    // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
    // `0.5` by default).
    run: function(el, newPos, duration, easeLinearity) {
        this.stop();
        this._el = el;
        this._inProgress = true;
        this._duration = duration || 0.25;
        this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
        this._startPos = $b316889e4737b9d0$export$1690e12b840569b9(el);
        this._offset = newPos.subtract(this._startPos);
        this._startTime = +new Date();
        // @event start: Event
        // Fired when the animation starts
        this.fire("start");
        this._animate();
    },
    // @method stop()
    // Stops the animation (if currently running).
    stop: function() {
        if (!this._inProgress) return;
        this._step(true);
        this._complete();
    },
    _animate: function() {
        // animation loop
        this._animId = $78a895d83da22602$export$d371ad015c199c06(this._animate, this);
        this._step();
    },
    _step: function(round) {
        var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
        if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
        else {
            this._runFrame(1);
            this._complete();
        }
    },
    _runFrame: function(progress, round) {
        var pos = this._startPos.add(this._offset.multiplyBy(progress));
        if (round) pos._round();
        $b316889e4737b9d0$export$f9b088a47202d605(this._el, pos);
        // @event step: Event
        // Fired continuously during the animation.
        this.fire("step");
    },
    _complete: function() {
        $78a895d83da22602$export$e1ed83507f55dc9d(this._animId);
        this._inProgress = false;
        // @event end: Event
        // Fired when the animation ends.
        this.fire("end");
    },
    _easeOut: function(t) {
        return 1 - Math.pow(1 - t, this._easeOutPower);
    }
});


var $a14ca6047db5cfcd$export$a5c7b93649eaf8f8 = (0, $8d0e67ac3b8042d8$export$ebcc362d8f4c4311).extend({
    options: {
        // @section Map State Options
        // @option crs: CRS = L.CRS.EPSG3857
        // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
        // sure what it means.
        crs: (0, $4ab72094fac4360b$export$fa530d80b080b222),
        // @option center: LatLng = undefined
        // Initial geographic center of the map
        center: undefined,
        // @option zoom: Number = undefined
        // Initial map zoom level
        zoom: undefined,
        // @option minZoom: Number = *
        // Minimum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the lowest of their `minZoom` options will be used instead.
        minZoom: undefined,
        // @option maxZoom: Number = *
        // Maximum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the highest of their `maxZoom` options will be used instead.
        maxZoom: undefined,
        // @option layers: Layer[] = []
        // Array of layers that will be added to the map initially
        layers: [],
        // @option maxBounds: LatLngBounds = null
        // When this option is set, the map restricts the view to the given
        // geographical bounds, bouncing the user back if the user tries to pan
        // outside the view. To set the restriction dynamically, use
        // [`setMaxBounds`](#map-setmaxbounds) method.
        maxBounds: undefined,
        // @option renderer: Renderer = *
        // The default method for drawing vector layers on the map. `L.SVG`
        // or `L.Canvas` by default depending on browser support.
        renderer: undefined,
        // @section Animation Options
        // @option zoomAnimation: Boolean = true
        // Whether the map zoom animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        zoomAnimation: true,
        // @option zoomAnimationThreshold: Number = 4
        // Won't animate zoom if the zoom difference exceeds this value.
        zoomAnimationThreshold: 4,
        // @option fadeAnimation: Boolean = true
        // Whether the tile fade animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        fadeAnimation: true,
        // @option markerZoomAnimation: Boolean = true
        // Whether markers animate their zoom with the zoom animation, if disabled
        // they will disappear for the length of the animation. By default it's
        // enabled in all browsers that support CSS3 Transitions except Android.
        markerZoomAnimation: true,
        // @option transform3DLimit: Number = 2^23
        // Defines the maximum size of a CSS translation transform. The default
        // value should not be changed unless a web browser positions layers in
        // the wrong place after doing a large `panBy`.
        transform3DLimit: 8388608,
        // @section Interaction Options
        // @option zoomSnap: Number = 1
        // Forces the map's zoom level to always be a multiple of this, particularly
        // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
        // By default, the zoom level snaps to the nearest integer; lower values
        // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
        // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
        zoomSnap: 1,
        // @option zoomDelta: Number = 1
        // Controls how much the map's zoom level will change after a
        // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
        // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
        // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
        zoomDelta: 1,
        // @option trackResize: Boolean = true
        // Whether the map automatically handles browser window resize to update itself.
        trackResize: true
    },
    initialize: function(id, options) {
        options = $78a895d83da22602$export$add91eafeaeab287(this, options);
        // Make sure to assign internal flags at the beginning,
        // to avoid inconsistent state in some edge cases.
        this._handlers = [];
        this._layers = {};
        this._zoomBoundLayers = {};
        this._sizeChanged = true;
        this._initContainer(id);
        this._initLayout();
        // hack for https://github.com/Leaflet/Leaflet/issues/1980
        this._onResize = $78a895d83da22602$export$2385a24977818dd0(this._onResize, this);
        this._initEvents();
        if (options.maxBounds) this.setMaxBounds(options.maxBounds);
        if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
        if (options.center && options.zoom !== undefined) this.setView((0, $331f1841eb1ed916$export$a192f247fc7a2057)(options.center), options.zoom, {
            reset: true
        });
        this.callInitHooks();
        // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
        this._zoomAnimated = $b316889e4737b9d0$export$f2127cf693ff3edc && (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d && !(0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).mobileOpera && this.options.zoomAnimation;
        // zoom transitions run with the same duration for all layers, so if one of transitionend events
        // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
        if (this._zoomAnimated) {
            this._createAnimProxy();
            $7c9dd72411ef2269$export$af631764ddc44097(this._proxy, $b316889e4737b9d0$export$2f1790097c50b1a5, this._catchTransitionEnd, this);
        }
        this._addLayers(this.options.layers);
    },
    // @section Methods for modifying map state
    // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
    // Sets the view of the map (geographical center and zoom) with the given
    // animation options.
    setView: function(center, zoom, options) {
        zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
        center = this._limitCenter((0, $331f1841eb1ed916$export$a192f247fc7a2057)(center), zoom, this.options.maxBounds);
        options = options || {};
        this._stop();
        if (this._loaded && !options.reset && options !== true) {
            if (options.animate !== undefined) {
                options.zoom = $78a895d83da22602$export$8b58be045bf06082({
                    animate: options.animate
                }, options.zoom);
                options.pan = $78a895d83da22602$export$8b58be045bf06082({
                    animate: options.animate,
                    duration: options.duration
                }, options.pan);
            }
            // try animating pan or zoom
            var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
            if (moved) {
                // prevent resize handler call, the view will refresh after animation anyway
                clearTimeout(this._sizeTimer);
                return this;
            }
        }
        // animation didn't start, just reset the map view
        this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
        return this;
    },
    // @method setZoom(zoom: Number, options?: Zoom/pan options): this
    // Sets the zoom of the map.
    setZoom: function(zoom, options) {
        if (!this._loaded) {
            this._zoom = zoom;
            return this;
        }
        return this.setView(this.getCenter(), zoom, {
            zoom: options
        });
    },
    // @method zoomIn(delta?: Number, options?: Zoom options): this
    // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
    zoomIn: function(delta, options) {
        delta = delta || ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d ? this.options.zoomDelta : 1);
        return this.setZoom(this._zoom + delta, options);
    },
    // @method zoomOut(delta?: Number, options?: Zoom options): this
    // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
    zoomOut: function(delta, options) {
        delta = delta || ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d ? this.options.zoomDelta : 1);
        return this.setZoom(this._zoom - delta, options);
    },
    // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
    // Zooms the map while keeping a specified geographical point on the map
    // stationary (e.g. used internally for scroll zoom and double-click zoom).
    // @alternative
    // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
    // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
    setZoomAround: function(latlng, zoom, options) {
        var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof (0, $0552a615fcf79927$export$baf26146a414f24a) ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
        return this.setView(newCenter, zoom, {
            zoom: options
        });
    },
    _getBoundsCenterZoom: function(bounds, options) {
        options = options || {};
        bounds = bounds.getBounds ? bounds.getBounds() : (0, $1b787e0b76fef54a$export$4904432a68b0399)(bounds);
        var paddingTL = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(options.paddingTopLeft || options.padding || [
            0,
            0
        ]), paddingBR = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(options.paddingBottomRight || options.padding || [
            0,
            0
        ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
        zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
        if (zoom === Infinity) return {
            center: bounds.getCenter(),
            zoom: zoom
        };
        var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
        return {
            center: center,
            zoom: zoom
        };
    },
    // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
    // Sets a map view that contains the given geographical bounds with the
    // maximum zoom level possible.
    fitBounds: function(bounds, options) {
        bounds = (0, $1b787e0b76fef54a$export$4904432a68b0399)(bounds);
        if (!bounds.isValid()) throw new Error("Bounds are not valid.");
        var target = this._getBoundsCenterZoom(bounds, options);
        return this.setView(target.center, target.zoom, options);
    },
    // @method fitWorld(options?: fitBounds options): this
    // Sets a map view that mostly contains the whole world with the maximum
    // zoom level possible.
    fitWorld: function(options) {
        return this.fitBounds([
            [
                -90,
                -180
            ],
            [
                90,
                180
            ]
        ], options);
    },
    // @method panTo(latlng: LatLng, options?: Pan options): this
    // Pans the map to a given center.
    panTo: function(center, options) {
        return this.setView(center, this._zoom, {
            pan: options
        });
    },
    // @method panBy(offset: Point, options?: Pan options): this
    // Pans the map by a given number of pixels (animated).
    panBy: function(offset, options) {
        offset = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(offset).round();
        options = options || {};
        if (!offset.x && !offset.y) return this.fire("moveend");
        // If we pan too far, Chrome gets issues with tiles
        // and makes them disappear or appear in the wrong place (slightly offset) #2602
        if (options.animate !== true && !this.getSize().contains(offset)) {
            this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
            return this;
        }
        if (!this._panAnim) {
            this._panAnim = new (0, $96140b52804261c8$export$51243ffcd383b20)();
            this._panAnim.on({
                "step": this._onPanTransitionStep,
                "end": this._onPanTransitionEnd
            }, this);
        }
        // don't fire movestart if animating inertia
        if (!options.noMoveStart) this.fire("movestart");
        // animate pan unless animate: false specified
        if (options.animate !== false) {
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._mapPane, "leaflet-pan-anim");
            var newPos = this._getMapPanePos().subtract(offset).round();
            this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
        } else {
            this._rawPanBy(offset);
            this.fire("move").fire("moveend");
        }
        return this;
    },
    // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
    // Sets the view of the map (geographical center and zoom) performing a smooth
    // pan-zoom animation.
    flyTo: function(targetCenter, targetZoom, options) {
        options = options || {};
        if (options.animate === false || !(0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d) return this.setView(targetCenter, targetZoom, options);
        this._stop();
        var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
        targetCenter = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(targetCenter);
        targetZoom = targetZoom === undefined ? startZoom : targetZoom;
        var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
        function r(i) {
            var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
            // workaround for floating point precision bug when sq = 0, log = -Infinite,
            // thus triggering an infinite loop in flyTo
            var log = sq < 0.000000001 ? -18 : Math.log(sq);
            return log;
        }
        function sinh(n) {
            return (Math.exp(n) - Math.exp(-n)) / 2;
        }
        function cosh(n) {
            return (Math.exp(n) + Math.exp(-n)) / 2;
        }
        function tanh(n) {
            return sinh(n) / cosh(n);
        }
        var r0 = r(0);
        function w(s) {
            return w0 * (cosh(r0) / cosh(r0 + rho * s));
        }
        function u(s) {
            return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
        }
        function easeOut(t) {
            return 1 - Math.pow(1 - t, 1.5);
        }
        var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
        function frame() {
            var t = (Date.now() - start) / duration, s = easeOut(t) * S;
            if (t <= 1) {
                this._flyToFrame = $78a895d83da22602$export$d371ad015c199c06(frame, this);
                this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                    flyTo: true
                });
            } else this._move(targetCenter, targetZoom)._moveEnd(true);
        }
        this._moveStart(true, options.noMoveStart);
        frame.call(this);
        return this;
    },
    // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
    // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
    // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
    flyToBounds: function(bounds, options) {
        var target = this._getBoundsCenterZoom(bounds, options);
        return this.flyTo(target.center, target.zoom, options);
    },
    // @method setMaxBounds(bounds: LatLngBounds): this
    // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
    setMaxBounds: function(bounds) {
        bounds = (0, $1b787e0b76fef54a$export$4904432a68b0399)(bounds);
        if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
        if (!bounds.isValid()) {
            this.options.maxBounds = null;
            return this;
        }
        this.options.maxBounds = bounds;
        if (this._loaded) this._panInsideMaxBounds();
        return this.on("moveend", this._panInsideMaxBounds);
    },
    // @method setMinZoom(zoom: Number): this
    // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
    setMinZoom: function(zoom) {
        var oldZoom = this.options.minZoom;
        this.options.minZoom = zoom;
        if (this._loaded && oldZoom !== zoom) {
            this.fire("zoomlevelschange");
            if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
        }
        return this;
    },
    // @method setMaxZoom(zoom: Number): this
    // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
    setMaxZoom: function(zoom) {
        var oldZoom = this.options.maxZoom;
        this.options.maxZoom = zoom;
        if (this._loaded && oldZoom !== zoom) {
            this.fire("zoomlevelschange");
            if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
        }
        return this;
    },
    // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
    // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
    panInsideBounds: function(bounds, options) {
        this._enforcingBounds = true;
        var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, (0, $1b787e0b76fef54a$export$4904432a68b0399)(bounds));
        if (!center.equals(newCenter)) this.panTo(newCenter, options);
        this._enforcingBounds = false;
        return this;
    },
    // @method panInside(latlng: LatLng, options?: padding options): this
    // Pans the map the minimum amount to make the `latlng` visible. Use
    // padding options to fit the display to more restricted bounds.
    // If `latlng` is already within the (optionally padded) display bounds,
    // the map will not be panned.
    panInside: function(latlng, options) {
        options = options || {};
        var paddingTL = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(options.paddingTopLeft || options.padding || [
            0,
            0
        ]), paddingBR = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(options.paddingBottomRight || options.padding || [
            0,
            0
        ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)([
            pixelBounds.min.add(paddingTL),
            pixelBounds.max.subtract(paddingBR)
        ]), paddedSize = paddedBounds.getSize();
        if (!paddedBounds.contains(pixelPoint)) {
            this._enforcingBounds = true;
            var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
            var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
            pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
            pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
            this.panTo(this.unproject(pixelCenter), options);
            this._enforcingBounds = false;
        }
        return this;
    },
    // @method invalidateSize(options: Zoom/pan options): this
    // Checks if the map container size changed and updates the map if so —
    // call it after you've changed the map size dynamically, also animating
    // pan by default. If `options.pan` is `false`, panning will not occur.
    // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
    // that it doesn't happen often even if the method is called many
    // times in a row.
    // @alternative
    // @method invalidateSize(animate: Boolean): this
    // Checks if the map container size changed and updates the map if so —
    // call it after you've changed the map size dynamically, also animating
    // pan by default.
    invalidateSize: function(options) {
        if (!this._loaded) return this;
        options = $78a895d83da22602$export$8b58be045bf06082({
            animate: false,
            pan: true
        }, options === true ? {
            animate: true
        } : options);
        var oldSize = this.getSize();
        this._sizeChanged = true;
        this._lastCenter = null;
        var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
        if (!offset.x && !offset.y) return this;
        if (options.animate && options.pan) this.panBy(offset);
        else {
            if (options.pan) this._rawPanBy(offset);
            this.fire("move");
            if (options.debounceMoveend) {
                clearTimeout(this._sizeTimer);
                this._sizeTimer = setTimeout($78a895d83da22602$export$2385a24977818dd0(this.fire, this, "moveend"), 200);
            } else this.fire("moveend");
        }
        // @section Map state change events
        // @event resize: ResizeEvent
        // Fired when the map is resized.
        return this.fire("resize", {
            oldSize: oldSize,
            newSize: newSize
        });
    },
    // @section Methods for modifying map state
    // @method stop(): this
    // Stops the currently running `panTo` or `flyTo` animation, if any.
    stop: function() {
        this.setZoom(this._limitZoom(this._zoom));
        if (!this.options.zoomSnap) this.fire("viewreset");
        return this._stop();
    },
    // @section Geolocation methods
    // @method locate(options?: Locate options): this
    // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
    // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
    // and optionally sets the map view to the user's location with respect to
    // detection accuracy (or to the world view if geolocation failed).
    // Note that, if your page doesn't use HTTPS, this method will fail in
    // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
    // See `Locate options` for more details.
    locate: function(options) {
        options = this._locateOptions = $78a895d83da22602$export$8b58be045bf06082({
            timeout: 10000,
            watch: false
        }, options);
        if (!("geolocation" in navigator)) {
            this._handleGeolocationError({
                code: 0,
                message: "Geolocation not supported."
            });
            return this;
        }
        var onResponse = $78a895d83da22602$export$2385a24977818dd0(this._handleGeolocationResponse, this), onError = $78a895d83da22602$export$2385a24977818dd0(this._handleGeolocationError, this);
        if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
        else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
        return this;
    },
    // @method stopLocate(): this
    // Stops watching location previously initiated by `map.locate({watch: true})`
    // and aborts resetting the map view if map.locate was called with
    // `{setView: true}`.
    stopLocate: function() {
        if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
        if (this._locateOptions) this._locateOptions.setView = false;
        return this;
    },
    _handleGeolocationError: function(error) {
        if (!this._container._leaflet_id) return;
        var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
        if (this._locateOptions.setView && !this._loaded) this.fitWorld();
        // @section Location events
        // @event locationerror: ErrorEvent
        // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
        this.fire("locationerror", {
            code: c,
            message: "Geolocation error: " + message + "."
        });
    },
    _handleGeolocationResponse: function(pos) {
        if (!this._container._leaflet_id) return;
        var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
        if (options.setView) {
            var zoom = this.getBoundsZoom(bounds);
            this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
        }
        var data = {
            latlng: latlng,
            bounds: bounds,
            timestamp: pos.timestamp
        };
        for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
        // @event locationfound: LocationEvent
        // Fired when geolocation (using the [`locate`](#map-locate) method)
        // went successfully.
        this.fire("locationfound", data);
    },
    // TODO Appropriate docs section?
    // @section Other Methods
    // @method addHandler(name: String, HandlerClass: Function): this
    // Adds a new `Handler` to the map, given its name and constructor function.
    addHandler: function(name, HandlerClass) {
        if (!HandlerClass) return this;
        var handler = this[name] = new HandlerClass(this);
        this._handlers.push(handler);
        if (this.options[name]) handler.enable();
        return this;
    },
    // @method remove(): this
    // Destroys the map and clears all related event listeners.
    remove: function() {
        this._initEvents(true);
        if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
        if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
        try {
            // throws error in IE6-8
            delete this._container._leaflet_id;
            delete this._containerId;
        } catch (e) {
            /*eslint-disable */ this._container._leaflet_id = undefined;
            /* eslint-enable */ this._containerId = undefined;
        }
        if (this._locationWatchId !== undefined) this.stopLocate();
        this._stop();
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._mapPane);
        if (this._clearControlPos) this._clearControlPos();
        if (this._resizeRequest) {
            $78a895d83da22602$export$e1ed83507f55dc9d(this._resizeRequest);
            this._resizeRequest = null;
        }
        this._clearHandlers();
        if (this._loaded) // @section Map state change events
        // @event unload: Event
        // Fired when the map is destroyed with [remove](#map-remove) method.
        this.fire("unload");
        var i;
        for(i in this._layers)this._layers[i].remove();
        for(i in this._panes)$b316889e4737b9d0$export$cd7f480d6b8286c3(this._panes[i]);
        this._layers = [];
        this._panes = [];
        delete this._mapPane;
        delete this._renderer;
        return this;
    },
    // @section Other Methods
    // @method createPane(name: String, container?: HTMLElement): HTMLElement
    // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
    // then returns it. The pane is created as a child of `container`, or
    // as a child of the main map pane if not set.
    createPane: function(name, container) {
        var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = $b316889e4737b9d0$export$185802fd694ee1f5("div", className, container || this._mapPane);
        if (name) this._panes[name] = pane;
        return pane;
    },
    // @section Methods for Getting Map State
    // @method getCenter(): LatLng
    // Returns the geographical center of the map view
    getCenter: function() {
        this._checkIfLoaded();
        if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
        return this.layerPointToLatLng(this._getCenterLayerPoint());
    },
    // @method getZoom(): Number
    // Returns the current zoom level of the map view
    getZoom: function() {
        return this._zoom;
    },
    // @method getBounds(): LatLngBounds
    // Returns the geographical bounds visible in the current map view
    getBounds: function() {
        var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
        return new (0, $1b787e0b76fef54a$export$fe84d4076a55a8e6)(sw, ne);
    },
    // @method getMinZoom(): Number
    // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
    getMinZoom: function() {
        return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
    },
    // @method getMaxZoom(): Number
    // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
    getMaxZoom: function() {
        return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
    },
    // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
    // Returns the maximum zoom level on which the given bounds fit to the map
    // view in its entirety. If `inside` (optional) is set to `true`, the method
    // instead returns the minimum zoom level on which the map view fits into
    // the given bounds in its entirety.
    getBoundsZoom: function(bounds, inside, padding) {
        bounds = (0, $1b787e0b76fef54a$export$4904432a68b0399)(bounds);
        padding = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(padding || [
            0,
            0
        ]);
        var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
        zoom = this.getScaleZoom(scale, zoom);
        if (snap) {
            zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
            zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
        }
        return Math.max(min, Math.min(max, zoom));
    },
    // @method getSize(): Point
    // Returns the current size of the map container (in pixels).
    getSize: function() {
        if (!this._size || this._sizeChanged) {
            this._size = new (0, $0552a615fcf79927$export$baf26146a414f24a)(this._container.clientWidth || 0, this._container.clientHeight || 0);
            this._sizeChanged = false;
        }
        return this._size.clone();
    },
    // @method getPixelBounds(): Bounds
    // Returns the bounds of the current map view in projected pixel
    // coordinates (sometimes useful in layer and overlay implementations).
    getPixelBounds: function(center, zoom) {
        var topLeftPoint = this._getTopLeftPoint(center, zoom);
        return new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(topLeftPoint, topLeftPoint.add(this.getSize()));
    },
    // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
    // the map pane? "left point of the map layer" can be confusing, specially
    // since there can be negative offsets.
    // @method getPixelOrigin(): Point
    // Returns the projected pixel coordinates of the top left point of
    // the map layer (useful in custom layer and overlay implementations).
    getPixelOrigin: function() {
        this._checkIfLoaded();
        return this._pixelOrigin;
    },
    // @method getPixelWorldBounds(zoom?: Number): Bounds
    // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
    // If `zoom` is omitted, the map's current zoom level is used.
    getPixelWorldBounds: function(zoom) {
        return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
    },
    // @section Other Methods
    // @method getPane(pane: String|HTMLElement): HTMLElement
    // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
    getPane: function(pane) {
        return typeof pane === "string" ? this._panes[pane] : pane;
    },
    // @method getPanes(): Object
    // Returns a plain object containing the names of all [panes](#map-pane) as keys and
    // the panes as values.
    getPanes: function() {
        return this._panes;
    },
    // @method getContainer: HTMLElement
    // Returns the HTML element that contains the map.
    getContainer: function() {
        return this._container;
    },
    // @section Conversion Methods
    // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
    // Returns the scale factor to be applied to a map transition from zoom level
    // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
    getZoomScale: function(toZoom, fromZoom) {
        // TODO replace with universal implementation after refactoring projections
        var crs = this.options.crs;
        fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
        return crs.scale(toZoom) / crs.scale(fromZoom);
    },
    // @method getScaleZoom(scale: Number, fromZoom: Number): Number
    // Returns the zoom level that the map would end up at, if it is at `fromZoom`
    // level and everything is scaled by a factor of `scale`. Inverse of
    // [`getZoomScale`](#map-getZoomScale).
    getScaleZoom: function(scale, fromZoom) {
        var crs = this.options.crs;
        fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
        var zoom = crs.zoom(scale * crs.scale(fromZoom));
        return isNaN(zoom) ? Infinity : zoom;
    },
    // @method project(latlng: LatLng, zoom: Number): Point
    // Projects a geographical coordinate `LatLng` according to the projection
    // of the map's CRS, then scales it according to `zoom` and the CRS's
    // `Transformation`. The result is pixel coordinate relative to
    // the CRS origin.
    project: function(latlng, zoom) {
        zoom = zoom === undefined ? this._zoom : zoom;
        return this.options.crs.latLngToPoint((0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng), zoom);
    },
    // @method unproject(point: Point, zoom: Number): LatLng
    // Inverse of [`project`](#map-project).
    unproject: function(point, zoom) {
        zoom = zoom === undefined ? this._zoom : zoom;
        return this.options.crs.pointToLatLng((0, $0552a615fcf79927$export$b63cca88ddc558a9)(point), zoom);
    },
    // @method layerPointToLatLng(point: Point): LatLng
    // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
    // returns the corresponding geographical coordinate (for the current zoom level).
    layerPointToLatLng: function(point) {
        var projectedPoint = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(point).add(this.getPixelOrigin());
        return this.unproject(projectedPoint);
    },
    // @method latLngToLayerPoint(latlng: LatLng): Point
    // Given a geographical coordinate, returns the corresponding pixel coordinate
    // relative to the [origin pixel](#map-getpixelorigin).
    latLngToLayerPoint: function(latlng) {
        var projectedPoint = this.project((0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng))._round();
        return projectedPoint._subtract(this.getPixelOrigin());
    },
    // @method wrapLatLng(latlng: LatLng): LatLng
    // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
    // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
    // CRS's bounds.
    // By default this means longitude is wrapped around the dateline so its
    // value is between -180 and +180 degrees.
    wrapLatLng: function(latlng) {
        return this.options.crs.wrapLatLng((0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng));
    },
    // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
    // Returns a `LatLngBounds` with the same size as the given one, ensuring that
    // its center is within the CRS's bounds.
    // By default this means the center longitude is wrapped around the dateline so its
    // value is between -180 and +180 degrees, and the majority of the bounds
    // overlaps the CRS's bounds.
    wrapLatLngBounds: function(latlng) {
        return this.options.crs.wrapLatLngBounds((0, $1b787e0b76fef54a$export$4904432a68b0399)(latlng));
    },
    // @method distance(latlng1: LatLng, latlng2: LatLng): Number
    // Returns the distance between two geographical coordinates according to
    // the map's CRS. By default this measures distance in meters.
    distance: function(latlng1, latlng2) {
        return this.options.crs.distance((0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng1), (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng2));
    },
    // @method containerPointToLayerPoint(point: Point): Point
    // Given a pixel coordinate relative to the map container, returns the corresponding
    // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
    containerPointToLayerPoint: function(point) {
        return (0, $0552a615fcf79927$export$b63cca88ddc558a9)(point).subtract(this._getMapPanePos());
    },
    // @method layerPointToContainerPoint(point: Point): Point
    // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
    // returns the corresponding pixel coordinate relative to the map container.
    layerPointToContainerPoint: function(point) {
        return (0, $0552a615fcf79927$export$b63cca88ddc558a9)(point).add(this._getMapPanePos());
    },
    // @method containerPointToLatLng(point: Point): LatLng
    // Given a pixel coordinate relative to the map container, returns
    // the corresponding geographical coordinate (for the current zoom level).
    containerPointToLatLng: function(point) {
        var layerPoint = this.containerPointToLayerPoint((0, $0552a615fcf79927$export$b63cca88ddc558a9)(point));
        return this.layerPointToLatLng(layerPoint);
    },
    // @method latLngToContainerPoint(latlng: LatLng): Point
    // Given a geographical coordinate, returns the corresponding pixel coordinate
    // relative to the map container.
    latLngToContainerPoint: function(latlng) {
        return this.layerPointToContainerPoint(this.latLngToLayerPoint((0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng)));
    },
    // @method mouseEventToContainerPoint(ev: MouseEvent): Point
    // Given a MouseEvent object, returns the pixel coordinate relative to the
    // map container where the event took place.
    mouseEventToContainerPoint: function(e) {
        return $7c9dd72411ef2269$export$642213d516a9b928(e, this._container);
    },
    // @method mouseEventToLayerPoint(ev: MouseEvent): Point
    // Given a MouseEvent object, returns the pixel coordinate relative to
    // the [origin pixel](#map-getpixelorigin) where the event took place.
    mouseEventToLayerPoint: function(e) {
        return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
    },
    // @method mouseEventToLatLng(ev: MouseEvent): LatLng
    // Given a MouseEvent object, returns geographical coordinate where the
    // event took place.
    mouseEventToLatLng: function(e) {
        return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
    },
    // map initialization methods
    _initContainer: function(id) {
        var container = this._container = $b316889e4737b9d0$export$3988ae62b71be9a3(id);
        if (!container) throw new Error("Map container not found.");
        else if (container._leaflet_id) throw new Error("Map container is already initialized.");
        $7c9dd72411ef2269$export$af631764ddc44097(container, "scroll", this._onScroll, this);
        this._containerId = $78a895d83da22602$export$bd3fba034e28f6b(container);
    },
    _initLayout: function() {
        var container = this._container;
        this._fadeAnimated = this.options.fadeAnimation && (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d;
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(container, "leaflet-container" + ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).touch ? " leaflet-touch" : "") + ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).retina ? " leaflet-retina" : "") + ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).ielt9 ? " leaflet-oldie" : "") + ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
        var position = $b316889e4737b9d0$export$3d2f074408bd1b82(container, "position");
        if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
        this._initPanes();
        if (this._initControlPos) this._initControlPos();
    },
    _initPanes: function() {
        var panes = this._panes = {};
        this._paneRenderers = {};
        // @section
        //
        // Panes are DOM elements used to control the ordering of layers on the map. You
        // can access panes with [`map.getPane`](#map-getpane) or
        // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
        // [`map.createPane`](#map-createpane) method.
        //
        // Every map has the following default panes that differ only in zIndex.
        //
        // @pane mapPane: HTMLElement = 'auto'
        // Pane that contains all other map panes
        this._mapPane = this.createPane("mapPane", this._container);
        $b316889e4737b9d0$export$f9b088a47202d605(this._mapPane, new (0, $0552a615fcf79927$export$baf26146a414f24a)(0, 0));
        // @pane tilePane: HTMLElement = 200
        // Pane for `GridLayer`s and `TileLayer`s
        this.createPane("tilePane");
        // @pane overlayPane: HTMLElement = 400
        // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
        this.createPane("overlayPane");
        // @pane shadowPane: HTMLElement = 500
        // Pane for overlay shadows (e.g. `Marker` shadows)
        this.createPane("shadowPane");
        // @pane markerPane: HTMLElement = 600
        // Pane for `Icon`s of `Marker`s
        this.createPane("markerPane");
        // @pane tooltipPane: HTMLElement = 650
        // Pane for `Tooltip`s.
        this.createPane("tooltipPane");
        // @pane popupPane: HTMLElement = 700
        // Pane for `Popup`s.
        this.createPane("popupPane");
        if (!this.options.markerZoomAnimation) {
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(panes.markerPane, "leaflet-zoom-hide");
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(panes.shadowPane, "leaflet-zoom-hide");
        }
    },
    // private methods that modify map state
    // @section Map state change events
    _resetView: function(center, zoom, noMoveStart) {
        $b316889e4737b9d0$export$f9b088a47202d605(this._mapPane, new (0, $0552a615fcf79927$export$baf26146a414f24a)(0, 0));
        var loading = !this._loaded;
        this._loaded = true;
        zoom = this._limitZoom(zoom);
        this.fire("viewprereset");
        var zoomChanged = this._zoom !== zoom;
        this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
        // @event viewreset: Event
        // Fired when the map needs to redraw its content (this usually happens
        // on map zoom or load). Very useful for creating custom overlays.
        this.fire("viewreset");
        // @event load: Event
        // Fired when the map is initialized (when its center and zoom are set
        // for the first time).
        if (loading) this.fire("load");
    },
    _moveStart: function(zoomChanged, noMoveStart) {
        // @event zoomstart: Event
        // Fired when the map zoom is about to change (e.g. before zoom animation).
        // @event movestart: Event
        // Fired when the view of the map starts changing (e.g. user starts dragging the map).
        if (zoomChanged) this.fire("zoomstart");
        if (!noMoveStart) this.fire("movestart");
        return this;
    },
    _move: function(center, zoom, data, supressEvent) {
        if (zoom === undefined) zoom = this._zoom;
        var zoomChanged = this._zoom !== zoom;
        this._zoom = zoom;
        this._lastCenter = center;
        this._pixelOrigin = this._getNewPixelOrigin(center);
        if (!supressEvent) {
            // @event zoom: Event
            // Fired repeatedly during any change in zoom level,
            // including zoom and fly animations.
            if (zoomChanged || data && data.pinch) this.fire("zoom", data);
            // @event move: Event
            // Fired repeatedly during any movement of the map,
            // including pan and fly animations.
            this.fire("move", data);
        } else if (data && data.pinch) this.fire("zoom", data);
        return this;
    },
    _moveEnd: function(zoomChanged) {
        // @event zoomend: Event
        // Fired when the map zoom changed, after any animations.
        if (zoomChanged) this.fire("zoomend");
        // @event moveend: Event
        // Fired when the center of the map stops changing
        // (e.g. user stopped dragging the map or after non-centered zoom).
        return this.fire("moveend");
    },
    _stop: function() {
        $78a895d83da22602$export$e1ed83507f55dc9d(this._flyToFrame);
        if (this._panAnim) this._panAnim.stop();
        return this;
    },
    _rawPanBy: function(offset) {
        $b316889e4737b9d0$export$f9b088a47202d605(this._mapPane, this._getMapPanePos().subtract(offset));
    },
    _getZoomSpan: function() {
        return this.getMaxZoom() - this.getMinZoom();
    },
    _panInsideMaxBounds: function() {
        if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
    },
    _checkIfLoaded: function() {
        if (!this._loaded) throw new Error("Set map center and zoom first.");
    },
    // DOM event handling
    // @section Interaction events
    _initEvents: function(remove) {
        this._targets = {};
        this._targets[$78a895d83da22602$export$bd3fba034e28f6b(this._container)] = this;
        var onOff = remove ? $7c9dd72411ef2269$export$8c8705df4a2dcec9 : $7c9dd72411ef2269$export$af631764ddc44097;
        // @event click: MouseEvent
        // Fired when the user clicks (or taps) the map.
        // @event dblclick: MouseEvent
        // Fired when the user double-clicks (or double-taps) the map.
        // @event mousedown: MouseEvent
        // Fired when the user pushes the mouse button on the map.
        // @event mouseup: MouseEvent
        // Fired when the user releases the mouse button on the map.
        // @event mouseover: MouseEvent
        // Fired when the mouse enters the map.
        // @event mouseout: MouseEvent
        // Fired when the mouse leaves the map.
        // @event mousemove: MouseEvent
        // Fired while the mouse moves over the map.
        // @event contextmenu: MouseEvent
        // Fired when the user pushes the right mouse button on the map, prevents
        // default browser context menu from showing if there are listeners on
        // this event. Also fired on mobile when the user holds a single touch
        // for a second (also called long press).
        // @event keypress: KeyboardEvent
        // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
        // @event keydown: KeyboardEvent
        // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
        // the `keydown` event is fired for keys that produce a character value and for keys
        // that do not produce a character value.
        // @event keyup: KeyboardEvent
        // Fired when the user releases a key from the keyboard while the map is focused.
        onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
        if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
        if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
    },
    _onResize: function() {
        $78a895d83da22602$export$e1ed83507f55dc9d(this._resizeRequest);
        this._resizeRequest = $78a895d83da22602$export$d371ad015c199c06(function() {
            this.invalidateSize({
                debounceMoveend: true
            });
        }, this);
    },
    _onScroll: function() {
        this._container.scrollTop = 0;
        this._container.scrollLeft = 0;
    },
    _onMoveEnd: function() {
        var pos = this._getMapPanePos();
        if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
        // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
        this._resetView(this.getCenter(), this.getZoom());
    },
    _findEventTargets: function(e, type) {
        var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
        while(src){
            target = this._targets[$78a895d83da22602$export$bd3fba034e28f6b(src)];
            if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                // Prevent firing click after you just dragged an object.
                dragging = true;
                break;
            }
            if (target && target.listens(type, true)) {
                if (isHover && !$7c9dd72411ef2269$export$de90706eda23efa2(src, e)) break;
                targets.push(target);
                if (isHover) break;
            }
            if (src === this._container) break;
            src = src.parentNode;
        }
        if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
            this
        ];
        return targets;
    },
    _isClickDisabled: function(el) {
        while(el && el !== this._container){
            if (el["_leaflet_disable_click"]) return true;
            el = el.parentNode;
        }
    },
    _handleDOMEvent: function(e) {
        var el = e.target || e.srcElement;
        if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
        var type = e.type;
        if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
        $b316889e4737b9d0$export$73d26a0c96b464b6(el);
        this._fireDOMEvent(e, type);
    },
    _mouseEvents: [
        "click",
        "dblclick",
        "mouseover",
        "mouseout",
        "contextmenu"
    ],
    _fireDOMEvent: function(e, type, canvasTargets) {
        if (e.type === "click") {
            // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
            // @event preclick: MouseEvent
            // Fired before mouse click on the map (sometimes useful when you
            // want something to happen on click before any existing click
            // handlers start running).
            var synth = $78a895d83da22602$export$8b58be045bf06082({}, e);
            synth.type = "preclick";
            this._fireDOMEvent(synth, synth.type, canvasTargets);
        }
        // Find the layer the event is propagating from and its parents.
        var targets = this._findEventTargets(e, type);
        if (canvasTargets) {
            var filtered = []; // pick only targets with listeners
            for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
            targets = filtered.concat(targets);
        }
        if (!targets.length) return;
        if (type === "contextmenu") $7c9dd72411ef2269$export$fa3b29edae795ef4(e);
        var target = targets[0];
        var data = {
            originalEvent: e
        };
        if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
            var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
            data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
            data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
            data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
        }
        for(i = 0; i < targets.length; i++){
            targets[i].fire(type, data, true);
            if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && $78a895d83da22602$export$305f7d4e9d4624f2(this._mouseEvents, type) !== -1) return;
        }
    },
    _draggableMoved: function(obj) {
        obj = obj.dragging && obj.dragging.enabled() ? obj : this;
        return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
    },
    _clearHandlers: function() {
        for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
    },
    // @section Other Methods
    // @method whenReady(fn: Function, context?: Object): this
    // Runs the given function `fn` when the map gets initialized with
    // a view (center and zoom) and at least one layer, or immediately
    // if it's already initialized, optionally passing a function context.
    whenReady: function(callback, context) {
        if (this._loaded) callback.call(context || this, {
            target: this
        });
        else this.on("load", callback, context);
        return this;
    },
    // private methods for getting map state
    _getMapPanePos: function() {
        return $b316889e4737b9d0$export$1690e12b840569b9(this._mapPane) || new (0, $0552a615fcf79927$export$baf26146a414f24a)(0, 0);
    },
    _moved: function() {
        var pos = this._getMapPanePos();
        return pos && !pos.equals([
            0,
            0
        ]);
    },
    _getTopLeftPoint: function(center, zoom) {
        var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
        return pixelOrigin.subtract(this._getMapPanePos());
    },
    _getNewPixelOrigin: function(center, zoom) {
        var viewHalf = this.getSize()._divideBy(2);
        return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
    },
    _latLngToNewLayerPoint: function(latlng, zoom, center) {
        var topLeft = this._getNewPixelOrigin(center, zoom);
        return this.project(latlng, zoom)._subtract(topLeft);
    },
    _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
        var topLeft = this._getNewPixelOrigin(center, zoom);
        return (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)([
            this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
            this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
            this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
            this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
        ]);
    },
    // layer point of the current center
    _getCenterLayerPoint: function() {
        return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
    },
    // offset of the specified place to the current center in pixels
    _getCenterOffset: function(latlng) {
        return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
    },
    // adjust center for view to get inside bounds
    _limitCenter: function(center, zoom, bounds) {
        if (!bounds) return center;
        var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
        // If offset is less than a pixel, ignore.
        // This prevents unstable projections from getting into
        // an infinite loop of tiny offsets.
        if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
        return this.unproject(centerPoint.add(offset), zoom);
    },
    // adjust offset for view to get inside bounds
    _limitOffset: function(offset, bounds) {
        if (!bounds) return offset;
        var viewBounds = this.getPixelBounds(), newBounds = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(viewBounds.min.add(offset), viewBounds.max.add(offset));
        return offset.add(this._getBoundsOffset(newBounds, bounds));
    },
    // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
    _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
        var projectedMaxBounds = (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
        return new (0, $0552a615fcf79927$export$baf26146a414f24a)(dx, dy);
    },
    _rebound: function(left, right) {
        return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
    },
    _limitZoom: function(zoom) {
        var min = this.getMinZoom(), max = this.getMaxZoom(), snap = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d ? this.options.zoomSnap : 1;
        if (snap) zoom = Math.round(zoom / snap) * snap;
        return Math.max(min, Math.min(max, zoom));
    },
    _onPanTransitionStep: function() {
        this.fire("move");
    },
    _onPanTransitionEnd: function() {
        $b316889e4737b9d0$export$c2255604a80b4506(this._mapPane, "leaflet-pan-anim");
        this.fire("moveend");
    },
    _tryAnimatedPan: function(center, options) {
        // difference between the new and current centers in pixels
        var offset = this._getCenterOffset(center)._trunc();
        // don't animate too far unless animate: true specified in options
        if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
        this.panBy(offset, options);
        return true;
    },
    _createAnimProxy: function() {
        var proxy = this._proxy = $b316889e4737b9d0$export$185802fd694ee1f5("div", "leaflet-proxy leaflet-zoom-animated");
        this._panes.mapPane.appendChild(proxy);
        this.on("zoomanim", function(e) {
            var prop = $b316889e4737b9d0$export$e3fc61237fe28123, transform = this._proxy.style[prop];
            $b316889e4737b9d0$export$ff09356c35bee89b(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
            // workaround for case when transform is the same and so transitionend event is not fired
            if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
        }, this);
        this.on("load moveend", this._animMoveEnd, this);
        this._on("unload", this._destroyAnimProxy, this);
    },
    _destroyAnimProxy: function() {
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._proxy);
        this.off("load moveend", this._animMoveEnd, this);
        delete this._proxy;
    },
    _animMoveEnd: function() {
        var c = this.getCenter(), z = this.getZoom();
        $b316889e4737b9d0$export$ff09356c35bee89b(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
    },
    _catchTransitionEnd: function(e) {
        if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
    },
    _nothingToAnimate: function() {
        return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
    },
    _tryAnimatedZoom: function(center, zoom, options) {
        if (this._animatingZoom) return true;
        options = options || {};
        // don't animate if disabled, not supported or zoom difference is too large
        if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
        // offset is the pixel coords of the zoom origin relative to the current center
        var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
        // don't animate if the zoom origin isn't within one screen from the current center, unless forced
        if (options.animate !== true && !this.getSize().contains(offset)) return false;
        $78a895d83da22602$export$d371ad015c199c06(function() {
            this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
        }, this);
        return true;
    },
    _animateZoom: function(center, zoom, startAnim, noUpdate) {
        if (!this._mapPane) return;
        if (startAnim) {
            this._animatingZoom = true;
            // remember what center/zoom to set after animation
            this._animateToCenter = center;
            this._animateToZoom = zoom;
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._mapPane, "leaflet-zoom-anim");
        }
        // @section Other Events
        // @event zoomanim: ZoomAnimEvent
        // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
        this.fire("zoomanim", {
            center: center,
            zoom: zoom,
            noUpdate: noUpdate
        });
        if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
        this._move(this._animateToCenter, this._animateToZoom, undefined, true);
        // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
        setTimeout($78a895d83da22602$export$2385a24977818dd0(this._onZoomTransitionEnd, this), 250);
    },
    _onZoomTransitionEnd: function() {
        if (!this._animatingZoom) return;
        if (this._mapPane) $b316889e4737b9d0$export$c2255604a80b4506(this._mapPane, "leaflet-zoom-anim");
        this._animatingZoom = false;
        this._move(this._animateToCenter, this._animateToZoom, undefined, true);
        if (this._tempFireZoomEvent) this.fire("zoom");
        delete this._tempFireZoomEvent;
        this.fire("move");
        this._moveEnd(true);
    }
});
function $a14ca6047db5cfcd$export$d49c9aa30b771d59(id, options) {
    return new $a14ca6047db5cfcd$export$a5c7b93649eaf8f8(id, options);
}




var $833ac8fc109549bc$export$7a7fa4424cb20976 = (0, $a5dc067f35738c55$export$4c85e640eb41c31b).extend({
    // @section
    // @aka Control Options
    options: {
        // @option position: String = 'topright'
        // The position of the control (one of the map corners). Possible values are `'topleft'`,
        // `'topright'`, `'bottomleft'` or `'bottomright'`
        position: "topright"
    },
    initialize: function(options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
    },
    /* @section
	 * Classes extending L.Control will inherit the following methods:
	 *
	 * @method getPosition: string
	 * Returns the position of the control.
	 */ getPosition: function() {
        return this.options.position;
    },
    // @method setPosition(position: string): this
    // Sets the position of the control.
    setPosition: function(position) {
        var map = this._map;
        if (map) map.removeControl(this);
        this.options.position = position;
        if (map) map.addControl(this);
        return this;
    },
    // @method getContainer: HTMLElement
    // Returns the HTMLElement that contains the control.
    getContainer: function() {
        return this._container;
    },
    // @method addTo(map: Map): this
    // Adds the control to the given map.
    addTo: function(map) {
        this.remove();
        this._map = map;
        var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(container, "leaflet-control");
        if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
        else corner.appendChild(container);
        this._map.on("unload", this.remove, this);
        return this;
    },
    // @method remove: this
    // Removes the control from the map it is currently active on.
    remove: function() {
        if (!this._map) return this;
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._container);
        if (this.onRemove) this.onRemove(this._map);
        this._map.off("unload", this.remove, this);
        this._map = null;
        return this;
    },
    _refocusOnMap: function(e) {
        // if map exists and event is not a keyboard event
        if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
    }
});
var $833ac8fc109549bc$export$b5cde1de278b4330 = function(options) {
    return new $833ac8fc109549bc$export$7a7fa4424cb20976(options);
};
/* @section Extension methods
 * @uninheritable
 *
 * Every control should extend from `L.Control` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): HTMLElement
 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
 *
 * @method onRemove(map: Map)
 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
 */ /* @namespace Map
 * @section Methods for Layers and Controls
 */ (0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).include({
    // @method addControl(control: Control): this
    // Adds the given control to the map
    addControl: function(control) {
        control.addTo(this);
        return this;
    },
    // @method removeControl(control: Control): this
    // Removes the given control from the map
    removeControl: function(control) {
        control.remove();
        return this;
    },
    _initControlPos: function() {
        var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = $b316889e4737b9d0$export$185802fd694ee1f5("div", l + "control-container", this._container);
        function createCorner(vSide, hSide) {
            var className = l + vSide + " " + l + hSide;
            corners[vSide + hSide] = $b316889e4737b9d0$export$185802fd694ee1f5("div", className, container);
        }
        createCorner("top", "left");
        createCorner("top", "right");
        createCorner("bottom", "left");
        createCorner("bottom", "right");
    },
    _clearControlPos: function() {
        for(var i in this._controlCorners)$b316889e4737b9d0$export$cd7f480d6b8286c3(this._controlCorners[i]);
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._controlContainer);
        delete this._controlCorners;
        delete this._controlContainer;
    }
});






var $e695f66ed9e3fd52$export$89312ce47c0ca777 = (0, $833ac8fc109549bc$export$7a7fa4424cb20976).extend({
    // @section
    // @aka Control.Layers options
    options: {
        // @option collapsed: Boolean = true
        // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
        collapsed: true,
        position: "topright",
        // @option autoZIndex: Boolean = true
        // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
        autoZIndex: true,
        // @option hideSingleBase: Boolean = false
        // If `true`, the base layers in the control will be hidden when there is only one.
        hideSingleBase: false,
        // @option sortLayers: Boolean = false
        // Whether to sort the layers. When `false`, layers will keep the order
        // in which they were added to the control.
        sortLayers: false,
        // @option sortFunction: Function = *
        // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
        // that will be used for sorting the layers, when `sortLayers` is `true`.
        // The function receives both the `L.Layer` instances and their names, as in
        // `sortFunction(layerA, layerB, nameA, nameB)`.
        // By default, it sorts layers alphabetically by their name.
        sortFunction: function(layerA, layerB, nameA, nameB) {
            return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
        }
    },
    initialize: function(baseLayers, overlays, options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        this._layerControlInputs = [];
        this._layers = [];
        this._lastZIndex = 0;
        this._handlingClick = false;
        this._preventClick = false;
        for(var i in baseLayers)this._addLayer(baseLayers[i], i);
        for(i in overlays)this._addLayer(overlays[i], i, true);
    },
    onAdd: function(map) {
        this._initLayout();
        this._update();
        this._map = map;
        map.on("zoomend", this._checkDisabledLayers, this);
        for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
        return this._container;
    },
    addTo: function(map) {
        (0, $833ac8fc109549bc$export$7a7fa4424cb20976).prototype.addTo.call(this, map);
        // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
        return this._expandIfNotCollapsed();
    },
    onRemove: function() {
        this._map.off("zoomend", this._checkDisabledLayers, this);
        for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
    },
    // @method addBaseLayer(layer: Layer, name: String): this
    // Adds a base layer (radio button entry) with the given name to the control.
    addBaseLayer: function(layer, name) {
        this._addLayer(layer, name);
        return this._map ? this._update() : this;
    },
    // @method addOverlay(layer: Layer, name: String): this
    // Adds an overlay (checkbox entry) with the given name to the control.
    addOverlay: function(layer, name) {
        this._addLayer(layer, name, true);
        return this._map ? this._update() : this;
    },
    // @method removeLayer(layer: Layer): this
    // Remove the given layer from the control.
    removeLayer: function(layer) {
        layer.off("add remove", this._onLayerChange, this);
        var obj = this._getLayer($78a895d83da22602$export$bd3fba034e28f6b(layer));
        if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
        return this._map ? this._update() : this;
    },
    // @method expand(): this
    // Expand the control container if collapsed.
    expand: function() {
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._container, "leaflet-control-layers-expanded");
        this._section.style.height = null;
        var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
        if (acceptableHeight < this._section.clientHeight) {
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._section, "leaflet-control-layers-scrollbar");
            this._section.style.height = acceptableHeight + "px";
        } else $b316889e4737b9d0$export$c2255604a80b4506(this._section, "leaflet-control-layers-scrollbar");
        this._checkDisabledLayers();
        return this;
    },
    // @method collapse(): this
    // Collapse the control container if expanded.
    collapse: function() {
        $b316889e4737b9d0$export$c2255604a80b4506(this._container, "leaflet-control-layers-expanded");
        return this;
    },
    _initLayout: function() {
        var className = "leaflet-control-layers", container = this._container = $b316889e4737b9d0$export$185802fd694ee1f5("div", className), collapsed = this.options.collapsed;
        // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
        container.setAttribute("aria-haspopup", true);
        $7c9dd72411ef2269$export$a640b530813b3952(container);
        $7c9dd72411ef2269$export$383a0f6cce2d3ccb(container);
        var section = this._section = $b316889e4737b9d0$export$185802fd694ee1f5("section", className + "-list");
        if (collapsed) {
            this._map.on("click", this.collapse, this);
            $7c9dd72411ef2269$export$af631764ddc44097(container, {
                mouseenter: this._expandSafely,
                mouseleave: this.collapse
            }, this);
        }
        var link = this._layersLink = $b316889e4737b9d0$export$185802fd694ee1f5("a", className + "-toggle", container);
        link.href = "#";
        link.title = "Layers";
        link.setAttribute("role", "button");
        $7c9dd72411ef2269$export$af631764ddc44097(link, {
            keydown: function(e) {
                if (e.keyCode === 13) this._expandSafely();
            },
            // Certain screen readers intercept the key event and instead send a click event
            click: function(e) {
                $7c9dd72411ef2269$export$fa3b29edae795ef4(e);
                this._expandSafely();
            }
        }, this);
        if (!collapsed) this.expand();
        this._baseLayersList = $b316889e4737b9d0$export$185802fd694ee1f5("div", className + "-base", section);
        this._separator = $b316889e4737b9d0$export$185802fd694ee1f5("div", className + "-separator", section);
        this._overlaysList = $b316889e4737b9d0$export$185802fd694ee1f5("div", className + "-overlays", section);
        container.appendChild(section);
    },
    _getLayer: function(id) {
        for(var i = 0; i < this._layers.length; i++){
            if (this._layers[i] && $78a895d83da22602$export$bd3fba034e28f6b(this._layers[i].layer) === id) return this._layers[i];
        }
    },
    _addLayer: function(layer, name, overlay) {
        if (this._map) layer.on("add remove", this._onLayerChange, this);
        this._layers.push({
            layer: layer,
            name: name,
            overlay: overlay
        });
        if (this.options.sortLayers) this._layers.sort($78a895d83da22602$export$2385a24977818dd0(function(a, b) {
            return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
        }, this));
        if (this.options.autoZIndex && layer.setZIndex) {
            this._lastZIndex++;
            layer.setZIndex(this._lastZIndex);
        }
        this._expandIfNotCollapsed();
    },
    _update: function() {
        if (!this._container) return this;
        $b316889e4737b9d0$export$6e22c362a0406a2c(this._baseLayersList);
        $b316889e4737b9d0$export$6e22c362a0406a2c(this._overlaysList);
        this._layerControlInputs = [];
        var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
        for(i = 0; i < this._layers.length; i++){
            obj = this._layers[i];
            this._addItem(obj);
            overlaysPresent = overlaysPresent || obj.overlay;
            baseLayersPresent = baseLayersPresent || !obj.overlay;
            baseLayersCount += !obj.overlay ? 1 : 0;
        }
        // Hide base layers section if there's only one layer.
        if (this.options.hideSingleBase) {
            baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
            this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
        }
        this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
        return this;
    },
    _onLayerChange: function(e) {
        if (!this._handlingClick) this._update();
        var obj = this._getLayer($78a895d83da22602$export$bd3fba034e28f6b(e.target));
        // @namespace Map
        // @section Layer events
        // @event baselayerchange: LayersControlEvent
        // Fired when the base layer is changed through the [layers control](#control-layers).
        // @event overlayadd: LayersControlEvent
        // Fired when an overlay is selected through the [layers control](#control-layers).
        // @event overlayremove: LayersControlEvent
        // Fired when an overlay is deselected through the [layers control](#control-layers).
        // @namespace Control.Layers
        var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
        if (type) this._map.fire(type, obj);
    },
    // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
    _createRadioElement: function(name, checked) {
        var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
        var radioFragment = document.createElement("div");
        radioFragment.innerHTML = radioHtml;
        return radioFragment.firstChild;
    },
    _addItem: function(obj) {
        var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
        if (obj.overlay) {
            input = document.createElement("input");
            input.type = "checkbox";
            input.className = "leaflet-control-layers-selector";
            input.defaultChecked = checked;
        } else input = this._createRadioElement("leaflet-base-layers_" + $78a895d83da22602$export$bd3fba034e28f6b(this), checked);
        this._layerControlInputs.push(input);
        input.layerId = $78a895d83da22602$export$bd3fba034e28f6b(obj.layer);
        $7c9dd72411ef2269$export$af631764ddc44097(input, "click", this._onInputClick, this);
        var name = document.createElement("span");
        name.innerHTML = " " + obj.name;
        // Helps from preventing layer control flicker when checkboxes are disabled
        // https://github.com/Leaflet/Leaflet/issues/2771
        var holder = document.createElement("span");
        label.appendChild(holder);
        holder.appendChild(input);
        holder.appendChild(name);
        var container = obj.overlay ? this._overlaysList : this._baseLayersList;
        container.appendChild(label);
        this._checkDisabledLayers();
        return label;
    },
    _onInputClick: function() {
        // expanding the control on mobile with a click can cause adding a layer - we don't want this
        if (this._preventClick) return;
        var inputs = this._layerControlInputs, input, layer;
        var addedLayers = [], removedLayers = [];
        this._handlingClick = true;
        for(var i = inputs.length - 1; i >= 0; i--){
            input = inputs[i];
            layer = this._getLayer(input.layerId).layer;
            if (input.checked) addedLayers.push(layer);
            else if (!input.checked) removedLayers.push(layer);
        }
        // Bugfix issue 2318: Should remove all old layers before readding new ones
        for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
        for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
        this._handlingClick = false;
        this._refocusOnMap();
    },
    _checkDisabledLayers: function() {
        var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
        for(var i = inputs.length - 1; i >= 0; i--){
            input = inputs[i];
            layer = this._getLayer(input.layerId).layer;
            input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
        }
    },
    _expandIfNotCollapsed: function() {
        if (this._map && !this.options.collapsed) this.expand();
        return this;
    },
    _expandSafely: function() {
        var section = this._section;
        this._preventClick = true;
        $7c9dd72411ef2269$export$af631764ddc44097(section, "click", $7c9dd72411ef2269$export$fa3b29edae795ef4);
        this.expand();
        var that = this;
        setTimeout(function() {
            $7c9dd72411ef2269$export$8c8705df4a2dcec9(section, "click", $7c9dd72411ef2269$export$fa3b29edae795ef4);
            that._preventClick = false;
        });
    }
});
var $e695f66ed9e3fd52$export$7be255094ccdc533 = function(baseLayers, overlays, options) {
    return new $e695f66ed9e3fd52$export$89312ce47c0ca777(baseLayers, overlays, options);
};






var $311d7e7c3e466f1b$export$65cfd44a2050f99 = (0, $833ac8fc109549bc$export$7a7fa4424cb20976).extend({
    // @section
    // @aka Control.Zoom options
    options: {
        position: "topleft",
        // @option zoomInText: String = '<span aria-hidden="true">+</span>'
        // The text set on the 'zoom in' button.
        zoomInText: '<span aria-hidden="true">+</span>',
        // @option zoomInTitle: String = 'Zoom in'
        // The title set on the 'zoom in' button.
        zoomInTitle: "Zoom in",
        // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
        // The text set on the 'zoom out' button.
        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
        // @option zoomOutTitle: String = 'Zoom out'
        // The title set on the 'zoom out' button.
        zoomOutTitle: "Zoom out"
    },
    onAdd: function(map) {
        var zoomName = "leaflet-control-zoom", container = $b316889e4737b9d0$export$185802fd694ee1f5("div", zoomName + " leaflet-bar"), options = this.options;
        this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
        this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
        this._updateDisabled();
        map.on("zoomend zoomlevelschange", this._updateDisabled, this);
        return container;
    },
    onRemove: function(map) {
        map.off("zoomend zoomlevelschange", this._updateDisabled, this);
    },
    disable: function() {
        this._disabled = true;
        this._updateDisabled();
        return this;
    },
    enable: function() {
        this._disabled = false;
        this._updateDisabled();
        return this;
    },
    _zoomIn: function(e) {
        if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
    },
    _zoomOut: function(e) {
        if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
    },
    _createButton: function(html, title, className, container, fn) {
        var link = $b316889e4737b9d0$export$185802fd694ee1f5("a", className, container);
        link.innerHTML = html;
        link.href = "#";
        link.title = title;
        /*
		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
		 */ link.setAttribute("role", "button");
        link.setAttribute("aria-label", title);
        $7c9dd72411ef2269$export$a640b530813b3952(link);
        $7c9dd72411ef2269$export$af631764ddc44097(link, "click", $7c9dd72411ef2269$export$fa6813432f753b0d);
        $7c9dd72411ef2269$export$af631764ddc44097(link, "click", fn, this);
        $7c9dd72411ef2269$export$af631764ddc44097(link, "click", this._refocusOnMap, this);
        return link;
    },
    _updateDisabled: function() {
        var map = this._map, className = "leaflet-disabled";
        $b316889e4737b9d0$export$c2255604a80b4506(this._zoomInButton, className);
        $b316889e4737b9d0$export$c2255604a80b4506(this._zoomOutButton, className);
        this._zoomInButton.setAttribute("aria-disabled", "false");
        this._zoomOutButton.setAttribute("aria-disabled", "false");
        if (this._disabled || map._zoom === map.getMinZoom()) {
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._zoomOutButton, className);
            this._zoomOutButton.setAttribute("aria-disabled", "true");
        }
        if (this._disabled || map._zoom === map.getMaxZoom()) {
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._zoomInButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "true");
        }
    }
});
// @namespace Map
// @section Control options
// @option zoomControl: Boolean = true
// Whether a [zoom control](#control-zoom) is added to the map by default.
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    zoomControl: true
});
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).addInitHook(function() {
    if (this.options.zoomControl) {
        // @section Controls
        // @property zoomControl: Control.Zoom
        // The default zoom control (only available if the
        // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
        this.zoomControl = new $311d7e7c3e466f1b$export$65cfd44a2050f99();
        this.addControl(this.zoomControl);
    }
});
var $311d7e7c3e466f1b$export$e83f174dbf56adcc = function(options) {
    return new $311d7e7c3e466f1b$export$65cfd44a2050f99(options);
};




var $7086e92a04daf6c8$export$d60cfc58d3c358b6 = (0, $833ac8fc109549bc$export$7a7fa4424cb20976).extend({
    // @section
    // @aka Control.Scale options
    options: {
        position: "bottomleft",
        // @option maxWidth: Number = 100
        // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
        maxWidth: 100,
        // @option metric: Boolean = True
        // Whether to show the metric scale line (m/km).
        metric: true,
        // @option imperial: Boolean = True
        // Whether to show the imperial scale line (mi/ft).
        imperial: true
    },
    onAdd: function(map) {
        var className = "leaflet-control-scale", container = $b316889e4737b9d0$export$185802fd694ee1f5("div", className), options = this.options;
        this._addScales(options, className + "-line", container);
        map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
        map.whenReady(this._update, this);
        return container;
    },
    onRemove: function(map) {
        map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
    },
    _addScales: function(options, className, container) {
        if (options.metric) this._mScale = $b316889e4737b9d0$export$185802fd694ee1f5("div", className, container);
        if (options.imperial) this._iScale = $b316889e4737b9d0$export$185802fd694ee1f5("div", className, container);
    },
    _update: function() {
        var map = this._map, y = map.getSize().y / 2;
        var maxMeters = map.distance(map.containerPointToLatLng([
            0,
            y
        ]), map.containerPointToLatLng([
            this.options.maxWidth,
            y
        ]));
        this._updateScales(maxMeters);
    },
    _updateScales: function(maxMeters) {
        if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
        if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
    },
    _updateMetric: function(maxMeters) {
        var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
        this._updateScale(this._mScale, label, meters / maxMeters);
    },
    _updateImperial: function(maxMeters) {
        var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
        if (maxFeet > 5280) {
            maxMiles = maxFeet / 5280;
            miles = this._getRoundNum(maxMiles);
            this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
        } else {
            feet = this._getRoundNum(maxFeet);
            this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
        }
    },
    _updateScale: function(scale, text, ratio) {
        scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
        scale.innerHTML = text;
    },
    _getRoundNum: function(num) {
        var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
        d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
        return pow10 * d;
    }
});
var $7086e92a04daf6c8$export$dcdf75081b88279d = function(options) {
    return new $7086e92a04daf6c8$export$d60cfc58d3c358b6(options);
};








var $c508bdd127438e89$var$ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
var $c508bdd127438e89$export$c18a293673ef2524 = (0, $833ac8fc109549bc$export$7a7fa4424cb20976).extend({
    // @section
    // @aka Control.Attribution options
    options: {
        position: "bottomright",
        // @option prefix: String|false = 'Leaflet'
        // The HTML text shown before the attributions. Pass `false` to disable.
        prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).inlineSvg ? $c508bdd127438e89$var$ukrainianFlag + " " : "") + "Leaflet</a>"
    },
    initialize: function(options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        this._attributions = {};
    },
    onAdd: function(map) {
        map.attributionControl = this;
        this._container = $b316889e4737b9d0$export$185802fd694ee1f5("div", "leaflet-control-attribution");
        $7c9dd72411ef2269$export$a640b530813b3952(this._container);
        // TODO ugly, refactor
        for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
        this._update();
        map.on("layeradd", this._addAttribution, this);
        return this._container;
    },
    onRemove: function(map) {
        map.off("layeradd", this._addAttribution, this);
    },
    _addAttribution: function(ev) {
        if (ev.layer.getAttribution) {
            this.addAttribution(ev.layer.getAttribution());
            ev.layer.once("remove", function() {
                this.removeAttribution(ev.layer.getAttribution());
            }, this);
        }
    },
    // @method setPrefix(prefix: String|false): this
    // The HTML text shown before the attributions. Pass `false` to disable.
    setPrefix: function(prefix) {
        this.options.prefix = prefix;
        this._update();
        return this;
    },
    // @method addAttribution(text: String): this
    // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
    addAttribution: function(text) {
        if (!text) return this;
        if (!this._attributions[text]) this._attributions[text] = 0;
        this._attributions[text]++;
        this._update();
        return this;
    },
    // @method removeAttribution(text: String): this
    // Removes an attribution text.
    removeAttribution: function(text) {
        if (!text) return this;
        if (this._attributions[text]) {
            this._attributions[text]--;
            this._update();
        }
        return this;
    },
    _update: function() {
        if (!this._map) return;
        var attribs = [];
        for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
        var prefixAndAttribs = [];
        if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
        if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
        this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
    }
});
// @namespace Map
// @section Control options
// @option attributionControl: Boolean = true
// Whether a [attribution control](#control-attribution) is added to the map by default.
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    attributionControl: true
});
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).addInitHook(function() {
    if (this.options.attributionControl) new $c508bdd127438e89$export$c18a293673ef2524().addTo(this);
});
var $c508bdd127438e89$export$9a322927ac1e3d35 = function(options) {
    return new $c508bdd127438e89$export$c18a293673ef2524(options);
};


(0, $833ac8fc109549bc$export$7a7fa4424cb20976).Layers = (0, $e695f66ed9e3fd52$export$89312ce47c0ca777);
(0, $833ac8fc109549bc$export$7a7fa4424cb20976).Zoom = (0, $311d7e7c3e466f1b$export$65cfd44a2050f99);
(0, $833ac8fc109549bc$export$7a7fa4424cb20976).Scale = (0, $7086e92a04daf6c8$export$d60cfc58d3c358b6);
(0, $833ac8fc109549bc$export$7a7fa4424cb20976).Attribution = (0, $c508bdd127438e89$export$c18a293673ef2524);
(0, $833ac8fc109549bc$export$b5cde1de278b4330).layers = (0, $e695f66ed9e3fd52$export$7be255094ccdc533);
(0, $833ac8fc109549bc$export$b5cde1de278b4330).zoom = (0, $311d7e7c3e466f1b$export$e83f174dbf56adcc);
(0, $833ac8fc109549bc$export$b5cde1de278b4330).scale = (0, $7086e92a04daf6c8$export$dcdf75081b88279d);
(0, $833ac8fc109549bc$export$b5cde1de278b4330).attribution = (0, $c508bdd127438e89$export$9a322927ac1e3d35);






var $8edcec5990ab2544$export$a428cd33b25d5283 = (0, $a5dc067f35738c55$export$4c85e640eb41c31b).extend({
    initialize: function(map) {
        this._map = map;
    },
    // @method enable(): this
    // Enables the handler
    enable: function() {
        if (this._enabled) return this;
        this._enabled = true;
        this.addHooks();
        return this;
    },
    // @method disable(): this
    // Disables the handler
    disable: function() {
        if (!this._enabled) return this;
        this._enabled = false;
        this.removeHooks();
        return this;
    },
    // @method enabled(): Boolean
    // Returns `true` if the handler is enabled
    enabled: function() {
        return !!this._enabled;
    }
});
// @section There is static function which can be called without instantiating L.Handler:
// @function addTo(map: Map, name: String): this
// Adds a new Handler to the given map with the given name.
$8edcec5990ab2544$export$a428cd33b25d5283.addTo = function(map, name) {
    map.addHandler(name, this);
    return this;
};



var $125de421291c830e$export$c8d63b7d67105f7 = {
    Events: (0, $8d0e67ac3b8042d8$export$ada873a34909da65)
};











/*
 * @class Draggable
 * @aka L.Draggable
 * @inherits Evented
 *
 * A class for making DOM elements draggable (including touch support).
 * Used internally for map and marker dragging. Only works for elements
 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
 *
 * @example
 * ```js
 * var draggable = new L.Draggable(elementToDrag);
 * draggable.enable();
 * ```
 */ var $67085b4db43c69c6$var$START = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).touch ? "touchstart mousedown" : "mousedown";
var $67085b4db43c69c6$export$f2a139e5d18b9882 = (0, $8d0e67ac3b8042d8$export$ebcc362d8f4c4311).extend({
    options: {
        // @section
        // @aka Draggable options
        // @option clickTolerance: Number = 3
        // The max number of pixels a user can shift the mouse pointer during a click
        // for it to be considered a valid click (as opposed to a mouse drag).
        clickTolerance: 3
    },
    // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
    // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
    initialize: function(element, dragStartTarget, preventOutline, options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        this._element = element;
        this._dragStartTarget = dragStartTarget || element;
        this._preventOutline = preventOutline;
    },
    // @method enable()
    // Enables the dragging ability
    enable: function() {
        if (this._enabled) return;
        $7c9dd72411ef2269$export$af631764ddc44097(this._dragStartTarget, $67085b4db43c69c6$var$START, this._onDown, this);
        this._enabled = true;
    },
    // @method disable()
    // Disables the dragging ability
    disable: function() {
        if (!this._enabled) return;
        // If we're currently dragging this draggable,
        // disabling it counts as first ending the drag.
        if ($67085b4db43c69c6$export$f2a139e5d18b9882._dragging === this) this.finishDrag(true);
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(this._dragStartTarget, $67085b4db43c69c6$var$START, this._onDown, this);
        this._enabled = false;
        this._moved = false;
    },
    _onDown: function(e) {
        // Ignore the event if disabled; this happens in IE11
        // under some circumstances, see #3666.
        if (!this._enabled) return;
        this._moved = false;
        if ($b316889e4737b9d0$export$4ea3d958472af68f(this._element, "leaflet-zoom-anim")) return;
        if (e.touches && e.touches.length !== 1) {
            // Finish dragging to avoid conflict with touchZoom
            if ($67085b4db43c69c6$export$f2a139e5d18b9882._dragging === this) this.finishDrag();
            return;
        }
        if ($67085b4db43c69c6$export$f2a139e5d18b9882._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
        $67085b4db43c69c6$export$f2a139e5d18b9882._dragging = this; // Prevent dragging multiple objects at once.
        if (this._preventOutline) $b316889e4737b9d0$export$73d26a0c96b464b6(this._element);
        $b316889e4737b9d0$export$188eb2a17526281();
        $b316889e4737b9d0$export$16a4697467175487();
        if (this._moving) return;
        // @event down: Event
        // Fired when a drag is about to start.
        this.fire("down");
        var first = e.touches ? e.touches[0] : e, sizedParent = $b316889e4737b9d0$export$d444b651082dbd47(this._element);
        this._startPoint = new (0, $0552a615fcf79927$export$baf26146a414f24a)(first.clientX, first.clientY);
        this._startPos = $b316889e4737b9d0$export$1690e12b840569b9(this._element);
        // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
        this._parentScale = $b316889e4737b9d0$export$5cdac61cf538712e(sizedParent);
        var mouseevent = e.type === "mousedown";
        $7c9dd72411ef2269$export$af631764ddc44097(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
        $7c9dd72411ef2269$export$af631764ddc44097(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
    },
    _onMove: function(e) {
        // Ignore the event if disabled; this happens in IE11
        // under some circumstances, see #3666.
        if (!this._enabled) return;
        if (e.touches && e.touches.length > 1) {
            this._moved = true;
            return;
        }
        var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new (0, $0552a615fcf79927$export$baf26146a414f24a)(first.clientX, first.clientY)._subtract(this._startPoint);
        if (!offset.x && !offset.y) return;
        if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
        // We assume that the parent container's position, border and scale do not change for the duration of the drag.
        // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
        // and we can use the cached value for the scale.
        offset.x /= this._parentScale.x;
        offset.y /= this._parentScale.y;
        $7c9dd72411ef2269$export$fa3b29edae795ef4(e);
        if (!this._moved) {
            // @event dragstart: Event
            // Fired when a drag starts
            this.fire("dragstart");
            this._moved = true;
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(document.body, "leaflet-dragging");
            this._lastTarget = e.target || e.srcElement;
            // IE and Edge do not give the <use> element, so fetch it
            // if necessary
            if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._lastTarget, "leaflet-drag-target");
        }
        this._newPos = this._startPos.add(offset);
        this._moving = true;
        this._lastEvent = e;
        this._updatePosition();
    },
    _updatePosition: function() {
        var e = {
            originalEvent: this._lastEvent
        };
        // @event predrag: Event
        // Fired continuously during dragging *before* each corresponding
        // update of the element's position.
        this.fire("predrag", e);
        $b316889e4737b9d0$export$f9b088a47202d605(this._element, this._newPos);
        // @event drag: Event
        // Fired continuously during dragging.
        this.fire("drag", e);
    },
    _onUp: function() {
        // Ignore the event if disabled; this happens in IE11
        // under some circumstances, see #3666.
        if (!this._enabled) return;
        this.finishDrag();
    },
    finishDrag: function(noInertia) {
        $b316889e4737b9d0$export$c2255604a80b4506(document.body, "leaflet-dragging");
        if (this._lastTarget) {
            $b316889e4737b9d0$export$c2255604a80b4506(this._lastTarget, "leaflet-drag-target");
            this._lastTarget = null;
        }
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(document, "mousemove touchmove", this._onMove, this);
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(document, "mouseup touchend touchcancel", this._onUp, this);
        $b316889e4737b9d0$export$f5ef98e1c9198e63();
        $b316889e4737b9d0$export$b1bf1c69425cc693();
        var fireDragend = this._moved && this._moving;
        this._moving = false;
        $67085b4db43c69c6$export$f2a139e5d18b9882._dragging = false;
        if (fireDragend) // @event dragend: DragEndEvent
        // Fired when the drag ends.
        this.fire("dragend", {
            noInertia: noInertia,
            distance: this._newPos.distanceTo(this._startPos)
        });
    }
});














function $51edac15b28be71d$export$cf9573e980d97240(points, bounds, round) {
    var clippedPoints, edges = [
        1,
        4,
        2,
        8
    ], i, j, k, a, b, len, edge, p;
    for(i = 0, len = points.length; i < len; i++)points[i]._code = $63ae514521605ff0$export$ba8a7cb9c0fb62cb(points[i], bounds);
    // for each edge (left, bottom, right, top)
    for(k = 0; k < 4; k++){
        edge = edges[k];
        clippedPoints = [];
        for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
            a = points[i];
            b = points[j];
            // if a is inside the clip window
            if (!(a._code & edge)) {
                // if b is outside the clip window (a->b goes out of screen)
                if (b._code & edge) {
                    p = $63ae514521605ff0$export$fec5f43a3caeaae9(b, a, edge, bounds, round);
                    p._code = $63ae514521605ff0$export$ba8a7cb9c0fb62cb(p, bounds);
                    clippedPoints.push(p);
                }
                clippedPoints.push(a);
            // else if b is inside the clip window (a->b enters the screen)
            } else if (!(b._code & edge)) {
                p = $63ae514521605ff0$export$fec5f43a3caeaae9(b, a, edge, bounds, round);
                p._code = $63ae514521605ff0$export$ba8a7cb9c0fb62cb(p, bounds);
                clippedPoints.push(p);
            }
        }
        points = clippedPoints;
    }
    return points;
}
function $51edac15b28be71d$export$ab087439b250a32c(latlngs, crs) {
    var i, j, p1, p2, f, area, x, y, center;
    if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
    if (!$63ae514521605ff0$export$5a20f49a17c681a1(latlngs)) {
        console.warn("latlngs are not flat! Only the first ring will be used");
        latlngs = latlngs[0];
    }
    var centroidLatLng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)([
        0,
        0
    ]);
    var bounds = (0, $1b787e0b76fef54a$export$4904432a68b0399)(latlngs);
    var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
    // tests showed that below 1700 rounding errors are happening
    if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
    centroidLatLng = $51edac15b28be71d$export$e2a20c553f6c85ce(latlngs);
    var len = latlngs.length;
    var points = [];
    for(i = 0; i < len; i++){
        var latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlngs[i]);
        points.push(crs.project((0, $331f1841eb1ed916$export$a192f247fc7a2057)([
            latlng.lat - centroidLatLng.lat,
            latlng.lng - centroidLatLng.lng
        ])));
    }
    area = x = y = 0;
    // polygon centroid algorithm;
    for(i = 0, j = len - 1; i < len; j = i++){
        p1 = points[i];
        p2 = points[j];
        f = p1.y * p2.x - p2.y * p1.x;
        x += (p1.x + p2.x) * f;
        y += (p1.y + p2.y) * f;
        area += f * 3;
    }
    if (area === 0) // Polygon is so small that all points are on same pixel.
    center = points[0];
    else center = [
        x / area,
        y / area
    ];
    var latlngCenter = crs.unproject((0, $0552a615fcf79927$export$b63cca88ddc558a9)(center));
    return (0, $331f1841eb1ed916$export$a192f247fc7a2057)([
        latlngCenter.lat + centroidLatLng.lat,
        latlngCenter.lng + centroidLatLng.lng
    ]);
}
function $51edac15b28be71d$export$e2a20c553f6c85ce(coords) {
    var latSum = 0;
    var lngSum = 0;
    var len = 0;
    for(var i = 0; i < coords.length; i++){
        var latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(coords[i]);
        latSum += latlng.lat;
        lngSum += latlng.lng;
        len++;
    }
    return (0, $331f1841eb1ed916$export$a192f247fc7a2057)([
        latSum / len,
        lngSum / len
    ]);
}



function $63ae514521605ff0$export$798b53621063651(points, tolerance) {
    if (!tolerance || !points.length) return points.slice();
    var sqTolerance = tolerance * tolerance;
    // stage 1: vertex reduction
    points = $63ae514521605ff0$var$_reducePoints(points, sqTolerance);
    // stage 2: Douglas-Peucker simplification
    points = $63ae514521605ff0$var$_simplifyDP(points, sqTolerance);
    return points;
}
function $63ae514521605ff0$export$f96afe567099ccbe(p, p1, p2) {
    return Math.sqrt($63ae514521605ff0$export$618e0d6606476a13(p, p1, p2, true));
}
function $63ae514521605ff0$export$86054985d34bae0d(p, p1, p2) {
    return $63ae514521605ff0$export$618e0d6606476a13(p, p1, p2);
}
// Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
function $63ae514521605ff0$var$_simplifyDP(points, sqTolerance) {
    var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
    markers[0] = markers[len - 1] = 1;
    $63ae514521605ff0$var$_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
    var i, newPoints = [];
    for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
    return newPoints;
}
function $63ae514521605ff0$var$_simplifyDPStep(points, markers, sqTolerance, first, last) {
    var maxSqDist = 0, index, i, sqDist;
    for(i = first + 1; i <= last - 1; i++){
        sqDist = $63ae514521605ff0$export$618e0d6606476a13(points[i], points[first], points[last], true);
        if (sqDist > maxSqDist) {
            index = i;
            maxSqDist = sqDist;
        }
    }
    if (maxSqDist > sqTolerance) {
        markers[index] = 1;
        $63ae514521605ff0$var$_simplifyDPStep(points, markers, sqTolerance, first, index);
        $63ae514521605ff0$var$_simplifyDPStep(points, markers, sqTolerance, index, last);
    }
}
// reduce points that are too close to each other to a single point
function $63ae514521605ff0$var$_reducePoints(points, sqTolerance) {
    var reducedPoints = [
        points[0]
    ];
    for(var i = 1, prev = 0, len = points.length; i < len; i++)if ($63ae514521605ff0$var$_sqDist(points[i], points[prev]) > sqTolerance) {
        reducedPoints.push(points[i]);
        prev = i;
    }
    if (prev < len - 1) reducedPoints.push(points[len - 1]);
    return reducedPoints;
}
var $63ae514521605ff0$var$_lastCode;
function $63ae514521605ff0$export$2ba0cd7011ee887c(a, b, bounds, useLastCode, round) {
    var codeA = useLastCode ? $63ae514521605ff0$var$_lastCode : $63ae514521605ff0$export$ba8a7cb9c0fb62cb(a, bounds), codeB = $63ae514521605ff0$export$ba8a7cb9c0fb62cb(b, bounds), codeOut, p, newCode;
    // save 2nd code to avoid calculating it on the next segment
    $63ae514521605ff0$var$_lastCode = codeB;
    while(true){
        // if a,b is inside the clip window (trivial accept)
        if (!(codeA | codeB)) return [
            a,
            b
        ];
        // if a,b is outside the clip window (trivial reject)
        if (codeA & codeB) return false;
        // other cases
        codeOut = codeA || codeB;
        p = $63ae514521605ff0$export$fec5f43a3caeaae9(a, b, codeOut, bounds, round);
        newCode = $63ae514521605ff0$export$ba8a7cb9c0fb62cb(p, bounds);
        if (codeOut === codeA) {
            a = p;
            codeA = newCode;
        } else {
            b = p;
            codeB = newCode;
        }
    }
}
function $63ae514521605ff0$export$fec5f43a3caeaae9(a, b, code, bounds, round) {
    var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
    if (code & 8) {
        x = a.x + dx * (max.y - a.y) / dy;
        y = max.y;
    } else if (code & 4) {
        x = a.x + dx * (min.y - a.y) / dy;
        y = min.y;
    } else if (code & 2) {
        x = max.x;
        y = a.y + dy * (max.x - a.x) / dx;
    } else if (code & 1) {
        x = min.x;
        y = a.y + dy * (min.x - a.x) / dx;
    }
    return new (0, $0552a615fcf79927$export$baf26146a414f24a)(x, y, round);
}
function $63ae514521605ff0$export$ba8a7cb9c0fb62cb(p, bounds) {
    var code = 0;
    if (p.x < bounds.min.x) code |= 1;
    else if (p.x > bounds.max.x) code |= 2;
    if (p.y < bounds.min.y) code |= 4;
    else if (p.y > bounds.max.y) code |= 8;
    return code;
}
// square distance (to avoid unnecessary Math.sqrt calls)
function $63ae514521605ff0$var$_sqDist(p1, p2) {
    var dx = p2.x - p1.x, dy = p2.y - p1.y;
    return dx * dx + dy * dy;
}
function $63ae514521605ff0$export$618e0d6606476a13(p, p1, p2, sqDist) {
    var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
    if (dot > 0) {
        t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
        if (t > 1) {
            x = p2.x;
            y = p2.y;
        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }
    dx = p.x - x;
    dy = p.y - y;
    return sqDist ? dx * dx + dy * dy : new (0, $0552a615fcf79927$export$baf26146a414f24a)(x, y);
}
function $63ae514521605ff0$export$5a20f49a17c681a1(latlngs) {
    return !$78a895d83da22602$export$43bee75e5e14138e(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
}
function $63ae514521605ff0$export$cad69f152e26932d(latlngs) {
    console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
    return $63ae514521605ff0$export$5a20f49a17c681a1(latlngs);
}
function $63ae514521605ff0$export$a2a52905e1ae659c(latlngs, crs) {
    var i, halfDist, segDist, dist, p1, p2, ratio, center;
    if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
    if (!$63ae514521605ff0$export$5a20f49a17c681a1(latlngs)) {
        console.warn("latlngs are not flat! Only the first ring will be used");
        latlngs = latlngs[0];
    }
    var centroidLatLng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)([
        0,
        0
    ]);
    var bounds = (0, $1b787e0b76fef54a$export$4904432a68b0399)(latlngs);
    var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
    // tests showed that below 1700 rounding errors are happening
    if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
    centroidLatLng = (0, $51edac15b28be71d$export$e2a20c553f6c85ce)(latlngs);
    var len = latlngs.length;
    var points = [];
    for(i = 0; i < len; i++){
        var latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlngs[i]);
        points.push(crs.project((0, $331f1841eb1ed916$export$a192f247fc7a2057)([
            latlng.lat - centroidLatLng.lat,
            latlng.lng - centroidLatLng.lng
        ])));
    }
    for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
    // The line is so small in the current view that all points are on the same pixel.
    if (halfDist === 0) center = points[0];
    else for(i = 0, dist = 0; i < len - 1; i++){
        p1 = points[i];
        p2 = points[i + 1];
        segDist = p1.distanceTo(p2);
        dist += segDist;
        if (dist > halfDist) {
            ratio = (dist - halfDist) / segDist;
            center = [
                p2.x - ratio * (p2.x - p1.x),
                p2.y - ratio * (p2.y - p1.y)
            ];
            break;
        }
    }
    var latlngCenter = crs.unproject((0, $0552a615fcf79927$export$b63cca88ddc558a9)(center));
    return (0, $331f1841eb1ed916$export$a192f247fc7a2057)([
        latlngCenter.lat + centroidLatLng.lat,
        latlngCenter.lng + centroidLatLng.lng
    ]);
}







/*
 * @class Projection

 * An object with methods for projecting geographical coordinates of the world onto
 * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

 * @property bounds: Bounds
 * The bounds (specified in CRS units) where the projection is valid

 * @method project(latlng: LatLng): Point
 * Projects geographical coordinates into a 2D point.
 * Only accepts actual `L.LatLng` instances, not arrays.

 * @method unproject(point: Point): LatLng
 * The inverse of `project`. Projects a 2D point into a geographical location.
 * Only accepts actual `L.Point` instances, not arrays.

 * Note that the projection instances do not inherit from Leaflet's `Class` object,
 * and can't be instantiated. Also, new classes can't inherit from them,
 * and methods can't be added to them with the `include` function.

 */ 


var $e4aa55a540db72ca$export$e7f0da3b842d3901 = {
    project: function(latlng) {
        return new (0, $0552a615fcf79927$export$baf26146a414f24a)(latlng.lng, latlng.lat);
    },
    unproject: function(point) {
        return new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(point.y, point.x);
    },
    bounds: new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)([
        -180,
        -90
    ], [
        180,
        90
    ])
};





var $f8d4935e05e0b412$export$10a6535c298114cf = {
    R: 6378137,
    R_MINOR: 6356752.314245179,
    bounds: new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)([
        -20037508.34279,
        -15496570.73972
    ], [
        20037508.34279,
        18764656.23138
    ]),
    project: function(latlng) {
        var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
        var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
        y = -r * Math.log(Math.max(ts, 1E-10));
        return new (0, $0552a615fcf79927$export$baf26146a414f24a)(latlng.lng * d * r, y);
    },
    unproject: function(point) {
        var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
        for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
            con = e * Math.sin(phi);
            con = Math.pow((1 - con) / (1 + con), e / 2);
            dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
            phi += dphi;
        }
        return new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(phi * d, point.x * d / r);
    }
};











var $b36ffd4c5f05ad69$export$4ca8c84c9ce518e1 = $78a895d83da22602$export$8b58be045bf06082({}, (0, $734dbda617228982$export$a8d7cb18a6ef9581), {
    code: "EPSG:3395",
    projection: (0, $f8d4935e05e0b412$export$10a6535c298114cf),
    transformation: function() {
        var scale = 0.5 / (Math.PI * (0, $f8d4935e05e0b412$export$10a6535c298114cf).R);
        return (0, $ce389bc6a650be4e$export$9f6f7fcc395e278)(scale, 0.5, -scale, 0.5);
    }()
});







var $94a9ac6cbd26b23f$export$6e6fafcc50e60294 = $78a895d83da22602$export$8b58be045bf06082({}, (0, $734dbda617228982$export$a8d7cb18a6ef9581), {
    code: "EPSG:4326",
    projection: (0, $e4aa55a540db72ca$export$e7f0da3b842d3901),
    transformation: (0, $ce389bc6a650be4e$export$9f6f7fcc395e278)(1 / 180, 1, -1 / 180, 0.5)
});






var $473454468c2e5688$export$f3818faa9fce9618 = $78a895d83da22602$export$8b58be045bf06082({}, (0, $4761dfee679e6705$export$bdae29047cba02fc), {
    projection: (0, $e4aa55a540db72ca$export$e7f0da3b842d3901),
    transformation: (0, $ce389bc6a650be4e$export$9f6f7fcc395e278)(1, 0, -1, 0),
    scale: function(zoom) {
        return Math.pow(2, zoom);
    },
    zoom: function(scale) {
        return Math.log(scale) / Math.LN2;
    },
    distance: function(latlng1, latlng2) {
        var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
        return Math.sqrt(dx * dx + dy * dy);
    },
    infinite: true
});


(0, $4761dfee679e6705$export$bdae29047cba02fc).Earth = (0, $734dbda617228982$export$a8d7cb18a6ef9581);
(0, $4761dfee679e6705$export$bdae29047cba02fc).EPSG3395 = (0, $b36ffd4c5f05ad69$export$4ca8c84c9ce518e1);
(0, $4761dfee679e6705$export$bdae29047cba02fc).EPSG3857 = (0, $4ab72094fac4360b$export$fa530d80b080b222);
(0, $4761dfee679e6705$export$bdae29047cba02fc).EPSG900913 = (0, $4ab72094fac4360b$export$ca3534a3dff3e397);
(0, $4761dfee679e6705$export$bdae29047cba02fc).EPSG4326 = (0, $94a9ac6cbd26b23f$export$6e6fafcc50e60294);
(0, $4761dfee679e6705$export$bdae29047cba02fc).Simple = (0, $473454468c2e5688$export$f3818faa9fce9618);







var $17ba674e92a8ad9d$export$936d0764594b6eb3 = (0, $8d0e67ac3b8042d8$export$ebcc362d8f4c4311).extend({
    // Classes extending `L.Layer` will inherit the following options:
    options: {
        // @option pane: String = 'overlayPane'
        // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
        pane: "overlayPane",
        // @option attribution: String = null
        // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
        attribution: null,
        bubblingMouseEvents: true
    },
    /* @section
	 * Classes extending `L.Layer` will inherit the following methods:
	 *
	 * @method addTo(map: Map|LayerGroup): this
	 * Adds the layer to the given map or layer group.
	 */ addTo: function(map) {
        map.addLayer(this);
        return this;
    },
    // @method remove: this
    // Removes the layer from the map it is currently active on.
    remove: function() {
        return this.removeFrom(this._map || this._mapToAdd);
    },
    // @method removeFrom(map: Map): this
    // Removes the layer from the given map
    //
    // @alternative
    // @method removeFrom(group: LayerGroup): this
    // Removes the layer from the given `LayerGroup`
    removeFrom: function(obj) {
        if (obj) obj.removeLayer(this);
        return this;
    },
    // @method getPane(name? : String): HTMLElement
    // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
    getPane: function(name) {
        return this._map.getPane(name ? this.options[name] || name : this.options.pane);
    },
    addInteractiveTarget: function(targetEl) {
        this._map._targets[$78a895d83da22602$export$bd3fba034e28f6b(targetEl)] = this;
        return this;
    },
    removeInteractiveTarget: function(targetEl) {
        delete this._map._targets[$78a895d83da22602$export$bd3fba034e28f6b(targetEl)];
        return this;
    },
    // @method getAttribution: String
    // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
    getAttribution: function() {
        return this.options.attribution;
    },
    _layerAdd: function(e) {
        var map = e.target;
        // check in case layer gets added and then removed before the map is ready
        if (!map.hasLayer(this)) return;
        this._map = map;
        this._zoomAnimated = map._zoomAnimated;
        if (this.getEvents) {
            var events = this.getEvents();
            map.on(events, this);
            this.once("remove", function() {
                map.off(events, this);
            }, this);
        }
        this.onAdd(map);
        this.fire("add");
        map.fire("layeradd", {
            layer: this
        });
    }
});
/* @section Extension methods
 * @uninheritable
 *
 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): this
 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
 *
 * @method onRemove(map: Map): this
 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
 *
 * @method getEvents(): Object
 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
 *
 * @method getAttribution(): String
 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
 *
 * @method beforeAdd(map: Map): this
 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
 */ /* @namespace Map
 * @section Layer events
 *
 * @event layeradd: LayerEvent
 * Fired when a new layer is added to the map.
 *
 * @event layerremove: LayerEvent
 * Fired when some layer is removed from the map
 *
 * @section Methods for Layers and Controls
 */ (0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).include({
    // @method addLayer(layer: Layer): this
    // Adds the given layer to the map
    addLayer: function(layer) {
        if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
        var id = $78a895d83da22602$export$bd3fba034e28f6b(layer);
        if (this._layers[id]) return this;
        this._layers[id] = layer;
        layer._mapToAdd = this;
        if (layer.beforeAdd) layer.beforeAdd(this);
        this.whenReady(layer._layerAdd, layer);
        return this;
    },
    // @method removeLayer(layer: Layer): this
    // Removes the given layer from the map.
    removeLayer: function(layer) {
        var id = $78a895d83da22602$export$bd3fba034e28f6b(layer);
        if (!this._layers[id]) return this;
        if (this._loaded) layer.onRemove(this);
        delete this._layers[id];
        if (this._loaded) {
            this.fire("layerremove", {
                layer: layer
            });
            layer.fire("remove");
        }
        layer._map = layer._mapToAdd = null;
        return this;
    },
    // @method hasLayer(layer: Layer): Boolean
    // Returns `true` if the given layer is currently added to the map
    hasLayer: function(layer) {
        return $78a895d83da22602$export$bd3fba034e28f6b(layer) in this._layers;
    },
    /* @method eachLayer(fn: Function, context?: Object): this
	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
	 * ```
	 * map.eachLayer(function(layer){
	 *     layer.bindPopup('Hello');
	 * });
	 * ```
	 */ eachLayer: function(method, context) {
        for(var i in this._layers)method.call(context, this._layers[i]);
        return this;
    },
    _addLayers: function(layers) {
        layers = layers ? $78a895d83da22602$export$43bee75e5e14138e(layers) ? layers : [
            layers
        ] : [];
        for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
    },
    _addZoomLimit: function(layer) {
        if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
            this._zoomBoundLayers[$78a895d83da22602$export$bd3fba034e28f6b(layer)] = layer;
            this._updateZoomLevels();
        }
    },
    _removeZoomLimit: function(layer) {
        var id = $78a895d83da22602$export$bd3fba034e28f6b(layer);
        if (this._zoomBoundLayers[id]) {
            delete this._zoomBoundLayers[id];
            this._updateZoomLevels();
        }
    },
    _updateZoomLevels: function() {
        var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
        for(var i in this._zoomBoundLayers){
            var options = this._zoomBoundLayers[i].options;
            minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
            maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
        }
        this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
        this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
        // @section Map state change events
        // @event zoomlevelschange: Event
        // Fired when the number of zoomlevels on the map is changed due
        // to adding or removing a layer.
        if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
        if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
        if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
    }
});




var $d4fc2309740d4799$export$829212b9319961ea = (0, $17ba674e92a8ad9d$export$936d0764594b6eb3).extend({
    initialize: function(layers, options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        this._layers = {};
        var i, len;
        if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
    },
    // @method addLayer(layer: Layer): this
    // Adds the given layer to the group.
    addLayer: function(layer) {
        var id = this.getLayerId(layer);
        this._layers[id] = layer;
        if (this._map) this._map.addLayer(layer);
        return this;
    },
    // @method removeLayer(layer: Layer): this
    // Removes the given layer from the group.
    // @alternative
    // @method removeLayer(id: Number): this
    // Removes the layer with the given internal ID from the group.
    removeLayer: function(layer) {
        var id = layer in this._layers ? layer : this.getLayerId(layer);
        if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
        delete this._layers[id];
        return this;
    },
    // @method hasLayer(layer: Layer): Boolean
    // Returns `true` if the given layer is currently added to the group.
    // @alternative
    // @method hasLayer(id: Number): Boolean
    // Returns `true` if the given internal ID is currently added to the group.
    hasLayer: function(layer) {
        var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
        return layerId in this._layers;
    },
    // @method clearLayers(): this
    // Removes all the layers from the group.
    clearLayers: function() {
        return this.eachLayer(this.removeLayer, this);
    },
    // @method invoke(methodName: String, …): this
    // Calls `methodName` on every layer contained in this group, passing any
    // additional parameters. Has no effect if the layers contained do not
    // implement `methodName`.
    invoke: function(methodName) {
        var args = Array.prototype.slice.call(arguments, 1), i, layer;
        for(i in this._layers){
            layer = this._layers[i];
            if (layer[methodName]) layer[methodName].apply(layer, args);
        }
        return this;
    },
    onAdd: function(map) {
        this.eachLayer(map.addLayer, map);
    },
    onRemove: function(map) {
        this.eachLayer(map.removeLayer, map);
    },
    // @method eachLayer(fn: Function, context?: Object): this
    // Iterates over the layers of the group, optionally specifying context of the iterator function.
    // ```js
    // group.eachLayer(function (layer) {
    // 	layer.bindPopup('Hello');
    // });
    // ```
    eachLayer: function(method, context) {
        for(var i in this._layers)method.call(context, this._layers[i]);
        return this;
    },
    // @method getLayer(id: Number): Layer
    // Returns the layer with the given internal ID.
    getLayer: function(id) {
        return this._layers[id];
    },
    // @method getLayers(): Layer[]
    // Returns an array of all the layers added to the group.
    getLayers: function() {
        var layers = [];
        this.eachLayer(layers.push, layers);
        return layers;
    },
    // @method setZIndex(zIndex: Number): this
    // Calls `setZIndex` on every layer contained in this group, passing the z-index.
    setZIndex: function(zIndex) {
        return this.invoke("setZIndex", zIndex);
    },
    // @method getLayerId(layer: Layer): Number
    // Returns the internal ID for a layer
    getLayerId: function(layer) {
        return $78a895d83da22602$export$bd3fba034e28f6b(layer);
    }
});
var $d4fc2309740d4799$export$ee36a4b3469360e3 = function(layers, options) {
    return new $d4fc2309740d4799$export$829212b9319961ea(layers, options);
};




var $5cf3947d51f7fe8b$export$520fbf7f9cbd232d = (0, $d4fc2309740d4799$export$829212b9319961ea).extend({
    addLayer: function(layer) {
        if (this.hasLayer(layer)) return this;
        layer.addEventParent(this);
        (0, $d4fc2309740d4799$export$829212b9319961ea).prototype.addLayer.call(this, layer);
        // @event layeradd: LayerEvent
        // Fired when a layer is added to this `FeatureGroup`
        return this.fire("layeradd", {
            layer: layer
        });
    },
    removeLayer: function(layer) {
        if (!this.hasLayer(layer)) return this;
        if (layer in this._layers) layer = this._layers[layer];
        layer.removeEventParent(this);
        (0, $d4fc2309740d4799$export$829212b9319961ea).prototype.removeLayer.call(this, layer);
        // @event layerremove: LayerEvent
        // Fired when a layer is removed from this `FeatureGroup`
        return this.fire("layerremove", {
            layer: layer
        });
    },
    // @method setStyle(style: Path options): this
    // Sets the given path options to each layer of the group that has a `setStyle` method.
    setStyle: function(style) {
        return this.invoke("setStyle", style);
    },
    // @method bringToFront(): this
    // Brings the layer group to the top of all other layers
    bringToFront: function() {
        return this.invoke("bringToFront");
    },
    // @method bringToBack(): this
    // Brings the layer group to the back of all other layers
    bringToBack: function() {
        return this.invoke("bringToBack");
    },
    // @method getBounds(): LatLngBounds
    // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
    getBounds: function() {
        var bounds = new (0, $1b787e0b76fef54a$export$fe84d4076a55a8e6)();
        for(var id in this._layers){
            var layer = this._layers[id];
            bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
        }
        return bounds;
    }
});
var $5cf3947d51f7fe8b$export$5549395e12fb3797 = function(layers, options) {
    return new $5cf3947d51f7fe8b$export$520fbf7f9cbd232d(layers, options);
};










var $ce8b38ccde560ce6$export$f04a61298a47a40f = (0, $a5dc067f35738c55$export$4c85e640eb41c31b).extend({
    /* @section
	 * @aka Icon options
	 *
	 * @option iconUrl: String = null
	 * **(required)** The URL to the icon image (absolute or relative to your script path).
	 *
	 * @option iconRetinaUrl: String = null
	 * The URL to a retina sized version of the icon image (absolute or relative to your
	 * script path). Used for Retina screen devices.
	 *
	 * @option iconSize: Point = null
	 * Size of the icon image in pixels.
	 *
	 * @option iconAnchor: Point = null
	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	 * will be aligned so that this point is at the marker's geographical location. Centered
	 * by default if size is specified, also can be set in CSS with negative margins.
	 *
	 * @option popupAnchor: Point = [0, 0]
	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
	 *
	 * @option tooltipAnchor: Point = [0, 0]
	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
	 *
	 * @option shadowUrl: String = null
	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
	 *
	 * @option shadowRetinaUrl: String = null
	 *
	 * @option shadowSize: Point = null
	 * Size of the shadow image in pixels.
	 *
	 * @option shadowAnchor: Point = null
	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	 * as iconAnchor if not specified).
	 *
	 * @option className: String = ''
	 * A custom class name to assign to both icon and shadow images. Empty by default.
	 */ options: {
        popupAnchor: [
            0,
            0
        ],
        tooltipAnchor: [
            0,
            0
        ],
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: false
    },
    initialize: function(options) {
        (0, $78a895d83da22602$export$add91eafeaeab287)(this, options);
    },
    // @method createIcon(oldIcon?: HTMLElement): HTMLElement
    // Called internally when the icon has to be shown, returns a `<img>` HTML element
    // styled according to the options.
    createIcon: function(oldIcon) {
        return this._createIcon("icon", oldIcon);
    },
    // @method createShadow(oldIcon?: HTMLElement): HTMLElement
    // As `createIcon`, but for the shadow beneath it.
    createShadow: function(oldIcon) {
        return this._createIcon("shadow", oldIcon);
    },
    _createIcon: function(name, oldIcon) {
        var src = this._getIconUrl(name);
        if (!src) {
            if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
            return null;
        }
        var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
        this._setIconStyles(img, name);
        if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
        return img;
    },
    _setIconStyles: function(img, name) {
        var options = this.options;
        var sizeOption = options[name + "Size"];
        if (typeof sizeOption === "number") sizeOption = [
            sizeOption,
            sizeOption
        ];
        var size = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(sizeOption), anchor = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
        img.className = "leaflet-marker-" + name + " " + (options.className || "");
        if (anchor) {
            img.style.marginLeft = -anchor.x + "px";
            img.style.marginTop = -anchor.y + "px";
        }
        if (size) {
            img.style.width = size.x + "px";
            img.style.height = size.y + "px";
        }
    },
    _createImg: function(src, el) {
        el = el || document.createElement("img");
        el.src = src;
        return el;
    },
    _getIconUrl: function(name) {
        return (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
    }
});
function $ce8b38ccde560ce6$export$1ca1ec8b29a4ce27(options) {
    return new $ce8b38ccde560ce6$export$f04a61298a47a40f(options);
}



var $fddf1565bfa293cc$export$cacc2a877598679f = (0, $ce8b38ccde560ce6$export$f04a61298a47a40f).extend({
    options: {
        iconUrl: "marker-icon.png",
        iconRetinaUrl: "marker-icon-2x.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [
            25,
            41
        ],
        iconAnchor: [
            12,
            41
        ],
        popupAnchor: [
            1,
            -34
        ],
        tooltipAnchor: [
            16,
            -28
        ],
        shadowSize: [
            41,
            41
        ]
    },
    _getIconUrl: function(name) {
        if (typeof $fddf1565bfa293cc$export$cacc2a877598679f.imagePath !== "string") $fddf1565bfa293cc$export$cacc2a877598679f.imagePath = this._detectIconPath();
        // @option imagePath: String
        // `Icon.Default` will try to auto-detect the location of the
        // blue icon images. If you are placing these images in a non-standard
        // way, set this option to point to the right path.
        return (this.options.imagePath || $fddf1565bfa293cc$export$cacc2a877598679f.imagePath) + (0, $ce8b38ccde560ce6$export$f04a61298a47a40f).prototype._getIconUrl.call(this, name);
    },
    _stripUrl: function(path) {
        var strip = function(str, re, idx) {
            var match = re.exec(str);
            return match && match[idx];
        };
        path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
        return path && strip(path, /^(.*)marker-icon\.png$/, 1);
    },
    _detectIconPath: function() {
        var el = $b316889e4737b9d0$export$185802fd694ee1f5("div", "leaflet-default-icon-path", document.body);
        var path = $b316889e4737b9d0$export$3d2f074408bd1b82(el, "background-image") || $b316889e4737b9d0$export$3d2f074408bd1b82(el, "backgroundImage"); // IE8
        document.body.removeChild(el);
        path = this._stripUrl(path);
        if (path) return path;
        var link = document.querySelector('link[href$="leaflet.css"]');
        if (!link) return "";
        return link.href.substring(0, link.href.length - 11 - 1);
    }
});













var $5f063ace676ef123$export$7f44c3c808f5c9a4 = (0, $8edcec5990ab2544$export$a428cd33b25d5283).extend({
    initialize: function(marker) {
        this._marker = marker;
    },
    addHooks: function() {
        var icon = this._marker._icon;
        if (!this._draggable) this._draggable = new (0, $67085b4db43c69c6$export$f2a139e5d18b9882)(icon, icon, true);
        this._draggable.on({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
        }, this).enable();
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(icon, "leaflet-marker-draggable");
    },
    removeHooks: function() {
        this._draggable.off({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
        }, this).disable();
        if (this._marker._icon) $b316889e4737b9d0$export$c2255604a80b4506(this._marker._icon, "leaflet-marker-draggable");
    },
    moved: function() {
        return this._draggable && this._draggable._moved;
    },
    _adjustPan: function(e) {
        var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = $b316889e4737b9d0$export$1690e12b840569b9(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
        var panBounds = (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
        if (!panBounds.contains(iconPos)) {
            // Compute incremental movement
            var movement = (0, $0552a615fcf79927$export$b63cca88ddc558a9)((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
            map.panBy(movement, {
                animate: false
            });
            this._draggable._newPos._add(movement);
            this._draggable._startPos._add(movement);
            $b316889e4737b9d0$export$f9b088a47202d605(marker._icon, this._draggable._newPos);
            this._onDrag(e);
            this._panRequest = (0, $78a895d83da22602$export$d371ad015c199c06)(this._adjustPan.bind(this, e));
        }
    },
    _onDragStart: function() {
        // @section Dragging events
        // @event dragstart: Event
        // Fired when the user starts dragging the marker.
        // @event movestart: Event
        // Fired when the marker starts moving (because of dragging).
        this._oldLatLng = this._marker.getLatLng();
        // When using ES6 imports it could not be set when `Popup` was not imported as well
        this._marker.closePopup && this._marker.closePopup();
        this._marker.fire("movestart").fire("dragstart");
    },
    _onPreDrag: function(e) {
        if (this._marker.options.autoPan) {
            (0, $78a895d83da22602$export$e1ed83507f55dc9d)(this._panRequest);
            this._panRequest = (0, $78a895d83da22602$export$d371ad015c199c06)(this._adjustPan.bind(this, e));
        }
    },
    _onDrag: function(e) {
        var marker = this._marker, shadow = marker._shadow, iconPos = $b316889e4737b9d0$export$1690e12b840569b9(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
        // update shadow position
        if (shadow) $b316889e4737b9d0$export$f9b088a47202d605(shadow, iconPos);
        marker._latlng = latlng;
        e.latlng = latlng;
        e.oldLatLng = this._oldLatLng;
        // @event drag: Event
        // Fired repeatedly while the user drags the marker.
        marker.fire("move", e).fire("drag", e);
    },
    _onDragEnd: function(e) {
        // @event dragend: DragEndEvent
        // Fired when the user stops dragging the marker.
        (0, $78a895d83da22602$export$e1ed83507f55dc9d)(this._panRequest);
        // @event moveend: Event
        // Fired when the marker stops moving (because of dragging).
        delete this._oldLatLng;
        this._marker.fire("moveend").fire("dragend", e);
    }
});


var $30b9db4f4a4e141e$export$e98856a975cab58e = (0, $17ba674e92a8ad9d$export$936d0764594b6eb3).extend({
    // @section
    // @aka Marker options
    options: {
        // @option icon: Icon = *
        // Icon instance to use for rendering the marker.
        // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
        // If not specified, a common instance of `L.Icon.Default` is used.
        icon: new (0, $fddf1565bfa293cc$export$cacc2a877598679f)(),
        // Option inherited from "Interactive layer" abstract class
        interactive: true,
        // @option keyboard: Boolean = true
        // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
        keyboard: true,
        // @option title: String = ''
        // Text for the browser tooltip that appear on marker hover (no tooltip by default).
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        title: "",
        // @option alt: String = 'Marker'
        // Text for the `alt` attribute of the icon image.
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        alt: "Marker",
        // @option zIndexOffset: Number = 0
        // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
        zIndexOffset: 0,
        // @option opacity: Number = 1.0
        // The opacity of the marker.
        opacity: 1,
        // @option riseOnHover: Boolean = false
        // If `true`, the marker will get on top of others when you hover the mouse over it.
        riseOnHover: false,
        // @option riseOffset: Number = 250
        // The z-index offset used for the `riseOnHover` feature.
        riseOffset: 250,
        // @option pane: String = 'markerPane'
        // `Map pane` where the markers icon will be added.
        pane: "markerPane",
        // @option shadowPane: String = 'shadowPane'
        // `Map pane` where the markers shadow will be added.
        shadowPane: "shadowPane",
        // @option bubblingMouseEvents: Boolean = false
        // When `true`, a mouse event on this marker will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: false,
        // @option autoPanOnFocus: Boolean = true
        // When `true`, the map will pan whenever the marker is focused (via
        // e.g. pressing `tab` on the keyboard) to ensure the marker is
        // visible within the map's bounds
        autoPanOnFocus: true,
        // @section Draggable marker options
        // @option draggable: Boolean = false
        // Whether the marker is draggable with mouse/touch or not.
        draggable: false,
        // @option autoPan: Boolean = false
        // Whether to pan the map when dragging this marker near its edge or not.
        autoPan: false,
        // @option autoPanPadding: Point = Point(50, 50)
        // Distance (in pixels to the left/right and to the top/bottom) of the
        // map edge to start panning the map.
        autoPanPadding: [
            50,
            50
        ],
        // @option autoPanSpeed: Number = 10
        // Number of pixels the map should pan by.
        autoPanSpeed: 10
    },
    /* @section
	 *
	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	 */ initialize: function(latlng, options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        this._latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng);
    },
    onAdd: function(map) {
        this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
        if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
        this._initIcon();
        this.update();
    },
    onRemove: function(map) {
        if (this.dragging && this.dragging.enabled()) {
            this.options.draggable = true;
            this.dragging.removeHooks();
        }
        delete this.dragging;
        if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
        this._removeIcon();
        this._removeShadow();
    },
    getEvents: function() {
        return {
            zoom: this.update,
            viewreset: this.update
        };
    },
    // @method getLatLng: LatLng
    // Returns the current geographical position of the marker.
    getLatLng: function() {
        return this._latlng;
    },
    // @method setLatLng(latlng: LatLng): this
    // Changes the marker position to the given point.
    setLatLng: function(latlng) {
        var oldLatLng = this._latlng;
        this._latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng);
        this.update();
        // @event move: Event
        // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
        return this.fire("move", {
            oldLatLng: oldLatLng,
            latlng: this._latlng
        });
    },
    // @method setZIndexOffset(offset: Number): this
    // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
    setZIndexOffset: function(offset) {
        this.options.zIndexOffset = offset;
        return this.update();
    },
    // @method getIcon: Icon
    // Returns the current icon used by the marker
    getIcon: function() {
        return this.options.icon;
    },
    // @method setIcon(icon: Icon): this
    // Changes the marker icon.
    setIcon: function(icon) {
        this.options.icon = icon;
        if (this._map) {
            this._initIcon();
            this.update();
        }
        if (this._popup) this.bindPopup(this._popup, this._popup.options);
        return this;
    },
    getElement: function() {
        return this._icon;
    },
    update: function() {
        if (this._icon && this._map) {
            var pos = this._map.latLngToLayerPoint(this._latlng).round();
            this._setPos(pos);
        }
        return this;
    },
    _initIcon: function() {
        var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        var icon = options.icon.createIcon(this._icon), addIcon = false;
        // if we're not reusing the icon, remove the old one and init new one
        if (icon !== this._icon) {
            if (this._icon) this._removeIcon();
            addIcon = true;
            if (options.title) icon.title = options.title;
            if (icon.tagName === "IMG") icon.alt = options.alt || "";
        }
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(icon, classToAdd);
        if (options.keyboard) {
            icon.tabIndex = "0";
            icon.setAttribute("role", "button");
        }
        this._icon = icon;
        if (options.riseOnHover) this.on({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
        });
        if (this.options.autoPanOnFocus) $7c9dd72411ef2269$export$af631764ddc44097(icon, "focus", this._panOnFocus, this);
        var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
        if (newShadow !== this._shadow) {
            this._removeShadow();
            addShadow = true;
        }
        if (newShadow) {
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(newShadow, classToAdd);
            newShadow.alt = "";
        }
        this._shadow = newShadow;
        if (options.opacity < 1) this._updateOpacity();
        if (addIcon) this.getPane().appendChild(this._icon);
        this._initInteraction();
        if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
    },
    _removeIcon: function() {
        if (this.options.riseOnHover) this.off({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
        });
        if (this.options.autoPanOnFocus) $7c9dd72411ef2269$export$8c8705df4a2dcec9(this._icon, "focus", this._panOnFocus, this);
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._icon);
        this.removeInteractiveTarget(this._icon);
        this._icon = null;
    },
    _removeShadow: function() {
        if (this._shadow) $b316889e4737b9d0$export$cd7f480d6b8286c3(this._shadow);
        this._shadow = null;
    },
    _setPos: function(pos) {
        if (this._icon) $b316889e4737b9d0$export$f9b088a47202d605(this._icon, pos);
        if (this._shadow) $b316889e4737b9d0$export$f9b088a47202d605(this._shadow, pos);
        this._zIndex = pos.y + this.options.zIndexOffset;
        this._resetZIndex();
    },
    _updateZIndex: function(offset) {
        if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
    },
    _animateZoom: function(opt) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
        this._setPos(pos);
    },
    _initInteraction: function() {
        if (!this.options.interactive) return;
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._icon, "leaflet-interactive");
        this.addInteractiveTarget(this._icon);
        if (0, $5f063ace676ef123$export$7f44c3c808f5c9a4) {
            var draggable = this.options.draggable;
            if (this.dragging) {
                draggable = this.dragging.enabled();
                this.dragging.disable();
            }
            this.dragging = new (0, $5f063ace676ef123$export$7f44c3c808f5c9a4)(this);
            if (draggable) this.dragging.enable();
        }
    },
    // @method setOpacity(opacity: Number): this
    // Changes the opacity of the marker.
    setOpacity: function(opacity) {
        this.options.opacity = opacity;
        if (this._map) this._updateOpacity();
        return this;
    },
    _updateOpacity: function() {
        var opacity = this.options.opacity;
        if (this._icon) $b316889e4737b9d0$export$2646c6b151d2e8(this._icon, opacity);
        if (this._shadow) $b316889e4737b9d0$export$2646c6b151d2e8(this._shadow, opacity);
    },
    _bringToFront: function() {
        this._updateZIndex(this.options.riseOffset);
    },
    _resetZIndex: function() {
        this._updateZIndex(0);
    },
    _panOnFocus: function() {
        var map = this._map;
        if (!map) return;
        var iconOpts = this.options.icon.options;
        var size = iconOpts.iconSize ? (0, $0552a615fcf79927$export$b63cca88ddc558a9)(iconOpts.iconSize) : (0, $0552a615fcf79927$export$b63cca88ddc558a9)(0, 0);
        var anchor = iconOpts.iconAnchor ? (0, $0552a615fcf79927$export$b63cca88ddc558a9)(iconOpts.iconAnchor) : (0, $0552a615fcf79927$export$b63cca88ddc558a9)(0, 0);
        map.panInside(this._latlng, {
            paddingTopLeft: anchor,
            paddingBottomRight: size.subtract(anchor)
        });
    },
    _getPopupAnchor: function() {
        return this.options.icon.options.popupAnchor;
    },
    _getTooltipAnchor: function() {
        return this.options.icon.options.tooltipAnchor;
    }
});
function $30b9db4f4a4e141e$export$ffc4d0086f1a4c9(latlng, options) {
    return new $30b9db4f4a4e141e$export$e98856a975cab58e(latlng, options);
}




var $f59a1fa4c4c5d7b6$export$4b2950bdac9b6ee9 = (0, $17ba674e92a8ad9d$export$936d0764594b6eb3).extend({
    // @section
    // @aka Path options
    options: {
        // @option stroke: Boolean = true
        // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
        stroke: true,
        // @option color: String = '#3388ff'
        // Stroke color
        color: "#3388ff",
        // @option weight: Number = 3
        // Stroke width in pixels
        weight: 3,
        // @option opacity: Number = 1.0
        // Stroke opacity
        opacity: 1,
        // @option lineCap: String= 'round'
        // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
        lineCap: "round",
        // @option lineJoin: String = 'round'
        // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
        lineJoin: "round",
        // @option dashArray: String = null
        // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashArray: null,
        // @option dashOffset: String = null
        // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashOffset: null,
        // @option fill: Boolean = depends
        // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
        fill: false,
        // @option fillColor: String = *
        // Fill color. Defaults to the value of the [`color`](#path-color) option
        fillColor: null,
        // @option fillOpacity: Number = 0.2
        // Fill opacity.
        fillOpacity: 0.2,
        // @option fillRule: String = 'evenodd'
        // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
        fillRule: "evenodd",
        // className: '',
        // Option inherited from "Interactive layer" abstract class
        interactive: true,
        // @option bubblingMouseEvents: Boolean = true
        // When `true`, a mouse event on this path will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: true
    },
    beforeAdd: function(map) {
        // Renderer is set here because we need to call renderer.getEvents
        // before this.getEvents.
        this._renderer = map.getRenderer(this);
    },
    onAdd: function() {
        this._renderer._initPath(this);
        this._reset();
        this._renderer._addPath(this);
    },
    onRemove: function() {
        this._renderer._removePath(this);
    },
    // @method redraw(): this
    // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
    redraw: function() {
        if (this._map) this._renderer._updatePath(this);
        return this;
    },
    // @method setStyle(style: Path options): this
    // Changes the appearance of a Path based on the options in the `Path options` object.
    setStyle: function(style) {
        $78a895d83da22602$export$add91eafeaeab287(this, style);
        if (this._renderer) {
            this._renderer._updateStyle(this);
            if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
        }
        return this;
    },
    // @method bringToFront(): this
    // Brings the layer to the top of all path layers.
    bringToFront: function() {
        if (this._renderer) this._renderer._bringToFront(this);
        return this;
    },
    // @method bringToBack(): this
    // Brings the layer to the bottom of all path layers.
    bringToBack: function() {
        if (this._renderer) this._renderer._bringToBack(this);
        return this;
    },
    getElement: function() {
        return this._path;
    },
    _reset: function() {
        // defined in child classes
        this._project();
        this._update();
    },
    _clickTolerance: function() {
        // used when doing hit detection for Canvas layers
        return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
    }
});





var $535ebc027ffc2e03$export$7bf46a893731b161 = (0, $f59a1fa4c4c5d7b6$export$4b2950bdac9b6ee9).extend({
    // @section
    // @aka CircleMarker options
    options: {
        fill: true,
        // @option radius: Number = 10
        // Radius of the circle marker, in pixels
        radius: 10
    },
    initialize: function(latlng, options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        this._latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng);
        this._radius = this.options.radius;
    },
    // @method setLatLng(latLng: LatLng): this
    // Sets the position of a circle marker to a new location.
    setLatLng: function(latlng) {
        var oldLatLng = this._latlng;
        this._latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng);
        this.redraw();
        // @event move: Event
        // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
        return this.fire("move", {
            oldLatLng: oldLatLng,
            latlng: this._latlng
        });
    },
    // @method getLatLng(): LatLng
    // Returns the current geographical position of the circle marker
    getLatLng: function() {
        return this._latlng;
    },
    // @method setRadius(radius: Number): this
    // Sets the radius of a circle marker. Units are in pixels.
    setRadius: function(radius) {
        this.options.radius = this._radius = radius;
        return this.redraw();
    },
    // @method getRadius(): Number
    // Returns the current radius of the circle
    getRadius: function() {
        return this._radius;
    },
    setStyle: function(options) {
        var radius = options && options.radius || this._radius;
        (0, $f59a1fa4c4c5d7b6$export$4b2950bdac9b6ee9).prototype.setStyle.call(this, options);
        this.setRadius(radius);
        return this;
    },
    _project: function() {
        this._point = this._map.latLngToLayerPoint(this._latlng);
        this._updateBounds();
    },
    _updateBounds: function() {
        var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
            r + w,
            r2 + w
        ];
        this._pxBounds = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(this._point.subtract(p), this._point.add(p));
    },
    _update: function() {
        if (this._map) this._updatePath();
    },
    _updatePath: function() {
        this._renderer._updateCircle(this);
    },
    _empty: function() {
        return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
    },
    // Needed by the `Canvas` renderer for interactivity
    _containsPoint: function(p) {
        return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
    }
});
function $535ebc027ffc2e03$export$d335a174f4e989fb(latlng, options) {
    return new $535ebc027ffc2e03$export$7bf46a893731b161(latlng, options);
}







var $a6dea4780f62f692$export$c89a927ffc67e6fa = (0, $535ebc027ffc2e03$export$7bf46a893731b161).extend({
    initialize: function(latlng, options, legacyOptions) {
        if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
        options = $78a895d83da22602$export$8b58be045bf06082({}, legacyOptions, {
            radius: options
        });
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        this._latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng);
        if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
        // @section
        // @aka Circle options
        // @option radius: Number; Radius of the circle, in meters.
        this._mRadius = this.options.radius;
    },
    // @method setRadius(radius: Number): this
    // Sets the radius of a circle. Units are in meters.
    setRadius: function(radius) {
        this._mRadius = radius;
        return this.redraw();
    },
    // @method getRadius(): Number
    // Returns the current radius of a circle. Units are in meters.
    getRadius: function() {
        return this._mRadius;
    },
    // @method getBounds(): LatLngBounds
    // Returns the `LatLngBounds` of the path.
    getBounds: function() {
        var half = [
            this._radius,
            this._radiusY || this._radius
        ];
        return new (0, $1b787e0b76fef54a$export$fe84d4076a55a8e6)(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
    },
    setStyle: (0, $f59a1fa4c4c5d7b6$export$4b2950bdac9b6ee9).prototype.setStyle,
    _project: function() {
        var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
        if (crs.distance === (0, $734dbda617228982$export$a8d7cb18a6ef9581).distance) {
            var d = Math.PI / 180, latR = this._mRadius / (0, $734dbda617228982$export$a8d7cb18a6ef9581).R / d, top = map.project([
                lat + latR,
                lng
            ]), bottom = map.project([
                lat - latR,
                lng
            ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
            if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
            this._point = p.subtract(map.getPixelOrigin());
            this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                lat2,
                lng - lngR
            ]).x;
            this._radiusY = p.y - top.y;
        } else {
            var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                this._mRadius,
                0
            ]));
            this._point = map.latLngToLayerPoint(this._latlng);
            this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
        }
        this._updateBounds();
    }
});
function $a6dea4780f62f692$export$e1d786d2f707b414(latlng, options, legacyOptions) {
    return new $a6dea4780f62f692$export$c89a927ffc67e6fa(latlng, options, legacyOptions);
}










var $5923b206f6af4923$export$79f3ee03e63e7073 = (0, $f59a1fa4c4c5d7b6$export$4b2950bdac9b6ee9).extend({
    // @section
    // @aka Polyline options
    options: {
        // @option smoothFactor: Number = 1.0
        // How much to simplify the polyline on each zoom level. More means
        // better performance and smoother look, and less means more accurate representation.
        smoothFactor: 1.0,
        // @option noClip: Boolean = false
        // Disable polyline clipping.
        noClip: false
    },
    initialize: function(latlngs, options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        this._setLatLngs(latlngs);
    },
    // @method getLatLngs(): LatLng[]
    // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
    getLatLngs: function() {
        return this._latlngs;
    },
    // @method setLatLngs(latlngs: LatLng[]): this
    // Replaces all the points in the polyline with the given array of geographical points.
    setLatLngs: function(latlngs) {
        this._setLatLngs(latlngs);
        return this.redraw();
    },
    // @method isEmpty(): Boolean
    // Returns `true` if the Polyline has no LatLngs.
    isEmpty: function() {
        return !this._latlngs.length;
    },
    // @method closestLayerPoint(p: Point): Point
    // Returns the point closest to `p` on the Polyline.
    closestLayerPoint: function(p) {
        var minDistance = Infinity, minPoint = null, closest = $63ae514521605ff0$export$618e0d6606476a13, p1, p2;
        for(var j = 0, jLen = this._parts.length; j < jLen; j++){
            var points = this._parts[j];
            for(var i = 1, len = points.length; i < len; i++){
                p1 = points[i - 1];
                p2 = points[i];
                var sqDist = closest(p, p1, p2, true);
                if (sqDist < minDistance) {
                    minDistance = sqDist;
                    minPoint = closest(p, p1, p2);
                }
            }
        }
        if (minPoint) minPoint.distance = Math.sqrt(minDistance);
        return minPoint;
    },
    // @method getCenter(): LatLng
    // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
    getCenter: function() {
        // throws error when not yet added to map as this center calculation requires projected coordinates
        if (!this._map) throw new Error("Must add layer to map before using getCenter()");
        return $63ae514521605ff0$export$a2a52905e1ae659c(this._defaultShape(), this._map.options.crs);
    },
    // @method getBounds(): LatLngBounds
    // Returns the `LatLngBounds` of the path.
    getBounds: function() {
        return this._bounds;
    },
    // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
    // Adds a given point to the polyline. By default, adds to the first ring of
    // the polyline in case of a multi-polyline, but can be overridden by passing
    // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
    addLatLng: function(latlng, latlngs) {
        latlngs = latlngs || this._defaultShape();
        latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng);
        latlngs.push(latlng);
        this._bounds.extend(latlng);
        return this.redraw();
    },
    _setLatLngs: function(latlngs) {
        this._bounds = new (0, $1b787e0b76fef54a$export$fe84d4076a55a8e6)();
        this._latlngs = this._convertLatLngs(latlngs);
    },
    _defaultShape: function() {
        return $63ae514521605ff0$export$5a20f49a17c681a1(this._latlngs) ? this._latlngs : this._latlngs[0];
    },
    // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
    _convertLatLngs: function(latlngs) {
        var result = [], flat = $63ae514521605ff0$export$5a20f49a17c681a1(latlngs);
        for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
            result[i] = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlngs[i]);
            this._bounds.extend(result[i]);
        } else result[i] = this._convertLatLngs(latlngs[i]);
        return result;
    },
    _project: function() {
        var pxBounds = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)();
        this._rings = [];
        this._projectLatlngs(this._latlngs, this._rings, pxBounds);
        if (this._bounds.isValid() && pxBounds.isValid()) {
            this._rawPxBounds = pxBounds;
            this._updateBounds();
        }
    },
    _updateBounds: function() {
        var w = this._clickTolerance(), p = new (0, $0552a615fcf79927$export$baf26146a414f24a)(w, w);
        if (!this._rawPxBounds) return;
        this._pxBounds = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)([
            this._rawPxBounds.min.subtract(p),
            this._rawPxBounds.max.add(p)
        ]);
    },
    // recursively turns latlngs into a set of rings with projected coordinates
    _projectLatlngs: function(latlngs, result, projectedBounds) {
        var flat = latlngs[0] instanceof (0, $331f1841eb1ed916$export$5fd359ea0b43bded), len = latlngs.length, i, ring;
        if (flat) {
            ring = [];
            for(i = 0; i < len; i++){
                ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                projectedBounds.extend(ring[i]);
            }
            result.push(ring);
        } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
    },
    // clip polyline by renderer bounds so that we have less to render for performance
    _clipPoints: function() {
        var bounds = this._renderer._bounds;
        this._parts = [];
        if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
        if (this.options.noClip) {
            this._parts = this._rings;
            return;
        }
        var parts = this._parts, i, j, k, len, len2, segment, points;
        for(i = 0, k = 0, len = this._rings.length; i < len; i++){
            points = this._rings[i];
            for(j = 0, len2 = points.length; j < len2 - 1; j++){
                segment = $63ae514521605ff0$export$2ba0cd7011ee887c(points[j], points[j + 1], bounds, j, true);
                if (!segment) continue;
                parts[k] = parts[k] || [];
                parts[k].push(segment[0]);
                // if segment goes out of screen, or it's the last one, it's the end of the line part
                if (segment[1] !== points[j + 1] || j === len2 - 2) {
                    parts[k].push(segment[1]);
                    k++;
                }
            }
        }
    },
    // simplify each clipped part of the polyline for performance
    _simplifyPoints: function() {
        var parts = this._parts, tolerance = this.options.smoothFactor;
        for(var i = 0, len = parts.length; i < len; i++)parts[i] = $63ae514521605ff0$export$798b53621063651(parts[i], tolerance);
    },
    _update: function() {
        if (!this._map) return;
        this._clipPoints();
        this._simplifyPoints();
        this._updatePath();
    },
    _updatePath: function() {
        this._renderer._updatePoly(this);
    },
    // Needed by the `Canvas` renderer for interactivity
    _containsPoint: function(p, closed) {
        var i, j, k, len, len2, part, w = this._clickTolerance();
        if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
        // hit detection for polylines
        for(i = 0, len = this._parts.length; i < len; i++){
            part = this._parts[i];
            for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                if (!closed && j === 0) continue;
                if ($63ae514521605ff0$export$f96afe567099ccbe(p, part[k], part[j]) <= w) return true;
            }
        }
        return false;
    }
});
function $5923b206f6af4923$export$8d69707c7074d5c0(latlngs, options) {
    return new $5923b206f6af4923$export$79f3ee03e63e7073(latlngs, options);
}
// Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
$5923b206f6af4923$export$79f3ee03e63e7073._flat = $63ae514521605ff0$export$cad69f152e26932d;








var $5c1ba64c6ac1b9ee$export$7d31b617c820d435 = (0, $5923b206f6af4923$export$79f3ee03e63e7073).extend({
    options: {
        fill: true
    },
    isEmpty: function() {
        return !this._latlngs.length || !this._latlngs[0].length;
    },
    // @method getCenter(): LatLng
    // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
    getCenter: function() {
        // throws error when not yet added to map as this center calculation requires projected coordinates
        if (!this._map) throw new Error("Must add layer to map before using getCenter()");
        return $51edac15b28be71d$export$ab087439b250a32c(this._defaultShape(), this._map.options.crs);
    },
    _convertLatLngs: function(latlngs) {
        var result = (0, $5923b206f6af4923$export$79f3ee03e63e7073).prototype._convertLatLngs.call(this, latlngs), len = result.length;
        // remove last point if it equals first one
        if (len >= 2 && result[0] instanceof (0, $331f1841eb1ed916$export$5fd359ea0b43bded) && result[0].equals(result[len - 1])) result.pop();
        return result;
    },
    _setLatLngs: function(latlngs) {
        (0, $5923b206f6af4923$export$79f3ee03e63e7073).prototype._setLatLngs.call(this, latlngs);
        if ($63ae514521605ff0$export$5a20f49a17c681a1(this._latlngs)) this._latlngs = [
            this._latlngs
        ];
    },
    _defaultShape: function() {
        return $63ae514521605ff0$export$5a20f49a17c681a1(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
    },
    _clipPoints: function() {
        // polygons need a different clipping algorithm so we redefine that
        var bounds = this._renderer._bounds, w = this.options.weight, p = new (0, $0552a615fcf79927$export$baf26146a414f24a)(w, w);
        // increase clip padding by stroke width to avoid stroke on clip edges
        bounds = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(bounds.min.subtract(p), bounds.max.add(p));
        this._parts = [];
        if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
        if (this.options.noClip) {
            this._parts = this._rings;
            return;
        }
        for(var i = 0, len = this._rings.length, clipped; i < len; i++){
            clipped = $51edac15b28be71d$export$cf9573e980d97240(this._rings[i], bounds, true);
            if (clipped.length) this._parts.push(clipped);
        }
    },
    _updatePath: function() {
        this._renderer._updatePoly(this, true);
    },
    // Needed by the `Canvas` renderer for interactivity
    _containsPoint: function(p) {
        var inside = false, part, p1, p2, i, j, k, len, len2;
        if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
        // ray casting algorithm for detecting if point is in polygon
        for(i = 0, len = this._parts.length; i < len; i++){
            part = this._parts[i];
            for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                p1 = part[j];
                p2 = part[k];
                if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
            }
        }
        // also check if it's on polygon stroke
        return inside || (0, $5923b206f6af4923$export$79f3ee03e63e7073).prototype._containsPoint.call(this, p, true);
    }
});
function $5c1ba64c6ac1b9ee$export$b7b19aa0ee06c73(latlngs, options) {
    return new $5c1ba64c6ac1b9ee$export$7d31b617c820d435(latlngs, options);
}




var $60d132431ff550d0$export$3a16e672cb3a069e = (0, $5cf3947d51f7fe8b$export$520fbf7f9cbd232d).extend({
    /* @section
	 * @aka GeoJSON options
	 *
	 * @option pointToLayer: Function = *
	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	 * The default is to spawn a default `Marker`:
	 * ```js
	 * function(geoJsonPoint, latlng) {
	 * 	return L.marker(latlng);
	 * }
	 * ```
	 *
	 * @option style: Function = *
	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	 * called internally when data is added.
	 * The default value is to not override any defaults:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return {}
	 * }
	 * ```
	 *
	 * @option onEachFeature: Function = *
	 * A `Function` that will be called once for each created `Feature`, after it has
	 * been created and styled. Useful for attaching events and popups to features.
	 * The default is to do nothing with the newly created layers:
	 * ```js
	 * function (feature, layer) {}
	 * ```
	 *
	 * @option filter: Function = *
	 * A `Function` that will be used to decide whether to include a feature or not.
	 * The default is to include all features:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return true;
	 * }
	 * ```
	 * Note: dynamically changing the `filter` option will have effect only on newly
	 * added data. It will _not_ re-evaluate already included features.
	 *
	 * @option coordsToLatLng: Function = *
	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	 * The default is the `coordsToLatLng` static method.
	 *
	 * @option markersInheritOptions: Boolean = false
	 * Whether default Markers for "Point" type Features inherit from group options.
	 */ initialize: function(geojson, options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        this._layers = {};
        if (geojson) this.addData(geojson);
    },
    // @method addData( <GeoJSON> data ): this
    // Adds a GeoJSON object to the layer.
    addData: function(geojson) {
        var features = $78a895d83da22602$export$43bee75e5e14138e(geojson) ? geojson : geojson.features, i, len, feature;
        if (features) {
            for(i = 0, len = features.length; i < len; i++){
                // only add this if geometry or geometries are set and not null
                feature = features[i];
                if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
            }
            return this;
        }
        var options = this.options;
        if (options.filter && !options.filter(geojson)) return this;
        var layer = $60d132431ff550d0$export$1d62dde364ca646a(geojson, options);
        if (!layer) return this;
        layer.feature = $60d132431ff550d0$export$9b5abe57af2a50eb(geojson);
        layer.defaultOptions = layer.options;
        this.resetStyle(layer);
        if (options.onEachFeature) options.onEachFeature(geojson, layer);
        return this.addLayer(layer);
    },
    // @method resetStyle( <Path> layer? ): this
    // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
    // If `layer` is omitted, the style of all features in the current layer is reset.
    resetStyle: function(layer) {
        if (layer === undefined) return this.eachLayer(this.resetStyle, this);
        // reset any custom styles
        layer.options = $78a895d83da22602$export$8b58be045bf06082({}, layer.defaultOptions);
        this._setLayerStyle(layer, this.options.style);
        return this;
    },
    // @method setStyle( <Function> style ): this
    // Changes styles of GeoJSON vector layers with the given style function.
    setStyle: function(style) {
        return this.eachLayer(function(layer) {
            this._setLayerStyle(layer, style);
        }, this);
    },
    _setLayerStyle: function(layer, style) {
        if (layer.setStyle) {
            if (typeof style === "function") style = style(layer.feature);
            layer.setStyle(style);
        }
    }
});
function $60d132431ff550d0$export$1d62dde364ca646a(geojson, options) {
    var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || $60d132431ff550d0$export$68c7da933fd21adc, latlng, latlngs, i, len;
    if (!coords && !geometry) return null;
    switch(geometry.type){
        case "Point":
            latlng = _coordsToLatLng(coords);
            return $60d132431ff550d0$var$_pointToLayer(pointToLayer, geojson, latlng, options);
        case "MultiPoint":
            for(i = 0, len = coords.length; i < len; i++){
                latlng = _coordsToLatLng(coords[i]);
                layers.push($60d132431ff550d0$var$_pointToLayer(pointToLayer, geojson, latlng, options));
            }
            return new (0, $5cf3947d51f7fe8b$export$520fbf7f9cbd232d)(layers);
        case "LineString":
        case "MultiLineString":
            latlngs = $60d132431ff550d0$export$95b72bfd8b68a8bf(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
            return new (0, $5923b206f6af4923$export$79f3ee03e63e7073)(latlngs, options);
        case "Polygon":
        case "MultiPolygon":
            latlngs = $60d132431ff550d0$export$95b72bfd8b68a8bf(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
            return new (0, $5c1ba64c6ac1b9ee$export$7d31b617c820d435)(latlngs, options);
        case "GeometryCollection":
            for(i = 0, len = geometry.geometries.length; i < len; i++){
                var geoLayer = $60d132431ff550d0$export$1d62dde364ca646a({
                    geometry: geometry.geometries[i],
                    type: "Feature",
                    properties: geojson.properties
                }, options);
                if (geoLayer) layers.push(geoLayer);
            }
            return new (0, $5cf3947d51f7fe8b$export$520fbf7f9cbd232d)(layers);
        case "FeatureCollection":
            for(i = 0, len = geometry.features.length; i < len; i++){
                var featureLayer = $60d132431ff550d0$export$1d62dde364ca646a(geometry.features[i], options);
                if (featureLayer) layers.push(featureLayer);
            }
            return new (0, $5cf3947d51f7fe8b$export$520fbf7f9cbd232d)(layers);
        default:
            throw new Error("Invalid GeoJSON object.");
    }
}
function $60d132431ff550d0$var$_pointToLayer(pointToLayerFn, geojson, latlng, options) {
    return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new (0, $30b9db4f4a4e141e$export$e98856a975cab58e)(latlng, options && options.markersInheritOptions && options);
}
function $60d132431ff550d0$export$68c7da933fd21adc(coords) {
    return new (0, $331f1841eb1ed916$export$5fd359ea0b43bded)(coords[1], coords[0], coords[2]);
}
function $60d132431ff550d0$export$95b72bfd8b68a8bf(coords, levelsDeep, _coordsToLatLng) {
    var latlngs = [];
    for(var i = 0, len = coords.length, latlng; i < len; i++){
        latlng = levelsDeep ? $60d132431ff550d0$export$95b72bfd8b68a8bf(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || $60d132431ff550d0$export$68c7da933fd21adc)(coords[i]);
        latlngs.push(latlng);
    }
    return latlngs;
}
function $60d132431ff550d0$export$4a4f4d0b257f82d2(latlng, precision) {
    latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng);
    return latlng.alt !== undefined ? [
        $78a895d83da22602$export$533e61f4ff7f35ce(latlng.lng, precision),
        $78a895d83da22602$export$533e61f4ff7f35ce(latlng.lat, precision),
        $78a895d83da22602$export$533e61f4ff7f35ce(latlng.alt, precision)
    ] : [
        $78a895d83da22602$export$533e61f4ff7f35ce(latlng.lng, precision),
        $78a895d83da22602$export$533e61f4ff7f35ce(latlng.lat, precision)
    ];
}
function $60d132431ff550d0$export$77b6e764d6612623(latlngs, levelsDeep, closed, precision) {
    var coords = [];
    for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
    coords.push(levelsDeep ? $60d132431ff550d0$export$77b6e764d6612623(latlngs[i], $63ae514521605ff0$export$5a20f49a17c681a1(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : $60d132431ff550d0$export$4a4f4d0b257f82d2(latlngs[i], precision));
    if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
    return coords;
}
function $60d132431ff550d0$export$bba2e7bbd72e62e1(layer, newGeometry) {
    return layer.feature ? $78a895d83da22602$export$8b58be045bf06082({}, layer.feature, {
        geometry: newGeometry
    }) : $60d132431ff550d0$export$9b5abe57af2a50eb(newGeometry);
}
function $60d132431ff550d0$export$9b5abe57af2a50eb(geojson) {
    if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
    return {
        type: "Feature",
        properties: {},
        geometry: geojson
    };
}
var $60d132431ff550d0$var$PointToGeoJSON = {
    toGeoJSON: function(precision) {
        return $60d132431ff550d0$export$bba2e7bbd72e62e1(this, {
            type: "Point",
            coordinates: $60d132431ff550d0$export$4a4f4d0b257f82d2(this.getLatLng(), precision)
        });
    }
};
// @namespace Marker
// @section Other methods
// @method toGeoJSON(precision?: Number|false): Object
// Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
// Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
(0, $30b9db4f4a4e141e$export$e98856a975cab58e).include($60d132431ff550d0$var$PointToGeoJSON);
// @namespace CircleMarker
// @method toGeoJSON(precision?: Number|false): Object
// Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
// Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
(0, $a6dea4780f62f692$export$c89a927ffc67e6fa).include($60d132431ff550d0$var$PointToGeoJSON);
(0, $535ebc027ffc2e03$export$7bf46a893731b161).include($60d132431ff550d0$var$PointToGeoJSON);
// @namespace Polyline
// @method toGeoJSON(precision?: Number|false): Object
// Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
// Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
(0, $5923b206f6af4923$export$79f3ee03e63e7073).include({
    toGeoJSON: function(precision) {
        var multi = !$63ae514521605ff0$export$5a20f49a17c681a1(this._latlngs);
        var coords = $60d132431ff550d0$export$77b6e764d6612623(this._latlngs, multi ? 1 : 0, false, precision);
        return $60d132431ff550d0$export$bba2e7bbd72e62e1(this, {
            type: (multi ? "Multi" : "") + "LineString",
            coordinates: coords
        });
    }
});
// @namespace Polygon
// @method toGeoJSON(precision?: Number|false): Object
// Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
// Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
(0, $5c1ba64c6ac1b9ee$export$7d31b617c820d435).include({
    toGeoJSON: function(precision) {
        var holes = !$63ae514521605ff0$export$5a20f49a17c681a1(this._latlngs), multi = holes && !$63ae514521605ff0$export$5a20f49a17c681a1(this._latlngs[0]);
        var coords = $60d132431ff550d0$export$77b6e764d6612623(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
        if (!holes) coords = [
            coords
        ];
        return $60d132431ff550d0$export$bba2e7bbd72e62e1(this, {
            type: (multi ? "Multi" : "") + "Polygon",
            coordinates: coords
        });
    }
});
// @namespace LayerGroup
(0, $d4fc2309740d4799$export$829212b9319961ea).include({
    toMultiPoint: function(precision) {
        var coords = [];
        this.eachLayer(function(layer) {
            coords.push(layer.toGeoJSON(precision).geometry.coordinates);
        });
        return $60d132431ff550d0$export$bba2e7bbd72e62e1(this, {
            type: "MultiPoint",
            coordinates: coords
        });
    },
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
    toGeoJSON: function(precision) {
        var type = this.feature && this.feature.geometry && this.feature.geometry.type;
        if (type === "MultiPoint") return this.toMultiPoint(precision);
        var isGeometryCollection = type === "GeometryCollection", jsons = [];
        this.eachLayer(function(layer) {
            if (layer.toGeoJSON) {
                var json = layer.toGeoJSON(precision);
                if (isGeometryCollection) jsons.push(json.geometry);
                else {
                    var feature = $60d132431ff550d0$export$9b5abe57af2a50eb(json);
                    // Squash nested feature collections
                    if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                    else jsons.push(feature);
                }
            }
        });
        if (isGeometryCollection) return $60d132431ff550d0$export$bba2e7bbd72e62e1(this, {
            geometries: jsons,
            type: "GeometryCollection"
        });
        return {
            type: "FeatureCollection",
            features: jsons
        };
    }
});
function $60d132431ff550d0$export$604402e11a6b4b56(geojson, options) {
    return new $60d132431ff550d0$export$3a16e672cb3a069e(geojson, options);
}
var $60d132431ff550d0$export$1c99306f6e0eb8a = $60d132431ff550d0$export$604402e11a6b4b56;







var $5e8cbf3f3ba32a5c$export$4e7a29849e6c05f6 = (0, $17ba674e92a8ad9d$export$936d0764594b6eb3).extend({
    // @section
    // @aka ImageOverlay options
    options: {
        // @option opacity: Number = 1.0
        // The opacity of the image overlay.
        opacity: 1,
        // @option alt: String = ''
        // Text for the `alt` attribute of the image (useful for accessibility).
        alt: "",
        // @option interactive: Boolean = false
        // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
        interactive: false,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the image.
        // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: false,
        // @option errorOverlayUrl: String = ''
        // URL to the overlay image to show in place of the overlay that failed to load.
        errorOverlayUrl: "",
        // @option zIndex: Number = 1
        // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
        zIndex: 1,
        // @option className: String = ''
        // A custom class name to assign to the image. Empty by default.
        className: ""
    },
    initialize: function(url, bounds, options) {
        this._url = url;
        this._bounds = (0, $1b787e0b76fef54a$export$4904432a68b0399)(bounds);
        $78a895d83da22602$export$add91eafeaeab287(this, options);
    },
    onAdd: function() {
        if (!this._image) {
            this._initImage();
            if (this.options.opacity < 1) this._updateOpacity();
        }
        if (this.options.interactive) {
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._image, "leaflet-interactive");
            this.addInteractiveTarget(this._image);
        }
        this.getPane().appendChild(this._image);
        this._reset();
    },
    onRemove: function() {
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._image);
        if (this.options.interactive) this.removeInteractiveTarget(this._image);
    },
    // @method setOpacity(opacity: Number): this
    // Sets the opacity of the overlay.
    setOpacity: function(opacity) {
        this.options.opacity = opacity;
        if (this._image) this._updateOpacity();
        return this;
    },
    setStyle: function(styleOpts) {
        if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
        return this;
    },
    // @method bringToFront(): this
    // Brings the layer to the top of all overlays.
    bringToFront: function() {
        if (this._map) $b316889e4737b9d0$export$967ea9e64a77dad2(this._image);
        return this;
    },
    // @method bringToBack(): this
    // Brings the layer to the bottom of all overlays.
    bringToBack: function() {
        if (this._map) $b316889e4737b9d0$export$4d34781508fd70d9(this._image);
        return this;
    },
    // @method setUrl(url: String): this
    // Changes the URL of the image.
    setUrl: function(url) {
        this._url = url;
        if (this._image) this._image.src = url;
        return this;
    },
    // @method setBounds(bounds: LatLngBounds): this
    // Update the bounds that this ImageOverlay covers
    setBounds: function(bounds) {
        this._bounds = (0, $1b787e0b76fef54a$export$4904432a68b0399)(bounds);
        if (this._map) this._reset();
        return this;
    },
    getEvents: function() {
        var events = {
            zoom: this._reset,
            viewreset: this._reset
        };
        if (this._zoomAnimated) events.zoomanim = this._animateZoom;
        return events;
    },
    // @method setZIndex(value: Number): this
    // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
    setZIndex: function(value) {
        this.options.zIndex = value;
        this._updateZIndex();
        return this;
    },
    // @method getBounds(): LatLngBounds
    // Get the bounds that this ImageOverlay covers
    getBounds: function() {
        return this._bounds;
    },
    // @method getElement(): HTMLElement
    // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
    // used by this overlay.
    getElement: function() {
        return this._image;
    },
    _initImage: function() {
        var wasElementSupplied = this._url.tagName === "IMG";
        var img = this._image = wasElementSupplied ? this._url : $b316889e4737b9d0$export$185802fd694ee1f5("img");
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(img, "leaflet-image-layer");
        if (this._zoomAnimated) $b316889e4737b9d0$export$d2cf6cd1dc7067d3(img, "leaflet-zoom-animated");
        if (this.options.className) $b316889e4737b9d0$export$d2cf6cd1dc7067d3(img, this.options.className);
        img.onselectstart = $78a895d83da22602$export$a3891e81a74c5e40;
        img.onmousemove = $78a895d83da22602$export$a3891e81a74c5e40;
        // @event load: Event
        // Fired when the ImageOverlay layer has loaded its image
        img.onload = $78a895d83da22602$export$2385a24977818dd0(this.fire, this, "load");
        img.onerror = $78a895d83da22602$export$2385a24977818dd0(this._overlayOnError, this, "error");
        if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
        if (this.options.zIndex) this._updateZIndex();
        if (wasElementSupplied) {
            this._url = img.src;
            return;
        }
        img.src = this._url;
        img.alt = this.options.alt;
    },
    _animateZoom: function(e) {
        var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
        $b316889e4737b9d0$export$ff09356c35bee89b(this._image, offset, scale);
    },
    _reset: function() {
        var image = this._image, bounds = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
        $b316889e4737b9d0$export$f9b088a47202d605(image, bounds.min);
        image.style.width = size.x + "px";
        image.style.height = size.y + "px";
    },
    _updateOpacity: function() {
        $b316889e4737b9d0$export$2646c6b151d2e8(this._image, this.options.opacity);
    },
    _updateZIndex: function() {
        if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
    },
    _overlayOnError: function() {
        // @event error: Event
        // Fired when the ImageOverlay layer fails to load its image
        this.fire("error");
        var errorUrl = this.options.errorOverlayUrl;
        if (errorUrl && this._url !== errorUrl) {
            this._url = errorUrl;
            this._image.src = errorUrl;
        }
    },
    // @method getCenter(): LatLng
    // Returns the center of the ImageOverlay.
    getCenter: function() {
        return this._bounds.getCenter();
    }
});
var $5e8cbf3f3ba32a5c$export$fc122a52569c1acc = function(url, bounds, options) {
    return new $5e8cbf3f3ba32a5c$export$4e7a29849e6c05f6(url, bounds, options);
};





var $bf8058a611ad0f1c$export$ea43284be2732fd6 = (0, $5e8cbf3f3ba32a5c$export$4e7a29849e6c05f6).extend({
    // @section
    // @aka VideoOverlay options
    options: {
        // @option autoplay: Boolean = true
        // Whether the video starts playing automatically when loaded.
        // On some browsers autoplay will only work with `muted: true`
        autoplay: true,
        // @option loop: Boolean = true
        // Whether the video will loop back to the beginning when played.
        loop: true,
        // @option keepAspectRatio: Boolean = true
        // Whether the video will save aspect ratio after the projection.
        // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
        keepAspectRatio: true,
        // @option muted: Boolean = false
        // Whether the video starts on mute when loaded.
        muted: false,
        // @option playsInline: Boolean = true
        // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
        playsInline: true
    },
    _initImage: function() {
        var wasElementSupplied = this._url.tagName === "VIDEO";
        var vid = this._image = wasElementSupplied ? this._url : $b316889e4737b9d0$export$185802fd694ee1f5("video");
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(vid, "leaflet-image-layer");
        if (this._zoomAnimated) $b316889e4737b9d0$export$d2cf6cd1dc7067d3(vid, "leaflet-zoom-animated");
        if (this.options.className) $b316889e4737b9d0$export$d2cf6cd1dc7067d3(vid, this.options.className);
        vid.onselectstart = $78a895d83da22602$export$a3891e81a74c5e40;
        vid.onmousemove = $78a895d83da22602$export$a3891e81a74c5e40;
        // @event load: Event
        // Fired when the video has finished loading the first frame
        vid.onloadeddata = $78a895d83da22602$export$2385a24977818dd0(this.fire, this, "load");
        if (wasElementSupplied) {
            var sourceElements = vid.getElementsByTagName("source");
            var sources = [];
            for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
            this._url = sourceElements.length > 0 ? sources : [
                vid.src
            ];
            return;
        }
        if (!$78a895d83da22602$export$43bee75e5e14138e(this._url)) this._url = [
            this._url
        ];
        if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
        vid.autoplay = !!this.options.autoplay;
        vid.loop = !!this.options.loop;
        vid.muted = !!this.options.muted;
        vid.playsInline = !!this.options.playsInline;
        for(var i = 0; i < this._url.length; i++){
            var source = $b316889e4737b9d0$export$185802fd694ee1f5("source");
            source.src = this._url[i];
            vid.appendChild(source);
        }
    }
});
function $bf8058a611ad0f1c$export$2d1a6f5a86a25927(video, bounds, options) {
    return new $bf8058a611ad0f1c$export$ea43284be2732fd6(video, bounds, options);
}





var $6fef7e9908d158e9$export$515991047e5232e6 = (0, $5e8cbf3f3ba32a5c$export$4e7a29849e6c05f6).extend({
    _initImage: function() {
        var el = this._image = this._url;
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(el, "leaflet-image-layer");
        if (this._zoomAnimated) $b316889e4737b9d0$export$d2cf6cd1dc7067d3(el, "leaflet-zoom-animated");
        if (this.options.className) $b316889e4737b9d0$export$d2cf6cd1dc7067d3(el, this.options.className);
        el.onselectstart = $78a895d83da22602$export$a3891e81a74c5e40;
        el.onmousemove = $78a895d83da22602$export$a3891e81a74c5e40;
    }
});
function $6fef7e9908d158e9$export$90d67fcde5ffe8ca(el, bounds, options) {
    return new $6fef7e9908d158e9$export$515991047e5232e6(el, bounds, options);
}









var $4965e5f94875d1de$export$16862402e2cc620a = (0, $17ba674e92a8ad9d$export$936d0764594b6eb3).extend({
    // @section
    // @aka DivOverlay options
    options: {
        // @option interactive: Boolean = false
        // If true, the popup/tooltip will listen to the mouse events.
        interactive: false,
        // @option offset: Point = Point(0, 0)
        // The offset of the overlay position.
        offset: [
            0,
            0
        ],
        // @option className: String = ''
        // A custom CSS class name to assign to the overlay.
        className: "",
        // @option pane: String = undefined
        // `Map pane` where the overlay will be added.
        pane: undefined,
        // @option content: String|HTMLElement|Function = ''
        // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
        // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
        content: ""
    },
    initialize: function(options, source) {
        if (options && (options instanceof (0, $331f1841eb1ed916$export$5fd359ea0b43bded) || $78a895d83da22602$export$43bee75e5e14138e(options))) {
            this._latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(options);
            $78a895d83da22602$export$add91eafeaeab287(this, source);
        } else {
            $78a895d83da22602$export$add91eafeaeab287(this, options);
            this._source = source;
        }
        if (this.options.content) this._content = this.options.content;
    },
    // @method openOn(map: Map): this
    // Adds the overlay to the map.
    // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
    openOn: function(map) {
        map = arguments.length ? map : this._source._map; // experimental, not the part of public api
        if (!map.hasLayer(this)) map.addLayer(this);
        return this;
    },
    // @method close(): this
    // Closes the overlay.
    // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
    // and `layer.closePopup()`/`.closeTooltip()`.
    close: function() {
        if (this._map) this._map.removeLayer(this);
        return this;
    },
    // @method toggle(layer?: Layer): this
    // Opens or closes the overlay bound to layer depending on its current state.
    // Argument may be omitted only for overlay bound to layer.
    // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
    toggle: function(layer) {
        if (this._map) this.close();
        else {
            if (arguments.length) this._source = layer;
            else layer = this._source;
            this._prepareOpen();
            // open the overlay on the map
            this.openOn(layer._map);
        }
        return this;
    },
    onAdd: function(map) {
        this._zoomAnimated = map._zoomAnimated;
        if (!this._container) this._initLayout();
        if (map._fadeAnimated) $b316889e4737b9d0$export$2646c6b151d2e8(this._container, 0);
        clearTimeout(this._removeTimeout);
        this.getPane().appendChild(this._container);
        this.update();
        if (map._fadeAnimated) $b316889e4737b9d0$export$2646c6b151d2e8(this._container, 1);
        this.bringToFront();
        if (this.options.interactive) {
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._container, "leaflet-interactive");
            this.addInteractiveTarget(this._container);
        }
    },
    onRemove: function(map) {
        if (map._fadeAnimated) {
            $b316889e4737b9d0$export$2646c6b151d2e8(this._container, 0);
            this._removeTimeout = setTimeout($78a895d83da22602$export$2385a24977818dd0($b316889e4737b9d0$export$cd7f480d6b8286c3, undefined, this._container), 200);
        } else $b316889e4737b9d0$export$cd7f480d6b8286c3(this._container);
        if (this.options.interactive) {
            $b316889e4737b9d0$export$c2255604a80b4506(this._container, "leaflet-interactive");
            this.removeInteractiveTarget(this._container);
        }
    },
    // @namespace DivOverlay
    // @method getLatLng: LatLng
    // Returns the geographical point of the overlay.
    getLatLng: function() {
        return this._latlng;
    },
    // @method setLatLng(latlng: LatLng): this
    // Sets the geographical point where the overlay will open.
    setLatLng: function(latlng) {
        this._latlng = (0, $331f1841eb1ed916$export$a192f247fc7a2057)(latlng);
        if (this._map) {
            this._updatePosition();
            this._adjustPan();
        }
        return this;
    },
    // @method getContent: String|HTMLElement
    // Returns the content of the overlay.
    getContent: function() {
        return this._content;
    },
    // @method setContent(htmlContent: String|HTMLElement|Function): this
    // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
    // The function should return a `String` or `HTMLElement` to be used in the overlay.
    setContent: function(content) {
        this._content = content;
        this.update();
        return this;
    },
    // @method getElement: String|HTMLElement
    // Returns the HTML container of the overlay.
    getElement: function() {
        return this._container;
    },
    // @method update: null
    // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
    update: function() {
        if (!this._map) return;
        this._container.style.visibility = "hidden";
        this._updateContent();
        this._updateLayout();
        this._updatePosition();
        this._container.style.visibility = "";
        this._adjustPan();
    },
    getEvents: function() {
        var events = {
            zoom: this._updatePosition,
            viewreset: this._updatePosition
        };
        if (this._zoomAnimated) events.zoomanim = this._animateZoom;
        return events;
    },
    // @method isOpen: Boolean
    // Returns `true` when the overlay is visible on the map.
    isOpen: function() {
        return !!this._map && this._map.hasLayer(this);
    },
    // @method bringToFront: this
    // Brings this overlay in front of other overlays (in the same map pane).
    bringToFront: function() {
        if (this._map) $b316889e4737b9d0$export$967ea9e64a77dad2(this._container);
        return this;
    },
    // @method bringToBack: this
    // Brings this overlay to the back of other overlays (in the same map pane).
    bringToBack: function() {
        if (this._map) $b316889e4737b9d0$export$4d34781508fd70d9(this._container);
        return this;
    },
    // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
    _prepareOpen: function(latlng) {
        var source = this._source;
        if (!source._map) return false;
        if (source instanceof (0, $5cf3947d51f7fe8b$export$520fbf7f9cbd232d)) {
            source = null;
            var layers = this._source._layers;
            for(var id in layers)if (layers[id]._map) {
                source = layers[id];
                break;
            }
            if (!source) return false;
             // Unable to get source layer.
            // set overlay source to this layer
            this._source = source;
        }
        if (!latlng) {
            if (source.getCenter) latlng = source.getCenter();
            else if (source.getLatLng) latlng = source.getLatLng();
            else if (source.getBounds) latlng = source.getBounds().getCenter();
            else throw new Error("Unable to get source layer LatLng.");
        }
        this.setLatLng(latlng);
        if (this._map) // update the overlay (content, layout, etc...)
        this.update();
        return true;
    },
    _updateContent: function() {
        if (!this._content) return;
        var node = this._contentNode;
        var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
        if (typeof content === "string") node.innerHTML = content;
        else {
            while(node.hasChildNodes())node.removeChild(node.firstChild);
            node.appendChild(content);
        }
        // @namespace DivOverlay
        // @section DivOverlay events
        // @event contentupdate: Event
        // Fired when the content of the overlay is updated
        this.fire("contentupdate");
    },
    _updatePosition: function() {
        if (!this._map) return;
        var pos = this._map.latLngToLayerPoint(this._latlng), offset = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(this.options.offset), anchor = this._getAnchor();
        if (this._zoomAnimated) $b316889e4737b9d0$export$f9b088a47202d605(this._container, pos.add(anchor));
        else offset = offset.add(pos).add(anchor);
        var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
        // bottom position the overlay in case the height of the overlay changes (images loading etc)
        this._container.style.bottom = bottom + "px";
        this._container.style.left = left + "px";
    },
    _getAnchor: function() {
        return [
            0,
            0
        ];
    }
});
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).include({
    _initOverlay: function(OverlayClass, content, latlng, options) {
        var overlay = content;
        if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
        if (latlng) overlay.setLatLng(latlng);
        return overlay;
    }
});
(0, $17ba674e92a8ad9d$export$936d0764594b6eb3).include({
    _initOverlay: function(OverlayClass, old, content, options) {
        var overlay = content;
        if (overlay instanceof OverlayClass) {
            $78a895d83da22602$export$add91eafeaeab287(overlay, options);
            overlay._source = this;
        } else {
            overlay = old && !options ? old : new OverlayClass(options, this);
            overlay.setContent(content);
        }
        return overlay;
    }
});










var $f2bcd878b9398d2d$export$129a32eedafa97c5 = (0, $4965e5f94875d1de$export$16862402e2cc620a).extend({
    // @section
    // @aka Popup options
    options: {
        // @option pane: String = 'popupPane'
        // `Map pane` where the popup will be added.
        pane: "popupPane",
        // @option offset: Point = Point(0, 7)
        // The offset of the popup position.
        offset: [
            0,
            7
        ],
        // @option maxWidth: Number = 300
        // Max width of the popup, in pixels.
        maxWidth: 300,
        // @option minWidth: Number = 50
        // Min width of the popup, in pixels.
        minWidth: 50,
        // @option maxHeight: Number = null
        // If set, creates a scrollable container of the given height
        // inside a popup if its content exceeds it.
        // The scrollable container can be styled using the
        // `leaflet-popup-scrolled` CSS class selector.
        maxHeight: null,
        // @option autoPan: Boolean = true
        // Set it to `false` if you don't want the map to do panning animation
        // to fit the opened popup.
        autoPan: true,
        // @option autoPanPaddingTopLeft: Point = null
        // The margin between the popup and the top left corner of the map
        // view after autopanning was performed.
        autoPanPaddingTopLeft: null,
        // @option autoPanPaddingBottomRight: Point = null
        // The margin between the popup and the bottom right corner of the map
        // view after autopanning was performed.
        autoPanPaddingBottomRight: null,
        // @option autoPanPadding: Point = Point(5, 5)
        // Equivalent of setting both top left and bottom right autopan padding to the same value.
        autoPanPadding: [
            5,
            5
        ],
        // @option keepInView: Boolean = false
        // Set it to `true` if you want to prevent users from panning the popup
        // off of the screen while it is open.
        keepInView: false,
        // @option closeButton: Boolean = true
        // Controls the presence of a close button in the popup.
        closeButton: true,
        // @option autoClose: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the popup closing when another popup is opened.
        autoClose: true,
        // @option closeOnEscapeKey: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the ESC key for closing of the popup.
        closeOnEscapeKey: true,
        // @option closeOnClick: Boolean = *
        // Set it if you want to override the default behavior of the popup closing when user clicks
        // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
        // @option className: String = ''
        // A custom CSS class name to assign to the popup.
        className: ""
    },
    // @namespace Popup
    // @method openOn(map: Map): this
    // Alternative to `map.openPopup(popup)`.
    // Adds the popup to the map and closes the previous one.
    openOn: function(map) {
        map = arguments.length ? map : this._source._map; // experimental, not the part of public api
        if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
        map._popup = this;
        return (0, $4965e5f94875d1de$export$16862402e2cc620a).prototype.openOn.call(this, map);
    },
    onAdd: function(map) {
        (0, $4965e5f94875d1de$export$16862402e2cc620a).prototype.onAdd.call(this, map);
        // @namespace Map
        // @section Popup events
        // @event popupopen: PopupEvent
        // Fired when a popup is opened in the map
        map.fire("popupopen", {
            popup: this
        });
        if (this._source) {
            // @namespace Layer
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup bound to this layer is opened
            this._source.fire("popupopen", {
                popup: this
            }, true);
            // For non-path layers, we toggle the popup when clicking
            // again the layer, so prevent the map to reopen it.
            if (!(this._source instanceof (0, $f59a1fa4c4c5d7b6$export$4b2950bdac9b6ee9))) this._source.on("preclick", $7c9dd72411ef2269$export$51134cce184326b9);
        }
    },
    onRemove: function(map) {
        (0, $4965e5f94875d1de$export$16862402e2cc620a).prototype.onRemove.call(this, map);
        // @namespace Map
        // @section Popup events
        // @event popupclose: PopupEvent
        // Fired when a popup in the map is closed
        map.fire("popupclose", {
            popup: this
        });
        if (this._source) {
            // @namespace Layer
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup bound to this layer is closed
            this._source.fire("popupclose", {
                popup: this
            }, true);
            if (!(this._source instanceof (0, $f59a1fa4c4c5d7b6$export$4b2950bdac9b6ee9))) this._source.off("preclick", $7c9dd72411ef2269$export$51134cce184326b9);
        }
    },
    getEvents: function() {
        var events = (0, $4965e5f94875d1de$export$16862402e2cc620a).prototype.getEvents.call(this);
        if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
        if (this.options.keepInView) events.moveend = this._adjustPan;
        return events;
    },
    _initLayout: function() {
        var prefix = "leaflet-popup", container = this._container = $b316889e4737b9d0$export$185802fd694ee1f5("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
        var wrapper = this._wrapper = $b316889e4737b9d0$export$185802fd694ee1f5("div", prefix + "-content-wrapper", container);
        this._contentNode = $b316889e4737b9d0$export$185802fd694ee1f5("div", prefix + "-content", wrapper);
        $7c9dd72411ef2269$export$a640b530813b3952(container);
        $7c9dd72411ef2269$export$383a0f6cce2d3ccb(this._contentNode);
        $7c9dd72411ef2269$export$af631764ddc44097(container, "contextmenu", $7c9dd72411ef2269$export$51134cce184326b9);
        this._tipContainer = $b316889e4737b9d0$export$185802fd694ee1f5("div", prefix + "-tip-container", container);
        this._tip = $b316889e4737b9d0$export$185802fd694ee1f5("div", prefix + "-tip", this._tipContainer);
        if (this.options.closeButton) {
            var closeButton = this._closeButton = $b316889e4737b9d0$export$185802fd694ee1f5("a", prefix + "-close-button", container);
            closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
            closeButton.setAttribute("aria-label", "Close popup");
            closeButton.href = "#close";
            closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
            $7c9dd72411ef2269$export$af631764ddc44097(closeButton, "click", function(ev) {
                $7c9dd72411ef2269$export$fa3b29edae795ef4(ev);
                this.close();
            }, this);
        }
    },
    _updateLayout: function() {
        var container = this._contentNode, style = container.style;
        style.width = "";
        style.whiteSpace = "nowrap";
        var width = container.offsetWidth;
        width = Math.min(width, this.options.maxWidth);
        width = Math.max(width, this.options.minWidth);
        style.width = width + 1 + "px";
        style.whiteSpace = "";
        style.height = "";
        var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
        if (maxHeight && height > maxHeight) {
            style.height = maxHeight + "px";
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(container, scrolledClass);
        } else $b316889e4737b9d0$export$c2255604a80b4506(container, scrolledClass);
        this._containerWidth = this._container.offsetWidth;
    },
    _animateZoom: function(e) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
        $b316889e4737b9d0$export$f9b088a47202d605(this._container, pos.add(anchor));
    },
    _adjustPan: function() {
        if (!this.options.autoPan) return;
        if (this._map._panAnim) this._map._panAnim.stop();
        // We can endlessly recurse if keepInView is set and the view resets.
        // Let's guard against that by exiting early if we're responding to our own autopan.
        if (this._autopanning) {
            this._autopanning = false;
            return;
        }
        var map = this._map, marginBottom = parseInt($b316889e4737b9d0$export$3d2f074408bd1b82(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new (0, $0552a615fcf79927$export$baf26146a414f24a)(this._containerLeft, -containerHeight - this._containerBottom);
        layerPos._add($b316889e4737b9d0$export$1690e12b840569b9(this._container));
        var containerPos = map.layerPointToContainerPoint(layerPos), padding = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(this.options.autoPanPadding), paddingTL = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(this.options.autoPanPaddingTopLeft || padding), paddingBR = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
        if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
        if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
        if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
        if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
        // @namespace Map
        // @section Popup events
        // @event autopanstart: Event
        // Fired when the map starts autopanning when opening a popup.
        if (dx || dy) {
            // Track that we're autopanning, as this function will be re-ran on moveend
            if (this.options.keepInView) this._autopanning = true;
            map.fire("autopanstart").panBy([
                dx,
                dy
            ]);
        }
    },
    _getAnchor: function() {
        // Where should we anchor the popup on the source layer?
        return (0, $0552a615fcf79927$export$b63cca88ddc558a9)(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
            0,
            0
        ]);
    }
});
var $f2bcd878b9398d2d$export$63b4813c5280c707 = function(options, source) {
    return new $f2bcd878b9398d2d$export$129a32eedafa97c5(options, source);
};
/* @namespace Map
 * @section Interaction Options
 * @option closePopupOnClick: Boolean = true
 * Set it to `false` if you don't want popups to close when user clicks the map.
 */ (0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    closePopupOnClick: true
});
// @namespace Map
// @section Methods for Layers and Controls
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).include({
    // @method openPopup(popup: Popup): this
    // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
    // @alternative
    // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
    // Creates a popup with the specified content and options and opens it in the given point on a map.
    openPopup: function(popup, latlng, options) {
        this._initOverlay($f2bcd878b9398d2d$export$129a32eedafa97c5, popup, latlng, options).openOn(this);
        return this;
    },
    // @method closePopup(popup?: Popup): this
    // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
    closePopup: function(popup) {
        popup = arguments.length ? popup : this._popup;
        if (popup) popup.close();
        return this;
    }
});
/*
 * @namespace Layer
 * @section Popup methods example
 *
 * All layers share a set of methods convenient for binding popups to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
 * layer.openPopup();
 * layer.closePopup();
 * ```
 *
 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
 */ // @section Popup methods
(0, $17ba674e92a8ad9d$export$936d0764594b6eb3).include({
    // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
    // Binds a popup to the layer with the passed `content` and sets up the
    // necessary event listeners. If a `Function` is passed it will receive
    // the layer as the first argument and should return a `String` or `HTMLElement`.
    bindPopup: function(content, options) {
        this._popup = this._initOverlay($f2bcd878b9398d2d$export$129a32eedafa97c5, this._popup, content, options);
        if (!this._popupHandlersAdded) {
            this.on({
                click: this._openPopup,
                keypress: this._onKeyPress,
                remove: this.closePopup,
                move: this._movePopup
            });
            this._popupHandlersAdded = true;
        }
        return this;
    },
    // @method unbindPopup(): this
    // Removes the popup previously bound with `bindPopup`.
    unbindPopup: function() {
        if (this._popup) {
            this.off({
                click: this._openPopup,
                keypress: this._onKeyPress,
                remove: this.closePopup,
                move: this._movePopup
            });
            this._popupHandlersAdded = false;
            this._popup = null;
        }
        return this;
    },
    // @method openPopup(latlng?: LatLng): this
    // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
    openPopup: function(latlng) {
        if (this._popup) {
            if (!(this instanceof (0, $5cf3947d51f7fe8b$export$520fbf7f9cbd232d))) this._popup._source = this;
            if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
            this._popup.openOn(this._map);
        }
        return this;
    },
    // @method closePopup(): this
    // Closes the popup bound to this layer if it is open.
    closePopup: function() {
        if (this._popup) this._popup.close();
        return this;
    },
    // @method togglePopup(): this
    // Opens or closes the popup bound to this layer depending on its current state.
    togglePopup: function() {
        if (this._popup) this._popup.toggle(this);
        return this;
    },
    // @method isPopupOpen(): boolean
    // Returns `true` if the popup bound to this layer is currently open.
    isPopupOpen: function() {
        return this._popup ? this._popup.isOpen() : false;
    },
    // @method setPopupContent(content: String|HTMLElement|Popup): this
    // Sets the content of the popup bound to this layer.
    setPopupContent: function(content) {
        if (this._popup) this._popup.setContent(content);
        return this;
    },
    // @method getPopup(): Popup
    // Returns the popup bound to this layer.
    getPopup: function() {
        return this._popup;
    },
    _openPopup: function(e) {
        if (!this._popup || !this._map) return;
        // prevent map click
        $7c9dd72411ef2269$export$fa6813432f753b0d(e);
        var target = e.layer || e.target;
        if (this._popup._source === target && !(target instanceof (0, $f59a1fa4c4c5d7b6$export$4b2950bdac9b6ee9))) {
            // treat it like a marker and figure out
            // if we should toggle it open/closed
            if (this._map.hasLayer(this._popup)) this.closePopup();
            else this.openPopup(e.latlng);
            return;
        }
        this._popup._source = target;
        this.openPopup(e.latlng);
    },
    _movePopup: function(e) {
        this._popup.setLatLng(e.latlng);
    },
    _onKeyPress: function(e) {
        if (e.originalEvent.keyCode === 13) this._openPopup(e);
    }
});










var $4e4eba329242a160$export$28c660c63b792dea = (0, $4965e5f94875d1de$export$16862402e2cc620a).extend({
    // @section
    // @aka Tooltip options
    options: {
        // @option pane: String = 'tooltipPane'
        // `Map pane` where the tooltip will be added.
        pane: "tooltipPane",
        // @option offset: Point = Point(0, 0)
        // Optional offset of the tooltip position.
        offset: [
            0,
            0
        ],
        // @option direction: String = 'auto'
        // Direction where to open the tooltip. Possible values are: `right`, `left`,
        // `top`, `bottom`, `center`, `auto`.
        // `auto` will dynamically switch between `right` and `left` according to the tooltip
        // position on the map.
        direction: "auto",
        // @option permanent: Boolean = false
        // Whether to open the tooltip permanently or only on mouseover.
        permanent: false,
        // @option sticky: Boolean = false
        // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
        sticky: false,
        // @option opacity: Number = 0.9
        // Tooltip container opacity.
        opacity: 0.9
    },
    onAdd: function(map) {
        (0, $4965e5f94875d1de$export$16862402e2cc620a).prototype.onAdd.call(this, map);
        this.setOpacity(this.options.opacity);
        // @namespace Map
        // @section Tooltip events
        // @event tooltipopen: TooltipEvent
        // Fired when a tooltip is opened in the map.
        map.fire("tooltipopen", {
            tooltip: this
        });
        if (this._source) {
            this.addEventParent(this._source);
            // @namespace Layer
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip bound to this layer is opened.
            this._source.fire("tooltipopen", {
                tooltip: this
            }, true);
        }
    },
    onRemove: function(map) {
        (0, $4965e5f94875d1de$export$16862402e2cc620a).prototype.onRemove.call(this, map);
        // @namespace Map
        // @section Tooltip events
        // @event tooltipclose: TooltipEvent
        // Fired when a tooltip in the map is closed.
        map.fire("tooltipclose", {
            tooltip: this
        });
        if (this._source) {
            this.removeEventParent(this._source);
            // @namespace Layer
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip bound to this layer is closed.
            this._source.fire("tooltipclose", {
                tooltip: this
            }, true);
        }
    },
    getEvents: function() {
        var events = (0, $4965e5f94875d1de$export$16862402e2cc620a).prototype.getEvents.call(this);
        if (!this.options.permanent) events.preclick = this.close;
        return events;
    },
    _initLayout: function() {
        var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        this._contentNode = this._container = $b316889e4737b9d0$export$185802fd694ee1f5("div", className);
        this._container.setAttribute("role", "tooltip");
        this._container.setAttribute("id", "leaflet-tooltip-" + $78a895d83da22602$export$bd3fba034e28f6b(this));
    },
    _updateLayout: function() {},
    _adjustPan: function() {},
    _setPosition: function(pos) {
        var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(this.options.offset), anchor = this._getAnchor();
        if (direction === "top") {
            subX = tooltipWidth / 2;
            subY = tooltipHeight;
        } else if (direction === "bottom") {
            subX = tooltipWidth / 2;
            subY = 0;
        } else if (direction === "center") {
            subX = tooltipWidth / 2;
            subY = tooltipHeight / 2;
        } else if (direction === "right") {
            subX = 0;
            subY = tooltipHeight / 2;
        } else if (direction === "left") {
            subX = tooltipWidth;
            subY = tooltipHeight / 2;
        } else if (tooltipPoint.x < centerPoint.x) {
            direction = "right";
            subX = 0;
            subY = tooltipHeight / 2;
        } else {
            direction = "left";
            subX = tooltipWidth + (offset.x + anchor.x) * 2;
            subY = tooltipHeight / 2;
        }
        pos = pos.subtract((0, $0552a615fcf79927$export$b63cca88ddc558a9)(subX, subY, true)).add(offset).add(anchor);
        $b316889e4737b9d0$export$c2255604a80b4506(container, "leaflet-tooltip-right");
        $b316889e4737b9d0$export$c2255604a80b4506(container, "leaflet-tooltip-left");
        $b316889e4737b9d0$export$c2255604a80b4506(container, "leaflet-tooltip-top");
        $b316889e4737b9d0$export$c2255604a80b4506(container, "leaflet-tooltip-bottom");
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(container, "leaflet-tooltip-" + direction);
        $b316889e4737b9d0$export$f9b088a47202d605(container, pos);
    },
    _updatePosition: function() {
        var pos = this._map.latLngToLayerPoint(this._latlng);
        this._setPosition(pos);
    },
    setOpacity: function(opacity) {
        this.options.opacity = opacity;
        if (this._container) $b316889e4737b9d0$export$2646c6b151d2e8(this._container, opacity);
    },
    _animateZoom: function(e) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
        this._setPosition(pos);
    },
    _getAnchor: function() {
        // Where should we anchor the tooltip on the source layer?
        return (0, $0552a615fcf79927$export$b63cca88ddc558a9)(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
            0,
            0
        ]);
    }
});
var $4e4eba329242a160$export$4e6f96734dfe12f4 = function(options, source) {
    return new $4e4eba329242a160$export$28c660c63b792dea(options, source);
};
// @namespace Map
// @section Methods for Layers and Controls
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).include({
    // @method openTooltip(tooltip: Tooltip): this
    // Opens the specified tooltip.
    // @alternative
    // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
    // Creates a tooltip with the specified content and options and open it.
    openTooltip: function(tooltip, latlng, options) {
        this._initOverlay($4e4eba329242a160$export$28c660c63b792dea, tooltip, latlng, options).openOn(this);
        return this;
    },
    // @method closeTooltip(tooltip: Tooltip): this
    // Closes the tooltip given as parameter.
    closeTooltip: function(tooltip) {
        tooltip.close();
        return this;
    }
});
/*
 * @namespace Layer
 * @section Tooltip methods example
 *
 * All layers share a set of methods convenient for binding tooltips to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
 * layer.openTooltip();
 * layer.closeTooltip();
 * ```
 */ // @section Tooltip methods
(0, $17ba674e92a8ad9d$export$936d0764594b6eb3).include({
    // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
    // Binds a tooltip to the layer with the passed `content` and sets up the
    // necessary event listeners. If a `Function` is passed it will receive
    // the layer as the first argument and should return a `String` or `HTMLElement`.
    bindTooltip: function(content, options) {
        if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
        this._tooltip = this._initOverlay($4e4eba329242a160$export$28c660c63b792dea, this._tooltip, content, options);
        this._initTooltipInteractions();
        if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
        return this;
    },
    // @method unbindTooltip(): this
    // Removes the tooltip previously bound with `bindTooltip`.
    unbindTooltip: function() {
        if (this._tooltip) {
            this._initTooltipInteractions(true);
            this.closeTooltip();
            this._tooltip = null;
        }
        return this;
    },
    _initTooltipInteractions: function(remove) {
        if (!remove && this._tooltipHandlersAdded) return;
        var onOff = remove ? "off" : "on", events = {
            remove: this.closeTooltip,
            move: this._moveTooltip
        };
        if (!this._tooltip.options.permanent) {
            events.mouseover = this._openTooltip;
            events.mouseout = this.closeTooltip;
            events.click = this._openTooltip;
            if (this._map) this._addFocusListeners();
            else events.add = this._addFocusListeners;
        } else events.add = this._openTooltip;
        if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
        this[onOff](events);
        this._tooltipHandlersAdded = !remove;
    },
    // @method openTooltip(latlng?: LatLng): this
    // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
    openTooltip: function(latlng) {
        if (this._tooltip) {
            if (!(this instanceof (0, $5cf3947d51f7fe8b$export$520fbf7f9cbd232d))) this._tooltip._source = this;
            if (this._tooltip._prepareOpen(latlng)) {
                // open the tooltip on the map
                this._tooltip.openOn(this._map);
                if (this.getElement) this._setAriaDescribedByOnLayer(this);
                else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
            }
        }
        return this;
    },
    // @method closeTooltip(): this
    // Closes the tooltip bound to this layer if it is open.
    closeTooltip: function() {
        if (this._tooltip) return this._tooltip.close();
    },
    // @method toggleTooltip(): this
    // Opens or closes the tooltip bound to this layer depending on its current state.
    toggleTooltip: function() {
        if (this._tooltip) this._tooltip.toggle(this);
        return this;
    },
    // @method isTooltipOpen(): boolean
    // Returns `true` if the tooltip bound to this layer is currently open.
    isTooltipOpen: function() {
        return this._tooltip.isOpen();
    },
    // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
    // Sets the content of the tooltip bound to this layer.
    setTooltipContent: function(content) {
        if (this._tooltip) this._tooltip.setContent(content);
        return this;
    },
    // @method getTooltip(): Tooltip
    // Returns the tooltip bound to this layer.
    getTooltip: function() {
        return this._tooltip;
    },
    _addFocusListeners: function() {
        if (this.getElement) this._addFocusListenersOnLayer(this);
        else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
    },
    _addFocusListenersOnLayer: function(layer) {
        var el = typeof layer.getElement === "function" && layer.getElement();
        if (el) {
            $7c9dd72411ef2269$export$af631764ddc44097(el, "focus", function() {
                this._tooltip._source = layer;
                this.openTooltip();
            }, this);
            $7c9dd72411ef2269$export$af631764ddc44097(el, "blur", this.closeTooltip, this);
        }
    },
    _setAriaDescribedByOnLayer: function(layer) {
        var el = typeof layer.getElement === "function" && layer.getElement();
        if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
    },
    _openTooltip: function(e) {
        if (!this._tooltip || !this._map) return;
        // If the map is moving, we will show the tooltip after it's done.
        if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
            this._openOnceFlag = true;
            var that = this;
            this._map.once("moveend", function() {
                that._openOnceFlag = false;
                that._openTooltip(e);
            });
            return;
        }
        this._tooltip._source = e.layer || e.target;
        this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
    },
    _moveTooltip: function(e) {
        var latlng = e.latlng, containerPoint, layerPoint;
        if (this._tooltip.options.sticky && e.originalEvent) {
            containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
            layerPoint = this._map.containerPointToLayerPoint(containerPoint);
            latlng = this._map.layerPointToLatLng(layerPoint);
        }
        this._tooltip.setLatLng(latlng);
    }
});







var $afcbf3d238c0f4a7$export$2cb0785d16917af = (0, $ce8b38ccde560ce6$export$f04a61298a47a40f).extend({
    options: {
        // @section
        // @aka DivIcon options
        iconSize: [
            12,
            12
        ],
        // iconAnchor: (Point),
        // popupAnchor: (Point),
        // @option html: String|HTMLElement = ''
        // Custom HTML code to put inside the div element, empty by default. Alternatively,
        // an instance of `HTMLElement`.
        html: false,
        // @option bgPos: Point = [0, 0]
        // Optional relative position of the background, in pixels
        bgPos: null,
        className: "leaflet-div-icon"
    },
    createIcon: function(oldIcon) {
        var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
        if (options.html instanceof Element) {
            (0, $b316889e4737b9d0$export$6e22c362a0406a2c)(div);
            div.appendChild(options.html);
        } else div.innerHTML = options.html !== false ? options.html : "";
        if (options.bgPos) {
            var bgPos = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(options.bgPos);
            div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
        }
        this._setIconStyles(div, "icon");
        return div;
    },
    createShadow: function() {
        return null;
    }
});
function $afcbf3d238c0f4a7$export$46821b1bf0daf45b(options) {
    return new $afcbf3d238c0f4a7$export$2cb0785d16917af(options);
}



(0, $ce8b38ccde560ce6$export$f04a61298a47a40f).Default = (0, $fddf1565bfa293cc$export$cacc2a877598679f);









var $1d438cf1f584f090$export$3b2364b911db251c = (0, $17ba674e92a8ad9d$export$936d0764594b6eb3).extend({
    // @section
    // @aka GridLayer options
    options: {
        // @option tileSize: Number|Point = 256
        // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
        tileSize: 256,
        // @option opacity: Number = 1.0
        // Opacity of the tiles. Can be used in the `createTile()` function.
        opacity: 1,
        // @option updateWhenIdle: Boolean = (depends)
        // Load new tiles only when panning ends.
        // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
        // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
        // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
        updateWhenIdle: (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).mobile,
        // @option updateWhenZooming: Boolean = true
        // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
        updateWhenZooming: true,
        // @option updateInterval: Number = 200
        // Tiles will not update more than once every `updateInterval` milliseconds when panning.
        updateInterval: 200,
        // @option zIndex: Number = 1
        // The explicit zIndex of the tile layer.
        zIndex: 1,
        // @option bounds: LatLngBounds = undefined
        // If set, tiles will only be loaded inside the set `LatLngBounds`.
        bounds: null,
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = undefined
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: undefined,
        // @option maxNativeZoom: Number = undefined
        // Maximum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
        // from `maxNativeZoom` level and auto-scaled.
        maxNativeZoom: undefined,
        // @option minNativeZoom: Number = undefined
        // Minimum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
        // from `minNativeZoom` level and auto-scaled.
        minNativeZoom: undefined,
        // @option noWrap: Boolean = false
        // Whether the layer is wrapped around the antimeridian. If `true`, the
        // GridLayer will only be displayed once at low zoom levels. Has no
        // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
        // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
        // tiles outside the CRS limits.
        noWrap: false,
        // @option pane: String = 'tilePane'
        // `Map pane` where the grid layer will be added.
        pane: "tilePane",
        // @option className: String = ''
        // A custom class name to assign to the tile layer. Empty by default.
        className: "",
        // @option keepBuffer: Number = 2
        // When panning the map, keep this many rows and columns of tiles before unloading them.
        keepBuffer: 2
    },
    initialize: function(options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
    },
    onAdd: function() {
        this._initContainer();
        this._levels = {};
        this._tiles = {};
        this._resetView(); // implicit _update() call
    },
    beforeAdd: function(map) {
        map._addZoomLimit(this);
    },
    onRemove: function(map) {
        this._removeAllTiles();
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._container);
        map._removeZoomLimit(this);
        this._container = null;
        this._tileZoom = undefined;
    },
    // @method bringToFront: this
    // Brings the tile layer to the top of all tile layers.
    bringToFront: function() {
        if (this._map) {
            $b316889e4737b9d0$export$967ea9e64a77dad2(this._container);
            this._setAutoZIndex(Math.max);
        }
        return this;
    },
    // @method bringToBack: this
    // Brings the tile layer to the bottom of all tile layers.
    bringToBack: function() {
        if (this._map) {
            $b316889e4737b9d0$export$4d34781508fd70d9(this._container);
            this._setAutoZIndex(Math.min);
        }
        return this;
    },
    // @method getContainer: HTMLElement
    // Returns the HTML element that contains the tiles for this layer.
    getContainer: function() {
        return this._container;
    },
    // @method setOpacity(opacity: Number): this
    // Changes the [opacity](#gridlayer-opacity) of the grid layer.
    setOpacity: function(opacity) {
        this.options.opacity = opacity;
        this._updateOpacity();
        return this;
    },
    // @method setZIndex(zIndex: Number): this
    // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
    setZIndex: function(zIndex) {
        this.options.zIndex = zIndex;
        this._updateZIndex();
        return this;
    },
    // @method isLoading: Boolean
    // Returns `true` if any tile in the grid layer has not finished loading.
    isLoading: function() {
        return this._loading;
    },
    // @method redraw: this
    // Causes the layer to clear all the tiles and request them again.
    redraw: function() {
        if (this._map) {
            this._removeAllTiles();
            var tileZoom = this._clampZoom(this._map.getZoom());
            if (tileZoom !== this._tileZoom) {
                this._tileZoom = tileZoom;
                this._updateLevels();
            }
            this._update();
        }
        return this;
    },
    getEvents: function() {
        var events = {
            viewprereset: this._invalidateAll,
            viewreset: this._resetView,
            zoom: this._resetView,
            moveend: this._onMoveEnd
        };
        if (!this.options.updateWhenIdle) {
            // update tiles on move, but not more often than once per given interval
            if (!this._onMove) this._onMove = $78a895d83da22602$export$de363e709c412c8a(this._onMoveEnd, this.options.updateInterval, this);
            events.move = this._onMove;
        }
        if (this._zoomAnimated) events.zoomanim = this._animateZoom;
        return events;
    },
    // @section Extension methods
    // Layers extending `GridLayer` shall reimplement the following method.
    // @method createTile(coords: Object, done?: Function): HTMLElement
    // Called only internally, must be overridden by classes extending `GridLayer`.
    // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
    // is specified, it must be called when the tile has finished loading and drawing.
    createTile: function() {
        return document.createElement("div");
    },
    // @section
    // @method getTileSize: Point
    // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
    getTileSize: function() {
        var s = this.options.tileSize;
        return s instanceof (0, $0552a615fcf79927$export$baf26146a414f24a) ? s : new (0, $0552a615fcf79927$export$baf26146a414f24a)(s, s);
    },
    _updateZIndex: function() {
        if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
    },
    _setAutoZIndex: function(compare) {
        // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
        var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
        for(var i = 0, len = layers.length, zIndex; i < len; i++){
            zIndex = layers[i].style.zIndex;
            if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
        }
        if (isFinite(edgeZIndex)) {
            this.options.zIndex = edgeZIndex + compare(-1, 1);
            this._updateZIndex();
        }
    },
    _updateOpacity: function() {
        if (!this._map) return;
        // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
        if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).ielt9) return;
        $b316889e4737b9d0$export$2646c6b151d2e8(this._container, this.options.opacity);
        var now = +new Date(), nextFrame = false, willPrune = false;
        for(var key in this._tiles){
            var tile = this._tiles[key];
            if (!tile.current || !tile.loaded) continue;
            var fade = Math.min(1, (now - tile.loaded) / 200);
            $b316889e4737b9d0$export$2646c6b151d2e8(tile.el, fade);
            if (fade < 1) nextFrame = true;
            else {
                if (tile.active) willPrune = true;
                else this._onOpaqueTile(tile);
                tile.active = true;
            }
        }
        if (willPrune && !this._noPrune) this._pruneTiles();
        if (nextFrame) {
            $78a895d83da22602$export$e1ed83507f55dc9d(this._fadeFrame);
            this._fadeFrame = $78a895d83da22602$export$d371ad015c199c06(this._updateOpacity, this);
        }
    },
    _onOpaqueTile: $78a895d83da22602$export$a3891e81a74c5e40,
    _initContainer: function() {
        if (this._container) return;
        this._container = $b316889e4737b9d0$export$185802fd694ee1f5("div", "leaflet-layer " + (this.options.className || ""));
        this._updateZIndex();
        if (this.options.opacity < 1) this._updateOpacity();
        this.getPane().appendChild(this._container);
    },
    _updateLevels: function() {
        var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
        if (zoom === undefined) return undefined;
        for(var z in this._levels){
            z = Number(z);
            if (this._levels[z].el.children.length || z === zoom) {
                this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                this._onUpdateLevel(z);
            } else {
                $b316889e4737b9d0$export$cd7f480d6b8286c3(this._levels[z].el);
                this._removeTilesAtZoom(z);
                this._onRemoveLevel(z);
                delete this._levels[z];
            }
        }
        var level = this._levels[zoom], map = this._map;
        if (!level) {
            level = this._levels[zoom] = {};
            level.el = $b316889e4737b9d0$export$185802fd694ee1f5("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
            level.el.style.zIndex = maxZoom;
            level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
            level.zoom = zoom;
            this._setZoomTransform(level, map.getCenter(), map.getZoom());
            // force the browser to consider the newly added element for transition
            $78a895d83da22602$export$a3891e81a74c5e40(level.el.offsetWidth);
            this._onCreateLevel(level);
        }
        this._level = level;
        return level;
    },
    _onUpdateLevel: $78a895d83da22602$export$a3891e81a74c5e40,
    _onRemoveLevel: $78a895d83da22602$export$a3891e81a74c5e40,
    _onCreateLevel: $78a895d83da22602$export$a3891e81a74c5e40,
    _pruneTiles: function() {
        if (!this._map) return;
        var key, tile;
        var zoom = this._map.getZoom();
        if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
            this._removeAllTiles();
            return;
        }
        for(key in this._tiles){
            tile = this._tiles[key];
            tile.retain = tile.current;
        }
        for(key in this._tiles){
            tile = this._tiles[key];
            if (tile.current && !tile.active) {
                var coords = tile.coords;
                if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
            }
        }
        for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
    },
    _removeTilesAtZoom: function(zoom) {
        for(var key in this._tiles){
            if (this._tiles[key].coords.z !== zoom) continue;
            this._removeTile(key);
        }
    },
    _removeAllTiles: function() {
        for(var key in this._tiles)this._removeTile(key);
    },
    _invalidateAll: function() {
        for(var z in this._levels){
            $b316889e4737b9d0$export$cd7f480d6b8286c3(this._levels[z].el);
            this._onRemoveLevel(Number(z));
            delete this._levels[z];
        }
        this._removeAllTiles();
        this._tileZoom = undefined;
    },
    _retainParent: function(x, y, z, minZoom) {
        var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new (0, $0552a615fcf79927$export$baf26146a414f24a)(+x2, +y2);
        coords2.z = +z2;
        var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
        if (tile && tile.active) {
            tile.retain = true;
            return true;
        } else if (tile && tile.loaded) tile.retain = true;
        if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
        return false;
    },
    _retainChildren: function(x, y, z, maxZoom) {
        for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
            var coords = new (0, $0552a615fcf79927$export$baf26146a414f24a)(i, j);
            coords.z = z + 1;
            var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                continue;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
        }
    },
    _resetView: function(e) {
        var animating = e && (e.pinch || e.flyTo);
        this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
    },
    _animateZoom: function(e) {
        this._setView(e.center, e.zoom, true, e.noUpdate);
    },
    _clampZoom: function(zoom) {
        var options = this.options;
        if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
        if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
        return zoom;
    },
    _setView: function(center, zoom, noPrune, noUpdate) {
        var tileZoom = Math.round(zoom);
        if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
        else tileZoom = this._clampZoom(tileZoom);
        var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
        if (!noUpdate || tileZoomChanged) {
            this._tileZoom = tileZoom;
            if (this._abortLoading) this._abortLoading();
            this._updateLevels();
            this._resetGrid();
            if (tileZoom !== undefined) this._update(center);
            if (!noPrune) this._pruneTiles();
            // Flag to prevent _updateOpacity from pruning tiles during
            // a zoom anim or a pinch gesture
            this._noPrune = !!noPrune;
        }
        this._setZoomTransforms(center, zoom);
    },
    _setZoomTransforms: function(center, zoom) {
        for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
    },
    _setZoomTransform: function(level, center, zoom) {
        var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
        if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d) $b316889e4737b9d0$export$ff09356c35bee89b(level.el, translate, scale);
        else $b316889e4737b9d0$export$f9b088a47202d605(level.el, translate);
    },
    _resetGrid: function() {
        var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
        var bounds = this._map.getPixelWorldBounds(this._tileZoom);
        if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
        this._wrapX = crs.wrapLng && !this.options.noWrap && [
            Math.floor(map.project([
                0,
                crs.wrapLng[0]
            ], tileZoom).x / tileSize.x),
            Math.ceil(map.project([
                0,
                crs.wrapLng[1]
            ], tileZoom).x / tileSize.y)
        ];
        this._wrapY = crs.wrapLat && !this.options.noWrap && [
            Math.floor(map.project([
                crs.wrapLat[0],
                0
            ], tileZoom).y / tileSize.x),
            Math.ceil(map.project([
                crs.wrapLat[1],
                0
            ], tileZoom).y / tileSize.y)
        ];
    },
    _onMoveEnd: function() {
        if (!this._map || this._map._animatingZoom) return;
        this._update();
    },
    _getTiledPixelBounds: function(center) {
        var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
        return new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
    },
    // Private method to load tiles in the grid's active zoom level according to map bounds
    _update: function(center) {
        var map = this._map;
        if (!map) return;
        var zoom = this._clampZoom(map.getZoom());
        if (center === undefined) center = map.getCenter();
        if (this._tileZoom === undefined) return;
         // if out of minzoom/maxzoom
        var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(tileRange.getBottomLeft().subtract([
            margin,
            -margin
        ]), tileRange.getTopRight().add([
            margin,
            -margin
        ]));
        // Sanity check: panic if the tile range contains Infinity somewhere.
        if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
        for(var key in this._tiles){
            var c = this._tiles[key].coords;
            if (c.z !== this._tileZoom || !noPruneRange.contains(new (0, $0552a615fcf79927$export$baf26146a414f24a)(c.x, c.y))) this._tiles[key].current = false;
        }
        // _update just loads more tiles. If the tile zoom level differs too much
        // from the map's, let _setView reset levels and prune old tiles.
        if (Math.abs(zoom - this._tileZoom) > 1) {
            this._setView(center, zoom);
            return;
        }
        // create a queue of coordinates to load tiles from
        for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
            var coords = new (0, $0552a615fcf79927$export$baf26146a414f24a)(i, j);
            coords.z = this._tileZoom;
            if (!this._isValidTile(coords)) continue;
            var tile = this._tiles[this._tileCoordsToKey(coords)];
            if (tile) tile.current = true;
            else queue.push(coords);
        }
        // sort tile queue to load tiles in order of their distance to center
        queue.sort(function(a, b) {
            return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
        });
        if (queue.length !== 0) {
            // if it's the first batch of tiles to load
            if (!this._loading) {
                this._loading = true;
                // @event loading: Event
                // Fired when the grid layer starts loading tiles.
                this.fire("loading");
            }
            // create DOM fragment to append tiles in one batch
            var fragment = document.createDocumentFragment();
            for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
            this._level.el.appendChild(fragment);
        }
    },
    _isValidTile: function(coords) {
        var crs = this._map.options.crs;
        if (!crs.infinite) {
            // don't load tile if it's out of bounds and not wrapped
            var bounds = this._globalTileRange;
            if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
        }
        if (!this.options.bounds) return true;
        // don't load tile if it doesn't intersect the bounds in options
        var tileBounds = this._tileCoordsToBounds(coords);
        return (0, $1b787e0b76fef54a$export$4904432a68b0399)(this.options.bounds).overlaps(tileBounds);
    },
    _keyToBounds: function(key) {
        return this._tileCoordsToBounds(this._keyToTileCoords(key));
    },
    _tileCoordsToNwSe: function(coords) {
        var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
        return [
            nw,
            se
        ];
    },
    // converts tile coordinates to its geographical bounds
    _tileCoordsToBounds: function(coords) {
        var bp = this._tileCoordsToNwSe(coords), bounds = new (0, $1b787e0b76fef54a$export$fe84d4076a55a8e6)(bp[0], bp[1]);
        if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
        return bounds;
    },
    // converts tile coordinates to key for the tile cache
    _tileCoordsToKey: function(coords) {
        return coords.x + ":" + coords.y + ":" + coords.z;
    },
    // converts tile cache key to coordinates
    _keyToTileCoords: function(key) {
        var k = key.split(":"), coords = new (0, $0552a615fcf79927$export$baf26146a414f24a)(+k[0], +k[1]);
        coords.z = +k[2];
        return coords;
    },
    _removeTile: function(key) {
        var tile = this._tiles[key];
        if (!tile) return;
        $b316889e4737b9d0$export$cd7f480d6b8286c3(tile.el);
        delete this._tiles[key];
        // @event tileunload: TileEvent
        // Fired when a tile is removed (e.g. when a tile goes off the screen).
        this.fire("tileunload", {
            tile: tile.el,
            coords: this._keyToTileCoords(key)
        });
    },
    _initTile: function(tile) {
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(tile, "leaflet-tile");
        var tileSize = this.getTileSize();
        tile.style.width = tileSize.x + "px";
        tile.style.height = tileSize.y + "px";
        tile.onselectstart = $78a895d83da22602$export$a3891e81a74c5e40;
        tile.onmousemove = $78a895d83da22602$export$a3891e81a74c5e40;
        // update opacity on tiles in IE7-8 because of filter inheritance problems
        if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).ielt9 && this.options.opacity < 1) $b316889e4737b9d0$export$2646c6b151d2e8(tile, this.options.opacity);
    },
    _addTile: function(coords, container) {
        var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
        var tile = this.createTile(this._wrapCoords(coords), $78a895d83da22602$export$2385a24977818dd0(this._tileReady, this, coords));
        this._initTile(tile);
        // if createTile is defined with a second argument ("done" callback),
        // we know that tile is async and will be ready later; otherwise
        if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
        $78a895d83da22602$export$d371ad015c199c06($78a895d83da22602$export$2385a24977818dd0(this._tileReady, this, coords, null, tile));
        $b316889e4737b9d0$export$f9b088a47202d605(tile, tilePos);
        // save tile in cache
        this._tiles[key] = {
            el: tile,
            coords: coords,
            current: true
        };
        container.appendChild(tile);
        // @event tileloadstart: TileEvent
        // Fired when a tile is requested and starts loading.
        this.fire("tileloadstart", {
            tile: tile,
            coords: coords
        });
    },
    _tileReady: function(coords, err, tile) {
        if (err) // @event tileerror: TileErrorEvent
        // Fired when there is an error loading a tile.
        this.fire("tileerror", {
            error: err,
            tile: tile,
            coords: coords
        });
        var key = this._tileCoordsToKey(coords);
        tile = this._tiles[key];
        if (!tile) return;
        tile.loaded = +new Date();
        if (this._map._fadeAnimated) {
            $b316889e4737b9d0$export$2646c6b151d2e8(tile.el, 0);
            $78a895d83da22602$export$e1ed83507f55dc9d(this._fadeFrame);
            this._fadeFrame = $78a895d83da22602$export$d371ad015c199c06(this._updateOpacity, this);
        } else {
            tile.active = true;
            this._pruneTiles();
        }
        if (!err) {
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(tile.el, "leaflet-tile-loaded");
            // @event tileload: TileEvent
            // Fired when a tile loads.
            this.fire("tileload", {
                tile: tile.el,
                coords: coords
            });
        }
        if (this._noTilesToLoad()) {
            this._loading = false;
            // @event load: Event
            // Fired when the grid layer loaded all visible tiles.
            this.fire("load");
            if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).ielt9 || !this._map._fadeAnimated) $78a895d83da22602$export$d371ad015c199c06(this._pruneTiles, this);
            else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
            // to trigger a pruning.
            setTimeout($78a895d83da22602$export$2385a24977818dd0(this._pruneTiles, this), 250);
        }
    },
    _getTilePos: function(coords) {
        return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
    },
    _wrapCoords: function(coords) {
        var newCoords = new (0, $0552a615fcf79927$export$baf26146a414f24a)(this._wrapX ? $78a895d83da22602$export$f6cd9682189b118b(coords.x, this._wrapX) : coords.x, this._wrapY ? $78a895d83da22602$export$f6cd9682189b118b(coords.y, this._wrapY) : coords.y);
        newCoords.z = coords.z;
        return newCoords;
    },
    _pxBoundsToTileRange: function(bounds) {
        var tileSize = this.getTileSize();
        return new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
            1,
            1
        ]));
    },
    _noTilesToLoad: function() {
        for(var key in this._tiles){
            if (!this._tiles[key].loaded) return false;
        }
        return true;
    }
});
function $1d438cf1f584f090$export$4d73234a74ff0ca3(options) {
    return new $1d438cf1f584f090$export$3b2364b911db251c(options);
}







var $edbbe2536ba3f7be$export$f52ee31d61d0b27b = (0, $1d438cf1f584f090$export$3b2364b911db251c).extend({
    // @section
    // @aka TileLayer options
    options: {
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = 18
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: 18,
        // @option subdomains: String|String[] = 'abc'
        // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
        subdomains: "abc",
        // @option errorTileUrl: String = ''
        // URL to the tile image to show in place of the tile that failed to load.
        errorTileUrl: "",
        // @option zoomOffset: Number = 0
        // The zoom number used in tile URLs will be offset with this value.
        zoomOffset: 0,
        // @option tms: Boolean = false
        // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
        tms: false,
        // @option zoomReverse: Boolean = false
        // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
        zoomReverse: false,
        // @option detectRetina: Boolean = false
        // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
        detectRetina: false,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: false,
        // @option referrerPolicy: Boolean|String = false
        // Whether the referrerPolicy attribute will be added to the tiles.
        // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
        // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
        // (e.g. to validate an API token).
        // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
        referrerPolicy: false
    },
    initialize: function(url, options) {
        this._url = url;
        options = $78a895d83da22602$export$add91eafeaeab287(this, options);
        // detecting retina displays, adjusting tileSize and zoom levels
        if (options.detectRetina && (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).retina && options.maxZoom > 0) {
            options.tileSize = Math.floor(options.tileSize / 2);
            if (!options.zoomReverse) {
                options.zoomOffset++;
                options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
            } else {
                options.zoomOffset--;
                options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
            }
            options.minZoom = Math.max(0, options.minZoom);
        } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
        options.maxZoom = Math.max(options.minZoom, options.maxZoom);
        else // make sure minZoom is lte maxZoom
        options.minZoom = Math.min(options.maxZoom, options.minZoom);
        if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
        this.on("tileunload", this._onTileRemove);
    },
    // @method setUrl(url: String, noRedraw?: Boolean): this
    // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
    // If the URL does not change, the layer will not be redrawn unless
    // the noRedraw parameter is set to false.
    setUrl: function(url, noRedraw) {
        if (this._url === url && noRedraw === undefined) noRedraw = true;
        this._url = url;
        if (!noRedraw) this.redraw();
        return this;
    },
    // @method createTile(coords: Object, done?: Function): HTMLElement
    // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
    // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
    // callback is called when the tile has been loaded.
    createTile: function(coords, done) {
        var tile = document.createElement("img");
        $7c9dd72411ef2269$export$af631764ddc44097(tile, "load", $78a895d83da22602$export$2385a24977818dd0(this._tileOnLoad, this, done, tile));
        $7c9dd72411ef2269$export$af631764ddc44097(tile, "error", $78a895d83da22602$export$2385a24977818dd0(this._tileOnError, this, done, tile));
        if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
        // for this new option we follow the documented behavior
        // more closely by only setting the property when string
        if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
        // The alt attribute is set to the empty string,
        // allowing screen readers to ignore the decorative image tiles.
        // https://www.w3.org/WAI/tutorials/images/decorative/
        // https://www.w3.org/TR/html-aria/#el-img-empty-alt
        tile.alt = "";
        tile.src = this.getTileUrl(coords);
        return tile;
    },
    // @section Extension methods
    // @uninheritable
    // Layers extending `TileLayer` might reimplement the following method.
    // @method getTileUrl(coords: Object): String
    // Called only internally, returns the URL for a tile given its coordinates.
    // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
    getTileUrl: function(coords) {
        var data = {
            r: (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).retina ? "@2x" : "",
            s: this._getSubdomain(coords),
            x: coords.x,
            y: coords.y,
            z: this._getZoomForUrl()
        };
        if (this._map && !this._map.options.crs.infinite) {
            var invertedY = this._globalTileRange.max.y - coords.y;
            if (this.options.tms) data["y"] = invertedY;
            data["-y"] = invertedY;
        }
        return $78a895d83da22602$export$ce69bd05624d0c48(this._url, $78a895d83da22602$export$8b58be045bf06082(data, this.options));
    },
    _tileOnLoad: function(done, tile) {
        // For https://github.com/Leaflet/Leaflet/issues/3332
        if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).ielt9) setTimeout($78a895d83da22602$export$2385a24977818dd0(done, this, null, tile), 0);
        else done(null, tile);
    },
    _tileOnError: function(done, tile, e) {
        var errorUrl = this.options.errorTileUrl;
        if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
        done(e, tile);
    },
    _onTileRemove: function(e) {
        e.tile.onload = null;
    },
    _getZoomForUrl: function() {
        var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
        if (zoomReverse) zoom = maxZoom - zoom;
        return zoom + zoomOffset;
    },
    _getSubdomain: function(tilePoint) {
        var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
        return this.options.subdomains[index];
    },
    // stops loading all tiles in the background layer
    _abortLoading: function() {
        var i, tile;
        for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
            tile = this._tiles[i].el;
            tile.onload = $78a895d83da22602$export$a3891e81a74c5e40;
            tile.onerror = $78a895d83da22602$export$a3891e81a74c5e40;
            if (!tile.complete) {
                tile.src = $78a895d83da22602$export$993f7e5c731d5268;
                var coords = this._tiles[i].coords;
                $b316889e4737b9d0$export$cd7f480d6b8286c3(tile);
                delete this._tiles[i];
                // @event tileabort: TileEvent
                // Fired when a tile was loading but is now not wanted.
                this.fire("tileabort", {
                    tile: tile,
                    coords: coords
                });
            }
        }
    },
    _removeTile: function(key) {
        var tile = this._tiles[key];
        if (!tile) return;
        // Cancels any pending http requests associated with the tile
        tile.el.setAttribute("src", $78a895d83da22602$export$993f7e5c731d5268);
        return (0, $1d438cf1f584f090$export$3b2364b911db251c).prototype._removeTile.call(this, key);
    },
    _tileReady: function(coords, err, tile) {
        if (!this._map || tile && tile.getAttribute("src") === $78a895d83da22602$export$993f7e5c731d5268) return;
        return (0, $1d438cf1f584f090$export$3b2364b911db251c).prototype._tileReady.call(this, coords, err, tile);
    }
});
function $edbbe2536ba3f7be$export$be2e48cfdc7506da(url, options) {
    return new $edbbe2536ba3f7be$export$f52ee31d61d0b27b(url, options);
}







var $d918092ba7507de1$export$c504b28c0d56fb0a = (0, $edbbe2536ba3f7be$export$f52ee31d61d0b27b).extend({
    // @section
    // @aka TileLayer.WMS options
    // If any custom options not documented here are used, they will be sent to the
    // WMS server as extra parameters in each request URL. This can be useful for
    // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
    defaultWmsParams: {
        service: "WMS",
        request: "GetMap",
        // @option layers: String = ''
        // **(required)** Comma-separated list of WMS layers to show.
        layers: "",
        // @option styles: String = ''
        // Comma-separated list of WMS styles.
        styles: "",
        // @option format: String = 'image/jpeg'
        // WMS image format (use `'image/png'` for layers with transparency).
        format: "image/jpeg",
        // @option transparent: Boolean = false
        // If `true`, the WMS service will return images with transparency.
        transparent: false,
        // @option version: String = '1.1.1'
        // Version of the WMS service to use
        version: "1.1.1"
    },
    options: {
        // @option crs: CRS = null
        // Coordinate Reference System to use for the WMS requests, defaults to
        // map CRS. Don't change this if you're not sure what it means.
        crs: null,
        // @option uppercase: Boolean = false
        // If `true`, WMS request parameter keys will be uppercase.
        uppercase: false
    },
    initialize: function(url, options) {
        this._url = url;
        var wmsParams = (0, $78a895d83da22602$export$8b58be045bf06082)({}, this.defaultWmsParams);
        // all keys that are not TileLayer options go to WMS params
        for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
        options = (0, $78a895d83da22602$export$add91eafeaeab287)(this, options);
        var realRetina = options.detectRetina && (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).retina ? 2 : 1;
        var tileSize = this.getTileSize();
        wmsParams.width = tileSize.x * realRetina;
        wmsParams.height = tileSize.y * realRetina;
        this.wmsParams = wmsParams;
    },
    onAdd: function(map) {
        this._crs = this.options.crs || map.options.crs;
        this._wmsVersion = parseFloat(this.wmsParams.version);
        var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
        this.wmsParams[projectionKey] = this._crs.code;
        (0, $edbbe2536ba3f7be$export$f52ee31d61d0b27b).prototype.onAdd.call(this, map);
    },
    getTileUrl: function(coords) {
        var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === (0, $94a9ac6cbd26b23f$export$6e6fafcc50e60294) ? [
            min.y,
            min.x,
            max.y,
            max.x
        ] : [
            min.x,
            min.y,
            max.x,
            max.y
        ]).join(","), url = (0, $edbbe2536ba3f7be$export$f52ee31d61d0b27b).prototype.getTileUrl.call(this, coords);
        return url + (0, $78a895d83da22602$export$27213b73b2075e98)(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
    },
    // @method setParams(params: Object, noRedraw?: Boolean): this
    // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
    setParams: function(params, noRedraw) {
        (0, $78a895d83da22602$export$8b58be045bf06082)(this.wmsParams, params);
        if (!noRedraw) this.redraw();
        return this;
    }
});
function $d918092ba7507de1$export$4d01959a250b9387(url, options) {
    return new $d918092ba7507de1$export$c504b28c0d56fb0a(url, options);
}


(0, $edbbe2536ba3f7be$export$f52ee31d61d0b27b).WMS = (0, $d918092ba7507de1$export$c504b28c0d56fb0a);
(0, $edbbe2536ba3f7be$export$be2e48cfdc7506da).wms = (0, $d918092ba7507de1$export$4d01959a250b9387);







var $6c2efda35177e5b1$export$88530751e3977073 = (0, $17ba674e92a8ad9d$export$936d0764594b6eb3).extend({
    // @section
    // @aka Renderer options
    options: {
        // @option padding: Number = 0.1
        // How much to extend the clip area around the map view (relative to its size)
        // e.g. 0.1 would be 10% of map view in each direction
        padding: 0.1
    },
    initialize: function(options) {
        $78a895d83da22602$export$add91eafeaeab287(this, options);
        $78a895d83da22602$export$bd3fba034e28f6b(this);
        this._layers = this._layers || {};
    },
    onAdd: function() {
        if (!this._container) {
            this._initContainer(); // defined by renderer implementations
            // always keep transform-origin as 0 0
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._container, "leaflet-zoom-animated");
        }
        this.getPane().appendChild(this._container);
        this._update();
        this.on("update", this._updatePaths, this);
    },
    onRemove: function() {
        this.off("update", this._updatePaths, this);
        this._destroyContainer();
    },
    getEvents: function() {
        var events = {
            viewreset: this._reset,
            zoom: this._onZoom,
            moveend: this._update,
            zoomend: this._onZoomEnd
        };
        if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
        return events;
    },
    _onAnimZoom: function(ev) {
        this._updateTransform(ev.center, ev.zoom);
    },
    _onZoom: function() {
        this._updateTransform(this._map.getCenter(), this._map.getZoom());
    },
    _updateTransform: function(center, zoom) {
        var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
        if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).any3d) $b316889e4737b9d0$export$ff09356c35bee89b(this._container, topLeftOffset, scale);
        else $b316889e4737b9d0$export$f9b088a47202d605(this._container, topLeftOffset);
    },
    _reset: function() {
        this._update();
        this._updateTransform(this._center, this._zoom);
        for(var id in this._layers)this._layers[id]._reset();
    },
    _onZoomEnd: function() {
        for(var id in this._layers)this._layers[id]._project();
    },
    _updatePaths: function() {
        for(var id in this._layers)this._layers[id]._update();
    },
    _update: function() {
        // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
        // Subclasses are responsible of firing the 'update' event.
        var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
        this._bounds = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(min, min.add(size.multiplyBy(1 + p * 2)).round());
        this._center = this._map.getCenter();
        this._zoom = this._map.getZoom();
    }
});








var $4ac169443d26efb3$export$8d01c972ee8b14a9 = (0, $6c2efda35177e5b1$export$88530751e3977073).extend({
    // @section
    // @aka Canvas options
    options: {
        // @option tolerance: Number = 0
        // How much to extend the click tolerance around a path/object on the map.
        tolerance: 0
    },
    getEvents: function() {
        var events = (0, $6c2efda35177e5b1$export$88530751e3977073).prototype.getEvents.call(this);
        events.viewprereset = this._onViewPreReset;
        return events;
    },
    _onViewPreReset: function() {
        // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
        this._postponeUpdatePaths = true;
    },
    onAdd: function() {
        (0, $6c2efda35177e5b1$export$88530751e3977073).prototype.onAdd.call(this);
        // Redraw vectors since canvas is cleared upon removal,
        // in case of removing the renderer itself from the map.
        this._draw();
    },
    _initContainer: function() {
        var container = this._container = document.createElement("canvas");
        $7c9dd72411ef2269$export$af631764ddc44097(container, "mousemove", this._onMouseMove, this);
        $7c9dd72411ef2269$export$af631764ddc44097(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
        $7c9dd72411ef2269$export$af631764ddc44097(container, "mouseout", this._handleMouseOut, this);
        container["_leaflet_disable_events"] = true;
        this._ctx = container.getContext("2d");
    },
    _destroyContainer: function() {
        $78a895d83da22602$export$e1ed83507f55dc9d(this._redrawRequest);
        delete this._ctx;
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._container);
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(this._container);
        delete this._container;
    },
    _updatePaths: function() {
        if (this._postponeUpdatePaths) return;
        var layer;
        this._redrawBounds = null;
        for(var id in this._layers){
            layer = this._layers[id];
            layer._update();
        }
        this._redraw();
    },
    _update: function() {
        if (this._map._animatingZoom && this._bounds) return;
        (0, $6c2efda35177e5b1$export$88530751e3977073).prototype._update.call(this);
        var b = this._bounds, container = this._container, size = b.getSize(), m = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).retina ? 2 : 1;
        $b316889e4737b9d0$export$f9b088a47202d605(container, b.min);
        // set canvas size (also clearing it); use double size on retina
        container.width = m * size.x;
        container.height = m * size.y;
        container.style.width = size.x + "px";
        container.style.height = size.y + "px";
        if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).retina) this._ctx.scale(2, 2);
        // translate so we use the same path coordinates after canvas element moves
        this._ctx.translate(-b.min.x, -b.min.y);
        // Tell paths to redraw themselves
        this.fire("update");
    },
    _reset: function() {
        (0, $6c2efda35177e5b1$export$88530751e3977073).prototype._reset.call(this);
        if (this._postponeUpdatePaths) {
            this._postponeUpdatePaths = false;
            this._updatePaths();
        }
    },
    _initPath: function(layer) {
        this._updateDashArray(layer);
        this._layers[$78a895d83da22602$export$bd3fba034e28f6b(layer)] = layer;
        var order = layer._order = {
            layer: layer,
            prev: this._drawLast,
            next: null
        };
        if (this._drawLast) this._drawLast.next = order;
        this._drawLast = order;
        this._drawFirst = this._drawFirst || this._drawLast;
    },
    _addPath: function(layer) {
        this._requestRedraw(layer);
    },
    _removePath: function(layer) {
        var order = layer._order;
        var next = order.next;
        var prev = order.prev;
        if (next) next.prev = prev;
        else this._drawLast = prev;
        if (prev) prev.next = next;
        else this._drawFirst = next;
        delete layer._order;
        delete this._layers[$78a895d83da22602$export$bd3fba034e28f6b(layer)];
        this._requestRedraw(layer);
    },
    _updatePath: function(layer) {
        // Redraw the union of the layer's old pixel
        // bounds and the new pixel bounds.
        this._extendRedrawBounds(layer);
        layer._project();
        layer._update();
        // The redraw will extend the redraw bounds
        // with the new pixel bounds.
        this._requestRedraw(layer);
    },
    _updateStyle: function(layer) {
        this._updateDashArray(layer);
        this._requestRedraw(layer);
    },
    _updateDashArray: function(layer) {
        if (typeof layer.options.dashArray === "string") {
            var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
            for(i = 0; i < parts.length; i++){
                dashValue = Number(parts[i]);
                // Ignore dash array containing invalid lengths
                if (isNaN(dashValue)) return;
                dashArray.push(dashValue);
            }
            layer.options._dashArray = dashArray;
        } else layer.options._dashArray = layer.options.dashArray;
    },
    _requestRedraw: function(layer) {
        if (!this._map) return;
        this._extendRedrawBounds(layer);
        this._redrawRequest = this._redrawRequest || $78a895d83da22602$export$d371ad015c199c06(this._redraw, this);
    },
    _extendRedrawBounds: function(layer) {
        if (layer._pxBounds) {
            var padding = (layer.options.weight || 0) + 1;
            this._redrawBounds = this._redrawBounds || new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)();
            this._redrawBounds.extend(layer._pxBounds.min.subtract([
                padding,
                padding
            ]));
            this._redrawBounds.extend(layer._pxBounds.max.add([
                padding,
                padding
            ]));
        }
    },
    _redraw: function() {
        this._redrawRequest = null;
        if (this._redrawBounds) {
            this._redrawBounds.min._floor();
            this._redrawBounds.max._ceil();
        }
        this._clear(); // clear layers in redraw bounds
        this._draw(); // draw layers
        this._redrawBounds = null;
    },
    _clear: function() {
        var bounds = this._redrawBounds;
        if (bounds) {
            var size = bounds.getSize();
            this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
        } else {
            this._ctx.save();
            this._ctx.setTransform(1, 0, 0, 1, 0, 0);
            this._ctx.clearRect(0, 0, this._container.width, this._container.height);
            this._ctx.restore();
        }
    },
    _draw: function() {
        var layer, bounds = this._redrawBounds;
        this._ctx.save();
        if (bounds) {
            var size = bounds.getSize();
            this._ctx.beginPath();
            this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
            this._ctx.clip();
        }
        this._drawing = true;
        for(var order = this._drawFirst; order; order = order.next){
            layer = order.layer;
            if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
        }
        this._drawing = false;
        this._ctx.restore(); // Restore state before clipping.
    },
    _updatePoly: function(layer, closed) {
        if (!this._drawing) return;
        var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
        if (!len) return;
        ctx.beginPath();
        for(i = 0; i < len; i++){
            for(j = 0, len2 = parts[i].length; j < len2; j++){
                p = parts[i][j];
                ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
            }
            if (closed) ctx.closePath();
        }
        this._fillStroke(ctx, layer);
    // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
    },
    _updateCircle: function(layer) {
        if (!this._drawing || layer._empty()) return;
        var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
        if (s !== 1) {
            ctx.save();
            ctx.scale(1, s);
        }
        ctx.beginPath();
        ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
        if (s !== 1) ctx.restore();
        this._fillStroke(ctx, layer);
    },
    _fillStroke: function(ctx, layer) {
        var options = layer.options;
        if (options.fill) {
            ctx.globalAlpha = options.fillOpacity;
            ctx.fillStyle = options.fillColor || options.color;
            ctx.fill(options.fillRule || "evenodd");
        }
        if (options.stroke && options.weight !== 0) {
            if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
            ctx.globalAlpha = options.opacity;
            ctx.lineWidth = options.weight;
            ctx.strokeStyle = options.color;
            ctx.lineCap = options.lineCap;
            ctx.lineJoin = options.lineJoin;
            ctx.stroke();
        }
    },
    // Canvas obviously doesn't have mouse events for individual drawn objects,
    // so we emulate that by calculating what's under the mouse on mousemove/click manually
    _onClick: function(e) {
        var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
        for(var order = this._drawFirst; order; order = order.next){
            layer = order.layer;
            if (layer.options.interactive && layer._containsPoint(point)) {
                if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
            }
        }
        this._fireEvent(clickedLayer ? [
            clickedLayer
        ] : false, e);
    },
    _onMouseMove: function(e) {
        if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
        var point = this._map.mouseEventToLayerPoint(e);
        this._handleMouseHover(e, point);
    },
    _handleMouseOut: function(e) {
        var layer = this._hoveredLayer;
        if (layer) {
            // if we're leaving the layer, fire mouseout
            $b316889e4737b9d0$export$c2255604a80b4506(this._container, "leaflet-interactive");
            this._fireEvent([
                layer
            ], e, "mouseout");
            this._hoveredLayer = null;
            this._mouseHoverThrottled = false;
        }
    },
    _handleMouseHover: function(e, point) {
        if (this._mouseHoverThrottled) return;
        var layer, candidateHoveredLayer;
        for(var order = this._drawFirst; order; order = order.next){
            layer = order.layer;
            if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
        }
        if (candidateHoveredLayer !== this._hoveredLayer) {
            this._handleMouseOut(e);
            if (candidateHoveredLayer) {
                $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._container, "leaflet-interactive"); // change cursor
                this._fireEvent([
                    candidateHoveredLayer
                ], e, "mouseover");
                this._hoveredLayer = candidateHoveredLayer;
            }
        }
        this._fireEvent(this._hoveredLayer ? [
            this._hoveredLayer
        ] : false, e);
        this._mouseHoverThrottled = true;
        setTimeout($78a895d83da22602$export$2385a24977818dd0(function() {
            this._mouseHoverThrottled = false;
        }, this), 32);
    },
    _fireEvent: function(layers, e, type) {
        this._map._fireDOMEvent(e, type || e.type, layers);
    },
    _bringToFront: function(layer) {
        var order = layer._order;
        if (!order) return;
        var next = order.next;
        var prev = order.prev;
        if (next) next.prev = prev;
        else // Already last
        return;
        if (prev) prev.next = next;
        else if (next) // Update first entry unless this is the
        // single entry
        this._drawFirst = next;
        order.prev = this._drawLast;
        this._drawLast.next = order;
        order.next = null;
        this._drawLast = order;
        this._requestRedraw(layer);
    },
    _bringToBack: function(layer) {
        var order = layer._order;
        if (!order) return;
        var next = order.next;
        var prev = order.prev;
        if (prev) prev.next = next;
        else // Already first
        return;
        if (next) next.prev = prev;
        else if (prev) // Update last entry unless this is the
        // single entry
        this._drawLast = prev;
        order.prev = null;
        order.next = this._drawFirst;
        this._drawFirst.prev = order;
        this._drawFirst = order;
        this._requestRedraw(layer);
    }
});
function $4ac169443d26efb3$export$67ea982130081db(options) {
    return (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).canvas ? new $4ac169443d26efb3$export$8d01c972ee8b14a9(options) : null;
}











var $20b58e8f81675091$export$8077df4875198090 = function() {
    try {
        document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
        return function(name) {
            return document.createElement("<lvml:" + name + ' class="lvml">');
        };
    } catch (e) {
    // Do not return fn from catch block so `e` can be garbage collected
    // See https://github.com/Leaflet/Leaflet/pull/7279
    }
    return function(name) {
        return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
    };
}();
var $20b58e8f81675091$export$7bb6ae0c8f2e3b88 = {
    _initContainer: function() {
        this._container = $b316889e4737b9d0$export$185802fd694ee1f5("div", "leaflet-vml-container");
    },
    _update: function() {
        if (this._map._animatingZoom) return;
        (0, $6c2efda35177e5b1$export$88530751e3977073).prototype._update.call(this);
        this.fire("update");
    },
    _initPath: function(layer) {
        var container = layer._container = $20b58e8f81675091$export$8077df4875198090("shape");
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(container, "leaflet-vml-shape " + (this.options.className || ""));
        container.coordsize = "1 1";
        layer._path = $20b58e8f81675091$export$8077df4875198090("path");
        container.appendChild(layer._path);
        this._updateStyle(layer);
        this._layers[$78a895d83da22602$export$bd3fba034e28f6b(layer)] = layer;
    },
    _addPath: function(layer) {
        var container = layer._container;
        this._container.appendChild(container);
        if (layer.options.interactive) layer.addInteractiveTarget(container);
    },
    _removePath: function(layer) {
        var container = layer._container;
        $b316889e4737b9d0$export$cd7f480d6b8286c3(container);
        layer.removeInteractiveTarget(container);
        delete this._layers[$78a895d83da22602$export$bd3fba034e28f6b(layer)];
    },
    _updateStyle: function(layer) {
        var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
        container.stroked = !!options.stroke;
        container.filled = !!options.fill;
        if (options.stroke) {
            if (!stroke) stroke = layer._stroke = $20b58e8f81675091$export$8077df4875198090("stroke");
            container.appendChild(stroke);
            stroke.weight = options.weight + "px";
            stroke.color = options.color;
            stroke.opacity = options.opacity;
            if (options.dashArray) stroke.dashStyle = $78a895d83da22602$export$43bee75e5e14138e(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
            else stroke.dashStyle = "";
            stroke.endcap = options.lineCap.replace("butt", "flat");
            stroke.joinstyle = options.lineJoin;
        } else if (stroke) {
            container.removeChild(stroke);
            layer._stroke = null;
        }
        if (options.fill) {
            if (!fill) fill = layer._fill = $20b58e8f81675091$export$8077df4875198090("fill");
            container.appendChild(fill);
            fill.color = options.fillColor || options.color;
            fill.opacity = options.fillOpacity;
        } else if (fill) {
            container.removeChild(fill);
            layer._fill = null;
        }
    },
    _updateCircle: function(layer) {
        var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
        this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
    },
    _setPath: function(layer, path) {
        layer._path.v = path;
    },
    _bringToFront: function(layer) {
        $b316889e4737b9d0$export$967ea9e64a77dad2(layer._container);
    },
    _bringToBack: function(layer) {
        $b316889e4737b9d0$export$4d34781508fd70d9(layer._container);
    }
};


var $fff58c71be695211$export$185802fd694ee1f5 = (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).vml ? (0, $20b58e8f81675091$export$8077df4875198090) : (0, $67005fefedcce2f7$export$9d9648f1590c5e1);
var $fff58c71be695211$export$13f4b12aafeba5d6 = (0, $6c2efda35177e5b1$export$88530751e3977073).extend({
    _initContainer: function() {
        this._container = $fff58c71be695211$export$185802fd694ee1f5("svg");
        // makes it possible to click through svg root; we'll reset it back in individual paths
        this._container.setAttribute("pointer-events", "none");
        this._rootGroup = $fff58c71be695211$export$185802fd694ee1f5("g");
        this._container.appendChild(this._rootGroup);
    },
    _destroyContainer: function() {
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._container);
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(this._container);
        delete this._container;
        delete this._rootGroup;
        delete this._svgSize;
    },
    _update: function() {
        if (this._map._animatingZoom && this._bounds) return;
        (0, $6c2efda35177e5b1$export$88530751e3977073).prototype._update.call(this);
        var b = this._bounds, size = b.getSize(), container = this._container;
        // set size of svg-container if changed
        if (!this._svgSize || !this._svgSize.equals(size)) {
            this._svgSize = size;
            container.setAttribute("width", size.x);
            container.setAttribute("height", size.y);
        }
        // movement: update container viewBox so that we don't have to change coordinates of individual layers
        $b316889e4737b9d0$export$f9b088a47202d605(container, b.min);
        container.setAttribute("viewBox", [
            b.min.x,
            b.min.y,
            size.x,
            size.y
        ].join(" "));
        this.fire("update");
    },
    // methods below are called by vector layers implementations
    _initPath: function(layer) {
        var path = layer._path = $fff58c71be695211$export$185802fd694ee1f5("path");
        // @namespace Path
        // @option className: String = null
        // Custom class name set on an element. Only for SVG renderer.
        if (layer.options.className) $b316889e4737b9d0$export$d2cf6cd1dc7067d3(path, layer.options.className);
        if (layer.options.interactive) $b316889e4737b9d0$export$d2cf6cd1dc7067d3(path, "leaflet-interactive");
        this._updateStyle(layer);
        this._layers[(0, $78a895d83da22602$export$bd3fba034e28f6b)(layer)] = layer;
    },
    _addPath: function(layer) {
        if (!this._rootGroup) this._initContainer();
        this._rootGroup.appendChild(layer._path);
        layer.addInteractiveTarget(layer._path);
    },
    _removePath: function(layer) {
        $b316889e4737b9d0$export$cd7f480d6b8286c3(layer._path);
        layer.removeInteractiveTarget(layer._path);
        delete this._layers[(0, $78a895d83da22602$export$bd3fba034e28f6b)(layer)];
    },
    _updatePath: function(layer) {
        layer._project();
        layer._update();
    },
    _updateStyle: function(layer) {
        var path = layer._path, options = layer.options;
        if (!path) return;
        if (options.stroke) {
            path.setAttribute("stroke", options.color);
            path.setAttribute("stroke-opacity", options.opacity);
            path.setAttribute("stroke-width", options.weight);
            path.setAttribute("stroke-linecap", options.lineCap);
            path.setAttribute("stroke-linejoin", options.lineJoin);
            if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
            else path.removeAttribute("stroke-dasharray");
            if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
            else path.removeAttribute("stroke-dashoffset");
        } else path.setAttribute("stroke", "none");
        if (options.fill) {
            path.setAttribute("fill", options.fillColor || options.color);
            path.setAttribute("fill-opacity", options.fillOpacity);
            path.setAttribute("fill-rule", options.fillRule || "evenodd");
        } else path.setAttribute("fill", "none");
    },
    _updatePoly: function(layer, closed) {
        this._setPath(layer, (0, $67005fefedcce2f7$export$bc863495a5f10ca1)(layer._parts, closed));
    },
    _updateCircle: function(layer) {
        var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
        // drawing a circle with two half-arcs
        var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
        this._setPath(layer, d);
    },
    _setPath: function(layer, path) {
        layer._path.setAttribute("d", path);
    },
    // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
    _bringToFront: function(layer) {
        $b316889e4737b9d0$export$967ea9e64a77dad2(layer._path);
    },
    _bringToBack: function(layer) {
        $b316889e4737b9d0$export$4d34781508fd70d9(layer._path);
    }
});
if ((0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).vml) $fff58c71be695211$export$13f4b12aafeba5d6.include((0, $20b58e8f81675091$export$7bb6ae0c8f2e3b88));
function $fff58c71be695211$export$7ed1367e7fa1ad68(options) {
    return (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).svg || (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).vml ? new $fff58c71be695211$export$13f4b12aafeba5d6(options) : null;
}





(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).include({
    // @namespace Map; @method getRenderer(layer: Path): Renderer
    // Returns the instance of `Renderer` that should be used to render the given
    // `Path`. It will ensure that the `renderer` options of the map and paths
    // are respected, and that the renderers do exist on the map.
    getRenderer: function(layer) {
        // @namespace Path; @option renderer: Renderer
        // Use this specific instance of `Renderer` for this path. Takes
        // precedence over the map's [default renderer](#map-renderer).
        var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
        if (!renderer) renderer = this._renderer = this._createRenderer();
        if (!this.hasLayer(renderer)) this.addLayer(renderer);
        return renderer;
    },
    _getPaneRenderer: function(name) {
        if (name === "overlayPane" || name === undefined) return false;
        var renderer = this._paneRenderers[name];
        if (renderer === undefined) {
            renderer = this._createRenderer({
                pane: name
            });
            this._paneRenderers[name] = renderer;
        }
        return renderer;
    },
    _createRenderer: function(options) {
        // @namespace Map; @option preferCanvas: Boolean = false
        // Whether `Path`s should be rendered on a `Canvas` renderer.
        // By default, all `Path`s are rendered in a `SVG` renderer.
        return this.options.preferCanvas && (0, $4ac169443d26efb3$export$67ea982130081db)(options) || (0, $fff58c71be695211$export$7ed1367e7fa1ad68)(options);
    }
});









var $c008be3f7dfe3610$export$4617fb02663045ef = (0, $5c1ba64c6ac1b9ee$export$7d31b617c820d435).extend({
    initialize: function(latLngBounds, options) {
        (0, $5c1ba64c6ac1b9ee$export$7d31b617c820d435).prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
    },
    // @method setBounds(latLngBounds: LatLngBounds): this
    // Redraws the rectangle with the passed bounds.
    setBounds: function(latLngBounds) {
        return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
    },
    _boundsToLatLngs: function(latLngBounds) {
        latLngBounds = (0, $1b787e0b76fef54a$export$4904432a68b0399)(latLngBounds);
        return [
            latLngBounds.getSouthWest(),
            latLngBounds.getNorthWest(),
            latLngBounds.getNorthEast(),
            latLngBounds.getSouthEast()
        ];
    }
});
function $c008be3f7dfe3610$export$405b065079b7caf2(latLngBounds, options) {
    return new $c008be3f7dfe3610$export$4617fb02663045ef(latLngBounds, options);
}


(0, $fff58c71be695211$export$13f4b12aafeba5d6).create = (0, $fff58c71be695211$export$185802fd694ee1f5);
(0, $fff58c71be695211$export$13f4b12aafeba5d6).pointsToPath = (0, $67005fefedcce2f7$export$bc863495a5f10ca1);


(0, $60d132431ff550d0$export$3a16e672cb3a069e).geometryToLayer = (0, $60d132431ff550d0$export$1d62dde364ca646a);
(0, $60d132431ff550d0$export$3a16e672cb3a069e).coordsToLatLng = (0, $60d132431ff550d0$export$68c7da933fd21adc);
(0, $60d132431ff550d0$export$3a16e672cb3a069e).coordsToLatLngs = (0, $60d132431ff550d0$export$95b72bfd8b68a8bf);
(0, $60d132431ff550d0$export$3a16e672cb3a069e).latLngToCoords = (0, $60d132431ff550d0$export$4a4f4d0b257f82d2);
(0, $60d132431ff550d0$export$3a16e672cb3a069e).latLngsToCoords = (0, $60d132431ff550d0$export$77b6e764d6612623);
(0, $60d132431ff550d0$export$3a16e672cb3a069e).getFeature = (0, $60d132431ff550d0$export$bba2e7bbd72e62e1);
(0, $60d132431ff550d0$export$3a16e672cb3a069e).asFeature = (0, $60d132431ff550d0$export$9b5abe57af2a50eb);










/*
 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
 * (zoom to a selected bounding box), enabled by default.
 */ // @namespace Map
// @section Interaction Options
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    // @option boxZoom: Boolean = true
    // Whether the map can be zoomed to a rectangular area specified by
    // dragging the mouse while pressing the shift key.
    boxZoom: true
});
var $95d63c75e1bd265d$export$2151b62cd620e937 = (0, $8edcec5990ab2544$export$a428cd33b25d5283).extend({
    initialize: function(map) {
        this._map = map;
        this._container = map._container;
        this._pane = map._panes.overlayPane;
        this._resetStateTimeout = 0;
        map.on("unload", this._destroy, this);
    },
    addHooks: function() {
        $7c9dd72411ef2269$export$af631764ddc44097(this._container, "mousedown", this._onMouseDown, this);
    },
    removeHooks: function() {
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(this._container, "mousedown", this._onMouseDown, this);
    },
    moved: function() {
        return this._moved;
    },
    _destroy: function() {
        $b316889e4737b9d0$export$cd7f480d6b8286c3(this._pane);
        delete this._pane;
    },
    _resetState: function() {
        this._resetStateTimeout = 0;
        this._moved = false;
    },
    _clearDeferredResetState: function() {
        if (this._resetStateTimeout !== 0) {
            clearTimeout(this._resetStateTimeout);
            this._resetStateTimeout = 0;
        }
    },
    _onMouseDown: function(e) {
        if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
        // Clear the deferred resetState if it hasn't executed yet, otherwise it
        // will interrupt the interaction and orphan a box element in the container.
        this._clearDeferredResetState();
        this._resetState();
        $b316889e4737b9d0$export$16a4697467175487();
        $b316889e4737b9d0$export$188eb2a17526281();
        this._startPoint = this._map.mouseEventToContainerPoint(e);
        $7c9dd72411ef2269$export$af631764ddc44097(document, {
            contextmenu: $7c9dd72411ef2269$export$fa6813432f753b0d,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
        }, this);
    },
    _onMouseMove: function(e) {
        if (!this._moved) {
            this._moved = true;
            this._box = $b316889e4737b9d0$export$185802fd694ee1f5("div", "leaflet-zoom-box", this._container);
            $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._container, "leaflet-crosshair");
            this._map.fire("boxzoomstart");
        }
        this._point = this._map.mouseEventToContainerPoint(e);
        var bounds = new (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)(this._point, this._startPoint), size = bounds.getSize();
        $b316889e4737b9d0$export$f9b088a47202d605(this._box, bounds.min);
        this._box.style.width = size.x + "px";
        this._box.style.height = size.y + "px";
    },
    _finish: function() {
        if (this._moved) {
            $b316889e4737b9d0$export$cd7f480d6b8286c3(this._box);
            $b316889e4737b9d0$export$c2255604a80b4506(this._container, "leaflet-crosshair");
        }
        $b316889e4737b9d0$export$b1bf1c69425cc693();
        $b316889e4737b9d0$export$f5ef98e1c9198e63();
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(document, {
            contextmenu: $7c9dd72411ef2269$export$fa6813432f753b0d,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
        }, this);
    },
    _onMouseUp: function(e) {
        if (e.which !== 1 && e.button !== 1) return;
        this._finish();
        if (!this._moved) return;
        // Postpone to next JS tick so internal click event handling
        // still see it as "moved".
        this._clearDeferredResetState();
        this._resetStateTimeout = setTimeout($78a895d83da22602$export$2385a24977818dd0(this._resetState, this), 0);
        var bounds = new (0, $1b787e0b76fef54a$export$fe84d4076a55a8e6)(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
        this._map.fitBounds(bounds).fire("boxzoomend", {
            boxZoomBounds: bounds
        });
    },
    _onKeyDown: function(e) {
        if (e.keyCode === 27) {
            this._finish();
            this._clearDeferredResetState();
            this._resetState();
        }
    }
});
// @section Handlers
// @property boxZoom: Handler
// Box (shift-drag with mouse) zoom handler.
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).addInitHook("addHandler", "boxZoom", $95d63c75e1bd265d$export$2151b62cd620e937);




/*
 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
 */ // @namespace Map
// @section Interaction Options
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    // @option doubleClickZoom: Boolean|String = true
    // Whether the map can be zoomed in by double clicking on it and
    // zoomed out by double clicking while holding shift. If passed
    // `'center'`, double-click zoom will zoom to the center of the
    //  view regardless of where the mouse was.
    doubleClickZoom: true
});
var $ea04616009d5b16a$export$659838eb19c9ae68 = (0, $8edcec5990ab2544$export$a428cd33b25d5283).extend({
    addHooks: function() {
        this._map.on("dblclick", this._onDoubleClick, this);
    },
    removeHooks: function() {
        this._map.off("dblclick", this._onDoubleClick, this);
    },
    _onDoubleClick: function(e) {
        var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
        if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
        else map.setZoomAround(e.containerPoint, zoom);
    }
});
// @section Handlers
//
// Map properties include interaction handlers that allow you to control
// interaction behavior in runtime, enabling or disabling certain features such
// as dragging or touch zoom (see `Handler` methods). For example:
//
// ```js
// map.doubleClickZoom.disable();
// ```
//
// @property doubleClickZoom: Handler
// Double click zoom handler.
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).addInitHook("addHandler", "doubleClickZoom", $ea04616009d5b16a$export$659838eb19c9ae68);









/*
 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
 */ // @namespace Map
// @section Interaction Options
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    // @option dragging: Boolean = true
    // Whether the map is draggable with mouse/touch or not.
    dragging: true,
    // @section Panning Inertia Options
    // @option inertia: Boolean = *
    // If enabled, panning of the map will have an inertia effect where
    // the map builds momentum while dragging and continues moving in
    // the same direction for some time. Feels especially nice on touch
    // devices. Enabled by default.
    inertia: true,
    // @option inertiaDeceleration: Number = 3000
    // The rate with which the inertial movement slows down, in pixels/second².
    inertiaDeceleration: 3400,
    // @option inertiaMaxSpeed: Number = Infinity
    // Max speed of the inertial movement, in pixels/second.
    inertiaMaxSpeed: Infinity,
    // @option easeLinearity: Number = 0.2
    easeLinearity: 0.2,
    // TODO refactor, move to CRS
    // @option worldCopyJump: Boolean = false
    // With this option enabled, the map tracks when you pan to another "copy"
    // of the world and seamlessly jumps to the original one so that all overlays
    // like markers and vector layers are still visible.
    worldCopyJump: false,
    // @option maxBoundsViscosity: Number = 0.0
    // If `maxBounds` is set, this option will control how solid the bounds
    // are when dragging the map around. The default value of `0.0` allows the
    // user to drag outside the bounds at normal speed, higher values will
    // slow down map dragging outside bounds, and `1.0` makes the bounds fully
    // solid, preventing the user from dragging outside the bounds.
    maxBoundsViscosity: 0.0
});
var $f61fcd955993c830$export$b48985bba8f530f5 = (0, $8edcec5990ab2544$export$a428cd33b25d5283).extend({
    addHooks: function() {
        if (!this._draggable) {
            var map = this._map;
            this._draggable = new (0, $67085b4db43c69c6$export$f2a139e5d18b9882)(map._mapPane, map._container);
            this._draggable.on({
                dragstart: this._onDragStart,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this);
            this._draggable.on("predrag", this._onPreDragLimit, this);
            if (map.options.worldCopyJump) {
                this._draggable.on("predrag", this._onPreDragWrap, this);
                map.on("zoomend", this._onZoomEnd, this);
                map.whenReady(this._onZoomEnd, this);
            }
        }
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._map._container, "leaflet-grab leaflet-touch-drag");
        this._draggable.enable();
        this._positions = [];
        this._times = [];
    },
    removeHooks: function() {
        $b316889e4737b9d0$export$c2255604a80b4506(this._map._container, "leaflet-grab");
        $b316889e4737b9d0$export$c2255604a80b4506(this._map._container, "leaflet-touch-drag");
        this._draggable.disable();
    },
    moved: function() {
        return this._draggable && this._draggable._moved;
    },
    moving: function() {
        return this._draggable && this._draggable._moving;
    },
    _onDragStart: function() {
        var map = this._map;
        map._stop();
        if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
            var bounds = (0, $1b787e0b76fef54a$export$4904432a68b0399)(this._map.options.maxBounds);
            this._offsetLimit = (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
            this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
        } else this._offsetLimit = null;
        map.fire("movestart").fire("dragstart");
        if (map.options.inertia) {
            this._positions = [];
            this._times = [];
        }
    },
    _onDrag: function(e) {
        if (this._map.options.inertia) {
            var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
            this._positions.push(pos);
            this._times.push(time);
            this._prunePositions(time);
        }
        this._map.fire("move", e).fire("drag", e);
    },
    _prunePositions: function(time) {
        while(this._positions.length > 1 && time - this._times[0] > 50){
            this._positions.shift();
            this._times.shift();
        }
    },
    _onZoomEnd: function() {
        var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
            0,
            0
        ]);
        this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
        this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
    },
    _viscousLimit: function(value, threshold) {
        return value - (value - threshold) * this._viscosity;
    },
    _onPreDragLimit: function() {
        if (!this._viscosity || !this._offsetLimit) return;
        var offset = this._draggable._newPos.subtract(this._draggable._startPos);
        var limit = this._offsetLimit;
        if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
        if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
        if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
        if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
        this._draggable._newPos = this._draggable._startPos.add(offset);
    },
    _onPreDragWrap: function() {
        // TODO refactor to be able to adjust map pane position after zoom
        var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
        this._draggable._absPos = this._draggable._newPos.clone();
        this._draggable._newPos.x = newX;
    },
    _onDragEnd: function(e) {
        var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
        map.fire("dragend", e);
        if (noInertia) map.fire("moveend");
        else {
            this._prunePositions(+new Date());
            var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                0,
                0
            ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
            if (!offset.x && !offset.y) map.fire("moveend");
            else {
                offset = map._limitOffset(offset, map.options.maxBounds);
                $78a895d83da22602$export$d371ad015c199c06(function() {
                    map.panBy(offset, {
                        duration: decelerationDuration,
                        easeLinearity: ease,
                        noMoveStart: true,
                        animate: true
                    });
                });
            }
        }
    }
});
// @section Handlers
// @property dragging: Handler
// Map dragging handler (by both mouse and touch).
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).addInitHook("addHandler", "dragging", $f61fcd955993c830$export$b48985bba8f530f5);






/*
 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
 */ // @namespace Map
// @section Keyboard Navigation Options
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    // @option keyboard: Boolean = true
    // Makes the map focusable and allows users to navigate the map with keyboard
    // arrows and `+`/`-` keys.
    keyboard: true,
    // @option keyboardPanDelta: Number = 80
    // Amount of pixels to pan when pressing an arrow key.
    keyboardPanDelta: 80
});
var $9422e880fb13105b$export$16e4d70cc375e707 = (0, $8edcec5990ab2544$export$a428cd33b25d5283).extend({
    keyCodes: {
        left: [
            37
        ],
        right: [
            39
        ],
        down: [
            40
        ],
        up: [
            38
        ],
        zoomIn: [
            187,
            107,
            61,
            171
        ],
        zoomOut: [
            189,
            109,
            54,
            173
        ]
    },
    initialize: function(map) {
        this._map = map;
        this._setPanDelta(map.options.keyboardPanDelta);
        this._setZoomDelta(map.options.zoomDelta);
    },
    addHooks: function() {
        var container = this._map._container;
        // make the container focusable by tabbing
        if (container.tabIndex <= 0) container.tabIndex = "0";
        (0, $7c9dd72411ef2269$export$af631764ddc44097)(container, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
        }, this);
        this._map.on({
            focus: this._addHooks,
            blur: this._removeHooks
        }, this);
    },
    removeHooks: function() {
        this._removeHooks();
        (0, $7c9dd72411ef2269$export$8c8705df4a2dcec9)(this._map._container, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
        }, this);
        this._map.off({
            focus: this._addHooks,
            blur: this._removeHooks
        }, this);
    },
    _onMouseDown: function() {
        if (this._focused) return;
        var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
        this._map._container.focus();
        window.scrollTo(left, top);
    },
    _onFocus: function() {
        this._focused = true;
        this._map.fire("focus");
    },
    _onBlur: function() {
        this._focused = false;
        this._map.fire("blur");
    },
    _setPanDelta: function(panDelta) {
        var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
        for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
            -1 * panDelta,
            0
        ];
        for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
            panDelta,
            0
        ];
        for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
            0,
            panDelta
        ];
        for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
            0,
            -1 * panDelta
        ];
    },
    _setZoomDelta: function(zoomDelta) {
        var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
        for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
        for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
    },
    _addHooks: function() {
        (0, $7c9dd72411ef2269$export$af631764ddc44097)(document, "keydown", this._onKeyDown, this);
    },
    _removeHooks: function() {
        (0, $7c9dd72411ef2269$export$8c8705df4a2dcec9)(document, "keydown", this._onKeyDown, this);
    },
    _onKeyDown: function(e) {
        if (e.altKey || e.ctrlKey || e.metaKey) return;
        var key = e.keyCode, map = this._map, offset;
        if (key in this._panKeys) {
            if (!map._panAnim || !map._panAnim._inProgress) {
                offset = this._panKeys[key];
                if (e.shiftKey) offset = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(offset).multiplyBy(3);
                if (map.options.maxBounds) offset = map._limitOffset((0, $0552a615fcf79927$export$b63cca88ddc558a9)(offset), map.options.maxBounds);
                if (map.options.worldCopyJump) {
                    var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                    map.panTo(newLatLng);
                } else map.panBy(offset);
            }
        } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
        else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
        else return;
        (0, $7c9dd72411ef2269$export$fa6813432f753b0d)(e);
    }
});
// @section Handlers
// @section Handlers
// @property keyboard: Handler
// Keyboard navigation handler.
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).addInitHook("addHandler", "keyboard", $9422e880fb13105b$export$16e4d70cc375e707);






/*
 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
 */ // @namespace Map
// @section Interaction Options
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    // @section Mouse wheel options
    // @option scrollWheelZoom: Boolean|String = true
    // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
    // it will zoom to the center of the view regardless of where the mouse was.
    scrollWheelZoom: true,
    // @option wheelDebounceTime: Number = 40
    // Limits the rate at which a wheel can fire (in milliseconds). By default
    // user can't zoom via wheel more often than once per 40 ms.
    wheelDebounceTime: 40,
    // @option wheelPxPerZoomLevel: Number = 60
    // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
    // mean a change of one full zoom level. Smaller values will make wheel-zooming
    // faster (and vice versa).
    wheelPxPerZoomLevel: 60
});
var $f3db4258fbe82097$export$827ded792b758b05 = (0, $8edcec5990ab2544$export$a428cd33b25d5283).extend({
    addHooks: function() {
        $7c9dd72411ef2269$export$af631764ddc44097(this._map._container, "wheel", this._onWheelScroll, this);
        this._delta = 0;
    },
    removeHooks: function() {
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(this._map._container, "wheel", this._onWheelScroll, this);
    },
    _onWheelScroll: function(e) {
        var delta = $7c9dd72411ef2269$export$99de932e438a9331(e);
        var debounce = this._map.options.wheelDebounceTime;
        this._delta += delta;
        this._lastMousePos = this._map.mouseEventToContainerPoint(e);
        if (!this._startTime) this._startTime = +new Date();
        var left = Math.max(debounce - (+new Date() - this._startTime), 0);
        clearTimeout(this._timer);
        this._timer = setTimeout($78a895d83da22602$export$2385a24977818dd0(this._performZoom, this), left);
        $7c9dd72411ef2269$export$fa6813432f753b0d(e);
    },
    _performZoom: function() {
        var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
        map._stop(); // stop panning and fly animations if any
        // map the delta with a sigmoid function to -4..4 range leaning on -1..1
        var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
        this._delta = 0;
        this._startTime = null;
        if (!delta) return;
        if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
        else map.setZoomAround(this._lastMousePos, zoom + delta);
    }
});
// @section Handlers
// @property scrollWheelZoom: Handler
// Scroll wheel zoom handler.
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).addInitHook("addHandler", "scrollWheelZoom", $f3db4258fbe82097$export$827ded792b758b05);








/*
 * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
 * which otherwise is not fired by mobile Safari.
 */ var $3d00b009a61dc8b9$var$tapHoldDelay = 600;
// @namespace Map
// @section Interaction Options
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    // @section Touch interaction options
    // @option tapHold: Boolean
    // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
    tapHold: (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).touchNative && (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).safari && (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).mobile,
    // @option tapTolerance: Number = 15
    // The max number of pixels a user can shift his finger during touch
    // for it to be considered a valid tap.
    tapTolerance: 15
});
var $3d00b009a61dc8b9$export$1f41e5991b5e31c0 = (0, $8edcec5990ab2544$export$a428cd33b25d5283).extend({
    addHooks: function() {
        $7c9dd72411ef2269$export$af631764ddc44097(this._map._container, "touchstart", this._onDown, this);
    },
    removeHooks: function() {
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(this._map._container, "touchstart", this._onDown, this);
    },
    _onDown: function(e) {
        clearTimeout(this._holdTimeout);
        if (e.touches.length !== 1) return;
        var first = e.touches[0];
        this._startPos = this._newPos = new (0, $0552a615fcf79927$export$baf26146a414f24a)(first.clientX, first.clientY);
        this._holdTimeout = setTimeout($78a895d83da22602$export$2385a24977818dd0(function() {
            this._cancel();
            if (!this._isTapValid()) return;
            // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
            $7c9dd72411ef2269$export$af631764ddc44097(document, "touchend", $7c9dd72411ef2269$export$fa3b29edae795ef4);
            $7c9dd72411ef2269$export$af631764ddc44097(document, "touchend touchcancel", this._cancelClickPrevent);
            this._simulateEvent("contextmenu", first);
        }, this), $3d00b009a61dc8b9$var$tapHoldDelay);
        $7c9dd72411ef2269$export$af631764ddc44097(document, "touchend touchcancel contextmenu", this._cancel, this);
        $7c9dd72411ef2269$export$af631764ddc44097(document, "touchmove", this._onMove, this);
    },
    _cancelClickPrevent: function cancelClickPrevent() {
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(document, "touchend", $7c9dd72411ef2269$export$fa3b29edae795ef4);
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(document, "touchend touchcancel", cancelClickPrevent);
    },
    _cancel: function() {
        clearTimeout(this._holdTimeout);
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(document, "touchend touchcancel contextmenu", this._cancel, this);
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(document, "touchmove", this._onMove, this);
    },
    _onMove: function(e) {
        var first = e.touches[0];
        this._newPos = new (0, $0552a615fcf79927$export$baf26146a414f24a)(first.clientX, first.clientY);
    },
    _isTapValid: function() {
        return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
    },
    _simulateEvent: function(type, e) {
        var simulatedEvent = new MouseEvent(type, {
            bubbles: true,
            cancelable: true,
            view: window,
            // detail: 1,
            screenX: e.screenX,
            screenY: e.screenY,
            clientX: e.clientX,
            clientY: e.clientY
        });
        simulatedEvent._simulated = true;
        e.target.dispatchEvent(simulatedEvent);
    }
});
// @section Handlers
// @property tapHold: Handler
// Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).addInitHook("addHandler", "tapHold", $3d00b009a61dc8b9$export$1f41e5991b5e31c0);








/*
 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
 */ // @namespace Map
// @section Interaction Options
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).mergeOptions({
    // @section Touch interaction options
    // @option touchZoom: Boolean|String = *
    // Whether the map can be zoomed by touch-dragging with two fingers. If
    // passed `'center'`, it will zoom to the center of the view regardless of
    // where the touch events (fingers) were. Enabled for touch-capable web
    // browsers.
    touchZoom: (0, $029e6e3a5e23f5b8$export$2e2bcd8739ae039).touch,
    // @option bounceAtZoomLimits: Boolean = true
    // Set it to false if you don't want the map to zoom beyond min/max zoom
    // and then bounce back when pinch-zooming.
    bounceAtZoomLimits: true
});
var $315d37bceb2caec4$export$c2e78827ecf04883 = (0, $8edcec5990ab2544$export$a428cd33b25d5283).extend({
    addHooks: function() {
        $b316889e4737b9d0$export$d2cf6cd1dc7067d3(this._map._container, "leaflet-touch-zoom");
        $7c9dd72411ef2269$export$af631764ddc44097(this._map._container, "touchstart", this._onTouchStart, this);
    },
    removeHooks: function() {
        $b316889e4737b9d0$export$c2255604a80b4506(this._map._container, "leaflet-touch-zoom");
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(this._map._container, "touchstart", this._onTouchStart, this);
    },
    _onTouchStart: function(e) {
        var map = this._map;
        if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
        var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
        this._centerPoint = map.getSize()._divideBy(2);
        this._startLatLng = map.containerPointToLatLng(this._centerPoint);
        if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
        this._startDist = p1.distanceTo(p2);
        this._startZoom = map.getZoom();
        this._moved = false;
        this._zooming = true;
        map._stop();
        $7c9dd72411ef2269$export$af631764ddc44097(document, "touchmove", this._onTouchMove, this);
        $7c9dd72411ef2269$export$af631764ddc44097(document, "touchend touchcancel", this._onTouchEnd, this);
        $7c9dd72411ef2269$export$fa3b29edae795ef4(e);
    },
    _onTouchMove: function(e) {
        if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
        var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
        this._zoom = map.getScaleZoom(scale, this._startZoom);
        if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
        if (map.options.touchZoom === "center") {
            this._center = this._startLatLng;
            if (scale === 1) return;
        } else {
            // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
            var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
            if (scale === 1 && delta.x === 0 && delta.y === 0) return;
            this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
        }
        if (!this._moved) {
            map._moveStart(true, false);
            this._moved = true;
        }
        $78a895d83da22602$export$e1ed83507f55dc9d(this._animRequest);
        var moveFn = $78a895d83da22602$export$2385a24977818dd0(map._move, map, this._center, this._zoom, {
            pinch: true,
            round: false
        }, undefined);
        this._animRequest = $78a895d83da22602$export$d371ad015c199c06(moveFn, this, true);
        $7c9dd72411ef2269$export$fa3b29edae795ef4(e);
    },
    _onTouchEnd: function() {
        if (!this._moved || !this._zooming) {
            this._zooming = false;
            return;
        }
        this._zooming = false;
        $78a895d83da22602$export$e1ed83507f55dc9d(this._animRequest);
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(document, "touchmove", this._onTouchMove, this);
        $7c9dd72411ef2269$export$8c8705df4a2dcec9(document, "touchend touchcancel", this._onTouchEnd, this);
        // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
        if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
        else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
    }
});
// @section Handlers
// @property touchZoom: Handler
// Touch zoom handler.
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).addInitHook("addHandler", "touchZoom", $315d37bceb2caec4$export$c2e78827ecf04883);


(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).BoxZoom = (0, $95d63c75e1bd265d$export$2151b62cd620e937);
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).DoubleClickZoom = (0, $ea04616009d5b16a$export$659838eb19c9ae68);
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).Drag = (0, $f61fcd955993c830$export$b48985bba8f530f5);
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).Keyboard = (0, $9422e880fb13105b$export$16e4d70cc375e707);
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).ScrollWheelZoom = (0, $f3db4258fbe82097$export$827ded792b758b05);
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).TapHold = (0, $3d00b009a61dc8b9$export$1f41e5991b5e31c0);
(0, $a14ca6047db5cfcd$export$a5c7b93649eaf8f8).TouchZoom = (0, $315d37bceb2caec4$export$c2e78827ecf04883);




var $f5fb3e566b1746ef$exports = {};

/*!
Copyright (c) 2016 Dominik Moritz

This file is part of the leaflet locate control. It is licensed under the MIT license.
You can find the project at: https://github.com/domoritz/leaflet-locatecontrol
*/ (function(factory, window1) {
    // see https://github.com/Leaflet/Leaflet/blob/master/PLUGIN-GUIDE.md#module-loaders
    // for details on how to structure a leaflet plugin.
    // define an AMD module that relies on 'leaflet'
    if (typeof define === "function" && define.amd) define([
        "leaflet"
    ], factory);
    else if (true) {
        if (typeof window1 !== "undefined" && window1.L) $f5fb3e566b1746ef$exports = factory(L);
        else $f5fb3e566b1746ef$exports = factory((parcelRequire("bjwWZ")));
    }
    // attach your plugin to the global 'L' variable
    if (typeof window1 !== "undefined" && window1.L) window1.L.Control.Locate = factory(L);
})(function(L1) {
    const LDomUtilApplyClassesMethod = (method, element, classNames)=>{
        classNames = classNames.split(" ");
        classNames.forEach(function(className) {
            L1.DomUtil[method].call(this, element, className);
        });
    };
    const addClasses = (el, names)=>LDomUtilApplyClassesMethod("addClass", el, names);
    const removeClasses = (el, names)=>LDomUtilApplyClassesMethod("removeClass", el, names);
    /**
   * Compatible with L.Circle but a true marker instead of a path
   */ const LocationMarker = L1.Marker.extend({
        initialize (latlng, options) {
            L1.Util.setOptions(this, options);
            this._latlng = latlng;
            this.createIcon();
        },
        /**
     * Create a styled circle location marker
     */ createIcon () {
            const opt = this.options;
            let style = "";
            if (opt.color !== undefined) style += `stroke:${opt.color};`;
            if (opt.weight !== undefined) style += `stroke-width:${opt.weight};`;
            if (opt.fillColor !== undefined) style += `fill:${opt.fillColor};`;
            if (opt.fillOpacity !== undefined) style += `fill-opacity:${opt.fillOpacity};`;
            if (opt.opacity !== undefined) style += `opacity:${opt.opacity};`;
            const icon = this._getIconSVG(opt, style);
            this._locationIcon = L1.divIcon({
                className: icon.className,
                html: icon.svg,
                iconSize: [
                    icon.w,
                    icon.h
                ]
            });
            this.setIcon(this._locationIcon);
        },
        /**
     * Return the raw svg for the shape
     *
     * Split so can be easily overridden
     */ _getIconSVG (options, style) {
            const r = options.radius;
            const w = options.weight;
            const s = r + w;
            const s2 = s * 2;
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${s2}" height="${s2}" version="1.1" viewBox="-${s} -${s} ${s2} ${s2}">` + '<circle r="' + r + '" style="' + style + '" />' + "</svg>";
            return {
                className: "leaflet-control-locate-location",
                svg: svg,
                w: s2,
                h: s2
            };
        },
        setStyle (style) {
            L1.Util.setOptions(this, style);
            this.createIcon();
        }
    });
    const CompassMarker = LocationMarker.extend({
        initialize (latlng, heading, options) {
            L1.Util.setOptions(this, options);
            this._latlng = latlng;
            this._heading = heading;
            this.createIcon();
        },
        setHeading (heading) {
            this._heading = heading;
        },
        /**
     * Create a styled arrow compass marker
     */ _getIconSVG (options, style) {
            const r = options.radius;
            const w = options.width + options.weight;
            const h = (r + options.depth + options.weight) * 2;
            const path = `M0,0 l${options.width / 2},${options.depth} l-${w},0 z`;
            const svgstyle = `transform: rotate(${this._heading}deg)`;
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" version="1.1" viewBox="-${w / 2} 0 ${w} ${h}" style="${svgstyle}">` + '<path d="' + path + '" style="' + style + '" />' + "</svg>";
            return {
                className: "leaflet-control-locate-heading",
                svg: svg,
                w: w,
                h: h
            };
        }
    });
    const LocateControl = L1.Control.extend({
        options: {
            /** Position of the control */ position: "topleft",
            /** The layer that the user's location should be drawn on. By default creates a new layer. */ layer: undefined,
            /**
       * Automatically sets the map view (zoom and pan) to the user's location as it updates.
       * While the map is following the user's location, the control is in the `following` state,
       * which changes the style of the control and the circle marker.
       *
       * Possible values:
       *  - false: never updates the map view when location changes.
       *  - 'once': set the view when the location is first determined
       *  - 'always': always updates the map view when location changes.
       *              The map view follows the user's location.
       *  - 'untilPan': like 'always', except stops updating the
       *                view if the user has manually panned the map.
       *                The map view follows the user's location until she pans.
       *  - 'untilPanOrZoom': (default) like 'always', except stops updating the
       *                view if the user has manually panned the map.
       *                The map view follows the user's location until she pans.
       */ setView: "untilPanOrZoom",
            /** Keep the current map zoom level when setting the view and only pan. */ keepCurrentZoomLevel: false,
            /** After activating the plugin by clicking on the icon, zoom to the selected zoom level, even when keepCurrentZoomLevel is true. Set to 'false' to disable this feature. */ initialZoomLevel: false,
            /**
       * This callback can be used to override the viewport tracking
       * This function should return a LatLngBounds object.
       *
       * For example to extend the viewport to ensure that a particular LatLng is visible:
       *
       * getLocationBounds: function(locationEvent) {
       *    return locationEvent.bounds.extend([-33.873085, 151.219273]);
       * },
       */ getLocationBounds (locationEvent) {
                return locationEvent.bounds;
            },
            /** Smooth pan and zoom to the location of the marker. Only works in Leaflet 1.0+. */ flyTo: false,
            /**
       * The user location can be inside and outside the current view when the user clicks on the
       * control that is already active. Both cases can be configures separately.
       * Possible values are:
       *  - 'setView': zoom and pan to the current location
       *  - 'stop': stop locating and remove the location marker
       */ clickBehavior: {
                /** What should happen if the user clicks on the control while the location is within the current view. */ inView: "stop",
                /** What should happen if the user clicks on the control while the location is outside the current view. */ outOfView: "setView",
                /**
         * What should happen if the user clicks on the control while the location is within the current view
         * and we could be following but are not. Defaults to a special value which inherits from 'inView';
         */ inViewNotFollowing: "inView"
            },
            /**
       * If set, save the map bounds just before centering to the user's
       * location. When control is disabled, set the view back to the
       * bounds that were saved.
       */ returnToPrevBounds: false,
            /**
       * Keep a cache of the location after the user deactivates the control. If set to false, the user has to wait
       * until the locate API returns a new location before they see where they are again.
       */ cacheLocation: true,
            /** If set, a circle that shows the location accuracy is drawn. */ drawCircle: true,
            /** If set, the marker at the users' location is drawn. */ drawMarker: true,
            /** If set and supported then show the compass heading */ showCompass: true,
            /** The class to be used to create the marker. For example L.CircleMarker or L.Marker */ markerClass: LocationMarker,
            /** The class us be used to create the compass bearing arrow */ compassClass: CompassMarker,
            /** Accuracy circle style properties. NOTE these styles should match the css animations styles */ circleStyle: {
                className: "leaflet-control-locate-circle",
                color: "#136AEC",
                fillColor: "#136AEC",
                fillOpacity: 0.15,
                weight: 0
            },
            /** Inner marker style properties. Only works if your marker class supports `setStyle`. */ markerStyle: {
                className: "leaflet-control-locate-marker",
                color: "#fff",
                fillColor: "#2A93EE",
                fillOpacity: 1,
                weight: 3,
                opacity: 1,
                radius: 9
            },
            /** Compass */ compassStyle: {
                fillColor: "#2A93EE",
                fillOpacity: 1,
                weight: 0,
                color: "#fff",
                opacity: 1,
                radius: 9,
                width: 9,
                depth: 6 // Length of the arrow
            },
            /**
       * Changes to accuracy circle and inner marker while following.
       * It is only necessary to provide the properties that should change.
       */ followCircleStyle: {},
            followMarkerStyle: {
            },
            followCompassStyle: {},
            /** The CSS class for the icon. For example fa-location-arrow or fa-map-marker */ icon: "leaflet-control-locate-location-arrow",
            iconLoading: "leaflet-control-locate-spinner",
            /** The element to be created for icons. For example span or i */ iconElementTag: "span",
            /** The element to be created for the text. For example small or span */ textElementTag: "small",
            /** Padding around the accuracy circle. */ circlePadding: [
                0,
                0
            ],
            /** Use metric units. */ metric: true,
            /**
       * This callback can be used in case you would like to override button creation behavior.
       * This is useful for DOM manipulation frameworks such as angular etc.
       * This function should return an object with HtmlElement for the button (link property) and the icon (icon property).
       */ createButtonCallback (container, options) {
                const link = L1.DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single", container);
                link.title = options.strings.title;
                link.href = "#";
                link.setAttribute("role", "button");
                const icon = L1.DomUtil.create(options.iconElementTag, options.icon, link);
                if (options.strings.text !== undefined) {
                    const text = L1.DomUtil.create(options.textElementTag, "leaflet-locate-text", link);
                    text.textContent = options.strings.text;
                    link.classList.add("leaflet-locate-text-active");
                    link.parentNode.style.display = "flex";
                    if (options.icon.length > 0) icon.classList.add("leaflet-locate-icon");
                }
                return {
                    link: link,
                    icon: icon
                };
            },
            /** This event is called in case of any location error that is not a time out error. */ onLocationError (err, control) {
                alert(err.message);
            },
            /**
       * This event is called when the user's location is outside the bounds set on the map.
       * The event is called repeatedly when the location changes.
       */ onLocationOutsideMapBounds (control) {
                control.stop();
                alert(control.options.strings.outsideMapBoundsMsg);
            },
            /** Display a pop-up when the user click on the inner marker. */ showPopup: true,
            strings: {
                title: "Show me where I am",
                metersUnit: "meters",
                feetUnit: "feet",
                popup: "You are within {distance} {unit} from this point",
                outsideMapBoundsMsg: "You seem located outside the boundaries of the map"
            },
            /** The default options passed to leaflets locate method. */ locateOptions: {
                maxZoom: Infinity,
                watch: true,
                setView: false // have to set this to false because we have to
            }
        },
        initialize (options) {
            // set default options if nothing is set (merge one step deep)
            for(const i in options)if (typeof this.options[i] === "object") L1.extend(this.options[i], options[i]);
            else this.options[i] = options[i];
            // extend the follow marker style and circle from the normal style
            this.options.followMarkerStyle = L1.extend({}, this.options.markerStyle, this.options.followMarkerStyle);
            this.options.followCircleStyle = L1.extend({}, this.options.circleStyle, this.options.followCircleStyle);
            this.options.followCompassStyle = L1.extend({}, this.options.compassStyle, this.options.followCompassStyle);
        },
        /**
     * Add control to map. Returns the container for the control.
     */ onAdd (map) {
            const container = L1.DomUtil.create("div", "leaflet-control-locate leaflet-bar leaflet-control");
            this._container = container;
            this._map = map;
            this._layer = this.options.layer || new L1.LayerGroup();
            this._layer.addTo(map);
            this._event = undefined;
            this._compassHeading = null;
            this._prevBounds = null;
            const linkAndIcon = this.options.createButtonCallback(container, this.options);
            this._link = linkAndIcon.link;
            this._icon = linkAndIcon.icon;
            L1.DomEvent.on(this._link, "click", function(ev) {
                L1.DomEvent.stopPropagation(ev);
                L1.DomEvent.preventDefault(ev);
                this._onClick();
            }, this).on(this._link, "dblclick", L1.DomEvent.stopPropagation);
            this._resetVariables();
            this._map.on("unload", this._unload, this);
            return container;
        },
        /**
     * This method is called when the user clicks on the control.
     */ _onClick () {
            this._justClicked = true;
            const wasFollowing = this._isFollowing();
            this._userPanned = false;
            this._userZoomed = false;
            if (this._active && !this._event) // click while requesting
            this.stop();
            else if (this._active) {
                const behaviors = this.options.clickBehavior;
                let behavior = behaviors.outOfView;
                if (this._map.getBounds().contains(this._event.latlng)) behavior = wasFollowing ? behaviors.inView : behaviors.inViewNotFollowing;
                // Allow inheriting from another behavior
                if (behaviors[behavior]) behavior = behaviors[behavior];
                switch(behavior){
                    case "setView":
                        this.setView();
                        break;
                    case "stop":
                        this.stop();
                        if (this.options.returnToPrevBounds) {
                            const f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                            f.bind(this._map)(this._prevBounds);
                        }
                        break;
                }
            } else {
                if (this.options.returnToPrevBounds) this._prevBounds = this._map.getBounds();
                this.start();
            }
            this._updateContainerStyle();
        },
        /**
     * Starts the plugin:
     * - activates the engine
     * - draws the marker (if coordinates available)
     */ start () {
            this._activate();
            if (this._event) {
                this._drawMarker(this._map);
                // if we already have a location but the user clicked on the control
                if (this.options.setView) this.setView();
            }
            this._updateContainerStyle();
        },
        /**
     * Stops the plugin:
     * - deactivates the engine
     * - reinitializes the button
     * - removes the marker
     */ stop () {
            this._deactivate();
            this._cleanClasses();
            this._resetVariables();
            this._removeMarker();
        },
        /**
     * Keep the control active but stop following the location
     */ stopFollowing () {
            this._userPanned = true;
            this._updateContainerStyle();
            this._drawMarker();
        },
        /**
     * This method launches the location engine.
     * It is called before the marker is updated,
     * event if it does not mean that the event will be ready.
     *
     * Override it if you want to add more functionalities.
     * It should set the this._active to true and do nothing if
     * this._active is true.
     */ _activate () {
            if (this._active || !this._map) return;
            this._map.locate(this.options.locateOptions);
            this._map.fire("locateactivate", this);
            this._active = true;
            // bind event listeners
            this._map.on("locationfound", this._onLocationFound, this);
            this._map.on("locationerror", this._onLocationError, this);
            this._map.on("dragstart", this._onDrag, this);
            this._map.on("zoomstart", this._onZoom, this);
            this._map.on("zoomend", this._onZoomEnd, this);
            if (this.options.showCompass) {
                const oriAbs = "ondeviceorientationabsolute" in window;
                if (oriAbs || "ondeviceorientation" in window) {
                    const _this = this;
                    const deviceorientation = function() {
                        L1.DomEvent.on(window, oriAbs ? "deviceorientationabsolute" : "deviceorientation", _this._onDeviceOrientation, _this);
                    };
                    if (DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then(function(permissionState) {
                        if (permissionState === "granted") deviceorientation();
                    });
                    else deviceorientation();
                }
            }
        },
        /**
     * Called to stop the location engine.
     *
     * Override it to shutdown any functionalities you added on start.
     */ _deactivate () {
            if (!this._active || !this._map) return;
            this._map.stopLocate();
            this._map.fire("locatedeactivate", this);
            this._active = false;
            if (!this.options.cacheLocation) this._event = undefined;
            // unbind event listeners
            this._map.off("locationfound", this._onLocationFound, this);
            this._map.off("locationerror", this._onLocationError, this);
            this._map.off("dragstart", this._onDrag, this);
            this._map.off("zoomstart", this._onZoom, this);
            this._map.off("zoomend", this._onZoomEnd, this);
            if (this.options.showCompass) {
                this._compassHeading = null;
                if ("ondeviceorientationabsolute" in window) L1.DomEvent.off(window, "deviceorientationabsolute", this._onDeviceOrientation, this);
                else if ("ondeviceorientation" in window) L1.DomEvent.off(window, "deviceorientation", this._onDeviceOrientation, this);
            }
        },
        /**
     * Zoom (unless we should keep the zoom level) and an to the current view.
     */ setView () {
            this._drawMarker();
            if (this._isOutsideMapBounds()) {
                this._event = undefined; // clear the current location so we can get back into the bounds
                this.options.onLocationOutsideMapBounds(this);
            } else {
                if (this._justClicked && this.options.initialZoomLevel !== false) {
                    var f = this.options.flyTo ? this._map.flyTo : this._map.setView;
                    f.bind(this._map)([
                        this._event.latitude,
                        this._event.longitude
                    ], this.options.initialZoomLevel);
                } else if (this.options.keepCurrentZoomLevel) {
                    var f = this.options.flyTo ? this._map.flyTo : this._map.panTo;
                    f.bind(this._map)([
                        this._event.latitude,
                        this._event.longitude
                    ]);
                } else {
                    var f = this.options.flyTo ? this._map.flyToBounds : this._map.fitBounds;
                    // Ignore zoom events while setting the viewport as these would stop following
                    this._ignoreEvent = true;
                    f.bind(this._map)(this.options.getLocationBounds(this._event), {
                        padding: this.options.circlePadding,
                        maxZoom: this.options.initialZoomLevel || this.options.locateOptions.maxZoom
                    });
                    L1.Util.requestAnimFrame(function() {
                        // Wait until after the next animFrame because the flyTo can be async
                        this._ignoreEvent = false;
                    }, this);
                }
            }
        },
        /**
     *
     */ _drawCompass () {
            if (!this._event) return;
            const latlng = this._event.latlng;
            if (this.options.showCompass && latlng && this._compassHeading !== null) {
                const cStyle = this._isFollowing() ? this.options.followCompassStyle : this.options.compassStyle;
                if (!this._compass) this._compass = new this.options.compassClass(latlng, this._compassHeading, cStyle).addTo(this._layer);
                else {
                    this._compass.setLatLng(latlng);
                    this._compass.setHeading(this._compassHeading);
                    // If the compassClass can be updated with setStyle, update it.
                    if (this._compass.setStyle) this._compass.setStyle(cStyle);
                }
            //
            }
            if (this._compass && (!this.options.showCompass || this._compassHeading === null)) {
                this._compass.removeFrom(this._layer);
                this._compass = null;
            }
        },
        /**
     * Draw the marker and accuracy circle on the map.
     *
     * Uses the event retrieved from onLocationFound from the map.
     */ _drawMarker () {
            if (this._event.accuracy === undefined) this._event.accuracy = 0;
            const radius = this._event.accuracy;
            const latlng = this._event.latlng;
            // circle with the radius of the location's accuracy
            if (this.options.drawCircle) {
                const style = this._isFollowing() ? this.options.followCircleStyle : this.options.circleStyle;
                if (!this._circle) this._circle = L1.circle(latlng, radius, style).addTo(this._layer);
                else this._circle.setLatLng(latlng).setRadius(radius).setStyle(style);
            }
            let distance;
            let unit;
            if (this.options.metric) {
                distance = radius.toFixed(0);
                unit = this.options.strings.metersUnit;
            } else {
                distance = (radius * 3.2808399).toFixed(0);
                unit = this.options.strings.feetUnit;
            }
            // small inner marker
            if (this.options.drawMarker) {
                const mStyle = this._isFollowing() ? this.options.followMarkerStyle : this.options.markerStyle;
                if (!this._marker) this._marker = new this.options.markerClass(latlng, mStyle).addTo(this._layer);
                else {
                    this._marker.setLatLng(latlng);
                    // If the markerClass can be updated with setStyle, update it.
                    if (this._marker.setStyle) this._marker.setStyle(mStyle);
                }
            }
            this._drawCompass();
            const t = this.options.strings.popup;
            function getPopupText() {
                if (typeof t === "string") return L1.Util.template(t, {
                    distance: distance,
                    unit: unit
                });
                else if (typeof t === "function") return t({
                    distance: distance,
                    unit: unit
                });
                else return t;
            }
            if (this.options.showPopup && t && this._marker) this._marker.bindPopup(getPopupText())._popup.setLatLng(latlng);
            if (this.options.showPopup && t && this._compass) this._compass.bindPopup(getPopupText())._popup.setLatLng(latlng);
        },
        /**
     * Remove the marker from map.
     */ _removeMarker () {
            this._layer.clearLayers();
            this._marker = undefined;
            this._circle = undefined;
        },
        /**
     * Unload the plugin and all event listeners.
     * Kind of the opposite of onAdd.
     */ _unload () {
            this.stop();
            // May become undefined during HMR
            if (this._map) this._map.off("unload", this._unload, this);
        },
        /**
     * Sets the compass heading
     */ _setCompassHeading (angle) {
            if (!isNaN(parseFloat(angle)) && isFinite(angle)) {
                angle = Math.round(angle);
                this._compassHeading = angle;
                L1.Util.requestAnimFrame(this._drawCompass, this);
            } else this._compassHeading = null;
        },
        /**
     * If the compass fails calibration just fail safely and remove the compass
     */ _onCompassNeedsCalibration () {
            this._setCompassHeading();
        },
        /**
     * Process and normalise compass events
     */ _onDeviceOrientation (e) {
            if (!this._active) return;
            if (e.webkitCompassHeading) // iOS
            this._setCompassHeading(e.webkitCompassHeading);
            else if (e.absolute && e.alpha) // Android
            this._setCompassHeading(360 - e.alpha);
        },
        /**
     * Calls deactivate and dispatches an error.
     */ _onLocationError (err) {
            // ignore time out error if the location is watched
            if (err.code == 3 && this.options.locateOptions.watch) return;
            this.stop();
            this.options.onLocationError(err, this);
        },
        /**
     * Stores the received event and updates the marker.
     */ _onLocationFound (e) {
            // no need to do anything if the location has not changed
            if (this._event && this._event.latlng.lat === e.latlng.lat && this._event.latlng.lng === e.latlng.lng && this._event.accuracy === e.accuracy) return;
            if (!this._active) // we may have a stray event
            return;
            this._event = e;
            this._drawMarker();
            this._updateContainerStyle();
            switch(this.options.setView){
                case "once":
                    if (this._justClicked) this.setView();
                    break;
                case "untilPan":
                    if (!this._userPanned) this.setView();
                    break;
                case "untilPanOrZoom":
                    if (!this._userPanned && !this._userZoomed) this.setView();
                    break;
                case "always":
                    this.setView();
                    break;
                case false:
                    break;
            }
            this._justClicked = false;
        },
        /**
     * When the user drags. Need a separate event so we can bind and unbind event listeners.
     */ _onDrag () {
            // only react to drags once we have a location
            if (this._event && !this._ignoreEvent) {
                this._userPanned = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        },
        /**
     * When the user zooms. Need a separate event so we can bind and unbind event listeners.
     */ _onZoom () {
            // only react to drags once we have a location
            if (this._event && !this._ignoreEvent) {
                this._userZoomed = true;
                this._updateContainerStyle();
                this._drawMarker();
            }
        },
        /**
     * After a zoom ends update the compass and handle sideways zooms
     */ _onZoomEnd () {
            if (this._event) this._drawCompass();
            if (this._event && !this._ignoreEvent) // If we have zoomed in and out and ended up sideways treat it as a pan
            {
                if (this._marker && !this._map.getBounds().pad(-0.3).contains(this._marker.getLatLng())) {
                    this._userPanned = true;
                    this._updateContainerStyle();
                    this._drawMarker();
                }
            }
        },
        /**
     * Compute whether the map is following the user location with pan and zoom.
     */ _isFollowing () {
            if (!this._active) return false;
            if (this.options.setView === "always") return true;
            else if (this.options.setView === "untilPan") return !this._userPanned;
            else if (this.options.setView === "untilPanOrZoom") return !this._userPanned && !this._userZoomed;
        },
        /**
     * Check if location is in map bounds
     */ _isOutsideMapBounds () {
            if (this._event === undefined) return false;
            return this._map.options.maxBounds && !this._map.options.maxBounds.contains(this._event.latlng);
        },
        /**
     * Toggles button class between following and active.
     */ _updateContainerStyle () {
            if (!this._container) return;
            if (this._active && !this._event) // active but don't have a location yet
            this._setClasses("requesting");
            else if (this._isFollowing()) this._setClasses("following");
            else if (this._active) this._setClasses("active");
            else this._cleanClasses();
        },
        /**
     * Sets the CSS classes for the state.
     */ _setClasses (state) {
            if (state == "requesting") {
                removeClasses(this._container, "active following");
                addClasses(this._container, "requesting");
                removeClasses(this._icon, this.options.icon);
                addClasses(this._icon, this.options.iconLoading);
            } else if (state == "active") {
                removeClasses(this._container, "requesting following");
                addClasses(this._container, "active");
                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            } else if (state == "following") {
                removeClasses(this._container, "requesting");
                addClasses(this._container, "active following");
                removeClasses(this._icon, this.options.iconLoading);
                addClasses(this._icon, this.options.icon);
            }
        },
        /**
     * Removes all classes from button.
     */ _cleanClasses () {
            L1.DomUtil.removeClass(this._container, "requesting");
            L1.DomUtil.removeClass(this._container, "active");
            L1.DomUtil.removeClass(this._container, "following");
            removeClasses(this._icon, this.options.iconLoading);
            addClasses(this._icon, this.options.icon);
        },
        /**
     * Reinitializes state variables.
     */ _resetVariables () {
            // whether locate is active or not
            this._active = false;
            // true if the control was clicked for the first time
            // we need this so we can pan and zoom once we have the location
            this._justClicked = false;
            // true if the user has panned the map after clicking the control
            this._userPanned = false;
            // true if the user has zoomed the map after clicking the control
            this._userZoomed = false;
        }
    });
    L1.control.locate = (options)=>new L1.Control.Locate(options);
    return LocateControl;
}, window);



var $iRjZV = parcelRequire("iRjZV");

var $diMLx = parcelRequire("diMLx");


var $am1Dn = parcelRequire("am1Dn");
var $7a2b08189990a7f0$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ !function(t, e) {
    e($7a2b08189990a7f0$exports);
}($7a2b08189990a7f0$exports, function(t) {
    "use strict";
    function l(t) {
        for(var e, i, n = 1, o = arguments.length; n < o; n++)for(e in i = arguments[n])t[e] = i[e];
        return t;
    }
    var R = Object.create || function(t) {
        return N.prototype = t, new N;
    };
    function N() {}
    function a(t, e) {
        var i, n = Array.prototype.slice;
        return t.bind ? t.bind.apply(t, n.call(arguments, 1)) : (i = n.call(arguments, 2), function() {
            return t.apply(e, i.length ? i.concat(n.call(arguments)) : arguments);
        });
    }
    var D = 0;
    function h(t) {
        return "_leaflet_id" in t || (t._leaflet_id = ++D), t._leaflet_id;
    }
    function j(t, e, i) {
        var n, o, s = function() {
            n = !1, o && (r.apply(i, o), o = !1);
        }, r = function() {
            n ? o = arguments : (t.apply(i, arguments), setTimeout(s, e), n = !0);
        };
        return r;
    }
    function H(t, e, i) {
        var n = e[1], e = e[0], o = n - e;
        return t === n && i ? t : ((t - e) % o + o) % o + e;
    }
    function u() {
        return !1;
    }
    function i(t, e) {
        return !1 === e ? t : (e = Math.pow(10, void 0 === e ? 6 : e), Math.round(t * e) / e);
    }
    function W(t) {
        return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
    }
    function F(t) {
        return W(t).split(/\s+/);
    }
    function c(t, e) {
        for(var i in Object.prototype.hasOwnProperty.call(t, "options") || (t.options = t.options ? R(t.options) : {}), e)t.options[i] = e[i];
        return t.options;
    }
    function U(t, e, i) {
        var n, o = [];
        for(n in t)o.push(encodeURIComponent(i ? n.toUpperCase() : n) + "=" + encodeURIComponent(t[n]));
        return (e && -1 !== e.indexOf("?") ? "&" : "?") + o.join("&");
    }
    var V = /\{ *([\w_ -]+) *\}/g;
    function q(t, i) {
        return t.replace(V, function(t, e) {
            e = i[e];
            if (void 0 === e) throw new Error("No value provided for variable " + t);
            return e = "function" == typeof e ? e(i) : e;
        });
    }
    var d = Array.isArray || function(t) {
        return "[object Array]" === Object.prototype.toString.call(t);
    };
    function G(t, e) {
        for(var i = 0; i < t.length; i++)if (t[i] === e) return i;
        return -1;
    }
    var K = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    function Y(t) {
        return window["webkit" + t] || window["moz" + t] || window["ms" + t];
    }
    var X = 0;
    function J(t) {
        var e = +new Date, i = Math.max(0, 16 - (e - X));
        return X = e + i, window.setTimeout(t, i);
    }
    var $ = window.requestAnimationFrame || Y("RequestAnimationFrame") || J, Q = window.cancelAnimationFrame || Y("CancelAnimationFrame") || Y("CancelRequestAnimationFrame") || function(t) {
        window.clearTimeout(t);
    };
    function x(t, e, i) {
        if (!i || $ !== J) return $.call(window, a(t, e));
        t.call(e);
    }
    function r(t) {
        t && Q.call(window, t);
    }
    var tt = {
        __proto__: null,
        extend: l,
        create: R,
        bind: a,
        get lastId () {
            return D;
        },
        stamp: h,
        throttle: j,
        wrapNum: H,
        falseFn: u,
        formatNum: i,
        trim: W,
        splitWords: F,
        setOptions: c,
        getParamString: U,
        template: q,
        isArray: d,
        indexOf: G,
        emptyImageUrl: K,
        requestFn: $,
        cancelFn: Q,
        requestAnimFrame: x,
        cancelAnimFrame: r
    };
    function et() {}
    et.extend = function(t) {
        function e() {
            c(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
        }
        var i, n = e.__super__ = this.prototype, o = R(n);
        for(i in (o.constructor = e).prototype = o, this)Object.prototype.hasOwnProperty.call(this, i) && "prototype" !== i && "__super__" !== i && (e[i] = this[i]);
        if (t.statics && l(e, t.statics), t.includes) {
            var s = t.includes;
            if ("undefined" != typeof L && L && L.Mixin) {
                s = d(s) ? s : [
                    s
                ];
                for(var r = 0; r < s.length; r++)s[r] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", (new Error).stack);
            }
            l.apply(null, [
                o
            ].concat(t.includes));
        }
        return l(o, t), delete o.statics, delete o.includes, o.options && (o.options = n.options ? R(n.options) : {}, l(o.options, t.options)), o._initHooks = [], o.callInitHooks = function() {
            if (!this._initHooksCalled) {
                n.callInitHooks && n.callInitHooks.call(this), this._initHooksCalled = !0;
                for(var t = 0, e = o._initHooks.length; t < e; t++)o._initHooks[t].call(this);
            }
        }, e;
    }, et.include = function(t) {
        var e = this.prototype.options;
        return l(this.prototype, t), t.options && (this.prototype.options = e, this.mergeOptions(t.options)), this;
    }, et.mergeOptions = function(t) {
        return l(this.prototype.options, t), this;
    }, et.addInitHook = function(t) {
        var e = Array.prototype.slice.call(arguments, 1), i = "function" == typeof t ? t : function() {
            this[t].apply(this, e);
        };
        return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(i), this;
    };
    var e = {
        on: function(t, e, i) {
            if ("object" == typeof t) for(var n in t)this._on(n, t[n], e);
            else for(var o = 0, s = (t = F(t)).length; o < s; o++)this._on(t[o], e, i);
            return this;
        },
        off: function(t, e, i) {
            if (arguments.length) {
                if ("object" == typeof t) for(var n in t)this._off(n, t[n], e);
                else {
                    t = F(t);
                    for(var o = 1 === arguments.length, s = 0, r = t.length; s < r; s++)o ? this._off(t[s]) : this._off(t[s], e, i);
                }
            } else delete this._events;
            return this;
        },
        _on: function(t, e, i, n) {
            "function" != typeof e ? console.warn("wrong listener type: " + typeof e) : !1 === this._listens(t, e, i) && (e = {
                fn: e,
                ctx: i = i === this ? void 0 : i
            }, n && (e.once = !0), this._events = this._events || {}, this._events[t] = this._events[t] || [], this._events[t].push(e));
        },
        _off: function(t, e, i) {
            var n, o, s;
            if (this._events && (n = this._events[t])) {
                if (1 === arguments.length) {
                    if (this._firingCount) for(o = 0, s = n.length; o < s; o++)n[o].fn = u;
                    delete this._events[t];
                } else "function" != typeof e ? console.warn("wrong listener type: " + typeof e) : !1 !== (e = this._listens(t, e, i)) && (i = n[e], this._firingCount && (i.fn = u, this._events[t] = n = n.slice()), n.splice(e, 1));
            }
        },
        fire: function(t, e, i) {
            if (this.listens(t, i)) {
                var n = l({}, e, {
                    type: t,
                    target: this,
                    sourceTarget: e && e.sourceTarget || this
                });
                if (this._events) {
                    var o = this._events[t];
                    if (o) {
                        this._firingCount = this._firingCount + 1 || 1;
                        for(var s = 0, r = o.length; s < r; s++){
                            var a = o[s], h = a.fn;
                            a.once && this.off(t, h, a.ctx), h.call(a.ctx || this, n);
                        }
                        this._firingCount--;
                    }
                }
                i && this._propagateEvent(n);
            }
            return this;
        },
        listens: function(t, e, i, n) {
            "string" != typeof t && console.warn('"string" type argument expected');
            var o = e, s = ("function" != typeof e && (n = !!e, i = o = void 0), this._events && this._events[t]);
            if (s && s.length && !1 !== this._listens(t, o, i)) return !0;
            if (n) {
                for(var r in this._eventParents)if (this._eventParents[r].listens(t, e, i, n)) return !0;
            }
            return !1;
        },
        _listens: function(t, e, i) {
            if (this._events) {
                var n = this._events[t] || [];
                if (!e) return !!n.length;
                i === this && (i = void 0);
                for(var o = 0, s = n.length; o < s; o++)if (n[o].fn === e && n[o].ctx === i) return o;
            }
            return !1;
        },
        once: function(t, e, i) {
            if ("object" == typeof t) for(var n in t)this._on(n, t[n], e, !0);
            else for(var o = 0, s = (t = F(t)).length; o < s; o++)this._on(t[o], e, i, !0);
            return this;
        },
        addEventParent: function(t) {
            return this._eventParents = this._eventParents || {}, this._eventParents[h(t)] = t, this;
        },
        removeEventParent: function(t) {
            return this._eventParents && delete this._eventParents[h(t)], this;
        },
        _propagateEvent: function(t) {
            for(var e in this._eventParents)this._eventParents[e].fire(t.type, l({
                layer: t.target,
                propagatedFrom: t.target
            }, t), !0);
        }
    }, it = (e.addEventListener = e.on, e.removeEventListener = e.clearAllEventListeners = e.off, e.addOneTimeEventListener = e.once, e.fireEvent = e.fire, e.hasEventListeners = e.listens, et.extend(e));
    function p(t, e, i) {
        this.x = i ? Math.round(t) : t, this.y = i ? Math.round(e) : e;
    }
    var nt = Math.trunc || function(t) {
        return 0 < t ? Math.floor(t) : Math.ceil(t);
    };
    function m(t, e, i) {
        return t instanceof p ? t : d(t) ? new p(t[0], t[1]) : null == t ? t : "object" == typeof t && "x" in t && "y" in t ? new p(t.x, t.y) : new p(t, e, i);
    }
    function f(t, e) {
        if (t) for(var i = e ? [
            t,
            e
        ] : t, n = 0, o = i.length; n < o; n++)this.extend(i[n]);
    }
    function _(t, e) {
        return !t || t instanceof f ? t : new f(t, e);
    }
    function s(t, e) {
        if (t) for(var i = e ? [
            t,
            e
        ] : t, n = 0, o = i.length; n < o; n++)this.extend(i[n]);
    }
    function g(t, e) {
        return t instanceof s ? t : new s(t, e);
    }
    function v(t, e, i) {
        if (isNaN(t) || isNaN(e)) throw new Error("Invalid LatLng object: (" + t + ", " + e + ")");
        this.lat = +t, this.lng = +e, void 0 !== i && (this.alt = +i);
    }
    function w(t, e, i) {
        return t instanceof v ? t : d(t) && "object" != typeof t[0] ? 3 === t.length ? new v(t[0], t[1], t[2]) : 2 === t.length ? new v(t[0], t[1]) : null : null == t ? t : "object" == typeof t && "lat" in t ? new v(t.lat, "lng" in t ? t.lng : t.lon, t.alt) : void 0 === e ? null : new v(t, e, i);
    }
    p.prototype = {
        clone: function() {
            return new p(this.x, this.y);
        },
        add: function(t) {
            return this.clone()._add(m(t));
        },
        _add: function(t) {
            return this.x += t.x, this.y += t.y, this;
        },
        subtract: function(t) {
            return this.clone()._subtract(m(t));
        },
        _subtract: function(t) {
            return this.x -= t.x, this.y -= t.y, this;
        },
        divideBy: function(t) {
            return this.clone()._divideBy(t);
        },
        _divideBy: function(t) {
            return this.x /= t, this.y /= t, this;
        },
        multiplyBy: function(t) {
            return this.clone()._multiplyBy(t);
        },
        _multiplyBy: function(t) {
            return this.x *= t, this.y *= t, this;
        },
        scaleBy: function(t) {
            return new p(this.x * t.x, this.y * t.y);
        },
        unscaleBy: function(t) {
            return new p(this.x / t.x, this.y / t.y);
        },
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        },
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
        },
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
        },
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            return this.x = nt(this.x), this.y = nt(this.y), this;
        },
        distanceTo: function(t) {
            var e = (t = m(t)).x - this.x, t = t.y - this.y;
            return Math.sqrt(e * e + t * t);
        },
        equals: function(t) {
            return (t = m(t)).x === this.x && t.y === this.y;
        },
        contains: function(t) {
            return t = m(t), Math.abs(t.x) <= Math.abs(this.x) && Math.abs(t.y) <= Math.abs(this.y);
        },
        toString: function() {
            return "Point(" + i(this.x) + ", " + i(this.y) + ")";
        }
    }, f.prototype = {
        extend: function(t) {
            var e, i;
            if (t) {
                if (t instanceof p || "number" == typeof t[0] || "x" in t) e = i = m(t);
                else if (e = (t = _(t)).min, i = t.max, !e || !i) return this;
                this.min || this.max ? (this.min.x = Math.min(e.x, this.min.x), this.max.x = Math.max(i.x, this.max.x), this.min.y = Math.min(e.y, this.min.y), this.max.y = Math.max(i.y, this.max.y)) : (this.min = e.clone(), this.max = i.clone());
            }
            return this;
        },
        getCenter: function(t) {
            return m((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, t);
        },
        getBottomLeft: function() {
            return m(this.min.x, this.max.y);
        },
        getTopRight: function() {
            return m(this.max.x, this.min.y);
        },
        getTopLeft: function() {
            return this.min;
        },
        getBottomRight: function() {
            return this.max;
        },
        getSize: function() {
            return this.max.subtract(this.min);
        },
        contains: function(t) {
            var e, i;
            return (t = ("number" == typeof t[0] || t instanceof p ? m : _)(t)) instanceof f ? (e = t.min, i = t.max) : e = i = t, e.x >= this.min.x && i.x <= this.max.x && e.y >= this.min.y && i.y <= this.max.y;
        },
        intersects: function(t) {
            t = _(t);
            var e = this.min, i = this.max, n = t.min, t = t.max, o = t.x >= e.x && n.x <= i.x, t = t.y >= e.y && n.y <= i.y;
            return o && t;
        },
        overlaps: function(t) {
            t = _(t);
            var e = this.min, i = this.max, n = t.min, t = t.max, o = t.x > e.x && n.x < i.x, t = t.y > e.y && n.y < i.y;
            return o && t;
        },
        isValid: function() {
            return !(!this.min || !this.max);
        },
        pad: function(t) {
            var e = this.min, i = this.max, n = Math.abs(e.x - i.x) * t, t = Math.abs(e.y - i.y) * t;
            return _(m(e.x - n, e.y - t), m(i.x + n, i.y + t));
        },
        equals: function(t) {
            return !!t && (t = _(t), this.min.equals(t.getTopLeft()) && this.max.equals(t.getBottomRight()));
        }
    }, s.prototype = {
        extend: function(t) {
            var e, i, n = this._southWest, o = this._northEast;
            if (t instanceof v) i = e = t;
            else {
                if (!(t instanceof s)) return t ? this.extend(w(t) || g(t)) : this;
                if (e = t._southWest, i = t._northEast, !e || !i) return this;
            }
            return n || o ? (n.lat = Math.min(e.lat, n.lat), n.lng = Math.min(e.lng, n.lng), o.lat = Math.max(i.lat, o.lat), o.lng = Math.max(i.lng, o.lng)) : (this._southWest = new v(e.lat, e.lng), this._northEast = new v(i.lat, i.lng)), this;
        },
        pad: function(t) {
            var e = this._southWest, i = this._northEast, n = Math.abs(e.lat - i.lat) * t, t = Math.abs(e.lng - i.lng) * t;
            return new s(new v(e.lat - n, e.lng - t), new v(i.lat + n, i.lng + t));
        },
        getCenter: function() {
            return new v((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        getSouthWest: function() {
            return this._southWest;
        },
        getNorthEast: function() {
            return this._northEast;
        },
        getNorthWest: function() {
            return new v(this.getNorth(), this.getWest());
        },
        getSouthEast: function() {
            return new v(this.getSouth(), this.getEast());
        },
        getWest: function() {
            return this._southWest.lng;
        },
        getSouth: function() {
            return this._southWest.lat;
        },
        getEast: function() {
            return this._northEast.lng;
        },
        getNorth: function() {
            return this._northEast.lat;
        },
        contains: function(t) {
            t = ("number" == typeof t[0] || t instanceof v || "lat" in t ? w : g)(t);
            var e, i, n = this._southWest, o = this._northEast;
            return t instanceof s ? (e = t.getSouthWest(), i = t.getNorthEast()) : e = i = t, e.lat >= n.lat && i.lat <= o.lat && e.lng >= n.lng && i.lng <= o.lng;
        },
        intersects: function(t) {
            t = g(t);
            var e = this._southWest, i = this._northEast, n = t.getSouthWest(), t = t.getNorthEast(), o = t.lat >= e.lat && n.lat <= i.lat, t = t.lng >= e.lng && n.lng <= i.lng;
            return o && t;
        },
        overlaps: function(t) {
            t = g(t);
            var e = this._southWest, i = this._northEast, n = t.getSouthWest(), t = t.getNorthEast(), o = t.lat > e.lat && n.lat < i.lat, t = t.lng > e.lng && n.lng < i.lng;
            return o && t;
        },
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        equals: function(t, e) {
            return !!t && (t = g(t), this._southWest.equals(t.getSouthWest(), e) && this._northEast.equals(t.getNorthEast(), e));
        },
        isValid: function() {
            return !(!this._southWest || !this._northEast);
        }
    };
    var ot = {
        latLngToPoint: function(t, e) {
            t = this.projection.project(t), e = this.scale(e);
            return this.transformation._transform(t, e);
        },
        pointToLatLng: function(t, e) {
            e = this.scale(e), t = this.transformation.untransform(t, e);
            return this.projection.unproject(t);
        },
        project: function(t) {
            return this.projection.project(t);
        },
        unproject: function(t) {
            return this.projection.unproject(t);
        },
        scale: function(t) {
            return 256 * Math.pow(2, t);
        },
        zoom: function(t) {
            return Math.log(t / 256) / Math.LN2;
        },
        getProjectedBounds: function(t) {
            var e;
            return this.infinite ? null : (e = this.projection.bounds, t = this.scale(t), new f(this.transformation.transform(e.min, t), this.transformation.transform(e.max, t)));
        },
        infinite: (v.prototype = {
            equals: function(t, e) {
                return !!t && (t = w(t), Math.max(Math.abs(this.lat - t.lat), Math.abs(this.lng - t.lng)) <= (void 0 === e ? 1e-9 : e));
            },
            toString: function(t) {
                return "LatLng(" + i(this.lat, t) + ", " + i(this.lng, t) + ")";
            },
            distanceTo: function(t) {
                return st.distance(this, w(t));
            },
            wrap: function() {
                return st.wrapLatLng(this);
            },
            toBounds: function(t) {
                var t = 180 * t / 40075017, e = t / Math.cos(Math.PI / 180 * this.lat);
                return g([
                    this.lat - t,
                    this.lng - e
                ], [
                    this.lat + t,
                    this.lng + e
                ]);
            },
            clone: function() {
                return new v(this.lat, this.lng, this.alt);
            }
        }, false),
        wrapLatLng: function(t) {
            var e = this.wrapLng ? H(t.lng, this.wrapLng, !0) : t.lng;
            return new v(this.wrapLat ? H(t.lat, this.wrapLat, !0) : t.lat, e, t.alt);
        },
        wrapLatLngBounds: function(t) {
            var e = t.getCenter(), i = this.wrapLatLng(e), n = e.lat - i.lat, e = e.lng - i.lng;
            return 0 == n && 0 == e ? t : (i = t.getSouthWest(), t = t.getNorthEast(), new s(new v(i.lat - n, i.lng - e), new v(t.lat - n, t.lng - e)));
        }
    }, st = l({}, ot, {
        wrapLng: [
            -180,
            180
        ],
        R: 6371e3,
        distance: function(t, e) {
            var i = Math.PI / 180, n = t.lat * i, o = e.lat * i, s = Math.sin((e.lat - t.lat) * i / 2), e = Math.sin((e.lng - t.lng) * i / 2), t = s * s + Math.cos(n) * Math.cos(o) * e * e, i = 2 * Math.atan2(Math.sqrt(t), Math.sqrt(1 - t));
            return this.R * i;
        }
    }), rt = 6378137, rt = {
        R: rt,
        MAX_LATITUDE: 85.0511287798,
        project: function(t) {
            var e = Math.PI / 180, i = this.MAX_LATITUDE, i = Math.max(Math.min(i, t.lat), -i), i = Math.sin(i * e);
            return new p(this.R * t.lng * e, this.R * Math.log((1 + i) / (1 - i)) / 2);
        },
        unproject: function(t) {
            var e = 180 / Math.PI;
            return new v((2 * Math.atan(Math.exp(t.y / this.R)) - Math.PI / 2) * e, t.x * e / this.R);
        },
        bounds: new f([
            -(rt = rt * Math.PI),
            -rt
        ], [
            rt,
            rt
        ])
    };
    function at(t, e, i, n) {
        d(t) ? (this._a = t[0], this._b = t[1], this._c = t[2], this._d = t[3]) : (this._a = t, this._b = e, this._c = i, this._d = n);
    }
    function ht(t, e, i, n) {
        return new at(t, e, i, n);
    }
    at.prototype = {
        transform: function(t, e) {
            return this._transform(t.clone(), e);
        },
        _transform: function(t, e) {
            return t.x = (e = e || 1) * (this._a * t.x + this._b), t.y = e * (this._c * t.y + this._d), t;
        },
        untransform: function(t, e) {
            return new p((t.x / (e = e || 1) - this._b) / this._a, (t.y / e - this._d) / this._c);
        }
    };
    var lt = l({}, st, {
        code: "EPSG:3857",
        projection: rt,
        transformation: ht(lt = .5 / (Math.PI * rt.R), .5, -lt, .5)
    }), ut = l({}, lt, {
        code: "EPSG:900913"
    });
    function ct(t) {
        return document.createElementNS("http://www.w3.org/2000/svg", t);
    }
    function dt(t, e) {
        for(var i, n, o, s, r = "", a = 0, h = t.length; a < h; a++){
            for(i = 0, n = (o = t[a]).length; i < n; i++)r += (i ? "L" : "M") + (s = o[i]).x + " " + s.y;
            r += e ? b.svg ? "z" : "x" : "";
        }
        return r || "M0 0";
    }
    var _t = document.documentElement.style, pt = "ActiveXObject" in window, mt = pt && !document.addEventListener, n = "msLaunchUri" in navigator && !("documentMode" in document), ft = y("webkit"), gt = y("android"), vt = y("android 2") || y("android 3"), yt = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), yt = gt && y("Google") && yt < 537 && !("AudioNode" in window), xt = !!window.opera, wt = !n && y("chrome"), bt = y("gecko") && !ft && !xt && !pt, Pt = !wt && y("safari"), Lt = y("phantom"), o = "OTransition" in _t, Tt = 0 === navigator.platform.indexOf("Win"), Mt = pt && "transition" in _t, zt = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix && !vt, _t = "MozPerspective" in _t, Ct = !window.L_DISABLE_3D && (Mt || zt || _t) && !o && !Lt, Zt = "undefined" != typeof orientation || y("mobile"), St = Zt && ft, Et = Zt && zt, kt = !window.PointerEvent && window.MSPointerEvent, Ot = !(!window.PointerEvent && !kt), At = "ontouchstart" in window || !!window.TouchEvent, Bt = !window.L_NO_TOUCH && (At || Ot), It = Zt && xt, Rt = Zt && bt, Nt = 1 < (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI), Dt = function() {
        var t = !1;
        try {
            var e = Object.defineProperty({}, "passive", {
                get: function() {
                    t = !0;
                }
            });
            window.addEventListener("testPassiveEventSupport", u, e), window.removeEventListener("testPassiveEventSupport", u, e);
        } catch (t) {}
        return t;
    }(), jt = !!document.createElement("canvas").getContext, Ht = !(!document.createElementNS || !ct("svg").createSVGRect), Wt = !!Ht && ((Wt = document.createElement("div")).innerHTML = "<svg/>", "http://www.w3.org/2000/svg" === (Wt.firstChild && Wt.firstChild.namespaceURI));
    function y(t) {
        return 0 <= navigator.userAgent.toLowerCase().indexOf(t);
    }
    var b = {
        ie: pt,
        ielt9: mt,
        edge: n,
        webkit: ft,
        android: gt,
        android23: vt,
        androidStock: yt,
        opera: xt,
        chrome: wt,
        gecko: bt,
        safari: Pt,
        phantom: Lt,
        opera12: o,
        win: Tt,
        ie3d: Mt,
        webkit3d: zt,
        gecko3d: _t,
        any3d: Ct,
        mobile: Zt,
        mobileWebkit: St,
        mobileWebkit3d: Et,
        msPointer: kt,
        pointer: Ot,
        touch: Bt,
        touchNative: At,
        mobileOpera: It,
        mobileGecko: Rt,
        retina: Nt,
        passiveEvents: Dt,
        canvas: jt,
        svg: Ht,
        vml: !Ht && function() {
            try {
                var t = document.createElement("div"), e = (t.innerHTML = '<v:shape adj="1"/>', t.firstChild);
                return e.style.behavior = "url(#default#VML)", e && "object" == typeof e.adj;
            } catch (t) {
                return !1;
            }
        }(),
        inlineSvg: Wt,
        mac: 0 === navigator.platform.indexOf("Mac"),
        linux: 0 === navigator.platform.indexOf("Linux")
    }, Ft = b.msPointer ? "MSPointerDown" : "pointerdown", Ut = b.msPointer ? "MSPointerMove" : "pointermove", Vt = b.msPointer ? "MSPointerUp" : "pointerup", qt = b.msPointer ? "MSPointerCancel" : "pointercancel", Gt = {
        touchstart: Ft,
        touchmove: Ut,
        touchend: Vt,
        touchcancel: qt
    }, Kt = {
        touchstart: function(t, e) {
            e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH && O(e);
            ee(t, e);
        },
        touchmove: ee,
        touchend: ee,
        touchcancel: ee
    }, Yt = {}, Xt = !1;
    function Jt(t, e, i) {
        return "touchstart" !== e || Xt || (document.addEventListener(Ft, $t, !0), document.addEventListener(Ut, Qt, !0), document.addEventListener(Vt, te, !0), document.addEventListener(qt, te, !0), Xt = !0), Kt[e] ? (i = Kt[e].bind(this, i), t.addEventListener(Gt[e], i, !1), i) : (console.warn("wrong event specified:", e), u);
    }
    function $t(t) {
        Yt[t.pointerId] = t;
    }
    function Qt(t) {
        Yt[t.pointerId] && (Yt[t.pointerId] = t);
    }
    function te(t) {
        delete Yt[t.pointerId];
    }
    function ee(t, e) {
        if (e.pointerType !== (e.MSPOINTER_TYPE_MOUSE || "mouse")) {
            for(var i in e.touches = [], Yt)e.touches.push(Yt[i]);
            e.changedTouches = [
                e
            ], t(e);
        }
    }
    var ie = 200;
    function ne(t, i) {
        t.addEventListener("dblclick", i);
        var n, o = 0;
        function e(t) {
            var e;
            1 !== t.detail ? n = t.detail : "mouse" === t.pointerType || t.sourceCapabilities && !t.sourceCapabilities.firesTouchEvents || (e = Ne(t)).some(function(t) {
                return t instanceof HTMLLabelElement && t.attributes.for;
            }) && !e.some(function(t) {
                return t instanceof HTMLInputElement || t instanceof HTMLSelectElement;
            }) || ((e = Date.now()) - o <= ie ? 2 === ++n && i(function(t) {
                var e, i, n = {};
                for(i in t)e = t[i], n[i] = e && e.bind ? e.bind(t) : e;
                return (t = n).type = "dblclick", n.detail = 2, n.isTrusted = !1, n._simulated = !0, n;
            }(t)) : n = 1, o = e);
        }
        return t.addEventListener("click", e), {
            dblclick: i,
            simDblclick: e
        };
    }
    var oe, se, re, ae, he, le, ue = we([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]), ce = we([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]), de = "webkitTransition" === ce || "OTransition" === ce ? ce + "End" : "transitionend";
    function _e(t) {
        return "string" == typeof t ? document.getElementById(t) : t;
    }
    function pe(t, e) {
        var i = t.style[e] || t.currentStyle && t.currentStyle[e];
        return "auto" === (i = i && "auto" !== i || !document.defaultView ? i : (t = document.defaultView.getComputedStyle(t, null)) ? t[e] : null) ? null : i;
    }
    function P(t, e, i) {
        t = document.createElement(t);
        return t.className = e || "", i && i.appendChild(t), t;
    }
    function T(t) {
        var e = t.parentNode;
        e && e.removeChild(t);
    }
    function me(t) {
        for(; t.firstChild;)t.removeChild(t.firstChild);
    }
    function fe(t) {
        var e = t.parentNode;
        e && e.lastChild !== t && e.appendChild(t);
    }
    function ge(t) {
        var e = t.parentNode;
        e && e.firstChild !== t && e.insertBefore(t, e.firstChild);
    }
    function ve(t, e) {
        return void 0 !== t.classList ? t.classList.contains(e) : 0 < (t = xe(t)).length && new RegExp("(^|\\s)" + e + "(\\s|$)").test(t);
    }
    function M(t, e) {
        var i;
        if (void 0 !== t.classList) for(var n = F(e), o = 0, s = n.length; o < s; o++)t.classList.add(n[o]);
        else ve(t, e) || ye(t, ((i = xe(t)) ? i + " " : "") + e);
    }
    function z(t, e) {
        void 0 !== t.classList ? t.classList.remove(e) : ye(t, W((" " + xe(t) + " ").replace(" " + e + " ", " ")));
    }
    function ye(t, e) {
        void 0 === t.className.baseVal ? t.className = e : t.className.baseVal = e;
    }
    function xe(t) {
        return void 0 === (t = t.correspondingElement ? t.correspondingElement : t).className.baseVal ? t.className : t.className.baseVal;
    }
    function C(t, e) {
        if ("opacity" in t.style) t.style.opacity = e;
        else if ("filter" in t.style) {
            var i = !1, n = "DXImageTransform.Microsoft.Alpha";
            try {
                i = t.filters.item(n);
            } catch (t) {
                if (1 === e) return;
            }
            e = Math.round(100 * e), i ? (i.Enabled = 100 !== e, i.Opacity = e) : t.style.filter += " progid:" + n + "(opacity=" + e + ")";
        }
    }
    function we(t) {
        for(var e = document.documentElement.style, i = 0; i < t.length; i++)if (t[i] in e) return t[i];
        return !1;
    }
    function be(t, e, i) {
        e = e || new p(0, 0);
        t.style[ue] = (b.ie3d ? "translate(" + e.x + "px," + e.y + "px)" : "translate3d(" + e.x + "px," + e.y + "px,0)") + (i ? " scale(" + i + ")" : "");
    }
    function Z(t, e) {
        t._leaflet_pos = e, b.any3d ? be(t, e) : (t.style.left = e.x + "px", t.style.top = e.y + "px");
    }
    function Pe(t) {
        return t._leaflet_pos || new p(0, 0);
    }
    function Le() {
        S(window, "dragstart", O);
    }
    function Te() {
        k(window, "dragstart", O);
    }
    function Me(t) {
        for(; -1 === t.tabIndex;)t = t.parentNode;
        t.style && (ze(), le = (he = t).style.outlineStyle, t.style.outlineStyle = "none", S(window, "keydown", ze));
    }
    function ze() {
        he && (he.style.outlineStyle = le, le = he = void 0, k(window, "keydown", ze));
    }
    function Ce(t) {
        for(; !((t = t.parentNode).offsetWidth && t.offsetHeight || t === document.body););
        return t;
    }
    function Ze(t) {
        var e = t.getBoundingClientRect();
        return {
            x: e.width / t.offsetWidth || 1,
            y: e.height / t.offsetHeight || 1,
            boundingClientRect: e
        };
    }
    ae = "onselectstart" in document ? (re = function() {
        S(window, "selectstart", O);
    }, function() {
        k(window, "selectstart", O);
    }) : (se = we([
        "userSelect",
        "WebkitUserSelect",
        "OUserSelect",
        "MozUserSelect",
        "msUserSelect"
    ]), re = function() {
        var t;
        se && (t = document.documentElement.style, oe = t[se], t[se] = "none");
    }, function() {
        se && (document.documentElement.style[se] = oe, oe = void 0);
    });
    pt = {
        __proto__: null,
        TRANSFORM: ue,
        TRANSITION: ce,
        TRANSITION_END: de,
        get: _e,
        getStyle: pe,
        create: P,
        remove: T,
        empty: me,
        toFront: fe,
        toBack: ge,
        hasClass: ve,
        addClass: M,
        removeClass: z,
        setClass: ye,
        getClass: xe,
        setOpacity: C,
        testProp: we,
        setTransform: be,
        setPosition: Z,
        getPosition: Pe,
        get disableTextSelection () {
            return re;
        },
        get enableTextSelection () {
            return ae;
        },
        disableImageDrag: Le,
        enableImageDrag: Te,
        preventOutline: Me,
        restoreOutline: ze,
        getSizedParentNode: Ce,
        getScale: Ze
    };
    function S(t, e, i, n) {
        if (e && "object" == typeof e) for(var o in e)ke(t, o, e[o], i);
        else for(var s = 0, r = (e = F(e)).length; s < r; s++)ke(t, e[s], i, n);
        return this;
    }
    var E = "_leaflet_events";
    function k(t, e, i, n) {
        if (1 === arguments.length) Se(t), delete t[E];
        else if (e && "object" == typeof e) for(var o in e)Oe(t, o, e[o], i);
        else if (e = F(e), 2 === arguments.length) Se(t, function(t) {
            return -1 !== G(e, t);
        });
        else for(var s = 0, r = e.length; s < r; s++)Oe(t, e[s], i, n);
        return this;
    }
    function Se(t, e) {
        for(var i in t[E]){
            var n = i.split(/\d/)[0];
            e && !e(n) || Oe(t, n, null, null, i);
        }
    }
    var Ee = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function ke(e, t, i, n) {
        var o, s, r = t + h(i) + (n ? "_" + h(n) : "");
        e[E] && e[E][r] || (s = o = function(t) {
            return i.call(n || e, t || window.event);
        }, !b.touchNative && b.pointer && 0 === t.indexOf("touch") ? o = Jt(e, t, o) : b.touch && "dblclick" === t ? o = ne(e, o) : "addEventListener" in e ? "touchstart" === t || "touchmove" === t || "wheel" === t || "mousewheel" === t ? e.addEventListener(Ee[t] || t, o, !!b.passiveEvents && {
            passive: !1
        }) : "mouseenter" === t || "mouseleave" === t ? e.addEventListener(Ee[t], o = function(t) {
            t = t || window.event, We(e, t) && s(t);
        }, !1) : e.addEventListener(t, s, !1) : e.attachEvent("on" + t, o), e[E] = e[E] || {}, e[E][r] = o);
    }
    function Oe(t, e, i, n, o) {
        o = o || e + h(i) + (n ? "_" + h(n) : "");
        var s, r, i = t[E] && t[E][o];
        i && (!b.touchNative && b.pointer && 0 === e.indexOf("touch") ? (n = t, r = i, Gt[s = e] ? n.removeEventListener(Gt[s], r, !1) : console.warn("wrong event specified:", s)) : b.touch && "dblclick" === e ? (n = i, (r = t).removeEventListener("dblclick", n.dblclick), r.removeEventListener("click", n.simDblclick)) : "removeEventListener" in t ? t.removeEventListener(Ee[e] || e, i, !1) : t.detachEvent("on" + e, i), t[E][o] = null);
    }
    function Ae(t) {
        return t.stopPropagation ? t.stopPropagation() : t.originalEvent ? t.originalEvent._stopped = !0 : t.cancelBubble = !0, this;
    }
    function Be(t) {
        return ke(t, "wheel", Ae), this;
    }
    function Ie(t) {
        return S(t, "mousedown touchstart dblclick contextmenu", Ae), t._leaflet_disable_click = !0, this;
    }
    function O(t) {
        return t.preventDefault ? t.preventDefault() : t.returnValue = !1, this;
    }
    function Re(t) {
        return O(t), Ae(t), this;
    }
    function Ne(t) {
        if (t.composedPath) return t.composedPath();
        for(var e = [], i = t.target; i;)e.push(i), i = i.parentNode;
        return e;
    }
    function De(t, e) {
        var i, n;
        return e ? (n = (i = Ze(e)).boundingClientRect, new p((t.clientX - n.left) / i.x - e.clientLeft, (t.clientY - n.top) / i.y - e.clientTop)) : new p(t.clientX, t.clientY);
    }
    var je = b.linux && b.chrome ? window.devicePixelRatio : b.mac ? 3 * window.devicePixelRatio : 0 < window.devicePixelRatio ? 2 * window.devicePixelRatio : 1;
    function He(t) {
        return b.edge ? t.wheelDeltaY / 2 : t.deltaY && 0 === t.deltaMode ? -t.deltaY / je : t.deltaY && 1 === t.deltaMode ? 20 * -t.deltaY : t.deltaY && 2 === t.deltaMode ? 60 * -t.deltaY : t.deltaX || t.deltaZ ? 0 : t.wheelDelta ? (t.wheelDeltaY || t.wheelDelta) / 2 : t.detail && Math.abs(t.detail) < 32765 ? 20 * -t.detail : t.detail ? t.detail / -32765 * 60 : 0;
    }
    function We(t, e) {
        var i = e.relatedTarget;
        if (!i) return !0;
        try {
            for(; i && i !== t;)i = i.parentNode;
        } catch (t) {
            return !1;
        }
        return i !== t;
    }
    var mt = {
        __proto__: null,
        on: S,
        off: k,
        stopPropagation: Ae,
        disableScrollPropagation: Be,
        disableClickPropagation: Ie,
        preventDefault: O,
        stop: Re,
        getPropagationPath: Ne,
        getMousePosition: De,
        getWheelDelta: He,
        isExternalTarget: We,
        addListener: S,
        removeListener: k
    }, Fe = it.extend({
        run: function(t, e, i, n) {
            this.stop(), this._el = t, this._inProgress = !0, this._duration = i || .25, this._easeOutPower = 1 / Math.max(n || .5, .2), this._startPos = Pe(t), this._offset = e.subtract(this._startPos), this._startTime = +new Date, this.fire("start"), this._animate();
        },
        stop: function() {
            this._inProgress && (this._step(!0), this._complete());
        },
        _animate: function() {
            this._animId = x(this._animate, this), this._step();
        },
        _step: function(t) {
            var e = +new Date - this._startTime, i = 1e3 * this._duration;
            e < i ? this._runFrame(this._easeOut(e / i), t) : (this._runFrame(1), this._complete());
        },
        _runFrame: function(t, e) {
            t = this._startPos.add(this._offset.multiplyBy(t));
            e && t._round(), Z(this._el, t), this.fire("step");
        },
        _complete: function() {
            r(this._animId), this._inProgress = !1, this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    }), A = it.extend({
        options: {
            crs: lt,
            center: void 0,
            zoom: void 0,
            minZoom: void 0,
            maxZoom: void 0,
            layers: [],
            maxBounds: void 0,
            renderer: void 0,
            zoomAnimation: !0,
            zoomAnimationThreshold: 4,
            fadeAnimation: !0,
            markerZoomAnimation: !0,
            transform3DLimit: 8388608,
            zoomSnap: 1,
            zoomDelta: 1,
            trackResize: !0
        },
        initialize: function(t, e) {
            e = c(this, e), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(t), this._initLayout(), this._onResize = a(this._onResize, this), this._initEvents(), e.maxBounds && this.setMaxBounds(e.maxBounds), void 0 !== e.zoom && (this._zoom = this._limitZoom(e.zoom)), e.center && void 0 !== e.zoom && this.setView(w(e.center), e.zoom, {
                reset: !0
            }), this.callInitHooks(), this._zoomAnimated = ce && b.any3d && !b.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), S(this._proxy, de, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
        },
        setView: function(t, e, i) {
            if ((e = void 0 === e ? this._zoom : this._limitZoom(e), t = this._limitCenter(w(t), e, this.options.maxBounds), i = i || {}, this._stop(), this._loaded && !i.reset && !0 !== i) && (void 0 !== i.animate && (i.zoom = l({
                animate: i.animate
            }, i.zoom), i.pan = l({
                animate: i.animate,
                duration: i.duration
            }, i.pan)), this._zoom !== e ? this._tryAnimatedZoom && this._tryAnimatedZoom(t, e, i.zoom) : this._tryAnimatedPan(t, i.pan))) return clearTimeout(this._sizeTimer), this;
            return this._resetView(t, e, i.pan && i.pan.noMoveStart), this;
        },
        setZoom: function(t, e) {
            return this._loaded ? this.setView(this.getCenter(), t, {
                zoom: e
            }) : (this._zoom = t, this);
        },
        zoomIn: function(t, e) {
            return t = t || (b.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + t, e);
        },
        zoomOut: function(t, e) {
            return t = t || (b.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - t, e);
        },
        setZoomAround: function(t, e, i) {
            var n = this.getZoomScale(e), o = this.getSize().divideBy(2), t = (t instanceof p ? t : this.latLngToContainerPoint(t)).subtract(o).multiplyBy(1 - 1 / n), n = this.containerPointToLatLng(o.add(t));
            return this.setView(n, e, {
                zoom: i
            });
        },
        _getBoundsCenterZoom: function(t, e) {
            e = e || {}, t = t.getBounds ? t.getBounds() : g(t);
            var i = m(e.paddingTopLeft || e.padding || [
                0,
                0
            ]), n = m(e.paddingBottomRight || e.padding || [
                0,
                0
            ]), o = this.getBoundsZoom(t, !1, i.add(n));
            return (o = "number" == typeof e.maxZoom ? Math.min(e.maxZoom, o) : o) === 1 / 0 ? {
                center: t.getCenter(),
                zoom: o
            } : (e = n.subtract(i).divideBy(2), n = this.project(t.getSouthWest(), o), i = this.project(t.getNorthEast(), o), {
                center: this.unproject(n.add(i).divideBy(2).add(e), o),
                zoom: o
            });
        },
        fitBounds: function(t, e) {
            if ((t = g(t)).isValid()) return t = this._getBoundsCenterZoom(t, e), this.setView(t.center, t.zoom, e);
            throw new Error("Bounds are not valid.");
        },
        fitWorld: function(t) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], t);
        },
        panTo: function(t, e) {
            return this.setView(t, this._zoom, {
                pan: e
            });
        },
        panBy: function(t, e) {
            var i;
            return e = e || {}, (t = m(t).round()).x || t.y ? (!0 === e.animate || this.getSize().contains(t) ? (this._panAnim || (this._panAnim = new Fe, this._panAnim.on({
                step: this._onPanTransitionStep,
                end: this._onPanTransitionEnd
            }, this)), e.noMoveStart || this.fire("movestart"), !1 !== e.animate ? (M(this._mapPane, "leaflet-pan-anim"), i = this._getMapPanePos().subtract(t).round(), this._panAnim.run(this._mapPane, i, e.duration || .25, e.easeLinearity)) : (this._rawPanBy(t), this.fire("move").fire("moveend"))) : this._resetView(this.unproject(this.project(this.getCenter()).add(t)), this.getZoom()), this) : this.fire("moveend");
        },
        flyTo: function(n, o, t) {
            if (!1 === (t = t || {}).animate || !b.any3d) return this.setView(n, o, t);
            this._stop();
            var s = this.project(this.getCenter()), r = this.project(n), e = this.getSize(), a = this._zoom, h = (n = w(n), o = void 0 === o ? a : o, Math.max(e.x, e.y)), i = h * this.getZoomScale(a, o), l = r.distanceTo(s) || 1, u = 1.42, c = u * u;
            function d(t) {
                t = (i * i - h * h + (t ? -1 : 1) * c * c * l * l) / (2 * (t ? i : h) * c * l), t = Math.sqrt(t * t + 1) - t;
                return t < 1e-9 ? -18 : Math.log(t);
            }
            function _(t) {
                return (Math.exp(t) - Math.exp(-t)) / 2;
            }
            function p(t) {
                return (Math.exp(t) + Math.exp(-t)) / 2;
            }
            var m = d(0);
            function f(t) {
                return h * (p(m) * (_(t = m + u * t) / p(t)) - _(m)) / c;
            }
            var g = Date.now(), v = (d(1) - m) / u, y = t.duration ? 1e3 * t.duration : 1e3 * v * .8;
            return this._moveStart(!0, t.noMoveStart), (function t() {
                var e = (Date.now() - g) / y, i = (1 - Math.pow(1 - e, 1.5)) * v;
                e <= 1 ? (this._flyToFrame = x(t, this), this._move(this.unproject(s.add(r.subtract(s).multiplyBy(f(i) / l)), a), this.getScaleZoom(h / (e = i, h * (p(m) / p(m + u * e))), a), {
                    flyTo: !0
                })) : this._move(n, o)._moveEnd(!0);
            }).call(this), this;
        },
        flyToBounds: function(t, e) {
            t = this._getBoundsCenterZoom(t, e);
            return this.flyTo(t.center, t.zoom, e);
        },
        setMaxBounds: function(t) {
            return t = g(t), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), t.isValid() ? (this.options.maxBounds = t, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
        },
        setMinZoom: function(t) {
            var e = this.options.minZoom;
            return this.options.minZoom = t, this._loaded && e !== t && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(t) : this;
        },
        setMaxZoom: function(t) {
            var e = this.options.maxZoom;
            return this.options.maxZoom = t, this._loaded && e !== t && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(t) : this;
        },
        panInsideBounds: function(t, e) {
            this._enforcingBounds = !0;
            var i = this.getCenter(), t = this._limitCenter(i, this._zoom, g(t));
            return i.equals(t) || this.panTo(t, e), this._enforcingBounds = !1, this;
        },
        panInside: function(t, e) {
            var i = m((e = e || {}).paddingTopLeft || e.padding || [
                0,
                0
            ]), n = m(e.paddingBottomRight || e.padding || [
                0,
                0
            ]), o = this.project(this.getCenter()), t = this.project(t), s = this.getPixelBounds(), i = _([
                s.min.add(i),
                s.max.subtract(n)
            ]), s = i.getSize();
            return i.contains(t) || (this._enforcingBounds = !0, n = t.subtract(i.getCenter()), i = i.extend(t).getSize().subtract(s), o.x += n.x < 0 ? -i.x : i.x, o.y += n.y < 0 ? -i.y : i.y, this.panTo(this.unproject(o), e), this._enforcingBounds = !1), this;
        },
        invalidateSize: function(t) {
            if (!this._loaded) return this;
            t = l({
                animate: !1,
                pan: !0
            }, !0 === t ? {
                animate: !0
            } : t);
            var e = this.getSize(), i = (this._sizeChanged = !0, this._lastCenter = null, this.getSize()), n = e.divideBy(2).round(), o = i.divideBy(2).round(), n = n.subtract(o);
            return n.x || n.y ? (t.animate && t.pan ? this.panBy(n) : (t.pan && this._rawPanBy(n), this.fire("move"), t.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(a(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
                oldSize: e,
                newSize: i
            })) : this;
        },
        stop: function() {
            return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
        },
        locate: function(t) {
            var e, i;
            return t = this._locateOptions = l({
                timeout: 1e4,
                watch: !1
            }, t), "geolocation" in navigator ? (e = a(this._handleGeolocationResponse, this), i = a(this._handleGeolocationError, this), t.watch ? this._locationWatchId = navigator.geolocation.watchPosition(e, i, t) : navigator.geolocation.getCurrentPosition(e, i, t)) : this._handleGeolocationError({
                code: 0,
                message: "Geolocation not supported."
            }), this;
        },
        stopLocate: function() {
            return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
        },
        _handleGeolocationError: function(t) {
            var e;
            this._container._leaflet_id && (e = t.code, t = t.message || (1 === e ? "permission denied" : 2 === e ? "position unavailable" : "timeout"), this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
                code: e,
                message: "Geolocation error: " + t + "."
            }));
        },
        _handleGeolocationResponse: function(t) {
            if (this._container._leaflet_id) {
                var e, i, n = new v(t.coords.latitude, t.coords.longitude), o = n.toBounds(2 * t.coords.accuracy), s = this._locateOptions, r = (s.setView && (e = this.getBoundsZoom(o), this.setView(n, s.maxZoom ? Math.min(e, s.maxZoom) : e)), {
                    latlng: n,
                    bounds: o,
                    timestamp: t.timestamp
                });
                for(i in t.coords)"number" == typeof t.coords[i] && (r[i] = t.coords[i]);
                this.fire("locationfound", r);
            }
        },
        addHandler: function(t, e) {
            return e && (e = this[t] = new e(this), this._handlers.push(e), this.options[t] && e.enable()), this;
        },
        remove: function() {
            if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                delete this._container._leaflet_id, delete this._containerId;
            } catch (t) {
                this._container._leaflet_id = void 0, this._containerId = void 0;
            }
            for(var t1 in void 0 !== this._locationWatchId && this.stopLocate(), this._stop(), T(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (r(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload"), this._layers)this._layers[t1].remove();
            for(t in this._panes)T(this._panes[t]);
            return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
        },
        createPane: function(t, e) {
            e = P("div", "leaflet-pane" + (t ? " leaflet-" + t.replace("Pane", "") + "-pane" : ""), e || this._mapPane);
            return t && (this._panes[t] = e), e;
        },
        getCenter: function() {
            return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        getZoom: function() {
            return this._zoom;
        },
        getBounds: function() {
            var t = this.getPixelBounds();
            return new s(this.unproject(t.getBottomLeft()), this.unproject(t.getTopRight()));
        },
        getMinZoom: function() {
            return void 0 === this.options.minZoom ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        getMaxZoom: function() {
            return void 0 === this.options.maxZoom ? void 0 === this._layersMaxZoom ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
        },
        getBoundsZoom: function(t, e, i) {
            t = g(t), i = m(i || [
                0,
                0
            ]);
            var n = this.getZoom() || 0, o = this.getMinZoom(), s = this.getMaxZoom(), r = t.getNorthWest(), t = t.getSouthEast(), i = this.getSize().subtract(i), t = _(this.project(t, n), this.project(r, n)).getSize(), r = b.any3d ? this.options.zoomSnap : 1, a = i.x / t.x, i = i.y / t.y, t = e ? Math.max(a, i) : Math.min(a, i), n = this.getScaleZoom(t, n);
            return r && (n = Math.round(n / (r / 100)) * (r / 100), n = e ? Math.ceil(n / r) * r : Math.floor(n / r) * r), Math.max(o, Math.min(s, n));
        },
        getSize: function() {
            return this._size && !this._sizeChanged || (this._size = new p(this._container.clientWidth || 0, this._container.clientHeight || 0), this._sizeChanged = !1), this._size.clone();
        },
        getPixelBounds: function(t, e) {
            t = this._getTopLeftPoint(t, e);
            return new f(t, t.add(this.getSize()));
        },
        getPixelOrigin: function() {
            return this._checkIfLoaded(), this._pixelOrigin;
        },
        getPixelWorldBounds: function(t) {
            return this.options.crs.getProjectedBounds(void 0 === t ? this.getZoom() : t);
        },
        getPane: function(t) {
            return "string" == typeof t ? this._panes[t] : t;
        },
        getPanes: function() {
            return this._panes;
        },
        getContainer: function() {
            return this._container;
        },
        getZoomScale: function(t, e) {
            var i = this.options.crs;
            return e = void 0 === e ? this._zoom : e, i.scale(t) / i.scale(e);
        },
        getScaleZoom: function(t, e) {
            var i = this.options.crs, t = (e = void 0 === e ? this._zoom : e, i.zoom(t * i.scale(e)));
            return isNaN(t) ? 1 / 0 : t;
        },
        project: function(t, e) {
            return e = void 0 === e ? this._zoom : e, this.options.crs.latLngToPoint(w(t), e);
        },
        unproject: function(t, e) {
            return e = void 0 === e ? this._zoom : e, this.options.crs.pointToLatLng(m(t), e);
        },
        layerPointToLatLng: function(t) {
            t = m(t).add(this.getPixelOrigin());
            return this.unproject(t);
        },
        latLngToLayerPoint: function(t) {
            return this.project(w(t))._round()._subtract(this.getPixelOrigin());
        },
        wrapLatLng: function(t) {
            return this.options.crs.wrapLatLng(w(t));
        },
        wrapLatLngBounds: function(t) {
            return this.options.crs.wrapLatLngBounds(g(t));
        },
        distance: function(t, e) {
            return this.options.crs.distance(w(t), w(e));
        },
        containerPointToLayerPoint: function(t) {
            return m(t).subtract(this._getMapPanePos());
        },
        layerPointToContainerPoint: function(t) {
            return m(t).add(this._getMapPanePos());
        },
        containerPointToLatLng: function(t) {
            t = this.containerPointToLayerPoint(m(t));
            return this.layerPointToLatLng(t);
        },
        latLngToContainerPoint: function(t) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(w(t)));
        },
        mouseEventToContainerPoint: function(t) {
            return De(t, this._container);
        },
        mouseEventToLayerPoint: function(t) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t));
        },
        mouseEventToLatLng: function(t) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(t));
        },
        _initContainer: function(t) {
            t = this._container = _e(t);
            if (!t) throw new Error("Map container not found.");
            if (t._leaflet_id) throw new Error("Map container is already initialized.");
            S(t, "scroll", this._onScroll, this), this._containerId = h(t);
        },
        _initLayout: function() {
            var t = this._container, e = (this._fadeAnimated = this.options.fadeAnimation && b.any3d, M(t, "leaflet-container" + (b.touch ? " leaflet-touch" : "") + (b.retina ? " leaflet-retina" : "") + (b.ielt9 ? " leaflet-oldie" : "") + (b.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : "")), pe(t, "position"));
            "absolute" !== e && "relative" !== e && "fixed" !== e && "sticky" !== e && (t.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
        },
        _initPanes: function() {
            var t = this._panes = {};
            this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), Z(this._mapPane, new p(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (M(t.markerPane, "leaflet-zoom-hide"), M(t.shadowPane, "leaflet-zoom-hide"));
        },
        _resetView: function(t, e, i) {
            Z(this._mapPane, new p(0, 0));
            var n = !this._loaded, o = (this._loaded = !0, e = this._limitZoom(e), this.fire("viewprereset"), this._zoom !== e);
            this._moveStart(o, i)._move(t, e)._moveEnd(o), this.fire("viewreset"), n && this.fire("load");
        },
        _moveStart: function(t, e) {
            return t && this.fire("zoomstart"), e || this.fire("movestart"), this;
        },
        _move: function(t, e, i, n) {
            void 0 === e && (e = this._zoom);
            var o = this._zoom !== e;
            return this._zoom = e, this._lastCenter = t, this._pixelOrigin = this._getNewPixelOrigin(t), n ? i && i.pinch && this.fire("zoom", i) : ((o || i && i.pinch) && this.fire("zoom", i), this.fire("move", i)), this;
        },
        _moveEnd: function(t) {
            return t && this.fire("zoomend"), this.fire("moveend");
        },
        _stop: function() {
            return r(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
        },
        _rawPanBy: function(t) {
            Z(this._mapPane, this._getMapPanePos().subtract(t));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        _initEvents: function(t) {
            this._targets = {};
            var e = t ? k : S;
            e((this._targets[h(this._container)] = this)._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && e(window, "resize", this._onResize, this), b.any3d && this.options.transform3DLimit && (t ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            r(this._resizeRequest), this._resizeRequest = x(function() {
                this.invalidateSize({
                    debounceMoveend: !0
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0, this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var t = this._getMapPanePos();
            Math.max(Math.abs(t.x), Math.abs(t.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(t, e) {
            for(var i, n = [], o = "mouseout" === e || "mouseover" === e, s = t.target || t.srcElement, r = !1; s;){
                if ((i = this._targets[h(s)]) && ("click" === e || "preclick" === e) && this._draggableMoved(i)) {
                    r = !0;
                    break;
                }
                if (i && i.listens(e, !0)) {
                    if (o && !We(s, t)) break;
                    if (n.push(i), o) break;
                }
                if (s === this._container) break;
                s = s.parentNode;
            }
            return n = n.length || r || o || !this.listens(e, !0) ? n : [
                this
            ];
        },
        _isClickDisabled: function(t) {
            for(; t && t !== this._container;){
                if (t._leaflet_disable_click) return !0;
                t = t.parentNode;
            }
        },
        _handleDOMEvent: function(t) {
            var e, i = t.target || t.srcElement;
            !this._loaded || i._leaflet_disable_events || "click" === t.type && this._isClickDisabled(i) || ("mousedown" === (e = t.type) && Me(i), this._fireDOMEvent(t, e));
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(t, e, i) {
            "click" === t.type && ((a = l({}, t)).type = "preclick", this._fireDOMEvent(a, a.type, i));
            var n = this._findEventTargets(t, e);
            if (i) {
                for(var o = [], s = 0; s < i.length; s++)i[s].listens(e, !0) && o.push(i[s]);
                n = o.concat(n);
            }
            if (n.length) {
                "contextmenu" === e && O(t);
                var r, a = n[0], h = {
                    originalEvent: t
                };
                for("keypress" !== t.type && "keydown" !== t.type && "keyup" !== t.type && (r = a.getLatLng && (!a._radius || a._radius <= 10), h.containerPoint = r ? this.latLngToContainerPoint(a.getLatLng()) : this.mouseEventToContainerPoint(t), h.layerPoint = this.containerPointToLayerPoint(h.containerPoint), h.latlng = r ? a.getLatLng() : this.layerPointToLatLng(h.layerPoint)), s = 0; s < n.length; s++)if (n[s].fire(e, h, !0), h.originalEvent._stopped || !1 === n[s].options.bubblingMouseEvents && -1 !== G(this._mouseEvents, e)) return;
            }
        },
        _draggableMoved: function(t) {
            return (t = t.dragging && t.dragging.enabled() ? t : this).dragging && t.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var t = 0, e = this._handlers.length; t < e; t++)this._handlers[t].disable();
        },
        whenReady: function(t, e) {
            return this._loaded ? t.call(e || this, {
                target: this
            }) : this.on("load", t, e), this;
        },
        _getMapPanePos: function() {
            return Pe(this._mapPane) || new p(0, 0);
        },
        _moved: function() {
            var t = this._getMapPanePos();
            return t && !t.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(t, e) {
            return (t && void 0 !== e ? this._getNewPixelOrigin(t, e) : this.getPixelOrigin()).subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(t, e) {
            var i = this.getSize()._divideBy(2);
            return this.project(t, e)._subtract(i)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(t, e, i) {
            i = this._getNewPixelOrigin(i, e);
            return this.project(t, e)._subtract(i);
        },
        _latLngBoundsToNewLayerBounds: function(t, e, i) {
            i = this._getNewPixelOrigin(i, e);
            return _([
                this.project(t.getSouthWest(), e)._subtract(i),
                this.project(t.getNorthWest(), e)._subtract(i),
                this.project(t.getSouthEast(), e)._subtract(i),
                this.project(t.getNorthEast(), e)._subtract(i)
            ]);
        },
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        _getCenterOffset: function(t) {
            return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint());
        },
        _limitCenter: function(t, e, i) {
            var n, o;
            return !i || (n = this.project(t, e), o = this.getSize().divideBy(2), o = new f(n.subtract(o), n.add(o)), o = this._getBoundsOffset(o, i, e), Math.abs(o.x) <= 1 && Math.abs(o.y) <= 1) ? t : this.unproject(n.add(o), e);
        },
        _limitOffset: function(t, e) {
            var i;
            return e ? (i = new f((i = this.getPixelBounds()).min.add(t), i.max.add(t)), t.add(this._getBoundsOffset(i, e))) : t;
        },
        _getBoundsOffset: function(t, e, i) {
            e = _(this.project(e.getNorthEast(), i), this.project(e.getSouthWest(), i)), i = e.min.subtract(t.min), e = e.max.subtract(t.max);
            return new p(this._rebound(i.x, -e.x), this._rebound(i.y, -e.y));
        },
        _rebound: function(t, e) {
            return 0 < t + e ? Math.round(t - e) / 2 : Math.max(0, Math.ceil(t)) - Math.max(0, Math.floor(e));
        },
        _limitZoom: function(t) {
            var e = this.getMinZoom(), i = this.getMaxZoom(), n = b.any3d ? this.options.zoomSnap : 1;
            return n && (t = Math.round(t / n) * n), Math.max(e, Math.min(i, t));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            z(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
        },
        _tryAnimatedPan: function(t, e) {
            t = this._getCenterOffset(t)._trunc();
            return !(!0 !== (e && e.animate) && !this.getSize().contains(t)) && (this.panBy(t, e), !0);
        },
        _createAnimProxy: function() {
            var t = this._proxy = P("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(t), this.on("zoomanim", function(t) {
                var e = ue, i = this._proxy.style[e];
                be(this._proxy, this.project(t.center, t.zoom), this.getZoomScale(t.zoom, 1)), i === this._proxy.style[e] && this._animatingZoom && this._onZoomTransitionEnd();
            }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            T(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
        },
        _animMoveEnd: function() {
            var t = this.getCenter(), e = this.getZoom();
            be(this._proxy, this.project(t, e), this.getZoomScale(e, 1));
        },
        _catchTransitionEnd: function(t) {
            this._animatingZoom && 0 <= t.propertyName.indexOf("transform") && this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(t, e, i) {
            if (!this._animatingZoom) {
                if (i = i || {}, !this._zoomAnimated || !1 === i.animate || this._nothingToAnimate() || Math.abs(e - this._zoom) > this.options.zoomAnimationThreshold) return !1;
                var n = this.getZoomScale(e), n = this._getCenterOffset(t)._divideBy(1 - 1 / n);
                if (!0 !== i.animate && !this.getSize().contains(n)) return !1;
                x(function() {
                    this._moveStart(!0, i.noMoveStart || !1)._animateZoom(t, e, !0);
                }, this);
            }
            return !0;
        },
        _animateZoom: function(t, e, i, n) {
            this._mapPane && (i && (this._animatingZoom = !0, this._animateToCenter = t, this._animateToZoom = e, M(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
                center: t,
                zoom: e,
                noUpdate: n
            }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(a(this._onZoomTransitionEnd, this), 250));
        },
        _onZoomTransitionEnd: function() {
            this._animatingZoom && (this._mapPane && z(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
        }
    });
    function Ue(t) {
        return new B(t);
    }
    var B = et.extend({
        options: {
            position: "topright"
        },
        initialize: function(t) {
            c(this, t);
        },
        getPosition: function() {
            return this.options.position;
        },
        setPosition: function(t) {
            var e = this._map;
            return e && e.removeControl(this), this.options.position = t, e && e.addControl(this), this;
        },
        getContainer: function() {
            return this._container;
        },
        addTo: function(t) {
            this.remove(), this._map = t;
            var e = this._container = this.onAdd(t), i = this.getPosition(), t = t._controlCorners[i];
            return M(e, "leaflet-control"), -1 !== i.indexOf("bottom") ? t.insertBefore(e, t.firstChild) : t.appendChild(e), this._map.on("unload", this.remove, this), this;
        },
        remove: function() {
            return this._map && (T(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null), this;
        },
        _refocusOnMap: function(t) {
            this._map && t && 0 < t.screenX && 0 < t.screenY && this._map.getContainer().focus();
        }
    }), Ve = (A.include({
        addControl: function(t) {
            return t.addTo(this), this;
        },
        removeControl: function(t) {
            return t.remove(), this;
        },
        _initControlPos: function() {
            var i = this._controlCorners = {}, n = "leaflet-", o = this._controlContainer = P("div", n + "control-container", this._container);
            function t(t, e) {
                i[t + e] = P("div", n + t + " " + n + e, o);
            }
            t("top", "left"), t("top", "right"), t("bottom", "left"), t("bottom", "right");
        },
        _clearControlPos: function() {
            for(var t in this._controlCorners)T(this._controlCorners[t]);
            T(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
        }
    }), B.extend({
        options: {
            collapsed: !0,
            position: "topright",
            autoZIndex: !0,
            hideSingleBase: !1,
            sortLayers: !1,
            sortFunction: function(t, e, i, n) {
                return i < n ? -1 : n < i ? 1 : 0;
            }
        },
        initialize: function(t, e, i) {
            for(var n in c(this, i), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1, t)this._addLayer(t[n], n);
            for(n in e)this._addLayer(e[n], n, !0);
        },
        onAdd: function(t) {
            this._initLayout(), this._update(), (this._map = t).on("zoomend", this._checkDisabledLayers, this);
            for(var e = 0; e < this._layers.length; e++)this._layers[e].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(t) {
            return B.prototype.addTo.call(this, t), this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var t = 0; t < this._layers.length; t++)this._layers[t].layer.off("add remove", this._onLayerChange, this);
        },
        addBaseLayer: function(t, e) {
            return this._addLayer(t, e), this._map ? this._update() : this;
        },
        addOverlay: function(t, e) {
            return this._addLayer(t, e, !0), this._map ? this._update() : this;
        },
        removeLayer: function(t) {
            t.off("add remove", this._onLayerChange, this);
            t = this._getLayer(h(t));
            return t && this._layers.splice(this._layers.indexOf(t), 1), this._map ? this._update() : this;
        },
        expand: function() {
            M(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
            var t = this._map.getSize().y - (this._container.offsetTop + 50);
            return t < this._section.clientHeight ? (M(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = t + "px") : z(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
        },
        collapse: function() {
            return z(this._container, "leaflet-control-layers-expanded"), this;
        },
        _initLayout: function() {
            var t = "leaflet-control-layers", e = this._container = P("div", t), i = this.options.collapsed, n = (e.setAttribute("aria-haspopup", !0), Ie(e), Be(e), this._section = P("section", t + "-list")), o = (i && (this._map.on("click", this.collapse, this), S(e, {
                mouseenter: this._expandSafely,
                mouseleave: this.collapse
            }, this)), this._layersLink = P("a", t + "-toggle", e));
            o.href = "#", o.title = "Layers", o.setAttribute("role", "button"), S(o, {
                keydown: function(t) {
                    13 === t.keyCode && this._expandSafely();
                },
                click: function(t) {
                    O(t), this._expandSafely();
                }
            }, this), i || this.expand(), this._baseLayersList = P("div", t + "-base", n), this._separator = P("div", t + "-separator", n), this._overlaysList = P("div", t + "-overlays", n), e.appendChild(n);
        },
        _getLayer: function(t) {
            for(var e = 0; e < this._layers.length; e++)if (this._layers[e] && h(this._layers[e].layer) === t) return this._layers[e];
        },
        _addLayer: function(t, e, i) {
            this._map && t.on("add remove", this._onLayerChange, this), this._layers.push({
                layer: t,
                name: e,
                overlay: i
            }), this.options.sortLayers && this._layers.sort(a(function(t, e) {
                return this.options.sortFunction(t.layer, e.layer, t.name, e.name);
            }, this)), this.options.autoZIndex && t.setZIndex && (this._lastZIndex++, t.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
        },
        _update: function() {
            if (this._container) {
                me(this._baseLayersList), me(this._overlaysList), this._layerControlInputs = [];
                for(var t, e, i, n = 0, o = 0; o < this._layers.length; o++)i = this._layers[o], this._addItem(i), e = e || i.overlay, t = t || !i.overlay, n += i.overlay ? 0 : 1;
                this.options.hideSingleBase && (this._baseLayersList.style.display = (t = t && 1 < n) ? "" : "none"), this._separator.style.display = e && t ? "" : "none";
            }
            return this;
        },
        _onLayerChange: function(t) {
            this._handlingClick || this._update();
            var e = this._getLayer(h(t.target)), t = e.overlay ? "add" === t.type ? "overlayadd" : "overlayremove" : "add" === t.type ? "baselayerchange" : null;
            t && this._map.fire(t, e);
        },
        _createRadioElement: function(t, e) {
            t = '<input type="radio" class="leaflet-control-layers-selector" name="' + t + '"' + (e ? ' checked="checked"' : "") + "/>", e = document.createElement("div");
            return e.innerHTML = t, e.firstChild;
        },
        _addItem: function(t) {
            var e, i = document.createElement("label"), n = this._map.hasLayer(t.layer), n = (t.overlay ? ((e = document.createElement("input")).type = "checkbox", e.className = "leaflet-control-layers-selector", e.defaultChecked = n) : e = this._createRadioElement("leaflet-base-layers_" + h(this), n), this._layerControlInputs.push(e), e.layerId = h(t.layer), S(e, "click", this._onInputClick, this), document.createElement("span")), o = (n.innerHTML = " " + t.name, document.createElement("span"));
            return i.appendChild(o), o.appendChild(e), o.appendChild(n), (t.overlay ? this._overlaysList : this._baseLayersList).appendChild(i), this._checkDisabledLayers(), i;
        },
        _onInputClick: function() {
            if (!this._preventClick) {
                var t, e, i = this._layerControlInputs, n = [], o = [];
                this._handlingClick = !0;
                for(var s = i.length - 1; 0 <= s; s--)t = i[s], e = this._getLayer(t.layerId).layer, t.checked ? n.push(e) : t.checked || o.push(e);
                for(s = 0; s < o.length; s++)this._map.hasLayer(o[s]) && this._map.removeLayer(o[s]);
                for(s = 0; s < n.length; s++)this._map.hasLayer(n[s]) || this._map.addLayer(n[s]);
                this._handlingClick = !1, this._refocusOnMap();
            }
        },
        _checkDisabledLayers: function() {
            for(var t, e, i = this._layerControlInputs, n = this._map.getZoom(), o = i.length - 1; 0 <= o; o--)t = i[o], e = this._getLayer(t.layerId).layer, t.disabled = void 0 !== e.options.minZoom && n < e.options.minZoom || void 0 !== e.options.maxZoom && n > e.options.maxZoom;
        },
        _expandIfNotCollapsed: function() {
            return this._map && !this.options.collapsed && this.expand(), this;
        },
        _expandSafely: function() {
            var t = this._section, e = (this._preventClick = !0, S(t, "click", O), this.expand(), this);
            setTimeout(function() {
                k(t, "click", O), e._preventClick = !1;
            });
        }
    })), qe = B.extend({
        options: {
            position: "topleft",
            zoomInText: '<span aria-hidden="true">+</span>',
            zoomInTitle: "Zoom in",
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(t) {
            var e = "leaflet-control-zoom", i = P("div", e + " leaflet-bar"), n = this.options;
            return this._zoomInButton = this._createButton(n.zoomInText, n.zoomInTitle, e + "-in", i, this._zoomIn), this._zoomOutButton = this._createButton(n.zoomOutText, n.zoomOutTitle, e + "-out", i, this._zoomOut), this._updateDisabled(), t.on("zoomend zoomlevelschange", this._updateDisabled, this), i;
        },
        onRemove: function(t) {
            t.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            return this._disabled = !0, this._updateDisabled(), this;
        },
        enable: function() {
            return this._disabled = !1, this._updateDisabled(), this;
        },
        _zoomIn: function(t) {
            !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (t.shiftKey ? 3 : 1));
        },
        _zoomOut: function(t) {
            !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (t.shiftKey ? 3 : 1));
        },
        _createButton: function(t, e, i, n, o) {
            i = P("a", i, n);
            return i.innerHTML = t, i.href = "#", i.title = e, i.setAttribute("role", "button"), i.setAttribute("aria-label", e), Ie(i), S(i, "click", Re), S(i, "click", o, this), S(i, "click", this._refocusOnMap, this), i;
        },
        _updateDisabled: function() {
            var t = this._map, e = "leaflet-disabled";
            z(this._zoomInButton, e), z(this._zoomOutButton, e), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), !this._disabled && t._zoom !== t.getMinZoom() || (M(this._zoomOutButton, e), this._zoomOutButton.setAttribute("aria-disabled", "true")), !this._disabled && t._zoom !== t.getMaxZoom() || (M(this._zoomInButton, e), this._zoomInButton.setAttribute("aria-disabled", "true"));
        }
    }), Ge = (A.mergeOptions({
        zoomControl: !0
    }), A.addInitHook(function() {
        this.options.zoomControl && (this.zoomControl = new qe, this.addControl(this.zoomControl));
    }), B.extend({
        options: {
            position: "bottomleft",
            maxWidth: 100,
            metric: !0,
            imperial: !0
        },
        onAdd: function(t) {
            var e = "leaflet-control-scale", i = P("div", e), n = this.options;
            return this._addScales(n, e + "-line", i), t.on(n.updateWhenIdle ? "moveend" : "move", this._update, this), t.whenReady(this._update, this), i;
        },
        onRemove: function(t) {
            t.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(t, e, i) {
            t.metric && (this._mScale = P("div", e, i)), t.imperial && (this._iScale = P("div", e, i));
        },
        _update: function() {
            var t = this._map, e = t.getSize().y / 2, t = t.distance(t.containerPointToLatLng([
                0,
                e
            ]), t.containerPointToLatLng([
                this.options.maxWidth,
                e
            ]));
            this._updateScales(t);
        },
        _updateScales: function(t) {
            this.options.metric && t && this._updateMetric(t), this.options.imperial && t && this._updateImperial(t);
        },
        _updateMetric: function(t) {
            var e = this._getRoundNum(t);
            this._updateScale(this._mScale, e < 1e3 ? e + " m" : e / 1e3 + " km", e / t);
        },
        _updateImperial: function(t) {
            var e, i, t = 3.2808399 * t;
            5280 < t ? (i = this._getRoundNum(e = t / 5280), this._updateScale(this._iScale, i + " mi", i / e)) : (i = this._getRoundNum(t), this._updateScale(this._iScale, i + " ft", i / t));
        },
        _updateScale: function(t, e, i) {
            t.style.width = Math.round(this.options.maxWidth * i) + "px", t.innerHTML = e;
        },
        _getRoundNum: function(t) {
            var e = Math.pow(10, (Math.floor(t) + "").length - 1), t = t / e;
            return e * (t = 10 <= t ? 10 : 5 <= t ? 5 : 3 <= t ? 3 : 2 <= t ? 2 : 1);
        }
    })), Ke = B.extend({
        options: {
            position: "bottomright",
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (b.inlineSvg ? '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg> ' : "") + "Leaflet</a>"
        },
        initialize: function(t) {
            c(this, t), this._attributions = {};
        },
        onAdd: function(t) {
            for(var e in (t.attributionControl = this)._container = P("div", "leaflet-control-attribution"), Ie(this._container), t._layers)t._layers[e].getAttribution && this.addAttribution(t._layers[e].getAttribution());
            return this._update(), t.on("layeradd", this._addAttribution, this), this._container;
        },
        onRemove: function(t) {
            t.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(t) {
            t.layer.getAttribution && (this.addAttribution(t.layer.getAttribution()), t.layer.once("remove", function() {
                this.removeAttribution(t.layer.getAttribution());
            }, this));
        },
        setPrefix: function(t) {
            return this.options.prefix = t, this._update(), this;
        },
        addAttribution: function(t) {
            return t && (this._attributions[t] || (this._attributions[t] = 0), this._attributions[t]++, this._update()), this;
        },
        removeAttribution: function(t) {
            return t && this._attributions[t] && (this._attributions[t]--, this._update()), this;
        },
        _update: function() {
            if (this._map) {
                var t, e = [];
                for(t in this._attributions)this._attributions[t] && e.push(t);
                var i = [];
                this.options.prefix && i.push(this.options.prefix), e.length && i.push(e.join(", ")), this._container.innerHTML = i.join(' <span aria-hidden="true">|</span> ');
            }
        }
    }), n = (A.mergeOptions({
        attributionControl: !0
    }), A.addInitHook(function() {
        this.options.attributionControl && (new Ke).addTo(this);
    }), B.Layers = Ve, B.Zoom = qe, B.Scale = Ge, B.Attribution = Ke, Ue.layers = function(t, e, i) {
        return new Ve(t, e, i);
    }, Ue.zoom = function(t) {
        return new qe(t);
    }, Ue.scale = function(t) {
        return new Ge(t);
    }, Ue.attribution = function(t) {
        return new Ke(t);
    }, et.extend({
        initialize: function(t) {
            this._map = t;
        },
        enable: function() {
            return this._enabled || (this._enabled = !0, this.addHooks()), this;
        },
        disable: function() {
            return this._enabled && (this._enabled = !1, this.removeHooks()), this;
        },
        enabled: function() {
            return !!this._enabled;
        }
    })), ft = (n.addTo = function(t, e) {
        return t.addHandler(e, this), this;
    }, {
        Events: e
    }), Ye = b.touch ? "touchstart mousedown" : "mousedown", Xe = it.extend({
        options: {
            clickTolerance: 3
        },
        initialize: function(t, e, i, n) {
            c(this, n), this._element = t, this._dragStartTarget = e || t, this._preventOutline = i;
        },
        enable: function() {
            this._enabled || (S(this._dragStartTarget, Ye, this._onDown, this), this._enabled = !0);
        },
        disable: function() {
            this._enabled && (Xe._dragging === this && this.finishDrag(!0), k(this._dragStartTarget, Ye, this._onDown, this), this._enabled = !1, this._moved = !1);
        },
        _onDown: function(t) {
            var e, i;
            this._enabled && (this._moved = !1, ve(this._element, "leaflet-zoom-anim") || (t.touches && 1 !== t.touches.length ? Xe._dragging === this && this.finishDrag() : Xe._dragging || t.shiftKey || 1 !== t.which && 1 !== t.button && !t.touches || ((Xe._dragging = this)._preventOutline && Me(this._element), Le(), re(), this._moving || (this.fire("down"), i = t.touches ? t.touches[0] : t, e = Ce(this._element), this._startPoint = new p(i.clientX, i.clientY), this._startPos = Pe(this._element), this._parentScale = Ze(e), i = "mousedown" === t.type, S(document, i ? "mousemove" : "touchmove", this._onMove, this), S(document, i ? "mouseup" : "touchend touchcancel", this._onUp, this)))));
        },
        _onMove: function(t) {
            var e;
            this._enabled && (t.touches && 1 < t.touches.length ? this._moved = !0 : !(e = new p((e = t.touches && 1 === t.touches.length ? t.touches[0] : t).clientX, e.clientY)._subtract(this._startPoint)).x && !e.y || Math.abs(e.x) + Math.abs(e.y) < this.options.clickTolerance || (e.x /= this._parentScale.x, e.y /= this._parentScale.y, O(t), this._moved || (this.fire("dragstart"), this._moved = !0, M(document.body, "leaflet-dragging"), this._lastTarget = t.target || t.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), M(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(e), this._moving = !0, this._lastEvent = t, this._updatePosition()));
        },
        _updatePosition: function() {
            var t = {
                originalEvent: this._lastEvent
            };
            this.fire("predrag", t), Z(this._element, this._newPos), this.fire("drag", t);
        },
        _onUp: function() {
            this._enabled && this.finishDrag();
        },
        finishDrag: function(t) {
            z(document.body, "leaflet-dragging"), this._lastTarget && (z(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), k(document, "mousemove touchmove", this._onMove, this), k(document, "mouseup touchend touchcancel", this._onUp, this), Te(), ae();
            var e = this._moved && this._moving;
            this._moving = !1, Xe._dragging = !1, e && this.fire("dragend", {
                noInertia: t,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    function Je(t, e, i) {
        for(var n, o, s, r, a, h, l, u = [
            1,
            4,
            2,
            8
        ], c = 0, d = t.length; c < d; c++)t[c]._code = si(t[c], e);
        for(s = 0; s < 4; s++){
            for(h = u[s], n = [], c = 0, o = (d = t.length) - 1; c < d; o = c++)r = t[c], a = t[o], r._code & h ? a._code & h || ((l = oi(a, r, h, e, i))._code = si(l, e), n.push(l)) : (a._code & h && ((l = oi(a, r, h, e, i))._code = si(l, e), n.push(l)), n.push(r));
            t = n;
        }
        return t;
    }
    function $e(t, e) {
        var i, n, o, s, r, a, h;
        if (!t || 0 === t.length) throw new Error("latlngs not passed");
        I(t) || (console.warn("latlngs are not flat! Only the first ring will be used"), t = t[0]);
        for(var l = w([
            0,
            0
        ]), u = g(t), c = (u.getNorthWest().distanceTo(u.getSouthWest()) * u.getNorthEast().distanceTo(u.getNorthWest()) < 1700 && (l = Qe(t)), t.length), d = [], _ = 0; _ < c; _++){
            var p = w(t[_]);
            d.push(e.project(w([
                p.lat - l.lat,
                p.lng - l.lng
            ])));
        }
        for(_ = r = a = h = 0, i = c - 1; _ < c; i = _++)n = d[_], o = d[i], s = n.y * o.x - o.y * n.x, a += (n.x + o.x) * s, h += (n.y + o.y) * s, r += 3 * s;
        u = 0 === r ? d[0] : [
            a / r,
            h / r
        ], u = e.unproject(m(u));
        return w([
            u.lat + l.lat,
            u.lng + l.lng
        ]);
    }
    function Qe(t) {
        for(var e = 0, i = 0, n = 0, o = 0; o < t.length; o++){
            var s = w(t[o]);
            e += s.lat, i += s.lng, n++;
        }
        return w([
            e / n,
            i / n
        ]);
    }
    var ti, gt = {
        __proto__: null,
        clipPolygon: Je,
        polygonCenter: $e,
        centroid: Qe
    };
    function ei(t, e) {
        if (e && t.length) {
            var i = t = function(t, e) {
                for(var i = [
                    t[0]
                ], n = 1, o = 0, s = t.length; n < s; n++)(function(t, e) {
                    var i = e.x - t.x, e = e.y - t.y;
                    return i * i + e * e;
                })(t[n], t[o]) > e && (i.push(t[n]), o = n);
                o < s - 1 && i.push(t[s - 1]);
                return i;
            }(t, e = e * e), n = i.length, o = new (typeof Uint8Array != "undefined" ? Uint8Array : Array)(n);
            o[0] = o[n - 1] = 1, function t(e, i, n, o, s) {
                var r, a, h, l = 0;
                for(a = o + 1; a <= s - 1; a++)h = ri(e[a], e[o], e[s], !0), l < h && (r = a, l = h);
                n < l && (i[r] = 1, t(e, i, n, o, r), t(e, i, n, r, s));
            }(i, o, e, 0, n - 1);
            var s, r = [];
            for(s = 0; s < n; s++)o[s] && r.push(i[s]);
            return r;
        }
        return t.slice();
    }
    function ii(t, e, i) {
        return Math.sqrt(ri(t, e, i, !0));
    }
    function ni(t, e, i, n, o) {
        var s, r, a, h = n ? ti : si(t, i), l = si(e, i);
        for(ti = l;;){
            if (!(h | l)) return [
                t,
                e
            ];
            if (h & l) return !1;
            a = si(r = oi(t, e, s = h || l, i, o), i), s === h ? (t = r, h = a) : (e = r, l = a);
        }
    }
    function oi(t, e, i, n, o) {
        var s, r, a = e.x - t.x, e = e.y - t.y, h = n.min, n = n.max;
        return 8 & i ? (s = t.x + a * (n.y - t.y) / e, r = n.y) : 4 & i ? (s = t.x + a * (h.y - t.y) / e, r = h.y) : 2 & i ? (s = n.x, r = t.y + e * (n.x - t.x) / a) : 1 & i && (s = h.x, r = t.y + e * (h.x - t.x) / a), new p(s, r, o);
    }
    function si(t, e) {
        var i = 0;
        return t.x < e.min.x ? i |= 1 : t.x > e.max.x && (i |= 2), t.y < e.min.y ? i |= 4 : t.y > e.max.y && (i |= 8), i;
    }
    function ri(t, e, i, n) {
        var o = e.x, e = e.y, s = i.x - o, r = i.y - e, a = s * s + r * r;
        return 0 < a && (1 < (a = ((t.x - o) * s + (t.y - e) * r) / a) ? (o = i.x, e = i.y) : 0 < a && (o += s * a, e += r * a)), s = t.x - o, r = t.y - e, n ? s * s + r * r : new p(o, e);
    }
    function I(t) {
        return !d(t[0]) || "object" != typeof t[0][0] && void 0 !== t[0][0];
    }
    function ai(t) {
        return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), I(t);
    }
    function hi(t, e) {
        var i, n, o, s, r, a;
        if (!t || 0 === t.length) throw new Error("latlngs not passed");
        I(t) || (console.warn("latlngs are not flat! Only the first ring will be used"), t = t[0]);
        for(var h = w([
            0,
            0
        ]), l = g(t), u = (l.getNorthWest().distanceTo(l.getSouthWest()) * l.getNorthEast().distanceTo(l.getNorthWest()) < 1700 && (h = Qe(t)), t.length), c = [], d = 0; d < u; d++){
            var _ = w(t[d]);
            c.push(e.project(w([
                _.lat - h.lat,
                _.lng - h.lng
            ])));
        }
        for(i = d = 0; d < u - 1; d++)i += c[d].distanceTo(c[d + 1]) / 2;
        if (0 === i) a = c[0];
        else for(n = d = 0; d < u - 1; d++)if (o = c[d], s = c[d + 1], i < (n += r = o.distanceTo(s))) {
            a = [
                s.x - (r = (n - i) / r) * (s.x - o.x),
                s.y - r * (s.y - o.y)
            ];
            break;
        }
        l = e.unproject(m(a));
        return w([
            l.lat + h.lat,
            l.lng + h.lng
        ]);
    }
    var vt = {
        __proto__: null,
        simplify: ei,
        pointToSegmentDistance: ii,
        closestPointOnSegment: function(t, e, i) {
            return ri(t, e, i);
        },
        clipSegment: ni,
        _getEdgeIntersection: oi,
        _getBitCode: si,
        _sqClosestPointOnSegment: ri,
        isFlat: I,
        _flat: ai,
        polylineCenter: hi
    }, yt = {
        project: function(t) {
            return new p(t.lng, t.lat);
        },
        unproject: function(t) {
            return new v(t.y, t.x);
        },
        bounds: new f([
            -180,
            -90
        ], [
            180,
            90
        ])
    }, xt = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new f([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(t) {
            var e = Math.PI / 180, i = this.R, n = t.lat * e, o = this.R_MINOR / i, o = Math.sqrt(1 - o * o), s = o * Math.sin(n), s = Math.tan(Math.PI / 4 - n / 2) / Math.pow((1 - s) / (1 + s), o / 2), n = -i * Math.log(Math.max(s, 1e-10));
            return new p(t.lng * e * i, n);
        },
        unproject: function(t) {
            for(var e, i = 180 / Math.PI, n = this.R, o = this.R_MINOR / n, s = Math.sqrt(1 - o * o), r = Math.exp(-t.y / n), a = Math.PI / 2 - 2 * Math.atan(r), h = 0, l = .1; h < 15 && 1e-7 < Math.abs(l); h++)e = s * Math.sin(a), e = Math.pow((1 - e) / (1 + e), s / 2), a += l = Math.PI / 2 - 2 * Math.atan(r * e) - a;
            return new v(a * i, t.x * i / n);
        }
    }, wt = {
        __proto__: null,
        LonLat: yt,
        Mercator: xt,
        SphericalMercator: rt
    }, Pt = l({}, st, {
        code: "EPSG:3395",
        projection: xt,
        transformation: ht(bt = .5 / (Math.PI * xt.R), .5, -bt, .5)
    }), li = l({}, st, {
        code: "EPSG:4326",
        projection: yt,
        transformation: ht(1 / 180, 1, -1 / 180, .5)
    }), Lt = l({}, ot, {
        projection: yt,
        transformation: ht(1, 0, -1, 0),
        scale: function(t) {
            return Math.pow(2, t);
        },
        zoom: function(t) {
            return Math.log(t) / Math.LN2;
        },
        distance: function(t, e) {
            var i = e.lng - t.lng, e = e.lat - t.lat;
            return Math.sqrt(i * i + e * e);
        },
        infinite: !0
    }), o = (ot.Earth = st, ot.EPSG3395 = Pt, ot.EPSG3857 = lt, ot.EPSG900913 = ut, ot.EPSG4326 = li, ot.Simple = Lt, it.extend({
        options: {
            pane: "overlayPane",
            attribution: null,
            bubblingMouseEvents: !0
        },
        addTo: function(t) {
            return t.addLayer(this), this;
        },
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        removeFrom: function(t) {
            return t && t.removeLayer(this), this;
        },
        getPane: function(t) {
            return this._map.getPane(t ? this.options[t] || t : this.options.pane);
        },
        addInteractiveTarget: function(t) {
            return this._map._targets[h(t)] = this;
        },
        removeInteractiveTarget: function(t) {
            return delete this._map._targets[h(t)], this;
        },
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(t) {
            var e, i = t.target;
            i.hasLayer(this) && (this._map = i, this._zoomAnimated = i._zoomAnimated, this.getEvents && (e = this.getEvents(), i.on(e, this), this.once("remove", function() {
                i.off(e, this);
            }, this)), this.onAdd(i), this.fire("add"), i.fire("layeradd", {
                layer: this
            }));
        }
    })), ui = (A.include({
        addLayer: function(t) {
            var e;
            if (t._layerAdd) return e = h(t), this._layers[e] || ((this._layers[e] = t)._mapToAdd = this, t.beforeAdd && t.beforeAdd(this), this.whenReady(t._layerAdd, t)), this;
            throw new Error("The provided object is not a Layer.");
        },
        removeLayer: function(t) {
            var e = h(t);
            return this._layers[e] && (this._loaded && t.onRemove(this), delete this._layers[e], this._loaded && (this.fire("layerremove", {
                layer: t
            }), t.fire("remove")), t._map = t._mapToAdd = null), this;
        },
        hasLayer: function(t) {
            return h(t) in this._layers;
        },
        eachLayer: function(t, e) {
            for(var i in this._layers)t.call(e, this._layers[i]);
            return this;
        },
        _addLayers: function(t) {
            for(var e = 0, i = (t = t ? d(t) ? t : [
                t
            ] : []).length; e < i; e++)this.addLayer(t[e]);
        },
        _addZoomLimit: function(t) {
            isNaN(t.options.maxZoom) && isNaN(t.options.minZoom) || (this._zoomBoundLayers[h(t)] = t, this._updateZoomLevels());
        },
        _removeZoomLimit: function(t) {
            t = h(t);
            this._zoomBoundLayers[t] && (delete this._zoomBoundLayers[t], this._updateZoomLevels());
        },
        _updateZoomLevels: function() {
            var t, e = 1 / 0, i = -1 / 0, n = this._getZoomSpan();
            for(t in this._zoomBoundLayers)var o = this._zoomBoundLayers[t].options, e = void 0 === o.minZoom ? e : Math.min(e, o.minZoom), i = void 0 === o.maxZoom ? i : Math.max(i, o.maxZoom);
            this._layersMaxZoom = i === -1 / 0 ? void 0 : i, this._layersMinZoom = e === 1 / 0 ? void 0 : e, n !== this._getZoomSpan() && this.fire("zoomlevelschange"), void 0 === this.options.maxZoom && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), void 0 === this.options.minZoom && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
        }
    }), o.extend({
        initialize: function(t, e) {
            var i, n;
            if (c(this, e), this._layers = {}, t) for(i = 0, n = t.length; i < n; i++)this.addLayer(t[i]);
        },
        addLayer: function(t) {
            var e = this.getLayerId(t);
            return this._layers[e] = t, this._map && this._map.addLayer(t), this;
        },
        removeLayer: function(t) {
            t = t in this._layers ? t : this.getLayerId(t);
            return this._map && this._layers[t] && this._map.removeLayer(this._layers[t]), delete this._layers[t], this;
        },
        hasLayer: function(t) {
            return ("number" == typeof t ? t : this.getLayerId(t)) in this._layers;
        },
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        invoke: function(t) {
            var e, i, n = Array.prototype.slice.call(arguments, 1);
            for(e in this._layers)(i = this._layers[e])[t] && i[t].apply(i, n);
            return this;
        },
        onAdd: function(t) {
            this.eachLayer(t.addLayer, t);
        },
        onRemove: function(t) {
            this.eachLayer(t.removeLayer, t);
        },
        eachLayer: function(t, e) {
            for(var i in this._layers)t.call(e, this._layers[i]);
            return this;
        },
        getLayer: function(t) {
            return this._layers[t];
        },
        getLayers: function() {
            var t = [];
            return this.eachLayer(t.push, t), t;
        },
        setZIndex: function(t) {
            return this.invoke("setZIndex", t);
        },
        getLayerId: h
    })), ci = ui.extend({
        addLayer: function(t) {
            return this.hasLayer(t) ? this : (t.addEventParent(this), ui.prototype.addLayer.call(this, t), this.fire("layeradd", {
                layer: t
            }));
        },
        removeLayer: function(t) {
            return this.hasLayer(t) ? ((t = t in this._layers ? this._layers[t] : t).removeEventParent(this), ui.prototype.removeLayer.call(this, t), this.fire("layerremove", {
                layer: t
            })) : this;
        },
        setStyle: function(t) {
            return this.invoke("setStyle", t);
        },
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        getBounds: function() {
            var t, e = new s;
            for(t in this._layers){
                var i = this._layers[t];
                e.extend(i.getBounds ? i.getBounds() : i.getLatLng());
            }
            return e;
        }
    }), di = et.extend({
        options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            crossOrigin: !1
        },
        initialize: function(t) {
            c(this, t);
        },
        createIcon: function(t) {
            return this._createIcon("icon", t);
        },
        createShadow: function(t) {
            return this._createIcon("shadow", t);
        },
        _createIcon: function(t, e) {
            var i = this._getIconUrl(t);
            if (i) return i = this._createImg(i, e && "IMG" === e.tagName ? e : null), this._setIconStyles(i, t), !this.options.crossOrigin && "" !== this.options.crossOrigin || (i.crossOrigin = !0 === this.options.crossOrigin ? "" : this.options.crossOrigin), i;
            if ("icon" === t) throw new Error("iconUrl not set in Icon options (see the docs).");
            return null;
        },
        _setIconStyles: function(t, e) {
            var i = this.options, n = i[e + "Size"], n = m(n = "number" == typeof n ? [
                n,
                n
            ] : n), o = m("shadow" === e && i.shadowAnchor || i.iconAnchor || n && n.divideBy(2, !0));
            t.className = "leaflet-marker-" + e + " " + (i.className || ""), o && (t.style.marginLeft = -o.x + "px", t.style.marginTop = -o.y + "px"), n && (t.style.width = n.x + "px", t.style.height = n.y + "px");
        },
        _createImg: function(t, e) {
            return (e = e || document.createElement("img")).src = t, e;
        },
        _getIconUrl: function(t) {
            return b.retina && this.options[t + "RetinaUrl"] || this.options[t + "Url"];
        }
    });
    var _i = di.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(t) {
            return "string" != typeof _i.imagePath && (_i.imagePath = this._detectIconPath()), (this.options.imagePath || _i.imagePath) + di.prototype._getIconUrl.call(this, t);
        },
        _stripUrl: function(t) {
            function e(t, e, i) {
                return (e = e.exec(t)) && e[i];
            }
            return (t = e(t, /^url\((['"])?(.+)\1\)$/, 2)) && e(t, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var t = P("div", "leaflet-default-icon-path", document.body), e = pe(t, "background-image") || pe(t, "backgroundImage");
            return document.body.removeChild(t), (e = this._stripUrl(e)) ? e : (t = document.querySelector('link[href$="leaflet.css"]')) ? t.href.substring(0, t.href.length - 11 - 1) : "";
        }
    }), pi = n.extend({
        initialize: function(t) {
            this._marker = t;
        },
        addHooks: function() {
            var t = this._marker._icon;
            this._draggable || (this._draggable = new Xe(t, t, !0)), this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable(), M(t, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable(), this._marker._icon && z(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(t) {
            var e = this._marker, i = e._map, n = this._marker.options.autoPanSpeed, o = this._marker.options.autoPanPadding, s = Pe(e._icon), r = i.getPixelBounds(), a = i.getPixelOrigin(), a = _(r.min._subtract(a).add(o), r.max._subtract(a).subtract(o));
            a.contains(s) || (o = m((Math.max(a.max.x, s.x) - a.max.x) / (r.max.x - a.max.x) - (Math.min(a.min.x, s.x) - a.min.x) / (r.min.x - a.min.x), (Math.max(a.max.y, s.y) - a.max.y) / (r.max.y - a.max.y) - (Math.min(a.min.y, s.y) - a.min.y) / (r.min.y - a.min.y)).multiplyBy(n), i.panBy(o, {
                animate: !1
            }), this._draggable._newPos._add(o), this._draggable._startPos._add(o), Z(e._icon, this._draggable._newPos), this._onDrag(t), this._panRequest = x(this._adjustPan.bind(this, t)));
        },
        _onDragStart: function() {
            this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(t) {
            this._marker.options.autoPan && (r(this._panRequest), this._panRequest = x(this._adjustPan.bind(this, t)));
        },
        _onDrag: function(t) {
            var e = this._marker, i = e._shadow, n = Pe(e._icon), o = e._map.layerPointToLatLng(n);
            i && Z(i, n), e._latlng = o, t.latlng = o, t.oldLatLng = this._oldLatLng, e.fire("move", t).fire("drag", t);
        },
        _onDragEnd: function(t) {
            r(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", t);
        }
    }), mi = o.extend({
        options: {
            icon: new _i,
            interactive: !0,
            keyboard: !0,
            title: "",
            alt: "Marker",
            zIndexOffset: 0,
            opacity: 1,
            riseOnHover: !1,
            riseOffset: 250,
            pane: "markerPane",
            shadowPane: "shadowPane",
            bubblingMouseEvents: !1,
            autoPanOnFocus: !0,
            draggable: !1,
            autoPan: !1,
            autoPanPadding: [
                50,
                50
            ],
            autoPanSpeed: 10
        },
        initialize: function(t, e) {
            c(this, e), this._latlng = w(t);
        },
        onAdd: function(t) {
            this._zoomAnimated = this._zoomAnimated && t.options.markerZoomAnimation, this._zoomAnimated && t.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
        },
        onRemove: function(t) {
            this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && t.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        getLatLng: function() {
            return this._latlng;
        },
        setLatLng: function(t) {
            var e = this._latlng;
            return this._latlng = w(t), this.update(), this.fire("move", {
                oldLatLng: e,
                latlng: this._latlng
            });
        },
        setZIndexOffset: function(t) {
            return this.options.zIndexOffset = t, this.update();
        },
        getIcon: function() {
            return this.options.icon;
        },
        setIcon: function(t) {
            return this.options.icon = t, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            var t;
            return this._icon && this._map && (t = this._map.latLngToLayerPoint(this._latlng).round(), this._setPos(t)), this;
        },
        _initIcon: function() {
            var t = this.options, e = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), i = t.icon.createIcon(this._icon), n = !1, i = (i !== this._icon && (this._icon && this._removeIcon(), n = !0, t.title && (i.title = t.title), "IMG" === i.tagName && (i.alt = t.alt || "")), M(i, e), t.keyboard && (i.tabIndex = "0", i.setAttribute("role", "button")), this._icon = i, t.riseOnHover && this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            }), this.options.autoPanOnFocus && S(i, "focus", this._panOnFocus, this), t.icon.createShadow(this._shadow)), o = !1;
            i !== this._shadow && (this._removeShadow(), o = !0), i && (M(i, e), i.alt = ""), this._shadow = i, t.opacity < 1 && this._updateOpacity(), n && this.getPane().appendChild(this._icon), this._initInteraction(), i && o && this.getPane(t.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            this.options.riseOnHover && this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            }), this.options.autoPanOnFocus && k(this._icon, "focus", this._panOnFocus, this), T(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
        },
        _removeShadow: function() {
            this._shadow && T(this._shadow), this._shadow = null;
        },
        _setPos: function(t) {
            this._icon && Z(this._icon, t), this._shadow && Z(this._shadow, t), this._zIndex = t.y + this.options.zIndexOffset, this._resetZIndex();
        },
        _updateZIndex: function(t) {
            this._icon && (this._icon.style.zIndex = this._zIndex + t);
        },
        _animateZoom: function(t) {
            t = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center).round();
            this._setPos(t);
        },
        _initInteraction: function() {
            var t;
            this.options.interactive && (M(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), pi && (t = this.options.draggable, this.dragging && (t = this.dragging.enabled(), this.dragging.disable()), this.dragging = new pi(this), t && this.dragging.enable()));
        },
        setOpacity: function(t) {
            return this.options.opacity = t, this._map && this._updateOpacity(), this;
        },
        _updateOpacity: function() {
            var t = this.options.opacity;
            this._icon && C(this._icon, t), this._shadow && C(this._shadow, t);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var t, e, i = this._map;
            i && (t = (e = this.options.icon.options).iconSize ? m(e.iconSize) : m(0, 0), e = e.iconAnchor ? m(e.iconAnchor) : m(0, 0), i.panInside(this._latlng, {
                paddingTopLeft: e,
                paddingBottomRight: t.subtract(e)
            }));
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    var fi = o.extend({
        options: {
            stroke: !0,
            color: "#3388ff",
            weight: 3,
            opacity: 1,
            lineCap: "round",
            lineJoin: "round",
            dashArray: null,
            dashOffset: null,
            fill: !1,
            fillColor: null,
            fillOpacity: .2,
            fillRule: "evenodd",
            interactive: !0,
            bubblingMouseEvents: !0
        },
        beforeAdd: function(t) {
            this._renderer = t.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        redraw: function() {
            return this._map && this._renderer._updatePath(this), this;
        },
        setStyle: function(t) {
            return c(this, t), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && t && Object.prototype.hasOwnProperty.call(t, "weight") && this._updateBounds()), this;
        },
        bringToFront: function() {
            return this._renderer && this._renderer._bringToFront(this), this;
        },
        bringToBack: function() {
            return this._renderer && this._renderer._bringToBack(this), this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            this._project(), this._update();
        },
        _clickTolerance: function() {
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    }), gi = fi.extend({
        options: {
            fill: !0,
            radius: 10
        },
        initialize: function(t, e) {
            c(this, e), this._latlng = w(t), this._radius = this.options.radius;
        },
        setLatLng: function(t) {
            var e = this._latlng;
            return this._latlng = w(t), this.redraw(), this.fire("move", {
                oldLatLng: e,
                latlng: this._latlng
            });
        },
        getLatLng: function() {
            return this._latlng;
        },
        setRadius: function(t) {
            return this.options.radius = this._radius = t, this.redraw();
        },
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(t) {
            var e = t && t.radius || this._radius;
            return fi.prototype.setStyle.call(this, t), this.setRadius(e), this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
        },
        _updateBounds: function() {
            var t = this._radius, e = this._radiusY || t, i = this._clickTolerance(), t = [
                t + i,
                e + i
            ];
            this._pxBounds = new f(this._point.subtract(t), this._point.add(t));
        },
        _update: function() {
            this._map && this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        _containsPoint: function(t) {
            return t.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    var vi = gi.extend({
        initialize: function(t, e, i) {
            if (c(this, e = "number" == typeof e ? l({}, i, {
                radius: e
            }) : e), this._latlng = w(t), isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            this._mRadius = this.options.radius;
        },
        setRadius: function(t) {
            return this._mRadius = t, this.redraw();
        },
        getRadius: function() {
            return this._mRadius;
        },
        getBounds: function() {
            var t = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new s(this._map.layerPointToLatLng(this._point.subtract(t)), this._map.layerPointToLatLng(this._point.add(t)));
        },
        setStyle: fi.prototype.setStyle,
        _project: function() {
            var t, e, i, n, o, s = this._latlng.lng, r = this._latlng.lat, a = this._map, h = a.options.crs;
            h.distance === st.distance ? (n = Math.PI / 180, o = this._mRadius / st.R / n, t = a.project([
                r + o,
                s
            ]), e = a.project([
                r - o,
                s
            ]), e = t.add(e).divideBy(2), i = a.unproject(e).lat, n = Math.acos((Math.cos(o * n) - Math.sin(r * n) * Math.sin(i * n)) / (Math.cos(r * n) * Math.cos(i * n))) / n, !isNaN(n) && 0 !== n || (n = o / Math.cos(Math.PI / 180 * r)), this._point = e.subtract(a.getPixelOrigin()), this._radius = isNaN(n) ? 0 : e.x - a.project([
                i,
                s - n
            ]).x, this._radiusY = e.y - t.y) : (o = h.unproject(h.project(this._latlng).subtract([
                this._mRadius,
                0
            ])), this._point = a.latLngToLayerPoint(this._latlng), this._radius = this._point.x - a.latLngToLayerPoint(o).x), this._updateBounds();
        }
    });
    var yi = fi.extend({
        options: {
            smoothFactor: 1,
            noClip: !1
        },
        initialize: function(t, e) {
            c(this, e), this._setLatLngs(t);
        },
        getLatLngs: function() {
            return this._latlngs;
        },
        setLatLngs: function(t) {
            return this._setLatLngs(t), this.redraw();
        },
        isEmpty: function() {
            return !this._latlngs.length;
        },
        closestLayerPoint: function(t) {
            for(var e = 1 / 0, i = null, n = ri, o = 0, s = this._parts.length; o < s; o++)for(var r = this._parts[o], a = 1, h = r.length; a < h; a++){
                var l, u, c = n(t, l = r[a - 1], u = r[a], !0);
                c < e && (e = c, i = n(t, l, u));
            }
            return i && (i.distance = Math.sqrt(e)), i;
        },
        getCenter: function() {
            if (this._map) return hi(this._defaultShape(), this._map.options.crs);
            throw new Error("Must add layer to map before using getCenter()");
        },
        getBounds: function() {
            return this._bounds;
        },
        addLatLng: function(t, e) {
            return e = e || this._defaultShape(), t = w(t), e.push(t), this._bounds.extend(t), this.redraw();
        },
        _setLatLngs: function(t) {
            this._bounds = new s, this._latlngs = this._convertLatLngs(t);
        },
        _defaultShape: function() {
            return I(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        _convertLatLngs: function(t) {
            for(var e = [], i = I(t), n = 0, o = t.length; n < o; n++)i ? (e[n] = w(t[n]), this._bounds.extend(e[n])) : e[n] = this._convertLatLngs(t[n]);
            return e;
        },
        _project: function() {
            var t = new f;
            this._rings = [], this._projectLatlngs(this._latlngs, this._rings, t), this._bounds.isValid() && t.isValid() && (this._rawPxBounds = t, this._updateBounds());
        },
        _updateBounds: function() {
            var t = this._clickTolerance(), t = new p(t, t);
            this._rawPxBounds && (this._pxBounds = new f([
                this._rawPxBounds.min.subtract(t),
                this._rawPxBounds.max.add(t)
            ]));
        },
        _projectLatlngs: function(t, e, i) {
            var n, o, s = t[0] instanceof v, r = t.length;
            if (s) {
                for(o = [], n = 0; n < r; n++)o[n] = this._map.latLngToLayerPoint(t[n]), i.extend(o[n]);
                e.push(o);
            } else for(n = 0; n < r; n++)this._projectLatlngs(t[n], e, i);
        },
        _clipPoints: function() {
            var t = this._renderer._bounds;
            if (this._parts = [], this._pxBounds && this._pxBounds.intersects(t)) {
                if (this.options.noClip) this._parts = this._rings;
                else for(var e, i, n, o, s = this._parts, r = 0, a = 0, h = this._rings.length; r < h; r++)for(e = 0, i = (o = this._rings[r]).length; e < i - 1; e++)(n = ni(o[e], o[e + 1], t, e, !0)) && (s[a] = s[a] || [], s[a].push(n[0]), n[1] === o[e + 1] && e !== i - 2 || (s[a].push(n[1]), a++));
            }
        },
        _simplifyPoints: function() {
            for(var t = this._parts, e = this.options.smoothFactor, i = 0, n = t.length; i < n; i++)t[i] = ei(t[i], e);
        },
        _update: function() {
            this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        _containsPoint: function(t, e) {
            var i, n, o, s, r, a, h = this._clickTolerance();
            if (this._pxBounds && this._pxBounds.contains(t)) {
                for(i = 0, s = this._parts.length; i < s; i++)for(n = 0, o = (r = (a = this._parts[i]).length) - 1; n < r; o = n++)if ((e || 0 !== n) && ii(t, a[o], a[n]) <= h) return !0;
            }
            return !1;
        }
    });
    yi._flat = ai;
    var xi = yi.extend({
        options: {
            fill: !0
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        getCenter: function() {
            if (this._map) return $e(this._defaultShape(), this._map.options.crs);
            throw new Error("Must add layer to map before using getCenter()");
        },
        _convertLatLngs: function(t) {
            var t = yi.prototype._convertLatLngs.call(this, t), e = t.length;
            return 2 <= e && t[0] instanceof v && t[0].equals(t[e - 1]) && t.pop(), t;
        },
        _setLatLngs: function(t) {
            yi.prototype._setLatLngs.call(this, t), I(this._latlngs) && (this._latlngs = [
                this._latlngs
            ]);
        },
        _defaultShape: function() {
            return (I(this._latlngs[0]) ? this._latlngs : this._latlngs[0])[0];
        },
        _clipPoints: function() {
            var t = this._renderer._bounds, e = this.options.weight, e = new p(e, e), t = new f(t.min.subtract(e), t.max.add(e));
            if (this._parts = [], this._pxBounds && this._pxBounds.intersects(t)) {
                if (this.options.noClip) this._parts = this._rings;
                else for(var i, n = 0, o = this._rings.length; n < o; n++)(i = Je(this._rings[n], t, !0)).length && this._parts.push(i);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, !0);
        },
        _containsPoint: function(t) {
            var e, i, n, o, s, r, a, h, l = !1;
            if (!this._pxBounds || !this._pxBounds.contains(t)) return !1;
            for(o = 0, a = this._parts.length; o < a; o++)for(s = 0, r = (h = (e = this._parts[o]).length) - 1; s < h; r = s++)i = e[s], n = e[r], i.y > t.y != n.y > t.y && t.x < (n.x - i.x) * (t.y - i.y) / (n.y - i.y) + i.x && (l = !l);
            return l || yi.prototype._containsPoint.call(this, t, !0);
        }
    });
    var wi = ci.extend({
        initialize: function(t, e) {
            c(this, e), this._layers = {}, t && this.addData(t);
        },
        addData: function(t) {
            var e, i, n, o = d(t) ? t : t.features;
            if (o) {
                for(e = 0, i = o.length; e < i; e++)((n = o[e]).geometries || n.geometry || n.features || n.coordinates) && this.addData(n);
                return this;
            }
            var s, r = this.options;
            return (!r.filter || r.filter(t)) && (s = bi(t, r)) ? (s.feature = Zi(t), s.defaultOptions = s.options, this.resetStyle(s), r.onEachFeature && r.onEachFeature(t, s), this.addLayer(s)) : this;
        },
        resetStyle: function(t) {
            return void 0 === t ? this.eachLayer(this.resetStyle, this) : (t.options = l({}, t.defaultOptions), this._setLayerStyle(t, this.options.style), this);
        },
        setStyle: function(e) {
            return this.eachLayer(function(t) {
                this._setLayerStyle(t, e);
            }, this);
        },
        _setLayerStyle: function(t, e) {
            t.setStyle && ("function" == typeof e && (e = e(t.feature)), t.setStyle(e));
        }
    });
    function bi(t, e) {
        var i, n, o, s, r = "Feature" === t.type ? t.geometry : t, a = r ? r.coordinates : null, h = [], l = e && e.pointToLayer, u = e && e.coordsToLatLng || Li;
        if (!a && !r) return null;
        switch(r.type){
            case "Point":
                return Pi(l, t, i = u(a), e);
            case "MultiPoint":
                for(o = 0, s = a.length; o < s; o++)i = u(a[o]), h.push(Pi(l, t, i, e));
                return new ci(h);
            case "LineString":
            case "MultiLineString":
                return n = Ti(a, "LineString" === r.type ? 0 : 1, u), new yi(n, e);
            case "Polygon":
            case "MultiPolygon":
                return n = Ti(a, "Polygon" === r.type ? 1 : 2, u), new xi(n, e);
            case "GeometryCollection":
                for(o = 0, s = r.geometries.length; o < s; o++){
                    var c = bi({
                        geometry: r.geometries[o],
                        type: "Feature",
                        properties: t.properties
                    }, e);
                    c && h.push(c);
                }
                return new ci(h);
            case "FeatureCollection":
                for(o = 0, s = r.features.length; o < s; o++){
                    var d = bi(r.features[o], e);
                    d && h.push(d);
                }
                return new ci(h);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function Pi(t, e, i, n) {
        return t ? t(e, i) : new mi(i, n && n.markersInheritOptions && n);
    }
    function Li(t) {
        return new v(t[1], t[0], t[2]);
    }
    function Ti(t, e, i) {
        for(var n, o = [], s = 0, r = t.length; s < r; s++)n = e ? Ti(t[s], e - 1, i) : (i || Li)(t[s]), o.push(n);
        return o;
    }
    function Mi(t, e) {
        return void 0 !== (t = w(t)).alt ? [
            i(t.lng, e),
            i(t.lat, e),
            i(t.alt, e)
        ] : [
            i(t.lng, e),
            i(t.lat, e)
        ];
    }
    function zi(t, e, i, n) {
        for(var o = [], s = 0, r = t.length; s < r; s++)o.push(e ? zi(t[s], I(t[s]) ? 0 : e - 1, i, n) : Mi(t[s], n));
        return !e && i && 0 < o.length && o.push(o[0].slice()), o;
    }
    function Ci(t, e) {
        return t.feature ? l({}, t.feature, {
            geometry: e
        }) : Zi(e);
    }
    function Zi(t) {
        return "Feature" === t.type || "FeatureCollection" === t.type ? t : {
            type: "Feature",
            properties: {},
            geometry: t
        };
    }
    Tt = {
        toGeoJSON: function(t) {
            return Ci(this, {
                type: "Point",
                coordinates: Mi(this.getLatLng(), t)
            });
        }
    };
    function Si(t, e) {
        return new wi(t, e);
    }
    mi.include(Tt), vi.include(Tt), gi.include(Tt), yi.include({
        toGeoJSON: function(t) {
            var e = !I(this._latlngs);
            return Ci(this, {
                type: (e ? "Multi" : "") + "LineString",
                coordinates: zi(this._latlngs, e ? 1 : 0, !1, t)
            });
        }
    }), xi.include({
        toGeoJSON: function(t) {
            var e = !I(this._latlngs), i = e && !I(this._latlngs[0]), t = zi(this._latlngs, i ? 2 : e ? 1 : 0, !0, t);
            return Ci(this, {
                type: (i ? "Multi" : "") + "Polygon",
                coordinates: t = e ? t : [
                    t
                ]
            });
        }
    }), ui.include({
        toMultiPoint: function(e) {
            var i = [];
            return this.eachLayer(function(t) {
                i.push(t.toGeoJSON(e).geometry.coordinates);
            }), Ci(this, {
                type: "MultiPoint",
                coordinates: i
            });
        },
        toGeoJSON: function(e) {
            var i, n, t = this.feature && this.feature.geometry && this.feature.geometry.type;
            return "MultiPoint" === t ? this.toMultiPoint(e) : (i = "GeometryCollection" === t, n = [], this.eachLayer(function(t) {
                t.toGeoJSON && (t = t.toGeoJSON(e), i ? n.push(t.geometry) : "FeatureCollection" === (t = Zi(t)).type ? n.push.apply(n, t.features) : n.push(t));
            }), i ? Ci(this, {
                geometries: n,
                type: "GeometryCollection"
            }) : {
                type: "FeatureCollection",
                features: n
            });
        }
    });
    var Mt = Si, Ei = o.extend({
        options: {
            opacity: 1,
            alt: "",
            interactive: !1,
            crossOrigin: !1,
            errorOverlayUrl: "",
            zIndex: 1,
            className: ""
        },
        initialize: function(t, e, i) {
            this._url = t, this._bounds = g(e), c(this, i);
        },
        onAdd: function() {
            this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (M(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
        },
        onRemove: function() {
            T(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
        },
        setOpacity: function(t) {
            return this.options.opacity = t, this._image && this._updateOpacity(), this;
        },
        setStyle: function(t) {
            return t.opacity && this.setOpacity(t.opacity), this;
        },
        bringToFront: function() {
            return this._map && fe(this._image), this;
        },
        bringToBack: function() {
            return this._map && ge(this._image), this;
        },
        setUrl: function(t) {
            return this._url = t, this._image && (this._image.src = t), this;
        },
        setBounds: function(t) {
            return this._bounds = g(t), this._map && this._reset(), this;
        },
        getEvents: function() {
            var t = {
                zoom: this._reset,
                viewreset: this._reset
            };
            return this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
        },
        setZIndex: function(t) {
            return this.options.zIndex = t, this._updateZIndex(), this;
        },
        getBounds: function() {
            return this._bounds;
        },
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var t = "IMG" === this._url.tagName, e = this._image = t ? this._url : P("img");
            M(e, "leaflet-image-layer"), this._zoomAnimated && M(e, "leaflet-zoom-animated"), this.options.className && M(e, this.options.className), e.onselectstart = u, e.onmousemove = u, e.onload = a(this.fire, this, "load"), e.onerror = a(this._overlayOnError, this, "error"), !this.options.crossOrigin && "" !== this.options.crossOrigin || (e.crossOrigin = !0 === this.options.crossOrigin ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), t ? this._url = e.src : (e.src = this._url, e.alt = this.options.alt);
        },
        _animateZoom: function(t) {
            var e = this._map.getZoomScale(t.zoom), t = this._map._latLngBoundsToNewLayerBounds(this._bounds, t.zoom, t.center).min;
            be(this._image, t, e);
        },
        _reset: function() {
            var t = this._image, e = new f(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), i = e.getSize();
            Z(t, e.min), t.style.width = i.x + "px", t.style.height = i.y + "px";
        },
        _updateOpacity: function() {
            C(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            this._image && void 0 !== this.options.zIndex && null !== this.options.zIndex && (this._image.style.zIndex = this.options.zIndex);
        },
        _overlayOnError: function() {
            this.fire("error");
            var t = this.options.errorOverlayUrl;
            t && this._url !== t && (this._url = t, this._image.src = t);
        },
        getCenter: function() {
            return this._bounds.getCenter();
        }
    }), ki = Ei.extend({
        options: {
            autoplay: !0,
            loop: !0,
            keepAspectRatio: !0,
            muted: !1,
            playsInline: !0
        },
        _initImage: function() {
            var t = "VIDEO" === this._url.tagName, e = this._image = t ? this._url : P("video");
            if (M(e, "leaflet-image-layer"), this._zoomAnimated && M(e, "leaflet-zoom-animated"), this.options.className && M(e, this.options.className), e.onselectstart = u, e.onmousemove = u, e.onloadeddata = a(this.fire, this, "load"), t) {
                for(var i = e.getElementsByTagName("source"), n = [], o = 0; o < i.length; o++)n.push(i[o].src);
                this._url = 0 < i.length ? n : [
                    e.src
                ];
            } else {
                d(this._url) || (this._url = [
                    this._url
                ]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(e.style, "objectFit") && (e.style.objectFit = "fill"), e.autoplay = !!this.options.autoplay, e.loop = !!this.options.loop, e.muted = !!this.options.muted, e.playsInline = !!this.options.playsInline;
                for(var s = 0; s < this._url.length; s++){
                    var r = P("source");
                    r.src = this._url[s], e.appendChild(r);
                }
            }
        }
    });
    var Oi = Ei.extend({
        _initImage: function() {
            var t = this._image = this._url;
            M(t, "leaflet-image-layer"), this._zoomAnimated && M(t, "leaflet-zoom-animated"), this.options.className && M(t, this.options.className), t.onselectstart = u, t.onmousemove = u;
        }
    });
    var Ai = o.extend({
        options: {
            interactive: !1,
            offset: [
                0,
                0
            ],
            className: "",
            pane: void 0,
            content: ""
        },
        initialize: function(t, e) {
            t && (t instanceof v || d(t)) ? (this._latlng = w(t), c(this, e)) : (c(this, t), this._source = e), this.options.content && (this._content = this.options.content);
        },
        openOn: function(t) {
            return (t = arguments.length ? t : this._source._map).hasLayer(this) || t.addLayer(this), this;
        },
        close: function() {
            return this._map && this._map.removeLayer(this), this;
        },
        toggle: function(t) {
            return this._map ? this.close() : (arguments.length ? this._source = t : t = this._source, this._prepareOpen(), this.openOn(t._map)), this;
        },
        onAdd: function(t) {
            this._zoomAnimated = t._zoomAnimated, this._container || this._initLayout(), t._fadeAnimated && C(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), t._fadeAnimated && C(this._container, 1), this.bringToFront(), this.options.interactive && (M(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
        },
        onRemove: function(t) {
            t._fadeAnimated ? (C(this._container, 0), this._removeTimeout = setTimeout(a(T, void 0, this._container), 200)) : T(this._container), this.options.interactive && (z(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
        },
        getLatLng: function() {
            return this._latlng;
        },
        setLatLng: function(t) {
            return this._latlng = w(t), this._map && (this._updatePosition(), this._adjustPan()), this;
        },
        getContent: function() {
            return this._content;
        },
        setContent: function(t) {
            return this._content = t, this.update(), this;
        },
        getElement: function() {
            return this._container;
        },
        update: function() {
            this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
        },
        getEvents: function() {
            var t = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            return this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
        },
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        bringToFront: function() {
            return this._map && fe(this._container), this;
        },
        bringToBack: function() {
            return this._map && ge(this._container), this;
        },
        _prepareOpen: function(t) {
            if (!(i = this._source)._map) return !1;
            if (i instanceof ci) {
                var e, i = null, n = this._source._layers;
                for(e in n)if (n[e]._map) {
                    i = n[e];
                    break;
                }
                if (!i) return !1;
                this._source = i;
            }
            if (!t) {
                if (i.getCenter) t = i.getCenter();
                else if (i.getLatLng) t = i.getLatLng();
                else {
                    if (!i.getBounds) throw new Error("Unable to get source layer LatLng.");
                    t = i.getBounds().getCenter();
                }
            }
            return this.setLatLng(t), this._map && this.update(), !0;
        },
        _updateContent: function() {
            if (this._content) {
                var t = this._contentNode, e = "function" == typeof this._content ? this._content(this._source || this) : this._content;
                if ("string" == typeof e) t.innerHTML = e;
                else {
                    for(; t.hasChildNodes();)t.removeChild(t.firstChild);
                    t.appendChild(e);
                }
                this.fire("contentupdate");
            }
        },
        _updatePosition: function() {
            var t, e, i;
            this._map && (e = this._map.latLngToLayerPoint(this._latlng), t = m(this.options.offset), i = this._getAnchor(), this._zoomAnimated ? Z(this._container, e.add(i)) : t = t.add(e).add(i), e = this._containerBottom = -t.y, i = this._containerLeft = -Math.round(this._containerWidth / 2) + t.x, this._container.style.bottom = e + "px", this._container.style.left = i + "px");
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    }), Bi = (A.include({
        _initOverlay: function(t, e, i, n) {
            var o = e;
            return o instanceof t || (o = new t(n).setContent(e)), i && o.setLatLng(i), o;
        }
    }), o.include({
        _initOverlay: function(t, e, i, n) {
            var o = i;
            return o instanceof t ? (c(o, n), o._source = this) : (o = e && !n ? e : new t(n, this)).setContent(i), o;
        }
    }), Ai.extend({
        options: {
            pane: "popupPane",
            offset: [
                0,
                7
            ],
            maxWidth: 300,
            minWidth: 50,
            maxHeight: null,
            autoPan: !0,
            autoPanPaddingTopLeft: null,
            autoPanPaddingBottomRight: null,
            autoPanPadding: [
                5,
                5
            ],
            keepInView: !1,
            closeButton: !0,
            autoClose: !0,
            closeOnEscapeKey: !0,
            className: ""
        },
        openOn: function(t) {
            return !(t = arguments.length ? t : this._source._map).hasLayer(this) && t._popup && t._popup.options.autoClose && t.removeLayer(t._popup), t._popup = this, Ai.prototype.openOn.call(this, t);
        },
        onAdd: function(t) {
            Ai.prototype.onAdd.call(this, t), t.fire("popupopen", {
                popup: this
            }), this._source && (this._source.fire("popupopen", {
                popup: this
            }, !0), this._source instanceof fi || this._source.on("preclick", Ae));
        },
        onRemove: function(t) {
            Ai.prototype.onRemove.call(this, t), t.fire("popupclose", {
                popup: this
            }), this._source && (this._source.fire("popupclose", {
                popup: this
            }, !0), this._source instanceof fi || this._source.off("preclick", Ae));
        },
        getEvents: function() {
            var t = Ai.prototype.getEvents.call(this);
            return (void 0 !== this.options.closeOnClick ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (t.preclick = this.close), this.options.keepInView && (t.moveend = this._adjustPan), t;
        },
        _initLayout: function() {
            var t = "leaflet-popup", e = this._container = P("div", t + " " + (this.options.className || "") + " leaflet-zoom-animated"), i = this._wrapper = P("div", t + "-content-wrapper", e);
            this._contentNode = P("div", t + "-content", i), Ie(e), Be(this._contentNode), S(e, "contextmenu", Ae), this._tipContainer = P("div", t + "-tip-container", e), this._tip = P("div", t + "-tip", this._tipContainer), this.options.closeButton && ((i = this._closeButton = P("a", t + "-close-button", e)).setAttribute("role", "button"), i.setAttribute("aria-label", "Close popup"), i.href = "#close", i.innerHTML = '<span aria-hidden="true">&#215;</span>', S(i, "click", function(t) {
                O(t), this.close();
            }, this));
        },
        _updateLayout: function() {
            var t = this._contentNode, e = t.style, i = (e.width = "", e.whiteSpace = "nowrap", t.offsetWidth), i = Math.min(i, this.options.maxWidth), i = (i = Math.max(i, this.options.minWidth), e.width = i + 1 + "px", e.whiteSpace = "", e.height = "", t.offsetHeight), n = this.options.maxHeight, o = "leaflet-popup-scrolled";
            (n && n < i ? (e.height = n + "px", M) : z)(t, o), this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(t) {
            var t = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center), e = this._getAnchor();
            Z(this._container, t.add(e));
        },
        _adjustPan: function() {
            var t, e, i, n, o, s, r, a;
            this.options.autoPan && (this._map._panAnim && this._map._panAnim.stop(), this._autopanning ? this._autopanning = !1 : (t = this._map, e = parseInt(pe(this._container, "marginBottom"), 10) || 0, e = this._container.offsetHeight + e, a = this._containerWidth, (i = new p(this._containerLeft, -e - this._containerBottom))._add(Pe(this._container)), i = t.layerPointToContainerPoint(i), o = m(this.options.autoPanPadding), n = m(this.options.autoPanPaddingTopLeft || o), o = m(this.options.autoPanPaddingBottomRight || o), s = t.getSize(), r = 0, i.x + a + o.x > s.x && (r = i.x + a - s.x + o.x), i.x - r - n.x < (a = 0) && (r = i.x - n.x), i.y + e + o.y > s.y && (a = i.y + e - s.y + o.y), i.y - a - n.y < 0 && (a = i.y - n.y), (r || a) && (this.options.keepInView && (this._autopanning = !0), t.fire("autopanstart").panBy([
                r,
                a
            ]))));
        },
        _getAnchor: function() {
            return m(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    })), Ii = (A.mergeOptions({
        closePopupOnClick: !0
    }), A.include({
        openPopup: function(t, e, i) {
            return this._initOverlay(Bi, t, e, i).openOn(this), this;
        },
        closePopup: function(t) {
            return (t = arguments.length ? t : this._popup) && t.close(), this;
        }
    }), o.include({
        bindPopup: function(t, e) {
            return this._popup = this._initOverlay(Bi, this._popup, t, e), this._popupHandlersAdded || (this.on({
                click: this._openPopup,
                keypress: this._onKeyPress,
                remove: this.closePopup,
                move: this._movePopup
            }), this._popupHandlersAdded = !0), this;
        },
        unbindPopup: function() {
            return this._popup && (this.off({
                click: this._openPopup,
                keypress: this._onKeyPress,
                remove: this.closePopup,
                move: this._movePopup
            }), this._popupHandlersAdded = !1, this._popup = null), this;
        },
        openPopup: function(t) {
            return this._popup && (this instanceof ci || (this._popup._source = this), this._popup._prepareOpen(t || this._latlng) && this._popup.openOn(this._map)), this;
        },
        closePopup: function() {
            return this._popup && this._popup.close(), this;
        },
        togglePopup: function() {
            return this._popup && this._popup.toggle(this), this;
        },
        isPopupOpen: function() {
            return !!this._popup && this._popup.isOpen();
        },
        setPopupContent: function(t) {
            return this._popup && this._popup.setContent(t), this;
        },
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(t) {
            var e;
            this._popup && this._map && (Re(t), e = t.layer || t.target, this._popup._source !== e || e instanceof fi ? (this._popup._source = e, this.openPopup(t.latlng)) : this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(t.latlng));
        },
        _movePopup: function(t) {
            this._popup.setLatLng(t.latlng);
        },
        _onKeyPress: function(t) {
            13 === t.originalEvent.keyCode && this._openPopup(t);
        }
    }), Ai.extend({
        options: {
            pane: "tooltipPane",
            offset: [
                0,
                0
            ],
            direction: "auto",
            permanent: !1,
            sticky: !1,
            opacity: .9
        },
        onAdd: function(t) {
            Ai.prototype.onAdd.call(this, t), this.setOpacity(this.options.opacity), t.fire("tooltipopen", {
                tooltip: this
            }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", {
                tooltip: this
            }, !0));
        },
        onRemove: function(t) {
            Ai.prototype.onRemove.call(this, t), t.fire("tooltipclose", {
                tooltip: this
            }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", {
                tooltip: this
            }, !0));
        },
        getEvents: function() {
            var t = Ai.prototype.getEvents.call(this);
            return this.options.permanent || (t.preclick = this.close), t;
        },
        _initLayout: function() {
            var t = "leaflet-tooltip " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = P("div", t), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + h(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(t) {
            var e, i = this._map, n = this._container, o = i.latLngToContainerPoint(i.getCenter()), i = i.layerPointToContainerPoint(t), s = this.options.direction, r = n.offsetWidth, a = n.offsetHeight, h = m(this.options.offset), l = this._getAnchor(), i = "top" === s ? (e = r / 2, a) : "bottom" === s ? (e = r / 2, 0) : (e = "center" === s ? r / 2 : "right" === s ? 0 : "left" === s ? r : i.x < o.x ? (s = "right", 0) : (s = "left", r + 2 * (h.x + l.x)), a / 2);
            t = t.subtract(m(e, i, !0)).add(h).add(l), z(n, "leaflet-tooltip-right"), z(n, "leaflet-tooltip-left"), z(n, "leaflet-tooltip-top"), z(n, "leaflet-tooltip-bottom"), M(n, "leaflet-tooltip-" + s), Z(n, t);
        },
        _updatePosition: function() {
            var t = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(t);
        },
        setOpacity: function(t) {
            this.options.opacity = t, this._container && C(this._container, t);
        },
        _animateZoom: function(t) {
            t = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center);
            this._setPosition(t);
        },
        _getAnchor: function() {
            return m(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    })), Ri = (A.include({
        openTooltip: function(t, e, i) {
            return this._initOverlay(Ii, t, e, i).openOn(this), this;
        },
        closeTooltip: function(t) {
            return t.close(), this;
        }
    }), o.include({
        bindTooltip: function(t, e) {
            return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(Ii, this._tooltip, t, e), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
        },
        unbindTooltip: function() {
            return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
        },
        _initTooltipInteractions: function(t) {
            var e, i;
            !t && this._tooltipHandlersAdded || (e = t ? "off" : "on", i = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            }, this._tooltip.options.permanent ? i.add = this._openTooltip : (i.mouseover = this._openTooltip, i.mouseout = this.closeTooltip, i.click = this._openTooltip, this._map ? this._addFocusListeners() : i.add = this._addFocusListeners), this._tooltip.options.sticky && (i.mousemove = this._moveTooltip), this[e](i), this._tooltipHandlersAdded = !t);
        },
        openTooltip: function(t) {
            return this._tooltip && (this instanceof ci || (this._tooltip._source = this), this._tooltip._prepareOpen(t) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
        },
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        toggleTooltip: function() {
            return this._tooltip && this._tooltip.toggle(this), this;
        },
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        setTooltipContent: function(t) {
            return this._tooltip && this._tooltip.setContent(t), this;
        },
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(t) {
            var e = "function" == typeof t.getElement && t.getElement();
            e && (S(e, "focus", function() {
                this._tooltip._source = t, this.openTooltip();
            }, this), S(e, "blur", this.closeTooltip, this));
        },
        _setAriaDescribedByOnLayer: function(t) {
            t = "function" == typeof t.getElement && t.getElement();
            t && t.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(t) {
            var e;
            this._tooltip && this._map && (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag ? (this._openOnceFlag = !0, (e = this)._map.once("moveend", function() {
                e._openOnceFlag = !1, e._openTooltip(t);
            })) : (this._tooltip._source = t.layer || t.target, this.openTooltip(this._tooltip.options.sticky ? t.latlng : void 0)));
        },
        _moveTooltip: function(t) {
            var e = t.latlng;
            this._tooltip.options.sticky && t.originalEvent && (t = this._map.mouseEventToContainerPoint(t.originalEvent), t = this._map.containerPointToLayerPoint(t), e = this._map.layerPointToLatLng(t)), this._tooltip.setLatLng(e);
        }
    }), di.extend({
        options: {
            iconSize: [
                12,
                12
            ],
            html: !1,
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(t) {
            var t = t && "DIV" === t.tagName ? t : document.createElement("div"), e = this.options;
            return e.html instanceof Element ? (me(t), t.appendChild(e.html)) : t.innerHTML = !1 !== e.html ? e.html : "", e.bgPos && (e = m(e.bgPos), t.style.backgroundPosition = -e.x + "px " + -e.y + "px"), this._setIconStyles(t, "icon"), t;
        },
        createShadow: function() {
            return null;
        }
    }));
    di.Default = _i;
    var Ni = o.extend({
        options: {
            tileSize: 256,
            opacity: 1,
            updateWhenIdle: b.mobile,
            updateWhenZooming: !0,
            updateInterval: 200,
            zIndex: 1,
            bounds: null,
            minZoom: 0,
            maxZoom: void 0,
            maxNativeZoom: void 0,
            minNativeZoom: void 0,
            noWrap: !1,
            pane: "tilePane",
            className: "",
            keepBuffer: 2
        },
        initialize: function(t) {
            c(this, t);
        },
        onAdd: function() {
            this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
        },
        beforeAdd: function(t) {
            t._addZoomLimit(this);
        },
        onRemove: function(t) {
            this._removeAllTiles(), T(this._container), t._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
        },
        bringToFront: function() {
            return this._map && (fe(this._container), this._setAutoZIndex(Math.max)), this;
        },
        bringToBack: function() {
            return this._map && (ge(this._container), this._setAutoZIndex(Math.min)), this;
        },
        getContainer: function() {
            return this._container;
        },
        setOpacity: function(t) {
            return this.options.opacity = t, this._updateOpacity(), this;
        },
        setZIndex: function(t) {
            return this.options.zIndex = t, this._updateZIndex(), this;
        },
        isLoading: function() {
            return this._loading;
        },
        redraw: function() {
            var t;
            return this._map && (this._removeAllTiles(), (t = this._clampZoom(this._map.getZoom())) !== this._tileZoom && (this._tileZoom = t, this._updateLevels()), this._update()), this;
        },
        getEvents: function() {
            var t = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            return this.options.updateWhenIdle || (this._onMove || (this._onMove = j(this._onMoveEnd, this.options.updateInterval, this)), t.move = this._onMove), this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
        },
        createTile: function() {
            return document.createElement("div");
        },
        getTileSize: function() {
            var t = this.options.tileSize;
            return t instanceof p ? t : new p(t, t);
        },
        _updateZIndex: function() {
            this._container && void 0 !== this.options.zIndex && null !== this.options.zIndex && (this._container.style.zIndex = this.options.zIndex);
        },
        _setAutoZIndex: function(t) {
            for(var e, i = this.getPane().children, n = -t(-1 / 0, 1 / 0), o = 0, s = i.length; o < s; o++)e = i[o].style.zIndex, i[o] !== this._container && e && (n = t(n, +e));
            isFinite(n) && (this.options.zIndex = n + t(-1, 1), this._updateZIndex());
        },
        _updateOpacity: function() {
            if (this._map && !b.ielt9) {
                C(this._container, this.options.opacity);
                var t, e = +new Date, i = !1, n = !1;
                for(t in this._tiles){
                    var o, s = this._tiles[t];
                    s.current && s.loaded && (o = Math.min(1, (e - s.loaded) / 200), C(s.el, o), o < 1 ? i = !0 : (s.active ? n = !0 : this._onOpaqueTile(s), s.active = !0));
                }
                n && !this._noPrune && this._pruneTiles(), i && (r(this._fadeFrame), this._fadeFrame = x(this._updateOpacity, this));
            }
        },
        _onOpaqueTile: u,
        _initContainer: function() {
            this._container || (this._container = P("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
        },
        _updateLevels: function() {
            var t = this._tileZoom, e = this.options.maxZoom;
            if (void 0 !== t) {
                for(var i in this._levels)i = Number(i), this._levels[i].el.children.length || i === t ? (this._levels[i].el.style.zIndex = e - Math.abs(t - i), this._onUpdateLevel(i)) : (T(this._levels[i].el), this._removeTilesAtZoom(i), this._onRemoveLevel(i), delete this._levels[i]);
                var n = this._levels[t], o = this._map;
                return n || ((n = this._levels[t] = {}).el = P("div", "leaflet-tile-container leaflet-zoom-animated", this._container), n.el.style.zIndex = e, n.origin = o.project(o.unproject(o.getPixelOrigin()), t).round(), n.zoom = t, this._setZoomTransform(n, o.getCenter(), o.getZoom()), u(n.el.offsetWidth), this._onCreateLevel(n)), this._level = n;
            }
        },
        _onUpdateLevel: u,
        _onRemoveLevel: u,
        _onCreateLevel: u,
        _pruneTiles: function() {
            if (this._map) {
                var t, e, i, n = this._map.getZoom();
                if (n > this.options.maxZoom || n < this.options.minZoom) this._removeAllTiles();
                else {
                    for(t in this._tiles)(i = this._tiles[t]).retain = i.current;
                    for(t in this._tiles)(i = this._tiles[t]).current && !i.active && (e = i.coords, this._retainParent(e.x, e.y, e.z, e.z - 5) || this._retainChildren(e.x, e.y, e.z, e.z + 2));
                    for(t in this._tiles)this._tiles[t].retain || this._removeTile(t);
                }
            }
        },
        _removeTilesAtZoom: function(t) {
            for(var e in this._tiles)this._tiles[e].coords.z === t && this._removeTile(e);
        },
        _removeAllTiles: function() {
            for(var t in this._tiles)this._removeTile(t);
        },
        _invalidateAll: function() {
            for(var t in this._levels)T(this._levels[t].el), this._onRemoveLevel(Number(t)), delete this._levels[t];
            this._removeAllTiles(), this._tileZoom = void 0;
        },
        _retainParent: function(t, e, i, n) {
            var t = Math.floor(t / 2), e = Math.floor(e / 2), i = i - 1, o = new p(+t, +e), o = (o.z = i, this._tileCoordsToKey(o)), o = this._tiles[o];
            return o && o.active ? o.retain = !0 : (o && o.loaded && (o.retain = !0), n < i && this._retainParent(t, e, i, n));
        },
        _retainChildren: function(t, e, i, n) {
            for(var o = 2 * t; o < 2 * t + 2; o++)for(var s = 2 * e; s < 2 * e + 2; s++){
                var r = new p(o, s), r = (r.z = i + 1, this._tileCoordsToKey(r)), r = this._tiles[r];
                r && r.active ? r.retain = !0 : (r && r.loaded && (r.retain = !0), i + 1 < n && this._retainChildren(o, s, i + 1, n));
            }
        },
        _resetView: function(t) {
            t = t && (t.pinch || t.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), t, t);
        },
        _animateZoom: function(t) {
            this._setView(t.center, t.zoom, !0, t.noUpdate);
        },
        _clampZoom: function(t) {
            var e = this.options;
            return void 0 !== e.minNativeZoom && t < e.minNativeZoom ? e.minNativeZoom : void 0 !== e.maxNativeZoom && e.maxNativeZoom < t ? e.maxNativeZoom : t;
        },
        _setView: function(t, e, i, n) {
            var o = Math.round(e), o = void 0 !== this.options.maxZoom && o > this.options.maxZoom || void 0 !== this.options.minZoom && o < this.options.minZoom ? void 0 : this._clampZoom(o), s = this.options.updateWhenZooming && o !== this._tileZoom;
            n && !s || (this._tileZoom = o, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), void 0 !== o && this._update(t), i || this._pruneTiles(), this._noPrune = !!i), this._setZoomTransforms(t, e);
        },
        _setZoomTransforms: function(t, e) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], t, e);
        },
        _setZoomTransform: function(t, e, i) {
            var n = this._map.getZoomScale(i, t.zoom), e = t.origin.multiplyBy(n).subtract(this._map._getNewPixelOrigin(e, i)).round();
            b.any3d ? be(t.el, e, n) : Z(t.el, e);
        },
        _resetGrid: function() {
            var t = this._map, e = t.options.crs, i = this._tileSize = this.getTileSize(), n = this._tileZoom, o = this._map.getPixelWorldBounds(this._tileZoom);
            o && (this._globalTileRange = this._pxBoundsToTileRange(o)), this._wrapX = e.wrapLng && !this.options.noWrap && [
                Math.floor(t.project([
                    0,
                    e.wrapLng[0]
                ], n).x / i.x),
                Math.ceil(t.project([
                    0,
                    e.wrapLng[1]
                ], n).x / i.y)
            ], this._wrapY = e.wrapLat && !this.options.noWrap && [
                Math.floor(t.project([
                    e.wrapLat[0],
                    0
                ], n).y / i.x),
                Math.ceil(t.project([
                    e.wrapLat[1],
                    0
                ], n).y / i.y)
            ];
        },
        _onMoveEnd: function() {
            this._map && !this._map._animatingZoom && this._update();
        },
        _getTiledPixelBounds: function(t) {
            var e = this._map, i = e._animatingZoom ? Math.max(e._animateToZoom, e.getZoom()) : e.getZoom(), i = e.getZoomScale(i, this._tileZoom), t = e.project(t, this._tileZoom).floor(), e = e.getSize().divideBy(2 * i);
            return new f(t.subtract(e), t.add(e));
        },
        _update: function(t) {
            var e = this._map;
            if (e) {
                var i = this._clampZoom(e.getZoom());
                if (void 0 === t && (t = e.getCenter()), void 0 !== this._tileZoom) {
                    var n, e = this._getTiledPixelBounds(t), o = this._pxBoundsToTileRange(e), s = o.getCenter(), r = [], e = this.options.keepBuffer, a = new f(o.getBottomLeft().subtract([
                        e,
                        -e
                    ]), o.getTopRight().add([
                        e,
                        -e
                    ]));
                    if (!(isFinite(o.min.x) && isFinite(o.min.y) && isFinite(o.max.x) && isFinite(o.max.y))) throw new Error("Attempted to load an infinite number of tiles");
                    for(n in this._tiles){
                        var h = this._tiles[n].coords;
                        h.z === this._tileZoom && a.contains(new p(h.x, h.y)) || (this._tiles[n].current = !1);
                    }
                    if (1 < Math.abs(i - this._tileZoom)) this._setView(t, i);
                    else {
                        for(var l = o.min.y; l <= o.max.y; l++)for(var u = o.min.x; u <= o.max.x; u++){
                            var c, d = new p(u, l);
                            d.z = this._tileZoom, this._isValidTile(d) && ((c = this._tiles[this._tileCoordsToKey(d)]) ? c.current = !0 : r.push(d));
                        }
                        if (r.sort(function(t, e) {
                            return t.distanceTo(s) - e.distanceTo(s);
                        }), 0 !== r.length) {
                            this._loading || (this._loading = !0, this.fire("loading"));
                            for(var _ = document.createDocumentFragment(), u = 0; u < r.length; u++)this._addTile(r[u], _);
                            this._level.el.appendChild(_);
                        }
                    }
                }
            }
        },
        _isValidTile: function(t) {
            var e = this._map.options.crs;
            if (!e.infinite) {
                var i = this._globalTileRange;
                if (!e.wrapLng && (t.x < i.min.x || t.x > i.max.x) || !e.wrapLat && (t.y < i.min.y || t.y > i.max.y)) return !1;
            }
            return !this.options.bounds || (e = this._tileCoordsToBounds(t), g(this.options.bounds).overlaps(e));
        },
        _keyToBounds: function(t) {
            return this._tileCoordsToBounds(this._keyToTileCoords(t));
        },
        _tileCoordsToNwSe: function(t) {
            var e = this._map, i = this.getTileSize(), n = t.scaleBy(i), i = n.add(i);
            return [
                e.unproject(n, t.z),
                e.unproject(i, t.z)
            ];
        },
        _tileCoordsToBounds: function(t) {
            t = this._tileCoordsToNwSe(t), t = new s(t[0], t[1]);
            return t = this.options.noWrap ? t : this._map.wrapLatLngBounds(t);
        },
        _tileCoordsToKey: function(t) {
            return t.x + ":" + t.y + ":" + t.z;
        },
        _keyToTileCoords: function(t) {
            var t = t.split(":"), e = new p(+t[0], +t[1]);
            return e.z = +t[2], e;
        },
        _removeTile: function(t) {
            var e = this._tiles[t];
            e && (T(e.el), delete this._tiles[t], this.fire("tileunload", {
                tile: e.el,
                coords: this._keyToTileCoords(t)
            }));
        },
        _initTile: function(t) {
            M(t, "leaflet-tile");
            var e = this.getTileSize();
            t.style.width = e.x + "px", t.style.height = e.y + "px", t.onselectstart = u, t.onmousemove = u, b.ielt9 && this.options.opacity < 1 && C(t, this.options.opacity);
        },
        _addTile: function(t, e) {
            var i = this._getTilePos(t), n = this._tileCoordsToKey(t), o = this.createTile(this._wrapCoords(t), a(this._tileReady, this, t));
            this._initTile(o), this.createTile.length < 2 && x(a(this._tileReady, this, t, null, o)), Z(o, i), this._tiles[n] = {
                el: o,
                coords: t,
                current: !0
            }, e.appendChild(o), this.fire("tileloadstart", {
                tile: o,
                coords: t
            });
        },
        _tileReady: function(t, e, i) {
            e && this.fire("tileerror", {
                error: e,
                tile: i,
                coords: t
            });
            var n = this._tileCoordsToKey(t);
            (i = this._tiles[n]) && (i.loaded = +new Date, this._map._fadeAnimated ? (C(i.el, 0), r(this._fadeFrame), this._fadeFrame = x(this._updateOpacity, this)) : (i.active = !0, this._pruneTiles()), e || (M(i.el, "leaflet-tile-loaded"), this.fire("tileload", {
                tile: i.el,
                coords: t
            })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), b.ielt9 || !this._map._fadeAnimated ? x(this._pruneTiles, this) : setTimeout(a(this._pruneTiles, this), 250)));
        },
        _getTilePos: function(t) {
            return t.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(t) {
            var e = new p(this._wrapX ? H(t.x, this._wrapX) : t.x, this._wrapY ? H(t.y, this._wrapY) : t.y);
            return e.z = t.z, e;
        },
        _pxBoundsToTileRange: function(t) {
            var e = this.getTileSize();
            return new f(t.min.unscaleBy(e).floor(), t.max.unscaleBy(e).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var t in this._tiles)if (!this._tiles[t].loaded) return !1;
            return !0;
        }
    });
    var Di = Ni.extend({
        options: {
            minZoom: 0,
            maxZoom: 18,
            subdomains: "abc",
            errorTileUrl: "",
            zoomOffset: 0,
            tms: !1,
            zoomReverse: !1,
            detectRetina: !1,
            crossOrigin: !1,
            referrerPolicy: !1
        },
        initialize: function(t, e) {
            this._url = t, (e = c(this, e)).detectRetina && b.retina && 0 < e.maxZoom ? (e.tileSize = Math.floor(e.tileSize / 2), e.zoomReverse ? (e.zoomOffset--, e.minZoom = Math.min(e.maxZoom, e.minZoom + 1)) : (e.zoomOffset++, e.maxZoom = Math.max(e.minZoom, e.maxZoom - 1)), e.minZoom = Math.max(0, e.minZoom)) : e.zoomReverse ? e.minZoom = Math.min(e.maxZoom, e.minZoom) : e.maxZoom = Math.max(e.minZoom, e.maxZoom), "string" == typeof e.subdomains && (e.subdomains = e.subdomains.split("")), this.on("tileunload", this._onTileRemove);
        },
        setUrl: function(t, e) {
            return this._url === t && void 0 === e && (e = !0), this._url = t, e || this.redraw(), this;
        },
        createTile: function(t, e) {
            var i = document.createElement("img");
            return S(i, "load", a(this._tileOnLoad, this, e, i)), S(i, "error", a(this._tileOnError, this, e, i)), !this.options.crossOrigin && "" !== this.options.crossOrigin || (i.crossOrigin = !0 === this.options.crossOrigin ? "" : this.options.crossOrigin), "string" == typeof this.options.referrerPolicy && (i.referrerPolicy = this.options.referrerPolicy), i.alt = "", i.src = this.getTileUrl(t), i;
        },
        getTileUrl: function(t) {
            var e = {
                r: b.retina ? "@2x" : "",
                s: this._getSubdomain(t),
                x: t.x,
                y: t.y,
                z: this._getZoomForUrl()
            };
            return this._map && !this._map.options.crs.infinite && (t = this._globalTileRange.max.y - t.y, this.options.tms && (e.y = t), e["-y"] = t), q(this._url, l(e, this.options));
        },
        _tileOnLoad: function(t, e) {
            b.ielt9 ? setTimeout(a(t, this, null, e), 0) : t(null, e);
        },
        _tileOnError: function(t, e, i) {
            var n = this.options.errorTileUrl;
            n && e.getAttribute("src") !== n && (e.src = n), t(i, e);
        },
        _onTileRemove: function(t) {
            t.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var t = this._tileZoom, e = this.options.maxZoom;
            return (t = this.options.zoomReverse ? e - t : t) + this.options.zoomOffset;
        },
        _getSubdomain: function(t) {
            t = Math.abs(t.x + t.y) % this.options.subdomains.length;
            return this.options.subdomains[t];
        },
        _abortLoading: function() {
            var t, e, i;
            for(t in this._tiles)this._tiles[t].coords.z !== this._tileZoom && ((i = this._tiles[t].el).onload = u, i.onerror = u, i.complete || (i.src = K, e = this._tiles[t].coords, T(i), delete this._tiles[t], this.fire("tileabort", {
                tile: i,
                coords: e
            })));
        },
        _removeTile: function(t) {
            var e = this._tiles[t];
            if (e) return e.el.setAttribute("src", K), Ni.prototype._removeTile.call(this, t);
        },
        _tileReady: function(t, e, i) {
            if (this._map && (!i || i.getAttribute("src") !== K)) return Ni.prototype._tileReady.call(this, t, e, i);
        }
    });
    function ji(t, e) {
        return new Di(t, e);
    }
    var Hi = Di.extend({
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            layers: "",
            styles: "",
            format: "image/jpeg",
            transparent: !1,
            version: "1.1.1"
        },
        options: {
            crs: null,
            uppercase: !1
        },
        initialize: function(t, e) {
            this._url = t;
            var i, n = l({}, this.defaultWmsParams);
            for(i in e)i in this.options || (n[i] = e[i]);
            var t = (e = c(this, e)).detectRetina && b.retina ? 2 : 1, o = this.getTileSize();
            n.width = o.x * t, n.height = o.y * t, this.wmsParams = n;
        },
        onAdd: function(t) {
            this._crs = this.options.crs || t.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
            var e = 1.3 <= this._wmsVersion ? "crs" : "srs";
            this.wmsParams[e] = this._crs.code, Di.prototype.onAdd.call(this, t);
        },
        getTileUrl: function(t) {
            var e = this._tileCoordsToNwSe(t), i = this._crs, i = _(i.project(e[0]), i.project(e[1])), e = i.min, i = i.max, e = (1.3 <= this._wmsVersion && this._crs === li ? [
                e.y,
                e.x,
                i.y,
                i.x
            ] : [
                e.x,
                e.y,
                i.x,
                i.y
            ]).join(","), i = Di.prototype.getTileUrl.call(this, t);
            return i + U(this.wmsParams, i, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + e;
        },
        setParams: function(t, e) {
            return l(this.wmsParams, t), e || this.redraw(), this;
        }
    });
    Di.WMS = Hi, ji.wms = function(t, e) {
        return new Hi(t, e);
    };
    var Wi = o.extend({
        options: {
            padding: .1
        },
        initialize: function(t) {
            c(this, t), h(this), this._layers = this._layers || {};
        },
        onAdd: function() {
            this._container || (this._initContainer(), M(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this), this._destroyContainer();
        },
        getEvents: function() {
            var t = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            return this._zoomAnimated && (t.zoomanim = this._onAnimZoom), t;
        },
        _onAnimZoom: function(t) {
            this._updateTransform(t.center, t.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(t, e) {
            var i = this._map.getZoomScale(e, this._zoom), n = this._map.getSize().multiplyBy(.5 + this.options.padding), o = this._map.project(this._center, e), n = n.multiplyBy(-i).add(o).subtract(this._map._getNewPixelOrigin(t, e));
            b.any3d ? be(this._container, n, i) : Z(this._container, n);
        },
        _reset: function() {
            for(var t in this._update(), this._updateTransform(this._center, this._zoom), this._layers)this._layers[t]._reset();
        },
        _onZoomEnd: function() {
            for(var t in this._layers)this._layers[t]._project();
        },
        _updatePaths: function() {
            for(var t in this._layers)this._layers[t]._update();
        },
        _update: function() {
            var t = this.options.padding, e = this._map.getSize(), i = this._map.containerPointToLayerPoint(e.multiplyBy(-t)).round();
            this._bounds = new f(i, i.add(e.multiplyBy(1 + 2 * t)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
        }
    }), Fi = Wi.extend({
        options: {
            tolerance: 0
        },
        getEvents: function() {
            var t = Wi.prototype.getEvents.call(this);
            return t.viewprereset = this._onViewPreReset, t;
        },
        _onViewPreReset: function() {
            this._postponeUpdatePaths = !0;
        },
        onAdd: function() {
            Wi.prototype.onAdd.call(this), this._draw();
        },
        _initContainer: function() {
            var t = this._container = document.createElement("canvas");
            S(t, "mousemove", this._onMouseMove, this), S(t, "click dblclick mousedown mouseup contextmenu", this._onClick, this), S(t, "mouseout", this._handleMouseOut, this), t._leaflet_disable_events = !0, this._ctx = t.getContext("2d");
        },
        _destroyContainer: function() {
            r(this._redrawRequest), delete this._ctx, T(this._container), k(this._container), delete this._container;
        },
        _updatePaths: function() {
            if (!this._postponeUpdatePaths) {
                for(var t in this._redrawBounds = null, this._layers)this._layers[t]._update();
                this._redraw();
            }
        },
        _update: function() {
            var t, e, i, n;
            this._map._animatingZoom && this._bounds || (Wi.prototype._update.call(this), t = this._bounds, e = this._container, i = t.getSize(), n = b.retina ? 2 : 1, Z(e, t.min), e.width = n * i.x, e.height = n * i.y, e.style.width = i.x + "px", e.style.height = i.y + "px", b.retina && this._ctx.scale(2, 2), this._ctx.translate(-t.min.x, -t.min.y), this.fire("update"));
        },
        _reset: function() {
            Wi.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
        },
        _initPath: function(t) {
            this._updateDashArray(t);
            t = (this._layers[h(t)] = t)._order = {
                layer: t,
                prev: this._drawLast,
                next: null
            };
            this._drawLast && (this._drawLast.next = t), this._drawLast = t, this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(t) {
            this._requestRedraw(t);
        },
        _removePath: function(t) {
            var e = t._order, i = e.next, e = e.prev;
            i ? i.prev = e : this._drawLast = e, e ? e.next = i : this._drawFirst = i, delete t._order, delete this._layers[h(t)], this._requestRedraw(t);
        },
        _updatePath: function(t) {
            this._extendRedrawBounds(t), t._project(), t._update(), this._requestRedraw(t);
        },
        _updateStyle: function(t) {
            this._updateDashArray(t), this._requestRedraw(t);
        },
        _updateDashArray: function(t) {
            if ("string" == typeof t.options.dashArray) {
                for(var e, i = t.options.dashArray.split(/[, ]+/), n = [], o = 0; o < i.length; o++){
                    if (e = Number(i[o]), isNaN(e)) return;
                    n.push(e);
                }
                t.options._dashArray = n;
            } else t.options._dashArray = t.options.dashArray;
        },
        _requestRedraw: function(t) {
            this._map && (this._extendRedrawBounds(t), this._redrawRequest = this._redrawRequest || x(this._redraw, this));
        },
        _extendRedrawBounds: function(t) {
            var e;
            t._pxBounds && (e = (t.options.weight || 0) + 1, this._redrawBounds = this._redrawBounds || new f, this._redrawBounds.extend(t._pxBounds.min.subtract([
                e,
                e
            ])), this._redrawBounds.extend(t._pxBounds.max.add([
                e,
                e
            ])));
        },
        _redraw: function() {
            this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
        },
        _clear: function() {
            var t, e = this._redrawBounds;
            e ? (t = e.getSize(), this._ctx.clearRect(e.min.x, e.min.y, t.x, t.y)) : (this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore());
        },
        _draw: function() {
            var t, e, i = this._redrawBounds;
            this._ctx.save(), i && (e = i.getSize(), this._ctx.beginPath(), this._ctx.rect(i.min.x, i.min.y, e.x, e.y), this._ctx.clip()), this._drawing = !0;
            for(var n = this._drawFirst; n; n = n.next)t = n.layer, (!i || t._pxBounds && t._pxBounds.intersects(i)) && t._updatePath();
            this._drawing = !1, this._ctx.restore();
        },
        _updatePoly: function(t, e) {
            if (this._drawing) {
                var i, n, o, s, r = t._parts, a = r.length, h = this._ctx;
                if (a) {
                    for(h.beginPath(), i = 0; i < a; i++){
                        for(n = 0, o = r[i].length; n < o; n++)s = r[i][n], h[n ? "lineTo" : "moveTo"](s.x, s.y);
                        e && h.closePath();
                    }
                    this._fillStroke(h, t);
                }
            }
        },
        _updateCircle: function(t) {
            var e, i, n, o;
            this._drawing && !t._empty() && (e = t._point, i = this._ctx, n = Math.max(Math.round(t._radius), 1), 1 != (o = (Math.max(Math.round(t._radiusY), 1) || n) / n) && (i.save(), i.scale(1, o)), i.beginPath(), i.arc(e.x, e.y / o, n, 0, 2 * Math.PI, !1), 1 != o && i.restore(), this._fillStroke(i, t));
        },
        _fillStroke: function(t, e) {
            var i = e.options;
            i.fill && (t.globalAlpha = i.fillOpacity, t.fillStyle = i.fillColor || i.color, t.fill(i.fillRule || "evenodd")), i.stroke && 0 !== i.weight && (t.setLineDash && t.setLineDash(e.options && e.options._dashArray || []), t.globalAlpha = i.opacity, t.lineWidth = i.weight, t.strokeStyle = i.color, t.lineCap = i.lineCap, t.lineJoin = i.lineJoin, t.stroke());
        },
        _onClick: function(t) {
            for(var e, i, n = this._map.mouseEventToLayerPoint(t), o = this._drawFirst; o; o = o.next)(e = o.layer).options.interactive && e._containsPoint(n) && (("click" === t.type || "preclick" === t.type) && this._map._draggableMoved(e) || (i = e));
            this._fireEvent(!!i && [
                i
            ], t);
        },
        _onMouseMove: function(t) {
            var e;
            !this._map || this._map.dragging.moving() || this._map._animatingZoom || (e = this._map.mouseEventToLayerPoint(t), this._handleMouseHover(t, e));
        },
        _handleMouseOut: function(t) {
            var e = this._hoveredLayer;
            e && (z(this._container, "leaflet-interactive"), this._fireEvent([
                e
            ], t, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
        },
        _handleMouseHover: function(t, e) {
            if (!this._mouseHoverThrottled) {
                for(var i, n, o = this._drawFirst; o; o = o.next)(i = o.layer).options.interactive && i._containsPoint(e) && (n = i);
                n !== this._hoveredLayer && (this._handleMouseOut(t), n && (M(this._container, "leaflet-interactive"), this._fireEvent([
                    n
                ], t, "mouseover"), this._hoveredLayer = n)), this._fireEvent(!!this._hoveredLayer && [
                    this._hoveredLayer
                ], t), this._mouseHoverThrottled = !0, setTimeout(a(function() {
                    this._mouseHoverThrottled = !1;
                }, this), 32);
            }
        },
        _fireEvent: function(t, e, i) {
            this._map._fireDOMEvent(e, i || e.type, t);
        },
        _bringToFront: function(t) {
            var e, i, n = t._order;
            n && (e = n.next, i = n.prev, e && ((e.prev = i) ? i.next = e : e && (this._drawFirst = e), n.prev = this._drawLast, (this._drawLast.next = n).next = null, this._drawLast = n, this._requestRedraw(t)));
        },
        _bringToBack: function(t) {
            var e, i, n = t._order;
            n && (e = n.next, (i = n.prev) && ((i.next = e) ? e.prev = i : i && (this._drawLast = i), n.prev = null, n.next = this._drawFirst, this._drawFirst.prev = n, this._drawFirst = n, this._requestRedraw(t)));
        }
    });
    function Ui(t) {
        return b.canvas ? new Fi(t) : null;
    }
    var Vi = function() {
        try {
            return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(t) {
                return document.createElement("<lvml:" + t + ' class="lvml">');
            };
        } catch (t) {}
        return function(t) {
            return document.createElement("<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }(), zt = {
        _initContainer: function() {
            this._container = P("div", "leaflet-vml-container");
        },
        _update: function() {
            this._map._animatingZoom || (Wi.prototype._update.call(this), this.fire("update"));
        },
        _initPath: function(t) {
            var e = t._container = Vi("shape");
            M(e, "leaflet-vml-shape " + (this.options.className || "")), e.coordsize = "1 1", t._path = Vi("path"), e.appendChild(t._path), this._updateStyle(t), this._layers[h(t)] = t;
        },
        _addPath: function(t) {
            var e = t._container;
            this._container.appendChild(e), t.options.interactive && t.addInteractiveTarget(e);
        },
        _removePath: function(t) {
            var e = t._container;
            T(e), t.removeInteractiveTarget(e), delete this._layers[h(t)];
        },
        _updateStyle: function(t) {
            var e = t._stroke, i = t._fill, n = t.options, o = t._container;
            o.stroked = !!n.stroke, o.filled = !!n.fill, n.stroke ? (e = e || (t._stroke = Vi("stroke")), o.appendChild(e), e.weight = n.weight + "px", e.color = n.color, e.opacity = n.opacity, n.dashArray ? e.dashStyle = d(n.dashArray) ? n.dashArray.join(" ") : n.dashArray.replace(/( *, *)/g, " ") : e.dashStyle = "", e.endcap = n.lineCap.replace("butt", "flat"), e.joinstyle = n.lineJoin) : e && (o.removeChild(e), t._stroke = null), n.fill ? (i = i || (t._fill = Vi("fill")), o.appendChild(i), i.color = n.fillColor || n.color, i.opacity = n.fillOpacity) : i && (o.removeChild(i), t._fill = null);
        },
        _updateCircle: function(t) {
            var e = t._point.round(), i = Math.round(t._radius), n = Math.round(t._radiusY || i);
            this._setPath(t, t._empty() ? "M0 0" : "AL " + e.x + "," + e.y + " " + i + "," + n + " 0,23592600");
        },
        _setPath: function(t, e) {
            t._path.v = e;
        },
        _bringToFront: function(t) {
            fe(t._container);
        },
        _bringToBack: function(t) {
            ge(t._container);
        }
    }, qi = b.vml ? Vi : ct, Gi = Wi.extend({
        _initContainer: function() {
            this._container = qi("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = qi("g"), this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            T(this._container), k(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
        },
        _update: function() {
            var t, e, i;
            this._map._animatingZoom && this._bounds || (Wi.prototype._update.call(this), e = (t = this._bounds).getSize(), i = this._container, this._svgSize && this._svgSize.equals(e) || (this._svgSize = e, i.setAttribute("width", e.x), i.setAttribute("height", e.y)), Z(i, t.min), i.setAttribute("viewBox", [
                t.min.x,
                t.min.y,
                e.x,
                e.y
            ].join(" ")), this.fire("update"));
        },
        _initPath: function(t) {
            var e = t._path = qi("path");
            t.options.className && M(e, t.options.className), t.options.interactive && M(e, "leaflet-interactive"), this._updateStyle(t), this._layers[h(t)] = t;
        },
        _addPath: function(t) {
            this._rootGroup || this._initContainer(), this._rootGroup.appendChild(t._path), t.addInteractiveTarget(t._path);
        },
        _removePath: function(t) {
            T(t._path), t.removeInteractiveTarget(t._path), delete this._layers[h(t)];
        },
        _updatePath: function(t) {
            t._project(), t._update();
        },
        _updateStyle: function(t) {
            var e = t._path, t = t.options;
            e && (t.stroke ? (e.setAttribute("stroke", t.color), e.setAttribute("stroke-opacity", t.opacity), e.setAttribute("stroke-width", t.weight), e.setAttribute("stroke-linecap", t.lineCap), e.setAttribute("stroke-linejoin", t.lineJoin), t.dashArray ? e.setAttribute("stroke-dasharray", t.dashArray) : e.removeAttribute("stroke-dasharray"), t.dashOffset ? e.setAttribute("stroke-dashoffset", t.dashOffset) : e.removeAttribute("stroke-dashoffset")) : e.setAttribute("stroke", "none"), t.fill ? (e.setAttribute("fill", t.fillColor || t.color), e.setAttribute("fill-opacity", t.fillOpacity), e.setAttribute("fill-rule", t.fillRule || "evenodd")) : e.setAttribute("fill", "none"));
        },
        _updatePoly: function(t, e) {
            this._setPath(t, dt(t._parts, e));
        },
        _updateCircle: function(t) {
            var e = t._point, i = Math.max(Math.round(t._radius), 1), n = "a" + i + "," + (Math.max(Math.round(t._radiusY), 1) || i) + " 0 1,0 ", e = t._empty() ? "M0 0" : "M" + (e.x - i) + "," + e.y + n + 2 * i + ",0 " + n + 2 * -i + ",0 ";
            this._setPath(t, e);
        },
        _setPath: function(t, e) {
            t._path.setAttribute("d", e);
        },
        _bringToFront: function(t) {
            fe(t._path);
        },
        _bringToBack: function(t) {
            ge(t._path);
        }
    });
    function Ki(t) {
        return b.svg || b.vml ? new Gi(t) : null;
    }
    b.vml && Gi.include(zt), A.include({
        getRenderer: function(t) {
            t = (t = t.options.renderer || this._getPaneRenderer(t.options.pane) || this.options.renderer || this._renderer) || (this._renderer = this._createRenderer());
            return this.hasLayer(t) || this.addLayer(t), t;
        },
        _getPaneRenderer: function(t) {
            var e;
            return "overlayPane" !== t && void 0 !== t && (void 0 === (e = this._paneRenderers[t]) && (e = this._createRenderer({
                pane: t
            }), this._paneRenderers[t] = e), e);
        },
        _createRenderer: function(t) {
            return this.options.preferCanvas && Ui(t) || Ki(t);
        }
    });
    var Yi = xi.extend({
        initialize: function(t, e) {
            xi.prototype.initialize.call(this, this._boundsToLatLngs(t), e);
        },
        setBounds: function(t) {
            return this.setLatLngs(this._boundsToLatLngs(t));
        },
        _boundsToLatLngs: function(t) {
            return [
                (t = g(t)).getSouthWest(),
                t.getNorthWest(),
                t.getNorthEast(),
                t.getSouthEast()
            ];
        }
    });
    Gi.create = qi, Gi.pointsToPath = dt, wi.geometryToLayer = bi, wi.coordsToLatLng = Li, wi.coordsToLatLngs = Ti, wi.latLngToCoords = Mi, wi.latLngsToCoords = zi, wi.getFeature = Ci, wi.asFeature = Zi, A.mergeOptions({
        boxZoom: !0
    });
    var _t = n.extend({
        initialize: function(t) {
            this._map = t, this._container = t._container, this._pane = t._panes.overlayPane, this._resetStateTimeout = 0, t.on("unload", this._destroy, this);
        },
        addHooks: function() {
            S(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            k(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            T(this._pane), delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0, this._moved = !1;
        },
        _clearDeferredResetState: function() {
            0 !== this._resetStateTimeout && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
        },
        _onMouseDown: function(t) {
            if (!t.shiftKey || 1 !== t.which && 1 !== t.button) return !1;
            this._clearDeferredResetState(), this._resetState(), re(), Le(), this._startPoint = this._map.mouseEventToContainerPoint(t), S(document, {
                contextmenu: Re,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(t) {
            this._moved || (this._moved = !0, this._box = P("div", "leaflet-zoom-box", this._container), M(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(t);
            var t = new f(this._point, this._startPoint), e = t.getSize();
            Z(this._box, t.min), this._box.style.width = e.x + "px", this._box.style.height = e.y + "px";
        },
        _finish: function() {
            this._moved && (T(this._box), z(this._container, "leaflet-crosshair")), ae(), Te(), k(document, {
                contextmenu: Re,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(t) {
            1 !== t.which && 1 !== t.button || (this._finish(), this._moved && (this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(a(this._resetState, this), 0), t = new s(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point)), this._map.fitBounds(t).fire("boxzoomend", {
                boxZoomBounds: t
            })));
        },
        _onKeyDown: function(t) {
            27 === t.keyCode && (this._finish(), this._clearDeferredResetState(), this._resetState());
        }
    }), Ct = (A.addInitHook("addHandler", "boxZoom", _t), A.mergeOptions({
        doubleClickZoom: !0
    }), n.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(t) {
            var e = this._map, i = e.getZoom(), n = e.options.zoomDelta, i = t.originalEvent.shiftKey ? i - n : i + n;
            "center" === e.options.doubleClickZoom ? e.setZoom(i) : e.setZoomAround(t.containerPoint, i);
        }
    })), Zt = (A.addInitHook("addHandler", "doubleClickZoom", Ct), A.mergeOptions({
        dragging: !0,
        inertia: !0,
        inertiaDeceleration: 3400,
        inertiaMaxSpeed: 1 / 0,
        easeLinearity: .2,
        worldCopyJump: !1,
        maxBoundsViscosity: 0
    }), n.extend({
        addHooks: function() {
            var t;
            this._draggable || (t = this._map, this._draggable = new Xe(t._mapPane, t._container), this._draggable.on({
                dragstart: this._onDragStart,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this), this._draggable.on("predrag", this._onPreDragLimit, this), t.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), t.on("zoomend", this._onZoomEnd, this), t.whenReady(this._onZoomEnd, this))), M(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
        },
        removeHooks: function() {
            z(this._map._container, "leaflet-grab"), z(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var t, e = this._map;
            e._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity ? (t = g(this._map.options.maxBounds), this._offsetLimit = _(this._map.latLngToContainerPoint(t.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(t.getSouthEast()).multiplyBy(-1).add(this._map.getSize())), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity))) : this._offsetLimit = null, e.fire("movestart").fire("dragstart"), e.options.inertia && (this._positions = [], this._times = []);
        },
        _onDrag: function(t) {
            var e, i;
            this._map.options.inertia && (e = this._lastTime = +new Date, i = this._lastPos = this._draggable._absPos || this._draggable._newPos, this._positions.push(i), this._times.push(e), this._prunePositions(e)), this._map.fire("move", t).fire("drag", t);
        },
        _prunePositions: function(t) {
            for(; 1 < this._positions.length && 50 < t - this._times[0];)this._positions.shift(), this._times.shift();
        },
        _onZoomEnd: function() {
            var t = this._map.getSize().divideBy(2), e = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = e.subtract(t).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(t, e) {
            return t - (t - e) * this._viscosity;
        },
        _onPreDragLimit: function() {
            var t, e;
            this._viscosity && this._offsetLimit && (t = this._draggable._newPos.subtract(this._draggable._startPos), e = this._offsetLimit, t.x < e.min.x && (t.x = this._viscousLimit(t.x, e.min.x)), t.y < e.min.y && (t.y = this._viscousLimit(t.y, e.min.y)), t.x > e.max.x && (t.x = this._viscousLimit(t.x, e.max.x)), t.y > e.max.y && (t.y = this._viscousLimit(t.y, e.max.y)), this._draggable._newPos = this._draggable._startPos.add(t));
        },
        _onPreDragWrap: function() {
            var t = this._worldWidth, e = Math.round(t / 2), i = this._initialWorldOffset, n = this._draggable._newPos.x, o = (n - e + i) % t + e - i, n = (n + e + i) % t - e - i, t = Math.abs(o + i) < Math.abs(n + i) ? o : n;
            this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = t;
        },
        _onDragEnd: function(t) {
            var e, i, n, o, s = this._map, r = s.options, a = !r.inertia || t.noInertia || this._times.length < 2;
            s.fire("dragend", t), !a && (this._prunePositions(+new Date), t = this._lastPos.subtract(this._positions[0]), a = (this._lastTime - this._times[0]) / 1e3, e = r.easeLinearity, a = (t = t.multiplyBy(e / a)).distanceTo([
                0,
                0
            ]), i = Math.min(r.inertiaMaxSpeed, a), t = t.multiplyBy(i / a), n = i / (r.inertiaDeceleration * e), (o = t.multiplyBy(-n / 2).round()).x || o.y) ? (o = s._limitOffset(o, s.options.maxBounds), x(function() {
                s.panBy(o, {
                    duration: n,
                    easeLinearity: e,
                    noMoveStart: !0,
                    animate: !0
                });
            })) : s.fire("moveend");
        }
    })), St = (A.addInitHook("addHandler", "dragging", Zt), A.mergeOptions({
        keyboard: !0,
        keyboardPanDelta: 80
    }), n.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(t) {
            this._map = t, this._setPanDelta(t.options.keyboardPanDelta), this._setZoomDelta(t.options.zoomDelta);
        },
        addHooks: function() {
            var t = this._map._container;
            t.tabIndex <= 0 && (t.tabIndex = "0"), S(t, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this), this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks(), k(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this), this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            var t, e, i;
            this._focused || (i = document.body, t = document.documentElement, e = i.scrollTop || t.scrollTop, i = i.scrollLeft || t.scrollLeft, this._map._container.focus(), window.scrollTo(i, e));
        },
        _onFocus: function() {
            this._focused = !0, this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = !1, this._map.fire("blur");
        },
        _setPanDelta: function(t) {
            for(var e = this._panKeys = {}, i = this.keyCodes, n = 0, o = i.left.length; n < o; n++)e[i.left[n]] = [
                -1 * t,
                0
            ];
            for(n = 0, o = i.right.length; n < o; n++)e[i.right[n]] = [
                t,
                0
            ];
            for(n = 0, o = i.down.length; n < o; n++)e[i.down[n]] = [
                0,
                t
            ];
            for(n = 0, o = i.up.length; n < o; n++)e[i.up[n]] = [
                0,
                -1 * t
            ];
        },
        _setZoomDelta: function(t) {
            for(var e = this._zoomKeys = {}, i = this.keyCodes, n = 0, o = i.zoomIn.length; n < o; n++)e[i.zoomIn[n]] = t;
            for(n = 0, o = i.zoomOut.length; n < o; n++)e[i.zoomOut[n]] = -t;
        },
        _addHooks: function() {
            S(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            k(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(t) {
            if (!(t.altKey || t.ctrlKey || t.metaKey)) {
                var e, i, n = t.keyCode, o = this._map;
                if (n in this._panKeys) o._panAnim && o._panAnim._inProgress || (i = this._panKeys[n], t.shiftKey && (i = m(i).multiplyBy(3)), o.options.maxBounds && (i = o._limitOffset(m(i), o.options.maxBounds)), o.options.worldCopyJump ? (e = o.wrapLatLng(o.unproject(o.project(o.getCenter()).add(i))), o.panTo(e)) : o.panBy(i));
                else if (n in this._zoomKeys) o.setZoom(o.getZoom() + (t.shiftKey ? 3 : 1) * this._zoomKeys[n]);
                else {
                    if (27 !== n || !o._popup || !o._popup.options.closeOnEscapeKey) return;
                    o.closePopup();
                }
                Re(t);
            }
        }
    })), Et = (A.addInitHook("addHandler", "keyboard", St), A.mergeOptions({
        scrollWheelZoom: !0,
        wheelDebounceTime: 40,
        wheelPxPerZoomLevel: 60
    }), n.extend({
        addHooks: function() {
            S(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
        },
        removeHooks: function() {
            k(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(t) {
            var e = He(t), i = this._map.options.wheelDebounceTime, e = (this._delta += e, this._lastMousePos = this._map.mouseEventToContainerPoint(t), this._startTime || (this._startTime = +new Date), Math.max(i - (+new Date - this._startTime), 0));
            clearTimeout(this._timer), this._timer = setTimeout(a(this._performZoom, this), e), Re(t);
        },
        _performZoom: function() {
            var t = this._map, e = t.getZoom(), i = this._map.options.zoomSnap || 0, n = (t._stop(), this._delta / (4 * this._map.options.wheelPxPerZoomLevel)), n = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(n)))) / Math.LN2, i = i ? Math.ceil(n / i) * i : n, n = t._limitZoom(e + (0 < this._delta ? i : -i)) - e;
            this._delta = 0, this._startTime = null, n && ("center" === t.options.scrollWheelZoom ? t.setZoom(e + n) : t.setZoomAround(this._lastMousePos, e + n));
        }
    })), kt = (A.addInitHook("addHandler", "scrollWheelZoom", Et), A.mergeOptions({
        tapHold: b.touchNative && b.safari && b.mobile,
        tapTolerance: 15
    }), n.extend({
        addHooks: function() {
            S(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            k(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(t) {
            var e;
            clearTimeout(this._holdTimeout), 1 === t.touches.length && (e = t.touches[0], this._startPos = this._newPos = new p(e.clientX, e.clientY), this._holdTimeout = setTimeout(a(function() {
                this._cancel(), this._isTapValid() && (S(document, "touchend", O), S(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", e));
            }, this), 600), S(document, "touchend touchcancel contextmenu", this._cancel, this), S(document, "touchmove", this._onMove, this));
        },
        _cancelClickPrevent: function t() {
            k(document, "touchend", O), k(document, "touchend touchcancel", t);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout), k(document, "touchend touchcancel contextmenu", this._cancel, this), k(document, "touchmove", this._onMove, this);
        },
        _onMove: function(t) {
            t = t.touches[0];
            this._newPos = new p(t.clientX, t.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(t, e) {
            t = new MouseEvent(t, {
                bubbles: !0,
                cancelable: !0,
                view: window,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            t._simulated = !0, e.target.dispatchEvent(t);
        }
    })), Ot = (A.addInitHook("addHandler", "tapHold", kt), A.mergeOptions({
        touchZoom: b.touch,
        bounceAtZoomLimits: !0
    }), n.extend({
        addHooks: function() {
            M(this._map._container, "leaflet-touch-zoom"), S(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            z(this._map._container, "leaflet-touch-zoom"), k(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(t) {
            var e, i, n = this._map;
            !t.touches || 2 !== t.touches.length || n._animatingZoom || this._zooming || (e = n.mouseEventToContainerPoint(t.touches[0]), i = n.mouseEventToContainerPoint(t.touches[1]), this._centerPoint = n.getSize()._divideBy(2), this._startLatLng = n.containerPointToLatLng(this._centerPoint), "center" !== n.options.touchZoom && (this._pinchStartLatLng = n.containerPointToLatLng(e.add(i)._divideBy(2))), this._startDist = e.distanceTo(i), this._startZoom = n.getZoom(), this._moved = !1, this._zooming = !0, n._stop(), S(document, "touchmove", this._onTouchMove, this), S(document, "touchend touchcancel", this._onTouchEnd, this), O(t));
        },
        _onTouchMove: function(t) {
            if (t.touches && 2 === t.touches.length && this._zooming) {
                var e = this._map, i = e.mouseEventToContainerPoint(t.touches[0]), n = e.mouseEventToContainerPoint(t.touches[1]), o = i.distanceTo(n) / this._startDist;
                if (this._zoom = e.getScaleZoom(o, this._startZoom), !e.options.bounceAtZoomLimits && (this._zoom < e.getMinZoom() && o < 1 || this._zoom > e.getMaxZoom() && 1 < o) && (this._zoom = e._limitZoom(this._zoom)), "center" === e.options.touchZoom) {
                    if (this._center = this._startLatLng, 1 == o) return;
                } else {
                    i = i._add(n)._divideBy(2)._subtract(this._centerPoint);
                    if (1 == o && 0 === i.x && 0 === i.y) return;
                    this._center = e.unproject(e.project(this._pinchStartLatLng, this._zoom).subtract(i), this._zoom);
                }
                this._moved || (e._moveStart(!0, !1), this._moved = !0), r(this._animRequest);
                n = a(e._move, e, this._center, this._zoom, {
                    pinch: !0,
                    round: !1
                }, void 0);
                this._animRequest = x(n, this, !0), O(t);
            }
        },
        _onTouchEnd: function() {
            this._moved && this._zooming ? (this._zooming = !1, r(this._animRequest), k(document, "touchmove", this._onTouchMove, this), k(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom))) : this._zooming = !1;
        }
    })), Xi = (A.addInitHook("addHandler", "touchZoom", Ot), A.BoxZoom = _t, A.DoubleClickZoom = Ct, A.Drag = Zt, A.Keyboard = St, A.ScrollWheelZoom = Et, A.TapHold = kt, A.TouchZoom = Ot, t.Bounds = f, t.Browser = b, t.CRS = ot, t.Canvas = Fi, t.Circle = vi, t.CircleMarker = gi, t.Class = et, t.Control = B, t.DivIcon = Ri, t.DivOverlay = Ai, t.DomEvent = mt, t.DomUtil = pt, t.Draggable = Xe, t.Evented = it, t.FeatureGroup = ci, t.GeoJSON = wi, t.GridLayer = Ni, t.Handler = n, t.Icon = di, t.ImageOverlay = Ei, t.LatLng = v, t.LatLngBounds = s, t.Layer = o, t.LayerGroup = ui, t.LineUtil = vt, t.Map = A, t.Marker = mi, t.Mixin = ft, t.Path = fi, t.Point = p, t.PolyUtil = gt, t.Polygon = xi, t.Polyline = yi, t.Popup = Bi, t.PosAnimation = Fe, t.Projection = wt, t.Rectangle = Yi, t.Renderer = Wi, t.SVG = Gi, t.SVGOverlay = Oi, t.TileLayer = Di, t.Tooltip = Ii, t.Transformation = at, t.Util = tt, t.VideoOverlay = ki, t.bind = a, t.bounds = _, t.canvas = Ui, t.circle = function(t, e, i) {
        return new vi(t, e, i);
    }, t.circleMarker = function(t, e) {
        return new gi(t, e);
    }, t.control = Ue, t.divIcon = function(t) {
        return new Ri(t);
    }, t.extend = l, t.featureGroup = function(t, e) {
        return new ci(t, e);
    }, t.geoJSON = Si, t.geoJson = Mt, t.gridLayer = function(t) {
        return new Ni(t);
    }, t.icon = function(t) {
        return new di(t);
    }, t.imageOverlay = function(t, e, i) {
        return new Ei(t, e, i);
    }, t.latLng = w, t.latLngBounds = g, t.layerGroup = function(t, e) {
        return new ui(t, e);
    }, t.map = function(t, e) {
        return new A(t, e);
    }, t.marker = function(t, e) {
        return new mi(t, e);
    }, t.point = m, t.polygon = function(t, e) {
        return new xi(t, e);
    }, t.polyline = function(t, e) {
        return new yi(t, e);
    }, t.popup = function(t, e) {
        return new Bi(t, e);
    }, t.rectangle = function(t, e) {
        return new Yi(t, e);
    }, t.setOptions = c, t.stamp = h, t.svg = Ki, t.svgOverlay = function(t, e, i) {
        return new Oi(t, e, i);
    }, t.tileLayer = ji, t.tooltip = function(t, e) {
        return new Ii(t, e);
    }, t.transformation = ht, t.version = "1.9.4", t.videoOverlay = function(t, e, i) {
        return new ki(t, e, i);
    }, window.L);
    t.noConflict = function() {
        return window.L = Xi, this;
    }, window.L = t;
});




function $8343a91d9043513e$export$19d26e5f9c5b1089(leafletBounds) {
    leafletBounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        extend: function(point) {
            point = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(point);
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = point.clone();
                this.max = point.clone();
            } else {
                this.min.x = Math.min(point.x, this.min.x);
                this.max.x = Math.max(point.x, this.max.x);
                this.min.y = Math.min(point.y, this.min.y);
                this.max.y = Math.max(point.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return new (0, $0552a615fcf79927$export$baf26146a414f24a)((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return new (0, $0552a615fcf79927$export$baf26146a414f24a)(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return new (0, $0552a615fcf79927$export$baf26146a414f24a)(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof (0, $0552a615fcf79927$export$baf26146a414f24a)) obj = (0, $0552a615fcf79927$export$b63cca88ddc558a9)(obj);
            else obj = (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)(obj);
            if (obj instanceof (0, $cf9ba342210785ec$export$c4e9d269599ab4b4)) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)(bounds);
            // console.log('overriddenxxxxx leaflet - this.min : ' + this.min + ' - this.max : ' + this.max +
            //   ' - bounds : ' + JSON.stringify(bounds));
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects, yIntersects;
            if (min2 && max2) xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            else xIntersects = false, yIntersects = false;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = (0, $cf9ba342210785ec$export$c8e2f7c8aba65b28)(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        isValid: function() {
            return !!(this.min && this.max);
        }
    };
}



function $c022c3a831c783e1$export$b08464e47b7a3a8() {
    // console.time('initMap');
    (0, $diMLx.map).instance = $a14ca6047db5cfcd$export$d49c9aa30b771d59("map", {
        center: (0, $am1Dn.config).mapCenter,
        zoom: (0, $am1Dn.config).mapZoom,
        minZoom: 9.15,
        maxBoundsViscosity: 1,
        zoomControl: false,
        zoomSnap: 0,
        zoomAnimation: false
    });
    $833ac8fc109549bc$export$b5cde1de278b4330.zoom({
        position: "topleft"
    }).addTo((0, $diMLx.map).instance);
    new (0, (/*@__PURE__*/$parcel$interopDefault($f5fb3e566b1746ef$exports)))({
        position: "bottomleft",
        keepCurrentZoomLevel: true,
        setView: false,
        strings: {
            title: "Voir ma position",
            metersUnit: "m\xe8tres",
            feetUnit: "pieds",
            popup: "Vous \xeates situ\xe9(e) dans un p\xe9rim\xe8tre de {distance} {unit} autour de ce point",
            outsideMapBoundsMsg: "Vous semblez \xeatre localis\xe9(e) hors du p\xe9rim\xe8tre de la carte"
        },
        locateOptions: {
            enableHighAccuracy: true
        }
    }).addTo((0, $diMLx.map).instance);
    (0, $8343a91d9043513e$export$19d26e5f9c5b1089)($cf9ba342210785ec$export$c4e9d269599ab4b4);
    $fff58c71be695211$export$7ed1367e7fa1ad68().addTo((0, $diMLx.map).instance);
    document.querySelector("#map .leaflet-overlay-pane").insertAdjacentHTML("afterbegin", '<div id="particles_wrapper" class="leaflet-zoom-animated" style="width: ' + (0, $diMLx.layout).width + "px; height: " + (0, $diMLx.layout).height + 'px;"></div>');
    let isSingleClick = true, updateParticles = (0, $iRjZV.debounce)((0, $4a909a324b05f370$export$392d57327b439f08), 500);
    (0, $diMLx.map).instance.on("zoomstart", function() {
        $c022c3a831c783e1$var$stopParticles();
    });
    (0, $diMLx.map).instance.on("zoomend", function(evt) {
        (0, $4a909a324b05f370$export$68cdf4e2cb6fc30e)();
        setTimeout(function() {
            isSingleClick = true;
        }, 300);
        if ((0, $diMLx.map).windLayer && (0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1 || (0, $diMLx.map).wavesLayer && (0, $diMLx.layers).dataLayers.indexOf("waves_fc") !== -1) updateParticles();
    });
    (0, $diMLx.map).instance.on("movestart", function() {
        $c022c3a831c783e1$var$stopParticles();
    });
    (0, $diMLx.map).instance.on("moveend", function(evt) {
        (0, $4a909a324b05f370$export$68cdf4e2cb6fc30e)();
        if ((0, $diMLx.map).windLayer && (0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1 || (0, $diMLx.map).wavesLayer && (0, $diMLx.layers).dataLayers.indexOf("waves_fc") !== -1) updateParticles();
        $c022c3a831c783e1$var$updateParticlesPane();
    });
    (0, $diMLx.map).instance.on("click", function(e) {
        setTimeout(function() {
            if (isSingleClick) {
                if ((0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1 || (0, $diMLx.layers).dataLayers.indexOf("waves_fc") !== -1) {
                    let popLocation = e.latlng;
                    (0, $diMLx.map).popup = $f2bcd878b9398d2d$export$63b4813c5280c707().setLatLng(popLocation);
                    (0, $am1Dn.config).popup = (0, $diMLx.map).popup;
                    $c022c3a831c783e1$var$setPopupContent((0, $am1Dn.config).popup, e);
                    (0, $diMLx.map).instance.openPopup((0, $am1Dn.config).popup);
                }
            }
        }, 300);
    });
    (0, $diMLx.map).instance.on("dblclick", function(e) {
        isSingleClick = false;
    });
    (0, $diMLx.map).instance.on("popupclose", function(e) {
        (0, $diMLx.map).popup = null;
    });
    (0, $diMLx.map).instance.on("locationerror", function(e) {
        window.alert("Votre position n'a pas pu \xeatre relev\xe9e.");
    });
    (0, $diMLx.layers).overlay = (0, $5ff8fe1f0e47d54c$export$2e2bcd8739ae039)((0, $diMLx.map).instance.getPanes().overlayPane).select("svg").attr("id", "markers_layer").attr("pointer-events", "all");
    return $c022c3a831c783e1$export$f0c5438bd76c55d8(true).then(function() {
        console.log("maxBounds: " + (0, $am1Dn.config).mapBounds);
        (0, $diMLx.map).instance.setMaxBounds((0, $am1Dn.config).mapBounds);
        (0, $diMLx.map).viewBox = (0, $diMLx.map).instance.getPixelBounds();
        (0, $diMLx.map).refZoom = (0, $diMLx.map).instance.getBoundsZoom((0, $am1Dn.config).mapBounds);
        (0, $diMLx.map).windBox = [
            (0, $diMLx.map).instance.project((0, $am1Dn.config).mapBounds[0], (0, $diMLx.map).refZoom),
            (0, $diMLx.map).instance.project((0, $am1Dn.config).mapBounds[1], (0, $diMLx.map).refZoom)
        ];
        (0, $diMLx.map).windWidth = (0, $diMLx.map).windBox[1].x - (0, $diMLx.map).windBox[0].x;
        (0, $diMLx.map).windHeight = (0, $diMLx.map).windBox[1].y - (0, $diMLx.map).windBox[0].y;
        (0, $diMLx.map).wavesBox = [
            (0, $diMLx.map).instance.project((0, $am1Dn.config).mapBounds[0], (0, $diMLx.map).refZoom),
            (0, $diMLx.map).instance.project((0, $am1Dn.config).mapBounds[1], (0, $diMLx.map).refZoom)
        ];
        (0, $diMLx.map).wavesWidth = (0, $diMLx.map).wavesBox[1].x - (0, $diMLx.map).wavesBox[0].x;
        (0, $diMLx.map).wavesHeight = (0, $diMLx.map).wavesBox[1].y - (0, $diMLx.map).wavesBox[0].y;
    // console.timeEnd('initMap');
    });
}
function $c022c3a831c783e1$var$updateParticlesPane() {
    let panTransform = document.querySelector("#map > .leaflet-map-pane").getAttribute("style");
    if (panTransform && panTransform.indexOf("translate3d") !== -1) {
        let [x, y, z] = panTransform.match(/-?[.\d]+px/g).map(function(v) {
            return parseInt(v.replace("px", ""));
        });
        document.querySelector("#particles_wrapper").setAttribute("style", "width: " + (0, $diMLx.layout).width + "px; height: " + (0, $diMLx.layout).height + "px; transform: translate3d(" + -x + "px, " + -y + "px, 0px);");
        if (document.querySelector("#waves_wrapper")) document.querySelector("#waves_wrapper").setAttribute("style", "width: " + (0, $diMLx.layout).width + "px; height: " + (0, $diMLx.layout).height + "px; transform: translate3d(" + -x + "px, " + -y + "px, 0px);");
    }
}
function $c022c3a831c783e1$var$stopParticles() {
    if ((0, $diMLx.map).windLayer && (0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1) (0, $diMLx.map).windLayer.stop();
    if ((0, $diMLx.map).wavesLayer && (0, $diMLx.layers).dataLayers.indexOf("waves_fc") !== -1) (0, $diMLx.map).wavesLayer.stop();
}
function $c022c3a831c783e1$export$720449d359f5eb20(btn, ref) {
    if ((0, $diMLx.map).activeMap !== ref) {
        let activeBtn = document.querySelector("#side_menu .map_layer.active");
        if (activeBtn) activeBtn.classList.remove("active");
        $c022c3a831c783e1$export$7936340adedaf8bc(ref);
        (0, $diMLx.map).activeMap = ref;
        btn.classList.add("active");
    }
}
function $c022c3a831c783e1$export$7936340adedaf8bc(ref, skipRefresh) {
    let mapContainer = document.querySelector("#map_container");
    if (ref === "wm") {
        $c022c3a831c783e1$export$382d1aca2389ca8b();
        $c022c3a831c783e1$export$f0c5438bd76c55d8(true);
    } else if (ref === "satellite") $c022c3a831c783e1$var$displayOrthoLayer();
    else if (ref === "elevation") $c022c3a831c783e1$var$displayMntLayer();
    mapContainer.classList.remove((0, $diMLx.map).activeMap);
    mapContainer.classList.add(ref);
    if (typeof skipRefresh === "undefined" || !skipRefresh) (0, $ac969ff4dde4b936$export$40548a160ab2d315)();
}
function $c022c3a831c783e1$export$f0c5438bd76c55d8(forceFill, waves = false) {
    // console.time('displayCoastLine');
    // const mtLayer = new MaptilerLayer({
    //   apiKey: "ZkJJ9tNsbzF6IRldrpeM",
    //   style: waves ? 'https://api.maptiler.com/maps/dc27b623-f58d-4a84-a9eb-c8f5e970c2e7/style.json' : (forceFill ? "https://api.maptiler.com/maps/9252a2f8-bdda-477b-aa0a-52eeb8a1653c/style.json" : "https://api.maptiler.com/maps/5ddfa15f-9859-4f36-95f7-25323cd9b3c3/style.json"),
    //   attributionControl: false,
    //   pane: 'overlayPane'
    // }).addTo(map.instance);
    const rasterTilesUrl = waves ? "https://api.maptiler.com/maps/dc27b623-f58d-4a84-a9eb-c8f5e970c2e7/{z}/{x}/{y}.png?key=ZkJJ9tNsbzF6IRldrpeM" : forceFill ? "https://tiles.windmorbihan.com/{z}/{x}/{y}.png" : "https://api.maptiler.com/maps/5ddfa15f-9859-4f36-95f7-25323cd9b3c3/{z}/{x}/{y}.png?key=ZkJJ9tNsbzF6IRldrpeM";
    const mtLayer = $edbbe2536ba3f7be$export$be2e48cfdc7506da(rasterTilesUrl, {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 1,
        attribution: false,
        crossOrigin: true,
        minNativeZoom: 10
    }).addTo((0, $diMLx.map).instance);
    (0, $diMLx.layers).bgLayers.push(mtLayer);
    // console.timeEnd('displayCoastLine');
    return Promise.resolve(mtLayer);
}
function $c022c3a831c783e1$export$382d1aca2389ca8b() {
    let l;
    for (l of (0, $diMLx.layers).bgLayers)(0, $diMLx.map).instance.removeLayer(l);
    (0, $diMLx.layers).bgLayers = [];
}
function $c022c3a831c783e1$var$setPopupContent(popup, evt) {
    console.debug("pt clicked : " + evt.latlng);
    if ((0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1 || (0, $diMLx.layers).dataLayers.indexOf("waves_fc") !== -1) return (0, $4a909a324b05f370$export$53d225340945d25c)(popup, evt.latlng.lat, evt.latlng.lng);
    else return popup.setContent(evt.latlng.lat + ", " + evt.latlng.lng);
}
function $c022c3a831c783e1$var$displayOrthoLayer() {
    let mtLayer = new $edbbe2536ba3f7be$export$be2e48cfdc7506da("https://data.geopf.fr/wmts?&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/jpeg&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}");
    mtLayer.addTo((0, $diMLx.map).instance);
    (0, $diMLx.layers).bgLayers.push(mtLayer);
}
function $c022c3a831c783e1$var$displayMntLayer() {
    let layr = new $edbbe2536ba3f7be$export$be2e48cfdc7506da.wms("https://services.data.shom.fr/INSPIRE/wms/r?", {
        layers: "MNT_COTIER_MORBIHAN_TANDEM_20m_PBMA_3857_WMSR",
        format: "image/png",
        transparent: true,
        version: "1.3.0",
        service: "WMS",
        request: "GetMap",
        uppercase: true,
        className: "mnt_layer"
    });
    layr.addTo((0, $diMLx.map).instance);
    (0, $diMLx.layers).bgLayers.push(layr);
}
function $c022c3a831c783e1$export$33d1addef09845d7(lng, lat) {
    let pt = (0, $diMLx.map).instance.latLngToLayerPoint([
        lat,
        lng
    ]);
    return [
        pt.x,
        pt.y
    ];
}



var $f1b279363cb8b9b4$exports = {};
var $4631b301579198ba$exports = {};
$4631b301579198ba$exports = new URL("lune-nuage-1-pluie-1.5f3e727c.svg", import.meta.url).toString();


var $a90aee355d09f955$exports = {};
$a90aee355d09f955$exports = new URL("lune-nuage-1-pluie-2.e923860f.svg", import.meta.url).toString();


var $f64fe6ab2d69f01c$exports = {};
$f64fe6ab2d69f01c$exports = new URL("lune-nuage-1-pluie-3.8e22855c.svg", import.meta.url).toString();


var $cd1fb1aaece70a98$exports = {};
$cd1fb1aaece70a98$exports = new URL("lune-nuage-1.647e6658.svg", import.meta.url).toString();


var $0ad61fe494092800$exports = {};
$0ad61fe494092800$exports = new URL("lune-nuage-2-pluie-1.e3f72300.svg", import.meta.url).toString();


var $e0e72329363d2da9$exports = {};
$e0e72329363d2da9$exports = new URL("lune-nuage-2-pluie-2.4420f248.svg", import.meta.url).toString();


var $a399964445a68df4$exports = {};
$a399964445a68df4$exports = new URL("lune-nuage-2-pluie-3.e99f3c7e.svg", import.meta.url).toString();


var $2eb52e5add6386a7$exports = {};
$2eb52e5add6386a7$exports = new URL("lune-nuage-2.bbb32705.svg", import.meta.url).toString();


var $f4ecad7daffe5bff$exports = {};
$f4ecad7daffe5bff$exports = new URL("lune-nuage-3-pluie-1.4753560e.svg", import.meta.url).toString();


var $ec2f113ab8689c80$exports = {};
$ec2f113ab8689c80$exports = new URL("lune-nuage-3-pluie-2.68a72b69.svg", import.meta.url).toString();


var $a2b7e9df4b3de8df$exports = {};
$a2b7e9df4b3de8df$exports = new URL("lune-nuage-3-pluie-3.d5c436cb.svg", import.meta.url).toString();


var $65785e469e715f95$exports = {};
$65785e469e715f95$exports = new URL("lune-nuage-3.9204baa5.svg", import.meta.url).toString();


var $28fbd112bd74aa72$exports = {};
$28fbd112bd74aa72$exports = new URL("lune-pluie-1.37e1dd31.svg", import.meta.url).toString();


var $501ed3b7bd8a86ab$exports = {};
$501ed3b7bd8a86ab$exports = new URL("lune-pluie-2.27bccd53.svg", import.meta.url).toString();


var $c14d781416948845$exports = {};
$c14d781416948845$exports = new URL("lune-pluie-3.daa267b6.svg", import.meta.url).toString();


var $0fc2946eb78860d5$exports = {};
$0fc2946eb78860d5$exports = new URL("lune-voile-pluie-1.8ae6d3a4.svg", import.meta.url).toString();


var $25536a527a20307c$exports = {};
$25536a527a20307c$exports = new URL("lune-voile-pluie-2.1605b873.svg", import.meta.url).toString();


var $658cdd970f8f71f0$exports = {};
$658cdd970f8f71f0$exports = new URL("lune-voile-pluie-3.84a12d3f.svg", import.meta.url).toString();


var $6de9cc6c0d974211$exports = {};
$6de9cc6c0d974211$exports = new URL("lune-voile.44a915df.svg", import.meta.url).toString();


var $8ce622cdbe2ff950$exports = {};
$8ce622cdbe2ff950$exports = new URL("lune.bc430886.svg", import.meta.url).toString();


var $a78a0ba0c59b11eb$exports = {};
$a78a0ba0c59b11eb$exports = new URL("nuage-3-pluie-1.4182f042.svg", import.meta.url).toString();


var $58203b2ec1cc69e6$exports = {};
$58203b2ec1cc69e6$exports = new URL("nuage-3-pluie-2.955d450e.svg", import.meta.url).toString();


var $c78cdfaab01385b6$exports = {};
$c78cdfaab01385b6$exports = new URL("nuage-3-pluie-3.3eda1ac8.svg", import.meta.url).toString();


var $cf1c91d4b4bdf00f$exports = {};
$cf1c91d4b4bdf00f$exports = new URL("nuage-3.c44add4c.svg", import.meta.url).toString();


var $67bd528943b24e16$exports = {};
$67bd528943b24e16$exports = new URL("nuage-pluie-1.23af1aaf.svg", import.meta.url).toString();


var $823a416039f94e81$exports = {};
$823a416039f94e81$exports = new URL("nuage-pluie-2.42a4a462.svg", import.meta.url).toString();


var $a746c0742cd8df7d$exports = {};
$a746c0742cd8df7d$exports = new URL("nuage-pluie-3.b4a4012a.svg", import.meta.url).toString();


var $e5dd4bb154bc052e$exports = {};
$e5dd4bb154bc052e$exports = new URL("nuage.cb5005d5.svg", import.meta.url).toString();


var $3318ad4fad50d121$exports = {};
$3318ad4fad50d121$exports = new URL("soleil-nuage-1-pluie-1.60181a3f.svg", import.meta.url).toString();


var $84544caf985da35e$exports = {};
$84544caf985da35e$exports = new URL("soleil-nuage-1-pluie-2.31358178.svg", import.meta.url).toString();


var $c33668d960bbfa9e$exports = {};
$c33668d960bbfa9e$exports = new URL("soleil-nuage-1-pluie-3.8ee1c01c.svg", import.meta.url).toString();


var $9101df8f5d103a0a$exports = {};
$9101df8f5d103a0a$exports = new URL("soleil-nuage-1.555b937b.svg", import.meta.url).toString();


var $89f36d45ba8b3af7$exports = {};
$89f36d45ba8b3af7$exports = new URL("soleil-nuage-2-pluie-1.9addd2ac.svg", import.meta.url).toString();


var $d4eac5247bb00ef1$exports = {};
$d4eac5247bb00ef1$exports = new URL("soleil-nuage-2-pluie-2.8591b68a.svg", import.meta.url).toString();


var $b647493ae084906d$exports = {};
$b647493ae084906d$exports = new URL("soleil-nuage-2-pluie-3.407fc3e5.svg", import.meta.url).toString();


var $6f4fbde0a022651e$exports = {};
$6f4fbde0a022651e$exports = new URL("soleil-nuage-2.7b675de9.svg", import.meta.url).toString();


var $7fd846bc80cfd3d8$exports = {};
$7fd846bc80cfd3d8$exports = new URL("soleil-pluie-1.7c82d183.svg", import.meta.url).toString();


var $4c8d6bd09dc8f9a2$exports = {};
$4c8d6bd09dc8f9a2$exports = new URL("soleil-pluie-2.7f55c1cd.svg", import.meta.url).toString();


var $65c4cbca23f98057$exports = {};
$65c4cbca23f98057$exports = new URL("soleil-pluie-3.adb896e1.svg", import.meta.url).toString();


var $56b3a85dfb87852b$exports = {};
$56b3a85dfb87852b$exports = new URL("soleil-voile-pluie-1.0b00ef42.svg", import.meta.url).toString();


var $12f46caa29407126$exports = {};
$12f46caa29407126$exports = new URL("soleil-voile-pluie-2.ce97767c.svg", import.meta.url).toString();


var $79bc4cbdc3cfd064$exports = {};
$79bc4cbdc3cfd064$exports = new URL("soleil-voile-pluie-3.3a8ba4e6.svg", import.meta.url).toString();


var $e7ac74d13389129d$exports = {};
$e7ac74d13389129d$exports = new URL("soleil-voile.1eaa033b.svg", import.meta.url).toString();


var $a3b88939c4cf4063$exports = {};
$a3b88939c4cf4063$exports = new URL("soleil.ecdb683b.svg", import.meta.url).toString();


$f1b279363cb8b9b4$exports = {
    "lune-nuage-1-pluie-1": $4631b301579198ba$exports,
    "lune-nuage-1-pluie-2": $a90aee355d09f955$exports,
    "lune-nuage-1-pluie-3": $f64fe6ab2d69f01c$exports,
    "lune-nuage-1": $cd1fb1aaece70a98$exports,
    "lune-nuage-2-pluie-1": $0ad61fe494092800$exports,
    "lune-nuage-2-pluie-2": $e0e72329363d2da9$exports,
    "lune-nuage-2-pluie-3": $a399964445a68df4$exports,
    "lune-nuage-2": $2eb52e5add6386a7$exports,
    "lune-nuage-3-pluie-1": $f4ecad7daffe5bff$exports,
    "lune-nuage-3-pluie-2": $ec2f113ab8689c80$exports,
    "lune-nuage-3-pluie-3": $a2b7e9df4b3de8df$exports,
    "lune-nuage-3": $65785e469e715f95$exports,
    "lune-pluie-1": $28fbd112bd74aa72$exports,
    "lune-pluie-2": $501ed3b7bd8a86ab$exports,
    "lune-pluie-3": $c14d781416948845$exports,
    "lune-voile-pluie-1": $0fc2946eb78860d5$exports,
    "lune-voile-pluie-2": $25536a527a20307c$exports,
    "lune-voile-pluie-3": $658cdd970f8f71f0$exports,
    "lune-voile": $6de9cc6c0d974211$exports,
    "lune": $8ce622cdbe2ff950$exports,
    "nuage-3-pluie-1": $a78a0ba0c59b11eb$exports,
    "nuage-3-pluie-2": $58203b2ec1cc69e6$exports,
    "nuage-3-pluie-3": $c78cdfaab01385b6$exports,
    "nuage-3": $cf1c91d4b4bdf00f$exports,
    "nuage-pluie-1": $67bd528943b24e16$exports,
    "nuage-pluie-2": $823a416039f94e81$exports,
    "nuage-pluie-3": $a746c0742cd8df7d$exports,
    "nuage": $e5dd4bb154bc052e$exports,
    "soleil-nuage-1-pluie-1": $3318ad4fad50d121$exports,
    "soleil-nuage-1-pluie-2": $84544caf985da35e$exports,
    "soleil-nuage-1-pluie-3": $c33668d960bbfa9e$exports,
    "soleil-nuage-1": $9101df8f5d103a0a$exports,
    "soleil-nuage-2-pluie-1": $89f36d45ba8b3af7$exports,
    "soleil-nuage-2-pluie-2": $d4eac5247bb00ef1$exports,
    "soleil-nuage-2-pluie-3": $b647493ae084906d$exports,
    "soleil-nuage-2": $6f4fbde0a022651e$exports,
    "soleil-pluie-1": $7fd846bc80cfd3d8$exports,
    "soleil-pluie-2": $4c8d6bd09dc8f9a2$exports,
    "soleil-pluie-3": $65c4cbca23f98057$exports,
    "soleil-voile-pluie-1": $56b3a85dfb87852b$exports,
    "soleil-voile-pluie-2": $12f46caa29407126$exports,
    "soleil-voile-pluie-3": $79bc4cbdc3cfd064$exports,
    "soleil-voile": $e7ac74d13389129d$exports,
    "soleil": $a3b88939c4cf4063$exports
};



var $am1Dn = parcelRequire("am1Dn");


var $iRjZV = parcelRequire("iRjZV");
var $1744ee85d0ea69cd$exports = {};
var $ca0894d12d6ab207$exports = {};
$ca0894d12d6ab207$exports = new URL("amp-map.5f4d399a.svg", import.meta.url).toString();


var $cf1a51d53edb1fbb$exports = {};
$cf1a51d53edb1fbb$exports = new URL("arrow.6dfe1608.svg", import.meta.url).toString();


var $4ec12ce0d39042f5$exports = {};
$4ec12ce0d39042f5$exports = new URL("arrow_gray.b01d5c81.svg", import.meta.url).toString();


var $391c07920c558983$exports = {};
$391c07920c558983$exports = new URL("favoris.4c725afc.svg", import.meta.url).toString();


var $7a952d3c11020d54$exports = {};
$7a952d3c11020d54$exports = new URL("fleche-vague.44f035ea.svg", import.meta.url).toString();


var $42dabfdb94bd9156$exports = {};
$42dabfdb94bd9156$exports = new URL("fleche-vent.119f7036.svg", import.meta.url).toString();


var $65081e609ccdb793$exports = {};
$65081e609ccdb793$exports = new URL("info.325a1dbe.svg", import.meta.url).toString();


var $a4ef8072bf68c833$exports = {};
$a4ef8072bf68c833$exports = new URL("legend.8c3b114a.svg", import.meta.url).toString();


var $5af910c28f0d0832$exports = {};
$5af910c28f0d0832$exports = new URL("meteo.20ddaefd.svg", import.meta.url).toString();


var $a5a78c2603ab657c$exports = {};
$a5a78c2603ab657c$exports = new URL("meteo_previ.3ade7218.svg", import.meta.url).toString();


var $f825286ad9a19b5b$exports = {};
$f825286ad9a19b5b$exports = new URL("meteo_select.7431bb88.svg", import.meta.url).toString();


var $ec088a7a0ba6a0de$exports = {};
$ec088a7a0ba6a0de$exports = new URL("meteogramme-prevision.474c8c2b.svg", import.meta.url).toString();


var $5c2888cd036ff74f$exports = {};
$5c2888cd036ff74f$exports = new URL("meteogramme.d5d95ae7.svg", import.meta.url).toString();


var $139a026670552dda$exports = {};
$139a026670552dda$exports = new URL("temp.1ca9d45d.svg", import.meta.url).toString();


var $16661f7c51d33ebc$exports = {};
$16661f7c51d33ebc$exports = new URL("tide-map.d8641695.svg", import.meta.url).toString();


var $9f1523de681a2da3$exports = {};
$9f1523de681a2da3$exports = new URL("tide.52e5a567.svg", import.meta.url).toString();


var $5a63085825d3a8d7$exports = {};
$5a63085825d3a8d7$exports = new URL("waves-prevision.3ddf4c14.svg", import.meta.url).toString();


var $7d20f20bc2917321$exports = {};
$7d20f20bc2917321$exports = new URL("waves.7798a008.svg", import.meta.url).toString();


var $762fc762b7a1b20d$exports = {};
$762fc762b7a1b20d$exports = new URL("webcam-map.39b9a9ff.svg", import.meta.url).toString();


var $8ee73e64c3f79645$exports = {};
$8ee73e64c3f79645$exports = new URL("webcam.15d4ed6b.svg", import.meta.url).toString();


var $a95dd60864cd9c7c$exports = {};
$a95dd60864cd9c7c$exports = new URL("wind.06ed8561.svg", import.meta.url).toString();


var $2902366e3a9fe18a$exports = {};
$2902366e3a9fe18a$exports = new URL("wind_prevision.4d15525c.svg", import.meta.url).toString();


$1744ee85d0ea69cd$exports = {
    "amp-map": $ca0894d12d6ab207$exports,
    "arrow": $cf1a51d53edb1fbb$exports,
    "arrow_gray": $4ec12ce0d39042f5$exports,
    "favoris": $391c07920c558983$exports,
    "fleche-vague": $7a952d3c11020d54$exports,
    "fleche-vent": $42dabfdb94bd9156$exports,
    "info": $65081e609ccdb793$exports,
    "legend": $a4ef8072bf68c833$exports,
    "meteo": $5af910c28f0d0832$exports,
    "meteo_previ": $a5a78c2603ab657c$exports,
    "meteo_select": $f825286ad9a19b5b$exports,
    "meteogramme-prevision": $ec088a7a0ba6a0de$exports,
    "meteogramme": $5c2888cd036ff74f$exports,
    "temp": $139a026670552dda$exports,
    "tide-map": $16661f7c51d33ebc$exports,
    "tide": $9f1523de681a2da3$exports,
    "waves-prevision": $5a63085825d3a8d7$exports,
    "waves": $7d20f20bc2917321$exports,
    "webcam-map": $762fc762b7a1b20d$exports,
    "webcam": $8ee73e64c3f79645$exports,
    "wind": $a95dd60864cd9c7c$exports,
    "wind_prevision": $2902366e3a9fe18a$exports
};


var $ad9411963a5d44fa$exports = {};
!function(t, n) {
    $ad9411963a5d44fa$exports = n();
}("undefined" != typeof self ? self : $ad9411963a5d44fa$exports, function() {
    return function() {
        "use strict";
        var t = {
            407: function(t, n, e) {
                e.d(n, {
                    default: function() {
                        return N;
                    }
                });
                var o = /([:*])(\w+)/g, r = /\*/g, i = /\/\?/g;
                function a(t) {
                    return void 0 === t && (t = "/"), v() ? location.pathname + location.search + location.hash : t;
                }
                function s(t) {
                    return t.replace(/\/+$/, "").replace(/^\/+/, "");
                }
                function c(t) {
                    return "string" == typeof t;
                }
                function u(t) {
                    return t && t.indexOf("#") >= 0 && t.split("#").pop() || "";
                }
                function h(t) {
                    var n = s(t).split(/\?(.*)?$/);
                    return [
                        s(n[0]),
                        n.slice(1).join("")
                    ];
                }
                function f(t) {
                    for(var n = {}, e = t.split("&"), o = 0; o < e.length; o++){
                        var r = e[o].split("=");
                        if ("" !== r[0]) {
                            var i = decodeURIComponent(r[0]);
                            n[i] ? (Array.isArray(n[i]) || (n[i] = [
                                n[i]
                            ]), n[i].push(decodeURIComponent(r[1] || ""))) : n[i] = decodeURIComponent(r[1] || "");
                        }
                    }
                    return n;
                }
                function l(t, n) {
                    var e, a = h(s(t.currentLocationPath)), l = a[0], p = a[1], d = "" === p ? null : f(p), v = [];
                    if (c(n.path)) {
                        if (e = "(?:/^|^)" + s(n.path).replace(o, function(t, n, e) {
                            return v.push(e), "([^/]+)";
                        }).replace(r, "?(?:.*)").replace(i, "/?([^/]+|)") + "$", "" === s(n.path) && "" === s(l)) return {
                            url: l,
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: null,
                            params: d
                        };
                    } else e = n.path;
                    var g = new RegExp(e, ""), m = l.match(g);
                    if (m) {
                        var y = c(n.path) ? function(t, n) {
                            return 0 === n.length ? null : t ? t.slice(1, t.length).reduce(function(t, e, o) {
                                return null === t && (t = {}), t[n[o]] = decodeURIComponent(e), t;
                            }, null) : null;
                        }(m, v) : m.groups ? m.groups : m.slice(1);
                        return {
                            url: s(l.replace(new RegExp("^" + t.instance.root), "")),
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: y,
                            params: d
                        };
                    }
                    return !1;
                }
                function p() {
                    return !("undefined" == typeof window || !window.history || !window.history.pushState);
                }
                function d(t, n) {
                    return void 0 === t[n] || !0 === t[n];
                }
                function v() {
                    return "undefined" != typeof window;
                }
                function g(t, n) {
                    return void 0 === t && (t = []), void 0 === n && (n = {}), t.filter(function(t) {
                        return t;
                    }).forEach(function(t) {
                        [
                            "before",
                            "after",
                            "already",
                            "leave"
                        ].forEach(function(e) {
                            t[e] && (n[e] || (n[e] = []), n[e].push(t[e]));
                        });
                    }), n;
                }
                function m(t, n, e) {
                    var o = n || {}, r = 0;
                    !function n() {
                        t[r] ? Array.isArray(t[r]) ? (t.splice.apply(t, [
                            r,
                            1
                        ].concat(t[r][0](o) ? t[r][1] : t[r][2])), n()) : t[r](o, function(t) {
                            void 0 === t || !0 === t ? (r += 1, n()) : e && e(o);
                        }) : e && e(o);
                    }();
                }
                function y(t, n) {
                    void 0 === t.currentLocationPath && (t.currentLocationPath = t.to = a(t.instance.root)), t.currentLocationPath = t.instance._checkForAHash(t.currentLocationPath), n();
                }
                function _(t, n) {
                    for(var e = 0; e < t.instance.routes.length; e++){
                        var o = l(t, t.instance.routes[e]);
                        if (o && (t.matches || (t.matches = []), t.matches.push(o), "ONE" === t.resolveOptions.strategy)) return void n();
                    }
                    n();
                }
                function k(t, n) {
                    t.navigateOptions && (void 0 !== t.navigateOptions.shouldResolve && console.warn('"shouldResolve" is deprecated. Please check the documentation.'), void 0 !== t.navigateOptions.silent && console.warn('"silent" is deprecated. Please check the documentation.')), n();
                }
                function O(t, n) {
                    !0 === t.navigateOptions.force ? (t.instance._setCurrent([
                        t.instance._pathToMatchObject(t.to)
                    ]), n(!1)) : n();
                }
                m.if = function(t, n, e) {
                    return Array.isArray(n) || (n = [
                        n
                    ]), Array.isArray(e) || (e = [
                        e
                    ]), [
                        t,
                        n,
                        e
                    ];
                };
                var w = v(), L = p();
                function b(t, n) {
                    if (d(t.navigateOptions, "updateBrowserURL")) {
                        var e = ("/" + t.to).replace(/\/\//g, "/"), o = w && t.resolveOptions && !0 === t.resolveOptions.hash;
                        L ? (history[t.navigateOptions.historyAPIMethod || "pushState"](t.navigateOptions.stateObj || {}, t.navigateOptions.title || "", o ? "#" + e : e), location && location.hash && (t.instance.__freezeListening = !0, setTimeout(function() {
                            if (!o) {
                                var n = location.hash;
                                location.hash = "", location.hash = n;
                            }
                            t.instance.__freezeListening = !1;
                        }, 1))) : w && (window.location.href = t.to);
                    }
                    n();
                }
                function A(t, n) {
                    var e = t.instance;
                    e.lastResolved() ? m(e.lastResolved().map(function(n) {
                        return function(e, o) {
                            if (n.route.hooks && n.route.hooks.leave) {
                                var r = !1, i = t.instance.matchLocation(n.route.path, t.currentLocationPath, !1);
                                r = "*" !== n.route.path ? !i : !(t.matches && t.matches.find(function(t) {
                                    return n.route.path === t.route.path;
                                })), d(t.navigateOptions, "callHooks") && r ? m(n.route.hooks.leave.map(function(n) {
                                    return function(e, o) {
                                        return n(function(n) {
                                            !1 === n ? t.instance.__markAsClean(t) : o();
                                        }, t.matches && t.matches.length > 0 ? 1 === t.matches.length ? t.matches[0] : t.matches : void 0);
                                    };
                                }).concat([
                                    function() {
                                        return o();
                                    }
                                ])) : o();
                            } else o();
                        };
                    }), {}, function() {
                        return n();
                    }) : n();
                }
                function P(t, n) {
                    d(t.navigateOptions, "updateState") && t.instance._setCurrent(t.matches), n();
                }
                var R = [
                    function(t, n) {
                        var e = t.instance.lastResolved();
                        if (e && e[0] && e[0].route === t.match.route && e[0].url === t.match.url && e[0].queryString === t.match.queryString) return e.forEach(function(n) {
                            n.route.hooks && n.route.hooks.already && d(t.navigateOptions, "callHooks") && n.route.hooks.already.forEach(function(n) {
                                return n(t.match);
                            });
                        }), void n(!1);
                        n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.before && d(t.navigateOptions, "callHooks") ? m(t.match.route.hooks.before.map(function(n) {
                            return function(e, o) {
                                return n(function(n) {
                                    !1 === n ? t.instance.__markAsClean(t) : o();
                                }, t.match);
                            };
                        }).concat([
                            function() {
                                return n();
                            }
                        ])) : n();
                    },
                    function(t, n) {
                        d(t.navigateOptions, "callHandler") && t.match.route.handler(t.match), t.instance.updatePageLinks(), n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.after && d(t.navigateOptions, "callHooks") && t.match.route.hooks.after.forEach(function(n) {
                            return n(t.match);
                        }), n();
                    }
                ], S = [
                    A,
                    function(t, n) {
                        var e = t.instance._notFoundRoute;
                        if (e) {
                            t.notFoundHandled = !0;
                            var o = h(t.currentLocationPath), r = o[0], i = o[1], a = u(t.to);
                            e.path = s(r);
                            var c = {
                                url: e.path,
                                queryString: i,
                                hashString: a,
                                data: null,
                                route: e,
                                params: "" !== i ? f(i) : null
                            };
                            t.matches = [
                                c
                            ], t.match = c;
                        }
                        n();
                    },
                    m.if(function(t) {
                        return t.notFoundHandled;
                    }, R.concat([
                        P
                    ]), [
                        function(t, n) {
                            t.resolveOptions && !1 !== t.resolveOptions.noMatchWarning && void 0 !== t.resolveOptions.noMatchWarning || console.warn('Navigo: "' + t.currentLocationPath + "\" didn't match any of the registered routes."), n();
                        },
                        function(t, n) {
                            t.instance._setCurrent(null), n();
                        }
                    ])
                ];
                function E() {
                    return (E = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                function x(t, n) {
                    var e = 0;
                    A(t, function o() {
                        e !== t.matches.length ? m(R, E({}, t, {
                            match: t.matches[e]
                        }), function() {
                            e += 1, o();
                        }) : P(t, n);
                    });
                }
                function H(t) {
                    t.instance.__markAsClean(t);
                }
                function j() {
                    return (j = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                var C = "[data-navigo]";
                function N(t, n) {
                    var e, o = n || {
                        strategy: "ONE",
                        hash: !1,
                        noMatchWarning: !1,
                        linksSelector: C
                    }, r = this, i = "/", d = null, w = [], L = !1, A = p(), P = v();
                    function R(t) {
                        return t.indexOf("#") >= 0 && (t = !0 === o.hash ? t.split("#")[1] || "/" : t.split("#")[0]), t;
                    }
                    function E(t) {
                        return s(i + "/" + s(t));
                    }
                    function N(t, n, e, o) {
                        return t = c(t) ? E(t) : t, {
                            name: o || s(String(t)),
                            path: t,
                            handler: n,
                            hooks: g(e)
                        };
                    }
                    function U(t, n) {
                        if (!r.__dirty) {
                            r.__dirty = !0, t = t ? s(i) + "/" + s(t) : void 0;
                            var e = {
                                instance: r,
                                to: t,
                                currentLocationPath: t,
                                navigateOptions: {},
                                resolveOptions: j({}, o, n)
                            };
                            return m([
                                y,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S)
                            ], e, H), !!e.matches && e.matches;
                        }
                        r.__waiting.push(function() {
                            return r.resolve(t, n);
                        });
                    }
                    function q(t, n) {
                        if (r.__dirty) r.__waiting.push(function() {
                            return r.navigate(t, n);
                        });
                        else {
                            r.__dirty = !0, t = s(i) + "/" + s(t);
                            var e = {
                                instance: r,
                                to: t,
                                navigateOptions: n || {},
                                resolveOptions: n && n.resolveOptions ? n.resolveOptions : o,
                                currentLocationPath: R(t)
                            };
                            m([
                                k,
                                O,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S),
                                b,
                                H
                            ], e, H);
                        }
                    }
                    function F() {
                        if (P) return (P ? [].slice.call(document.querySelectorAll(o.linksSelector || C)) : []).forEach(function(t) {
                            "false" !== t.getAttribute("data-navigo") && "_blank" !== t.getAttribute("target") ? t.hasListenerAttached || (t.hasListenerAttached = !0, t.navigoHandler = function(n) {
                                if ((n.ctrlKey || n.metaKey) && "a" === n.target.tagName.toLowerCase()) return !1;
                                var e = t.getAttribute("href");
                                if (null == e) return !1;
                                if (e.match(/^(http|https)/) && "undefined" != typeof URL) try {
                                    var o = new URL(e);
                                    e = o.pathname + o.search;
                                } catch (t) {}
                                var i = function(t) {
                                    if (!t) return {};
                                    var n, e = t.split(","), o = {};
                                    return e.forEach(function(t) {
                                        var e = t.split(":").map(function(t) {
                                            return t.replace(/(^ +| +$)/g, "");
                                        });
                                        switch(e[0]){
                                            case "historyAPIMethod":
                                                o.historyAPIMethod = e[1];
                                                break;
                                            case "resolveOptionsStrategy":
                                                n || (n = {}), n.strategy = e[1];
                                                break;
                                            case "resolveOptionsHash":
                                                n || (n = {}), n.hash = "true" === e[1];
                                                break;
                                            case "updateBrowserURL":
                                            case "callHandler":
                                            case "updateState":
                                            case "force":
                                                o[e[0]] = "true" === e[1];
                                        }
                                    }), n && (o.resolveOptions = n), o;
                                }(t.getAttribute("data-navigo-options"));
                                L || (n.preventDefault(), n.stopPropagation(), r.navigate(s(e), i));
                            }, t.addEventListener("click", t.navigoHandler)) : t.hasListenerAttached && t.removeEventListener("click", t.navigoHandler);
                        }), r;
                    }
                    function I(t, n, e) {
                        var o = w.find(function(n) {
                            return n.name === t;
                        }), r = null;
                        if (o) {
                            if (r = o.path, n) for(var a in n)r = r.replace(":" + a, n[a]);
                            r = r.match(/^\//) ? r : "/" + r;
                        }
                        return r && e && !e.includeRoot && (r = r.replace(new RegExp("^/" + i), "")), r;
                    }
                    function M(t) {
                        var n = h(s(t)), o = n[0], r = n[1], i = "" === r ? null : f(r);
                        return {
                            url: o,
                            queryString: r,
                            hashString: u(t),
                            route: N(o, function() {}, [
                                e
                            ], o),
                            data: null,
                            params: i
                        };
                    }
                    function T(t, n, e) {
                        return "string" == typeof n && (n = z(n)), n ? (n.hooks[t] || (n.hooks[t] = []), n.hooks[t].push(e), function() {
                            n.hooks[t] = n.hooks[t].filter(function(t) {
                                return t !== e;
                            });
                        }) : (console.warn("Route doesn't exists: " + n), function() {});
                    }
                    function z(t) {
                        return "string" == typeof t ? w.find(function(n) {
                            return n.name === E(t);
                        }) : w.find(function(n) {
                            return n.handler === t;
                        });
                    }
                    t ? i = s(t) : console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'), this.root = i, this.routes = w, this.destroyed = L, this.current = d, this.__freezeListening = !1, this.__waiting = [], this.__dirty = !1, this.__markAsClean = function(t) {
                        t.instance.__dirty = !1, t.instance.__waiting.length > 0 && t.instance.__waiting.shift()();
                    }, this.on = function(t, n, o) {
                        var r = this;
                        return "object" != typeof t || t instanceof RegExp ? ("function" == typeof t && (o = n, n = t, t = i), w.push(N(t, n, [
                            e,
                            o
                        ])), this) : (Object.keys(t).forEach(function(n) {
                            if ("function" == typeof t[n]) r.on(n, t[n]);
                            else {
                                var o = t[n], i = o.uses, a = o.as, s = o.hooks;
                                w.push(N(n, i, [
                                    e,
                                    s
                                ], a));
                            }
                        }), this);
                    }, this.off = function(t) {
                        return this.routes = w = w.filter(function(n) {
                            return c(t) ? s(n.path) !== s(t) : "function" == typeof t ? t !== n.handler : String(n.path) !== String(t);
                        }), this;
                    }, this.resolve = U, this.navigate = q, this.navigateByName = function(t, n, e) {
                        var o = I(t, n);
                        return null !== o && (q(o.replace(new RegExp("^/?" + i), ""), e), !0);
                    }, this.destroy = function() {
                        this.routes = w = [], A && window.removeEventListener("popstate", this.__popstateListener), this.destroyed = L = !0;
                    }, this.notFound = function(t, n) {
                        return r._notFoundRoute = N("*", t, [
                            e,
                            n
                        ], "__NOT_FOUND__"), this;
                    }, this.updatePageLinks = F, this.link = function(t) {
                        return "/" + i + "/" + s(t);
                    }, this.hooks = function(t) {
                        return e = t, this;
                    }, this.extractGETParameters = function(t) {
                        return h(R(t));
                    }, this.lastResolved = function() {
                        return d;
                    }, this.generate = I, this.getLinkPath = function(t) {
                        return t.getAttribute("href");
                    }, this.match = function(t) {
                        var n = {
                            instance: r,
                            currentLocationPath: t,
                            to: t,
                            navigateOptions: {},
                            resolveOptions: o
                        };
                        return _(n, function() {}), !!n.matches && n.matches;
                    }, this.matchLocation = function(t, n, e) {
                        void 0 === n || void 0 !== e && !e || (n = E(n));
                        var o = {
                            instance: r,
                            to: n,
                            currentLocationPath: n
                        };
                        return y(o, function() {}), "string" == typeof t && (t = void 0 === e || e ? E(t) : t), l(o, {
                            name: String(t),
                            path: t,
                            handler: function() {},
                            hooks: {}
                        }) || !1;
                    }, this.getCurrentLocation = function() {
                        return M(s(a(i)).replace(new RegExp("^" + i), ""));
                    }, this.addBeforeHook = T.bind(this, "before"), this.addAfterHook = T.bind(this, "after"), this.addAlreadyHook = T.bind(this, "already"), this.addLeaveHook = T.bind(this, "leave"), this.getRoute = z, this._pathToMatchObject = M, this._clean = s, this._checkForAHash = R, this._setCurrent = function(t) {
                        return d = r.current = t;
                    }, (function() {
                        A && (this.__popstateListener = function() {
                            r.__freezeListening || U();
                        }, window.addEventListener("popstate", this.__popstateListener));
                    }).call(this), F.call(this);
                }
            }
        }, n = {};
        function e(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                exports: {}
            };
            return t[o](r, r.exports, e), r.exports;
        }
        return e.d = function(t, n) {
            for(var o in n)e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: n[o]
            });
        }, e.o = function(t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
        }, e(407);
    }().default;
});



var $ca9ad = parcelRequire("ca9ad");






var $etzOt = parcelRequire("etzOt");

var $jwWxh = parcelRequire("jwWxh");

var $am1Dn = parcelRequire("am1Dn");

var $iRjZV = parcelRequire("iRjZV");

function $befda12da388622b$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $7a9d5aba215bb2ce$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}


function $54a861da3a3357eb$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}


function $5b735ef1925cbd1f$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}


function $b38b7448f04db943$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $7730d2bbaf51c965$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}


function $ac4087ceb56372ea$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $ac4087ceb56372ea$export$686e14b8469efec4(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$ac4087ceb56372ea$export$686e14b8469efec4(f[i], f[j]));
        }
        return (0, $7730d2bbaf51c965$export$2e2bcd8739ae039)(values, index);
    }
    return values.sort($ac4087ceb56372ea$export$5708b2c031939e56(f));
}
function $ac4087ceb56372ea$export$5708b2c031939e56(compare = (0, $b38b7448f04db943$export$2e2bcd8739ae039)) {
    if (compare === (0, $b38b7448f04db943$export$2e2bcd8739ae039)) return $ac4087ceb56372ea$export$686e14b8469efec4;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $ac4087ceb56372ea$export$686e14b8469efec4(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}


function $c934ebb301f53074$export$2e2bcd8739ae039(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, $ac4087ceb56372ea$export$686e14b8469efec4) : (0, $ac4087ceb56372ea$export$5708b2c031939e56)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $c934ebb301f53074$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $c934ebb301f53074$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $c934ebb301f53074$var$swap(array, left, right);
        while(i < j){
            $c934ebb301f53074$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $c934ebb301f53074$var$swap(array, left, j);
        else ++j, $c934ebb301f53074$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $c934ebb301f53074$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}


function $948a0a31377f7d52$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $948a0a31377f7d52$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}




function $5a4a51ebec8b0a63$export$2e2bcd8739ae039(values, compare = (0, $b38b7448f04db943$export$2e2bcd8739ae039)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $b38b7448f04db943$export$2e2bcd8739ae039)(value, maxValue) > 0 : (0, $b38b7448f04db943$export$2e2bcd8739ae039)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}


function $dbaf0f7619b88515$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $948a0a31377f7d52$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $54a861da3a3357eb$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $befda12da388622b$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $befda12da388622b$export$2e2bcd8739ae039)((0, $c934ebb301f53074$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $54a861da3a3357eb$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $dbaf0f7619b88515$export$f924a6cad778dddb(values, p, valueof = (0, $948a0a31377f7d52$export$2e2bcd8739ae039)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $dbaf0f7619b88515$export$f1fcc854ecc6ce55(values, p, valueof = (0, $948a0a31377f7d52$export$2e2bcd8739ae039)) {
    if (isNaN(p = +p)) return;
    numbers = Float64Array.from(values, (_, i)=>(0, $948a0a31377f7d52$export$2e2bcd8739ae039)(valueof(values[i], i, values)));
    if (p <= 0) return (0, $5b735ef1925cbd1f$export$2e2bcd8739ae039)(numbers);
    if (p >= 1) return (0, $7a9d5aba215bb2ce$export$2e2bcd8739ae039)(numbers);
    var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
    (0, $c934ebb301f53074$export$2e2bcd8739ae039)(index, i, 0, j, (i, j)=>(0, $ac4087ceb56372ea$export$686e14b8469efec4)(numbers[i], numbers[j]));
    i = (0, $5a4a51ebec8b0a63$export$2e2bcd8739ae039)(index.subarray(0, i + 1), (i)=>numbers[i]);
    return i >= 0 ? i : -1;
}


function $d6cbb20d6c6485f8$export$2e2bcd8739ae039(values, valueof) {
    return (0, $dbaf0f7619b88515$export$2e2bcd8739ae039)(values, 0.5, valueof);
}
function $d6cbb20d6c6485f8$export$57546ab4fd3c7a5e(values, valueof) {
    return (0, $dbaf0f7619b88515$export$f1fcc854ecc6ce55)(values, 0.5, valueof);
}

function $87a96f5646f68817$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}



var $am1Dn = parcelRequire("am1Dn");

var $e9fc6713eb9fa285$var$REGEX_VALID_OFFSET_FORMAT = /[+-]\d\d(?::?\d\d)?/g;
var $e9fc6713eb9fa285$var$REGEX_OFFSET_HOURS_MINUTES_FORMAT = /([+-]|\d\d)/g;
function $e9fc6713eb9fa285$var$offsetFromString(value) {
    if (value === void 0) value = "";
    var offset = value.match($e9fc6713eb9fa285$var$REGEX_VALID_OFFSET_FORMAT);
    if (!offset) return null;
    var _ref = ("" + offset[0]).match($e9fc6713eb9fa285$var$REGEX_OFFSET_HOURS_MINUTES_FORMAT) || [
        "-",
        0,
        0
    ], indicator = _ref[0], hoursOffset = _ref[1], minutesOffset = _ref[2];
    var totalOffsetInMinutes = +hoursOffset * 60 + +minutesOffset;
    if (totalOffsetInMinutes === 0) return 0;
    return indicator === "+" ? totalOffsetInMinutes : -totalOffsetInMinutes;
}
var $e9fc6713eb9fa285$export$2e2bcd8739ae039 = function(option, Dayjs, dayjs) {
    var proto = Dayjs.prototype;
    dayjs.utc = function(date) {
        var cfg = {
            date: date,
            utc: true,
            args: arguments
        }; // eslint-disable-line prefer-rest-params
        return new Dayjs(cfg); // eslint-disable-line no-use-before-define
    };
    proto.utc = function(keepLocalTime) {
        var ins = dayjs(this.toDate(), {
            locale: this.$L,
            utc: true
        });
        if (keepLocalTime) return ins.add(this.utcOffset(), (0, $0683ab1ee172a3e8$export$85fbf3b9d951b785));
        return ins;
    };
    proto.local = function() {
        return dayjs(this.toDate(), {
            locale: this.$L,
            utc: false
        });
    };
    var oldParse = proto.parse;
    proto.parse = function(cfg) {
        if (cfg.utc) this.$u = true;
        if (!this.$utils().u(cfg.$offset)) this.$offset = cfg.$offset;
        oldParse.call(this, cfg);
    };
    var oldInit = proto.init;
    proto.init = function() {
        if (this.$u) {
            var $d = this.$d;
            this.$y = $d.getUTCFullYear();
            this.$M = $d.getUTCMonth();
            this.$D = $d.getUTCDate();
            this.$W = $d.getUTCDay();
            this.$H = $d.getUTCHours();
            this.$m = $d.getUTCMinutes();
            this.$s = $d.getUTCSeconds();
            this.$ms = $d.getUTCMilliseconds();
        } else oldInit.call(this);
    };
    var oldUtcOffset = proto.utcOffset;
    proto.utcOffset = function(input, keepLocalTime) {
        var _this$$utils = this.$utils(), u = _this$$utils.u;
        if (u(input)) {
            if (this.$u) return 0;
            if (!u(this.$offset)) return this.$offset;
            return oldUtcOffset.call(this);
        }
        if (typeof input === "string") {
            input = $e9fc6713eb9fa285$var$offsetFromString(input);
            if (input === null) return this;
        }
        var offset = Math.abs(input) <= 16 ? input * 60 : input;
        var ins = this;
        if (keepLocalTime) {
            ins.$offset = offset;
            ins.$u = input === 0;
            return ins;
        }
        if (input !== 0) {
            var localTimezoneOffset = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            ins = this.local().add(offset + localTimezoneOffset, (0, $0683ab1ee172a3e8$export$85fbf3b9d951b785));
            ins.$offset = offset;
            ins.$x.$localOffset = localTimezoneOffset;
        } else ins = this.utc();
        return ins;
    };
    var oldFormat = proto.format;
    var UTC_FORMAT_DEFAULT = "YYYY-MM-DDTHH:mm:ss[Z]";
    proto.format = function(formatStr) {
        var str = formatStr || (this.$u ? UTC_FORMAT_DEFAULT : "");
        return oldFormat.call(this, str);
    };
    proto.valueOf = function() {
        var addedOffset = !this.$utils().u(this.$offset) ? this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset()) : 0;
        return this.$d.valueOf() - addedOffset * (0, $0683ab1ee172a3e8$export$37971e215480ff4b);
    };
    proto.isUTC = function() {
        return !!this.$u;
    };
    proto.toISOString = function() {
        return this.toDate().toISOString();
    };
    proto.toString = function() {
        return this.toDate().toUTCString();
    };
    var oldToDate = proto.toDate;
    proto.toDate = function(type) {
        if (type === "s" && this.$offset) return dayjs(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate();
        return oldToDate.call(this);
    };
    var oldDiff = proto.diff;
    proto.diff = function(input, units, _float) {
        if (input && this.$u === input.$u) return oldDiff.call(this, input, units, _float);
        var localThis = this.local();
        var localInput = dayjs(input).local();
        return oldDiff.call(localThis, localInput, units, _float);
    };
};



var $08e84c98e2b64281$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
}; // Cache time-zone lookups from Intl.DateTimeFormat,
// as it is a *very* slow method.
var $08e84c98e2b64281$var$dtfCache = {};
var $08e84c98e2b64281$var$getDateTimeFormat = function getDateTimeFormat(timezone, options) {
    if (options === void 0) options = {};
    var timeZoneName = options.timeZoneName || "short";
    var key = timezone + "|" + timeZoneName;
    var dtf = $08e84c98e2b64281$var$dtfCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: timezone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZoneName: timeZoneName
        });
        $08e84c98e2b64281$var$dtfCache[key] = dtf;
    }
    return dtf;
};
var $08e84c98e2b64281$export$2e2bcd8739ae039 = function(o, c, d) {
    var defaultTimezone;
    var makeFormatParts = function makeFormatParts(timestamp, timezone, options) {
        if (options === void 0) options = {};
        var date = new Date(timestamp);
        var dtf = $08e84c98e2b64281$var$getDateTimeFormat(timezone, options);
        return dtf.formatToParts(date);
    };
    var tzOffset = function tzOffset(timestamp, timezone) {
        var formatResult = makeFormatParts(timestamp, timezone);
        var filled = [];
        for(var i = 0; i < formatResult.length; i += 1){
            var _formatResult$i = formatResult[i], type = _formatResult$i.type, value = _formatResult$i.value;
            var pos = $08e84c98e2b64281$var$typeToPos[type];
            if (pos >= 0) filled[pos] = parseInt(value, 10);
        }
        var hour = filled[3]; // Workaround for the same behavior in different node version
        // https://github.com/nodejs/node/issues/33027
        /* istanbul ignore next */ var fixedHour = hour === 24 ? 0 : hour;
        var utcString = filled[0] + "-" + filled[1] + "-" + filled[2] + " " + fixedHour + ":" + filled[4] + ":" + filled[5] + ":000";
        var utcTs = d.utc(utcString).valueOf();
        var asTS = +timestamp;
        var over = asTS % 1000;
        asTS -= over;
        return (utcTs - asTS) / 60000;
    }; // find the right offset a given local time. The o input is our guess, which determines which
    // offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
    // https://github.com/moment/luxon/blob/master/src/datetime.js#L76
    var fixOffset = function fixOffset(localTS, o0, tz) {
        // Our UTC time is just a guess because our offset is just a guess
        var utcGuess = localTS - o0 * 60000; // Test whether the zone matches the offset for this ts
        var o2 = tzOffset(utcGuess, tz); // If so, offset didn't change and we're done
        if (o0 === o2) return [
            utcGuess,
            o0
        ];
         // If not, change the ts by the difference in the offset
        utcGuess -= (o2 - o0) * 60000; // If that gives us the local time we want, we're done
        var o3 = tzOffset(utcGuess, tz);
        if (o2 === o3) return [
            utcGuess,
            o2
        ];
         // If it's different, we're in a hole time.
        // The offset has changed, but the we don't adjust the time
        return [
            localTS - Math.min(o2, o3) * 60000,
            Math.max(o2, o3)
        ];
    };
    var proto = c.prototype;
    proto.tz = function(timezone, keepLocalTime) {
        if (timezone === void 0) timezone = defaultTimezone;
        var oldOffset = this.utcOffset();
        var date = this.toDate();
        var target = date.toLocaleString("en-US", {
            timeZone: timezone
        });
        var diff = Math.round((date - new Date(target)) / 1000 / 60);
        var ins = d(target, {
            locale: this.$L
        }).$set((0, $0683ab1ee172a3e8$export$71ad59f2e432cfe8), this.$ms).utcOffset(-Math.round(date.getTimezoneOffset() / 15) * 15 - diff, true);
        if (keepLocalTime) {
            var newOffset = ins.utcOffset();
            ins = ins.add(oldOffset - newOffset, (0, $0683ab1ee172a3e8$export$85fbf3b9d951b785));
        }
        ins.$x.$timezone = timezone;
        return ins;
    };
    proto.offsetName = function(type) {
        // type: short(default) / long
        var zone = this.$x.$timezone || d.tz.guess();
        var result = makeFormatParts(this.valueOf(), zone, {
            timeZoneName: type
        }).find(function(m) {
            return m.type.toLowerCase() === "timezonename";
        });
        return result && result.value;
    };
    var oldStartOf = proto.startOf;
    proto.startOf = function(units, startOf) {
        if (!this.$x || !this.$x.$timezone) return oldStartOf.call(this, units, startOf);
        var withoutTz = d(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
            locale: this.$L
        });
        var startOfWithoutTz = oldStartOf.call(withoutTz, units, startOf);
        return startOfWithoutTz.tz(this.$x.$timezone, true);
    };
    d.tz = function(input, arg1, arg2) {
        var parseFormat = arg2 && arg1;
        var timezone = arg2 || arg1 || defaultTimezone;
        var previousOffset = tzOffset(+d(), timezone);
        if (typeof input !== "string") // timestamp number || js Date || Day.js
        return d(input).tz(timezone);
        var localTs = d.utc(input, parseFormat).valueOf();
        var _fixOffset = fixOffset(localTs, previousOffset, timezone), targetTs = _fixOffset[0], targetOffset = _fixOffset[1];
        var ins = d(targetTs).utcOffset(targetOffset);
        ins.$x.$timezone = timezone;
        return ins;
    };
    d.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    };
    d.tz.setDefault = function(timezone) {
        defaultTimezone = timezone;
    };
};



var $72a5aeb23b3730ca$export$2e2bcd8739ae039 = function(o, c) {
    // locale needed later
    var proto = c.prototype;
    var oldFormat = proto.format;
    proto.format = function(formatStr) {
        var _this = this;
        var locale = this.$locale();
        if (!this.isValid()) return oldFormat.bind(this)(formatStr);
        var utils = this.$utils();
        var str = formatStr || (0, $0683ab1ee172a3e8$export$43dfb2cd49ed2315);
        var result = str.replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(match) {
            switch(match){
                case "Q":
                    return Math.ceil((_this.$M + 1) / 3);
                case "Do":
                    return locale.ordinal(_this.$D);
                case "gggg":
                    return _this.weekYear();
                case "GGGG":
                    return _this.isoWeekYear();
                case "wo":
                    return locale.ordinal(_this.week(), "W");
                // W for week
                case "w":
                case "ww":
                    return utils.s(_this.week(), match === "w" ? 1 : 2, "0");
                case "W":
                case "WW":
                    return utils.s(_this.isoWeek(), match === "W" ? 1 : 2, "0");
                case "k":
                case "kk":
                    return utils.s(String(_this.$H === 0 ? 24 : _this.$H), match === "k" ? 1 : 2, "0");
                case "X":
                    return Math.floor(_this.$d.getTime() / 1000);
                case "x":
                    return _this.$d.getTime();
                case "z":
                    return "[" + _this.offsetName() + "]";
                case "zzz":
                    return "[" + _this.offsetName("long") + "]";
                default:
                    return match;
            }
        });
        return oldFormat.bind(this)(result);
    };
};


var $af640ff2c4a6bed0$exports = {};








/*!
 * chartjs-adapter-dayjs v0.2.0
 * https://www.chartjs.org
 * (c) 2019 Chart.js Contributors
 * Released under the MIT license
 * Patched to include time zone information when formatting
 */ (function(global, factory) {
    factory((parcelRequire("jwWxh")), (parcelRequire("jCgCX")), (parcelRequire("5VMx0")), (parcelRequire("9hx7p")), (parcelRequire("favLa")), (parcelRequire("cKWSB")), (parcelRequire("f8xpu")), (parcelRequire("6s8rf")));
})($af640ff2c4a6bed0$exports, function(chart_js, dayjs, utc, dayjsTz, dayjsWeekday, advancedFormat, localizedFormat, weekOfYear) {
    "use strict";
    dayjs = dayjs && dayjs.hasOwnProperty("default") ? dayjs["default"] : dayjs;
    utc = utc && utc.hasOwnProperty("default") ? utc["default"] : utc;
    dayjsTz = dayjsTz && dayjsTz.hasOwnProperty("default") ? dayjsTz["default"] : dayjsTz;
    dayjsWeekday = dayjsWeekday && dayjsWeekday.hasOwnProperty("default") ? dayjsWeekday["default"] : dayjsWeekday;
    advancedFormat = advancedFormat && advancedFormat.hasOwnProperty("default") ? advancedFormat["default"] : advancedFormat;
    localizedFormat = localizedFormat && localizedFormat.hasOwnProperty("default") ? localizedFormat["default"] : localizedFormat;
    weekOfYear = weekOfYear && weekOfYear.hasOwnProperty("default") ? weekOfYear["default"] : weekOfYear;
    const FORMATS = {
        datetime: "MMM D, YYYY, h:mm:ss a",
        millisecond: "h:mm:ss.SSS a",
        second: "h:mm:ss a",
        minute: "h:mm a",
        hour: "hA",
        day: "MMM D",
        week: "ll",
        month: "MMM YYYY",
        quarter: "[Q]Q - YYYY",
        year: "YYYY"
    };
    chart_js._adapters._date.override({
        _id: "dayjs",
        /**
     * @private
     */ _create: function(time) {
            dayjs.extend(utc);
            return dayjs.utc(time);
        },
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            dayjs.extend(utc);
            if (typeof value === "string" && typeof format === "string") value = dayjs.utc(value, format);
            else if (!(value instanceof dayjs)) value = dayjs.utc(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            dayjs.extend(utc);
            dayjs.extend(dayjsTz);
            dayjs.extend(advancedFormat);
            dayjs.extend(localizedFormat);
            dayjs.extend(weekOfYear);
            return dayjs.tz ? dayjs.utc(time).tz(dayjs.tz.guess()).format(format) : dayjs.utc(time).format(format);
        },
        add: function(time, amount, unit) {
            dayjs.extend(utc);
            return dayjs.utc(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            dayjs.extend(utc);
            return dayjs.utc(max).diff(dayjs(min), unit);
        },
        startOf: function(time, unit, weekday) {
            dayjs.extend(utc);
            dayjs.extend(dayjsWeekday);
            time = dayjs.utc(time);
            if (unit === "isoWeek") return time.weekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            dayjs.extend(utc);
            return dayjs.utc(time).endOf(unit).valueOf();
        }
    });
});


(0, $0866737b96521d45$export$2e2bcd8739ae039).extend((0, $e9fc6713eb9fa285$export$2e2bcd8739ae039));
(0, $0866737b96521d45$export$2e2bcd8739ae039).extend((0, $08e84c98e2b64281$export$2e2bcd8739ae039));
(0, $0866737b96521d45$export$2e2bcd8739ae039).extend((0, $72a5aeb23b3730ca$export$2e2bcd8739ae039));
function $7b54f81a1705cc34$export$a00e671a9b023575(rawData, duration, metrics, isSwell) {
    console.debug("generateChartConfig");
    let m, yScales = {}, xScale = {
        display: true,
        type: "time",
        time: {
            unit: duration === 60 || duration === 36 ? "minute" : "hour",
            tooltipFormat: "DD/MM/YYYY\nHH[h]mm",
            displayFormats: {
                hour: "HH[h]mm",
                minute: "HH[h]mm",
                day: "ddd DD/MM [-] HH[h]mm"
            }
        },
        scaleLabel: {
            display: true
        },
        ticks: {
            source: "labels",
            includeBounds: false
        }
    };
    var cfg = {
        type: "line",
        data: $7b54f81a1705cc34$var$generateChartData(rawData, metrics, isSwell, duration),
        options: {
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
                tooltip: {
                    yAlign: "center",
                    caretPadding: 25,
                    callbacks: {
                        label: function(tooltipItem) {
                            if (tooltipItem.chart.canvas.id === "sensor_chart_wind") {
                                let value = parseInt(tooltipItem.formattedValue);
                                if (value < 0) value = value + 360;
                                return tooltipItem.dataset.label + " : " + (tooltipItem.dataset.label.indexOf("V") === 0 ? value.toString() + " nds" : (value % 360).toString() + "\xb0");
                            } else return tooltipItem.dataset.label + " : " + tooltipItem.formattedValue;
                        }
                    }
                }
            },
            transitions: {
                active: {
                    animation: {
                        duration: 0
                    }
                }
            },
            interaction: {
                mode: "index",
                intersect: false
            },
            radius: 0
        }
    };
    for(m = 0; m < metrics.length; m++)yScales["y" + (m === 0 ? "" : m)] = {
        type: "linear",
        display: true,
        scaleLabel: {
            display: true
        },
        ticks: {
            // major: {enabled: true},
            includeBounds: false,
            color: $7b54f81a1705cc34$var$getMetricColor(metrics[m]),
            stepSize: $7b54f81a1705cc34$var$getStepSizeY(metrics[m], duration),
            callback: $7b54f81a1705cc34$var$labelWithUnit(metrics[m]),
            font: {
                size: 10
            }
        },
        position: m === 0 ? "left" : "right",
        grid: {
            display: true,
            drawBorder: true,
            drawOnChartArea: m === 0
        },
        ...$7b54f81a1705cc34$var$scaleRange(metrics[m], duration, $7b54f81a1705cc34$var$computeMinMax(cfg.data.datasets), isSwell)
    };
    cfg.options.scales = {
        x: xScale,
        ...yScales
    };
    return cfg;
}
function $7b54f81a1705cc34$var$getMetricColor(metric) {
    return "#333"; //config.chartColors[metric].moy;
}
function $7b54f81a1705cc34$var$labelWithUnit(metric) {
    return function(val) {
        let unit;
        if (metric === "ws") unit = " nds";
        else if (metric === "wd" || metric === "sd") {
            unit = "\xb0";
            val = val < 0 ? 360 + Math.round(val) : Math.round(val) % 360;
        } else if (metric === "t") {
            if (Math.abs(val) > 1 && Math.abs(val) < 10) val = val.toPrecision(2);
            else if (Math.abs(val) > 9) val = val.toPrecision(3);
            else val = val.toPrecision(2);
            val = Math.round(val);
            unit = " \xb0C";
        } else if (metric === "sh") unit = " m";
        else if (metric === "p") unit = " hPa";
        else if (metric === "wv") {
            val = val.toPrecision(1);
            unit = " m/s";
        } else if (metric === "sp") unit = " s";
        return val + unit;
    };
}
function $7b54f81a1705cc34$var$generateChartData(rawData, fields, isSwell, duration) {
    console.debug("generateChartData");
    var graphDatasets = {}, graphTimestamps = [], d, prop, f;
    for (d of rawData){
        const isSwellSensor = d["sh"] && d["sh"]["moy"];
        graphTimestamps.push(d.ts);
        for (f of fields){
            if (d[f]) for(prop in d[f]){
                graphDatasets[f + prop] = graphDatasets[f + prop] || {
                    label: $7b54f81a1705cc34$var$graphDatasetLabel(f, prop, isSwell, isSwellSensor),
                    color: (0, $am1Dn.config).chartColors[f][prop] || "#000000",
                    values: []
                };
                graphDatasets[f + prop].values.push({
                    x: (0, $0866737b96521d45$export$2e2bcd8739ae039).unix(d.ts),
                    y: d[f][prop]
                });
            }
        }
    }
    let skippedTicks = isSwell ? 0 : duration === 60 ? 4 : 2;
    let hoverElt = document.createElement("IMG");
    hoverElt.src = (0, $am1Dn.LayersIcons)["graph-cursor"];
    hoverElt.alt = "img";
    return {
        labels: graphTimestamps.map(function(ts) {
            if (isSwell) return (0, $0866737b96521d45$export$2e2bcd8739ae039).unix(ts);
            else {
                let stepInSeconds = duration === 60 ? 600 : duration === 36 ? 1800 : 7200;
                return (0, $0866737b96521d45$export$2e2bcd8739ae039).unix(ts - ts % stepInSeconds);
            }
        }).slice(skippedTicks),
        datasets: Object.keys(graphDatasets).map(function(ds, i) {
            return {
                ref: ds,
                label: graphDatasets[ds].label,
                data: graphDatasets[ds].values,
                borderColor: graphDatasets[ds].color,
                hidden: $7b54f81a1705cc34$var$isLegendHidden(ds),
                fill: false,
                tension: 0.4,
                yAxisID: "y" + (fields.indexOf($7b54f81a1705cc34$var$fieldRef(ds)) === 0 ? "" : fields.indexOf($7b54f81a1705cc34$var$fieldRef(ds))),
                pointStyle: hoverElt,
                pointRadius: 0,
                pointHoverRadius: 2000,
                hoverBorderColor: "#333333"
            };
        })
    };
}
function $7b54f81a1705cc34$var$isLegendHidden(type) {
    if (type === "wsmax") return false;
    else return type.indexOf("moy") === -1;
}
function $7b54f81a1705cc34$var$fieldRef(ref) {
    return ref.indexOf("w") === 0 || ref.indexOf("s") === 0 ? ref.substring(0, 2) : ref.substring(0, 1);
}
function $7b54f81a1705cc34$var$computeMinMax(datasets) {
    let minMax = {}, dataset, datasetValues, field, min, max, med;
    for (dataset of datasets){
        field = $7b54f81a1705cc34$var$fieldRef(dataset.ref), datasetValues = dataset.data.map(function(d) {
            return d.y;
        });
        min = Math.min(...datasetValues);
        max = Math.max(...datasetValues);
        if (!minMax[field]) minMax[field] = {};
        if (field === "wd") {
            med = (0, $d6cbb20d6c6485f8$export$2e2bcd8739ae039)(datasetValues);
            if (minMax[field]["med"]) minMax[field]["med"].push(med);
            else minMax[field]["med"] = [
                med
            ];
        }
        if (!minMax[field].min || min < minMax[field].min) minMax[field].min = min;
        if (!minMax[field].max || max > minMax[field].max) minMax[field].max = max;
    }
    return minMax;
}
function $7b54f81a1705cc34$var$scaleRange(field, duration, minMax, isSwell) {
    let range, absMin, absMax, sMin, sMax, scaleRng = {};
    if (field === "wv") scaleRng = {
        min: -5,
        max: 5
    };
    else if (field === "sp") scaleRng = {
        min: 0,
        max: 30
    };
    else if (field === "sd") scaleRng = {
        min: 0,
        max: 360
    };
    else if (field === "sh") {
        range = 10;
        sMin = minMax[field].min;
        sMax = minMax[field].max;
        scaleRng = {
            min: Math.max(0, Math.round((sMin + sMax - range) / 2)),
            max: Math.max(10, Math.round((sMin + sMax + range) / 2))
        };
    } else if (field === "t") {
        if (isSwell) range = 10;
        else range = 30;
        sMin = minMax[field].min;
        sMax = minMax[field].max;
        scaleRng = {
            min: Math.round((sMin + sMax - range) / 2),
            max: Math.round((sMin + sMax + range) / 2)
        };
    } else if (field === "p") {
        range = 20;
        sMin = minMax[field].min;
        sMax = minMax[field].max;
        scaleRng = {
            min: Math.round((sMin + sMax - range) / 2),
            max: Math.round((sMin + sMax + range) / 2)
        };
    } else if (field === "wd") {
        let med = (0, $87a96f5646f68817$export$2e2bcd8739ae039)(minMax[field].med), amplitude = duration === 144 ? 400 : 200;
        scaleRng = {
            min: Math.round((med - amplitude / 2) / 10) * 10,
            max: med + amplitude / 2
        };
    } else if (field === "ws") {
        if (duration === 60 || duration === 36 || duration === 144) {
            range = duration === 144 ? 70 : 40;
            absMin = 0;
            absMax = 200;
            sMin = Math.max(absMin, minMax[field].min);
            sMax = Math.min(absMax, minMax[field].max);
            scaleRng = {
                min: (sMin + sMax - range) / 2 < absMin ? absMin : Math.round((sMin + sMax - range) / 2),
                max: (sMin + sMax - range) / 2 < absMin ? range : Math.round((sMin + sMax + range) / 2)
            };
        }
    }
    // console.log('computed scale range - field : ' + field + ' - duration : ' + duration + ' - minMax : ' +
    //   JSON.stringify(minMax) + ' - isSwell : ' + isSwell + ' - scale range : ' + JSON.stringify(scaleRng));
    return scaleRng;
}
function $7b54f81a1705cc34$var$getStepSizeY(metrics, duration) {
    if (metrics === "t" || metrics === "p" || metrics === "wv") return 1;
    else if (metrics === "t") return 4;
    else if (metrics === "ws") return duration < 144 ? 2 : 4;
    else if (metrics === "sd") return 20;
    else if (metrics === "wd") {
        if (duration === 60 || duration === 36) return 10;
        else if (duration === 144) return 20;
    }
}
function $7b54f81a1705cc34$var$positiveValue(rawData) {
    for(let d = 0; d < rawData.length; d++){
        if (rawData[d]["wd"].moy < 0) rawData[d]["wd"].moy = rawData[d]["wd"].moy + 360;
        if (rawData[d]["wd"].min < 0) rawData[d]["wd"].min = rawData[d]["wd"].min + 360;
        if (rawData[d]["wd"].max < 0) rawData[d]["wd"].max = rawData[d]["wd"].max + 360;
    }
    return rawData;
}
function $7b54f81a1705cc34$var$graphDatasetLabel(field, prop, isSeaTemp, isSwellSensor) {
    if (field === "ws") return "V. " + prop + "";
    else if (field === "wd") return "Dir. " + prop + "";
    else if (field === "wv") return "V. vert.";
    else if (field === "t") return "T\xb0 " + (isSeaTemp ? `mer (${isSwellSensor ? "\xe0 40cm" : "\xe0 2m"} sous la surface)` : "air");
    else if (field === "sh") return "Hauteur de la houle " + prop + "";
    else if (field === "sp") return "P\xe9riode de la houle " + prop + "";
    else if (field === "p") return "Pression atmosph\xe9rique";
    else if (field === "sd") return "Direction de la houle";
    else return prop;
}
function $7b54f81a1705cc34$var$chartTitle(metric) {
    if (metric === "ws") return "Vitesse du vent";
    else if (metric === "wd") return "Direction du vent";
    else if (metric === "wv") return "Vitesse verticale du vent";
    else if (metric === "t") return "Temp\xe9rature de l'air";
    else if (metric === "p") return "Pression atmosph\xe9rique";
    else return metric;
}




(0, $jwWxh.Chart).register(...(0, $jwWxh.registerables));
(0, $fddf1565bfa293cc$export$cacc2a877598679f).prototype.options.iconUrl = (0, $am1Dn.LayersIcons)["marker-icon"];
(0, $fddf1565bfa293cc$export$cacc2a877598679f).prototype.options.iconRetinaUrl = (0, $am1Dn.LayersIcons)["marker-icon-2x"];
(0, $fddf1565bfa293cc$export$cacc2a877598679f).prototype.options.shadowUrl = (0, $am1Dn.LayersIcons)["marker-shadow"];
function $15afa6c724e20c66$export$aadaa5940712eda(d) {
    console.log("sensorDetails:" + d.category);
    let sensor;
    if (d.nid === (0, $am1Dn.waterTempSensorId)) sensor = (0, $am1Dn.waterTempSensorsRefs)[0];
    else sensor = (0, $am1Dn.sensorsRefs)[d.nid] || (0, $am1Dn.waveSensorsRefs)[d.nid];
    document.querySelector("#map_modal").setAttribute("data-modal", "wind_sensor");
    document.querySelector("#map_modal_title").innerHTML = sensor.label + "<span>Observations</span>";
    document.querySelector("#map_modal #header_links").innerHTML = $15afa6c724e20c66$var$renderLinks(sensor, "header");
    document.querySelector("#map_modal_content").innerHTML = '<section><div id="charts_actions"><button type="button" onclick="wm.displaySensorCharts(this, ' + d.nid + ", '" + d.category + '\', 120, 60);" class="active">2 derni\xe8res heures</button>' + '<button type="button" onclick="wm.displaySensorCharts(this, ' + d.nid + ", '" + d.category + "', 600, 36);\">Graphique 6h</button>" + '<button type="button" onclick="wm.displaySensorCharts(this, ' + d.nid + ", '" + d.category + "', 600, 144);\">Graphique 24h</button>" + '<button type="button" onclick="wm.displaySensorCharts(this, ' + d.nid + ", '" + d.category + "', 600, 1152);\">8 derniers jours</button>" + "</div>" + '<div id="charts_wrapper"></div>' + "</section>" + "<aside>" + $15afa6c724e20c66$var$renderAside(sensor) + "</aside>";
    (0, $ca9ad.default).show("map_modal", {
        disableScroll: true,
        onClose: ()=>{
            (0, $26ce3c45196098b3$export$2e2bcd8739ae039).navigate("/");
        }
    });
    $15afa6c724e20c66$export$af377084b1bb65fd(null, d.nid, d.category, 120, 60);
    // initAsideMap();
    $15afa6c724e20c66$var$initAsideSlides();
}
function $15afa6c724e20c66$export$af377084b1bb65fd(btn, sensorId, sensorCategory, period, duration) {
    document.querySelector("#map_modal_content #charts_wrapper").innerHTML = '<p class="loading">Chargement des donn\xe9es en cours...</p>';
    let isSwell = (0, $am1Dn.waveSensorsRefs)[sensorId], isWaterTemp = sensorId === (0, $am1Dn.waterTempSensorId), apiDuration;
    if (isWaterTemp) apiDuration = duration === 60 ? 2 : duration === 36 ? 3 : duration === 1152 ? 40 : 5;
    else apiDuration = duration;
    if ($15afa6c724e20c66$var$isNewGeneration(sensorId, sensorCategory)) (0, $iRjZV.getAsync)(`https://backend.windmorbihan.com/observations/chart.json?sensor=${sensorId}&time_frame=${duration}`, (resp)=>$15afa6c724e20c66$var$processChartData(resp, sensorId, sensorCategory, duration, isSwell, isWaterTemp));
    else (0, $iRjZV.postAsync)("https://private1.windmorbihan.com/mesures/get_graph_sensor_data", "settings[cid]=" + sensorId + "&settings[interval]=-1&settings[type]=" + (isSwell || isWaterTemp ? 0 : period) + "&settings[limit]=" + apiDuration, (resp)=>$15afa6c724e20c66$var$processChartData(resp, sensorId, sensorCategory, duration, isSwell, isWaterTemp));
    if (btn) {
        var activeBtn = document.querySelector("#map_modal_content #charts_actions .active");
        if (activeBtn) activeBtn.classList.remove("active");
        btn.classList.add("active");
    }
}
function $15afa6c724e20c66$var$isNewGeneration(sensorId, sensorCategory) {
    return sensorCategory === "mf" || /^\d{1,4}$/.test(sensorId);
}
function $15afa6c724e20c66$var$processChartData(resp, sensorId, sensorCategory, duration, isSwell, isWaterTemp) {
    console.debug("processChartData");
    let data = $15afa6c724e20c66$var$isNewGeneration(sensorId, sensorCategory) ? resp : JSON.parse(resp).reverse(), ctx, i, windMetrics = [
        "ws",
        "wd"
    ], otherMetrics = isSwell ? [
        "sh",
        "sp",
        "sd",
        "t"
    ] : [
        "t",
        "sh",
        "sp",
        "sd",
        "wv",
        "p"
    ];
    let rawData = isSwell || isWaterTemp ? data : $15afa6c724e20c66$var$cleanUpDataset(data, sensorId);
    if (rawData && rawData.length) {
        if (document.querySelector(".radio-container")) document.querySelector(".radio-container").remove();
        document.querySelector("#map_modal_content #charts_wrapper").innerHTML = "";
        if (duration === 1152) {
            let seperateData = $15afa6c724e20c66$var$generateSeperateChartData(rawData);
            let separateAvailableMetrics = $15afa6c724e20c66$var$getseparateAvailableMetrics(seperateData, windMetrics, otherMetrics);
            $15afa6c724e20c66$var$generateRadioCollection(seperateData, separateAvailableMetrics, isSwell || isWaterTemp, otherMetrics);
            let radioCollectionList = document.querySelectorAll(".radio-container_item input");
            $15afa6c724e20c66$var$initChart(radioCollectionList, seperateData, separateAvailableMetrics, isSwell || isWaterTemp, otherMetrics);
        } else {
            let availableMetrics = $15afa6c724e20c66$var$getAvailableMetric(rawData, windMetrics, otherMetrics);
            let availWindMetrics = availableMetrics[0];
            let availOtherMetrics = availableMetrics[1];
            let m = availableMetrics[2];
            if (availWindMetrics.length) {
                document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_wind"></canvas></div>');
                ctx = document.getElementById("sensor_chart_wind").getContext("2d");
                new (0, $jwWxh.Chart)(ctx, (0, $7b54f81a1705cc34$export$a00e671a9b023575)($15afa6c724e20c66$export$4e89807aca88641f(rawData, 360), duration, availWindMetrics, isSwell || isWaterTemp));
            }
            if (availOtherMetrics.length) {
                let sortedOther = availOtherMetrics.sort(function(m) {
                    return otherMetrics.indexOf(m);
                });
                for (m of availOtherMetrics){
                    document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_' + m + '"></canvas></div>');
                    ctx = document.getElementById("sensor_chart_" + m).getContext("2d");
                    new (0, $jwWxh.Chart)(ctx, (0, $7b54f81a1705cc34$export$a00e671a9b023575)(rawData, duration, [
                        m
                    ], isSwell || isWaterTemp));
                }
            }
        }
    }
}
/* ------ get available metric ------*/ function $15afa6c724e20c66$var$getseparateAvailableMetrics(seperateData, windMetrics, otherMetrics) {
    let separateAvailableMetrics = {};
    for(let s in seperateData){
        if (!separateAvailableMetrics[s]) separateAvailableMetrics[s] = [];
        let availableMetrics = $15afa6c724e20c66$var$getAvailableMetric(seperateData[s], windMetrics, otherMetrics);
        separateAvailableMetrics[s].push(availableMetrics);
    }
    return separateAvailableMetrics;
}
function $15afa6c724e20c66$var$getAvailableMetric(rawData, windMetrics, otherMetrics) {
    let availableMetrics = Object.keys(rawData[0]), availWindMetrics = [], availOtherMetrics = [], m;
    for (m of availableMetrics){
        if (windMetrics.indexOf(m) !== -1 && Object.values(rawData[0][m])[0]) availWindMetrics.push(m);
        else if (otherMetrics.indexOf(m) !== -1 && Object.values(rawData[0][m])[0]) availOtherMetrics.push(m);
    }
    return [
        availWindMetrics,
        availOtherMetrics,
        m
    ];
}
/* ------ generate seperate dataset for 8 days view ------ */ function $15afa6c724e20c66$var$generateSeperateChartData(rawData) {
    let today = (0, $0866737b96521d45$export$2e2bcd8739ae039)();
    let todayFormated = today.format("ddd DD/MM");
    let lastDate = today.subtract(7, "day");
    let lastDateTS = lastDate.format("x");
    let radioCollectionData = {};
    for(let i = 0; i < rawData.length; i++)if (rawData[i]["ts"] * 1000 > lastDateTS) {
        let formatedDate = (0, $0866737b96521d45$export$2e2bcd8739ae039).unix(rawData[i]["ts"]).format("ddd DD/MM");
        if (formatedDate !== todayFormated) {
            if (!radioCollectionData[formatedDate]) radioCollectionData[formatedDate] = [];
            radioCollectionData[formatedDate].push(rawData[i]);
        }
    }
    return radioCollectionData;
}
/* ------ Generate chart  ------*/ function $15afa6c724e20c66$var$initChart(radioCollectionList, seperateData, separateAvailableMetrics, isSwell, otherMetrics) {
    console.debug("initChart");
    for(let i = 0; i < radioCollectionList.length; i++)if (radioCollectionList[i].checked) {
        let availWindMetrics = separateAvailableMetrics[radioCollectionList[i].value][0][0];
        let availOtherMetrics = separateAvailableMetrics[radioCollectionList[i].value][0][1];
        let m = separateAvailableMetrics[radioCollectionList[i].value][0][2];
        if (availWindMetrics.length) {
            document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_wind"></canvas></div>');
            let ctx = document.getElementById("sensor_chart_wind").getContext("2d");
            new (0, $jwWxh.Chart)(ctx, (0, $7b54f81a1705cc34$export$a00e671a9b023575)($15afa6c724e20c66$export$4e89807aca88641f(seperateData[radioCollectionList[i].value], 360), 144, availWindMetrics, isSwell));
        }
        if (availOtherMetrics.length) {
            let sortedOther = availOtherMetrics.sort(function(m) {
                return otherMetrics.indexOf(m);
            });
            for (m of availOtherMetrics){
                document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_' + m + '"></canvas></div>');
                let ctx = document.getElementById("sensor_chart_" + m).getContext("2d");
                new (0, $jwWxh.Chart)(ctx, (0, $7b54f81a1705cc34$export$a00e671a9b023575)(seperateData[radioCollectionList[i].value], 144, [
                    m
                ], isSwell));
            }
        }
    }
}
function $15afa6c724e20c66$var$generateSeperateChart(d, seperateData, separateAvailableMetrics, isSwell, otherMetrics) {
    let availWindMetrics = separateAvailableMetrics[0][0];
    let availOtherMetrics = separateAvailableMetrics[0][1];
    let m = separateAvailableMetrics[0][2];
    if (availWindMetrics.length) {
        document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_wind"></canvas></div>');
        let ctx = document.getElementById("sensor_chart_wind").getContext("2d");
        new (0, $jwWxh.Chart)(ctx, (0, $7b54f81a1705cc34$export$a00e671a9b023575)($15afa6c724e20c66$export$4e89807aca88641f(seperateData[d], 360), 144, availWindMetrics, isSwell));
    }
    if (availOtherMetrics.length) {
        let sortedOther = availOtherMetrics.sort(function(m) {
            return otherMetrics.indexOf(m);
        });
        for (m of availOtherMetrics){
            document.querySelector("#map_modal_content #charts_wrapper").insertAdjacentHTML("beforeend", '<div class="chart_container"><canvas id="sensor_chart_' + m + '"></canvas></div>');
            let ctx = document.getElementById("sensor_chart_" + m).getContext("2d");
            new (0, $jwWxh.Chart)(ctx, (0, $7b54f81a1705cc34$export$a00e671a9b023575)(seperateData[d], 144, [
                m
            ], isSwell));
        }
    }
}
/* ------ Generate radio collection  ------*/ function $15afa6c724e20c66$var$generateRadioCollection(data, separateAvailableMetrics, isSwell, otherMetrics) {
    let radioListContainer = $15afa6c724e20c66$var$generateRadioCollectionContainer();
    for(let d in data){
        let radioContainer = $15afa6c724e20c66$var$generateRadioContainer(radioListContainer, d);
        $15afa6c724e20c66$var$generateRadioInput(radioContainer, d, data, separateAvailableMetrics[d], isSwell, otherMetrics);
        $15afa6c724e20c66$var$generateRadioLabel(radioContainer, d);
    }
    $15afa6c724e20c66$var$reverseChildren(radioListContainer);
    let firstRadio = radioListContainer.firstChild;
    let firstRadioInput = firstRadio.querySelector("input");
    firstRadioInput.checked = true;
}
function $15afa6c724e20c66$var$generateRadioCollectionContainer() {
    let div = document.createElement("div");
    div.classList.add("radio-container");
    let container = document.querySelector("#charts_actions");
    return container.parentNode.insertBefore(div, container.nextSibling);
}
function $15afa6c724e20c66$var$generateRadioContainer(radioListContainer, d) {
    let radioContainer = document.createElement("div");
    radioContainer.classList.add("radio-container_item");
    radioContainer.id = "container-" + d;
    radioListContainer.append(radioContainer);
    return radioContainer;
}
function $15afa6c724e20c66$var$generateRadioInput(radioContainer, d, data, separateAvailableMetrics, isSwell, otherMetrics) {
    let radioInput = document.createElement("input");
    radioInput.id = "input-" + d.replace(/\s|\.|\//g, "");
    radioInput.type = "radio";
    radioInput.name = "date";
    radioInput.value = d;
    radioInput.onclick = function(event) {
        let lastCanvasList = document.querySelectorAll(".chart_container");
        for(let i = 0; i < lastCanvasList.length; i++)lastCanvasList[i].remove();
        $15afa6c724e20c66$var$generateSeperateChart(d, data, separateAvailableMetrics, isSwell, otherMetrics);
    };
    radioContainer.append(radioInput);
}
function $15afa6c724e20c66$var$generateRadioLabel(radioContainer, d) {
    let radioLabel = document.createElement("label");
    radioLabel.id = "label-" + d.replace(/\s|\.|\//g, "");
    radioLabel.setAttribute("for", "input-" + d.replace(/\s|\.|\//g, ""));
    radioLabel.innerHTML = d;
    radioContainer.append(radioLabel);
}
function $15afa6c724e20c66$var$reverseChildren(parent) {
    for(let i = 1; i < parent.childNodes.length; i++)parent.insertBefore(parent.childNodes[i], parent.firstChild);
}
function $15afa6c724e20c66$var$cleanUpDataset(data, sensorId) {
    let dataset = $15afa6c724e20c66$var$cleanUpWindSpeedDataset(data, sensorId);
    return $15afa6c724e20c66$var$cleanUpWindDirectionDataset(dataset);
}
function $15afa6c724e20c66$var$cleanUpWindDirectionDataset(data) {
    console.debug("cleanUpWindDirectionDataset");
    let validData = [];
    for(let i = 0; i < data.length; i++)if (data[i]["wd"].min && data[i]["wd"].moy && data[i]["wd"].max || !data[i]["wd"].min && data[i]["wd"].moy && !data[i]["wd"].max) validData.push(data[i]);
    return validData;
}
function $15afa6c724e20c66$export$4e89807aca88641f(data, range) {
    let i, prevValue, valueDiff, field = "wd";
    if (data.length && data[0][field]) for(i = 0; i < data.length; i++){
        valueDiff = prevValue ? data[i][field].moy - prevValue : 0;
        if (Math.abs(valueDiff) > range / 2) {
            if (valueDiff > 0) // saut vers le haut : on decale les points suivants de "range" vers le bas (en detectant d'autres sauts s'il y en a)
            return [
                ...data.slice(0, i),
                ...$15afa6c724e20c66$export$4e89807aca88641f($15afa6c724e20c66$var$translatedValues(field, data.slice(i), -range), range)
            ];
            else // saut vers le bas : on decale les points suivants de "range" vers le haut (en detectant d'autres sauts s'il y en a)
            return [
                ...data.slice(0, i),
                ...$15afa6c724e20c66$export$4e89807aca88641f($15afa6c724e20c66$var$translatedValues(field, data.slice(i), range), range)
            ];
        }
        prevValue = data[i][field].moy;
    }
    return data;
}
function $15afa6c724e20c66$var$translatedValues(field, values, offset) {
    let i, translatedValues = [
        ...values
    ];
    for(i = 0; i < values.length; i++)translatedValues[i][field] = {
        min: Math.round(values[i][field].min + offset),
        moy: Math.round(values[i][field].moy + offset),
        max: Math.round(values[i][field].max + offset)
    };
    return translatedValues;
}
function $15afa6c724e20c66$var$cleanUpWindSpeedDataset(data, sensorId) {
    console.debug("cleanUpWindSpeedDataset");
    const validData = [], windSpeed = "ws", limitWindSpeed = 200, knotFactor = 1.94384;
    let previousWindSpeed = null;
    for(let i = 0; i < data.length; i++){
        // +(6.688687).toPrecision(2)
        if ([
            "73091306",
            "73091305"
        ].indexOf(sensorId.toString()) !== -1) {
            data[i][windSpeed].min = +(data[i][windSpeed].min * knotFactor).toFixed(1);
            data[i][windSpeed].moy = +(data[i][windSpeed].moy * knotFactor).toFixed(1);
            data[i][windSpeed].max = +(data[i][windSpeed].max * knotFactor).toFixed(1);
        }
        if (data[i][windSpeed].max.length === 0) validData.push(data[i]);
        if (previousWindSpeed == null) previousWindSpeed = data[i][windSpeed].max;
        if (data[i][windSpeed].max < 2 * previousWindSpeed && data[i][windSpeed].max < limitWindSpeed) {
            previousWindSpeed = data[i][windSpeed].max;
            validData.push(data[i]);
        } else previousWindSpeed = data[i][windSpeed].max;
    }
    return validData;
}
function $15afa6c724e20c66$var$renderLinks(sensor, section) {
    let linksMarkup = "", sectionLinks = (sensor.image_links_list || []).filter((l)=>l.section === section);
    if (sectionLinks.length) linksMarkup += $15afa6c724e20c66$var$renderSectionLinks("partners_links", sectionLinks);
    else if ((0, $am1Dn.asides)[sensor.nid]) {
        for (let a of (0, $am1Dn.asides)[sensor.nid])if (a.links) linksMarkup += '<div class="partners_links">' + a.links.map(function(l) {
            return '<a href="' + l.href + '" target="_blank"><img src="' + l.img + '" alt=""/></a>';
        }).join("") + "</div>";
    }
    return linksMarkup + '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
}
function $15afa6c724e20c66$var$renderSectionLinks(wrapperClass, sectionLinks) {
    return `<div class="${wrapperClass}">${sectionLinks.map((l)=>'<a href="' + l.link_url + '" target="_blank"><img src="' + l.image_url + '" alt=""/></a>').join("")}</div>`;
}
function $15afa6c724e20c66$var$renderAside(sensor) {
    let asideContent = "";
    if (sensor.description_content) asideContent += sensor.description_content;
    if (sensor.photos_list?.length) asideContent += `<div id="aside_slides">${sensor.photos_list.map((p)=>'<div><img src="' + p + '" alt=""/></div>').join("")}</div>`;
    const footerLinks = (sensor.image_links_list || []).filter((l)=>l.section === "footer");
    if (footerLinks.length) asideContent += $15afa6c724e20c66$var$renderSectionLinks("footer_links", footerLinks);
    if (sensor.validAngle && sensor.validAngle.filter((deg)=>deg > 0).length) {
        const [a1, a2, a3] = sensor.validAngle;
        let deventPie, pieSegments = [];
        if (a2) {
            if (a3) {
                for (const segment of [
                    [
                        a1,
                        a2,
                        "green"
                    ],
                    [
                        a2,
                        a3,
                        "orange"
                    ],
                    [
                        a3,
                        a1,
                        "red"
                    ]
                ])pieSegments.push(...$15afa6c724e20c66$var$pieSegment(segment[0], segment[1], segment[2]));
                pieSegments = pieSegments.sort((s1, s2)=>s1.from - s2.from).map((s)=>`${s.color} ${s.from}deg ${s.to}deg`).join(", ");
                deventPie = `<div class="devent_pie" style="border-radius: 100%; width: 180px; aspect-ratio: 1; background: conic-gradient(${pieSegments});"></div>`;
            } else {
                for (const segment of [
                    [
                        a1,
                        a2,
                        "green"
                    ],
                    [
                        a2,
                        a1,
                        "orange"
                    ]
                ])pieSegments.push(...$15afa6c724e20c66$var$pieSegment(segment[0], segment[1], segment[2]));
                pieSegments = pieSegments.sort((s1, s2)=>s1.from - s2.from).map((s)=>`${s.color} ${s.from}deg ${s.to}deg`).join(", ");
                deventPie = `<div class="devent_pie" style="border-radius: 100%; width: 180px; aspect-ratio: 1; background: conic-gradient(${pieSegments});"></div>`;
            }
        } else {
            for (const segment of [
                [
                    a1,
                    a3,
                    "green"
                ],
                [
                    a3,
                    a1,
                    "red"
                ]
            ])pieSegments.push(...$15afa6c724e20c66$var$pieSegment(segment[0], segment[1], segment[2]));
            pieSegments = pieSegments.sort((s1, s2)=>s1.from - s2.from).map((s)=>`${s.color} ${s.from}deg ${s.to}deg`).join(", ");
            deventPie = `<div class="devent_pie" style="border-radius: 100%; width: 180px; aspect-ratio: 1; background: conic-gradient(${pieSegments});"></div>`;
        }
        asideContent += '<section class="sensor_devent"><h2>Secteurs d\'utilisation</h2>' + deventPie + "<ul>" + "<li><strong>Vert</strong> : pas de d\xe9vent</li>" + "<li><strong>Orange</strong> : l\xe9ger d\xe9vent</li>" + "<li><strong>Rouge</strong> : fort d\xe9vent</li>" + "</ul>" + "<p><em>Le vent en hauteur est sup\xe9rieur au vent en surface. Ce diff\xe9rentiel est d\u2019autant plus important que le vent est faible et que la masse d\u2019air est stable.</em></p>" + "</section>";
    }
    return asideContent;
}
function $15afa6c724e20c66$var$pieSegment(fromAngle, toAngle, color) {
    if (fromAngle <= toAngle) return [
        {
            from: fromAngle,
            to: toAngle,
            color: color
        }
    ];
    else return [
        {
            from: fromAngle,
            to: 0,
            color: color
        },
        {
            from: 0,
            to: toAngle,
            color: color
        }
    ];
}
function $15afa6c724e20c66$var$initAsideSlides() {
    var slidesElt = document.querySelector("#aside_slides");
    if (slidesElt) (0, $etzOt.tns)({
        container: "#aside_slides",
        autoplay: true,
        controls: false,
        mode: "gallery"
    });
}



var $am1Dn = parcelRequire("am1Dn");

var $iRjZV = parcelRequire("iRjZV");



var $diMLx = parcelRequire("diMLx");


const $26ce3c45196098b3$var$router = new (0, (/*@__PURE__*/$parcel$interopDefault($ad9411963a5d44fa$exports)))("/");
let $26ce3c45196098b3$var$autoRefresh;
// console.time('routerConfig');
$26ce3c45196098b3$var$router.on("/", function(match) {
    // console.timeEnd('partialInit');
    $26ce3c45196098b3$var$displayDefaultData();
    (0, $diMLx.logPageView)($26ce3c45196098b3$var$router.lastResolved(), "/", "Accueil");
    $26ce3c45196098b3$var$setAutoRefresh();
});
$26ce3c45196098b3$var$router.on("/webcam/:name", function(match) {
    $26ce3c45196098b3$var$displayDefaultData(function() {
        (0, $iRjZV.getAsync)((0, $am1Dn.config).backEndUrl + "/webcams/list.json", function(data) {
            var webcam = data.webcams.find((element)=>element.slug === match.data.name);
            if (webcam) {
                (0, $4a909a324b05f370$export$3d0a3aba327d4829)(webcam);
                (0, $diMLx.logPageView)($26ce3c45196098b3$var$router.lastResolved(), "/webcam/" + webcam.slug, webcam.label);
            }
        });
    });
});
$26ce3c45196098b3$var$router.on("/port/:name", function(match) {
    $26ce3c45196098b3$var$displayDefaultData(function() {
        (0, $iRjZV.getAsync)((0, $am1Dn.config).backEndUrl + "/harbors/list.json", function(data) {
            var harbor = data.harbors.find((element)=>element.slug === match.data.name);
            if (harbor) {
                (0, $4a909a324b05f370$export$a56d4708c86e0d68)(harbor);
                (0, $diMLx.logPageView)($26ce3c45196098b3$var$router.lastResolved(), "/port/" + harbor.slug, harbor.label);
            }
        });
    });
});
$26ce3c45196098b3$var$router.on("/previsions/:name", function(match) {
    $26ce3c45196098b3$var$displayDefaultData(function() {
        (0, $iRjZV.getAsync)((0, $am1Dn.config).backEndUrl + "/live_forecasts/weather.json", function(poisData) {
            const poi = poisData["pois"].find((element)=>element.slug === match.data.name);
            if (poi) {
                (0, $828c72eac0f0470f$export$564dd0f7905e57b7)(poi);
                const menuBtn = document.querySelector("#weather_fc");
                if (menuBtn.classList.contains("active") && (0, $diMLx.layers).dataLayers.indexOf("weather_fc") !== -1) (0, $828c72eac0f0470f$export$c5f0806055af3943)(poi.slug);
                (0, $diMLx.map).instance.setView(new L.LatLng(parseFloat(poi.lat) - 0.1, parseFloat(poi.lng)), 9.5);
                (0, $diMLx.logPageView)($26ce3c45196098b3$var$router.lastResolved(), "/previsions/" + poi.slug, poi.label);
                $26ce3c45196098b3$var$setAutoRefresh();
            }
        });
    });
});
$26ce3c45196098b3$var$router.on("/:name", function(match) {
    $26ce3c45196098b3$var$displayDefaultData(function() {
        (0, $am1Dn.loadSensors)(function(data) {
            let sensors = Object.values(data.sensors["WindSensor"] || {}).concat(Object.values(data.sensors["WaveSensor"] || {})).concat(data.sensors["TempSensor"] || []);
            let sensor = sensors.find((s)=>s.slug === match.data.name);
            if (sensor) {
                (0, $15afa6c724e20c66$export$aadaa5940712eda)(sensor);
                (0, $diMLx.logPageView)($26ce3c45196098b3$var$router.lastResolved(), "/" + sensor.slug, sensor.label);
                $26ce3c45196098b3$var$setAutoRefresh();
            }
        });
    });
});
if ((0, $am1Dn.config).favoritePath && window.location.pathname === "/") {
    if (document.querySelector("#map_favorite button").classList.contains("no-favorite")) document.querySelector("#map_favorite button").classList.remove("no-favorite");
    $26ce3c45196098b3$var$router.navigate((0, $am1Dn.config).favoritePath);
} else {
    if (!document.querySelector("#map_favorite button").classList.contains("no-favorite")) document.querySelector("#map_favorite button").classList.add("no-favorite");
    $26ce3c45196098b3$var$router.resolve();
}
if (!(0, $am1Dn.config).newsDisplay && window.location.search.indexOf("nosplash") === -1) (0, $diMLx.displayNews)(1000);
function $26ce3c45196098b3$var$displayDefaultData(callback) {
    // console.time('displayDefaultData');
    let isHome = $26ce3c45196098b3$var$router.lastResolved() === null || $26ce3c45196098b3$var$router.lastResolved().path === "";
    if (isHome) {
        (0, $diMLx.updateLayout)();
        const referenceDate = new Date(new Date().toDateString()).getTime() / 1000;
        (0, $c022c3a831c783e1$export$b08464e47b7a3a8)().then(function() {
            // console.time('postInitMap');
            (0, $am1Dn.loadSensors)(function() {
                // console.time('initMeasuresLayer');
                (0, $4a909a324b05f370$export$c3627125dd65970c)();
                // console.timeEnd('initMeasuresLayer');
                // console.time('displayMeasures');
                (0, $4a909a324b05f370$export$2eeb97286c6ecc12)();
                // console.time('displayWaves');
                (0, $4a909a324b05f370$export$73503ae067c61ef7)();
                // console.time('displayWaterTemp');
                (0, $4a909a324b05f370$export$e7ff43a15e05d735)();
                // console.time('callback');
                if (callback) callback();
            // console.timeEnd('callback');
            // console.timeEnd('postInitMap');
            // console.timeEnd('displayDefaultData');
            });
        });
        (0, $ac969ff4dde4b936$export$59153413680588f8)(referenceDate);
        (0, $4a909a324b05f370$export$f45e13584efe3e9)();
    } else {
        (0, $4a909a324b05f370$export$2eeb97286c6ecc12)();
        (0, $4a909a324b05f370$export$73503ae067c61ef7)();
        (0, $4a909a324b05f370$export$e7ff43a15e05d735)();
        if (callback) callback();
    }
}
function $26ce3c45196098b3$var$setAutoRefresh() {
    if ($26ce3c45196098b3$var$autoRefresh) clearTimeout($26ce3c45196098b3$var$autoRefresh);
    $26ce3c45196098b3$var$autoRefresh = setTimeout(function() {
        window.location.reload();
    }, 900000);
}
var // console.timeEnd('routerConfig');
$26ce3c45196098b3$export$2e2bcd8739ae039 = $26ce3c45196098b3$var$router;



const $828c72eac0f0470f$export$77b77ede33ca4f0d = '  <div class="heading_table">      <div class="table_header_1 details_btn"><span class="short_label">N\xe9b.</span><span>N\xe9bulosit\xe9</span><span><button onclick="wm.toggleLines(this, \'neb_haute\', \'neb_moyenne\', \'neb_basse\');" class="button"></button></span></div>      <div class="neb_haute table_header_1" style="display:none;"><span class="short_label">Haute</span><span>N\xe9bulosit\xe9 haute</span> <span>%</span></div>      <div class="table_header_1 neb_moyenne" style="display:none;"><span class="short_label">Moy.</span><span>N\xe9bulosit\xe9 moyenne</span> <span>%</span></div>      <div class="table_header_1 neb_basse" style="display:none;"><span class="short_label">Basse</span><span>N\xe9bulosit\xe9 basse</span> <span>%</span></div>      <div class="table_header_1"><span class="short_label">Temp.</span><span>Temp\xe9rature</span> <span>\xb0C</span></div>      <div class="table_header_1 details_btn"><span class="short_label">Pr\xe9c.</span><span>Pr\xe9cipitation</span> <span>mm/h</span> <span><button onclick="wm.toggleLines(this, \'humidity_values\', \'pression_values\');" class="button"></button></span></div>      <div class="table_header_1 pression_values " style="display:none;"><span class="short_label">P</span><span>Pression</span> <span>(hPa)</span></div>      <div class="table_header_1 humidity_values" style="display:none;"><span class="short_label">Hum.</span><span>Humidit\xe9</span></div>      <div class="table_header_1 th-border-top"><span class="short_label">Vit.</span><span>Vitesse</span> <span>nds</span></div>      <div class="table_header_1"><span class="short_label">Raf.</span><span>Rafales</span> <span>nds</span></div>      <div class="table_header_1 zindex_high details_btn"><span class="short_label">Dir.</span><span>Direction</span><span><button onclick="wm.toggleLines(this, \'wind_direction_values\');" class="button"></button></span></div>      <div class="table_header_1 wind_direction_values" style="display:none;"><span class="short_label">Dir.</span><span>Direction</span> <span>\xb0</span></div>      <div class="table_header_1 th-border-top" ><span class="short_label">Mer tot.</span><span>Mer totale - hauteur</span> <span>m</span></div>      <div class="table_header_1 zindex_high" ><span class="short_label">Dir.</span><span>Direction</span></div>      <div class="table_header_1 details_btn" ><span class="short_label">P\xe9riode</span><span>P\xe9riode (s)</span>  <span><button onclick="wm.toggleLines(this, \'primary_swell_direction\',\'primary_swell_height\',\'primary_swell_period\', \'secondary_swell_values\', \'secondary_swell_height\',\'secondary_swell_period\');" class="button"></button></span></div>      <div class="table_header_1 zindex_high primary_swell_direction" style="display:none;"><span class="short_label">HP dir.</span><span>Houle primaire - direction</span></div>      <div class="table_header_1 primary_swell_height" style="display:none;"><span class="short_label">H (m)</span><span>Hauteur (m)</span></div>      <div class="table_header_1 primary_swell_period" style="display:none;"><span class="short_label">P (s)</span><span>P\xe9riode (s)</span></div>      <div class="table_header_1 zindex_high secondary_swell_values" style="display:none;"><span class="short_label">HS dir.</span><span>Houle secondaire - direction</span></div>      <div class="table_header_1 secondary_swell_height" style="display:none;"><span class="short_label">H (m)</span><span>Hauteur (m)</span></div>      <div class="table_header_1 secondary_swell_period" style="display:none;"><span class="short_label"> P (s)</span><span>P\xe9riode (s)</span></div>  </div>';
const $828c72eac0f0470f$export$cf29ab69f4b683c7 = '    <div class="content_table">      <div class="details_source"></div>      <div class="details_hours"></div>      <div class="details_neb"></div>      <div class="neb_haute details_nebh" style="display:none;"></div>      <div class="neb_moyenne details_nebm" style="display:none;"></div>      <div class="neb_basse details_nebl" style="display:none;"></div>      <div class="details_temp"></div>      <div class="details_rain"></div>      <div style="display:none;" class="pression_values details_pres"></div>      <div style="display:none;" class="humidity_values details_rh"></div>      <div class="details_ws"></div>      <div class="details_wg"></div>      <div class="details_wd"></div>      <div style="display:none;" class="wind_direction_values details_wd_deg"></div>      <div class="details_hs"></div>      <div class="details_ds"></div>      <div class="details_ps"></div>      <div class="details_dsp primary_swell_direction" style="display:none;"></div>      <div style="display:none;" class="primary_swell_height details_hsp"></div>      <div style="display:none;" class="primary_swell_period details_psp"></div>      <div style="display:none;" class="secondary_swell_values details_dss"></div>      <div style="display:none;" class="secondary_swell_height details_hss"></div>      <div style="display:none;" class="secondary_swell_period details_pss"></div>    </div>';
function $828c72eac0f0470f$export$564dd0f7905e57b7(dt) {
    const now = new Date().getTime() / 1000, prevHour = now - now % 3600;
    (0, $iRjZV.getAsync)(`${(0, $am1Dn.config).backEndUrl}/live_forecasts/details.json?poi=${dt.id}&timestamp=${prevHour - 86400}`, function(details) {
        document.querySelector("#timeline").classList.add("weather_details");
        document.querySelector("#weather_details_header").innerHTML = $828c72eac0f0470f$export$77b77ede33ca4f0d;
        document.querySelector("#weather_title").innerHTML = "<h2>" + dt.name + "</h2>";
        document.querySelector("#weather_details").innerHTML = $828c72eac0f0470f$export$cf29ab69f4b683c7;
        document.querySelector("#weather_buttons").innerHTML = '<button id="modal_favorite" data-slug="' + dt.slug + '" data-lat="' + dt.lat + '" data-lng="' + dt.lng + '" type="button" onclick="wm.setFavorite(this);"><i class="fas fa-star"></i><span>D\xe9finir comme favori</span></button>' + '<button aria-label="Fermer" onclick="wm.closePoi()"><i class="fas fa-times"></i></button>';
        document.body.classList.add("active_poi");
        let allHours = details.timestamps.reduce(function(currentHours, newHours) {
            return currentHours.concat(newHours[1]);
        }, []);
        // d3.select("#weather_details .details_header").selectAll(".table_day").data(details.timestamps).join("div")
        //   .attr("class", "table_day").attr("data-number", function(d) { return  d[1].length }).attr("style", function(d) { return "width: " + (d[1].length * 30) + "px;"; }).text(function(d) { return d[0]; });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_hours").selectAll(".table_hour").data(allHours).join("div").attr("class", "table_hour").attr("data-hour", function(d) {
            return d;
        }).text(function(d) {
            return d;
        }).attr("data-source", function(d) {
            return d.source ? d.source.substring(0, 3).toLowerCase() : "";
        }).text(function(d) {
            return d.source ? d.source.substring(0, 3).toUpperCase() : "";
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_neb").selectAll(".table_neb_icon").data(details.data.tcc).join("div").attr("class", "table_neb_icon").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_neb").selectAll(".table_neb_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_nebh").selectAll(".table_neb_color").data(details.data.hcc).join("div").attr("class", "table_neb_color").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_nebh").selectAll(".table_neb_color").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_nebm").selectAll(".table_neb_color").data(details.data.mcc).join("div").attr("class", "table_neb_color").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_nebm").selectAll(".table_neb_color").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_nebl").selectAll(".table_neb_color").data(details.data.lcc).join("div").attr("class", "table_neb_color").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_nebl").selectAll(".table_neb_color").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_temp").selectAll(".table_temp").data(details.data.temp).join("div").attr("class", "table_temp").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_temp").selectAll(".table_temp").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_rain").selectAll(".table_rain_color").data(details.data.rain).join("div").attr("class", "table_rain_color").text(function(d, i) {
            return i === 0 || details.data.rain[i - 1] === d || d === 0 ? "" : details.data.rain[i - 1] >= d ? d : Math.round(d * 10 - details.data.rain[i - 1] * 10) / 10;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_rain").selectAll(".table_rain_color").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_ws").selectAll(".table_wind").data(details.data.wind_s).join("div").attr("class", "table_wind").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_ws").selectAll(".table_wind").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_wg").selectAll(".table_wind").data(details.data.gust_s).join("div").attr("class", "table_wind").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_wg").selectAll(".table_wind").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_wd").selectAll(".table_wind_icon").data(details.data.wind_d).join("div").attr("class", "table_wind_icon").append("img").attr("class", "wind_dir_arrow img-small").attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($1744ee85d0ea69cd$exports)))["fleche-vent"]).attr("style", function(d) {
            return "transform: rotate(" + (90 - d) + "deg); transform-origin: 50% 50% 0px; display: inline;";
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_wd").selectAll(".table_wind_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_wd_deg").selectAll(".table_wind_deg").data(details.data.wind_d).join("div").attr("class", "table_wind_deg").text(function(d) {
            return (270 - d) % 360;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_wd_deg").selectAll(".table_wind_deg").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_hs").selectAll(".table_wave_height").data(details.data.wave_h).join("div").attr("class", "table_wave_height").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_hs").selectAll(".table_wave_height").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_ds").selectAll(".table_wind_icon").data(details.data.wave_d).join("div").attr("class", "table_wind_icon").append("img").attr("class", function(d) {
            return d ? "img-small" : "hidden";
        }).attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($1744ee85d0ea69cd$exports)))["fleche-vague"]).attr("style", function(d) {
            return "transform: rotate(" + (d - 180) + "deg); transform-origin: 50% 50% 0px; display: inline;";
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_ds").selectAll(".table_wind_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_ps").selectAll(".table_wind_period").data(details.data.ptp).join("div").attr("class", "table_wind_period").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_ps").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_dsp").selectAll(".table_wind_icon").data(details.data.pdir1).join("div").attr("class", "table_wind_icon").append("img").attr("class", function(d) {
            return d ? "img-small" : "hidden";
        }).attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($1744ee85d0ea69cd$exports)))["fleche-vague"]).attr("style", function(d) {
            return "transform: rotate(" + (d - 180) + "deg); transform-origin: 50% 50% 0px; display: inline;";
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_dsp").selectAll(".table_wind_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_hsp").selectAll(".table_wind_period").data(details.data.phs1).join("div").attr("class", "table_wind_period txt_smaller").html(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_hsp").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_psp").selectAll(".table_wind_period").data(details.data.ptp1).join("div").attr("class", "table_wind_period").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_psp").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_dss").selectAll(".table_wind_icon").data(details.data.pdir0).join("div").attr("class", "table_wind_icon").append("img").attr("class", function(d) {
            return d ? "img-small" : "hidden";
        }).attr("src", (0, (/*@__PURE__*/$parcel$interopDefault($1744ee85d0ea69cd$exports)))["fleche-vague"]).attr("style", function(d) {
            return "transform: rotate(" + (d - 180) + "deg); transform-origin: 50% 50% 0px; display: inline;";
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_dss").selectAll(".table_wind_icon").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_hss").selectAll(".table_wind_period").data(details.data.phs0).join("div").attr("class", "table_wind_period txt_smaller").html(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_hss").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_pss").selectAll(".table_wind_period").data(details.data.ptp0).join("div").attr("class", "table_wind_period").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_pss").selectAll(".table_wind_period").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_pres").selectAll(".table_wind_pression").data(details.data.pr).join("div").attr("class", "table_wind_pression").text(function(d) {
            return d ? d / 100.0 : "";
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_pres").selectAll(".table_wind_pression").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_rh").selectAll(".table_rh").data(details.data.rh).join("div").attr("class", "table_rh txt_smaller").text(function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_rh").selectAll(".table_rh").data(allHours).join("div").attr("data-hour", function(d) {
            return d;
        });
        $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#weather_details .details_source").selectAll(".table_source").data(details.source).join("div").attr("class", "table_source").attr("data-source", function(d) {
            return d.source ? d.source.substring(0, 3).toLowerCase() : "";
        });
        // d3.select("#weather_details .details_source").selectAll(".table_source").data(allHours)
        //   .join("div").attr("data-hour", function(d) { return d; });
        $828c72eac0f0470f$var$setWindColor();
        $828c72eac0f0470f$var$setTempColor();
        $828c72eac0f0470f$var$setNebColor();
        $828c72eac0f0470f$var$setNebIcon();
        $828c72eac0f0470f$var$setRainIcon();
        $828c72eac0f0470f$var$setWaveColor();
        $828c72eac0f0470f$var$setWavePeriodColor();
        $828c72eac0f0470f$var$setRainColor();
        $828c72eac0f0470f$var$setPressionColor();
        $828c72eac0f0470f$var$setNightColor();
        $828c72eac0f0470f$var$initFavorite(dt.slug);
        (0, $ac969ff4dde4b936$export$9cc3739d965cbe89)(true, true);
    });
}
function $828c72eac0f0470f$var$setWindColor() {
    var i, windSpeed, color, windCells = document.getElementsByClassName("table_wind");
    for(i = 0; i < windCells.length; i++){
        windSpeed = parseFloat(windCells[i].innerText || windCells[i].textContent);
        color = (0, $am1Dn.windColor)(windSpeed);
        windCells[i].style.color = color.text;
        windCells[i].style.backgroundColor = color.bg;
    }
}
function $828c72eac0f0470f$var$setTempColor() {
    var i, temp, tempCells = document.getElementsByClassName("table_temp");
    for(i = 0; i < tempCells.length; i++){
        temp = parseFloat(tempCells[i].innerText || tempCells[i].textContent);
        tempCells[i].style.color = (0, $am1Dn.tempColor)(temp);
    }
}
function $828c72eac0f0470f$var$setWaveColor() {
    var i, waveHeight, waveCells = document.getElementsByClassName("table_wave_height");
    for(i = 0; i < waveCells.length; i++){
        waveHeight = parseFloat(waveCells[i].innerText || waveCells[i].textContent);
        waveCells[i].style.backgroundColor = (0, $am1Dn.waveColor)(waveHeight);
    }
}
function $828c72eac0f0470f$var$setNebColor() {
    var i, neb, nebCells = document.getElementsByClassName("table_neb_color");
    for(i = 0; i < nebCells.length; i++){
        neb = parseFloat(nebCells[i].innerText || nebCells[i].textContent);
        if (neb < 13) nebCells[i].style.backgroundColor = "#ffffff";
        else if (neb > 14 && neb < 38) nebCells[i].style.backgroundColor = "#D9D9D9";
        else if (neb > 37 && neb < 63) {
            nebCells[i].style.backgroundColor = "#BEBEBE";
            nebCells[i].style.color = "#FFFFFF";
        } else if (neb > 62 && neb < 88) {
            nebCells[i].style.backgroundColor = "#A6A5A6";
            nebCells[i].style.color = "#FFFFFF";
        } else if (neb > 87 && neb < 101) {
            nebCells[i].style.backgroundColor = "#808181";
            nebCells[i].style.color = "#FFFFFF";
        } else nebCells[i].style.backgroundColor = "#FFFFFF";
    }
}
function $828c72eac0f0470f$var$setRainColor() {
    var i, rainHeight, rainCells = document.getElementsByClassName("table_rain_color");
    for(i = 0; i < rainCells.length; i++){
        rainHeight = parseFloat(rainCells[i].innerText || rainCells[i].textContent);
        rainCells[i].style.backgroundColor = (0, $am1Dn.rainColor)(rainHeight);
    }
}
function $828c72eac0f0470f$var$setWavePeriodColor() {
    var i, period, periodCells = document.querySelectorAll(".details_ps .table_wind_period");
    for(i = 0; i < periodCells.length; i++){
        period = parseFloat(periodCells[i].innerText || periodCells[i].textContent);
        periodCells[i].style.backgroundColor = (0, $am1Dn.periodColor)(period);
    }
}
function $828c72eac0f0470f$var$setNebIcon() {
    let i, nebH, nebM, nebL, rain, hour, icon;
    let nebCells = document.querySelectorAll("#weather_details .table_neb_icon"), nebHCells = document.querySelectorAll("#weather_details .details_nebh .table_neb_color"), nebMCells = document.querySelectorAll("#weather_details .details_nebm .table_neb_color"), nebLCells = document.querySelectorAll("#weather_details .details_nebl .table_neb_color"), rainCells = document.querySelectorAll("#weather_details .table_rain_color"), hourCells = document.querySelectorAll("#weather_details .table_hour");
    for(i = 0; i < nebCells.length; i++){
        nebH = nebHCells[i] ? parseFloat(nebHCells[i].innerText || nebHCells[i].textContent) : 0;
        nebM = nebMCells[i] ? parseFloat(nebMCells[i].innerText || nebMCells[i].textContent) : 0;
        nebL = nebLCells[i] ? parseFloat(nebLCells[i].innerText || nebLCells[i].textContent) : 0;
        rain = rainCells[i] ? parseFloat(rainCells[i].innerText || rainCells[i].textContent) : 0;
        hour = hourCells[i] ? parseFloat(hourCells[i].getAttribute("data-hour").replace("h", "")) : 0;
        icon = $828c72eac0f0470f$export$a815945e7f6f673b(nebH, nebM, nebL, hour, rain);
        // console.log('computeNebIcon - neb : ' +  nebH+ ' - hour : ' + hour + ' - rain : ' + rain + ' -> icon : ' + icon);
        nebCells[i].innerHTML = icon ? '<img class="img-icon" src="' + (0, (/*@__PURE__*/$parcel$interopDefault($f1b279363cb8b9b4$exports)))[icon] + '" alt="' + icon + '">' : "";
    }
}
function $828c72eac0f0470f$export$a815945e7f6f673b(nebH, nebM, nebL, hour, rain) {
    // console.log('computeNebIcon: ' + JSON.stringify({nebH, nebM, nebL, hour, rain}));
    let icon = "", sunOrMoon = hour < 21 && hour > 6 ? "soleil" : "lune";
    /* nebM et nebL ce qui prévaut c'est le plus couvert*/ if (nebM <= nebL) {
        /* Ciel dégagé ou voilé */ if (nebM <= 19 && nebL <= 19) {
            if (nebH <= 80) /* ciel clair */ icon = $828c72eac0f0470f$var$applyRain(sunOrMoon, rain);
            else /* ciel voilé */ icon = $828c72eac0f0470f$var$applyRain(sunOrMoon + "-voile", rain);
        } else if (nebL >= 20 && nebL <= 49) icon = $828c72eac0f0470f$var$applyRain(sunOrMoon + "-nuage-1", rain);
        else if (nebL >= 50 && nebL <= 79) icon = $828c72eac0f0470f$var$applyRain(sunOrMoon + "-nuage-2", rain);
        else if (nebL >= 80) icon = $828c72eac0f0470f$var$applyRain("nuage-3", rain);
    } else if (nebM > nebL) {
        /* Ciel dégagé ou voilé */ if (nebM <= 19 && nebL <= 19) {
            if (nebH <= 80) /* ciel clair */ icon = $828c72eac0f0470f$var$applyRain(sunOrMoon, rain);
            else /* ciel voilé */ icon = $828c72eac0f0470f$var$applyRain(sunOrMoon + "-voile", rain);
        } else if (nebM >= 20 && nebM <= 49) icon = $828c72eac0f0470f$var$applyRain(sunOrMoon + "-nuage-1", rain);
        else if (nebM >= 50 && nebM <= 79) icon = $828c72eac0f0470f$var$applyRain(sunOrMoon + "-nuage-2", rain);
        else if (nebM >= 80) icon = $828c72eac0f0470f$var$applyRain("nuage-3", rain);
    }
    return icon;
}
function $828c72eac0f0470f$var$applyRain(prefix, rain) {
    let icon;
    if (rain === 0) icon = prefix;
    else if (rain <= 2.5) icon = prefix + "-pluie-1";
    else if (rain > 2.5 && rain <= 7.6) icon = prefix + "-pluie-2";
    else if (rain > 7.6) icon = prefix + "-pluie-3";
    else icon = prefix;
    return icon;
}
function $828c72eac0f0470f$var$setRainIcon() {
    var i, x, icon, y = document.getElementsByClassName("table_rain_icon");
    for(i = 0; i < y.length; i++){
        x = parseFloat(y[i].innerText || y[i].textContent);
        if (x <= 2.5) icon = "nuage-pluie-1";
        else if (x > 2.5 && x < 7.7) icon = "nuage-pluie-2";
        else if (x >= 7.7) icon = "nuage-pluie-3";
        else icon = "";
        y[i].innerHTML = icon ? '<img class="img-icon" src="img/weather/' + icon + '.svg" alt="' + icon + '">' : "";
    }
}
function $828c72eac0f0470f$var$setPressionColor() {
    var i, txt, x, y = document.getElementsByClassName("table_wind_pression");
    for(i = 0; i < y.length; i++){
        txt = y[i].innerText || y[i].textContent;
        if (txt) {
            x = parseFloat(y[i].innerText || y[i].textContent);
            if (x < 1000) {
                y[i].style.fontWeight = "900";
                y[i].innerHTML = Math.trunc(x);
            } else if (x >= 1000 && x < 1020) {
                y[i].style.fontWeight = "500";
                y[i].innerHTML = Math.trunc(x);
            } else if (x >= 1020) {
                y[i].style.fontWeight = "900";
                y[i].innerHTML = Math.trunc(x);
            } else {
                y[i].style.fontWeight = "500";
                y[i].innerHTML = Math.trunc(x);
            }
        }
    }
}
function $828c72eac0f0470f$var$setNightColor() {
    var i, x, y = document.getElementsByClassName("table_hours");
    for(i = 0; i < y.length; i++){
        x = parseFloat(y[i].innerText || y[i].textContent);
        if (x > 6 && x < 21) y[i].style.backgroundColor = "rgb(255,255,255)";
        else y[i].style.backgroundColor = "rgb(229,229,229)";
    }
}
function $828c72eac0f0470f$var$initFavorite(slug) {
    let button = document.querySelector("#modal_favorite");
    let text = button.querySelector("span");
    let navBtn = document.querySelector("#map_favorite button");
    if ((0, $am1Dn.config).favoritePath === "/previsions/" + slug) {
        button.classList.add("is_favorite");
        text.innerHTML = "Supprimer le favori";
        if (navBtn.classList.contains("no-favorite")) navBtn.classList.remove("no-favorite");
    } else {
        button.classList.remove("is_favorite");
        text.innerHTML = "D\xe9finir comme favori";
    }
}
function $828c72eac0f0470f$export$1ed640048cefe91a(element) {
    var slug = element.getAttribute("data-slug");
    var button = document.querySelector("#modal_favorite");
    var navBtn = document.querySelector("#map_favorite button");
    var text = button.querySelector("span");
    if ((0, $am1Dn.config).favoritePath === "/previsions/" + slug) {
        localStorage.removeItem("path");
        (0, $am1Dn.config).favoritePath = "";
        button.classList.remove("is_favorite");
        if (!navBtn.classList.contains("no-favorite")) navBtn.classList.add("no-favorite");
        text.innerHTML = "D\xe9finir comme favori";
    } else {
        button.classList.add("is_favorite");
        text.innerHTML = "Supprimer le favori";
        if (navBtn.classList.contains("no-favorite")) navBtn.classList.remove("no-favorite");
        localStorage.setItem("path", "/previsions/" + slug);
        (0, $am1Dn.config).favoritePath = "/previsions/" + slug;
    }
}
function $828c72eac0f0470f$export$b678dbcde018e0b2() {
    (0, $26ce3c45196098b3$export$2e2bcd8739ae039).navigate("/");
    document.querySelector("#timeline").classList.remove("weather_details");
    document.querySelector("#weather_title").innerHTML = "";
    document.body.classList.remove("active_poi");
    (0, $ac969ff4dde4b936$export$9cc3739d965cbe89)(true, false);
    $828c72eac0f0470f$export$535890a1dbf69608();
}
function $828c72eac0f0470f$export$c5f0806055af3943(slug) {
    $828c72eac0f0470f$export$535890a1dbf69608();
    let poi = document.querySelector("#poi_" + slug);
    poi.classList.add("poi-active");
}
function $828c72eac0f0470f$export$535890a1dbf69608() {
    let poiActive = document.querySelector(".poi-active");
    if (poiActive) poiActive.classList.remove("poi-active");
}







function $4a909a324b05f370$var$loadWindSensorsData() {
    (0, $iRjZV.getAsync)("https://private2.windmorbihan.com/mesures/getlastalljson.json", function(dt) {
        if (!(0, $diMLx.timeline).timelineActiveStep || (0, $diMLx.timeline).timelineActiveStep === (0, $ac969ff4dde4b936$export$83a9ef028b771fd4)()) $4a909a324b05f370$export$e72c2db76561db73(dt);
        if ((0, $diMLx.timeline).timelineSteps) (0, $ac969ff4dde4b936$export$2b262526dbd61afc)(dt);
    });
}
function $4a909a324b05f370$var$loadWaveSensorsData() {
    (0, $iRjZV.getAsync)("https://private2.windmorbihan.com/mesures/latest-waves.json", function(dt) {
        if (!(0, $diMLx.timeline).timelineActiveStep || (0, $diMLx.timeline).timelineActiveStep === (0, $ac969ff4dde4b936$export$83a9ef028b771fd4)()) $4a909a324b05f370$export$7c21e768f6379ae(dt);
    });
}
function $4a909a324b05f370$export$9b75862e7acdcaad(timestamp) {
    var emptyForecastData = false;
    if ((0, $diMLx.map).activeMap === "wm") (0, $c022c3a831c783e1$export$382d1aca2389ca8b)();
    return fetch((0, $am1Dn.config).backEndUrl + "/live_forecasts/raster.json?metric=speed" + (timestamp ? "&timestamp=" + timestamp : "")).then(function(resp) {
        return resp.json();
    }).then(function(rasterData) {
        if (rasterData.width) {
            $4a909a324b05f370$var$renderForecastInfo(rasterData.source, rasterData.grid, rasterData.run_timestamp);
            if ((0, $diMLx.map).activeMap === "wm" || (0, $diMLx.map).activeMap === "elevation") return (0, $c022c3a831c783e1$export$f0c5438bd76c55d8)((0, $diMLx.layers).dataLayers.indexOf("waves_fc") !== -1).then(function() {
                if ((0, $diMLx.layers).forecastsLayer && (0, $diMLx.layers).forecastsLayer.overlay && (0, $diMLx.layers).dataLayers.indexOf("waves_fc") === -1 && (0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1) (0, $diMLx.map).instance.removeLayer((0, $diMLx.layers).forecastsLayer.overlay);
                if ((0, $diMLx.layers).dataLayers.indexOf("waves_fc") === -1 && (0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1) // Note : bounds adjusted to compensate img distortion
                (0, $diMLx.layers).forecastsLayer = {
                    forecastId: rasterData.id,
                    forecastTimestamp: timestamp,
                    overlay: new (0, $5e8cbf3f3ba32a5c$export$4e7a29849e6c05f6)(rasterData.raster, [
                        [
                            49,
                            -5
                        ],
                        [
                            45.96,
                            -1.05
                        ]
                    ], {
                        className: "fc_colors",
                        pane: "tilePane"
                    }).addTo((0, $diMLx.map).instance)
                };
                document.querySelector("#map_container").classList.add("rendered");
            });
            else if ((0, $diMLx.map).activeMap === "satellite") {
                if ((0, $diMLx.layers).forecastsLayer && (0, $diMLx.layers).forecastsLayer.overlay && (0, $diMLx.layers).dataLayers.indexOf("waves_fc") === -1 && (0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1) (0, $diMLx.map).instance.removeLayer((0, $diMLx.layers).forecastsLayer.overlay);
                (0, $diMLx.layers).forecastsLayer = {
                    forecastId: rasterData.id,
                    forecastTimestamp: timestamp
                };
                document.querySelector("#map_container").classList.add("rendered");
            } else return Promise.resolve();
        } else {
            emptyForecastData = true;
            $4a909a324b05f370$var$renderForecastInfo(null);
            if ((0, $diMLx.layers).forecastsLayer && (0, $diMLx.layers).forecastsLayer.overlay) (0, $diMLx.map).instance.removeLayer((0, $diMLx.layers).forecastsLayer.overlay);
            document.querySelector("#map_container").classList.remove("rendered");
            return (0, $c022c3a831c783e1$export$7936340adedaf8bc)((0, $diMLx.map).activeMap, emptyForecastData);
        }
    }).then(function() {
        if (!emptyForecastData) {
            $4a909a324b05f370$var$initWindParticles();
            return fetch((0, $am1Dn.config).backEndUrl + "/live_forecasts/raster.json?metric=direction" + (timestamp ? "&timestamp=" + timestamp : "")).then(function(resp) {
                return resp.json();
            }).then(function(rasterData) {
                if (rasterData.width) {
                    (0, $diMLx.map).rasterWidth = rasterData.width;
                    (0, $diMLx.map).rasterHeight = rasterData.height;
                    (0, $diMLx.map).windLayer.start();
                    if ((0, $diMLx.map).activeMap === "satellite") (0, $diMLx.map).windLayer.loadColorGradient((0, $am1Dn.windColorsGradient)(rasterData));
                    else (0, $diMLx.map).windLayer.loadColorGradient((0, $am1Dn.singleColorGradient)("#FFFFFF"));
                    (0, $diMLx.map).windLayer.setWindData({
                        uMin: rasterData.u_min,
                        uMax: rasterData.u_max,
                        vMin: rasterData.v_min,
                        vMax: rasterData.v_max,
                        width: rasterData.width,
                        height: rasterData.height,
                        image: rasterData.path
                    });
                    $4a909a324b05f370$export$392d57327b439f08();
                }
            });
        }
    });
}
function $4a909a324b05f370$export$392d57327b439f08(particlesLayer) {
    let scale = (0, $diMLx.map).instance.getZoomScale((0, $diMLx.map).instance.getZoom(), (0, $diMLx.map).refZoom), bottomLeft = (0, $diMLx.map).instance.project((0, $diMLx.map).instance.getBounds().getSouthWest(), (0, $diMLx.map).refZoom);
    // console.log('scale : ' + scale + ' - bottomLeft : ' + bottomLeft);
    let mSize = (0, $diMLx.map).instance.getSize();
    let nWidth = mSize.x / (0, $diMLx.map).windWidth / scale;
    let nHeight = mSize.y / (0, $diMLx.map).windHeight / scale;
    let x, y, rect;
    // console.log('relative rect : ' + JSON.stringify(rect));
    // console.log('actual rect : ' + JSON.stringify({
    //   width: Math.round(rect.width * map.rasterWidth), height: Math.round(rect.height * map.rasterHeight),
    //   x: Math.round(rect.x * map.rasterWidth), y: Math.round(rect.y * map.rasterHeight)
    // }));
    if ((0, $diMLx.map).windLayer && (0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1) {
        x = Math.abs(bottomLeft.x - (0, $diMLx.map).windBox[0].x) / (0, $diMLx.map).windWidth;
        y = Math.abs(bottomLeft.y - (0, $diMLx.map).windBox[1].y) / (0, $diMLx.map).windHeight;
        rect = {
            width: nWidth,
            height: nHeight,
            x: x,
            y: y
        };
        (0, $diMLx.map).windLayer.setWindMapRect(rect.x, rect.y, rect.width, rect.height);
        (0, $diMLx.map).windLayer.start();
    }
    if ((0, $diMLx.map).wavesLayer && (0, $diMLx.layers).dataLayers.indexOf("waves_fc") !== -1) {
        x = Math.abs(bottomLeft.x - (0, $diMLx.map).wavesBox[0].x) / (0, $diMLx.map).wavesWidth;
        y = Math.abs(bottomLeft.y - (0, $diMLx.map).wavesBox[1].y) / (0, $diMLx.map).wavesHeight;
        rect = {
            width: nWidth,
            height: nHeight,
            x: x,
            y: y
        };
        (0, $diMLx.map).wavesLayer.setWindMapRect(rect.x, rect.y, rect.width, rect.height);
        (0, $diMLx.map).wavesLayer.start();
    }
}
function $4a909a324b05f370$var$onWebGLFailure() {
    console.error("WebGL Context lost");
}
function $4a909a324b05f370$var$initWindParticles() {
    if (!(0, $diMLx.map).windLayer) {
        let params = {
            container: document.getElementById("particles_wrapper"),
            webGLFailureCallback: $4a909a324b05f370$var$onWebGLFailure
        };
        (0, $diMLx.map).windLayer = new WindMap(params);
        (0, $diMLx.map).windLayer.opacity = 1;
        (0, $diMLx.map).windLayer.fadeOut = 0.88;
        (0, $diMLx.map).windLayer.thickness = 1.5;
        (0, $diMLx.map).windLayer.speedFactor = 1.5;
        (0, $diMLx.map).windLayer.particlesNumber = 650;
        (0, $diMLx.map).windLayer.dropRate = 0.05;
    }
}
function $4a909a324b05f370$var$initWavesParticles() {
    if (!(0, $diMLx.map).wavesLayer) {
        let params = {
            container: document.getElementById("waves_wrapper"),
            webGLFailureCallback: $4a909a324b05f370$var$onWebGLFailure
        };
        (0, $diMLx.map).wavesLayer = new WindMap(params);
        (0, $diMLx.map).wavesLayer.opacity = 0.8;
        (0, $diMLx.map).wavesLayer.fadeOut = 0.999;
        (0, $diMLx.map).wavesLayer.thickness = 2;
        (0, $diMLx.map).wavesLayer.speedFactor = 0.5;
        (0, $diMLx.map).wavesLayer.particlesNumber = 2000;
        (0, $diMLx.map).wavesLayer.dropRate = 0.2;
    }
}
function $4a909a324b05f370$var$renderForecastInfo(source, grid, runTs) {
    let dataInfo = document.querySelector("#data_info"), fcInfo = dataInfo.querySelector("#fc_info");
    if (source) {
        let sourceDetail = "", runTimestamp = /^\d+$/.test(runTs) ? (0, $0866737b96521d45$export$2e2bcd8739ae039).unix(runTs) : (0, $0866737b96521d45$export$2e2bcd8739ae039)(runTs);
        if (source === "arome" || source === "arpege") sourceDetail = "M\xe9t\xe9o-France (" + source.toUpperCase() + " " + grid + ")";
        else sourceDetail = source.toUpperCase();
        if (sourceDetail === "WW3") sourceDetail = "WW3 M\xe9t\xe9o-France (haute r\xe9solution)";
        let fcContent = "<p>Pr\xe9vis. du " + runTimestamp.format("DD/MM \xe0 H[h]") + "<br/><em>" + sourceDetail + "</em></p>";
        if (fcInfo) fcInfo.innerHTML = fcContent;
        else {
            console.log("sourceDetail: " + fcContent);
            dataInfo.insertAdjacentHTML("beforeend", '<div id="fc_info">' + fcContent + "</div>");
        }
    } else {
        let emptyContent = "<p>Donn\xe9es indisponibles</p>";
        if (fcInfo) fcInfo.innerHTML = emptyContent;
        else dataInfo.insertAdjacentHTML("beforeend", emptyContent);
    }
}
function $4a909a324b05f370$var$renderWindInfo() {
    let dataInfo = document.querySelector("#data_info"), windInfo = dataInfo.querySelector("#wind_info"), windContent = "<p>Vents r\xe9els (et rafales) en n\u0153uds</p>";
    if (!windInfo) dataInfo.insertAdjacentHTML("beforeend", '<div id="wind_info">' + windContent + "</div>");
}
function $4a909a324b05f370$var$renderAmpInfo() {
    let dataInfo = document.querySelector("#data_info"), ampInfo = dataInfo.querySelector("#amp_info"), ampContent = "<p>Donn\xe9es Office fran\xe7ais de la biodiversit\xe9</p>";
    if (!ampInfo) dataInfo.insertAdjacentHTML("beforeend", '<div id="amp_info">' + ampContent + "</div>");
}
function $4a909a324b05f370$export$9e1f78c1c35aeca4() {
    if ((0, $diMLx.layers).forecastsLayer && (0, $diMLx.layers).forecastsLayer.overlay) (0, $diMLx.map).instance.removeLayer((0, $diMLx.layers).forecastsLayer.overlay);
    (0, $diMLx.layers).forecastsLayer = null;
    if ((0, $diMLx.map).windLayer) (0, $diMLx.map).windLayer.stop();
    if (document.querySelector("#fc_info")) document.querySelector("#fc_info").innerHTML = "";
    (0, $c022c3a831c783e1$export$7936340adedaf8bc)((0, $diMLx.map).activeMap);
}
function $4a909a324b05f370$export$ec577891f2365dde(timestamp) {
    if ((0, $diMLx.map).activeMap === "wm") (0, $c022c3a831c783e1$export$382d1aca2389ca8b)();
    return fetch((0, $am1Dn.config).backEndUrl + "/live_forecasts/raster.json?source=ww3&metric=wave" + (timestamp ? "&timestamp=" + timestamp : "")).then(function(resp) {
        if (resp.ok) return resp.json();
        else throw new Error("Forecast data not found");
    }).then(function(rasterData) {
        // console.log("rasterData: " + JSON.stringify(rasterData));
        if (rasterData.width) {
            $4a909a324b05f370$var$renderForecastInfo(rasterData.source, rasterData.grid, rasterData.run_timestamp);
            // var wmLayerBtn = document.querySelector("#styled_bg");
            // if (!wmLayerBtn.classList.contains("active") && map.activeMap !== 'elevation') {
            //   toggleMap(wmLayerBtn, "wm");
            // }
            return (0, $c022c3a831c783e1$export$f0c5438bd76c55d8)(true, true).then(function() {
                if ((0, $diMLx.layers).forecastsLayer && (0, $diMLx.layers).forecastsLayer.overlay) (0, $diMLx.map).instance.removeLayer((0, $diMLx.layers).forecastsLayer.overlay);
                // Note : bounds adjusted to compensate img distortion
                // Improvement : reproject properly to avoid distortion in the whole area
                (0, $diMLx.layers).forecastsLayer = {
                    forecastId: rasterData.id,
                    forecastTimestamp: timestamp,
                    overlay: new (0, $5e8cbf3f3ba32a5c$export$4e7a29849e6c05f6)(rasterData.raster, [
                        [
                            49,
                            -5
                        ],
                        [
                            45.96,
                            -0.98
                        ]
                    ], {
                        className: "fc_colors",
                        pane: "tilePane"
                    }).addTo((0, $diMLx.map).instance)
                };
                if (!document.querySelector("#waves_wrapper")) document.querySelector("#map .leaflet-tile-pane").insertAdjacentHTML("beforeend", '<div id="waves_wrapper" class="leaflet-zoom-animated" style="width: ' + (0, $diMLx.layout).width + "px; height: " + (0, $diMLx.layout).height + 'px;"></div>');
                document.querySelector("#map_container").classList.add("rendered");
            });
        } else {
            $4a909a324b05f370$var$renderForecastInfo(null);
            if ((0, $diMLx.layers).forecastsLayer && (0, $diMLx.layers).forecastsLayer.overlay) (0, $diMLx.map).instance.removeLayer((0, $diMLx.layers).forecastsLayer.overlay);
            document.querySelector("#map_container").classList.remove("rendered");
            return (0, $c022c3a831c783e1$export$7936340adedaf8bc)((0, $diMLx.map).activeMap);
        }
    }).then(function() {
        $4a909a324b05f370$var$initWavesParticles();
        return fetch((0, $am1Dn.config).backEndUrl + "/live_forecasts/raster.json?metric=wave_direction&source=ww3" + (timestamp ? "&timestamp=" + timestamp : "")).then(function(resp) {
            return resp.json();
        }).then(function(rasterData) {
            if (rasterData.width) {
                (0, $diMLx.map).rasterWidth = rasterData.width;
                (0, $diMLx.map).rasterHeight = rasterData.height;
                (0, $diMLx.map).wavesLayer.start();
                (0, $diMLx.map).wavesLayer.loadColorGradient((0, $am1Dn.singleColorGradient)("#02ACF1"));
                (0, $diMLx.map).wavesLayer.setWindData({
                    uMin: rasterData.u_min,
                    uMax: rasterData.u_max,
                    vMin: rasterData.v_min,
                    vMax: rasterData.v_max,
                    width: rasterData.width,
                    height: rasterData.height,
                    image: rasterData.path
                });
                if ((0, $diMLx.layers).dataLayers.indexOf("wind_fc") === -1) $4a909a324b05f370$export$392d57327b439f08();
            }
        });
    }).catch(function(err) {
        console.warn("Could not retrieve waves forecast data for provided timestamp");
        $4a909a324b05f370$export$b6340bfc991ad04(true);
    });
}
function $4a909a324b05f370$export$b6340bfc991ad04(skipRefresh = false) {
    console.log("hideWavesForecasts");
    if ((0, $diMLx.layers).forecastsLayer) (0, $diMLx.map).instance.removeLayer((0, $diMLx.layers).forecastsLayer.overlay);
    (0, $diMLx.layers).forecastsLayer = null;
    if ((0, $diMLx.map).wavesLayer) (0, $diMLx.map).wavesLayer.stop();
    if (document.querySelector("#fc_info")) document.querySelector("#fc_info").innerHTML = "";
    (0, $c022c3a831c783e1$export$7936340adedaf8bc)((0, $diMLx.map).activeMap, skipRefresh);
}
function $4a909a324b05f370$export$c3627125dd65970c() {
    (0, $diMLx.layers).overlay.node().innerHTML = '<symbol id="arrow" viewBox="0 0 43.4 47.4" width="24px" height="26px"><path stroke-width="2" d="M3.3,3.6C3.7,3.2,4.4,3,5.1,3.2l16.7,5.4l16.6-5.5c0.7-0.2,1.4,0,1.8,0.5c0.5,0.5,0.6,1.3,0.3,1.9L23.5,43.4c-0.2,0.6-0.9,1-1.6,1c-0.7,0-1.3-0.4-1.6-1L2.9,5.6C2.7,5,2.8,4.2,3.3,3.6C3.2,3.7,3.2,3.7,3.3,3.6z"/></symbol><symbol id="alt_arrow" width="22px" height="24px" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="group" transform="rotate(180) translate(-23, -24)"><g id="Subtract"><mask id="path-1-outside-1_31_8077" maskUnits="userSpaceOnUse" x="1.5" y="0" width="21" height="23" fill="black"><rect fill="white" x="1.5" width="21" height="23"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.3476 21.9103C20.6989 22.0119 21.0501 21.9103 21.2508 21.7073C21.5017 21.4028 21.5519 20.9968 21.4515 20.6923L18.7075 14.6627L11.9791 12.0841L5.25738 14.7161L2.58468 20.743C2.43414 21.0475 2.48432 21.4536 2.73521 21.7073C2.93592 21.9611 3.28716 22.0626 3.63841 21.9611L11.9679 19.1697L20.3476 21.9103ZM6.41003 12.1169L11.6106 10.0806L11.9713 9.93931L12.333 10.0779L17.5268 12.0684L12.7206 1.50753C12.5701 1.20301 12.269 1 11.9177 1C11.5665 1 11.2153 1.20301 11.1149 1.50753L6.41003 12.1169Z"/></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M20.3476 21.9103C20.6989 22.0119 21.0501 21.9103 21.2508 21.7073C21.5017 21.4028 21.5519 20.9968 21.4515 20.6923L18.7075 14.6627L11.9791 12.0841L5.25738 14.7161L2.58468 20.743C2.43414 21.0475 2.48432 21.4536 2.73521 21.7073C2.93592 21.9611 3.28716 22.0626 3.63841 21.9611L11.9679 19.1697L20.3476 21.9103ZM6.41003 12.1169L11.6106 10.0806L11.9713 9.93931L12.333 10.0779L17.5268 12.0684L12.7206 1.50753C12.5701 1.20301 12.269 1 11.9177 1C11.5665 1 11.2153 1.20301 11.1149 1.50753L6.41003 12.1169Z" fill="white"/></g></g></symbol><symbol id="wave_arrow" viewBox="0 0 100 100" width="24px" height="26px"><g transform="translate(0,-952.36218)"><path d="m 49.999995,1037.3622 27.00001,-38.00002 -17,3.00002 4,-35.00002 -28.00001,0 4,35.00002 -17,-3.00002 z" stroke-width="2"/></g></symbol><symbol id="wave_sensor_icon" viewBox="0 0 576 512" width="24px" height="26px"><path d="M0 336c0-17.7 14.3-32 32-32c35.3 0 64-28.7 64-64C96 125.1 189.1 32 304 32c84.7 0 157.6 50.7 190 123.2c4.7 10.5 1.3 22.8-8.1 29.4s-22.2 5.6-30.4-2.3C441 168.5 421.5 160 400 160c-44.2 0-80 35.8-80 80c0 35.3 28.7 64 64 64c0 0 0 0 0 0c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c15 3.5 25.1 17.1 24.7 31.9l0 41.9c-28.7 0-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2C55.1 369.7 28.7 378.6 0 378.6L0 336zm0 74.6c35 0 66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c21 9.5 52 20.3 87.1 20.3l0 36.6c.1 2.7-.2 5.4-.8 8.1c-4 17.2-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9c-.6-2.4-.8-4.9-.8-7.3c0 0 0 0 0 0s0 0 0 0l0-37.4z"/></symbol><g class="zoom_wrapper"></g>';
}
function $4a909a324b05f370$export$99d351c03c5dffc6() {
    (0, $diMLx.layers).forecastsLayer.node().innerHTML = '<symbol id="wave_arrow" viewBox="0 0 100 100" width="16px"><g transform="translate(0,-952.36218)"><path d="m 49.999995,1037.3622 27.00001,-38.00002 -17,3.00002 4,-35.00002 -28.00001,0 4,35.00002 -17,-3.00002 z" fill="none" stroke="#0c4da2"/></g></symbol><g class="zoom_wrapper"></g>';
}
function $4a909a324b05f370$export$f45e13584efe3e9() {
    if (!(0, $diMLx.data).sensorsPolling) (0, $diMLx.data).sensorsPolling = setInterval(()=>{
        $4a909a324b05f370$var$loadWindSensorsData();
        if ((0, $diMLx.layers).dataLayers.indexOf("waves") !== -1) $4a909a324b05f370$var$loadWaveSensorsData();
    }, 30000);
}
function $4a909a324b05f370$export$2eeb97286c6ecc12() {
    $4a909a324b05f370$var$loadWindSensorsData();
}
function $4a909a324b05f370$export$73503ae067c61ef7() {
    $4a909a324b05f370$var$loadWaveSensorsData();
}
function $4a909a324b05f370$export$29c237bcbb68a918() {
    (0, $diMLx.layers).overlay.selectAll(".wind_sensor").remove();
}
function $4a909a324b05f370$export$8bc70383dd83dd6b() {
    (0, $diMLx.layers).overlay.selectAll(".wave_sensor").remove();
}
function $4a909a324b05f370$export$cb0d41d287166a75(timestamp) {
    (0, $iRjZV.getAsync)((0, $am1Dn.config).backEndUrl + "/live_forecasts/weather.json" + (timestamp ? "?timestamp=" + timestamp : ""), function(poisData) {
        (0, $diMLx.layers).overlay.select(".zoom_wrapper").selectAll(".weather_poi").remove();
        var pois = (0, $diMLx.layers).overlay.select(".zoom_wrapper").selectAll(".weather_poi").data(poisData.pois, function(d) {
            return d.name;
        }).join("g").attr("class", function(d) {
            return (0, $26ce3c45196098b3$export$2e2bcd8739ae039).lastResolved()[0].data && d.slug === (0, $26ce3c45196098b3$export$2e2bcd8739ae039).lastResolved()[0].data.name ? "weather_poi poi-active" : "weather_poi";
        }).attr("id", function(d) {
            return "poi_" + d.slug;
        }).attr("transform", function(d) {
            return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)(d.lng, d.lat) + ")";
        });
        $4a909a324b05f370$var$renderForecastInfo(poisData.pois[0].source, poisData.pois[0].grid, poisData.pois[0].run_ts);
        pois.append("foreignObject").attr("width", 80).attr("height", 64).attr("transform", "translate(-40, -36)").append("xhtml:body").html(function(d, j) {
            let poiData = Object.values(poisData.pois)[j];
            if (poiData) {
                let currentRain = poiData.tw || poiData.tp || 0, prevRain = poiData.prev_tw || poiData.prev_tp || 0;
                let icon = (0, $828c72eac0f0470f$export$a815945e7f6f673b)(poiData.hc, poiData.mc, poiData.lc, parseInt(poisData.timestamp), currentRain - prevRain);
                return "<a href='/previsions/" + d.slug + "' class='poi_icon' data-navigo><img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($f1b279363cb8b9b4$exports)))[icon] + "' alt='" + d.name + "'/><span>" + poiData.temp + "\xb0</span></a>" + "<p class='poi_name'>" + d.name + "</p>";
            }
        });
        (0, $26ce3c45196098b3$export$2e2bcd8739ae039).updatePageLinks();
    });
}
function $4a909a324b05f370$export$8cec9de7786b83d1() {
    (0, $diMLx.layers).overlay.selectAll(".weather_poi").remove();
}
function $4a909a324b05f370$export$e7ff43a15e05d735() {
    (0, $iRjZV.getAsync)("https://private2.windmorbihan.com/mesures/getmapelement-water_temp.html", function(html) {
        var parser = new DOMParser(), tempDoc = parser.parseFromString(html, "text/html");
        var waterTempSensors = (0, $diMLx.layers).overlay.select(".zoom_wrapper").selectAll(".water_temp_sensor").data((0, $am1Dn.waterTempSensorsRefs)).join("g").attr("class", "water_temp_sensor").attr("id", function(d) {
            return "sensor_" + d.nid;
        }).attr("transform", function(d) {
            return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)(d.lng, d.lat) + ")";
        });
        waterTempSensors.filter(function(d) {
            return tempDoc.querySelector('[data-nid="' + d.nid + '"]');
        }).append("foreignObject").attr("width", 30).attr("height", 30).attr("transform", "translate(64, 18)").append("xhtml:body").html(function(d) {
            return "<p>" + tempDoc.querySelector('[data-nid="' + d.nid + '"]').textContent.replace(/\.\d+/, "").replace(/\s+C/, "") + "</p>";
        });
        waterTempSensors.on("click", function(evt, d) {
            evt.stopPropagation();
            (0, $26ce3c45196098b3$export$2e2bcd8739ae039).navigate("/" + (0, $am1Dn.waterTempSensorsRefs)[0].slug);
        });
        waterTempSensors.on("mouseover", function(evt, d) {
            $5ff8fe1f0e47d54c$export$2e2bcd8739ae039(this).raise();
            $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#sensor_" + d.nid).append("text").attr("class", "sensor_name").text((0, $am1Dn.waterTempSensorsRefs)[0].label);
        }).on("mouseout", function(evt, d) {
            $227417086e98b72e$export$2e2bcd8739ae039(".sensor_name").remove();
            $5ff8fe1f0e47d54c$export$2e2bcd8739ae039(this).lower();
        });
    // console.timeEnd('displayWaterTemp');
    }, true);
}
function $4a909a324b05f370$export$58ee9c5364baca8b() {
    (0, $diMLx.layers).overlay.selectAll(".water_temp_sensor").remove();
}
function $4a909a324b05f370$export$55801adb6166106a() {
    (0, $am1Dn.loadWebcams)(function() {
        var webcams = (0, $diMLx.layers).overlay.select(".zoom_wrapper").selectAll(".webcam_spot").data((0, $am1Dn.webcamsRefs)).join("g").attr("class", "webcam_spot").attr("transform", function(d) {
            return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)(d.lng, d.lat) + ")";
        });
        webcams.append("foreignObject").attr("width", 32).attr("height", 32).attr("transform", "translate(-16, -16)").append("xhtml:body").html(function(d) {
            return '<a href="/webcam/' + d.slug + '" title="' + d.label + '" data-navigo><img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($1744ee85d0ea69cd$exports)))["webcam-map"] + '" alt="' + d.label + '"></a>';
        });
        (0, $26ce3c45196098b3$export$2e2bcd8739ae039).updatePageLinks();
    });
}
function $4a909a324b05f370$export$d90e5afe47f108e7() {
    (0, $diMLx.layers).overlay.selectAll(".webcam_spot").remove();
}
function $4a909a324b05f370$export$d2af805eac6d6eea() {
    (0, $iRjZV.getAsync)("https://private2.windmorbihan.com/mesures/getmapelement-temp.html", function(html) {
        var parser = new DOMParser(), tempDoc = parser.parseFromString(html, "text/html");
        var tempSensors = (0, $diMLx.layers).overlay.select(".zoom_wrapper").selectAll(".temp_sensor").data((0, $am1Dn.tempSensorsRefs)).join("g").attr("class", "temp_sensor").attr("transform", function(d) {
            return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)(d.lng, d.lat) + ")";
        });
        tempSensors.filter(function(d) {
            return tempDoc.querySelector('.box_capteur[nid="' + d.nid + '"]');
        }).append("foreignObject").attr("width", 36).attr("height", 30).attr("transform", "translate(-50, -12)").append("xhtml:body").html(function(d) {
            return "<p>" + tempDoc.querySelector('.box_capteur[nid="' + d.nid + '"] .temp_value span').textContent + "</p>";
        });
    }, true);
}
function $4a909a324b05f370$export$5aa43213bed9fb5b() {
    (0, $diMLx.layers).overlay.selectAll(".temp_sensor").remove();
}
function $4a909a324b05f370$export$cf14a483bbda0641() {
// var windLegendItems = d3.selectAll("#wind_legend tbody").selectAll("tr").data(config.windLegendRanges).join("tr")
//   .attr("style", function (d) {
//     return "background-color: " + d.color;
//   });
//
// windLegendItems.append("td").text(function (d) {
//   return d.bLabel;
// });
// windLegendItems.append("td").text(function (d) {
//   return d.kLabel;
// });
// windLegendItems.append("td").text(function (d) {
//   return d.kmLabel;
// });
//
// var wavesLegendItems = d3.selectAll("#waves_legend tbody").selectAll("tr").data(config.wavesLegendRanges).join("tr")
//   .attr("style", function (d) {
//     return "background-color: " + d.color;
//   });
//
// wavesLegendItems.append("td").text(function (d) {
//   return d.height;
// });
// wavesLegendItems.append("td").text(function (d) {
//   return d.label;
// });
//
//
// d3.select("#map_legend").classed("active", true);
}
function $4a909a324b05f370$export$a8743d50e760069c() {
// d3.selectAll("#wind_legend tr").remove();
// d3.selectAll("#waves_legend tr").remove();
// d3.select("#map_legend").classed("active", false);
}
function $4a909a324b05f370$export$4b28a1d7df585529() {
    (0, $am1Dn.loadHarbors)(function() {
        var harbors = (0, $diMLx.layers).overlay.select(".zoom_wrapper").selectAll(".tide_spot").data((0, $am1Dn.harborsRefs)).join("g").attr("class", "tide_spot").attr("transform", function(d) {
            return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)(d.lng, d.lat) + ")";
        }).on("click", $4a909a324b05f370$export$a56d4708c86e0d68);
        harbors.append("foreignObject").attr("width", 32).attr("height", 32).attr("transform", "translate(-16, -16)").append("xhtml:body").html(function(d) {
            return '<a href="/port/' + d.slug + '" title="' + d.label + '" data-navigo><img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($1744ee85d0ea69cd$exports)))["tide-map"] + '" alt="' + d.label + '"></a>';
        });
        (0, $26ce3c45196098b3$export$2e2bcd8739ae039).updatePageLinks();
    });
}
function $4a909a324b05f370$export$d7485b22b743276a() {
    (0, $diMLx.layers).overlay.selectAll(".tide_spot").remove();
}
function $4a909a324b05f370$export$bc7a58d94166ace9() {
    var ampZones = document.querySelectorAll(".amp_zone"), i;
    if (ampZones.length > 0) for(i = 0; i < ampZones.length; i++)ampZones[i].remove();
    if (document.querySelector("#amp_info")) document.querySelector("#amp_info").remove();
}
function $4a909a324b05f370$export$374449e81fae6fe1() {
    (0, $diMLx.layers).overlay.selectAll(".amp_spot").remove();
    if (document.querySelector("#amp_info")) document.querySelector("#amp_info").remove();
}
function $4a909a324b05f370$export$aceb2de1ae588630() {
    (0, $60bb235caa3bb374$export$2e2bcd8739ae039)((0, $am1Dn.config).backEndUrl + "/features.json?source=amp_poi").then(function(geojsonPois) {
        $4a909a324b05f370$var$renderAmpInfo();
        var ampPois = (0, $diMLx.layers).overlay.select(".zoom_wrapper").selectAll(".amp_spot").data(geojsonPois.features).join("g").attr("class", "amp_spot").attr("transform", function(d) {
            return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)(d.geometry.coordinates[0], d.geometry.coordinates[1]) + ")";
        }).on("click", $4a909a324b05f370$var$ampDetails);
        ampPois.append("foreignObject").attr("width", 32).attr("height", 32).append("xhtml:body").html(function(d) {
            return '<div title="' + d.properties.title + '" ><img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($1744ee85d0ea69cd$exports)))["amp-map"] + '" alt="' + d.properties.title + '"></a>';
        });
    });
}
function $4a909a324b05f370$export$4f3be6eabe0c49e5() {
    let zoneStyle = {
        stroke: false,
        fill: true,
        fillColor: "rgb(224,87,247)",
        fillOpacity: 0.7
    };
    return (0, $60bb235caa3bb374$export$2e2bcd8739ae039)((0, $am1Dn.config).backEndUrl + "/features.json?source=amp").then(function(geoJsonZone) {
        $4a909a324b05f370$var$renderAmpInfo();
        let geoJson = $7a2b08189990a7f0$exports.geoJSON(geoJsonZone.features, {
            className: "amp_zone",
            style: zoneStyle,
            pane: "tilePane",
            filter: function(feature, layer) {
                return true;
            }
        });
        geoJson.addTo((0, $diMLx.map).instance);
        (0, $diMLx.layers).bgLayers.push(geoJson);
        return geoJson;
    });
}
function $4a909a324b05f370$var$ampDetails(evt, d) {
    document.querySelector("#map_modal").setAttribute("data-modal", "amp");
    document.querySelector("#map_modal_title").innerHTML = d.properties.title;
    document.querySelector("#header_links").innerHTML = '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
    var imgMarkup = "";
    if (d.properties.img) imgMarkup = "<div class='amp_photo'><img src='" + d.properties.img + "'/><p>Credit Photo : " + d.properties.credit_img1 + "</p></div>";
    document.querySelector("#map_modal_content").innerHTML = "<div class='amp_modal'>" + imgMarkup + "<div class='amp_description'>" + "<h2>" + d.properties.title + "</h2>" + "<h3>" + d.properties.header_text + "</h3>" + "<h4>Lieu : " + d.properties.amp_name + "</h4>" + "<p>" + d.properties.description + "</p>" + "</div>" + "</div>";
    (0, $ca9ad.default).show("map_modal", {
        disableScroll: true
    });
}
function $4a909a324b05f370$export$3d0a3aba327d4829(d) {
    document.querySelector("#map_modal").setAttribute("data-modal", "webcam");
    document.querySelector("#map_modal_title").innerHTML = d.label;
    document.querySelector("#header_links").innerHTML = '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
    document.querySelector("#map_modal_content").innerHTML = d.content;
    (0, $ca9ad.default).show("map_modal", {
        disableScroll: true,
        onClose: ()=>{
            (0, $26ce3c45196098b3$export$2e2bcd8739ae039).navigate("/");
        }
    });
}
function $4a909a324b05f370$export$a56d4708c86e0d68(d) {
    document.querySelector("#map_modal").setAttribute("data-modal", "tide");
    document.querySelector("#map_modal_title").innerHTML = d.label;
    document.querySelector("#header_links").innerHTML = '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
    document.querySelector("#map_modal_content").innerHTML = '<iframe id="shom_wrapper" src="javascript:void(0);"></iframe>';
    var frm = document.querySelector("#map_modal_content #shom_wrapper");
    frm.srcdoc = '<html><body style="margin: 0; padding: 0;"><script src="' + d.shomUrl + '"></script></body></html>';
    (0, $ca9ad.default).show("map_modal", {
        disableScroll: true,
        onClose: ()=>{
            (0, $26ce3c45196098b3$export$2e2bcd8739ae039).navigate("/");
        }
    });
}
function $4a909a324b05f370$export$53d225340945d25c(popup, lat, lng) {
    $4a909a324b05f370$var$getForecastPoint((0, $diMLx.layers).forecastsLayer.forecastId, lat, lng, function(pointData) {
        if (pointData.lat) {
            (0, $diMLx.map).currentFocus = pointData;
            let color = (0, $diMLx.map).currentFocus.ws ? (0, $am1Dn.windColor)((0, $diMLx.map).currentFocus.ws) : {
                bg: (0, $am1Dn.waveColor)((0, $diMLx.map).currentFocus.wah),
                text: "#154194"
            };
            let value = (0, $diMLx.map).currentFocus.ws ? Math.round((0, $diMLx.map).currentFocus.ws) + "nds" : (0, $diMLx.map).currentFocus.wah + "m";
            let windDir = "";
            if ((0, $diMLx.map).currentFocus.wind_d) {
                let dirVal = (270 - (0, $diMLx.map).currentFocus.wind_d) % 360;
                dirVal = dirVal < 10 ? "00" + dirVal : dirVal < 100 ? "0" + dirVal : dirVal;
                windDir = " / " + dirVal + "\xb0";
            }
            let waveDir = (0, $diMLx.map).currentFocus.wad ? '<img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($1744ee85d0ea69cd$exports)))["fleche-vague"] + '" alt="direction" class="pointer_direction" style="transform: rotate(' + ((0, $diMLx.map).currentFocus.wad - 180) + 'deg); transform-origin: 50% 50% 0px; display: inline;"/>' : "";
            popup.setContent('<p style="background-color: ' + color.bg + "; color: " + color.text + '" class="pointer_info">' + value + (windDir || waveDir) + "</p>");
        } else popup.setContent(lat + ", " + lng);
    });
}
function $4a909a324b05f370$var$getForecastPoint(forecastId, lat, lng, callback) {
    (0, $iRjZV.getAsync)((0, $am1Dn.config).backEndUrl + "/live_forecasts/" + forecastId + "/point?lat=" + lat + "&lng=" + lng, function(pointData) {
        callback(pointData);
    });
}
function $4a909a324b05f370$export$2a22cb1184287a3d() {
    (0, $diMLx.map).instance.locate();
}
function $4a909a324b05f370$export$e72c2db76561db73(data) {
    if ((0, $diMLx.layers).dataLayers.indexOf("wind") !== -1) {
        $4a909a324b05f370$var$renderWindInfo();
        let availableSensors = data.filter(function(d) {
            return Object.keys((0, $am1Dn.sensorsRefs)).indexOf(d.nid.toString()) !== -1;
        });
        (0, $diMLx.layers).overlay.select(".zoom_wrapper").selectAll(".wind_sensor").data(availableSensors, function(d) {
            return d.nid;
        }).join(function(enter) {
            var sensors = enter.append("g").attr("class", "wind_sensor").attr("id", function(d) {
                return "sensor_" + d.nid;
            }).attr("transform", function(d) {
                return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)((0, $am1Dn.sensorsRefs)[d.nid].lng, (0, $am1Dn.sensorsRefs)[d.nid].lat) + ")";
            });
            sensors.append("use").attr("xlink:href", "#arrow").attr("x", "-12").attr("y", "-13").attr("width", "24px").attr("height", "26px").attr("class", function(d) {
                return $4a909a324b05f370$var$isValidAngle(d.nid, d.wind_dir_true) ? "" : "devent";
            }).attr("transform", function(d) {
                return "rotate(" + d.wind_dir_true + ", 0, 0)";
            });
            sensors.append("g").attr("class", "wind_details").attr("transform", "translate(16, -12)").append("foreignObject").attr("width", 60).attr("height", 30).append("xhtml:body").html(function(d) {
                let color = (0, $am1Dn.windColor)(d.wind_pow_knot), colorMax = (0, $am1Dn.windColor)(d.wind_pow_knot_max);
                return "<p><span style='background-color: " + color.bg + "; color: " + color.text + "'>" + d.wind_pow_knot + "</span>" + "<span style='background-color: " + colorMax.bg + "; color: " + colorMax.text + "'>(" + d.wind_pow_knot_max + ")</span>" + "</p>";
            });
            sensors.on("click", function(evt, d) {
                evt.stopPropagation();
                (0, $26ce3c45196098b3$export$2e2bcd8739ae039).navigate("/" + (0, $am1Dn.sensorsRefs)[d.nid].slug);
            });
            sensors.on("mouseover", function(evt, d) {
                $5ff8fe1f0e47d54c$export$2e2bcd8739ae039(this).raise();
                $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#sensor_" + d.nid).append("text").attr("class", "sensor_name").text((0, $am1Dn.sensorsRefs)[d.nid].label);
            }).on("mouseout", function(evt, d) {
                $227417086e98b72e$export$2e2bcd8739ae039(".sensor_name").remove();
            // d3.select(this).lower();
            });
            return sensors;
        }, function(update) {
            update.select("use").attr("transform", function(d) {
                return "rotate(" + d.wind_dir_true + ", 0, 0)";
            });
            update.select("g foreignObject body p span:first-child").transition().style("background-color", function(d) {
                return (0, $am1Dn.windColor)(d.wind_pow_knot).bg;
            }).style("color", function(d) {
                return (0, $am1Dn.windColor)(d.wind_pow_knot).text;
            }).text(function(d) {
                return d.wind_pow_knot;
            });
            update.select("g foreignObject body p span:last-child").transition().style("background-color", function(d) {
                return (0, $am1Dn.windColor)(d.wind_pow_knot_max).bg;
            }).style("color", function(d) {
                return (0, $am1Dn.windColor)(d.wind_pow_knot_max).text;
            }).text(function(d) {
                return "(" + d.wind_pow_knot_max + ")";
            });
            return update;
        });
    }
}
function $4a909a324b05f370$export$7c21e768f6379ae(data) {
    if ((0, $diMLx.layers).dataLayers.indexOf("waves") !== -1) {
        let availableSensors = data.filter(function(d) {
            return Object.keys((0, $am1Dn.waveSensorsRefs)).indexOf(d.nid.toString()) !== -1;
        });
        (0, $diMLx.layers).overlay.select(".zoom_wrapper").selectAll(".wave_sensor").data(availableSensors, function(d) {
            return d.nid;
        }).join(function(enter) {
            let sensors = enter.append("g").attr("class", "wave_sensor").attr("id", function(d) {
                return "sensor_" + d.nid;
            }).attr("transform", function(d) {
                return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)((0, $am1Dn.waveSensorsRefs)[d.nid].lng, (0, $am1Dn.waveSensorsRefs)[d.nid].lat) + ")";
            });
            sensors.append("use").attr("xlink:href", function(d) {
                return d.wad ? "#wave_arrow" : "#wave_sensor_icon";
            }).attr("x", function(d) {
                return d.wad ? "-18" : "-10";
            }).attr("y", "-19").attr("width", function(d) {
                return d.wad ? "36px" : "24px";
            }).attr("height", "39px").attr("fill", "#FFFFFF").attr("transform", function(d) {
                return d.wad ? "rotate(" + d.wad + ", 0, 0)" : "";
            });
            sensors.append("g").attr("class", "wave_details").attr("transform", function(d) {
                return d.wat ? "translate(-120, -16)" : "translate(-84, -16)";
            }).append("foreignObject").attr("width", function(d) {
                return d.wat ? 105 : 88;
            }).attr("height", 36).append("xhtml:body").html(function(d) {
                return "<div class='swell_data'><div class='swell_height'><span></span><span>" + d.wah + "m</span></div>" + (d.wap ? "<div class='swell_period'><span></span><span>" + d.wap + "s</span></div>" : "") + (d.wat ? "<div class='swell_temp'><span></span><span>" + d.wat + "\xb0C</span></div>" : "") + "</div>";
            });
            sensors.on("click", function(evt, d) {
                evt.stopPropagation();
                (0, $26ce3c45196098b3$export$2e2bcd8739ae039).navigate("/" + (0, $am1Dn.waveSensorsRefs)[d.nid].slug);
            });
            sensors.on("mouseover", function(evt, d) {
                $5ff8fe1f0e47d54c$export$2e2bcd8739ae039(this).raise();
                $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#sensor_" + d.nid).append("text").attr("class", "sensor_name").attr("transform", "translate(-200, -16)").text((0, $am1Dn.waveSensorsRefs)[d.nid].label);
            }).on("mouseout", function(evt, d) {
                $227417086e98b72e$export$2e2bcd8739ae039(".sensor_name").remove();
                $5ff8fe1f0e47d54c$export$2e2bcd8739ae039(this).lower();
            });
            sensors.lower();
            return sensors;
        }, function(update) {
            update.select("use").attr("transform", function(d) {
                return "rotate(" + d.wad + ", 0, 0)";
            });
            update.select("g foreignObject body .swell_height > span:last-child").text(function(d) {
                return `${d.wah}m`;
            });
            update.select("g foreignObject body .swell_period > span:last-child").text(function(d) {
                return `${d.wap}s`;
            });
            update.select("g foreignObject body .swell_temp > span:last-child").text(function(d) {
                return `${d.wat}\xb0C`;
            });
            return update;
        });
    }
}
function $4a909a324b05f370$export$68cdf4e2cb6fc30e() {
    (0, $diMLx.layers).overlay.selectAll(".wind_sensor").attr("transform", function(d) {
        return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)((0, $am1Dn.sensorsRefs)[d.nid].lng, (0, $am1Dn.sensorsRefs)[d.nid].lat) + ")";
    });
    (0, $diMLx.layers).overlay.selectAll(".wave_sensor").attr("transform", function(d) {
        return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)((0, $am1Dn.waveSensorsRefs)[d.nid].lng, (0, $am1Dn.waveSensorsRefs)[d.nid].lat) + ")";
    });
    (0, $diMLx.layers).overlay.selectAll(".weather_poi").attr("transform", function(d) {
        return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)(d.lng, d.lat) + ")";
    });
    (0, $diMLx.layers).overlay.selectAll(".amp_spot").attr("transform", function(d) {
        return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)(d.geometry.coordinates[0], d.geometry.coordinates[1]) + ")";
    });
    (0, $diMLx.layers).overlay.selectAll(".webcam_spot, .temp_sensor, .water_temp_sensor, .tide_spot").attr("transform", function(d) {
        return "translate(" + (0, $c022c3a831c783e1$export$33d1addef09845d7)(d.lng, d.lat) + ")";
    });
}
function $4a909a324b05f370$export$886f6367efad2401(btn, layerRef) {
    var mapContainer = document.querySelector("#map_container");
    if ((0, $diMLx.layers).dataLayers.indexOf(layerRef) !== -1) {
        (0, $diMLx.layers).dataLayers.splice((0, $diMLx.layers).dataLayers.indexOf(layerRef), 1);
        $4a909a324b05f370$var$removeLayer(layerRef);
        if (layerRef === "wind") {
            var layerInfoContainer = document.querySelector("#wind_info");
            if (layerInfoContainer) layerInfoContainer.remove();
        }
        if (layerRef === "wave_fc" && (0, $diMLx.map).activeMap === "wm") (0, $c022c3a831c783e1$export$f0c5438bd76c55d8)(true);
        mapContainer.classList.remove(layerRef);
    } else {
        $4a909a324b05f370$export$2f794522d80bee9d(layerRef);
        (0, $diMLx.layers).dataLayers.push(layerRef);
        mapContainer.classList.add(layerRef);
    }
    let btnElt = btn.classList.contains("layer_preview") ? document.querySelector(`#map_layers #${layerRef}`) : btn;
    const sideBtn = document.querySelector(`#${layerRef}_side`);
    if (layerRef === "legend") btnElt = document.querySelector("#legend");
    if (btnElt) btnElt.classList.toggle("active");
    mapContainer.classList.remove("hide_inactive");
    if (sideBtn) sideBtn.classList.toggle("active");
    (0, $diMLx.logPageView)((0, $26ce3c45196098b3$export$2e2bcd8739ae039).lastResolved(), "/map/" + layerRef, layerRef);
}
function $4a909a324b05f370$var$isValidAngle(sensorId, windDir) {
    let validAngle = (0, $am1Dn.sensorsRefs)[sensorId].validAngle, dir = parseInt(windDir);
    // should work on ecole de voile
    if (validAngle && validAngle.filter((v)=>v).length > 0) {
        let fromAngle, toAngle;
        if (validAngle.length === 3) {
            fromAngle = validAngle[0];
            toAngle = validAngle[2];
        } else {
            fromAngle = validAngle[0];
            toAngle = validAngle[1];
        }
        if (fromAngle > toAngle) return dir >= fromAngle && dir <= 360 || dir >= 0 && dir <= toAngle;
        else return dir >= fromAngle && dir <= toAngle;
    }
    return true;
}
function $4a909a324b05f370$export$2f794522d80bee9d(layerRef) {
    console.debug("Adding layer " + layerRef);
    switch(layerRef){
        case "wind_fc":
            $4a909a324b05f370$export$9b75862e7acdcaad((0, $diMLx.timeline).timelineActiveStep ? $5ff8fe1f0e47d54c$export$2e2bcd8739ae039((0, $diMLx.timeline).timelineActiveStep).datum()[0] : null);
            break;
        case "waves_fc":
            $4a909a324b05f370$export$ec577891f2365dde((0, $diMLx.timeline).timelineActiveStep ? $5ff8fe1f0e47d54c$export$2e2bcd8739ae039((0, $diMLx.timeline).timelineActiveStep).datum()[0] : null);
            break;
        case "weather_fc":
            $4a909a324b05f370$export$cb0d41d287166a75((0, $diMLx.timeline).timelineActiveStep ? $5ff8fe1f0e47d54c$export$2e2bcd8739ae039((0, $diMLx.timeline).timelineActiveStep).datum()[0] : null);
            break;
        case "wind":
            $4a909a324b05f370$export$2eeb97286c6ecc12();
            break;
        case "waves":
            $4a909a324b05f370$export$73503ae067c61ef7();
            break;
        case "webcam":
            $4a909a324b05f370$export$55801adb6166106a();
            break;
        case "temp":
            if (!(0, $diMLx.timeline).timelineActiveStep || (0, $diMLx.timeline).timelineActiveStep && (0, $diMLx.timeline).timelineActiveStep.classList.contains("tl_obs")) $4a909a324b05f370$export$d2af805eac6d6eea();
            break;
        case "legend":
            $4a909a324b05f370$export$cf14a483bbda0641();
            break;
        case "tide_fc":
            $4a909a324b05f370$export$4b28a1d7df585529();
            break;
        case "amp":
            $4a909a324b05f370$export$4f3be6eabe0c49e5();
            break;
        case "amp_poi":
            $4a909a324b05f370$export$aceb2de1ae588630();
            break;
        default:
            console.debug("Unsupported layer ref : " + layerRef);
    }
}
function $4a909a324b05f370$var$removeLayer(layerRef) {
    console.debug("Removing layer " + layerRef);
    switch(layerRef){
        case "wind_fc":
            $4a909a324b05f370$export$9e1f78c1c35aeca4();
            break;
        case "waves_fc":
            $4a909a324b05f370$export$b6340bfc991ad04();
            break;
        case "weather_fc":
            $4a909a324b05f370$export$8cec9de7786b83d1();
            break;
        case "wind":
            $4a909a324b05f370$export$29c237bcbb68a918();
            break;
        case "waves":
            $4a909a324b05f370$export$8bc70383dd83dd6b();
            break;
        case "webcam":
            $4a909a324b05f370$export$d90e5afe47f108e7();
            break;
        case "temp":
            $4a909a324b05f370$export$5aa43213bed9fb5b();
            break;
        case "legend":
            $4a909a324b05f370$export$a8743d50e760069c();
            break;
        case "tide_fc":
            $4a909a324b05f370$export$d7485b22b743276a();
            break;
        case "amp":
            $4a909a324b05f370$export$bc7a58d94166ace9();
            break;
        case "amp_poi":
            $4a909a324b05f370$export$374449e81fae6fe1();
            break;
        default:
            console.debug("Unsupported layer ref : " + layerRef);
    }
}



var $am1Dn = parcelRequire("am1Dn");
function $ac969ff4dde4b936$export$59153413680588f8(timestamp) {
    // console.time('initTimeline');
    let i;
    (0, $diMLx.timeline).timelineReference = timestamp - 345600;
    (0, $diMLx.timeline).timelineSteps = [];
    for(i = 0; i < 1296; i++)(0, $diMLx.timeline).timelineSteps.push([
        (0, $diMLx.timeline).timelineReference + i * (0, $diMLx.timeline).timelineStep,
        (0, $diMLx.timeline).timelineReference + (i + 1) * (0, $diMLx.timeline).timelineStep
    ]);
    return fetch(`https://private2.windmorbihan.com/mesures/history.json`).then((resp)=>resp.json()).then((jsonData)=>{
        (0, $diMLx.data).timelineData = jsonData;
        $ac969ff4dde4b936$var$renderTimeline();
        if (!(0, $diMLx.timeline).keyBoardSetUp) $ac969ff4dde4b936$var$setUpKeyboardActions();
    // console.timeEnd('initTimeline');
    });
}
function $ac969ff4dde4b936$var$renderTimeline() {
    // console.time('renderTimeline');
    let ts, timelineElt = document.querySelector("#timeline");
    let timelineItems = $5ff8fe1f0e47d54c$export$2e2bcd8739ae039("#timeline_steps").selectAll(".tl_item").data((0, $diMLx.timeline).timelineSteps).join("div").attr("class", function(step) {
        return "tl_item" + ((0, $diMLx.timeline).timelineActiveStep && $5ff8fe1f0e47d54c$export$2e2bcd8739ae039((0, $diMLx.timeline).timelineActiveStep).datum()[0] === step[0] ? " active" : "") + ((0, $diMLx.data).timelineData[step[0]] ? " tl_obs" : "");
    }).attr("data-ts", function(step) {
        return step[0];
    }).attr("data-rt", function(step) {
        return (0, $diMLx.data).timelineData[step[0]] ? "1" : null;
    }).attr("data-fc", function(step) {
        return step[0] % 3600 === 0 ? (0, $0866737b96521d45$export$2e2bcd8739ae039).unix(step[0]).format("HH[h]") : null;
    }).attr("data-day", function(step) {
        return new Date(step[0] * 1000).toLocaleString().indexOf("00:00:00") !== -1 ? (0, $0866737b96521d45$export$2e2bcd8739ae039).unix(step[0]).format("ddd DD/MM") : null;
    }).on("click", function(evt) {
        if (!(0, $diMLx.timeline).moving) {
            const clickedTs = evt.target.getAttribute("data-ts");
            console.debug("clicked ts: " + new Date(parseInt(clickedTs) * 1000));
            $ac969ff4dde4b936$var$updateTimelinePosition(clickedTs);
        }
    });
    const now = new Date().getTime() / 1000, stepsCount = 1296.0;
    $ac969ff4dde4b936$var$updateTimelineDatetime(now, false);
    if (!(0, $diMLx.timeline).timelineSlider) {
        // console.time('initSlider');
        (0, $diMLx.timeline).timelineSlider = new (0, $a43bc8a9aed084f0$export$2e2bcd8739ae039)({
            viewport: document.querySelector("#timeline_viewport"),
            content: document.querySelector("#timeline_content"),
            scrollMode: "transform",
            direction: "horizontal",
            emulateScroll: true,
            onUpdate: (state)=>{
                (0, $diMLx.timeline).moving = (0, $diMLx.timeline).scrolling && state.isMoving || state.dragOffset.x !== 0 && state.isMoving;
                if (!state.isMoving) (0, $diMLx.timeline).scrolling = false;
                if (!(0, $diMLx.timeline).skipUpdate) {
                    const currentStep = Math.round((state.position.x + (0, $diMLx.timeline).cursorOffset) / (stepsCount * ((0, $diMLx.timeline).details ? (0, $diMLx.timeline).detailsStepWidth : (0, $diMLx.timeline).stepWidth)) * stepsCount) - 2;
                    ts = (0, $diMLx.timeline).timelineSteps[currentStep][1];
                    timelineElt.classList.remove("no_focus");
                    $ac969ff4dde4b936$var$debouncedSelectTimeline(ts);
                }
            },
            onWheel: ()=>{
                (0, $diMLx.timeline).scrolling = true;
            }
        });
        document.querySelector("#weather_details").setAttribute("style", `padding-left: ${($ac969ff4dde4b936$var$computeWeatherStep(now - 90000) - 2.5) * (0, $diMLx.timeline).detailsStepWidth}px`);
    // console.timeEnd('initSlider');
    }
    $ac969ff4dde4b936$export$9cc3739d965cbe89((0, $diMLx.timeline).details, (0, $diMLx.timeline).details);
// console.timeEnd('renderTimeline');
}
let $ac969ff4dde4b936$var$debouncedSelectTimeline = (0, $iRjZV.debounce)(function(ts) {
    $ac969ff4dde4b936$var$selectTsTimeline(ts);
}, 300);
function $ac969ff4dde4b936$export$9cc3739d965cbe89(updateMetrics, details) {
    // console.time('scaleTimelineSlider');
    (0, $diMLx.timeline).skipUpdate = true;
    if (updateMetrics) (0, $diMLx.timeline).timelineSlider.updateMetrics();
    (0, $diMLx.timeline).timelineActiveStep ||= $ac969ff4dde4b936$export$83a9ef028b771fd4();
    const currentTs = parseInt((0, $diMLx.timeline).timelineActiveStep.getAttribute("data-ts")), currentStep = $ac969ff4dde4b936$var$computeStep(currentTs), xAdjustment = details && !(0, $diMLx.layout).mobile ? 3.5 : 1;
    const xPos = details ? (currentStep + xAdjustment) * (0, $diMLx.timeline).detailsStepWidth : (currentStep + xAdjustment) * (0, $diMLx.timeline).stepWidth;
    (0, $diMLx.timeline).timelineSlider.setPosition({
        x: xPos - (details ? (0, $diMLx.timeline).detailsCursorOffset : (0, $diMLx.timeline).cursorOffset),
        y: 0
    });
    $ac969ff4dde4b936$var$updateTimelineDatetime(currentTs, details);
    setTimeout(()=>{
        (0, $diMLx.timeline).skipUpdate = false;
        (0, $diMLx.timeline).details = details;
    }, 2000);
// console.timeEnd('scaleTimelineSlider');
}
function $ac969ff4dde4b936$var$parseTimelineData(timestamp, rawData) {
    let currentTs;
    for(let nid in rawData)if (rawData.hasOwnProperty(nid)) {
        for(let ts in rawData[nid])if (rawData[nid].hasOwnProperty(ts)) {
            currentTs = timestamp + parseInt(ts);
            for (let s of (0, $diMLx.timeline).timelineSteps)if (currentTs >= s[0] && currentTs < s[1]) {
                (0, $diMLx.data).timelineData[s[0]] = (0, $diMLx.data).timelineData[s[0]] || {};
                (0, $diMLx.data).timelineData[s[0]][nid] = {
                    nid: nid,
                    ts: currentTs,
                    wind_dir_true: rawData[nid][ts]["wind_dir_true"],
                    wind_pow_knot: rawData[nid][ts]["wind_pow_knot"],
                    wind_pow_knot_max: rawData[nid][ts]["wind_pow_knot_max"]
                };
            }
        }
    }
}
function $ac969ff4dde4b936$export$2b262526dbd61afc(newMeasures) {
    let i, createdAt;
    for(i = 0; i < newMeasures.length; i++){
        createdAt = parseInt(Object.keys(newMeasures[i].created)[0]);
        for (let s of (0, $diMLx.timeline).timelineSteps)if (createdAt >= s[0] && createdAt < s[1]) {
            (0, $diMLx.data).timelineData[s[0]] = (0, $diMLx.data).timelineData[s[0]] || {};
            if (!(0, $diMLx.data).timelineData[s[0]][newMeasures[i].nid]) (0, $diMLx.data).timelineData[s[0]][newMeasures[i].nid] = {
                nid: newMeasures[i].nid,
                ts: createdAt,
                wind_dir_true: newMeasures[i]["wind_dir_true"],
                wind_pow_knot: newMeasures[i]["wind_pow_knot"],
                wind_pow_knot_max: newMeasures[i]["wind_pow_knot_max"]
            };
        }
    }
}
function $ac969ff4dde4b936$var$toggleStepTimeline(elt) {
    let activeItem = document.querySelector("#timeline_steps .tl_item.active");
    if (activeItem) activeItem.classList.remove("active");
    elt.classList.add("active");
    (0, $diMLx.timeline).timelineActiveStep = elt;
}
function $ac969ff4dde4b936$var$updateTimelineDatetime(ts, details) {
    const hourLabel = (0, $0866737b96521d45$export$2e2bcd8739ae039).unix(ts).format("ddd HH[h]mm").replace(".", ""), hour = parseInt(hourLabel.split("h")[0]);
    let hideDateLabel;
    (0, $diMLx.timeline).hourLabel.innerHTML = hourLabel;
    if ((0, $diMLx.layout).mobile) hideDateLabel = hour <= details ? 6 : 3;
    else hideDateLabel = hour <= (details ? (0, $diMLx.timeline).hoursCountDetails : (0, $diMLx.timeline).hoursCount);
    if (hideDateLabel) (0, $diMLx.timeline).dateLabel.innerHTML = "";
    else (0, $diMLx.timeline).dateLabel.innerHTML = (0, $0866737b96521d45$export$2e2bcd8739ae039).unix(ts).format("ddd DD/MM").replace(".", "");
}
function $ac969ff4dde4b936$export$17badd67dc179611(btn) {
    if (btn.classList.contains("playing") && (0, $diMLx.timeline).timelineInterval) {
        btn.classList.remove("playing");
        btn.querySelector("i").classList.replace("fa-pause", "fa-play");
        clearInterval((0, $diMLx.timeline).timelineInterval);
    } else {
        (0, $diMLx.timeline).timelineActiveStep ||= $ac969ff4dde4b936$export$83a9ef028b771fd4();
        btn.classList.add("playing");
        btn.querySelector("i").classList.replace("fa-play", "fa-pause");
        (0, $diMLx.timeline).timelineInterval = setInterval(function() {
            $ac969ff4dde4b936$var$updateTimelinePosition($ac969ff4dde4b936$var$selectedTs() + (0, $diMLx.timeline).timelineStep);
        }, 1200);
    }
}
function $ac969ff4dde4b936$export$83a9ef028b771fd4() {
    return Array.from(document.querySelectorAll("#timeline_steps .tl_item.tl_obs")).pop() || document.querySelector("#timeline_steps .tl_item:first-child");
}
function $ac969ff4dde4b936$export$c1326b26277d8d63() {
    console.log("nextStepTimeline");
    let offset = (0, $diMLx.timeline).timelineActiveStep.nextSibling.getAttribute("data-rt") ? (0, $diMLx.timeline).timelineStep : 3600 - parseInt((0, $diMLx.timeline).timelineActiveStep.getAttribute("data-ts")) % 3600;
    $ac969ff4dde4b936$var$updateTimelinePosition($ac969ff4dde4b936$var$selectedTs() + offset);
}
function $ac969ff4dde4b936$export$a3b381cc74bfefd3() {
    console.log("prevStepTimeline");
    let offset = (0, $diMLx.timeline).timelineActiveStep.previousSibling.getAttribute("data-rt") ? (0, $diMLx.timeline).timelineStep : 3600 - parseInt((0, $diMLx.timeline).timelineActiveStep.getAttribute("data-ts")) % 3600;
    $ac969ff4dde4b936$var$updateTimelinePosition($ac969ff4dde4b936$var$selectedTs() - offset);
}
function $ac969ff4dde4b936$export$f327a9a0705a3951() {
    const activeTs = parseInt((0, $diMLx.timeline).timelineActiveStep.getAttribute("data-ts")), nextTs = activeTs + 86400;
    $ac969ff4dde4b936$var$updateTimelinePosition(nextTs);
}
function $ac969ff4dde4b936$export$3527b2367285a74c() {
    const activeTs = parseInt((0, $diMLx.timeline).timelineActiveStep.getAttribute("data-ts")), nextTs = activeTs - 86400;
    $ac969ff4dde4b936$var$updateTimelinePosition(nextTs);
}
function $ac969ff4dde4b936$export$e45bb9041185a27a() {
    $ac969ff4dde4b936$export$83a9ef028b771fd4().click();
}
function $ac969ff4dde4b936$var$selectedTs() {
    return $5ff8fe1f0e47d54c$export$2e2bcd8739ae039((0, $diMLx.timeline).timelineActiveStep).datum()[0];
}
function $ac969ff4dde4b936$var$selectTsTimeline(newTs) {
    // console.log('selectTsTimeline: ' + (new Date(newTs * 1000)).toString());
    let newItem = document.querySelector("#timeline_steps .tl_item[data-ts='" + newTs + "']");
    if (newItem) {
        $ac969ff4dde4b936$var$toggleStepTimeline(newItem);
        $ac969ff4dde4b936$var$updateTimelineDatetime(newTs, (0, $diMLx.timeline).details);
        (0, $4a909a324b05f370$export$e72c2db76561db73)(Object.values((0, $diMLx.data).timelineData[newTs] || {}));
        const lastWavesMeasureTs = newTs - newTs % 1800;
        // console.debug("lastWavesMeasureTs: " + lastWavesMeasureTs.toString());
        // console.debug("lastWavesMeasure tl data: " + JSON.stringify(Object.values(data.timelineData[lastWavesMeasureTs] || {})));
        (0, $4a909a324b05f370$export$7c21e768f6379ae)(Object.values((0, $diMLx.data).timelineData[lastWavesMeasureTs] || {}));
        $ac969ff4dde4b936$export$40548a160ab2d315();
        let isFuture = !newItem.classList.contains("tl_obs");
        if (isFuture && (0, $diMLx.layers).dataLayers.indexOf("waves_fc") === -1) {
            if ((0, $diMLx.layers).dataLayers.indexOf("wind_fc") === -1) wm.toggleLayer(document.querySelector("#wind_fc"), "wind_fc");
        }
    }
    return newItem;
}
function $ac969ff4dde4b936$export$40548a160ab2d315() {
    let ts = null, rendered = document.querySelector("#map_container").classList.contains("rendered");
    if ((0, $diMLx.timeline).timelineActiveStep) {
        ts = parseInt((0, $diMLx.timeline).timelineActiveStep.getAttribute("data-ts"));
        if (!(0, $diMLx.timeline).timelineActiveStep.getAttribute("data-fc")) ts = ts - ts % 3600;
    }
    if ((0, $diMLx.layers).dataLayers.indexOf("wind_fc") !== -1) {
        if ((0, $diMLx.map).windLayer) (0, $diMLx.map).windLayer.stop();
        (0, $4a909a324b05f370$export$9b75862e7acdcaad)(ts).then(function() {
            if ((0, $diMLx.map).currentFocus && (0, $am1Dn.config).popup) (0, $4a909a324b05f370$export$53d225340945d25c)((0, $am1Dn.config).popup, (0, $diMLx.map).currentFocus.lat, (0, $diMLx.map).currentFocus.lng);
        });
    }
    if ((0, $diMLx.layers).dataLayers.indexOf("waves_fc") !== -1) (0, $4a909a324b05f370$export$ec577891f2365dde)(ts).then(function() {
        if ((0, $diMLx.map).currentFocus && (0, $am1Dn.config).popup) (0, $4a909a324b05f370$export$53d225340945d25c)((0, $am1Dn.config).popup, (0, $diMLx.map).currentFocus.lat, (0, $diMLx.map).currentFocus.lng);
    });
    if ((0, $diMLx.layers).dataLayers.indexOf("weather_fc") !== -1) (0, $4a909a324b05f370$export$cb0d41d287166a75)(ts);
    // Note : specific case for temps - to be removed when they are properly bound to tl
    if ((0, $diMLx.layers).dataLayers.indexOf("temp") !== -1) {
        if ((0, $diMLx.timeline).timelineActiveStep) (0, $4a909a324b05f370$export$5aa43213bed9fb5b)();
        else (0, $4a909a324b05f370$export$d2af805eac6d6eea)();
    }
}
function $ac969ff4dde4b936$var$setUpKeyboardActions() {
    window.addEventListener("keydown", function(e) {
        switch(e.code){
            case "ArrowLeft":
                e.stopPropagation();
                e.preventDefault();
                $ac969ff4dde4b936$export$a3b381cc74bfefd3();
                break;
            case "ArrowRight":
                e.stopPropagation();
                e.preventDefault();
                $ac969ff4dde4b936$export$c1326b26277d8d63();
                break;
            case "Escape":
                $ac969ff4dde4b936$export$e45bb9041185a27a();
                break;
            case "Space":
                e.stopPropagation();
                e.preventDefault();
                $ac969ff4dde4b936$export$17badd67dc179611(document.querySelector("#timeline_commands #tl_play"));
                break;
            default:
        }
    }, true);
    (0, $diMLx.timeline).keyBoardSetUp = true;
}
function $ac969ff4dde4b936$var$updateTimelinePosition(newVal) {
    const newStep = $ac969ff4dde4b936$var$computeStep(newVal), xAdjustment = (0, $diMLx.timeline).details && !(0, $diMLx.layout).mobile ? 4 : 1;
    const xPos = (0, $diMLx.timeline).details ? (newStep + xAdjustment) * (0, $diMLx.timeline).detailsStepWidth : (newStep + xAdjustment) * (0, $diMLx.timeline).stepWidth;
    (0, $diMLx.timeline).timelineSlider.scrollTo({
        x: xPos - ((0, $diMLx.timeline).details ? (0, $diMLx.timeline).detailsCursorOffset : (0, $diMLx.timeline).cursorOffset),
        y: 0
    });
}
function $ac969ff4dde4b936$var$computeStep(ts) {
    return (0, $diMLx.timeline).timelineSteps.findIndex((s)=>s[0] <= ts && s[1] > ts);
}
function $ac969ff4dde4b936$var$computeWeatherStep(ts) {
    let prevHour = ts - ts % 3600;
    return $ac969ff4dde4b936$var$computeStep(prevHour);
}






var $diMLx = parcelRequire("diMLx");

var $am1Dn = parcelRequire("am1Dn");


var $ca9ad = parcelRequire("ca9ad");


// import * as Sentry from "@sentry/browser";
// import {Integrations} from "@sentry/tracing";
// Sentry.init({
//   dsn: "https://226f2354cdc842db97ac896999739be9@o21346.ingest.sentry.io/5807697",
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 0.5
// });
(0, $0866737b96521d45$export$2e2bcd8739ae039).locale("fr");
// console.timeLog('trace', 'main.js start');
document.addEventListener("DOMContentLoaded", function(evt) {
    // document.querySelector("#toggle_map_menu").addEventListener("click", function(evt) {
    //   toggleMapNav();
    // });
    // console.time('initSlides');
    (0, $diMLx.initSlides)(function() {
        // console.timeLog('initSlides', 'p1')
        (0, $diMLx.createSlides)((0, $am1Dn.advertisersRefs), "partners");
        // console.timeLog('initSlides', 'p2')
        (0, $diMLx.sliderDisplay)("partners");
    // console.timeEnd('initSlides');
    });
    window.wm = {
        toggleLayer: (0, $4a909a324b05f370$export$886f6367efad2401),
        toggleMap: (0, $c022c3a831c783e1$export$720449d359f5eb20),
        toggleSideNav: $4d04f83e2a55769a$var$toggleSideNav,
        openTab: $4d04f83e2a55769a$var$openTab,
        geolocateMe: (0, $4a909a324b05f370$export$2a22cb1184287a3d),
        prevTimeline: (0, $ac969ff4dde4b936$export$3527b2367285a74c),
        prevStepTimeline: (0, $ac969ff4dde4b936$export$a3b381cc74bfefd3),
        nextTimeline: (0, $ac969ff4dde4b936$export$f327a9a0705a3951),
        nextStepTimeline: (0, $ac969ff4dde4b936$export$c1326b26277d8d63),
        toggleTimeline: (0, $ac969ff4dde4b936$export$17badd67dc179611),
        refreshTimeline: (0, $ac969ff4dde4b936$export$e45bb9041185a27a),
        toggleLines: $4d04f83e2a55769a$var$toggleLines,
        displaySensorCharts: (0, $15afa6c724e20c66$export$af377084b1bb65fd),
        setFavorite: (0, $828c72eac0f0470f$export$1ed640048cefe91a),
        goToFavorite: $4d04f83e2a55769a$var$goToFavorite,
        // setDayNight: setDayNight,
        closePoi: (0, $828c72eac0f0470f$export$b678dbcde018e0b2),
        displayNews: (0, $diMLx.displayNews)
    };
});
var $4d04f83e2a55769a$var$windowResized = (0, $iRjZV.debounce)(function() {
    (0, $diMLx.updateLayout)();
}, 800);
window.onresize = $4d04f83e2a55769a$var$windowResized;
function $4d04f83e2a55769a$var$toggleSideNav(btn, forceClose) {
    if (forceClose) btn.classList.remove("active");
    else btn.classList.toggle("active");
}
function $4d04f83e2a55769a$var$openTab(btn) {
    document.querySelector("#side_tabs .active").classList.remove("active");
    btn.classList.add("active");
    btn.parentElement.setAttribute("data-active", btn.getAttribute("data-tab"));
}
function $4d04f83e2a55769a$var$toggleLines(btn, ...cls) {
    let c, line;
    for (c of cls){
        let lines = Array.from(document.querySelectorAll("#weather_details_header ." + c + ", #weather_details ." + c));
        for (line of lines)if (line.style.display === "none") line.style.display = "flex";
        else line.style.display = "none";
    }
    btn.classList.toggle("active");
}
function $4d04f83e2a55769a$var$favoriteDetails() {
    (0, $828c72eac0f0470f$export$535890a1dbf69608)();
    document.querySelector("#map_modal").setAttribute("data-modal", "favorite");
    document.querySelector("#map_modal_title").innerHTML = "D\xe9finir son plan d\u2019eau favori";
    document.querySelector("#header_links").innerHTML = '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
    document.querySelector("#map_modal_content").innerHTML = '<div>Cliquez sur le pictogramme m\xe9t\xe9o <img class="img-icon" src="' + (0, (/*@__PURE__*/$parcel$interopDefault($f1b279363cb8b9b4$exports)))["soleil"] + '" alt="Soleil">  de votre choix. Puis cliquez sur le bouton \xab D\xe9finir comme favori \xbb</div>';
    (0, $ca9ad.default).show("map_modal", {
        disableScroll: true,
        onClose: ()=>{
            (0, $26ce3c45196098b3$export$2e2bcd8739ae039).navigate("/");
        }
    });
}
function $4d04f83e2a55769a$var$goToFavorite() {
    const path = (0, $am1Dn.config).favoritePath;
    if (path) (0, $26ce3c45196098b3$export$2e2bcd8739ae039).navigate(path);
    else {
        var menuBtn = document.querySelector("#weather_fc");
        if (!menuBtn.classList.contains("active")) wm.toggleLayer(menuBtn, "weather_fc");
        $4d04f83e2a55769a$var$favoriteDetails();
    }
    $4d04f83e2a55769a$var$toggleSideNav(document.querySelector("#toggle_side_menu"), true);
} // console.timeLog('trace', 'fin main.js');


//# sourceMappingURL=index.5c4440b4.js.map
